/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
import { ClientError } from 'graphql-request/dist/types';
import useSWR, { SWRConfiguration as SWRConfigInterface, Key as SWRKeyInterface } from 'swr';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: Record<string, any>;
  _int4: number;
  _numeric: any;
  _text: string;
  _uuid: string;
  bigint: bigint;
  bpchar: any;
  date: string;
  float8: any;
  interval: string;
  json: Record<string, any>;
  jsonb: Record<string, any>;
  lquery: string;
  ltree: string;
  ltxtquery: any;
  money: number;
  numeric: number;
  timestamptz: string;
  uuid: string;
};

export type AssignNewPartNumberOutput = {
  __typename?: 'AssignNewPartNumberOutput';
  id: Scalars['String'];
  newPartNumber: Scalars['String'];
  oldPartNumber: Scalars['String'];
};

export type BomResult = {
  __typename?: 'BOMResult';
  bom: Scalars['JSON'];
  /** entityid */
  entityid: Array<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type BomRowDetail = {
  __typename?: 'BOMRowDetail';
  item?: Maybe<Part_Download_View>;
  /** id of item record */
  item_id: Scalars['String'];
  /** Additional Data for row. */
  more?: Maybe<Array<UnitBomRowResult>>;
  /** id of item record */
  partId: Scalars['String'];
  subTotalCost: Scalars['Float'];
  subTotalQuantity: Scalars['Float'];
  takeOffSubTotalQuantity?: Maybe<Scalars['Float']>;
};

export type BomIndexCriteria = {
  /** entityid */
  entityid: Array<Scalars['String']>;
};

export type BomIndexDetail = {
  __typename?: 'BomIndexDetail';
  metadata: Scalars['JSON'];
  version: Scalars['String'];
};

export type BomIndexSearchResults = {
  __typename?: 'BomIndexSearchResults';
  criteria: BomParameters;
  results: Array<BomIndexDetail>;
};

export type BomParameters = {
  __typename?: 'BomParameters';
  /** entityid */
  entityid: Array<Scalars['String']>;
};

export type BomQueryCriteria = {
  /** entityid */
  entityid: Array<Scalars['String']>;
  /** version */
  version?: InputMaybe<Scalars['String']>;
};

export type BomVersionCriteria = {
  /** entityid */
  entityid: Array<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CloneUnmodeledBomInput = {
  fromSku: Scalars['String'];
  toSku: Scalars['String'];
};

export type CloneUnmodeledBomOutput = {
  __typename?: 'CloneUnmodeledBomOutput';
  success: Scalars['Boolean'];
};

export type CreateInfo = {
  __typename?: 'CreateInfo';
  bookmark?: Maybe<Scalars['String']>;
  nodesCreated: Scalars['Int'];
  relationshipsCreated: Scalars['Int'];
};

export type CreateItemTagInput = {
  /** Human readable TagType value. */
  entity_id: Scalars['String'];
  /** Enumeration Vale for TagType */
  tag_id: Scalars['String'];
};

export type CreateTagInput = {
  /** Tag Id */
  id: Scalars['String'];
  /** TODO */
  name: Scalars['String'];
  /** TODO */
  value: Scalars['String'];
};

export type CreateTagTypeInput = {
  /** Enumeration Value for TagType */
  description: Scalars['String'];
  /** Human readable TagType value. */
  value: Scalars['String'];
};

export type CreatechoiceNodesMutationResponse = {
  __typename?: 'CreatechoiceNodesMutationResponse';
  choiceNodes: Array<ChoiceNode>;
  info: CreateInfo;
};

export type CreatecsiNodesMutationResponse = {
  __typename?: 'CreatecsiNodesMutationResponse';
  csiNodes: Array<CsiNode>;
  info: CreateInfo;
};

export type CreatecustomerNodesMutationResponse = {
  __typename?: 'CreatecustomerNodesMutationResponse';
  customerNodes: Array<CustomerNode>;
  info: CreateInfo;
};

export type CreateitemNodesMutationResponse = {
  __typename?: 'CreateitemNodesMutationResponse';
  info: CreateInfo;
  itemNodes: Array<ItemNode>;
};

export type CreateorderNodesMutationResponse = {
  __typename?: 'CreateorderNodesMutationResponse';
  info: CreateInfo;
  orderNodes: Array<OrderNode>;
};

export type CreateplatformNodesMutationResponse = {
  __typename?: 'CreateplatformNodesMutationResponse';
  info: CreateInfo;
  platformNodes: Array<PlatformNode>;
};

export type CreateproductNodesMutationResponse = {
  __typename?: 'CreateproductNodesMutationResponse';
  info: CreateInfo;
  productNodes: Array<ProductNode>;
};

export type CreateproductOptionNodesMutationResponse = {
  __typename?: 'CreateproductOptionNodesMutationResponse';
  info: CreateInfo;
  productOptionNodes: Array<ProductOptionNode>;
};

export type CreateprogramNodesMutationResponse = {
  __typename?: 'CreateprogramNodesMutationResponse';
  info: CreateInfo;
  programNodes: Array<ProgramNode>;
};

export type CreateprojectNodesMutationResponse = {
  __typename?: 'CreateprojectNodesMutationResponse';
  info: CreateInfo;
  projectNodes: Array<ProjectNode>;
};

export type CreateunitNodesMutationResponse = {
  __typename?: 'CreateunitNodesMutationResponse';
  info: CreateInfo;
  unitNodes: Array<UnitNode>;
};

export type CreateuomNodesMutationResponse = {
  __typename?: 'CreateuomNodesMutationResponse';
  info: CreateInfo;
  uomNodes: Array<UomNode>;
};

export type CreateuomScopeNodesMutationResponse = {
  __typename?: 'CreateuomScopeNodesMutationResponse';
  info: CreateInfo;
  uomScopeNodes: Array<UomScopeNode>;
};

export type CreateuomSupplierNodesMutationResponse = {
  __typename?: 'CreateuomSupplierNodesMutationResponse';
  info: CreateInfo;
  uomSupplierNodes: Array<UomSupplierNode>;
};

export type DeleteInfo = {
  __typename?: 'DeleteInfo';
  bookmark?: Maybe<Scalars['String']>;
  nodesDeleted: Scalars['Int'];
  relationshipsDeleted: Scalars['Int'];
};

export type EmailInput = {
  html?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};

export type EmailOutput = {
  __typename?: 'EmailOutput';
  success?: Maybe<Scalars['Boolean']>;
};

export type FileUploadOutput = {
  __typename?: 'FileUploadOutput';
  url: Scalars['String'];
};

export type FloatAggregateSelection = {
  __typename?: 'FloatAggregateSelection';
  average?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  sum?: Maybe<Scalars['Float']>;
};

export type IntAggregateSelection = {
  __typename?: 'IntAggregateSelection';
  average?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  sum?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type ItemTag = {
  __typename?: 'ItemTag';
  entity_id: Scalars['String'];
  id: Scalars['Int'];
  tag: Tag;
  tag_id: Scalars['Int'];
};

export type Neo4JGraphResult = {
  __typename?: 'Neo4JGraphResult';
  links: Array<Neo4JLink>;
  nodes: Array<Neo4JNode>;
};

export type Neo4JLink = {
  __typename?: 'Neo4JLink';
  properties?: Maybe<Scalars['JSON']>;
  source: Scalars['String'];
  target: Scalars['String'];
  typename: Scalars['String'];
};

export type Neo4JNode = {
  __typename?: 'Neo4JNode';
  id: Scalars['String'];
  name: Scalars['String'];
  properties?: Maybe<Scalars['JSON']>;
  typename: Scalars['String'];
};

/** Pagination information (Relay) */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type ProjectBomResult = {
  __typename?: 'ProjectBOMResult';
  asOfDate: Scalars['String'];
  items: Array<Maybe<BomRowDetail>>;
  name: Scalars['String'];
  project?: Maybe<Project>;
  projectId: Scalars['String'];
  projectNumber: Scalars['String'];
  totalCost: Scalars['Float'];
  version?: Maybe<Scalars['String']>;
};

export type ProjectFilesOutput = {
  __typename?: 'ProjectFilesOutput';
  files?: Maybe<Scalars['jsonb']>;
  jobNumber: Scalars['String'];
  project?: Maybe<Project>;
};

export type RefreshAlgoliaOutput = {
  __typename?: 'RefreshAlgoliaOutput';
  success?: Maybe<Scalars['String']>;
};

export type SortDirection =
  /** Sort by field values in ascending order. */
  | 'ASC'
  /** Sort by field values in descending order. */
  | 'DESC';

export type StringAggregateSelection = {
  __typename?: 'StringAggregateSelection';
  longest?: Maybe<Scalars['String']>;
  shortest?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type TagPartSearchInput = {
  page?: InputMaybe<Scalars['Int']>;
  tagged_choices?: InputMaybe<Array<Scalars['String']>>;
  tagged_platforms?: InputMaybe<Array<Scalars['String']>>;
  tagged_processes?: InputMaybe<Array<Scalars['String']>>;
  tagged_products?: InputMaybe<Array<Scalars['String']>>;
};

export type TagPartSearchResult = {
  __typename?: 'TagPartSearchResult';
  page?: Maybe<Scalars['Int']>;
  results?: Maybe<TagPartSearchResultParts>;
};

export type TagPartSearchResultDetail = {
  __typename?: 'TagPartSearchResultDetail';
  id?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
};

export type TagPartSearchResultParts = {
  __typename?: 'TagPartSearchResultParts';
  tagged_parts?: Maybe<Array<Maybe<TagPartSearchResultDetail>>>;
};

export type TagPath = {
  __typename?: 'TagPath';
  id: Scalars['Int'];
  path: Scalars['String'];
};

export type TagPathCriteria = {
  /** Represents the query match clause. */
  query?: InputMaybe<Scalars['JSON']>;
};

export type TagPathEntry = {
  __typename?: 'TagPathEntry';
  entity_id: Scalars['String'];
  id: Scalars['String'];
  include_waste: Scalars['Boolean'];
  quantity: Scalars['Float'];
  tag_set: TagSet;
  tag_set_id: Scalars['String'];
};

export type TagPathResult = {
  __typename?: 'TagPathResult';
  entries: Array<TagPathEntry>;
  tags: Array<TagPathTag>;
};

export type TagPathTag = {
  __typename?: 'TagPathTag';
  id: Scalars['Int'];
  name: Scalars['String'];
  sequence: Scalars['Int'];
  tag_type_id: Scalars['String'];
  value: Scalars['String'];
};

export type TagSet = {
  __typename?: 'TagSet';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  selected_json?: Maybe<Scalars['JSON']>;
  tag_path?: Maybe<TagPath>;
};

export type TagType = {
  __typename?: 'TagType';
  description: Scalars['String'];
  value: Scalars['String'];
};

export type TaggedCriteria = {
  /** Items per page (40 is default) */
  items_per_page?: InputMaybe<Scalars['Int']>;
  /** Page to fetch (0 is root */
  page?: InputMaybe<Scalars['Int']>;
  /** Array of choice tags. */
  tagged_choices?: InputMaybe<Array<Scalars['String']>>;
  /** Array of platform tags. */
  tagged_platforms?: InputMaybe<Array<Scalars['String']>>;
  /** Array of process tags. */
  tagged_processes?: InputMaybe<Array<Scalars['String']>>;
  /** Array of product tags. */
  tagged_products?: InputMaybe<Array<Scalars['String']>>;
};

export type TaggedDetail = {
  __typename?: 'TaggedDetail';
  name: Scalars['String'];
  tag_id: Scalars['Int'];
  tag_type_id: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type TaggedItem = {
  __typename?: 'TaggedItem';
  approval_stage?: Maybe<Array<Scalars['String']>>;
  csiLevel1?: Maybe<Scalars['String']>;
  csiLevel2?: Maybe<Scalars['String']>;
  csiLevel3?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Array<Scalars['String']>>;
  manufacturer_part_number?: Maybe<Array<Scalars['String']>>;
  name?: Maybe<Scalars['String']>;
  objectID?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partNumberHistory?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  tagged_choices?: Maybe<Array<Scalars['String']>>;
  tagged_platforms?: Maybe<Array<Scalars['String']>>;
  tagged_processes?: Maybe<Array<Scalars['String']>>;
  tagged_products?: Maybe<Array<Scalars['String']>>;
  tagged_programs?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<TaggedDetail>>;
  vendor?: Maybe<Array<Scalars['String']>>;
};

export type TaggedResult = {
  __typename?: 'TaggedResult';
  items_per_page: Scalars['Int'];
  page: Scalars['Int'];
  params: Scalars['String'];
  tagged_parts: Array<TaggedItem>;
  total_hits: Scalars['Int'];
  total_pages: Scalars['Int'];
};

export type UnitBomResult = {
  __typename?: 'UnitBOMResult';
  asOfDate: Scalars['String'];
  id: Scalars['String'];
  items?: Maybe<Array<UnitBomRow2>>;
  old_serial_number?: Maybe<Scalars['String']>;
  serial_number: Scalars['String'];
  totalCost?: Maybe<Scalars['Float']>;
  version?: Maybe<Scalars['String']>;
};

export type UnitBomRow2 = {
  __typename?: 'UnitBOMRow2';
  cost: Scalars['Float'];
  include_waste: Scalars['Boolean'];
  item?: Maybe<Part_Download_View>;
  /** id of part record */
  item_id: Scalars['String'];
  level: Scalars['String'];
  quantity: Scalars['Float'];
  row_id: Scalars['String'];
  tagpathid?: Maybe<Scalars['String']>;
  take_off_quantity: Scalars['Float'];
};

export type UnitBomRowResult = {
  __typename?: 'UnitBOMRowResult';
  include_waste?: Maybe<Scalars['Boolean']>;
  sku: Scalars['String'];
  skuSubTotalCost: Scalars['Float'];
  skuSubTotalQuantity: Scalars['Float'];
  skuTakeOffSubTotalQuantity?: Maybe<Scalars['Float']>;
};

export type UpdateInfo = {
  __typename?: 'UpdateInfo';
  bookmark?: Maybe<Scalars['String']>;
  nodesCreated: Scalars['Int'];
  nodesDeleted: Scalars['Int'];
  relationshipsCreated: Scalars['Int'];
  relationshipsDeleted: Scalars['Int'];
};

export type UpdateItemTagInput = {
  /** Human readable TagType value. */
  entity_id?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Enumeration Vale for TagType */
  tag_id?: InputMaybe<Scalars['String']>;
};

export type UpdateTagInput = {
  /** Tag Id */
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type UpdatechoiceNodesMutationResponse = {
  __typename?: 'UpdatechoiceNodesMutationResponse';
  choiceNodes: Array<ChoiceNode>;
  info: UpdateInfo;
};

export type UpdatecsiNodesMutationResponse = {
  __typename?: 'UpdatecsiNodesMutationResponse';
  csiNodes: Array<CsiNode>;
  info: UpdateInfo;
};

export type UpdatecustomerNodesMutationResponse = {
  __typename?: 'UpdatecustomerNodesMutationResponse';
  customerNodes: Array<CustomerNode>;
  info: UpdateInfo;
};

export type UpdateitemNodesMutationResponse = {
  __typename?: 'UpdateitemNodesMutationResponse';
  info: UpdateInfo;
  itemNodes: Array<ItemNode>;
};

export type UpdateorderNodesMutationResponse = {
  __typename?: 'UpdateorderNodesMutationResponse';
  info: UpdateInfo;
  orderNodes: Array<OrderNode>;
};

export type UpdateplatformNodesMutationResponse = {
  __typename?: 'UpdateplatformNodesMutationResponse';
  info: UpdateInfo;
  platformNodes: Array<PlatformNode>;
};

export type UpdateproductNodesMutationResponse = {
  __typename?: 'UpdateproductNodesMutationResponse';
  info: UpdateInfo;
  productNodes: Array<ProductNode>;
};

export type UpdateproductOptionNodesMutationResponse = {
  __typename?: 'UpdateproductOptionNodesMutationResponse';
  info: UpdateInfo;
  productOptionNodes: Array<ProductOptionNode>;
};

export type UpdateprogramNodesMutationResponse = {
  __typename?: 'UpdateprogramNodesMutationResponse';
  info: UpdateInfo;
  programNodes: Array<ProgramNode>;
};

export type UpdateprojectNodesMutationResponse = {
  __typename?: 'UpdateprojectNodesMutationResponse';
  info: UpdateInfo;
  projectNodes: Array<ProjectNode>;
};

export type UpdateunitNodesMutationResponse = {
  __typename?: 'UpdateunitNodesMutationResponse';
  info: UpdateInfo;
  unitNodes: Array<UnitNode>;
};

export type UpdateuomNodesMutationResponse = {
  __typename?: 'UpdateuomNodesMutationResponse';
  info: UpdateInfo;
  uomNodes: Array<UomNode>;
};

export type UpdateuomScopeNodesMutationResponse = {
  __typename?: 'UpdateuomScopeNodesMutationResponse';
  info: UpdateInfo;
  uomScopeNodes: Array<UomScopeNode>;
};

export type UpdateuomSupplierNodesMutationResponse = {
  __typename?: 'UpdateuomSupplierNodesMutationResponse';
  info: UpdateInfo;
  uomSupplierNodes: Array<UomSupplierNode>;
};

/** Boolean expression to compare columns of type "_int4". All fields are combined with logical 'AND'. */
export type _Int4_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int4']>;
  _gt?: InputMaybe<Scalars['_int4']>;
  _gte?: InputMaybe<Scalars['_int4']>;
  _in?: InputMaybe<Array<Scalars['_int4']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int4']>;
  _lte?: InputMaybe<Scalars['_int4']>;
  _neq?: InputMaybe<Scalars['_int4']>;
  _nin?: InputMaybe<Array<Scalars['_int4']>>;
};

/** Boolean expression to compare columns of type "_numeric". All fields are combined with logical 'AND'. */
export type _Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_numeric']>;
  _gt?: InputMaybe<Scalars['_numeric']>;
  _gte?: InputMaybe<Scalars['_numeric']>;
  _in?: InputMaybe<Array<Scalars['_numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_numeric']>;
  _lte?: InputMaybe<Scalars['_numeric']>;
  _neq?: InputMaybe<Scalars['_numeric']>;
  _nin?: InputMaybe<Array<Scalars['_numeric']>>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']>;
  _gt?: InputMaybe<Scalars['_uuid']>;
  _gte?: InputMaybe<Scalars['_uuid']>;
  _in?: InputMaybe<Array<Scalars['_uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_uuid']>;
  _lte?: InputMaybe<Scalars['_uuid']>;
  _neq?: InputMaybe<Scalars['_uuid']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']>>;
};

/** columns and relationships of "all_boms_view" */
export type All_Boms_View = {
  __typename?: 'all_boms_view';
  csi?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  sku?: Maybe<Scalars['String']>;
  uom_take_off?: Maybe<Scalars['String']>;
};

/** aggregated selection of "all_boms_view" */
export type All_Boms_View_Aggregate = {
  __typename?: 'all_boms_view_aggregate';
  aggregate?: Maybe<All_Boms_View_Aggregate_Fields>;
  nodes: Array<All_Boms_View>;
};

/** aggregate fields of "all_boms_view" */
export type All_Boms_View_Aggregate_Fields = {
  __typename?: 'all_boms_view_aggregate_fields';
  avg?: Maybe<All_Boms_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<All_Boms_View_Max_Fields>;
  min?: Maybe<All_Boms_View_Min_Fields>;
  stddev?: Maybe<All_Boms_View_Stddev_Fields>;
  stddev_pop?: Maybe<All_Boms_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<All_Boms_View_Stddev_Samp_Fields>;
  sum?: Maybe<All_Boms_View_Sum_Fields>;
  var_pop?: Maybe<All_Boms_View_Var_Pop_Fields>;
  var_samp?: Maybe<All_Boms_View_Var_Samp_Fields>;
  variance?: Maybe<All_Boms_View_Variance_Fields>;
};


/** aggregate fields of "all_boms_view" */
export type All_Boms_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<All_Boms_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type All_Boms_View_Avg_Fields = {
  __typename?: 'all_boms_view_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "all_boms_view". All fields are combined with a logical 'AND'. */
export type All_Boms_View_Bool_Exp = {
  _and?: InputMaybe<Array<All_Boms_View_Bool_Exp>>;
  _not?: InputMaybe<All_Boms_View_Bool_Exp>;
  _or?: InputMaybe<Array<All_Boms_View_Bool_Exp>>;
  csi?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  uom_take_off?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type All_Boms_View_Max_Fields = {
  __typename?: 'all_boms_view_max_fields';
  csi?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  sku?: Maybe<Scalars['String']>;
  uom_take_off?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type All_Boms_View_Min_Fields = {
  __typename?: 'all_boms_view_min_fields';
  csi?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  sku?: Maybe<Scalars['String']>;
  uom_take_off?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "all_boms_view". */
export type All_Boms_View_Order_By = {
  csi?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  uom_take_off?: InputMaybe<Order_By>;
};

/** select columns of table "all_boms_view" */
export type All_Boms_View_Select_Column =
  /** column name */
  | 'csi'
  /** column name */
  | 'name'
  /** column name */
  | 'partNumber'
  /** column name */
  | 'quantity'
  /** column name */
  | 'sku'
  /** column name */
  | 'uom_take_off';

/** aggregate stddev on columns */
export type All_Boms_View_Stddev_Fields = {
  __typename?: 'all_boms_view_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type All_Boms_View_Stddev_Pop_Fields = {
  __typename?: 'all_boms_view_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type All_Boms_View_Stddev_Samp_Fields = {
  __typename?: 'all_boms_view_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "all_boms_view" */
export type All_Boms_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: All_Boms_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type All_Boms_View_Stream_Cursor_Value_Input = {
  csi?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  sku?: InputMaybe<Scalars['String']>;
  uom_take_off?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type All_Boms_View_Sum_Fields = {
  __typename?: 'all_boms_view_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type All_Boms_View_Var_Pop_Fields = {
  __typename?: 'all_boms_view_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type All_Boms_View_Var_Samp_Fields = {
  __typename?: 'all_boms_view_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type All_Boms_View_Variance_Fields = {
  __typename?: 'all_boms_view_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "base_product" */
export type Base_Product = {
  __typename?: 'base_product';
  /** An array relationship */
  bom_tags: Array<Tag_Entity>;
  /** An aggregate relationship */
  bom_tags_aggregate: Tag_Entity_Aggregate;
  cms_data?: Maybe<Scalars['jsonb']>;
  cms_id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  consumable_bom_details: Array<Consumable_Bom_Detail>;
  /** An aggregate relationship */
  consumable_bom_details_aggregate: Consumable_Bom_Detail_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  customer?: Maybe<Customer>;
  description: Scalars['String'];
  designed_for?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** An array relationship */
  items: Array<Item_Bom>;
  /** An aggregate relationship */
  items_aggregate: Item_Bom_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  platform?: Maybe<Platform>;
  platform_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  product_options: Array<Product_Option>;
  /** An aggregate relationship */
  product_options_aggregate: Product_Option_Aggregate;
  /** An object relationship */
  product_tag?: Maybe<Tags>;
  product_type: Scalars['String'];
  /** An array relationship */
  products: Array<Product>;
  /** An aggregate relationship */
  products_aggregate: Product_Aggregate;
  /** An object relationship */
  program?: Maybe<Program>;
  program_id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "base_product" */
export type Base_ProductBom_TagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductBom_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductCms_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_product" */
export type Base_ProductConsumable_Bom_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductConsumable_Bom_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductItemsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "base_product" */
export type Base_ProductProduct_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductProduct_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "base_product" */
export type Base_ProductUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** aggregated selection of "base_product" */
export type Base_Product_Aggregate = {
  __typename?: 'base_product_aggregate';
  aggregate?: Maybe<Base_Product_Aggregate_Fields>;
  nodes: Array<Base_Product>;
};

export type Base_Product_Aggregate_Bool_Exp = {
  count?: InputMaybe<Base_Product_Aggregate_Bool_Exp_Count>;
};

export type Base_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Base_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Base_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "base_product" */
export type Base_Product_Aggregate_Fields = {
  __typename?: 'base_product_aggregate_fields';
  avg?: Maybe<Base_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Base_Product_Max_Fields>;
  min?: Maybe<Base_Product_Min_Fields>;
  stddev?: Maybe<Base_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Base_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Base_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Base_Product_Sum_Fields>;
  var_pop?: Maybe<Base_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Base_Product_Var_Samp_Fields>;
  variance?: Maybe<Base_Product_Variance_Fields>;
};


/** aggregate fields of "base_product" */
export type Base_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Base_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "base_product" */
export type Base_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Base_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Base_Product_Max_Order_By>;
  min?: InputMaybe<Base_Product_Min_Order_By>;
  stddev?: InputMaybe<Base_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Base_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Base_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Base_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Base_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Base_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Base_Product_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Base_Product_Append_Input = {
  cms_data?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "base_product" */
export type Base_Product_Arr_Rel_Insert_Input = {
  data: Array<Base_Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Product_On_Conflict>;
};

/** aggregate avg on columns */
export type Base_Product_Avg_Fields = {
  __typename?: 'base_product_avg_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "base_product" */
export type Base_Product_Avg_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "base_product". All fields are combined with a logical 'AND'. */
export type Base_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Base_Product_Bool_Exp>>;
  _not?: InputMaybe<Base_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Base_Product_Bool_Exp>>;
  bom_tags?: InputMaybe<Tag_Entity_Bool_Exp>;
  bom_tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Bool_Exp>;
  cms_data?: InputMaybe<Jsonb_Comparison_Exp>;
  cms_id?: InputMaybe<Int_Comparison_Exp>;
  consumable_bom_details?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
  consumable_bom_details_aggregate?: InputMaybe<Consumable_Bom_Detail_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  designed_for?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  items?: InputMaybe<Item_Bom_Bool_Exp>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  platform_id?: InputMaybe<String_Comparison_Exp>;
  product_options?: InputMaybe<Product_Option_Bool_Exp>;
  product_options_aggregate?: InputMaybe<Product_Option_Aggregate_Bool_Exp>;
  product_tag?: InputMaybe<Tags_Bool_Exp>;
  product_type?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_Aggregate_Bool_Exp>;
  program?: InputMaybe<Program_Bool_Exp>;
  program_id?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "base_product" */
export type Base_Product_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'base_product_pkey'
  /** unique or primary key constraint on columns "sku" */
  | 'base_product_sku_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Base_Product_Delete_At_Path_Input = {
  cms_data?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Base_Product_Delete_Elem_Input = {
  cms_data?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Base_Product_Delete_Key_Input = {
  cms_data?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "base_product" */
export type Base_Product_Inc_Input = {
  cms_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "base_product" */
export type Base_Product_Insert_Input = {
  bom_tags?: InputMaybe<Tag_Entity_Arr_Rel_Insert_Input>;
  cms_data?: InputMaybe<Scalars['jsonb']>;
  cms_id?: InputMaybe<Scalars['Int']>;
  consumable_bom_details?: InputMaybe<Consumable_Bom_Detail_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Platform_Obj_Rel_Insert_Input>;
  platform_id?: InputMaybe<Scalars['String']>;
  product_options?: InputMaybe<Product_Option_Arr_Rel_Insert_Input>;
  product_tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  product_type?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Product_Arr_Rel_Insert_Input>;
  program?: InputMaybe<Program_Obj_Rel_Insert_Input>;
  program_id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Unit_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Base_Product_Max_Fields = {
  __typename?: 'base_product_max_fields';
  cms_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  designed_for?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "base_product" */
export type Base_Product_Max_Order_By = {
  cms_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Base_Product_Min_Fields = {
  __typename?: 'base_product_min_fields';
  cms_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  designed_for?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  program_id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "base_product" */
export type Base_Product_Min_Order_By = {
  cms_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Order_By>;
  program_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "base_product" */
export type Base_Product_Mutation_Response = {
  __typename?: 'base_product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Base_Product>;
};

/** input type for inserting object relation for remote table "base_product" */
export type Base_Product_Obj_Rel_Insert_Input = {
  data: Base_Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Base_Product_On_Conflict>;
};

/** on_conflict condition type for table "base_product" */
export type Base_Product_On_Conflict = {
  constraint: Base_Product_Constraint;
  update_columns?: Array<Base_Product_Update_Column>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};

/** Ordering options when selecting data from "base_product". */
export type Base_Product_Order_By = {
  bom_tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Order_By>;
  cms_data?: InputMaybe<Order_By>;
  cms_id?: InputMaybe<Order_By>;
  consumable_bom_details_aggregate?: InputMaybe<Consumable_Bom_Detail_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  platform_id?: InputMaybe<Order_By>;
  product_options_aggregate?: InputMaybe<Product_Option_Aggregate_Order_By>;
  product_tag?: InputMaybe<Tags_Order_By>;
  product_type?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_Aggregate_Order_By>;
  program?: InputMaybe<Program_Order_By>;
  program_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: base_product */
export type Base_Product_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Base_Product_Prepend_Input = {
  cms_data?: InputMaybe<Scalars['jsonb']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "base_product" */
export type Base_Product_Select_Column =
  /** column name */
  | 'cms_data'
  /** column name */
  | 'cms_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'designed_for'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'product_type'
  /** column name */
  | 'program_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "base_product" */
export type Base_Product_Set_Input = {
  cms_data?: InputMaybe<Scalars['jsonb']>;
  cms_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform_id?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  program_id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Base_Product_Stddev_Fields = {
  __typename?: 'base_product_stddev_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "base_product" */
export type Base_Product_Stddev_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Base_Product_Stddev_Pop_Fields = {
  __typename?: 'base_product_stddev_pop_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "base_product" */
export type Base_Product_Stddev_Pop_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Base_Product_Stddev_Samp_Fields = {
  __typename?: 'base_product_stddev_samp_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "base_product" */
export type Base_Product_Stddev_Samp_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "base_product" */
export type Base_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Base_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Base_Product_Stream_Cursor_Value_Input = {
  cms_data?: InputMaybe<Scalars['jsonb']>;
  cms_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform_id?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  program_id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Base_Product_Sum_Fields = {
  __typename?: 'base_product_sum_fields';
  cms_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "base_product" */
export type Base_Product_Sum_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** update columns of table "base_product" */
export type Base_Product_Update_Column =
  /** column name */
  | 'cms_data'
  /** column name */
  | 'cms_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'designed_for'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'product_type'
  /** column name */
  | 'program_id'
  /** column name */
  | 'sku'
  /** column name */
  | 'updated_at';

export type Base_Product_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Base_Product_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Base_Product_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Base_Product_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Base_Product_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Base_Product_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Base_Product_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Base_Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Base_Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Base_Product_Var_Pop_Fields = {
  __typename?: 'base_product_var_pop_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "base_product" */
export type Base_Product_Var_Pop_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Base_Product_Var_Samp_Fields = {
  __typename?: 'base_product_var_samp_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "base_product" */
export type Base_Product_Var_Samp_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Base_Product_Variance_Fields = {
  __typename?: 'base_product_variance_fields';
  cms_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "base_product" */
export type Base_Product_Variance_Order_By = {
  cms_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "bom_detail" */
export type Bom_Detail = {
  __typename?: 'bom_detail';
  options?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  part: Part;
  partId: Scalars['String'];
  /** An object relationship */
  product: Product;
  productId: Scalars['String'];
  quantity: Scalars['numeric'];
};


/** columns and relationships of "bom_detail" */
export type Bom_DetailOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "bom_detail" */
export type Bom_Detail_Aggregate = {
  __typename?: 'bom_detail_aggregate';
  aggregate?: Maybe<Bom_Detail_Aggregate_Fields>;
  nodes: Array<Bom_Detail>;
};

export type Bom_Detail_Aggregate_Bool_Exp = {
  count?: InputMaybe<Bom_Detail_Aggregate_Bool_Exp_Count>;
};

export type Bom_Detail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bom_Detail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bom_detail" */
export type Bom_Detail_Aggregate_Fields = {
  __typename?: 'bom_detail_aggregate_fields';
  avg?: Maybe<Bom_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bom_Detail_Max_Fields>;
  min?: Maybe<Bom_Detail_Min_Fields>;
  stddev?: Maybe<Bom_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Bom_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bom_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Bom_Detail_Sum_Fields>;
  var_pop?: Maybe<Bom_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Bom_Detail_Var_Samp_Fields>;
  variance?: Maybe<Bom_Detail_Variance_Fields>;
};


/** aggregate fields of "bom_detail" */
export type Bom_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bom_detail" */
export type Bom_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Bom_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bom_Detail_Max_Order_By>;
  min?: InputMaybe<Bom_Detail_Min_Order_By>;
  stddev?: InputMaybe<Bom_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bom_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bom_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bom_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Bom_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bom_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Bom_Detail_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Bom_Detail_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "bom_detail" */
export type Bom_Detail_Arr_Rel_Insert_Input = {
  data: Array<Bom_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bom_Detail_On_Conflict>;
};

/** aggregate avg on columns */
export type Bom_Detail_Avg_Fields = {
  __typename?: 'bom_detail_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bom_detail" */
export type Bom_Detail_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bom_detail". All fields are combined with a logical 'AND'. */
export type Bom_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Bom_Detail_Bool_Exp>>;
  _not?: InputMaybe<Bom_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Bom_Detail_Bool_Exp>>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  partId?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  productId?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "bom_detail" */
export type Bom_Detail_Constraint =
  /** unique or primary key constraint on columns "productId", "partId" */
  | 'bom_detail_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Bom_Detail_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Bom_Detail_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Bom_Detail_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "bom_detail" */
export type Bom_Detail_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "bom_detail" */
export type Bom_Detail_Insert_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  partId?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Bom_Detail_Max_Fields = {
  __typename?: 'bom_detail_max_fields';
  partId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "bom_detail" */
export type Bom_Detail_Max_Order_By = {
  partId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bom_Detail_Min_Fields = {
  __typename?: 'bom_detail_min_fields';
  partId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "bom_detail" */
export type Bom_Detail_Min_Order_By = {
  partId?: InputMaybe<Order_By>;
  productId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bom_detail" */
export type Bom_Detail_Mutation_Response = {
  __typename?: 'bom_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bom_Detail>;
};

/** on_conflict condition type for table "bom_detail" */
export type Bom_Detail_On_Conflict = {
  constraint: Bom_Detail_Constraint;
  update_columns?: Array<Bom_Detail_Update_Column>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "bom_detail". */
export type Bom_Detail_Order_By = {
  options?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  partId?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  productId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bom_detail */
export type Bom_Detail_Pk_Columns_Input = {
  partId: Scalars['String'];
  productId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Bom_Detail_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "bom_detail" */
export type Bom_Detail_Select_Column =
  /** column name */
  | 'options'
  /** column name */
  | 'partId'
  /** column name */
  | 'productId'
  /** column name */
  | 'quantity';

/** input type for updating data in table "bom_detail" */
export type Bom_Detail_Set_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
  partId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Bom_Detail_Stddev_Fields = {
  __typename?: 'bom_detail_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bom_detail" */
export type Bom_Detail_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bom_Detail_Stddev_Pop_Fields = {
  __typename?: 'bom_detail_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bom_detail" */
export type Bom_Detail_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bom_Detail_Stddev_Samp_Fields = {
  __typename?: 'bom_detail_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bom_detail" */
export type Bom_Detail_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bom_detail" */
export type Bom_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bom_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bom_Detail_Stream_Cursor_Value_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
  partId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Bom_Detail_Sum_Fields = {
  __typename?: 'bom_detail_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "bom_detail" */
export type Bom_Detail_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "bom_detail" */
export type Bom_Detail_Update_Column =
  /** column name */
  | 'options'
  /** column name */
  | 'partId'
  /** column name */
  | 'productId'
  /** column name */
  | 'quantity';

export type Bom_Detail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Bom_Detail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Bom_Detail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Bom_Detail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Bom_Detail_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bom_Detail_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Bom_Detail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bom_Detail_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bom_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bom_Detail_Var_Pop_Fields = {
  __typename?: 'bom_detail_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bom_detail" */
export type Bom_Detail_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bom_Detail_Var_Samp_Fields = {
  __typename?: 'bom_detail_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bom_detail" */
export type Bom_Detail_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bom_Detail_Variance_Fields = {
  __typename?: 'bom_detail_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bom_detail" */
export type Bom_Detail_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "bom_item_tag_set" */
export type Bom_Item_Tag_Set = {
  __typename?: 'bom_item_tag_set';
  entity_id: Scalars['String'];
  id: Scalars['uuid'];
  include_waste?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  item?: Maybe<Part>;
  quantity: Scalars['numeric'];
  /** An object relationship */
  tag_set?: Maybe<Tag_Set>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  uom?: Maybe<Uom_Conversion>;
  uom_conversion_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Aggregate = {
  __typename?: 'bom_item_tag_set_aggregate';
  aggregate?: Maybe<Bom_Item_Tag_Set_Aggregate_Fields>;
  nodes: Array<Bom_Item_Tag_Set>;
};

export type Bom_Item_Tag_Set_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Bom_Item_Tag_Set_Aggregate_Bool_Exp_Count>;
};

export type Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_And = {
  arguments: Bom_Item_Tag_Set_Select_Column_Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Bom_Item_Tag_Set_Select_Column_Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Bom_Item_Tag_Set_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Aggregate_Fields = {
  __typename?: 'bom_item_tag_set_aggregate_fields';
  avg?: Maybe<Bom_Item_Tag_Set_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bom_Item_Tag_Set_Max_Fields>;
  min?: Maybe<Bom_Item_Tag_Set_Min_Fields>;
  stddev?: Maybe<Bom_Item_Tag_Set_Stddev_Fields>;
  stddev_pop?: Maybe<Bom_Item_Tag_Set_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bom_Item_Tag_Set_Stddev_Samp_Fields>;
  sum?: Maybe<Bom_Item_Tag_Set_Sum_Fields>;
  var_pop?: Maybe<Bom_Item_Tag_Set_Var_Pop_Fields>;
  var_samp?: Maybe<Bom_Item_Tag_Set_Var_Samp_Fields>;
  variance?: Maybe<Bom_Item_Tag_Set_Variance_Fields>;
};


/** aggregate fields of "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Aggregate_Order_By = {
  avg?: InputMaybe<Bom_Item_Tag_Set_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bom_Item_Tag_Set_Max_Order_By>;
  min?: InputMaybe<Bom_Item_Tag_Set_Min_Order_By>;
  stddev?: InputMaybe<Bom_Item_Tag_Set_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bom_Item_Tag_Set_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bom_Item_Tag_Set_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bom_Item_Tag_Set_Sum_Order_By>;
  var_pop?: InputMaybe<Bom_Item_Tag_Set_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bom_Item_Tag_Set_Var_Samp_Order_By>;
  variance?: InputMaybe<Bom_Item_Tag_Set_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Arr_Rel_Insert_Input = {
  data: Array<Bom_Item_Tag_Set_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bom_Item_Tag_Set_On_Conflict>;
};

/** aggregate avg on columns */
export type Bom_Item_Tag_Set_Avg_Fields = {
  __typename?: 'bom_item_tag_set_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "bom_item_tag_set". All fields are combined with a logical 'AND'. */
export type Bom_Item_Tag_Set_Bool_Exp = {
  _and?: InputMaybe<Array<Bom_Item_Tag_Set_Bool_Exp>>;
  _not?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
  _or?: InputMaybe<Array<Bom_Item_Tag_Set_Bool_Exp>>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_waste?: InputMaybe<Boolean_Comparison_Exp>;
  item?: InputMaybe<Part_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tag_set?: InputMaybe<Tag_Set_Bool_Exp>;
  tag_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  uom?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversion_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'bom_item_tag_set_pkey'
  /** unique or primary key constraint on columns "entity_id", "tag_set_id" */
  | 'unique_bom_tag_set_entity';

/** input type for incrementing numeric columns in table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Insert_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  quantity?: InputMaybe<Scalars['numeric']>;
  tag_set?: InputMaybe<Tag_Set_Obj_Rel_Insert_Input>;
  tag_set_id?: InputMaybe<Scalars['uuid']>;
  uom?: InputMaybe<Uom_Conversion_Obj_Rel_Insert_Input>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Bom_Item_Tag_Set_Max_Fields = {
  __typename?: 'bom_item_tag_set_max_fields';
  entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Max_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tag_set_id?: InputMaybe<Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Bom_Item_Tag_Set_Min_Fields = {
  __typename?: 'bom_item_tag_set_min_fields';
  entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['numeric']>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Min_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tag_set_id?: InputMaybe<Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Mutation_Response = {
  __typename?: 'bom_item_tag_set_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bom_Item_Tag_Set>;
};

/** on_conflict condition type for table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_On_Conflict = {
  constraint: Bom_Item_Tag_Set_Constraint;
  update_columns?: Array<Bom_Item_Tag_Set_Update_Column>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};

/** Ordering options when selecting data from "bom_item_tag_set". */
export type Bom_Item_Tag_Set_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_waste?: InputMaybe<Order_By>;
  item?: InputMaybe<Part_Order_By>;
  quantity?: InputMaybe<Order_By>;
  tag_set?: InputMaybe<Tag_Set_Order_By>;
  tag_set_id?: InputMaybe<Order_By>;
  uom?: InputMaybe<Uom_Conversion_Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bom_item_tag_set */
export type Bom_Item_Tag_Set_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Select_Column =
  /** column name */
  | 'entity_id'
  /** column name */
  | 'id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'quantity'
  /** column name */
  | 'tag_set_id'
  /** column name */
  | 'uom_conversion_id';

/** select "bom_item_tag_set_aggregate_bool_exp_bool_and_arguments_columns" columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Select_Column_Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** select "bom_item_tag_set_aggregate_bool_exp_bool_or_arguments_columns" columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Select_Column_Bom_Item_Tag_Set_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** input type for updating data in table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Set_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  tag_set_id?: InputMaybe<Scalars['uuid']>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Bom_Item_Tag_Set_Stddev_Fields = {
  __typename?: 'bom_item_tag_set_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Bom_Item_Tag_Set_Stddev_Pop_Fields = {
  __typename?: 'bom_item_tag_set_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Bom_Item_Tag_Set_Stddev_Samp_Fields = {
  __typename?: 'bom_item_tag_set_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bom_Item_Tag_Set_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bom_Item_Tag_Set_Stream_Cursor_Value_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  tag_set_id?: InputMaybe<Scalars['uuid']>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Bom_Item_Tag_Set_Sum_Fields = {
  __typename?: 'bom_item_tag_set_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Update_Column =
  /** column name */
  | 'entity_id'
  /** column name */
  | 'id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'quantity'
  /** column name */
  | 'tag_set_id'
  /** column name */
  | 'uom_conversion_id';

export type Bom_Item_Tag_Set_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bom_Item_Tag_Set_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bom_Item_Tag_Set_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bom_Item_Tag_Set_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bom_Item_Tag_Set_Var_Pop_Fields = {
  __typename?: 'bom_item_tag_set_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Bom_Item_Tag_Set_Var_Samp_Fields = {
  __typename?: 'bom_item_tag_set_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Bom_Item_Tag_Set_Variance_Fields = {
  __typename?: 'bom_item_tag_set_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "bom_item_tag_set" */
export type Bom_Item_Tag_Set_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "boms_view" */
export type Boms_View = {
  __typename?: 'boms_view';
  id?: Maybe<Scalars['bigint']>;
  include_waste?: Maybe<Scalars['Boolean']>;
  item_id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['jsonb']>;
  quantity?: Maybe<Scalars['numeric']>;
  ref_id?: Maybe<Scalars['String']>;
  ref_type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "boms_view" */
export type Boms_ViewMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "boms_view" */
export type Boms_View_Aggregate = {
  __typename?: 'boms_view_aggregate';
  aggregate?: Maybe<Boms_View_Aggregate_Fields>;
  nodes: Array<Boms_View>;
};

/** aggregate fields of "boms_view" */
export type Boms_View_Aggregate_Fields = {
  __typename?: 'boms_view_aggregate_fields';
  avg?: Maybe<Boms_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Boms_View_Max_Fields>;
  min?: Maybe<Boms_View_Min_Fields>;
  stddev?: Maybe<Boms_View_Stddev_Fields>;
  stddev_pop?: Maybe<Boms_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Boms_View_Stddev_Samp_Fields>;
  sum?: Maybe<Boms_View_Sum_Fields>;
  var_pop?: Maybe<Boms_View_Var_Pop_Fields>;
  var_samp?: Maybe<Boms_View_Var_Samp_Fields>;
  variance?: Maybe<Boms_View_Variance_Fields>;
};


/** aggregate fields of "boms_view" */
export type Boms_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Boms_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Boms_View_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Boms_View_Avg_Fields = {
  __typename?: 'boms_view_avg_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "boms_view". All fields are combined with a logical 'AND'. */
export type Boms_View_Bool_Exp = {
  _and?: InputMaybe<Array<Boms_View_Bool_Exp>>;
  _not?: InputMaybe<Boms_View_Bool_Exp>;
  _or?: InputMaybe<Array<Boms_View_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  include_waste?: InputMaybe<Boolean_Comparison_Exp>;
  item_id?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  ref_id?: InputMaybe<String_Comparison_Exp>;
  ref_type?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Boms_View_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Boms_View_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Boms_View_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "boms_view" */
export type Boms_View_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "boms_view" */
export type Boms_View_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  ref_id?: InputMaybe<Scalars['String']>;
  ref_type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Boms_View_Max_Fields = {
  __typename?: 'boms_view_max_fields';
  id?: Maybe<Scalars['bigint']>;
  item_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  ref_id?: Maybe<Scalars['String']>;
  ref_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Boms_View_Min_Fields = {
  __typename?: 'boms_view_min_fields';
  id?: Maybe<Scalars['bigint']>;
  item_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  ref_id?: Maybe<Scalars['String']>;
  ref_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "boms_view" */
export type Boms_View_Mutation_Response = {
  __typename?: 'boms_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Boms_View>;
};

/** Ordering options when selecting data from "boms_view". */
export type Boms_View_Order_By = {
  id?: InputMaybe<Order_By>;
  include_waste?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  ref_id?: InputMaybe<Order_By>;
  ref_type?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Boms_View_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "boms_view" */
export type Boms_View_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'item_id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'quantity'
  /** column name */
  | 'ref_id'
  /** column name */
  | 'ref_type';

/** input type for updating data in table "boms_view" */
export type Boms_View_Set_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  ref_id?: InputMaybe<Scalars['String']>;
  ref_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Boms_View_Stddev_Fields = {
  __typename?: 'boms_view_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Boms_View_Stddev_Pop_Fields = {
  __typename?: 'boms_view_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Boms_View_Stddev_Samp_Fields = {
  __typename?: 'boms_view_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "boms_view" */
export type Boms_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Boms_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Boms_View_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  ref_id?: InputMaybe<Scalars['String']>;
  ref_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Boms_View_Sum_Fields = {
  __typename?: 'boms_view_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
};

export type Boms_View_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Boms_View_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Boms_View_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Boms_View_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Boms_View_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Boms_View_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Boms_View_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Boms_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Boms_View_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Boms_View_Var_Pop_Fields = {
  __typename?: 'boms_view_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Boms_View_Var_Samp_Fields = {
  __typename?: 'boms_view_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Boms_View_Variance_Fields = {
  __typename?: 'boms_view_variance_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

export type ChoiceNode = {
  __typename?: 'choiceNode';
  availableTo?: Maybe<Array<Maybe<ProductOptionNode>>>;
  availableToAggregate?: Maybe<ChoiceNodeproductOptionNodeAvailableToAggregationSelection>;
  availableToConnection: ChoiceNodeAvailableToConnection;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<ChoiceNodeitemNodeItemsAggregationSelection>;
  itemsConnection: ChoiceNodeItemsConnection;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optionsOf?: Maybe<Array<Maybe<ProductNode>>>;
  sort_order?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type ChoiceNodeAvailableToArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ChoiceNodeAvailableToAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ChoiceNodeAvailableToConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ChoiceNodeAvailableToConnectionSort>>;
  where?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
};


export type ChoiceNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type ChoiceNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type ChoiceNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ChoiceNodeItemsConnectionSort>>;
  where?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
};

export type ChoiceNodeAggregateSelection = {
  __typename?: 'choiceNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  label: StringAggregateSelection;
  name: StringAggregateSelection;
  sort_order: IntAggregateSelection;
  value: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ChoiceNodeAvailableToAggregateInput = {
  AND?: InputMaybe<Array<ChoiceNodeAvailableToAggregateInput>>;
  OR?: InputMaybe<Array<ChoiceNodeAvailableToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ChoiceNodeAvailableToNodeAggregationWhereInput>;
};

export type ChoiceNodeAvailableToConnectFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeConnectInput>>;
  where?: InputMaybe<ProductOptionNodeConnectWhere>;
};

export type ChoiceNodeAvailableToConnection = {
  __typename?: 'choiceNodeAvailableToConnection';
  edges: Array<ChoiceNodeAvailableToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ChoiceNodeAvailableToConnectionSort = {
  node?: InputMaybe<ProductOptionNodeSort>;
};

export type ChoiceNodeAvailableToConnectionWhere = {
  AND?: InputMaybe<Array<ChoiceNodeAvailableToConnectionWhere>>;
  OR?: InputMaybe<Array<ChoiceNodeAvailableToConnectionWhere>>;
  node?: InputMaybe<ProductOptionNodeWhere>;
  node_NOT?: InputMaybe<ProductOptionNodeWhere>;
};

export type ChoiceNodeAvailableToCreateFieldInput = {
  node: ProductOptionNodeCreateInput;
};

export type ChoiceNodeAvailableToDeleteFieldInput = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
};

export type ChoiceNodeAvailableToDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  where?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
};

export type ChoiceNodeAvailableToFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeAvailableToConnectFieldInput>>;
  create?: InputMaybe<Array<ChoiceNodeAvailableToCreateFieldInput>>;
};

export type ChoiceNodeAvailableToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChoiceNodeAvailableToNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ChoiceNodeAvailableToNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ChoiceNodeAvailableToRelationship = {
  __typename?: 'choiceNodeAvailableToRelationship';
  cursor: Scalars['String'];
  node: ProductOptionNode;
};

export type ChoiceNodeAvailableToUpdateConnectionInput = {
  node?: InputMaybe<ProductOptionNodeUpdateInput>;
};

export type ChoiceNodeAvailableToUpdateFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeAvailableToConnectFieldInput>>;
  create?: InputMaybe<Array<ChoiceNodeAvailableToCreateFieldInput>>;
  delete?: InputMaybe<Array<ChoiceNodeAvailableToDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChoiceNodeAvailableToDisconnectFieldInput>>;
  update?: InputMaybe<ChoiceNodeAvailableToUpdateConnectionInput>;
  where?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
};

export type ChoiceNodeConnectInput = {
  availableTo?: InputMaybe<Array<ChoiceNodeAvailableToConnectFieldInput>>;
  items?: InputMaybe<Array<ChoiceNodeItemsConnectFieldInput>>;
};

export type ChoiceNodeConnectWhere = {
  node: ChoiceNodeWhere;
};

export type ChoiceNodeCreateInput = {
  availableTo?: InputMaybe<ChoiceNodeAvailableToFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ChoiceNodeItemsFieldInput>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ChoiceNodeDeleteInput = {
  availableTo?: InputMaybe<Array<ChoiceNodeAvailableToDeleteFieldInput>>;
  items?: InputMaybe<Array<ChoiceNodeItemsDeleteFieldInput>>;
};

export type ChoiceNodeDisconnectInput = {
  availableTo?: InputMaybe<Array<ChoiceNodeAvailableToDisconnectFieldInput>>;
  items?: InputMaybe<Array<ChoiceNodeItemsDisconnectFieldInput>>;
};

export type ChoiceNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<ChoiceNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<ChoiceNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ChoiceNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<ChoiceNodeItemsNodeAggregationWhereInput>;
};

export type ChoiceNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type ChoiceNodeItemsConnection = {
  __typename?: 'choiceNodeItemsConnection';
  edges: Array<ChoiceNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ChoiceNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type ChoiceNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<ChoiceNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<ChoiceNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type ChoiceNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type ChoiceNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
};

export type ChoiceNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
};

export type ChoiceNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChoiceNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ChoiceNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ChoiceNodeItemsFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ChoiceNodeItemsCreateFieldInput>>;
};

export type ChoiceNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ChoiceNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ChoiceNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ChoiceNodeItemsRelationship = Quantity & {
  __typename?: 'choiceNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type ChoiceNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type ChoiceNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ChoiceNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ChoiceNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ChoiceNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<ChoiceNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
};

export type ChoiceNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more choiceNodeSort objects to sort choiceNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ChoiceNodeSort>>>;
};

export type ChoiceNodeRelationInput = {
  availableTo?: InputMaybe<Array<ChoiceNodeAvailableToCreateFieldInput>>;
  items?: InputMaybe<Array<ChoiceNodeItemsCreateFieldInput>>;
};

/** Fields to sort choiceNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one choiceNodeSort object. */
export type ChoiceNodeSort = {
  description?: InputMaybe<SortDirection>;
  label?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  sort_order?: InputMaybe<SortDirection>;
  value?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ChoiceNodeUpdateInput = {
  availableTo?: InputMaybe<Array<ChoiceNodeAvailableToUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ChoiceNodeItemsUpdateFieldInput>>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ChoiceNodeWhere = {
  AND?: InputMaybe<Array<ChoiceNodeWhere>>;
  OR?: InputMaybe<Array<ChoiceNodeWhere>>;
  availableTo?: InputMaybe<ProductOptionNodeWhere>;
  availableToAggregate?: InputMaybe<ChoiceNodeAvailableToAggregateInput>;
  availableToConnection?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
  availableToConnection_NOT?: InputMaybe<ChoiceNodeAvailableToConnectionWhere>;
  availableTo_NOT?: InputMaybe<ProductOptionNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<ChoiceNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<ChoiceNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  label?: InputMaybe<Scalars['String']>;
  label_CONTAINS?: InputMaybe<Scalars['String']>;
  label_ENDS_WITH?: InputMaybe<Scalars['String']>;
  label_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  label_NOT?: InputMaybe<Scalars['String']>;
  label_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  label_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  label_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  label_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  label_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  sort_order_GT?: InputMaybe<Scalars['Int']>;
  sort_order_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sort_order_LT?: InputMaybe<Scalars['Int']>;
  sort_order_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_NOT?: InputMaybe<Scalars['Int']>;
  sort_order_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  value?: InputMaybe<Scalars['String']>;
  value_CONTAINS?: InputMaybe<Scalars['String']>;
  value_ENDS_WITH?: InputMaybe<Scalars['String']>;
  value_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value_NOT?: InputMaybe<Scalars['String']>;
  value_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  value_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  value_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  value_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  value_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ChoiceNodeitemNodeItemsAggregationSelection = {
  __typename?: 'choiceNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ChoiceNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<ChoiceNodeitemNodeItemsNodeAggregateSelection>;
};

export type ChoiceNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'choiceNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ChoiceNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'choiceNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ChoiceNodeproductOptionNodeAvailableToAggregationSelection = {
  __typename?: 'choiceNodeproductOptionNodeAvailableToAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ChoiceNodeproductOptionNodeAvailableToNodeAggregateSelection>;
};

export type ChoiceNodeproductOptionNodeAvailableToNodeAggregateSelection = {
  __typename?: 'choiceNodeproductOptionNodeAvailableToNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** columns and relationships of "consumable_bom_detail" */
export type Consumable_Bom_Detail = {
  __typename?: 'consumable_bom_detail';
  baseProductId: Scalars['String'];
  /** An object relationship */
  base_product: Base_Product;
  options?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  part: Part;
  partId: Scalars['String'];
  quantity?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "consumable_bom_detail" */
export type Consumable_Bom_DetailOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "consumable_bom_detail" */
export type Consumable_Bom_Detail_Aggregate = {
  __typename?: 'consumable_bom_detail_aggregate';
  aggregate?: Maybe<Consumable_Bom_Detail_Aggregate_Fields>;
  nodes: Array<Consumable_Bom_Detail>;
};

export type Consumable_Bom_Detail_Aggregate_Bool_Exp = {
  count?: InputMaybe<Consumable_Bom_Detail_Aggregate_Bool_Exp_Count>;
};

export type Consumable_Bom_Detail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consumable_bom_detail" */
export type Consumable_Bom_Detail_Aggregate_Fields = {
  __typename?: 'consumable_bom_detail_aggregate_fields';
  avg?: Maybe<Consumable_Bom_Detail_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consumable_Bom_Detail_Max_Fields>;
  min?: Maybe<Consumable_Bom_Detail_Min_Fields>;
  stddev?: Maybe<Consumable_Bom_Detail_Stddev_Fields>;
  stddev_pop?: Maybe<Consumable_Bom_Detail_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumable_Bom_Detail_Stddev_Samp_Fields>;
  sum?: Maybe<Consumable_Bom_Detail_Sum_Fields>;
  var_pop?: Maybe<Consumable_Bom_Detail_Var_Pop_Fields>;
  var_samp?: Maybe<Consumable_Bom_Detail_Var_Samp_Fields>;
  variance?: Maybe<Consumable_Bom_Detail_Variance_Fields>;
};


/** aggregate fields of "consumable_bom_detail" */
export type Consumable_Bom_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Consumable_Bom_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consumable_Bom_Detail_Max_Order_By>;
  min?: InputMaybe<Consumable_Bom_Detail_Min_Order_By>;
  stddev?: InputMaybe<Consumable_Bom_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consumable_Bom_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consumable_Bom_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consumable_Bom_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Consumable_Bom_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consumable_Bom_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Consumable_Bom_Detail_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Consumable_Bom_Detail_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Arr_Rel_Insert_Input = {
  data: Array<Consumable_Bom_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consumable_Bom_Detail_On_Conflict>;
};

/** aggregate avg on columns */
export type Consumable_Bom_Detail_Avg_Fields = {
  __typename?: 'consumable_bom_detail_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consumable_bom_detail". All fields are combined with a logical 'AND'. */
export type Consumable_Bom_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Consumable_Bom_Detail_Bool_Exp>>;
  _not?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Consumable_Bom_Detail_Bool_Exp>>;
  baseProductId?: InputMaybe<String_Comparison_Exp>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  partId?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Constraint =
  /** unique or primary key constraint on columns "partId", "baseProductId" */
  | 'consumable_bom_detail_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Consumable_Bom_Detail_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Consumable_Bom_Detail_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Consumable_Bom_Detail_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Insert_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  options?: InputMaybe<Scalars['jsonb']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  partId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Consumable_Bom_Detail_Max_Fields = {
  __typename?: 'consumable_bom_detail_max_fields';
  baseProductId?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Max_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consumable_Bom_Detail_Min_Fields = {
  __typename?: 'consumable_bom_detail_min_fields';
  baseProductId?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Min_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Mutation_Response = {
  __typename?: 'consumable_bom_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Consumable_Bom_Detail>;
};

/** on_conflict condition type for table "consumable_bom_detail" */
export type Consumable_Bom_Detail_On_Conflict = {
  constraint: Consumable_Bom_Detail_Constraint;
  update_columns?: Array<Consumable_Bom_Detail_Update_Column>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "consumable_bom_detail". */
export type Consumable_Bom_Detail_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  base_product?: InputMaybe<Base_Product_Order_By>;
  options?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  partId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consumable_bom_detail */
export type Consumable_Bom_Detail_Pk_Columns_Input = {
  baseProductId: Scalars['String'];
  partId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Consumable_Bom_Detail_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Select_Column =
  /** column name */
  | 'baseProductId'
  /** column name */
  | 'options'
  /** column name */
  | 'partId'
  /** column name */
  | 'quantity';

/** input type for updating data in table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Set_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  partId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Consumable_Bom_Detail_Stddev_Fields = {
  __typename?: 'consumable_bom_detail_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consumable_Bom_Detail_Stddev_Pop_Fields = {
  __typename?: 'consumable_bom_detail_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consumable_Bom_Detail_Stddev_Samp_Fields = {
  __typename?: 'consumable_bom_detail_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumable_Bom_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumable_Bom_Detail_Stream_Cursor_Value_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  partId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Consumable_Bom_Detail_Sum_Fields = {
  __typename?: 'consumable_bom_detail_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Update_Column =
  /** column name */
  | 'baseProductId'
  /** column name */
  | 'options'
  /** column name */
  | 'partId'
  /** column name */
  | 'quantity';

export type Consumable_Bom_Detail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Consumable_Bom_Detail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Consumable_Bom_Detail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Consumable_Bom_Detail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Consumable_Bom_Detail_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consumable_Bom_Detail_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Consumable_Bom_Detail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consumable_Bom_Detail_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consumable_Bom_Detail_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consumable_Bom_Detail_Var_Pop_Fields = {
  __typename?: 'consumable_bom_detail_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consumable_Bom_Detail_Var_Samp_Fields = {
  __typename?: 'consumable_bom_detail_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consumable_Bom_Detail_Variance_Fields = {
  __typename?: 'consumable_bom_detail_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "consumable_bom_detail" */
export type Consumable_Bom_Detail_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

export type Convertable = {
  id?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

export type ConvertableCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
};

export type ConvertableSort = {
  id?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
};

export type ConvertableUpdateInput = {
  id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type ConvertableWhere = {
  AND?: InputMaybe<Array<ConvertableWhere>>;
  OR?: InputMaybe<Array<ConvertableWhere>>;
  id?: InputMaybe<Scalars['String']>;
  id_CONTAINS?: InputMaybe<Scalars['String']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT?: InputMaybe<Scalars['String']>;
  id_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_NOT?: InputMaybe<Scalars['Float']>;
  quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** columns and relationships of "counters" */
export type Counters = {
  __typename?: 'counters';
  id: Scalars['Int'];
  name: Scalars['String'];
  value: Scalars['Int'];
};

/** aggregated selection of "counters" */
export type Counters_Aggregate = {
  __typename?: 'counters_aggregate';
  aggregate?: Maybe<Counters_Aggregate_Fields>;
  nodes: Array<Counters>;
};

/** aggregate fields of "counters" */
export type Counters_Aggregate_Fields = {
  __typename?: 'counters_aggregate_fields';
  avg?: Maybe<Counters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Counters_Max_Fields>;
  min?: Maybe<Counters_Min_Fields>;
  stddev?: Maybe<Counters_Stddev_Fields>;
  stddev_pop?: Maybe<Counters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Counters_Stddev_Samp_Fields>;
  sum?: Maybe<Counters_Sum_Fields>;
  var_pop?: Maybe<Counters_Var_Pop_Fields>;
  var_samp?: Maybe<Counters_Var_Samp_Fields>;
  variance?: Maybe<Counters_Variance_Fields>;
};


/** aggregate fields of "counters" */
export type Counters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Counters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Counters_Avg_Fields = {
  __typename?: 'counters_avg_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "counters". All fields are combined with a logical 'AND'. */
export type Counters_Bool_Exp = {
  _and?: InputMaybe<Array<Counters_Bool_Exp>>;
  _not?: InputMaybe<Counters_Bool_Exp>;
  _or?: InputMaybe<Array<Counters_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "counters" */
export type Counters_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'counters_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'counters_pkey';

/** input type for incrementing numeric columns in table "counters" */
export type Counters_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "counters" */
export type Counters_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Counters_Max_Fields = {
  __typename?: 'counters_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Counters_Min_Fields = {
  __typename?: 'counters_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "counters" */
export type Counters_Mutation_Response = {
  __typename?: 'counters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Counters>;
};

/** on_conflict condition type for table "counters" */
export type Counters_On_Conflict = {
  constraint: Counters_Constraint;
  update_columns?: Array<Counters_Update_Column>;
  where?: InputMaybe<Counters_Bool_Exp>;
};

/** Ordering options when selecting data from "counters". */
export type Counters_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: counters */
export type Counters_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "counters" */
export type Counters_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'value';

/** input type for updating data in table "counters" */
export type Counters_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Counters_Stddev_Fields = {
  __typename?: 'counters_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Counters_Stddev_Pop_Fields = {
  __typename?: 'counters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Counters_Stddev_Samp_Fields = {
  __typename?: 'counters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "counters" */
export type Counters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Counters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Counters_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Counters_Sum_Fields = {
  __typename?: 'counters_sum_fields';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** update columns of table "counters" */
export type Counters_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'value';

export type Counters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Counters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Counters_Set_Input>;
  /** filter the rows which have to be updated */
  where: Counters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Counters_Var_Pop_Fields = {
  __typename?: 'counters_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Counters_Var_Samp_Fields = {
  __typename?: 'counters_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Counters_Variance_Fields = {
  __typename?: 'counters_variance_fields';
  id?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "csi" */
export type Csi = {
  __typename?: 'csi';
  applicationEngineerId?: Maybe<Scalars['String']>;
  /** An object relationship */
  application_engineer?: Maybe<User_Info>;
  created_at?: Maybe<Scalars['timestamptz']>;
  display_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  level1: Scalars['String'];
  level2: Scalars['String'];
  level3: Scalars['String'];
  /** An array relationship */
  parts: Array<Part>;
  /** An aggregate relationship */
  parts_aggregate: Part_Aggregate;
  title: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "csi" */
export type CsiPartsArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


/** columns and relationships of "csi" */
export type CsiParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};

export type CsiNode = {
  __typename?: 'csiNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<CsiNode>>>;
  itemsAggregate?: Maybe<CsiNodecsiNodeItemsAggregationSelection>;
  itemsConnection: CsiNodeItemsConnection;
  name?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type CsiNodeItemsArgs = {
  options?: InputMaybe<CsiNodeOptions>;
  where?: InputMaybe<CsiNodeWhere>;
};


export type CsiNodeItemsAggregateArgs = {
  where?: InputMaybe<CsiNodeWhere>;
};


export type CsiNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CsiNodeItemsConnectionSort>>;
  where?: InputMaybe<CsiNodeItemsConnectionWhere>;
};

export type CsiNodeAggregateSelection = {
  __typename?: 'csiNodeAggregateSelection';
  code: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type CsiNodeConnectInput = {
  items?: InputMaybe<Array<CsiNodeItemsConnectFieldInput>>;
};

export type CsiNodeConnectWhere = {
  node: CsiNodeWhere;
};

export type CsiNodeCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<CsiNodeItemsFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type CsiNodeDeleteInput = {
  items?: InputMaybe<Array<CsiNodeItemsDeleteFieldInput>>;
};

export type CsiNodeDisconnectInput = {
  items?: InputMaybe<Array<CsiNodeItemsDisconnectFieldInput>>;
};

export type CsiNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<CsiNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<CsiNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<CsiNodeItemsNodeAggregationWhereInput>;
};

export type CsiNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<CsiNodeConnectInput>>;
  where?: InputMaybe<CsiNodeConnectWhere>;
};

export type CsiNodeItemsConnection = {
  __typename?: 'csiNodeItemsConnection';
  edges: Array<CsiNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CsiNodeItemsConnectionSort = {
  node?: InputMaybe<CsiNodeSort>;
};

export type CsiNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<CsiNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<CsiNodeItemsConnectionWhere>>;
  node?: InputMaybe<CsiNodeWhere>;
  node_NOT?: InputMaybe<CsiNodeWhere>;
};

export type CsiNodeItemsCreateFieldInput = {
  node: CsiNodeCreateInput;
};

export type CsiNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<CsiNodeDeleteInput>;
  where?: InputMaybe<CsiNodeItemsConnectionWhere>;
};

export type CsiNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<CsiNodeDisconnectInput>;
  where?: InputMaybe<CsiNodeItemsConnectionWhere>;
};

export type CsiNodeItemsFieldInput = {
  connect?: InputMaybe<Array<CsiNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<CsiNodeItemsCreateFieldInput>>;
};

export type CsiNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CsiNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<CsiNodeItemsNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type CsiNodeItemsRelationship = {
  __typename?: 'csiNodeItemsRelationship';
  cursor: Scalars['String'];
  node: CsiNode;
};

export type CsiNodeItemsUpdateConnectionInput = {
  node?: InputMaybe<CsiNodeUpdateInput>;
};

export type CsiNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<CsiNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<CsiNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<CsiNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CsiNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<CsiNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<CsiNodeItemsConnectionWhere>;
};

export type CsiNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more csiNodeSort objects to sort csiNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<CsiNodeSort>>>;
};

export type CsiNodeRelationInput = {
  items?: InputMaybe<Array<CsiNodeItemsCreateFieldInput>>;
};

/** Fields to sort csiNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one csiNodeSort object. */
export type CsiNodeSort = {
  code?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type CsiNodeUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<CsiNodeItemsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type CsiNodeWhere = {
  AND?: InputMaybe<Array<CsiNodeWhere>>;
  OR?: InputMaybe<Array<CsiNodeWhere>>;
  code?: InputMaybe<Scalars['String']>;
  code_CONTAINS?: InputMaybe<Scalars['String']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']>;
  code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code_NOT?: InputMaybe<Scalars['String']>;
  code_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  code_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<CsiNodeWhere>;
  itemsAggregate?: InputMaybe<CsiNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<CsiNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<CsiNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<CsiNodeWhere>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type CsiNodecsiNodeItemsAggregationSelection = {
  __typename?: 'csiNodecsiNodeItemsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<CsiNodecsiNodeItemsNodeAggregateSelection>;
};

export type CsiNodecsiNodeItemsNodeAggregateSelection = {
  __typename?: 'csiNodecsiNodeItemsNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "csi" */
export type Csi_Aggregate = {
  __typename?: 'csi_aggregate';
  aggregate?: Maybe<Csi_Aggregate_Fields>;
  nodes: Array<Csi>;
};

/** aggregate fields of "csi" */
export type Csi_Aggregate_Fields = {
  __typename?: 'csi_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Csi_Max_Fields>;
  min?: Maybe<Csi_Min_Fields>;
};


/** aggregate fields of "csi" */
export type Csi_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Csi_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "csi". All fields are combined with a logical 'AND'. */
export type Csi_Bool_Exp = {
  _and?: InputMaybe<Array<Csi_Bool_Exp>>;
  _not?: InputMaybe<Csi_Bool_Exp>;
  _or?: InputMaybe<Array<Csi_Bool_Exp>>;
  applicationEngineerId?: InputMaybe<String_Comparison_Exp>;
  application_engineer?: InputMaybe<User_Info_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  level1?: InputMaybe<String_Comparison_Exp>;
  level2?: InputMaybe<String_Comparison_Exp>;
  level3?: InputMaybe<String_Comparison_Exp>;
  parts?: InputMaybe<Part_Bool_Exp>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "csi" */
export type Csi_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'csi_pkey';

/** input type for inserting data into table "csi" */
export type Csi_Insert_Input = {
  applicationEngineerId?: InputMaybe<Scalars['String']>;
  application_engineer?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  level1?: InputMaybe<Scalars['String']>;
  level2?: InputMaybe<Scalars['String']>;
  level3?: InputMaybe<Scalars['String']>;
  parts?: InputMaybe<Part_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Csi_Max_Fields = {
  __typename?: 'csi_max_fields';
  applicationEngineerId?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Csi_Min_Fields = {
  __typename?: 'csi_min_fields';
  applicationEngineerId?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  level1?: Maybe<Scalars['String']>;
  level2?: Maybe<Scalars['String']>;
  level3?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "csi" */
export type Csi_Mutation_Response = {
  __typename?: 'csi_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Csi>;
};

/** input type for inserting object relation for remote table "csi" */
export type Csi_Obj_Rel_Insert_Input = {
  data: Csi_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Csi_On_Conflict>;
};

/** on_conflict condition type for table "csi" */
export type Csi_On_Conflict = {
  constraint: Csi_Constraint;
  update_columns?: Array<Csi_Update_Column>;
  where?: InputMaybe<Csi_Bool_Exp>;
};

/** Ordering options when selecting data from "csi". */
export type Csi_Order_By = {
  applicationEngineerId?: InputMaybe<Order_By>;
  application_engineer?: InputMaybe<User_Info_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level1?: InputMaybe<Order_By>;
  level2?: InputMaybe<Order_By>;
  level3?: InputMaybe<Order_By>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: csi */
export type Csi_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "csi" */
export type Csi_Select_Column =
  /** column name */
  | 'applicationEngineerId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'level1'
  /** column name */
  | 'level2'
  /** column name */
  | 'level3'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "csi" */
export type Csi_Set_Input = {
  applicationEngineerId?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  level1?: InputMaybe<Scalars['String']>;
  level2?: InputMaybe<Scalars['String']>;
  level3?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "csi" */
export type Csi_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Csi_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Csi_Stream_Cursor_Value_Input = {
  applicationEngineerId?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  level1?: InputMaybe<Scalars['String']>;
  level2?: InputMaybe<Scalars['String']>;
  level3?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "csi" */
export type Csi_Update_Column =
  /** column name */
  | 'applicationEngineerId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'level1'
  /** column name */
  | 'level2'
  /** column name */
  | 'level3'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at';

export type Csi_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Csi_Set_Input>;
  /** filter the rows which have to be updated */
  where: Csi_Bool_Exp;
};

/** ordering argument of a cursor */
export type Cursor_Ordering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

/** columns and relationships of "customer" */
export type Customer = {
  __typename?: 'customer';
  /** An array relationship */
  admins: Array<Customer_Admin>;
  /** An aggregate relationship */
  admins_aggregate: Customer_Admin_Aggregate;
  alias: Scalars['String'];
  id: Scalars['String'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  products: Array<Base_Product>;
  /** An aggregate relationship */
  products_aggregate: Base_Product_Aggregate;
  /** An object relationship */
  programManager?: Maybe<User>;
  programManagerId?: Maybe<Scalars['String']>;
  /** An array relationship */
  programs: Array<Program>;
  /** An aggregate relationship */
  programs_aggregate: Program_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
};


/** columns and relationships of "customer" */
export type CustomerAdminsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerAdmins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProductsArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProgramsArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerPrograms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

export type CustomerNode = {
  __typename?: 'customerNode';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ordersConfirmed?: Maybe<Array<Maybe<OrderNode>>>;
  ordersConfirmedAggregate?: Maybe<CustomerNodeorderNodeOrdersConfirmedAggregationSelection>;
  ordersConfirmedConnection: CustomerNodeOrdersConfirmedConnection;
  ordersRequested?: Maybe<Array<Maybe<OrderNode>>>;
  ordersRequestedAggregate?: Maybe<CustomerNodeorderNodeOrdersRequestedAggregationSelection>;
  ordersRequestedConnection: CustomerNodeOrdersRequestedConnection;
  projects?: Maybe<Array<Maybe<ProjectNode>>>;
  projectsAggregate?: Maybe<CustomerNodeprojectNodeProjectsAggregationSelection>;
  projectsConnection: CustomerNodeProjectsConnection;
  wevrId?: Maybe<Scalars['String']>;
};


export type CustomerNodeOrdersConfirmedArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type CustomerNodeOrdersConfirmedAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type CustomerNodeOrdersConfirmedConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectionSort>>;
  where?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
};


export type CustomerNodeOrdersRequestedArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type CustomerNodeOrdersRequestedAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type CustomerNodeOrdersRequestedConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectionSort>>;
  where?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
};


export type CustomerNodeProjectsArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type CustomerNodeProjectsAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type CustomerNodeProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<CustomerNodeProjectsConnectionSort>>;
  where?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
};

export type CustomerNodeAggregateSelection = {
  __typename?: 'customerNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type CustomerNodeConnectInput = {
  ordersConfirmed?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectFieldInput>>;
  ordersRequested?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectFieldInput>>;
  projects?: InputMaybe<Array<CustomerNodeProjectsConnectFieldInput>>;
};

export type CustomerNodeConnectWhere = {
  node: CustomerNodeWhere;
};

export type CustomerNodeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ordersConfirmed?: InputMaybe<CustomerNodeOrdersConfirmedFieldInput>;
  ordersRequested?: InputMaybe<CustomerNodeOrdersRequestedFieldInput>;
  projects?: InputMaybe<CustomerNodeProjectsFieldInput>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type CustomerNodeDeleteInput = {
  ordersConfirmed?: InputMaybe<Array<CustomerNodeOrdersConfirmedDeleteFieldInput>>;
  ordersRequested?: InputMaybe<Array<CustomerNodeOrdersRequestedDeleteFieldInput>>;
  projects?: InputMaybe<Array<CustomerNodeProjectsDeleteFieldInput>>;
};

export type CustomerNodeDisconnectInput = {
  ordersConfirmed?: InputMaybe<Array<CustomerNodeOrdersConfirmedDisconnectFieldInput>>;
  ordersRequested?: InputMaybe<Array<CustomerNodeOrdersRequestedDisconnectFieldInput>>;
  projects?: InputMaybe<Array<CustomerNodeProjectsDisconnectFieldInput>>;
};

export type CustomerNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more customerNodeSort objects to sort customerNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<CustomerNodeSort>>>;
};

export type CustomerNodeOrdersConfirmedAggregateInput = {
  AND?: InputMaybe<Array<CustomerNodeOrdersConfirmedAggregateInput>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersConfirmedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<CustomerNodeOrdersConfirmedNodeAggregationWhereInput>;
};

export type CustomerNodeOrdersConfirmedConnectFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConnectInput>>;
  where?: InputMaybe<OrderNodeConnectWhere>;
};

export type CustomerNodeOrdersConfirmedConnection = {
  __typename?: 'customerNodeOrdersConfirmedConnection';
  edges: Array<CustomerNodeOrdersConfirmedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomerNodeOrdersConfirmedConnectionSort = {
  node?: InputMaybe<OrderNodeSort>;
};

export type CustomerNodeOrdersConfirmedConnectionWhere = {
  AND?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectionWhere>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectionWhere>>;
  node?: InputMaybe<OrderNodeWhere>;
  node_NOT?: InputMaybe<OrderNodeWhere>;
};

export type CustomerNodeOrdersConfirmedCreateFieldInput = {
  node: OrderNodeCreateInput;
};

export type CustomerNodeOrdersConfirmedDeleteFieldInput = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
};

export type CustomerNodeOrdersConfirmedDisconnectFieldInput = {
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  where?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
};

export type CustomerNodeOrdersConfirmedFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeOrdersConfirmedCreateFieldInput>>;
};

export type CustomerNodeOrdersConfirmedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomerNodeOrdersConfirmedNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersConfirmedNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type CustomerNodeOrdersConfirmedRelationship = {
  __typename?: 'customerNodeOrdersConfirmedRelationship';
  cursor: Scalars['String'];
  node: OrderNode;
};

export type CustomerNodeOrdersConfirmedUpdateConnectionInput = {
  node?: InputMaybe<OrderNodeUpdateInput>;
};

export type CustomerNodeOrdersConfirmedUpdateFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeOrdersConfirmedConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeOrdersConfirmedCreateFieldInput>>;
  delete?: InputMaybe<Array<CustomerNodeOrdersConfirmedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CustomerNodeOrdersConfirmedDisconnectFieldInput>>;
  update?: InputMaybe<CustomerNodeOrdersConfirmedUpdateConnectionInput>;
  where?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
};

export type CustomerNodeOrdersRequestedAggregateInput = {
  AND?: InputMaybe<Array<CustomerNodeOrdersRequestedAggregateInput>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersRequestedAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<CustomerNodeOrdersRequestedNodeAggregationWhereInput>;
};

export type CustomerNodeOrdersRequestedConnectFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConnectInput>>;
  where?: InputMaybe<OrderNodeConnectWhere>;
};

export type CustomerNodeOrdersRequestedConnection = {
  __typename?: 'customerNodeOrdersRequestedConnection';
  edges: Array<CustomerNodeOrdersRequestedRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomerNodeOrdersRequestedConnectionSort = {
  node?: InputMaybe<OrderNodeSort>;
};

export type CustomerNodeOrdersRequestedConnectionWhere = {
  AND?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectionWhere>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectionWhere>>;
  node?: InputMaybe<OrderNodeWhere>;
  node_NOT?: InputMaybe<OrderNodeWhere>;
};

export type CustomerNodeOrdersRequestedCreateFieldInput = {
  node: OrderNodeCreateInput;
};

export type CustomerNodeOrdersRequestedDeleteFieldInput = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
};

export type CustomerNodeOrdersRequestedDisconnectFieldInput = {
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  where?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
};

export type CustomerNodeOrdersRequestedFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeOrdersRequestedCreateFieldInput>>;
};

export type CustomerNodeOrdersRequestedNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomerNodeOrdersRequestedNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<CustomerNodeOrdersRequestedNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type CustomerNodeOrdersRequestedRelationship = {
  __typename?: 'customerNodeOrdersRequestedRelationship';
  cursor: Scalars['String'];
  node: OrderNode;
};

export type CustomerNodeOrdersRequestedUpdateConnectionInput = {
  node?: InputMaybe<OrderNodeUpdateInput>;
};

export type CustomerNodeOrdersRequestedUpdateFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeOrdersRequestedConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeOrdersRequestedCreateFieldInput>>;
  delete?: InputMaybe<Array<CustomerNodeOrdersRequestedDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CustomerNodeOrdersRequestedDisconnectFieldInput>>;
  update?: InputMaybe<CustomerNodeOrdersRequestedUpdateConnectionInput>;
  where?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
};

export type CustomerNodeProjectsAggregateInput = {
  AND?: InputMaybe<Array<CustomerNodeProjectsAggregateInput>>;
  OR?: InputMaybe<Array<CustomerNodeProjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<CustomerNodeProjectsNodeAggregationWhereInput>;
};

export type CustomerNodeProjectsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeConnectInput>>;
  where?: InputMaybe<ProjectNodeConnectWhere>;
};

export type CustomerNodeProjectsConnection = {
  __typename?: 'customerNodeProjectsConnection';
  edges: Array<CustomerNodeProjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomerNodeProjectsConnectionSort = {
  node?: InputMaybe<ProjectNodeSort>;
};

export type CustomerNodeProjectsConnectionWhere = {
  AND?: InputMaybe<Array<CustomerNodeProjectsConnectionWhere>>;
  OR?: InputMaybe<Array<CustomerNodeProjectsConnectionWhere>>;
  node?: InputMaybe<ProjectNodeWhere>;
  node_NOT?: InputMaybe<ProjectNodeWhere>;
};

export type CustomerNodeProjectsCreateFieldInput = {
  node: ProjectNodeCreateInput;
};

export type CustomerNodeProjectsDeleteFieldInput = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
};

export type CustomerNodeProjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  where?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
};

export type CustomerNodeProjectsFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeProjectsCreateFieldInput>>;
};

export type CustomerNodeProjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<CustomerNodeProjectsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<CustomerNodeProjectsNodeAggregationWhereInput>>;
  bloxProjectNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_EQUAL?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type CustomerNodeProjectsRelationship = {
  __typename?: 'customerNodeProjectsRelationship';
  cursor: Scalars['String'];
  node: ProjectNode;
};

export type CustomerNodeProjectsUpdateConnectionInput = {
  node?: InputMaybe<ProjectNodeUpdateInput>;
};

export type CustomerNodeProjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<CustomerNodeProjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<CustomerNodeProjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<CustomerNodeProjectsDisconnectFieldInput>>;
  update?: InputMaybe<CustomerNodeProjectsUpdateConnectionInput>;
  where?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
};

export type CustomerNodeRelationInput = {
  ordersConfirmed?: InputMaybe<Array<CustomerNodeOrdersConfirmedCreateFieldInput>>;
  ordersRequested?: InputMaybe<Array<CustomerNodeOrdersRequestedCreateFieldInput>>;
  projects?: InputMaybe<Array<CustomerNodeProjectsCreateFieldInput>>;
};

/** Fields to sort customerNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one customerNodeSort object. */
export type CustomerNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type CustomerNodeUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ordersConfirmed?: InputMaybe<Array<CustomerNodeOrdersConfirmedUpdateFieldInput>>;
  ordersRequested?: InputMaybe<Array<CustomerNodeOrdersRequestedUpdateFieldInput>>;
  projects?: InputMaybe<Array<CustomerNodeProjectsUpdateFieldInput>>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type CustomerNodeWhere = {
  AND?: InputMaybe<Array<CustomerNodeWhere>>;
  OR?: InputMaybe<Array<CustomerNodeWhere>>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  ordersConfirmed?: InputMaybe<OrderNodeWhere>;
  ordersConfirmedAggregate?: InputMaybe<CustomerNodeOrdersConfirmedAggregateInput>;
  ordersConfirmedConnection?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
  ordersConfirmedConnection_NOT?: InputMaybe<CustomerNodeOrdersConfirmedConnectionWhere>;
  ordersConfirmed_NOT?: InputMaybe<OrderNodeWhere>;
  ordersRequested?: InputMaybe<OrderNodeWhere>;
  ordersRequestedAggregate?: InputMaybe<CustomerNodeOrdersRequestedAggregateInput>;
  ordersRequestedConnection?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
  ordersRequestedConnection_NOT?: InputMaybe<CustomerNodeOrdersRequestedConnectionWhere>;
  ordersRequested_NOT?: InputMaybe<OrderNodeWhere>;
  projects?: InputMaybe<ProjectNodeWhere>;
  projectsAggregate?: InputMaybe<CustomerNodeProjectsAggregateInput>;
  projectsConnection?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
  projectsConnection_NOT?: InputMaybe<CustomerNodeProjectsConnectionWhere>;
  projects_NOT?: InputMaybe<ProjectNodeWhere>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type CustomerNodeorderNodeOrdersConfirmedAggregationSelection = {
  __typename?: 'customerNodeorderNodeOrdersConfirmedAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<CustomerNodeorderNodeOrdersConfirmedNodeAggregateSelection>;
};

export type CustomerNodeorderNodeOrdersConfirmedNodeAggregateSelection = {
  __typename?: 'customerNodeorderNodeOrdersConfirmedNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type CustomerNodeorderNodeOrdersRequestedAggregationSelection = {
  __typename?: 'customerNodeorderNodeOrdersRequestedAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<CustomerNodeorderNodeOrdersRequestedNodeAggregateSelection>;
};

export type CustomerNodeorderNodeOrdersRequestedNodeAggregateSelection = {
  __typename?: 'customerNodeorderNodeOrdersRequestedNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type CustomerNodeprojectNodeProjectsAggregationSelection = {
  __typename?: 'customerNodeprojectNodeProjectsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<CustomerNodeprojectNodeProjectsNodeAggregateSelection>;
};

export type CustomerNodeprojectNodeProjectsNodeAggregateSelection = {
  __typename?: 'customerNodeprojectNodeProjectsNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** columns and relationships of "customer_admin" */
export type Customer_Admin = {
  __typename?: 'customer_admin';
  /** An object relationship */
  customer?: Maybe<Customer>;
  customerId: Scalars['String'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "customer_admin" */
export type Customer_Admin_Aggregate = {
  __typename?: 'customer_admin_aggregate';
  aggregate?: Maybe<Customer_Admin_Aggregate_Fields>;
  nodes: Array<Customer_Admin>;
};

export type Customer_Admin_Aggregate_Bool_Exp = {
  count?: InputMaybe<Customer_Admin_Aggregate_Bool_Exp_Count>;
};

export type Customer_Admin_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customer_Admin_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer_admin" */
export type Customer_Admin_Aggregate_Fields = {
  __typename?: 'customer_admin_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Admin_Max_Fields>;
  min?: Maybe<Customer_Admin_Min_Fields>;
};


/** aggregate fields of "customer_admin" */
export type Customer_Admin_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "customer_admin" */
export type Customer_Admin_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Admin_Max_Order_By>;
  min?: InputMaybe<Customer_Admin_Min_Order_By>;
};

/** input type for inserting array relation for remote table "customer_admin" */
export type Customer_Admin_Arr_Rel_Insert_Input = {
  data: Array<Customer_Admin_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_Admin_On_Conflict>;
};

/** Boolean expression to filter rows from the table "customer_admin". All fields are combined with a logical 'AND'. */
export type Customer_Admin_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Admin_Bool_Exp>>;
  _not?: InputMaybe<Customer_Admin_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Admin_Bool_Exp>>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  customerId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "customer_admin" */
export type Customer_Admin_Constraint =
  /** unique or primary key constraint on columns "customerId", "userId" */
  | 'customer_admin_pkey';

/** input type for inserting data into table "customer_admin" */
export type Customer_Admin_Insert_Input = {
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  customerId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Customer_Admin_Max_Fields = {
  __typename?: 'customer_admin_max_fields';
  customerId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "customer_admin" */
export type Customer_Admin_Max_Order_By = {
  customerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Admin_Min_Fields = {
  __typename?: 'customer_admin_min_fields';
  customerId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "customer_admin" */
export type Customer_Admin_Min_Order_By = {
  customerId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "customer_admin" */
export type Customer_Admin_Mutation_Response = {
  __typename?: 'customer_admin_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer_Admin>;
};

/** on_conflict condition type for table "customer_admin" */
export type Customer_Admin_On_Conflict = {
  constraint: Customer_Admin_Constraint;
  update_columns?: Array<Customer_Admin_Update_Column>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};

/** Ordering options when selecting data from "customer_admin". */
export type Customer_Admin_Order_By = {
  customer?: InputMaybe<Customer_Order_By>;
  customerId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: customer_admin */
export type Customer_Admin_Pk_Columns_Input = {
  customerId: Scalars['String'];
  userId: Scalars['String'];
};

/** select columns of table "customer_admin" */
export type Customer_Admin_Select_Column =
  /** column name */
  | 'customerId'
  /** column name */
  | 'userId';

/** input type for updating data in table "customer_admin" */
export type Customer_Admin_Set_Input = {
  customerId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "customer_admin" */
export type Customer_Admin_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Admin_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Admin_Stream_Cursor_Value_Input = {
  customerId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "customer_admin" */
export type Customer_Admin_Update_Column =
  /** column name */
  | 'customerId'
  /** column name */
  | 'userId';

export type Customer_Admin_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Admin_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Admin_Bool_Exp;
};

/** aggregated selection of "customer" */
export type Customer_Aggregate = {
  __typename?: 'customer_aggregate';
  aggregate?: Maybe<Customer_Aggregate_Fields>;
  nodes: Array<Customer>;
};

/** aggregate fields of "customer" */
export type Customer_Aggregate_Fields = {
  __typename?: 'customer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Max_Fields>;
  min?: Maybe<Customer_Min_Fields>;
};


/** aggregate fields of "customer" */
export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>;
  _not?: InputMaybe<Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Bool_Exp>>;
  admins?: InputMaybe<Customer_Admin_Bool_Exp>;
  admins_aggregate?: InputMaybe<Customer_Admin_Aggregate_Bool_Exp>;
  alias?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Base_Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Base_Product_Aggregate_Bool_Exp>;
  programManager?: InputMaybe<User_Bool_Exp>;
  programManagerId?: InputMaybe<String_Comparison_Exp>;
  programs?: InputMaybe<Program_Bool_Exp>;
  programs_aggregate?: InputMaybe<Program_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "customer" */
export type Customer_Constraint =
  /** unique or primary key constraint on columns "alias" */
  | 'customer_alias_key'
  /** unique or primary key constraint on columns "id" */
  | 'customer_pkey';

/** input type for inserting data into table "customer" */
export type Customer_Insert_Input = {
  admins?: InputMaybe<Customer_Admin_Arr_Rel_Insert_Input>;
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Base_Product_Arr_Rel_Insert_Input>;
  programManager?: InputMaybe<User_Obj_Rel_Insert_Input>;
  programManagerId?: InputMaybe<Scalars['String']>;
  programs?: InputMaybe<Program_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Customer_Max_Fields = {
  __typename?: 'customer_max_fields';
  alias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programManagerId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customer_Min_Fields = {
  __typename?: 'customer_min_fields';
  alias?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programManagerId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "customer" */
export type Customer_Mutation_Response = {
  __typename?: 'customer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Customer>;
};

/** input type for inserting object relation for remote table "customer" */
export type Customer_Obj_Rel_Insert_Input = {
  data: Customer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};

/** on_conflict condition type for table "customer" */
export type Customer_On_Conflict = {
  constraint: Customer_Constraint;
  update_columns?: Array<Customer_Update_Column>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

/** Ordering options when selecting data from "customer". */
export type Customer_Order_By = {
  admins_aggregate?: InputMaybe<Customer_Admin_Aggregate_Order_By>;
  alias?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Base_Product_Aggregate_Order_By>;
  programManager?: InputMaybe<User_Order_By>;
  programManagerId?: InputMaybe<Order_By>;
  programs_aggregate?: InputMaybe<Program_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
};

/** primary key columns input for table: customer */
export type Customer_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "customer" */
export type Customer_Select_Column =
  /** column name */
  | 'alias'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'programManagerId';

/** input type for updating data in table "customer" */
export type Customer_Set_Input = {
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  programManagerId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "customer" */
export type Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  programManagerId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "customer" */
export type Customer_Update_Column =
  /** column name */
  | 'alias'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'programManagerId';

export type Customer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Customer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Customer_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "email_templates" */
export type Email_Templates = {
  __typename?: 'email_templates';
  body_template: Scalars['String'];
  default_recipients?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  input_type?: Maybe<Scalars['String']>;
  variables?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesVariablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_templates" */
export type Email_Templates_Aggregate = {
  __typename?: 'email_templates_aggregate';
  aggregate?: Maybe<Email_Templates_Aggregate_Fields>;
  nodes: Array<Email_Templates>;
};

/** aggregate fields of "email_templates" */
export type Email_Templates_Aggregate_Fields = {
  __typename?: 'email_templates_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Email_Templates_Max_Fields>;
  min?: Maybe<Email_Templates_Min_Fields>;
};


/** aggregate fields of "email_templates" */
export type Email_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Append_Input = {
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "email_templates". All fields are combined with a logical 'AND'. */
export type Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  body_template?: InputMaybe<String_Comparison_Exp>;
  default_recipients?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  input_type?: InputMaybe<String_Comparison_Exp>;
  variables?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_templates" */
export type Email_Templates_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'emails_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Templates_Delete_At_Path_Input = {
  variables?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Templates_Delete_Elem_Input = {
  variables?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Templates_Delete_Key_Input = {
  variables?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "email_templates" */
export type Email_Templates_Insert_Input = {
  body_template?: InputMaybe<Scalars['String']>;
  default_recipients?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_type?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Email_Templates_Max_Fields = {
  __typename?: 'email_templates_max_fields';
  body_template?: Maybe<Scalars['String']>;
  default_recipients?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Email_Templates_Min_Fields = {
  __typename?: 'email_templates_min_fields';
  body_template?: Maybe<Scalars['String']>;
  default_recipients?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "email_templates" */
export type Email_Templates_Mutation_Response = {
  __typename?: 'email_templates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates>;
};

/** on_conflict condition type for table "email_templates" */
export type Email_Templates_On_Conflict = {
  constraint: Email_Templates_Constraint;
  update_columns?: Array<Email_Templates_Update_Column>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "email_templates". */
export type Email_Templates_Order_By = {
  body_template?: InputMaybe<Order_By>;
  default_recipients?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_type?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_templates */
export type Email_Templates_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Prepend_Input = {
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "email_templates" */
export type Email_Templates_Select_Column =
  /** column name */
  | 'body_template'
  /** column name */
  | 'default_recipients'
  /** column name */
  | 'id'
  /** column name */
  | 'input_type'
  /** column name */
  | 'variables';

/** input type for updating data in table "email_templates" */
export type Email_Templates_Set_Input = {
  body_template?: InputMaybe<Scalars['String']>;
  default_recipients?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_type?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "email_templates" */
export type Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Templates_Stream_Cursor_Value_Input = {
  body_template?: InputMaybe<Scalars['String']>;
  default_recipients?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_type?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "email_templates" */
export type Email_Templates_Update_Column =
  /** column name */
  | 'body_template'
  /** column name */
  | 'default_recipients'
  /** column name */
  | 'id'
  /** column name */
  | 'input_type'
  /** column name */
  | 'variables';

export type Email_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Templates_Bool_Exp;
};

/** columns and relationships of "emails" */
export type Emails = {
  __typename?: 'emails';
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  created_by_user?: Maybe<User_Info>;
  html?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  send_attempted_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};

/** aggregated selection of "emails" */
export type Emails_Aggregate = {
  __typename?: 'emails_aggregate';
  aggregate?: Maybe<Emails_Aggregate_Fields>;
  nodes: Array<Emails>;
};

/** aggregate fields of "emails" */
export type Emails_Aggregate_Fields = {
  __typename?: 'emails_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Emails_Max_Fields>;
  min?: Maybe<Emails_Min_Fields>;
};


/** aggregate fields of "emails" */
export type Emails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Emails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "emails". All fields are combined with a logical 'AND'. */
export type Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Emails_Bool_Exp>>;
  _not?: InputMaybe<Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Emails_Bool_Exp>>;
  claimed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Info_Bool_Exp>;
  html?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  send_attempted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "emails" */
export type Emails_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'emails_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'emails_pkey1';

/** input type for inserting data into table "emails" */
export type Emails_Insert_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  send_attempted_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Emails_Max_Fields = {
  __typename?: 'emails_max_fields';
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  send_attempted_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Emails_Min_Fields = {
  __typename?: 'emails_min_fields';
  claimed_at?: Maybe<Scalars['timestamptz']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  send_attempted_at?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "emails" */
export type Emails_Mutation_Response = {
  __typename?: 'emails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Emails>;
};

/** on_conflict condition type for table "emails" */
export type Emails_On_Conflict = {
  constraint: Emails_Constraint;
  update_columns?: Array<Emails_Update_Column>;
  where?: InputMaybe<Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "emails". */
export type Emails_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Info_Order_By>;
  html?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  send_attempted_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emails */
export type Emails_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "emails" */
export type Emails_Select_Column =
  /** column name */
  | 'claimed_at'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'html'
  /** column name */
  | 'id'
  /** column name */
  | 'send_attempted_at'
  /** column name */
  | 'status'
  /** column name */
  | 'subject'
  /** column name */
  | 'text'
  /** column name */
  | 'to';

/** input type for updating data in table "emails" */
export type Emails_Set_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  send_attempted_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "emails" */
export type Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emails_Stream_Cursor_Value_Input = {
  claimed_at?: InputMaybe<Scalars['timestamptz']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  send_attempted_at?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** update columns of table "emails" */
export type Emails_Update_Column =
  /** column name */
  | 'claimed_at'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'html'
  /** column name */
  | 'id'
  /** column name */
  | 'send_attempted_at'
  /** column name */
  | 'status'
  /** column name */
  | 'subject'
  /** column name */
  | 'text'
  /** column name */
  | 'to';

export type Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emails_Bool_Exp;
};

/** columns and relationships of "feedback" */
export type Feedback = {
  __typename?: 'feedback';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  /** An object relationship */
  created_by_user?: Maybe<User_Info>;
  description: Scalars['String'];
  id: Scalars['Int'];
  issue_link: Scalars['String'];
  resolved: Scalars['Boolean'];
  resolved_reason: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "feedback" */
export type Feedback_Aggregate = {
  __typename?: 'feedback_aggregate';
  aggregate?: Maybe<Feedback_Aggregate_Fields>;
  nodes: Array<Feedback>;
};

/** aggregate fields of "feedback" */
export type Feedback_Aggregate_Fields = {
  __typename?: 'feedback_aggregate_fields';
  avg?: Maybe<Feedback_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Feedback_Max_Fields>;
  min?: Maybe<Feedback_Min_Fields>;
  stddev?: Maybe<Feedback_Stddev_Fields>;
  stddev_pop?: Maybe<Feedback_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Feedback_Stddev_Samp_Fields>;
  sum?: Maybe<Feedback_Sum_Fields>;
  var_pop?: Maybe<Feedback_Var_Pop_Fields>;
  var_samp?: Maybe<Feedback_Var_Samp_Fields>;
  variance?: Maybe<Feedback_Variance_Fields>;
};


/** aggregate fields of "feedback" */
export type Feedback_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Feedback_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Feedback_Avg_Fields = {
  __typename?: 'feedback_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "feedback". All fields are combined with a logical 'AND'. */
export type Feedback_Bool_Exp = {
  _and?: InputMaybe<Array<Feedback_Bool_Exp>>;
  _not?: InputMaybe<Feedback_Bool_Exp>;
  _or?: InputMaybe<Array<Feedback_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Info_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issue_link?: InputMaybe<String_Comparison_Exp>;
  resolved?: InputMaybe<Boolean_Comparison_Exp>;
  resolved_reason?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "feedback" */
export type Feedback_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'feedback_pkey';

/** input type for incrementing numeric columns in table "feedback" */
export type Feedback_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "feedback" */
export type Feedback_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  issue_link?: InputMaybe<Scalars['String']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resolved_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Feedback_Max_Fields = {
  __typename?: 'feedback_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  issue_link?: Maybe<Scalars['String']>;
  resolved_reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Feedback_Min_Fields = {
  __typename?: 'feedback_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  issue_link?: Maybe<Scalars['String']>;
  resolved_reason?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "feedback" */
export type Feedback_Mutation_Response = {
  __typename?: 'feedback_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Feedback>;
};

/** on_conflict condition type for table "feedback" */
export type Feedback_On_Conflict = {
  constraint: Feedback_Constraint;
  update_columns?: Array<Feedback_Update_Column>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};

/** Ordering options when selecting data from "feedback". */
export type Feedback_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Info_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_link?: InputMaybe<Order_By>;
  resolved?: InputMaybe<Order_By>;
  resolved_reason?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: feedback */
export type Feedback_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "feedback" */
export type Feedback_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'issue_link'
  /** column name */
  | 'resolved'
  /** column name */
  | 'resolved_reason'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "feedback" */
export type Feedback_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  issue_link?: InputMaybe<Scalars['String']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resolved_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Feedback_Stddev_Fields = {
  __typename?: 'feedback_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Feedback_Stddev_Pop_Fields = {
  __typename?: 'feedback_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Feedback_Stddev_Samp_Fields = {
  __typename?: 'feedback_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "feedback" */
export type Feedback_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feedback_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feedback_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  issue_link?: InputMaybe<Scalars['String']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
  resolved_reason?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Feedback_Sum_Fields = {
  __typename?: 'feedback_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "feedback" */
export type Feedback_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'issue_link'
  /** column name */
  | 'resolved'
  /** column name */
  | 'resolved_reason'
  /** column name */
  | 'updated_at';

export type Feedback_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Feedback_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Feedback_Set_Input>;
  /** filter the rows which have to be updated */
  where: Feedback_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Feedback_Var_Pop_Fields = {
  __typename?: 'feedback_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Feedback_Var_Samp_Fields = {
  __typename?: 'feedback_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Feedback_Variance_Fields = {
  __typename?: 'feedback_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** Boolean expression to compare columns of type "interval". All fields are combined with logical 'AND'. */
export type Interval_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['interval']>;
  _gt?: InputMaybe<Scalars['interval']>;
  _gte?: InputMaybe<Scalars['interval']>;
  _in?: InputMaybe<Array<Scalars['interval']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['interval']>;
  _lte?: InputMaybe<Scalars['interval']>;
  _neq?: InputMaybe<Scalars['interval']>;
  _nin?: InputMaybe<Array<Scalars['interval']>>;
};

/** columns and relationships of "invitation" */
export type Invitation = {
  __typename?: 'invitation';
  customerId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expires_at: Scalars['date'];
  id: Scalars['uuid'];
  invited_by: Scalars['String'];
  /** An object relationship */
  invitingUser: User;
  options: Scalars['jsonb'];
  responded_at?: Maybe<Scalars['date']>;
};


/** columns and relationships of "invitation" */
export type InvitationOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invitation" */
export type Invitation_Aggregate = {
  __typename?: 'invitation_aggregate';
  aggregate?: Maybe<Invitation_Aggregate_Fields>;
  nodes: Array<Invitation>;
};

export type Invitation_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invitation_Aggregate_Bool_Exp_Count>;
};

export type Invitation_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invitation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invitation_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invitation" */
export type Invitation_Aggregate_Fields = {
  __typename?: 'invitation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invitation_Max_Fields>;
  min?: Maybe<Invitation_Min_Fields>;
};


/** aggregate fields of "invitation" */
export type Invitation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invitation" */
export type Invitation_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invitation_Max_Order_By>;
  min?: InputMaybe<Invitation_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invitation_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invitation" */
export type Invitation_Arr_Rel_Insert_Input = {
  data: Array<Invitation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invitation". All fields are combined with a logical 'AND'. */
export type Invitation_Bool_Exp = {
  _and?: InputMaybe<Array<Invitation_Bool_Exp>>;
  _not?: InputMaybe<Invitation_Bool_Exp>;
  _or?: InputMaybe<Array<Invitation_Bool_Exp>>;
  customerId?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expires_at?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_by?: InputMaybe<String_Comparison_Exp>;
  invitingUser?: InputMaybe<User_Bool_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  responded_at?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitation" */
export type Invitation_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'invitations_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invitation_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invitation_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invitation_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "invitation" */
export type Invitation_Insert_Input = {
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_by?: InputMaybe<Scalars['String']>;
  invitingUser?: InputMaybe<User_Obj_Rel_Insert_Input>;
  options?: InputMaybe<Scalars['jsonb']>;
  responded_at?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Invitation_Max_Fields = {
  __typename?: 'invitation_max_fields';
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['String']>;
  responded_at?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "invitation" */
export type Invitation_Max_Order_By = {
  customerId?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invitation_Min_Fields = {
  __typename?: 'invitation_min_fields';
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  invited_by?: Maybe<Scalars['String']>;
  responded_at?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "invitation" */
export type Invitation_Min_Order_By = {
  customerId?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invitation" */
export type Invitation_Mutation_Response = {
  __typename?: 'invitation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitation>;
};

/** on_conflict condition type for table "invitation" */
export type Invitation_On_Conflict = {
  constraint: Invitation_Constraint;
  update_columns?: Array<Invitation_Update_Column>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};

/** Ordering options when selecting data from "invitation". */
export type Invitation_Order_By = {
  customerId?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  invitingUser?: InputMaybe<User_Order_By>;
  options?: InputMaybe<Order_By>;
  responded_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitation */
export type Invitation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invitation_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invitation" */
export type Invitation_Select_Column =
  /** column name */
  | 'customerId'
  /** column name */
  | 'email'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'invited_by'
  /** column name */
  | 'options'
  /** column name */
  | 'responded_at';

/** input type for updating data in table "invitation" */
export type Invitation_Set_Input = {
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_by?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  responded_at?: InputMaybe<Scalars['date']>;
};

/** Streaming cursor of the table "invitation" */
export type Invitation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitation_Stream_Cursor_Value_Input = {
  customerId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expires_at?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_by?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  responded_at?: InputMaybe<Scalars['date']>;
};

/** update columns of table "invitation" */
export type Invitation_Update_Column =
  /** column name */
  | 'customerId'
  /** column name */
  | 'email'
  /** column name */
  | 'expires_at'
  /** column name */
  | 'id'
  /** column name */
  | 'invited_by'
  /** column name */
  | 'options'
  /** column name */
  | 'responded_at';

export type Invitation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invitation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invitation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invitation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invitation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invitation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitation_Bool_Exp;
};

/** columns and relationships of "issue" */
export type Issue = {
  __typename?: 'issue';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  /** An object relationship */
  created_by_user?: Maybe<User_Info>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  options?: Maybe<Scalars['jsonb']>;
  status: Scalars['String'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['String'];
  /** An object relationship */
  updated_by_user?: Maybe<User_Info>;
};


/** columns and relationships of "issue" */
export type IssueOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "issue" */
export type Issue_Aggregate = {
  __typename?: 'issue_aggregate';
  aggregate?: Maybe<Issue_Aggregate_Fields>;
  nodes: Array<Issue>;
};

/** aggregate fields of "issue" */
export type Issue_Aggregate_Fields = {
  __typename?: 'issue_aggregate_fields';
  avg?: Maybe<Issue_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Issue_Max_Fields>;
  min?: Maybe<Issue_Min_Fields>;
  stddev?: Maybe<Issue_Stddev_Fields>;
  stddev_pop?: Maybe<Issue_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Issue_Stddev_Samp_Fields>;
  sum?: Maybe<Issue_Sum_Fields>;
  var_pop?: Maybe<Issue_Var_Pop_Fields>;
  var_samp?: Maybe<Issue_Var_Samp_Fields>;
  variance?: Maybe<Issue_Variance_Fields>;
};


/** aggregate fields of "issue" */
export type Issue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Issue_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Issue_Avg_Fields = {
  __typename?: 'issue_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "issue". All fields are combined with a logical 'AND'. */
export type Issue_Bool_Exp = {
  _and?: InputMaybe<Array<Issue_Bool_Exp>>;
  _not?: InputMaybe<Issue_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Info_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Info_Bool_Exp>;
};

/** unique or primary key constraints on table "issue" */
export type Issue_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'issue_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Issue_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Issue_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Issue_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "issue" */
export type Issue_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "issue" */
export type Issue_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  updated_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Issue_Max_Fields = {
  __typename?: 'issue_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Issue_Min_Fields = {
  __typename?: 'issue_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "issue" */
export type Issue_Mutation_Response = {
  __typename?: 'issue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Issue>;
};

/** on_conflict condition type for table "issue" */
export type Issue_On_Conflict = {
  constraint: Issue_Constraint;
  update_columns?: Array<Issue_Update_Column>;
  where?: InputMaybe<Issue_Bool_Exp>;
};

/** Ordering options when selecting data from "issue". */
export type Issue_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Info_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Info_Order_By>;
};

/** primary key columns input for table: issue */
export type Issue_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Issue_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "issue" */
export type Issue_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'options'
  /** column name */
  | 'status'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for updating data in table "issue" */
export type Issue_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "issue_status" */
export type Issue_Status = {
  __typename?: 'issue_status';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "issue_status" */
export type Issue_Status_Aggregate = {
  __typename?: 'issue_status_aggregate';
  aggregate?: Maybe<Issue_Status_Aggregate_Fields>;
  nodes: Array<Issue_Status>;
};

/** aggregate fields of "issue_status" */
export type Issue_Status_Aggregate_Fields = {
  __typename?: 'issue_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Issue_Status_Max_Fields>;
  min?: Maybe<Issue_Status_Min_Fields>;
};


/** aggregate fields of "issue_status" */
export type Issue_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Issue_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "issue_status". All fields are combined with a logical 'AND'. */
export type Issue_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Issue_Status_Bool_Exp>>;
  _not?: InputMaybe<Issue_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Issue_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "issue_status" */
export type Issue_Status_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'issue_status_pkey';

/** input type for inserting data into table "issue_status" */
export type Issue_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Issue_Status_Max_Fields = {
  __typename?: 'issue_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Issue_Status_Min_Fields = {
  __typename?: 'issue_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "issue_status" */
export type Issue_Status_Mutation_Response = {
  __typename?: 'issue_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Issue_Status>;
};

/** on_conflict condition type for table "issue_status" */
export type Issue_Status_On_Conflict = {
  constraint: Issue_Status_Constraint;
  update_columns?: Array<Issue_Status_Update_Column>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "issue_status". */
export type Issue_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: issue_status */
export type Issue_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "issue_status" */
export type Issue_Status_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "issue_status" */
export type Issue_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "issue_status" */
export type Issue_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "issue_status" */
export type Issue_Status_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Issue_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issue_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Issue_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Issue_Stddev_Fields = {
  __typename?: 'issue_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Issue_Stddev_Pop_Fields = {
  __typename?: 'issue_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Issue_Stddev_Samp_Fields = {
  __typename?: 'issue_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "issue" */
export type Issue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Issue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Issue_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Issue_Sum_Fields = {
  __typename?: 'issue_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "issue" */
export type Issue_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'options'
  /** column name */
  | 'status'
  /** column name */
  | 'title'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Issue_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Issue_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Issue_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Issue_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Issue_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Issue_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Issue_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Issue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Issue_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Issue_Var_Pop_Fields = {
  __typename?: 'issue_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Issue_Var_Samp_Fields = {
  __typename?: 'issue_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Issue_Variance_Fields = {
  __typename?: 'issue_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type ItemNode = {
  __typename?: 'itemNode';
  csi?: Maybe<Array<Maybe<CsiNode>>>;
  csiAggregate?: Maybe<ItemNodecsiNodeCsiAggregationSelection>;
  csiConnection: ItemNodeCsiConnection;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  relatedChoices?: Maybe<Array<Maybe<ChoiceNode>>>;
  relatedChoicesAggregate?: Maybe<ItemNodechoiceNodeRelatedChoicesAggregationSelection>;
  relatedChoicesConnection: ItemNodeRelatedChoicesConnection;
  relatedPlatforms?: Maybe<Array<Maybe<PlatformNode>>>;
  relatedPlatformsAggregate?: Maybe<ItemNodeplatformNodeRelatedPlatformsAggregationSelection>;
  relatedPlatformsConnection: ItemNodeRelatedPlatformsConnection;
  relatedProductOptions?: Maybe<Array<Maybe<ProductOptionNode>>>;
  relatedProductOptionsAggregate?: Maybe<ItemNodeproductOptionNodeRelatedProductOptionsAggregationSelection>;
  relatedProductOptionsConnection: ItemNodeRelatedProductOptionsConnection;
  relatedProducts?: Maybe<Array<Maybe<ProductNode>>>;
  relatedProductsAggregate?: Maybe<ItemNodeproductNodeRelatedProductsAggregationSelection>;
  relatedProductsConnection: ItemNodeRelatedProductsConnection;
  relatedProjects?: Maybe<Array<Maybe<ProjectNode>>>;
  relatedProjectsAggregate?: Maybe<ItemNodeprojectNodeRelatedProjectsAggregationSelection>;
  relatedProjectsConnection: ItemNodeRelatedProjectsConnection;
  relatedUnits?: Maybe<Array<Maybe<UnitNode>>>;
  relatedUnitsAggregate?: Maybe<ItemNodeunitNodeRelatedUnitsAggregationSelection>;
  relatedUnitsConnection: ItemNodeRelatedUnitsConnection;
  wevrId?: Maybe<Scalars['String']>;
};


export type ItemNodeCsiArgs = {
  options?: InputMaybe<CsiNodeOptions>;
  where?: InputMaybe<CsiNodeWhere>;
};


export type ItemNodeCsiAggregateArgs = {
  where?: InputMaybe<CsiNodeWhere>;
};


export type ItemNodeCsiConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeCsiConnectionSort>>;
  where?: InputMaybe<ItemNodeCsiConnectionWhere>;
};


export type ItemNodeRelatedChoicesArgs = {
  options?: InputMaybe<ChoiceNodeOptions>;
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type ItemNodeRelatedChoicesAggregateArgs = {
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type ItemNodeRelatedChoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedChoicesConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
};


export type ItemNodeRelatedPlatformsArgs = {
  options?: InputMaybe<PlatformNodeOptions>;
  where?: InputMaybe<PlatformNodeWhere>;
};


export type ItemNodeRelatedPlatformsAggregateArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type ItemNodeRelatedPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
};


export type ItemNodeRelatedProductOptionsArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ItemNodeRelatedProductOptionsAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ItemNodeRelatedProductOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
};


export type ItemNodeRelatedProductsArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type ItemNodeRelatedProductsAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type ItemNodeRelatedProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedProductsConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
};


export type ItemNodeRelatedProjectsArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type ItemNodeRelatedProjectsAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type ItemNodeRelatedProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedProjectsConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
};


export type ItemNodeRelatedUnitsArgs = {
  options?: InputMaybe<UnitNodeOptions>;
  where?: InputMaybe<UnitNodeWhere>;
};


export type ItemNodeRelatedUnitsAggregateArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type ItemNodeRelatedUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ItemNodeRelatedUnitsConnectionSort>>;
  where?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
};

export type ItemNodeAggregateSelection = {
  __typename?: 'itemNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeConnectInput = {
  csi?: InputMaybe<Array<ItemNodeCsiConnectFieldInput>>;
  relatedChoices?: InputMaybe<Array<ItemNodeRelatedChoicesConnectFieldInput>>;
  relatedPlatforms?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectFieldInput>>;
  relatedProductOptions?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectFieldInput>>;
  relatedProducts?: InputMaybe<Array<ItemNodeRelatedProductsConnectFieldInput>>;
  relatedProjects?: InputMaybe<Array<ItemNodeRelatedProjectsConnectFieldInput>>;
  relatedUnits?: InputMaybe<Array<ItemNodeRelatedUnitsConnectFieldInput>>;
};

export type ItemNodeConnectWhere = {
  node: ItemNodeWhere;
};

export type ItemNodeCreateInput = {
  csi?: InputMaybe<ItemNodeCsiFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  relatedChoices?: InputMaybe<ItemNodeRelatedChoicesFieldInput>;
  relatedPlatforms?: InputMaybe<ItemNodeRelatedPlatformsFieldInput>;
  relatedProductOptions?: InputMaybe<ItemNodeRelatedProductOptionsFieldInput>;
  relatedProducts?: InputMaybe<ItemNodeRelatedProductsFieldInput>;
  relatedProjects?: InputMaybe<ItemNodeRelatedProjectsFieldInput>;
  relatedUnits?: InputMaybe<ItemNodeRelatedUnitsFieldInput>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ItemNodeCsiAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeCsiAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeCsiAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ItemNodeCsiNodeAggregationWhereInput>;
};

export type ItemNodeCsiConnectFieldInput = {
  connect?: InputMaybe<Array<CsiNodeConnectInput>>;
  where?: InputMaybe<CsiNodeConnectWhere>;
};

export type ItemNodeCsiConnection = {
  __typename?: 'itemNodeCsiConnection';
  edges: Array<ItemNodeCsiRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeCsiConnectionSort = {
  node?: InputMaybe<CsiNodeSort>;
};

export type ItemNodeCsiConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeCsiConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeCsiConnectionWhere>>;
  node?: InputMaybe<CsiNodeWhere>;
  node_NOT?: InputMaybe<CsiNodeWhere>;
};

export type ItemNodeCsiCreateFieldInput = {
  node: CsiNodeCreateInput;
};

export type ItemNodeCsiDeleteFieldInput = {
  delete?: InputMaybe<CsiNodeDeleteInput>;
  where?: InputMaybe<ItemNodeCsiConnectionWhere>;
};

export type ItemNodeCsiDisconnectFieldInput = {
  disconnect?: InputMaybe<CsiNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeCsiConnectionWhere>;
};

export type ItemNodeCsiFieldInput = {
  connect?: InputMaybe<Array<ItemNodeCsiConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeCsiCreateFieldInput>>;
};

export type ItemNodeCsiNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeCsiNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeCsiNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeCsiRelationship = {
  __typename?: 'itemNodeCsiRelationship';
  cursor: Scalars['String'];
  node: CsiNode;
};

export type ItemNodeCsiUpdateConnectionInput = {
  node?: InputMaybe<CsiNodeUpdateInput>;
};

export type ItemNodeCsiUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeCsiConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeCsiCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeCsiDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeCsiDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeCsiUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeCsiConnectionWhere>;
};

export type ItemNodeDeleteInput = {
  csi?: InputMaybe<Array<ItemNodeCsiDeleteFieldInput>>;
  relatedChoices?: InputMaybe<Array<ItemNodeRelatedChoicesDeleteFieldInput>>;
  relatedPlatforms?: InputMaybe<Array<ItemNodeRelatedPlatformsDeleteFieldInput>>;
  relatedProductOptions?: InputMaybe<Array<ItemNodeRelatedProductOptionsDeleteFieldInput>>;
  relatedProducts?: InputMaybe<Array<ItemNodeRelatedProductsDeleteFieldInput>>;
  relatedProjects?: InputMaybe<Array<ItemNodeRelatedProjectsDeleteFieldInput>>;
  relatedUnits?: InputMaybe<Array<ItemNodeRelatedUnitsDeleteFieldInput>>;
};

export type ItemNodeDisconnectInput = {
  csi?: InputMaybe<Array<ItemNodeCsiDisconnectFieldInput>>;
  relatedChoices?: InputMaybe<Array<ItemNodeRelatedChoicesDisconnectFieldInput>>;
  relatedPlatforms?: InputMaybe<Array<ItemNodeRelatedPlatformsDisconnectFieldInput>>;
  relatedProductOptions?: InputMaybe<Array<ItemNodeRelatedProductOptionsDisconnectFieldInput>>;
  relatedProducts?: InputMaybe<Array<ItemNodeRelatedProductsDisconnectFieldInput>>;
  relatedProjects?: InputMaybe<Array<ItemNodeRelatedProjectsDisconnectFieldInput>>;
  relatedUnits?: InputMaybe<Array<ItemNodeRelatedUnitsDisconnectFieldInput>>;
};

export type ItemNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more itemNodeSort objects to sort itemNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ItemNodeSort>>>;
};

export type ItemNodeRelatedChoicesAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedChoicesAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedChoicesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedChoicesEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedChoicesNodeAggregationWhereInput>;
};

export type ItemNodeRelatedChoicesConnectFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ChoiceNodeConnectWhere>;
};

export type ItemNodeRelatedChoicesConnection = {
  __typename?: 'itemNodeRelatedChoicesConnection';
  edges: Array<ItemNodeRelatedChoicesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedChoicesConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ChoiceNodeSort>;
};

export type ItemNodeRelatedChoicesConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedChoicesConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedChoicesConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ChoiceNodeWhere>;
  node_NOT?: InputMaybe<ChoiceNodeWhere>;
};

export type ItemNodeRelatedChoicesCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ChoiceNodeCreateInput;
};

export type ItemNodeRelatedChoicesDeleteFieldInput = {
  delete?: InputMaybe<ChoiceNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
};

export type ItemNodeRelatedChoicesDisconnectFieldInput = {
  disconnect?: InputMaybe<ChoiceNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
};

export type ItemNodeRelatedChoicesEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedChoicesEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedChoicesEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedChoicesFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedChoicesCreateFieldInput>>;
};

export type ItemNodeRelatedChoicesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedChoicesNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedChoicesNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  label_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  label_EQUAL?: InputMaybe<Scalars['String']>;
  label_GT?: InputMaybe<Scalars['Int']>;
  label_GTE?: InputMaybe<Scalars['Int']>;
  label_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  label_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  label_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  label_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  label_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  label_LT?: InputMaybe<Scalars['Int']>;
  label_LTE?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sort_order_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_GT?: InputMaybe<Scalars['Int']>;
  sort_order_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_LT?: InputMaybe<Scalars['Int']>;
  sort_order_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_GT?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_LT?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_GT?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_LT?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_GT?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_LT?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_LTE?: InputMaybe<Scalars['Int']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  value_EQUAL?: InputMaybe<Scalars['String']>;
  value_GT?: InputMaybe<Scalars['Int']>;
  value_GTE?: InputMaybe<Scalars['Int']>;
  value_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  value_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  value_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  value_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  value_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  value_LT?: InputMaybe<Scalars['Int']>;
  value_LTE?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedChoicesRelationship = Quantity & {
  __typename?: 'itemNodeRelatedChoicesRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ChoiceNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedChoicesUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ChoiceNodeUpdateInput>;
};

export type ItemNodeRelatedChoicesUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedChoicesCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedChoicesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedChoicesDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedChoicesUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
};

export type ItemNodeRelatedPlatformsAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedPlatformsAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedPlatformsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedPlatformsEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedPlatformsNodeAggregationWhereInput>;
};

export type ItemNodeRelatedPlatformsConnectFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<PlatformNodeConnectWhere>;
};

export type ItemNodeRelatedPlatformsConnection = {
  __typename?: 'itemNodeRelatedPlatformsConnection';
  edges: Array<ItemNodeRelatedPlatformsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedPlatformsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<PlatformNodeSort>;
};

export type ItemNodeRelatedPlatformsConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<PlatformNodeWhere>;
  node_NOT?: InputMaybe<PlatformNodeWhere>;
};

export type ItemNodeRelatedPlatformsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: PlatformNodeCreateInput;
};

export type ItemNodeRelatedPlatformsDeleteFieldInput = {
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
};

export type ItemNodeRelatedPlatformsDisconnectFieldInput = {
  disconnect?: InputMaybe<PlatformNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
};

export type ItemNodeRelatedPlatformsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedPlatformsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedPlatformsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedPlatformsFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedPlatformsCreateFieldInput>>;
};

export type ItemNodeRelatedPlatformsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedPlatformsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedPlatformsNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedPlatformsRelationship = Quantity & {
  __typename?: 'itemNodeRelatedPlatformsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: PlatformNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedPlatformsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<PlatformNodeUpdateInput>;
};

export type ItemNodeRelatedPlatformsUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedPlatformsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedPlatformsCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedPlatformsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedPlatformsDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedPlatformsUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
};

export type ItemNodeRelatedProductOptionsAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductOptionsAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductOptionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedProductOptionsEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedProductOptionsNodeAggregationWhereInput>;
};

export type ItemNodeRelatedProductOptionsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ProductOptionNodeConnectWhere>;
};

export type ItemNodeRelatedProductOptionsConnection = {
  __typename?: 'itemNodeRelatedProductOptionsConnection';
  edges: Array<ItemNodeRelatedProductOptionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedProductOptionsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ProductOptionNodeSort>;
};

export type ItemNodeRelatedProductOptionsConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ProductOptionNodeWhere>;
  node_NOT?: InputMaybe<ProductOptionNodeWhere>;
};

export type ItemNodeRelatedProductOptionsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ProductOptionNodeCreateInput;
};

export type ItemNodeRelatedProductOptionsDeleteFieldInput = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
};

export type ItemNodeRelatedProductOptionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
};

export type ItemNodeRelatedProductOptionsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductOptionsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductOptionsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedProductOptionsFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProductOptionsCreateFieldInput>>;
};

export type ItemNodeRelatedProductOptionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductOptionsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductOptionsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedProductOptionsRelationship = Quantity & {
  __typename?: 'itemNodeRelatedProductOptionsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ProductOptionNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedProductOptionsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ProductOptionNodeUpdateInput>;
};

export type ItemNodeRelatedProductOptionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProductOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProductOptionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedProductOptionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedProductOptionsDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedProductOptionsUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
};

export type ItemNodeRelatedProductsAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductsAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedProductsEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedProductsNodeAggregationWhereInput>;
};

export type ItemNodeRelatedProductsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ProductNodeConnectWhere>;
};

export type ItemNodeRelatedProductsConnection = {
  __typename?: 'itemNodeRelatedProductsConnection';
  edges: Array<ItemNodeRelatedProductsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedProductsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ProductNodeSort>;
};

export type ItemNodeRelatedProductsConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductsConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ProductNodeWhere>;
  node_NOT?: InputMaybe<ProductNodeWhere>;
};

export type ItemNodeRelatedProductsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ProductNodeCreateInput;
};

export type ItemNodeRelatedProductsDeleteFieldInput = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
};

export type ItemNodeRelatedProductsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
};

export type ItemNodeRelatedProductsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedProductsFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProductsCreateFieldInput>>;
};

export type ItemNodeRelatedProductsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProductsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProductsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sku_EQUAL?: InputMaybe<Scalars['String']>;
  sku_GT?: InputMaybe<Scalars['Int']>;
  sku_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_LT?: InputMaybe<Scalars['Int']>;
  sku_LTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedProductsRelationship = Quantity & {
  __typename?: 'itemNodeRelatedProductsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ProductNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedProductsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ProductNodeUpdateInput>;
};

export type ItemNodeRelatedProductsUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProductsCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedProductsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedProductsDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedProductsUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
};

export type ItemNodeRelatedProjectsAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProjectsAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedProjectsEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedProjectsNodeAggregationWhereInput>;
};

export type ItemNodeRelatedProjectsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ProjectNodeConnectWhere>;
};

export type ItemNodeRelatedProjectsConnection = {
  __typename?: 'itemNodeRelatedProjectsConnection';
  edges: Array<ItemNodeRelatedProjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedProjectsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ProjectNodeSort>;
};

export type ItemNodeRelatedProjectsConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedProjectsConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProjectsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ProjectNodeWhere>;
  node_NOT?: InputMaybe<ProjectNodeWhere>;
};

export type ItemNodeRelatedProjectsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ProjectNodeCreateInput;
};

export type ItemNodeRelatedProjectsDeleteFieldInput = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
};

export type ItemNodeRelatedProjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
};

export type ItemNodeRelatedProjectsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProjectsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProjectsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedProjectsFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProjectsCreateFieldInput>>;
};

export type ItemNodeRelatedProjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedProjectsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedProjectsNodeAggregationWhereInput>>;
  bloxProjectNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_EQUAL?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedProjectsRelationship = Quantity & {
  __typename?: 'itemNodeRelatedProjectsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ProjectNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedProjectsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ProjectNodeUpdateInput>;
};

export type ItemNodeRelatedProjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedProjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedProjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedProjectsDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedProjectsUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
};

export type ItemNodeRelatedUnitsAggregateInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedUnitsAggregateInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ItemNodeRelatedUnitsEdgeAggregationWhereInput>;
  node?: InputMaybe<ItemNodeRelatedUnitsNodeAggregationWhereInput>;
};

export type ItemNodeRelatedUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<UnitNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<UnitNodeConnectWhere>;
};

export type ItemNodeRelatedUnitsConnection = {
  __typename?: 'itemNodeRelatedUnitsConnection';
  edges: Array<ItemNodeRelatedUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ItemNodeRelatedUnitsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<UnitNodeSort>;
};

export type ItemNodeRelatedUnitsConnectionWhere = {
  AND?: InputMaybe<Array<ItemNodeRelatedUnitsConnectionWhere>>;
  OR?: InputMaybe<Array<ItemNodeRelatedUnitsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<UnitNodeWhere>;
  node_NOT?: InputMaybe<UnitNodeWhere>;
};

export type ItemNodeRelatedUnitsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: UnitNodeCreateInput;
};

export type ItemNodeRelatedUnitsDeleteFieldInput = {
  delete?: InputMaybe<UnitNodeDeleteInput>;
  where?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
};

export type ItemNodeRelatedUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<UnitNodeDisconnectInput>;
  where?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
};

export type ItemNodeRelatedUnitsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedUnitsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedUnitsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ItemNodeRelatedUnitsFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedUnitsCreateFieldInput>>;
};

export type ItemNodeRelatedUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ItemNodeRelatedUnitsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ItemNodeRelatedUnitsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ItemNodeRelatedUnitsRelationship = Quantity & {
  __typename?: 'itemNodeRelatedUnitsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: UnitNode;
  quantity: Scalars['Float'];
};

export type ItemNodeRelatedUnitsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<UnitNodeUpdateInput>;
};

export type ItemNodeRelatedUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<ItemNodeRelatedUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<ItemNodeRelatedUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<ItemNodeRelatedUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ItemNodeRelatedUnitsDisconnectFieldInput>>;
  update?: InputMaybe<ItemNodeRelatedUnitsUpdateConnectionInput>;
  where?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
};

export type ItemNodeRelationInput = {
  csi?: InputMaybe<Array<ItemNodeCsiCreateFieldInput>>;
  relatedChoices?: InputMaybe<Array<ItemNodeRelatedChoicesCreateFieldInput>>;
  relatedPlatforms?: InputMaybe<Array<ItemNodeRelatedPlatformsCreateFieldInput>>;
  relatedProductOptions?: InputMaybe<Array<ItemNodeRelatedProductOptionsCreateFieldInput>>;
  relatedProducts?: InputMaybe<Array<ItemNodeRelatedProductsCreateFieldInput>>;
  relatedProjects?: InputMaybe<Array<ItemNodeRelatedProjectsCreateFieldInput>>;
  relatedUnits?: InputMaybe<Array<ItemNodeRelatedUnitsCreateFieldInput>>;
};

/** Fields to sort itemNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one itemNodeSort object. */
export type ItemNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  partNumber?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ItemNodeUpdateInput = {
  csi?: InputMaybe<Array<ItemNodeCsiUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  relatedChoices?: InputMaybe<Array<ItemNodeRelatedChoicesUpdateFieldInput>>;
  relatedPlatforms?: InputMaybe<Array<ItemNodeRelatedPlatformsUpdateFieldInput>>;
  relatedProductOptions?: InputMaybe<Array<ItemNodeRelatedProductOptionsUpdateFieldInput>>;
  relatedProducts?: InputMaybe<Array<ItemNodeRelatedProductsUpdateFieldInput>>;
  relatedProjects?: InputMaybe<Array<ItemNodeRelatedProjectsUpdateFieldInput>>;
  relatedUnits?: InputMaybe<Array<ItemNodeRelatedUnitsUpdateFieldInput>>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ItemNodeWhere = {
  AND?: InputMaybe<Array<ItemNodeWhere>>;
  OR?: InputMaybe<Array<ItemNodeWhere>>;
  csi?: InputMaybe<CsiNodeWhere>;
  csiAggregate?: InputMaybe<ItemNodeCsiAggregateInput>;
  csiConnection?: InputMaybe<ItemNodeCsiConnectionWhere>;
  csiConnection_NOT?: InputMaybe<ItemNodeCsiConnectionWhere>;
  csi_NOT?: InputMaybe<CsiNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partNumber_CONTAINS?: InputMaybe<Scalars['String']>;
  partNumber_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partNumber_NOT?: InputMaybe<Scalars['String']>;
  partNumber_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  partNumber_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partNumber_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  partNumber_STARTS_WITH?: InputMaybe<Scalars['String']>;
  relatedChoices?: InputMaybe<ChoiceNodeWhere>;
  relatedChoicesAggregate?: InputMaybe<ItemNodeRelatedChoicesAggregateInput>;
  relatedChoicesConnection?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
  relatedChoicesConnection_NOT?: InputMaybe<ItemNodeRelatedChoicesConnectionWhere>;
  relatedChoices_NOT?: InputMaybe<ChoiceNodeWhere>;
  relatedPlatforms?: InputMaybe<PlatformNodeWhere>;
  relatedPlatformsAggregate?: InputMaybe<ItemNodeRelatedPlatformsAggregateInput>;
  relatedPlatformsConnection?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
  relatedPlatformsConnection_NOT?: InputMaybe<ItemNodeRelatedPlatformsConnectionWhere>;
  relatedPlatforms_NOT?: InputMaybe<PlatformNodeWhere>;
  relatedProductOptions?: InputMaybe<ProductOptionNodeWhere>;
  relatedProductOptionsAggregate?: InputMaybe<ItemNodeRelatedProductOptionsAggregateInput>;
  relatedProductOptionsConnection?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
  relatedProductOptionsConnection_NOT?: InputMaybe<ItemNodeRelatedProductOptionsConnectionWhere>;
  relatedProductOptions_NOT?: InputMaybe<ProductOptionNodeWhere>;
  relatedProducts?: InputMaybe<ProductNodeWhere>;
  relatedProductsAggregate?: InputMaybe<ItemNodeRelatedProductsAggregateInput>;
  relatedProductsConnection?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
  relatedProductsConnection_NOT?: InputMaybe<ItemNodeRelatedProductsConnectionWhere>;
  relatedProducts_NOT?: InputMaybe<ProductNodeWhere>;
  relatedProjects?: InputMaybe<ProjectNodeWhere>;
  relatedProjectsAggregate?: InputMaybe<ItemNodeRelatedProjectsAggregateInput>;
  relatedProjectsConnection?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
  relatedProjectsConnection_NOT?: InputMaybe<ItemNodeRelatedProjectsConnectionWhere>;
  relatedProjects_NOT?: InputMaybe<ProjectNodeWhere>;
  relatedUnits?: InputMaybe<UnitNodeWhere>;
  relatedUnitsAggregate?: InputMaybe<ItemNodeRelatedUnitsAggregateInput>;
  relatedUnitsConnection?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
  relatedUnitsConnection_NOT?: InputMaybe<ItemNodeRelatedUnitsConnectionWhere>;
  relatedUnits_NOT?: InputMaybe<UnitNodeWhere>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ItemNodechoiceNodeRelatedChoicesAggregationSelection = {
  __typename?: 'itemNodechoiceNodeRelatedChoicesAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodechoiceNodeRelatedChoicesEdgeAggregateSelection>;
  node?: Maybe<ItemNodechoiceNodeRelatedChoicesNodeAggregateSelection>;
};

export type ItemNodechoiceNodeRelatedChoicesEdgeAggregateSelection = {
  __typename?: 'itemNodechoiceNodeRelatedChoicesEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodechoiceNodeRelatedChoicesNodeAggregateSelection = {
  __typename?: 'itemNodechoiceNodeRelatedChoicesNodeAggregateSelection';
  description: StringAggregateSelection;
  label: StringAggregateSelection;
  name: StringAggregateSelection;
  sort_order: IntAggregateSelection;
  value: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodecsiNodeCsiAggregationSelection = {
  __typename?: 'itemNodecsiNodeCsiAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ItemNodecsiNodeCsiNodeAggregateSelection>;
};

export type ItemNodecsiNodeCsiNodeAggregateSelection = {
  __typename?: 'itemNodecsiNodeCsiNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeplatformNodeRelatedPlatformsAggregationSelection = {
  __typename?: 'itemNodeplatformNodeRelatedPlatformsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodeplatformNodeRelatedPlatformsEdgeAggregateSelection>;
  node?: Maybe<ItemNodeplatformNodeRelatedPlatformsNodeAggregateSelection>;
};

export type ItemNodeplatformNodeRelatedPlatformsEdgeAggregateSelection = {
  __typename?: 'itemNodeplatformNodeRelatedPlatformsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodeplatformNodeRelatedPlatformsNodeAggregateSelection = {
  __typename?: 'itemNodeplatformNodeRelatedPlatformsNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeproductNodeRelatedProductsAggregationSelection = {
  __typename?: 'itemNodeproductNodeRelatedProductsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodeproductNodeRelatedProductsEdgeAggregateSelection>;
  node?: Maybe<ItemNodeproductNodeRelatedProductsNodeAggregateSelection>;
};

export type ItemNodeproductNodeRelatedProductsEdgeAggregateSelection = {
  __typename?: 'itemNodeproductNodeRelatedProductsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodeproductNodeRelatedProductsNodeAggregateSelection = {
  __typename?: 'itemNodeproductNodeRelatedProductsNodeAggregateSelection';
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeproductOptionNodeRelatedProductOptionsAggregationSelection = {
  __typename?: 'itemNodeproductOptionNodeRelatedProductOptionsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodeproductOptionNodeRelatedProductOptionsEdgeAggregateSelection>;
  node?: Maybe<ItemNodeproductOptionNodeRelatedProductOptionsNodeAggregateSelection>;
};

export type ItemNodeproductOptionNodeRelatedProductOptionsEdgeAggregateSelection = {
  __typename?: 'itemNodeproductOptionNodeRelatedProductOptionsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodeproductOptionNodeRelatedProductOptionsNodeAggregateSelection = {
  __typename?: 'itemNodeproductOptionNodeRelatedProductOptionsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeprojectNodeRelatedProjectsAggregationSelection = {
  __typename?: 'itemNodeprojectNodeRelatedProjectsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodeprojectNodeRelatedProjectsEdgeAggregateSelection>;
  node?: Maybe<ItemNodeprojectNodeRelatedProjectsNodeAggregateSelection>;
};

export type ItemNodeprojectNodeRelatedProjectsEdgeAggregateSelection = {
  __typename?: 'itemNodeprojectNodeRelatedProjectsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodeprojectNodeRelatedProjectsNodeAggregateSelection = {
  __typename?: 'itemNodeprojectNodeRelatedProjectsNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ItemNodeunitNodeRelatedUnitsAggregationSelection = {
  __typename?: 'itemNodeunitNodeRelatedUnitsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ItemNodeunitNodeRelatedUnitsEdgeAggregateSelection>;
  node?: Maybe<ItemNodeunitNodeRelatedUnitsNodeAggregateSelection>;
};

export type ItemNodeunitNodeRelatedUnitsEdgeAggregateSelection = {
  __typename?: 'itemNodeunitNodeRelatedUnitsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ItemNodeunitNodeRelatedUnitsNodeAggregateSelection = {
  __typename?: 'itemNodeunitNodeRelatedUnitsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** columns and relationships of "item_bom" */
export type Item_Bom = {
  __typename?: 'item_bom';
  /** An object relationship */
  base_product?: Maybe<Base_Product>;
  base_product_id?: Maybe<Scalars['String']>;
  choice_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['bigint'];
  include_waste?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  item: Part;
  item_id: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  platform?: Maybe<Platform>;
  platform_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  product_option_choice?: Maybe<Product_Option_Choice>;
  /** An object relationship */
  project?: Maybe<Project>;
  project_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  unit?: Maybe<Unit>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "item_bom" */
export type Item_BomMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "item_bom" */
export type Item_Bom_Aggregate = {
  __typename?: 'item_bom_aggregate';
  aggregate?: Maybe<Item_Bom_Aggregate_Fields>;
  nodes: Array<Item_Bom>;
};

export type Item_Bom_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Item_Bom_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Item_Bom_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Item_Bom_Aggregate_Bool_Exp_Count>;
};

export type Item_Bom_Aggregate_Bool_Exp_Bool_And = {
  arguments: Item_Bom_Select_Column_Item_Bom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Item_Bom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Item_Bom_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Item_Bom_Select_Column_Item_Bom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Item_Bom_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Item_Bom_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Item_Bom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Item_Bom_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "item_bom" */
export type Item_Bom_Aggregate_Fields = {
  __typename?: 'item_bom_aggregate_fields';
  avg?: Maybe<Item_Bom_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Item_Bom_Max_Fields>;
  min?: Maybe<Item_Bom_Min_Fields>;
  stddev?: Maybe<Item_Bom_Stddev_Fields>;
  stddev_pop?: Maybe<Item_Bom_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Item_Bom_Stddev_Samp_Fields>;
  sum?: Maybe<Item_Bom_Sum_Fields>;
  var_pop?: Maybe<Item_Bom_Var_Pop_Fields>;
  var_samp?: Maybe<Item_Bom_Var_Samp_Fields>;
  variance?: Maybe<Item_Bom_Variance_Fields>;
};


/** aggregate fields of "item_bom" */
export type Item_Bom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Item_Bom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "item_bom" */
export type Item_Bom_Aggregate_Order_By = {
  avg?: InputMaybe<Item_Bom_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Item_Bom_Max_Order_By>;
  min?: InputMaybe<Item_Bom_Min_Order_By>;
  stddev?: InputMaybe<Item_Bom_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Item_Bom_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Item_Bom_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Item_Bom_Sum_Order_By>;
  var_pop?: InputMaybe<Item_Bom_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Item_Bom_Var_Samp_Order_By>;
  variance?: InputMaybe<Item_Bom_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Item_Bom_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "item_bom" */
export type Item_Bom_Arr_Rel_Insert_Input = {
  data: Array<Item_Bom_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Item_Bom_On_Conflict>;
};

/** aggregate avg on columns */
export type Item_Bom_Avg_Fields = {
  __typename?: 'item_bom_avg_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "item_bom" */
export type Item_Bom_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "item_bom". All fields are combined with a logical 'AND'. */
export type Item_Bom_Bool_Exp = {
  _and?: InputMaybe<Array<Item_Bom_Bool_Exp>>;
  _not?: InputMaybe<Item_Bom_Bool_Exp>;
  _or?: InputMaybe<Array<Item_Bom_Bool_Exp>>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  base_product_id?: InputMaybe<String_Comparison_Exp>;
  choice_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  include_waste?: InputMaybe<Boolean_Comparison_Exp>;
  item?: InputMaybe<Part_Bool_Exp>;
  item_id?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  platform_id?: InputMaybe<String_Comparison_Exp>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "item_bom" */
export type Item_Bom_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'item_bom_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Item_Bom_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Item_Bom_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Item_Bom_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "item_bom" */
export type Item_Bom_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "item_bom" */
export type Item_Bom_Insert_Input = {
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  base_product_id?: InputMaybe<Scalars['String']>;
  choice_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform?: InputMaybe<Platform_Obj_Rel_Insert_Input>;
  platform_id?: InputMaybe<Scalars['String']>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Obj_Rel_Insert_Input>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Item_Bom_Max_Fields = {
  __typename?: 'item_bom_max_fields';
  base_product_id?: Maybe<Scalars['String']>;
  choice_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  item_id?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "item_bom" */
export type Item_Bom_Max_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Item_Bom_Min_Fields = {
  __typename?: 'item_bom_min_fields';
  base_product_id?: Maybe<Scalars['String']>;
  choice_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  item_id?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  unit_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "item_bom" */
export type Item_Bom_Min_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item_id?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "item_bom" */
export type Item_Bom_Mutation_Response = {
  __typename?: 'item_bom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Item_Bom>;
};

/** on_conflict condition type for table "item_bom" */
export type Item_Bom_On_Conflict = {
  constraint: Item_Bom_Constraint;
  update_columns?: Array<Item_Bom_Update_Column>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};

/** Ordering options when selecting data from "item_bom". */
export type Item_Bom_Order_By = {
  base_product?: InputMaybe<Base_Product_Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  choice_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_waste?: InputMaybe<Order_By>;
  item?: InputMaybe<Part_Order_By>;
  item_id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  platform_id?: InputMaybe<Order_By>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: item_bom */
export type Item_Bom_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Item_Bom_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "item_bom" */
export type Item_Bom_Select_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'choice_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'item_id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'project_id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'unit_id'
  /** column name */
  | 'updated_at';

/** select "item_bom_aggregate_bool_exp_bool_and_arguments_columns" columns of table "item_bom" */
export type Item_Bom_Select_Column_Item_Bom_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** select "item_bom_aggregate_bool_exp_bool_or_arguments_columns" columns of table "item_bom" */
export type Item_Bom_Select_Column_Item_Bom_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** input type for updating data in table "item_bom" */
export type Item_Bom_Set_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  choice_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform_id?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Item_Bom_Stddev_Fields = {
  __typename?: 'item_bom_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "item_bom" */
export type Item_Bom_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Item_Bom_Stddev_Pop_Fields = {
  __typename?: 'item_bom_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "item_bom" */
export type Item_Bom_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Item_Bom_Stddev_Samp_Fields = {
  __typename?: 'item_bom_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "item_bom" */
export type Item_Bom_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "item_bom" */
export type Item_Bom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Item_Bom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Item_Bom_Stream_Cursor_Value_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  choice_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['bigint']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  item_id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  platform_id?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  unit_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Item_Bom_Sum_Fields = {
  __typename?: 'item_bom_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "item_bom" */
export type Item_Bom_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "item_bom" */
export type Item_Bom_Update_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'choice_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'item_id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'project_id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'unit_id'
  /** column name */
  | 'updated_at';

export type Item_Bom_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Item_Bom_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Item_Bom_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Item_Bom_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Item_Bom_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Item_Bom_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Item_Bom_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Item_Bom_Set_Input>;
  /** filter the rows which have to be updated */
  where: Item_Bom_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Item_Bom_Var_Pop_Fields = {
  __typename?: 'item_bom_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "item_bom" */
export type Item_Bom_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Item_Bom_Var_Samp_Fields = {
  __typename?: 'item_bom_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "item_bom" */
export type Item_Bom_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Item_Bom_Variance_Fields = {
  __typename?: 'item_bom_variance_fields';
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "item_bom" */
export type Item_Bom_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "item_type" */
export type Item_Type = {
  __typename?: 'item_type';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "item_type" */
export type Item_Type_Aggregate = {
  __typename?: 'item_type_aggregate';
  aggregate?: Maybe<Item_Type_Aggregate_Fields>;
  nodes: Array<Item_Type>;
};

/** aggregate fields of "item_type" */
export type Item_Type_Aggregate_Fields = {
  __typename?: 'item_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Item_Type_Max_Fields>;
  min?: Maybe<Item_Type_Min_Fields>;
};


/** aggregate fields of "item_type" */
export type Item_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Item_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "item_type". All fields are combined with a logical 'AND'. */
export type Item_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Item_Type_Bool_Exp>>;
  _not?: InputMaybe<Item_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Item_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "item_type" */
export type Item_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'item_type_pkey';

/** input type for inserting data into table "item_type" */
export type Item_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Item_Type_Max_Fields = {
  __typename?: 'item_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Item_Type_Min_Fields = {
  __typename?: 'item_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "item_type" */
export type Item_Type_Mutation_Response = {
  __typename?: 'item_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Item_Type>;
};

/** on_conflict condition type for table "item_type" */
export type Item_Type_On_Conflict = {
  constraint: Item_Type_Constraint;
  update_columns?: Array<Item_Type_Update_Column>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "item_type". */
export type Item_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: item_type */
export type Item_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "item_type" */
export type Item_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "item_type" */
export type Item_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "item_type" */
export type Item_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Item_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Item_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "item_type" */
export type Item_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Item_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Item_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Item_Type_Bool_Exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "kbb_parts_view" */
export type Kbb_Parts_View = {
  __typename?: 'kbb_parts_view';
  id?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  part_cost?: Maybe<Scalars['numeric']>;
  part_custom_field_1?: Maybe<Scalars['String']>;
  part_custom_field_2?: Maybe<Scalars['String']>;
  part_description?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  part_unit_of_measurement?: Maybe<Scalars['String']>;
  part_weight?: Maybe<Scalars['String']>;
};

/** aggregated selection of "kbb_parts_view" */
export type Kbb_Parts_View_Aggregate = {
  __typename?: 'kbb_parts_view_aggregate';
  aggregate?: Maybe<Kbb_Parts_View_Aggregate_Fields>;
  nodes: Array<Kbb_Parts_View>;
};

/** aggregate fields of "kbb_parts_view" */
export type Kbb_Parts_View_Aggregate_Fields = {
  __typename?: 'kbb_parts_view_aggregate_fields';
  avg?: Maybe<Kbb_Parts_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Kbb_Parts_View_Max_Fields>;
  min?: Maybe<Kbb_Parts_View_Min_Fields>;
  stddev?: Maybe<Kbb_Parts_View_Stddev_Fields>;
  stddev_pop?: Maybe<Kbb_Parts_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Kbb_Parts_View_Stddev_Samp_Fields>;
  sum?: Maybe<Kbb_Parts_View_Sum_Fields>;
  var_pop?: Maybe<Kbb_Parts_View_Var_Pop_Fields>;
  var_samp?: Maybe<Kbb_Parts_View_Var_Samp_Fields>;
  variance?: Maybe<Kbb_Parts_View_Variance_Fields>;
};


/** aggregate fields of "kbb_parts_view" */
export type Kbb_Parts_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kbb_Parts_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Kbb_Parts_View_Avg_Fields = {
  __typename?: 'kbb_parts_view_avg_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "kbb_parts_view". All fields are combined with a logical 'AND'. */
export type Kbb_Parts_View_Bool_Exp = {
  _and?: InputMaybe<Array<Kbb_Parts_View_Bool_Exp>>;
  _not?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
  _or?: InputMaybe<Array<Kbb_Parts_View_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  kbb_id?: InputMaybe<String_Comparison_Exp>;
  part_cost?: InputMaybe<Numeric_Comparison_Exp>;
  part_custom_field_1?: InputMaybe<String_Comparison_Exp>;
  part_custom_field_2?: InputMaybe<String_Comparison_Exp>;
  part_description?: InputMaybe<String_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  part_unit_of_measurement?: InputMaybe<String_Comparison_Exp>;
  part_weight?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Kbb_Parts_View_Max_Fields = {
  __typename?: 'kbb_parts_view_max_fields';
  id?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  part_cost?: Maybe<Scalars['numeric']>;
  part_custom_field_1?: Maybe<Scalars['String']>;
  part_custom_field_2?: Maybe<Scalars['String']>;
  part_description?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  part_unit_of_measurement?: Maybe<Scalars['String']>;
  part_weight?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Kbb_Parts_View_Min_Fields = {
  __typename?: 'kbb_parts_view_min_fields';
  id?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  part_cost?: Maybe<Scalars['numeric']>;
  part_custom_field_1?: Maybe<Scalars['String']>;
  part_custom_field_2?: Maybe<Scalars['String']>;
  part_description?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  part_unit_of_measurement?: Maybe<Scalars['String']>;
  part_weight?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "kbb_parts_view". */
export type Kbb_Parts_View_Order_By = {
  id?: InputMaybe<Order_By>;
  kbb_id?: InputMaybe<Order_By>;
  part_cost?: InputMaybe<Order_By>;
  part_custom_field_1?: InputMaybe<Order_By>;
  part_custom_field_2?: InputMaybe<Order_By>;
  part_description?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  part_unit_of_measurement?: InputMaybe<Order_By>;
  part_weight?: InputMaybe<Order_By>;
};

/** select columns of table "kbb_parts_view" */
export type Kbb_Parts_View_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'kbb_id'
  /** column name */
  | 'part_cost'
  /** column name */
  | 'part_custom_field_1'
  /** column name */
  | 'part_custom_field_2'
  /** column name */
  | 'part_description'
  /** column name */
  | 'part_number'
  /** column name */
  | 'part_unit_of_measurement'
  /** column name */
  | 'part_weight';

/** aggregate stddev on columns */
export type Kbb_Parts_View_Stddev_Fields = {
  __typename?: 'kbb_parts_view_stddev_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Kbb_Parts_View_Stddev_Pop_Fields = {
  __typename?: 'kbb_parts_view_stddev_pop_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Kbb_Parts_View_Stddev_Samp_Fields = {
  __typename?: 'kbb_parts_view_stddev_samp_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "kbb_parts_view" */
export type Kbb_Parts_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kbb_Parts_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kbb_Parts_View_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  kbb_id?: InputMaybe<Scalars['String']>;
  part_cost?: InputMaybe<Scalars['numeric']>;
  part_custom_field_1?: InputMaybe<Scalars['String']>;
  part_custom_field_2?: InputMaybe<Scalars['String']>;
  part_description?: InputMaybe<Scalars['String']>;
  part_number?: InputMaybe<Scalars['String']>;
  part_unit_of_measurement?: InputMaybe<Scalars['String']>;
  part_weight?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Kbb_Parts_View_Sum_Fields = {
  __typename?: 'kbb_parts_view_sum_fields';
  part_cost?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Kbb_Parts_View_Var_Pop_Fields = {
  __typename?: 'kbb_parts_view_var_pop_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Kbb_Parts_View_Var_Samp_Fields = {
  __typename?: 'kbb_parts_view_var_samp_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Kbb_Parts_View_Variance_Fields = {
  __typename?: 'kbb_parts_view_variance_fields';
  part_cost?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "lookup_view" */
export type Lookup = {
  __typename?: 'lookup';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "lookup_view" */
export type Lookup_Aggregate = {
  __typename?: 'lookup_aggregate';
  aggregate?: Maybe<Lookup_Aggregate_Fields>;
  nodes: Array<Lookup>;
};

/** aggregate fields of "lookup_view" */
export type Lookup_Aggregate_Fields = {
  __typename?: 'lookup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Lookup_Max_Fields>;
  min?: Maybe<Lookup_Min_Fields>;
};


/** aggregate fields of "lookup_view" */
export type Lookup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lookup_view". All fields are combined with a logical 'AND'. */
export type Lookup_Bool_Exp = {
  _and?: InputMaybe<Array<Lookup_Bool_Exp>>;
  _not?: InputMaybe<Lookup_Bool_Exp>;
  _or?: InputMaybe<Array<Lookup_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Lookup_Max_Fields = {
  __typename?: 'lookup_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Lookup_Min_Fields = {
  __typename?: 'lookup_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "lookup_view". */
export type Lookup_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** select columns of table "lookup_view" */
export type Lookup_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'source';

/** Streaming cursor of the table "lookup" */
export type Lookup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lookup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lookup_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type Ltree_Comparison_Exp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** columns and relationships of "manufacturer" */
export type Manufacturer = {
  __typename?: 'manufacturer';
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  parts_list: Array<Manufacturer_Parts>;
  /** An aggregate relationship */
  parts_list_aggregate: Manufacturer_Parts_Aggregate;
};


/** columns and relationships of "manufacturer" */
export type ManufacturerParts_ListArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


/** columns and relationships of "manufacturer" */
export type ManufacturerParts_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};

/** aggregated selection of "manufacturer" */
export type Manufacturer_Aggregate = {
  __typename?: 'manufacturer_aggregate';
  aggregate?: Maybe<Manufacturer_Aggregate_Fields>;
  nodes: Array<Manufacturer>;
};

/** aggregate fields of "manufacturer" */
export type Manufacturer_Aggregate_Fields = {
  __typename?: 'manufacturer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Manufacturer_Max_Fields>;
  min?: Maybe<Manufacturer_Min_Fields>;
};


/** aggregate fields of "manufacturer" */
export type Manufacturer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Manufacturer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "manufacturer". All fields are combined with a logical 'AND'. */
export type Manufacturer_Bool_Exp = {
  _and?: InputMaybe<Array<Manufacturer_Bool_Exp>>;
  _not?: InputMaybe<Manufacturer_Bool_Exp>;
  _or?: InputMaybe<Array<Manufacturer_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parts_list?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  parts_list_aggregate?: InputMaybe<Manufacturer_Parts_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "manufacturer" */
export type Manufacturer_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'manufacturer_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'manufacturer_pkey';

/** input type for inserting data into table "manufacturer" */
export type Manufacturer_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parts_list?: InputMaybe<Manufacturer_Parts_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Manufacturer_Max_Fields = {
  __typename?: 'manufacturer_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Manufacturer_Min_Fields = {
  __typename?: 'manufacturer_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "manufacturer" */
export type Manufacturer_Mutation_Response = {
  __typename?: 'manufacturer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturer>;
};

/** input type for inserting object relation for remote table "manufacturer" */
export type Manufacturer_Obj_Rel_Insert_Input = {
  data: Manufacturer_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};

/** on_conflict condition type for table "manufacturer" */
export type Manufacturer_On_Conflict = {
  constraint: Manufacturer_Constraint;
  update_columns?: Array<Manufacturer_Update_Column>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};

/** Ordering options when selecting data from "manufacturer". */
export type Manufacturer_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parts_list_aggregate?: InputMaybe<Manufacturer_Parts_Aggregate_Order_By>;
};

/** columns and relationships of "manufacturer_parts" */
export type Manufacturer_Parts = {
  __typename?: 'manufacturer_parts';
  container_depth?: Maybe<Scalars['String']>;
  container_height?: Maybe<Scalars['String']>;
  container_weight?: Maybe<Scalars['String']>;
  container_width?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  /** An object relationship */
  manufacturer: Manufacturer;
  manufacturerId: Scalars['String'];
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  part: Part;
  partId: Scalars['String'];
  preferred: Scalars['Boolean'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "manufacturer_parts" */
export type Manufacturer_Parts_Aggregate = {
  __typename?: 'manufacturer_parts_aggregate';
  aggregate?: Maybe<Manufacturer_Parts_Aggregate_Fields>;
  nodes: Array<Manufacturer_Parts>;
};

export type Manufacturer_Parts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Manufacturer_Parts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Manufacturer_Parts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Manufacturer_Parts_Aggregate_Bool_Exp_Count>;
};

export type Manufacturer_Parts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Manufacturer_Parts_Select_Column_Manufacturer_Parts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manufacturer_Parts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Manufacturer_Parts_Select_Column_Manufacturer_Parts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Manufacturer_Parts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "manufacturer_parts" */
export type Manufacturer_Parts_Aggregate_Fields = {
  __typename?: 'manufacturer_parts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Manufacturer_Parts_Max_Fields>;
  min?: Maybe<Manufacturer_Parts_Min_Fields>;
};


/** aggregate fields of "manufacturer_parts" */
export type Manufacturer_Parts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "manufacturer_parts" */
export type Manufacturer_Parts_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Manufacturer_Parts_Max_Order_By>;
  min?: InputMaybe<Manufacturer_Parts_Min_Order_By>;
};

/** input type for inserting array relation for remote table "manufacturer_parts" */
export type Manufacturer_Parts_Arr_Rel_Insert_Input = {
  data: Array<Manufacturer_Parts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Manufacturer_Parts_On_Conflict>;
};

/** Boolean expression to filter rows from the table "manufacturer_parts". All fields are combined with a logical 'AND'. */
export type Manufacturer_Parts_Bool_Exp = {
  _and?: InputMaybe<Array<Manufacturer_Parts_Bool_Exp>>;
  _not?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  _or?: InputMaybe<Array<Manufacturer_Parts_Bool_Exp>>;
  container_depth?: InputMaybe<String_Comparison_Exp>;
  container_height?: InputMaybe<String_Comparison_Exp>;
  container_weight?: InputMaybe<String_Comparison_Exp>;
  container_width?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  cutSheetUrl?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<Manufacturer_Bool_Exp>;
  manufacturerId?: InputMaybe<String_Comparison_Exp>;
  manufacturerPartNumber?: InputMaybe<String_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  partId?: InputMaybe<String_Comparison_Exp>;
  preferred?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "manufacturer_parts" */
export type Manufacturer_Parts_Constraint =
  /** unique or primary key constraint on columns "manufacturerId", "partId" */
  | 'manufacturer_parts_pkey';

/** input type for inserting data into table "manufacturer_parts" */
export type Manufacturer_Parts_Insert_Input = {
  container_depth?: InputMaybe<Scalars['String']>;
  container_height?: InputMaybe<Scalars['String']>;
  container_weight?: InputMaybe<Scalars['String']>;
  container_width?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Manufacturer_Obj_Rel_Insert_Input>;
  manufacturerId?: InputMaybe<Scalars['String']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Manufacturer_Parts_Max_Fields = {
  __typename?: 'manufacturer_parts_max_fields';
  container_depth?: Maybe<Scalars['String']>;
  container_height?: Maybe<Scalars['String']>;
  container_weight?: Maybe<Scalars['String']>;
  container_width?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  manufacturerId?: Maybe<Scalars['String']>;
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Max_Order_By = {
  container_depth?: InputMaybe<Order_By>;
  container_height?: InputMaybe<Order_By>;
  container_weight?: InputMaybe<Order_By>;
  container_width?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  manufacturerId?: InputMaybe<Order_By>;
  manufacturerPartNumber?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Manufacturer_Parts_Min_Fields = {
  __typename?: 'manufacturer_parts_min_fields';
  container_depth?: Maybe<Scalars['String']>;
  container_height?: Maybe<Scalars['String']>;
  container_weight?: Maybe<Scalars['String']>;
  container_width?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  manufacturerId?: Maybe<Scalars['String']>;
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Min_Order_By = {
  container_depth?: InputMaybe<Order_By>;
  container_height?: InputMaybe<Order_By>;
  container_weight?: InputMaybe<Order_By>;
  container_width?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  manufacturerId?: InputMaybe<Order_By>;
  manufacturerPartNumber?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "manufacturer_parts" */
export type Manufacturer_Parts_Mutation_Response = {
  __typename?: 'manufacturer_parts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Manufacturer_Parts>;
};

/** on_conflict condition type for table "manufacturer_parts" */
export type Manufacturer_Parts_On_Conflict = {
  constraint: Manufacturer_Parts_Constraint;
  update_columns?: Array<Manufacturer_Parts_Update_Column>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};

/** Ordering options when selecting data from "manufacturer_parts". */
export type Manufacturer_Parts_Order_By = {
  container_depth?: InputMaybe<Order_By>;
  container_height?: InputMaybe<Order_By>;
  container_weight?: InputMaybe<Order_By>;
  container_width?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Manufacturer_Order_By>;
  manufacturerId?: InputMaybe<Order_By>;
  manufacturerPartNumber?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  partId?: InputMaybe<Order_By>;
  preferred?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: manufacturer_parts */
export type Manufacturer_Parts_Pk_Columns_Input = {
  manufacturerId: Scalars['String'];
  partId: Scalars['String'];
};

/** select columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Select_Column =
  /** column name */
  | 'container_depth'
  /** column name */
  | 'container_height'
  /** column name */
  | 'container_weight'
  /** column name */
  | 'container_width'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'cutSheetUrl'
  /** column name */
  | 'manufacturerId'
  /** column name */
  | 'manufacturerPartNumber'
  /** column name */
  | 'partId'
  /** column name */
  | 'preferred'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** select "manufacturer_parts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Select_Column_Manufacturer_Parts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'preferred';

/** select "manufacturer_parts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Select_Column_Manufacturer_Parts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'preferred';

/** input type for updating data in table "manufacturer_parts" */
export type Manufacturer_Parts_Set_Input = {
  container_depth?: InputMaybe<Scalars['String']>;
  container_height?: InputMaybe<Scalars['String']>;
  container_weight?: InputMaybe<Scalars['String']>;
  container_width?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  manufacturerId?: InputMaybe<Scalars['String']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "manufacturer_parts" */
export type Manufacturer_Parts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manufacturer_Parts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturer_Parts_Stream_Cursor_Value_Input = {
  container_depth?: InputMaybe<Scalars['String']>;
  container_height?: InputMaybe<Scalars['String']>;
  container_weight?: InputMaybe<Scalars['String']>;
  container_width?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  manufacturerId?: InputMaybe<Scalars['String']>;
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** update columns of table "manufacturer_parts" */
export type Manufacturer_Parts_Update_Column =
  /** column name */
  | 'container_depth'
  /** column name */
  | 'container_height'
  /** column name */
  | 'container_weight'
  /** column name */
  | 'container_width'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'cutSheetUrl'
  /** column name */
  | 'manufacturerId'
  /** column name */
  | 'manufacturerPartNumber'
  /** column name */
  | 'partId'
  /** column name */
  | 'preferred'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Manufacturer_Parts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturer_Parts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Manufacturer_Parts_Bool_Exp;
};

/** primary key columns input for table: manufacturer */
export type Manufacturer_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "manufacturer" */
export type Manufacturer_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "manufacturer" */
export type Manufacturer_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "manufacturer" */
export type Manufacturer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Manufacturer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Manufacturer_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "manufacturer" */
export type Manufacturer_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Manufacturer_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Manufacturer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Manufacturer_Bool_Exp;
};

/** columns and relationships of "milestone" */
export type Milestone = {
  __typename?: 'milestone';
  id: Scalars['Int'];
  name: Scalars['String'];
  phased: Scalars['Boolean'];
  /** An array relationship */
  project_milestones: Array<Project_Milestone>;
  /** An aggregate relationship */
  project_milestones_aggregate: Project_Milestone_Aggregate;
  sortOrder?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "milestone" */
export type MilestoneProject_MilestonesArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


/** columns and relationships of "milestone" */
export type MilestoneProject_Milestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};

/** aggregated selection of "milestone" */
export type Milestone_Aggregate = {
  __typename?: 'milestone_aggregate';
  aggregate?: Maybe<Milestone_Aggregate_Fields>;
  nodes: Array<Milestone>;
};

/** aggregate fields of "milestone" */
export type Milestone_Aggregate_Fields = {
  __typename?: 'milestone_aggregate_fields';
  avg?: Maybe<Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Milestone_Max_Fields>;
  min?: Maybe<Milestone_Min_Fields>;
  stddev?: Maybe<Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Milestone_Sum_Fields>;
  var_pop?: Maybe<Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Milestone_Var_Samp_Fields>;
  variance?: Maybe<Milestone_Variance_Fields>;
};


/** aggregate fields of "milestone" */
export type Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Milestone_Avg_Fields = {
  __typename?: 'milestone_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "milestone". All fields are combined with a logical 'AND'. */
export type Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Milestone_Bool_Exp>>;
  _not?: InputMaybe<Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Milestone_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phased?: InputMaybe<Boolean_Comparison_Exp>;
  project_milestones?: InputMaybe<Project_Milestone_Bool_Exp>;
  project_milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Bool_Exp>;
  sortOrder?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "milestone" */
export type Milestone_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'milestone_id_key'
  /** unique or primary key constraint on columns "name" */
  | 'milestone_name_key';

/** input type for incrementing numeric columns in table "milestone" */
export type Milestone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "milestone" */
export type Milestone_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phased?: InputMaybe<Scalars['Boolean']>;
  project_milestones?: InputMaybe<Project_Milestone_Arr_Rel_Insert_Input>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Milestone_Max_Fields = {
  __typename?: 'milestone_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Milestone_Min_Fields = {
  __typename?: 'milestone_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "milestone" */
export type Milestone_Mutation_Response = {
  __typename?: 'milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Milestone>;
};

/** input type for inserting object relation for remote table "milestone" */
export type Milestone_Obj_Rel_Insert_Input = {
  data: Milestone_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};

/** on_conflict condition type for table "milestone" */
export type Milestone_On_Conflict = {
  constraint: Milestone_Constraint;
  update_columns?: Array<Milestone_Update_Column>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "milestone". */
export type Milestone_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phased?: InputMaybe<Order_By>;
  project_milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Order_By>;
  sortOrder?: InputMaybe<Order_By>;
};

/** select columns of table "milestone" */
export type Milestone_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'phased'
  /** column name */
  | 'sortOrder';

/** input type for updating data in table "milestone" */
export type Milestone_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phased?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Milestone_Stddev_Fields = {
  __typename?: 'milestone_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Milestone_Stddev_Pop_Fields = {
  __typename?: 'milestone_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Milestone_Stddev_Samp_Fields = {
  __typename?: 'milestone_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "milestone" */
export type Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Milestone_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phased?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Milestone_Sum_Fields = {
  __typename?: 'milestone_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "milestone" */
export type Milestone_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'phased'
  /** column name */
  | 'sortOrder';

export type Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Milestone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Milestone_Var_Pop_Fields = {
  __typename?: 'milestone_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Milestone_Var_Samp_Fields = {
  __typename?: 'milestone_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Milestone_Variance_Fields = {
  __typename?: 'milestone_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sortOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "money". All fields are combined with logical 'AND'. */
export type Money_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['money']>;
  _gt?: InputMaybe<Scalars['money']>;
  _gte?: InputMaybe<Scalars['money']>;
  _in?: InputMaybe<Array<Scalars['money']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['money']>;
  _lte?: InputMaybe<Scalars['money']>;
  _neq?: InputMaybe<Scalars['money']>;
  _nin?: InputMaybe<Array<Scalars['money']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  CreateBomVersion: BomResult;
  CreateItemTag: ItemTag;
  CreateTag: Tag;
  CreateTagType: TagType;
  UpdateItemTag: ItemTag;
  UpdateTag: Tag;
  assignNewPartNumber?: Maybe<AssignNewPartNumberOutput>;
  cloneUnmodeledBom?: Maybe<CloneUnmodeledBomOutput>;
  createchoiceNodes: CreatechoiceNodesMutationResponse;
  createcsiNodes: CreatecsiNodesMutationResponse;
  createcustomerNodes: CreatecustomerNodesMutationResponse;
  createitemNodes: CreateitemNodesMutationResponse;
  createorderNodes: CreateorderNodesMutationResponse;
  createplatformNodes: CreateplatformNodesMutationResponse;
  createproductNodes: CreateproductNodesMutationResponse;
  createproductOptionNodes: CreateproductOptionNodesMutationResponse;
  createprogramNodes: CreateprogramNodesMutationResponse;
  createprojectNodes: CreateprojectNodesMutationResponse;
  createunitNodes: CreateunitNodesMutationResponse;
  createuomNodes: CreateuomNodesMutationResponse;
  createuomScopeNodes: CreateuomScopeNodesMutationResponse;
  createuomSupplierNodes: CreateuomSupplierNodesMutationResponse;
  /** delete data from the table: "base_product" */
  delete_base_product?: Maybe<Base_Product_Mutation_Response>;
  /** delete single row from the table: "base_product" */
  delete_base_product_by_pk?: Maybe<Base_Product>;
  /** delete data from the table: "bom_detail" */
  delete_bom_detail?: Maybe<Bom_Detail_Mutation_Response>;
  /** delete single row from the table: "bom_detail" */
  delete_bom_detail_by_pk?: Maybe<Bom_Detail>;
  /** delete data from the table: "bom_item_tag_set" */
  delete_bom_item_tag_set?: Maybe<Bom_Item_Tag_Set_Mutation_Response>;
  /** delete single row from the table: "bom_item_tag_set" */
  delete_bom_item_tag_set_by_pk?: Maybe<Bom_Item_Tag_Set>;
  /** delete data from the table: "boms_view" */
  delete_boms_view?: Maybe<Boms_View_Mutation_Response>;
  /** delete data from the table: "consumable_bom_detail" */
  delete_consumable_bom_detail?: Maybe<Consumable_Bom_Detail_Mutation_Response>;
  /** delete single row from the table: "consumable_bom_detail" */
  delete_consumable_bom_detail_by_pk?: Maybe<Consumable_Bom_Detail>;
  /** delete data from the table: "counters" */
  delete_counters?: Maybe<Counters_Mutation_Response>;
  /** delete single row from the table: "counters" */
  delete_counters_by_pk?: Maybe<Counters>;
  /** delete data from the table: "csi" */
  delete_csi?: Maybe<Csi_Mutation_Response>;
  /** delete single row from the table: "csi" */
  delete_csi_by_pk?: Maybe<Csi>;
  /** delete data from the table: "customer" */
  delete_customer?: Maybe<Customer_Mutation_Response>;
  /** delete data from the table: "customer_admin" */
  delete_customer_admin?: Maybe<Customer_Admin_Mutation_Response>;
  /** delete single row from the table: "customer_admin" */
  delete_customer_admin_by_pk?: Maybe<Customer_Admin>;
  /** delete single row from the table: "customer" */
  delete_customer_by_pk?: Maybe<Customer>;
  /** delete data from the table: "email_templates" */
  delete_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** delete single row from the table: "email_templates" */
  delete_email_templates_by_pk?: Maybe<Email_Templates>;
  /** delete data from the table: "emails" */
  delete_emails?: Maybe<Emails_Mutation_Response>;
  /** delete single row from the table: "emails" */
  delete_emails_by_pk?: Maybe<Emails>;
  /** delete data from the table: "feedback" */
  delete_feedback?: Maybe<Feedback_Mutation_Response>;
  /** delete single row from the table: "feedback" */
  delete_feedback_by_pk?: Maybe<Feedback>;
  /** delete data from the table: "invitation" */
  delete_invitation?: Maybe<Invitation_Mutation_Response>;
  /** delete single row from the table: "invitation" */
  delete_invitation_by_pk?: Maybe<Invitation>;
  /** delete data from the table: "issue" */
  delete_issue?: Maybe<Issue_Mutation_Response>;
  /** delete single row from the table: "issue" */
  delete_issue_by_pk?: Maybe<Issue>;
  /** delete data from the table: "issue_status" */
  delete_issue_status?: Maybe<Issue_Status_Mutation_Response>;
  /** delete single row from the table: "issue_status" */
  delete_issue_status_by_pk?: Maybe<Issue_Status>;
  /** delete data from the table: "item_bom" */
  delete_item_bom?: Maybe<Item_Bom_Mutation_Response>;
  /** delete single row from the table: "item_bom" */
  delete_item_bom_by_pk?: Maybe<Item_Bom>;
  /** delete data from the table: "item_type" */
  delete_item_type?: Maybe<Item_Type_Mutation_Response>;
  /** delete single row from the table: "item_type" */
  delete_item_type_by_pk?: Maybe<Item_Type>;
  /** delete data from the table: "manufacturer" */
  delete_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** delete single row from the table: "manufacturer" */
  delete_manufacturer_by_pk?: Maybe<Manufacturer>;
  /** delete data from the table: "manufacturer_parts" */
  delete_manufacturer_parts?: Maybe<Manufacturer_Parts_Mutation_Response>;
  /** delete single row from the table: "manufacturer_parts" */
  delete_manufacturer_parts_by_pk?: Maybe<Manufacturer_Parts>;
  /** delete data from the table: "milestone" */
  delete_milestone?: Maybe<Milestone_Mutation_Response>;
  /** delete data from the table: "part" */
  delete_part?: Maybe<Part_Mutation_Response>;
  /** delete single row from the table: "part" */
  delete_part_by_pk?: Maybe<Part>;
  /** delete data from the table: "part_number_history" */
  delete_part_number_history?: Maybe<Part_Number_History_Mutation_Response>;
  /** delete single row from the table: "part_number_history" */
  delete_part_number_history_by_pk?: Maybe<Part_Number_History>;
  /** delete data from the table: "part_request" */
  delete_part_request?: Maybe<Part_Request_Mutation_Response>;
  /** delete single row from the table: "part_request" */
  delete_part_request_by_pk?: Maybe<Part_Request>;
  /** delete data from the table: "part_request_reason" */
  delete_part_request_reason?: Maybe<Part_Request_Reason_Mutation_Response>;
  /** delete single row from the table: "part_request_reason" */
  delete_part_request_reason_by_pk?: Maybe<Part_Request_Reason>;
  /** delete data from the table: "part_request_status" */
  delete_part_request_status?: Maybe<Part_Request_Status_Mutation_Response>;
  /** delete single row from the table: "part_request_status" */
  delete_part_request_status_by_pk?: Maybe<Part_Request_Status>;
  /** delete data from the table: "part_request_type" */
  delete_part_request_type?: Maybe<Part_Request_Type_Mutation_Response>;
  /** delete single row from the table: "part_request_type" */
  delete_part_request_type_by_pk?: Maybe<Part_Request_Type>;
  /** delete data from the table: "part_status" */
  delete_part_status?: Maybe<Part_Status_Mutation_Response>;
  /** delete single row from the table: "part_status" */
  delete_part_status_by_pk?: Maybe<Part_Status>;
  /** delete data from the table: "part_sync" */
  delete_part_sync?: Maybe<Part_Sync_Mutation_Response>;
  /** delete single row from the table: "part_sync" */
  delete_part_sync_by_pk?: Maybe<Part_Sync>;
  /** delete data from the table: "part_type" */
  delete_part_type?: Maybe<Part_Type_Mutation_Response>;
  /** delete single row from the table: "part_type" */
  delete_part_type_by_pk?: Maybe<Part_Type>;
  /** delete data from the table: "part_warehouse_detail" */
  delete_part_warehouse_detail?: Maybe<Part_Warehouse_Detail_Mutation_Response>;
  /** delete single row from the table: "part_warehouse_detail" */
  delete_part_warehouse_detail_by_pk?: Maybe<Part_Warehouse_Detail>;
  /** delete data from the table: "parts_related" */
  delete_parts_related?: Maybe<Parts_Related_Mutation_Response>;
  /** delete single row from the table: "parts_related" */
  delete_parts_related_by_pk?: Maybe<Parts_Related>;
  /** delete data from the table: "permissions" */
  delete_permissions?: Maybe<Permissions_Mutation_Response>;
  /** delete single row from the table: "permissions" */
  delete_permissions_by_pk?: Maybe<Permissions>;
  /** delete data from the table: "phase" */
  delete_phase?: Maybe<Phase_Mutation_Response>;
  /** delete single row from the table: "phase" */
  delete_phase_by_pk?: Maybe<Phase>;
  /** delete data from the table: "platform" */
  delete_platform?: Maybe<Platform_Mutation_Response>;
  /** delete single row from the table: "platform" */
  delete_platform_by_pk?: Maybe<Platform>;
  /** delete data from the table: "platform_requirement" */
  delete_platform_requirement?: Maybe<Platform_Requirement_Mutation_Response>;
  /** delete single row from the table: "platform_requirement" */
  delete_platform_requirement_by_pk?: Maybe<Platform_Requirement>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_option" */
  delete_product_option?: Maybe<Product_Option_Mutation_Response>;
  /** delete single row from the table: "product_option" */
  delete_product_option_by_pk?: Maybe<Product_Option>;
  /** delete data from the table: "product_option_choice" */
  delete_product_option_choice?: Maybe<Product_Option_Choice_Mutation_Response>;
  /** delete single row from the table: "product_option_choice" */
  delete_product_option_choice_by_pk?: Maybe<Product_Option_Choice>;
  /** delete data from the table: "product_type" */
  delete_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** delete single row from the table: "product_type" */
  delete_product_type_by_pk?: Maybe<Product_Type>;
  /** delete data from the table: "program" */
  delete_program?: Maybe<Program_Mutation_Response>;
  /** delete single row from the table: "program" */
  delete_program_by_pk?: Maybe<Program>;
  /** delete data from the table: "project" */
  delete_project?: Maybe<Project_Mutation_Response>;
  /** delete data from the table: "project_base_product_quantities" */
  delete_project_base_product_quantities?: Maybe<Project_Base_Product_Quantities_Mutation_Response>;
  /** delete single row from the table: "project_base_product_quantities" */
  delete_project_base_product_quantities_by_pk?: Maybe<Project_Base_Product_Quantities>;
  /** delete single row from the table: "project" */
  delete_project_by_pk?: Maybe<Project>;
  /** delete data from the table: "project_comment" */
  delete_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** delete single row from the table: "project_comment" */
  delete_project_comment_by_pk?: Maybe<Project_Comment>;
  /** delete data from the table: "project_contacts" */
  delete_project_contacts?: Maybe<Project_Contacts_Mutation_Response>;
  /** delete single row from the table: "project_contacts" */
  delete_project_contacts_by_pk?: Maybe<Project_Contacts>;
  /** delete data from the table: "project_milestone" */
  delete_project_milestone?: Maybe<Project_Milestone_Mutation_Response>;
  /** delete single row from the table: "project_milestone" */
  delete_project_milestone_by_pk?: Maybe<Project_Milestone>;
  /** delete data from the table: "project_module" */
  delete_project_module?: Maybe<Project_Module_Mutation_Response>;
  /** delete single row from the table: "project_module" */
  delete_project_module_by_pk?: Maybe<Project_Module>;
  /** delete data from the table: "project_status" */
  delete_project_status?: Maybe<Project_Status_Mutation_Response>;
  /** delete single row from the table: "project_status" */
  delete_project_status_by_pk?: Maybe<Project_Status>;
  /** delete data from the table: "project_users" */
  delete_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** delete single row from the table: "project_users" */
  delete_project_users_by_pk?: Maybe<Project_Users>;
  /** delete data from the table: "purchase_type" */
  delete_purchase_type?: Maybe<Purchase_Type_Mutation_Response>;
  /** delete single row from the table: "purchase_type" */
  delete_purchase_type_by_pk?: Maybe<Purchase_Type>;
  /** delete data from the table: "qb_items" */
  delete_qb_items?: Maybe<Qb_Items_Mutation_Response>;
  /** delete single row from the table: "qb_items" */
  delete_qb_items_by_pk?: Maybe<Qb_Items>;
  /** delete data from the table: "relation_type" */
  delete_relation_type?: Maybe<Relation_Type_Mutation_Response>;
  /** delete single row from the table: "relation_type" */
  delete_relation_type_by_pk?: Maybe<Relation_Type>;
  /** delete data from the table: "report" */
  delete_report?: Maybe<Report_Mutation_Response>;
  /** delete single row from the table: "report" */
  delete_report_by_pk?: Maybe<Report>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "role_permissions" */
  delete_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** delete single row from the table: "role_permissions" */
  delete_role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** delete data from the table: "serial_numbers" */
  delete_serial_numbers?: Maybe<Serial_Numbers_Mutation_Response>;
  /** delete single row from the table: "serial_numbers" */
  delete_serial_numbers_by_pk?: Maybe<Serial_Numbers>;
  /** delete data from the table: "short_url" */
  delete_short_url?: Maybe<Short_Url_Mutation_Response>;
  /** delete single row from the table: "short_url" */
  delete_short_url_by_pk?: Maybe<Short_Url>;
  /** delete data from the table: "system_event" */
  delete_system_event?: Maybe<System_Event_Mutation_Response>;
  /** delete single row from the table: "system_event" */
  delete_system_event_by_pk?: Maybe<System_Event>;
  /** delete data from the table: "tag_entity" */
  delete_tag_entity?: Maybe<Tag_Entity_Mutation_Response>;
  /** delete single row from the table: "tag_entity" */
  delete_tag_entity_by_pk?: Maybe<Tag_Entity>;
  /** delete data from the table: "tag_path" */
  delete_tag_path?: Maybe<Tag_Path_Mutation_Response>;
  /** delete single row from the table: "tag_path" */
  delete_tag_path_by_pk?: Maybe<Tag_Path>;
  /** delete data from the table: "tag_set" */
  delete_tag_set?: Maybe<Tag_Set_Mutation_Response>;
  /** delete single row from the table: "tag_set" */
  delete_tag_set_by_pk?: Maybe<Tag_Set>;
  /** delete data from the table: "tag_type" */
  delete_tag_type?: Maybe<Tag_Type_Mutation_Response>;
  /** delete single row from the table: "tag_type" */
  delete_tag_type_by_pk?: Maybe<Tag_Type>;
  /** delete data from the table: "tags" */
  delete_tags?: Maybe<Tags_Mutation_Response>;
  /** delete single row from the table: "tags" */
  delete_tags_by_pk?: Maybe<Tags>;
  /** delete data from the table: "unit" */
  delete_unit?: Maybe<Unit_Mutation_Response>;
  /** delete single row from the table: "unit" */
  delete_unit_by_pk?: Maybe<Unit>;
  /** delete data from the table: "unit_product_option_choice" */
  delete_unit_product_option_choice?: Maybe<Unit_Product_Option_Choice_Mutation_Response>;
  /** delete single row from the table: "unit_product_option_choice" */
  delete_unit_product_option_choice_by_pk?: Maybe<Unit_Product_Option_Choice>;
  /** delete data from the table: "uom" */
  delete_uom?: Maybe<Uom_Mutation_Response>;
  /** delete single row from the table: "uom" */
  delete_uom_by_pk?: Maybe<Uom>;
  /** delete data from the table: "uom_classification" */
  delete_uom_classification?: Maybe<Uom_Classification_Mutation_Response>;
  /** delete single row from the table: "uom_classification" */
  delete_uom_classification_by_pk?: Maybe<Uom_Classification>;
  /** delete data from the table: "uom_conversion" */
  delete_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** delete single row from the table: "uom_conversion" */
  delete_uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** delete data from the table: "uom_csi_conversion" */
  delete_uom_csi_conversion?: Maybe<Uom_Csi_Conversion_Mutation_Response>;
  /** delete single row from the table: "uom_csi_conversion" */
  delete_uom_csi_conversion_by_pk?: Maybe<Uom_Csi_Conversion>;
  /** delete data from the table: "uom_scope" */
  delete_uom_scope?: Maybe<Uom_Scope_Mutation_Response>;
  /** delete single row from the table: "uom_scope" */
  delete_uom_scope_by_pk?: Maybe<Uom_Scope>;
  /** delete data from the table: "uom_scope_part" */
  delete_uom_scope_part?: Maybe<Uom_Scope_Part_Mutation_Response>;
  /** delete single row from the table: "uom_scope_part" */
  delete_uom_scope_part_by_pk?: Maybe<Uom_Scope_Part>;
  /** delete data from the table: "uom_system_conversion" */
  delete_uom_system_conversion?: Maybe<Uom_System_Conversion_Mutation_Response>;
  /** delete single row from the table: "uom_system_conversion" */
  delete_uom_system_conversion_by_pk?: Maybe<Uom_System_Conversion>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_info" */
  delete_user_info?: Maybe<User_Info_Mutation_Response>;
  /** delete data from the table: "user_permissions" */
  delete_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** delete single row from the table: "user_permissions" */
  delete_user_permissions_by_pk?: Maybe<User_Permissions>;
  /** delete data from the table: "user_role" */
  delete_user_role?: Maybe<User_Role_Mutation_Response>;
  /** delete single row from the table: "user_role" */
  delete_user_role_by_pk?: Maybe<User_Role>;
  /** delete data from the table: "vendor" */
  delete_vendor?: Maybe<Vendor_Mutation_Response>;
  /** delete single row from the table: "vendor" */
  delete_vendor_by_pk?: Maybe<Vendor>;
  /** delete data from the table: "vendor_cleanup_audit" */
  delete_vendor_cleanup_audit?: Maybe<Vendor_Cleanup_Audit_Mutation_Response>;
  /** delete single row from the table: "vendor_cleanup_audit" */
  delete_vendor_cleanup_audit_by_pk?: Maybe<Vendor_Cleanup_Audit>;
  /** delete data from the table: "vendor_cleanup_wevr_mapping_lookup" */
  delete_vendor_cleanup_wevr_mapping_lookup?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Mutation_Response>;
  /** delete single row from the table: "vendor_cleanup_wevr_mapping_lookup" */
  delete_vendor_cleanup_wevr_mapping_lookup_by_pk?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** delete data from the table: "vendor_parts" */
  delete_vendor_parts?: Maybe<Vendor_Parts_Mutation_Response>;
  /** delete single row from the table: "vendor_parts" */
  delete_vendor_parts_by_pk?: Maybe<Vendor_Parts>;
  /** delete data from the table: "workflow" */
  delete_workflow?: Maybe<Workflow_Mutation_Response>;
  /** delete single row from the table: "workflow" */
  delete_workflow_by_pk?: Maybe<Workflow>;
  deletechoiceNodes: DeleteInfo;
  deletecsiNodes: DeleteInfo;
  deletecustomerNodes: DeleteInfo;
  deleteitemNodes: DeleteInfo;
  deleteorderNodes: DeleteInfo;
  deleteplatformNodes: DeleteInfo;
  deleteproductNodes: DeleteInfo;
  deleteproductOptionNodes: DeleteInfo;
  deleteprogramNodes: DeleteInfo;
  deleteprojectNodes: DeleteInfo;
  deleteunitNodes: DeleteInfo;
  deleteuomNodes: DeleteInfo;
  deleteuomScopeNodes: DeleteInfo;
  deleteuomSupplierNodes: DeleteInfo;
  fileUpload?: Maybe<FileUploadOutput>;
  /** insert data into the table: "base_product" */
  insert_base_product?: Maybe<Base_Product_Mutation_Response>;
  /** insert a single row into the table: "base_product" */
  insert_base_product_one?: Maybe<Base_Product>;
  /** insert data into the table: "bom_detail" */
  insert_bom_detail?: Maybe<Bom_Detail_Mutation_Response>;
  /** insert a single row into the table: "bom_detail" */
  insert_bom_detail_one?: Maybe<Bom_Detail>;
  /** insert data into the table: "bom_item_tag_set" */
  insert_bom_item_tag_set?: Maybe<Bom_Item_Tag_Set_Mutation_Response>;
  /** insert a single row into the table: "bom_item_tag_set" */
  insert_bom_item_tag_set_one?: Maybe<Bom_Item_Tag_Set>;
  /** insert data into the table: "boms_view" */
  insert_boms_view?: Maybe<Boms_View_Mutation_Response>;
  /** insert a single row into the table: "boms_view" */
  insert_boms_view_one?: Maybe<Boms_View>;
  /** insert data into the table: "consumable_bom_detail" */
  insert_consumable_bom_detail?: Maybe<Consumable_Bom_Detail_Mutation_Response>;
  /** insert a single row into the table: "consumable_bom_detail" */
  insert_consumable_bom_detail_one?: Maybe<Consumable_Bom_Detail>;
  /** insert data into the table: "counters" */
  insert_counters?: Maybe<Counters_Mutation_Response>;
  /** insert a single row into the table: "counters" */
  insert_counters_one?: Maybe<Counters>;
  /** insert data into the table: "csi" */
  insert_csi?: Maybe<Csi_Mutation_Response>;
  /** insert a single row into the table: "csi" */
  insert_csi_one?: Maybe<Csi>;
  /** insert data into the table: "customer" */
  insert_customer?: Maybe<Customer_Mutation_Response>;
  /** insert data into the table: "customer_admin" */
  insert_customer_admin?: Maybe<Customer_Admin_Mutation_Response>;
  /** insert a single row into the table: "customer_admin" */
  insert_customer_admin_one?: Maybe<Customer_Admin>;
  /** insert a single row into the table: "customer" */
  insert_customer_one?: Maybe<Customer>;
  /** insert data into the table: "email_templates" */
  insert_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** insert a single row into the table: "email_templates" */
  insert_email_templates_one?: Maybe<Email_Templates>;
  /** insert data into the table: "emails" */
  insert_emails?: Maybe<Emails_Mutation_Response>;
  /** insert a single row into the table: "emails" */
  insert_emails_one?: Maybe<Emails>;
  /** insert data into the table: "feedback" */
  insert_feedback?: Maybe<Feedback_Mutation_Response>;
  /** insert a single row into the table: "feedback" */
  insert_feedback_one?: Maybe<Feedback>;
  /** insert data into the table: "invitation" */
  insert_invitation?: Maybe<Invitation_Mutation_Response>;
  /** insert a single row into the table: "invitation" */
  insert_invitation_one?: Maybe<Invitation>;
  /** insert data into the table: "issue" */
  insert_issue?: Maybe<Issue_Mutation_Response>;
  /** insert a single row into the table: "issue" */
  insert_issue_one?: Maybe<Issue>;
  /** insert data into the table: "issue_status" */
  insert_issue_status?: Maybe<Issue_Status_Mutation_Response>;
  /** insert a single row into the table: "issue_status" */
  insert_issue_status_one?: Maybe<Issue_Status>;
  /** insert data into the table: "item_bom" */
  insert_item_bom?: Maybe<Item_Bom_Mutation_Response>;
  /** insert a single row into the table: "item_bom" */
  insert_item_bom_one?: Maybe<Item_Bom>;
  /** insert data into the table: "item_type" */
  insert_item_type?: Maybe<Item_Type_Mutation_Response>;
  /** insert a single row into the table: "item_type" */
  insert_item_type_one?: Maybe<Item_Type>;
  /** insert data into the table: "manufacturer" */
  insert_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** insert a single row into the table: "manufacturer" */
  insert_manufacturer_one?: Maybe<Manufacturer>;
  /** insert data into the table: "manufacturer_parts" */
  insert_manufacturer_parts?: Maybe<Manufacturer_Parts_Mutation_Response>;
  /** insert a single row into the table: "manufacturer_parts" */
  insert_manufacturer_parts_one?: Maybe<Manufacturer_Parts>;
  /** insert data into the table: "milestone" */
  insert_milestone?: Maybe<Milestone_Mutation_Response>;
  /** insert a single row into the table: "milestone" */
  insert_milestone_one?: Maybe<Milestone>;
  /** insert data into the table: "part" */
  insert_part?: Maybe<Part_Mutation_Response>;
  /** insert data into the table: "part_number_history" */
  insert_part_number_history?: Maybe<Part_Number_History_Mutation_Response>;
  /** insert a single row into the table: "part_number_history" */
  insert_part_number_history_one?: Maybe<Part_Number_History>;
  /** insert a single row into the table: "part" */
  insert_part_one?: Maybe<Part>;
  /** insert data into the table: "part_request" */
  insert_part_request?: Maybe<Part_Request_Mutation_Response>;
  /** insert a single row into the table: "part_request" */
  insert_part_request_one?: Maybe<Part_Request>;
  /** insert data into the table: "part_request_reason" */
  insert_part_request_reason?: Maybe<Part_Request_Reason_Mutation_Response>;
  /** insert a single row into the table: "part_request_reason" */
  insert_part_request_reason_one?: Maybe<Part_Request_Reason>;
  /** insert data into the table: "part_request_status" */
  insert_part_request_status?: Maybe<Part_Request_Status_Mutation_Response>;
  /** insert a single row into the table: "part_request_status" */
  insert_part_request_status_one?: Maybe<Part_Request_Status>;
  /** insert data into the table: "part_request_type" */
  insert_part_request_type?: Maybe<Part_Request_Type_Mutation_Response>;
  /** insert a single row into the table: "part_request_type" */
  insert_part_request_type_one?: Maybe<Part_Request_Type>;
  /** insert data into the table: "part_status" */
  insert_part_status?: Maybe<Part_Status_Mutation_Response>;
  /** insert a single row into the table: "part_status" */
  insert_part_status_one?: Maybe<Part_Status>;
  /** insert data into the table: "part_sync" */
  insert_part_sync?: Maybe<Part_Sync_Mutation_Response>;
  /** insert a single row into the table: "part_sync" */
  insert_part_sync_one?: Maybe<Part_Sync>;
  /** insert data into the table: "part_type" */
  insert_part_type?: Maybe<Part_Type_Mutation_Response>;
  /** insert a single row into the table: "part_type" */
  insert_part_type_one?: Maybe<Part_Type>;
  /** insert data into the table: "part_warehouse_detail" */
  insert_part_warehouse_detail?: Maybe<Part_Warehouse_Detail_Mutation_Response>;
  /** insert a single row into the table: "part_warehouse_detail" */
  insert_part_warehouse_detail_one?: Maybe<Part_Warehouse_Detail>;
  /** insert data into the table: "parts_related" */
  insert_parts_related?: Maybe<Parts_Related_Mutation_Response>;
  /** insert a single row into the table: "parts_related" */
  insert_parts_related_one?: Maybe<Parts_Related>;
  /** insert data into the table: "permissions" */
  insert_permissions?: Maybe<Permissions_Mutation_Response>;
  /** insert a single row into the table: "permissions" */
  insert_permissions_one?: Maybe<Permissions>;
  /** insert data into the table: "phase" */
  insert_phase?: Maybe<Phase_Mutation_Response>;
  /** insert a single row into the table: "phase" */
  insert_phase_one?: Maybe<Phase>;
  /** insert data into the table: "platform" */
  insert_platform?: Maybe<Platform_Mutation_Response>;
  /** insert a single row into the table: "platform" */
  insert_platform_one?: Maybe<Platform>;
  /** insert data into the table: "platform_requirement" */
  insert_platform_requirement?: Maybe<Platform_Requirement_Mutation_Response>;
  /** insert a single row into the table: "platform_requirement" */
  insert_platform_requirement_one?: Maybe<Platform_Requirement>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_option" */
  insert_product_option?: Maybe<Product_Option_Mutation_Response>;
  /** insert data into the table: "product_option_choice" */
  insert_product_option_choice?: Maybe<Product_Option_Choice_Mutation_Response>;
  /** insert a single row into the table: "product_option_choice" */
  insert_product_option_choice_one?: Maybe<Product_Option_Choice>;
  /** insert a single row into the table: "product_option" */
  insert_product_option_one?: Maybe<Product_Option>;
  /** insert data into the table: "product_type" */
  insert_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** insert a single row into the table: "product_type" */
  insert_product_type_one?: Maybe<Product_Type>;
  /** insert data into the table: "program" */
  insert_program?: Maybe<Program_Mutation_Response>;
  /** insert a single row into the table: "program" */
  insert_program_one?: Maybe<Program>;
  /** insert data into the table: "project" */
  insert_project?: Maybe<Project_Mutation_Response>;
  /** insert data into the table: "project_base_product_quantities" */
  insert_project_base_product_quantities?: Maybe<Project_Base_Product_Quantities_Mutation_Response>;
  /** insert a single row into the table: "project_base_product_quantities" */
  insert_project_base_product_quantities_one?: Maybe<Project_Base_Product_Quantities>;
  /** insert data into the table: "project_comment" */
  insert_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** insert a single row into the table: "project_comment" */
  insert_project_comment_one?: Maybe<Project_Comment>;
  /** insert data into the table: "project_contacts" */
  insert_project_contacts?: Maybe<Project_Contacts_Mutation_Response>;
  /** insert a single row into the table: "project_contacts" */
  insert_project_contacts_one?: Maybe<Project_Contacts>;
  /** insert data into the table: "project_milestone" */
  insert_project_milestone?: Maybe<Project_Milestone_Mutation_Response>;
  /** insert a single row into the table: "project_milestone" */
  insert_project_milestone_one?: Maybe<Project_Milestone>;
  /** insert data into the table: "project_module" */
  insert_project_module?: Maybe<Project_Module_Mutation_Response>;
  /** insert a single row into the table: "project_module" */
  insert_project_module_one?: Maybe<Project_Module>;
  /** insert a single row into the table: "project" */
  insert_project_one?: Maybe<Project>;
  /** insert data into the table: "project_status" */
  insert_project_status?: Maybe<Project_Status_Mutation_Response>;
  /** insert a single row into the table: "project_status" */
  insert_project_status_one?: Maybe<Project_Status>;
  /** insert data into the table: "project_users" */
  insert_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** insert a single row into the table: "project_users" */
  insert_project_users_one?: Maybe<Project_Users>;
  /** insert data into the table: "purchase_type" */
  insert_purchase_type?: Maybe<Purchase_Type_Mutation_Response>;
  /** insert a single row into the table: "purchase_type" */
  insert_purchase_type_one?: Maybe<Purchase_Type>;
  /** insert data into the table: "qb_items" */
  insert_qb_items?: Maybe<Qb_Items_Mutation_Response>;
  /** insert a single row into the table: "qb_items" */
  insert_qb_items_one?: Maybe<Qb_Items>;
  /** insert data into the table: "relation_type" */
  insert_relation_type?: Maybe<Relation_Type_Mutation_Response>;
  /** insert a single row into the table: "relation_type" */
  insert_relation_type_one?: Maybe<Relation_Type>;
  /** insert data into the table: "report" */
  insert_report?: Maybe<Report_Mutation_Response>;
  /** insert a single row into the table: "report" */
  insert_report_one?: Maybe<Report>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "role_permissions" */
  insert_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** insert a single row into the table: "role_permissions" */
  insert_role_permissions_one?: Maybe<Role_Permissions>;
  /** insert data into the table: "serial_numbers" */
  insert_serial_numbers?: Maybe<Serial_Numbers_Mutation_Response>;
  /** insert a single row into the table: "serial_numbers" */
  insert_serial_numbers_one?: Maybe<Serial_Numbers>;
  /** insert data into the table: "short_url" */
  insert_short_url?: Maybe<Short_Url_Mutation_Response>;
  /** insert a single row into the table: "short_url" */
  insert_short_url_one?: Maybe<Short_Url>;
  /** insert data into the table: "system_event" */
  insert_system_event?: Maybe<System_Event_Mutation_Response>;
  /** insert a single row into the table: "system_event" */
  insert_system_event_one?: Maybe<System_Event>;
  /** insert data into the table: "tag_entity" */
  insert_tag_entity?: Maybe<Tag_Entity_Mutation_Response>;
  /** insert a single row into the table: "tag_entity" */
  insert_tag_entity_one?: Maybe<Tag_Entity>;
  /** insert data into the table: "tag_path" */
  insert_tag_path?: Maybe<Tag_Path_Mutation_Response>;
  /** insert a single row into the table: "tag_path" */
  insert_tag_path_one?: Maybe<Tag_Path>;
  /** insert data into the table: "tag_set" */
  insert_tag_set?: Maybe<Tag_Set_Mutation_Response>;
  /** insert a single row into the table: "tag_set" */
  insert_tag_set_one?: Maybe<Tag_Set>;
  /** insert data into the table: "tag_type" */
  insert_tag_type?: Maybe<Tag_Type_Mutation_Response>;
  /** insert a single row into the table: "tag_type" */
  insert_tag_type_one?: Maybe<Tag_Type>;
  /** insert data into the table: "tags" */
  insert_tags?: Maybe<Tags_Mutation_Response>;
  /** insert a single row into the table: "tags" */
  insert_tags_one?: Maybe<Tags>;
  /** insert data into the table: "unit" */
  insert_unit?: Maybe<Unit_Mutation_Response>;
  /** insert a single row into the table: "unit" */
  insert_unit_one?: Maybe<Unit>;
  /** insert data into the table: "unit_product_option_choice" */
  insert_unit_product_option_choice?: Maybe<Unit_Product_Option_Choice_Mutation_Response>;
  /** insert a single row into the table: "unit_product_option_choice" */
  insert_unit_product_option_choice_one?: Maybe<Unit_Product_Option_Choice>;
  /** insert data into the table: "uom" */
  insert_uom?: Maybe<Uom_Mutation_Response>;
  /** insert data into the table: "uom_classification" */
  insert_uom_classification?: Maybe<Uom_Classification_Mutation_Response>;
  /** insert a single row into the table: "uom_classification" */
  insert_uom_classification_one?: Maybe<Uom_Classification>;
  /** insert data into the table: "uom_conversion" */
  insert_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** insert a single row into the table: "uom_conversion" */
  insert_uom_conversion_one?: Maybe<Uom_Conversion>;
  /** insert data into the table: "uom_csi_conversion" */
  insert_uom_csi_conversion?: Maybe<Uom_Csi_Conversion_Mutation_Response>;
  /** insert a single row into the table: "uom_csi_conversion" */
  insert_uom_csi_conversion_one?: Maybe<Uom_Csi_Conversion>;
  /** insert a single row into the table: "uom" */
  insert_uom_one?: Maybe<Uom>;
  /** insert data into the table: "uom_scope" */
  insert_uom_scope?: Maybe<Uom_Scope_Mutation_Response>;
  /** insert a single row into the table: "uom_scope" */
  insert_uom_scope_one?: Maybe<Uom_Scope>;
  /** insert data into the table: "uom_scope_part" */
  insert_uom_scope_part?: Maybe<Uom_Scope_Part_Mutation_Response>;
  /** insert a single row into the table: "uom_scope_part" */
  insert_uom_scope_part_one?: Maybe<Uom_Scope_Part>;
  /** insert data into the table: "uom_system_conversion" */
  insert_uom_system_conversion?: Maybe<Uom_System_Conversion_Mutation_Response>;
  /** insert a single row into the table: "uom_system_conversion" */
  insert_uom_system_conversion_one?: Maybe<Uom_System_Conversion>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_info" */
  insert_user_info?: Maybe<User_Info_Mutation_Response>;
  /** insert a single row into the table: "user_info" */
  insert_user_info_one?: Maybe<User_Info>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_permissions" */
  insert_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** insert a single row into the table: "user_permissions" */
  insert_user_permissions_one?: Maybe<User_Permissions>;
  /** insert data into the table: "user_role" */
  insert_user_role?: Maybe<User_Role_Mutation_Response>;
  /** insert a single row into the table: "user_role" */
  insert_user_role_one?: Maybe<User_Role>;
  /** insert data into the table: "vendor" */
  insert_vendor?: Maybe<Vendor_Mutation_Response>;
  /** insert data into the table: "vendor_cleanup_audit" */
  insert_vendor_cleanup_audit?: Maybe<Vendor_Cleanup_Audit_Mutation_Response>;
  /** insert a single row into the table: "vendor_cleanup_audit" */
  insert_vendor_cleanup_audit_one?: Maybe<Vendor_Cleanup_Audit>;
  /** insert data into the table: "vendor_cleanup_wevr_mapping_lookup" */
  insert_vendor_cleanup_wevr_mapping_lookup?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Mutation_Response>;
  /** insert a single row into the table: "vendor_cleanup_wevr_mapping_lookup" */
  insert_vendor_cleanup_wevr_mapping_lookup_one?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** insert a single row into the table: "vendor" */
  insert_vendor_one?: Maybe<Vendor>;
  /** insert data into the table: "vendor_parts" */
  insert_vendor_parts?: Maybe<Vendor_Parts_Mutation_Response>;
  /** insert a single row into the table: "vendor_parts" */
  insert_vendor_parts_one?: Maybe<Vendor_Parts>;
  /** insert data into the table: "workflow" */
  insert_workflow?: Maybe<Workflow_Mutation_Response>;
  /** insert a single row into the table: "workflow" */
  insert_workflow_one?: Maybe<Workflow>;
  refreshAlgolia?: Maybe<RefreshAlgoliaOutput>;
  sendEmail?: Maybe<EmailOutput>;
  /** update data of the table: "base_product" */
  update_base_product?: Maybe<Base_Product_Mutation_Response>;
  /** update single row of the table: "base_product" */
  update_base_product_by_pk?: Maybe<Base_Product>;
  /** update multiples rows of table: "base_product" */
  update_base_product_many?: Maybe<Array<Maybe<Base_Product_Mutation_Response>>>;
  /** update data of the table: "bom_detail" */
  update_bom_detail?: Maybe<Bom_Detail_Mutation_Response>;
  /** update single row of the table: "bom_detail" */
  update_bom_detail_by_pk?: Maybe<Bom_Detail>;
  /** update multiples rows of table: "bom_detail" */
  update_bom_detail_many?: Maybe<Array<Maybe<Bom_Detail_Mutation_Response>>>;
  /** update data of the table: "bom_item_tag_set" */
  update_bom_item_tag_set?: Maybe<Bom_Item_Tag_Set_Mutation_Response>;
  /** update single row of the table: "bom_item_tag_set" */
  update_bom_item_tag_set_by_pk?: Maybe<Bom_Item_Tag_Set>;
  /** update multiples rows of table: "bom_item_tag_set" */
  update_bom_item_tag_set_many?: Maybe<Array<Maybe<Bom_Item_Tag_Set_Mutation_Response>>>;
  /** update data of the table: "boms_view" */
  update_boms_view?: Maybe<Boms_View_Mutation_Response>;
  /** update multiples rows of table: "boms_view" */
  update_boms_view_many?: Maybe<Array<Maybe<Boms_View_Mutation_Response>>>;
  /** update data of the table: "consumable_bom_detail" */
  update_consumable_bom_detail?: Maybe<Consumable_Bom_Detail_Mutation_Response>;
  /** update single row of the table: "consumable_bom_detail" */
  update_consumable_bom_detail_by_pk?: Maybe<Consumable_Bom_Detail>;
  /** update multiples rows of table: "consumable_bom_detail" */
  update_consumable_bom_detail_many?: Maybe<Array<Maybe<Consumable_Bom_Detail_Mutation_Response>>>;
  /** update data of the table: "counters" */
  update_counters?: Maybe<Counters_Mutation_Response>;
  /** update single row of the table: "counters" */
  update_counters_by_pk?: Maybe<Counters>;
  /** update multiples rows of table: "counters" */
  update_counters_many?: Maybe<Array<Maybe<Counters_Mutation_Response>>>;
  /** update data of the table: "csi" */
  update_csi?: Maybe<Csi_Mutation_Response>;
  /** update single row of the table: "csi" */
  update_csi_by_pk?: Maybe<Csi>;
  /** update multiples rows of table: "csi" */
  update_csi_many?: Maybe<Array<Maybe<Csi_Mutation_Response>>>;
  /** update data of the table: "customer" */
  update_customer?: Maybe<Customer_Mutation_Response>;
  /** update data of the table: "customer_admin" */
  update_customer_admin?: Maybe<Customer_Admin_Mutation_Response>;
  /** update single row of the table: "customer_admin" */
  update_customer_admin_by_pk?: Maybe<Customer_Admin>;
  /** update multiples rows of table: "customer_admin" */
  update_customer_admin_many?: Maybe<Array<Maybe<Customer_Admin_Mutation_Response>>>;
  /** update single row of the table: "customer" */
  update_customer_by_pk?: Maybe<Customer>;
  /** update multiples rows of table: "customer" */
  update_customer_many?: Maybe<Array<Maybe<Customer_Mutation_Response>>>;
  /** update data of the table: "email_templates" */
  update_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** update single row of the table: "email_templates" */
  update_email_templates_by_pk?: Maybe<Email_Templates>;
  /** update multiples rows of table: "email_templates" */
  update_email_templates_many?: Maybe<Array<Maybe<Email_Templates_Mutation_Response>>>;
  /** update data of the table: "emails" */
  update_emails?: Maybe<Emails_Mutation_Response>;
  /** update single row of the table: "emails" */
  update_emails_by_pk?: Maybe<Emails>;
  /** update multiples rows of table: "emails" */
  update_emails_many?: Maybe<Array<Maybe<Emails_Mutation_Response>>>;
  /** update data of the table: "feedback" */
  update_feedback?: Maybe<Feedback_Mutation_Response>;
  /** update single row of the table: "feedback" */
  update_feedback_by_pk?: Maybe<Feedback>;
  /** update multiples rows of table: "feedback" */
  update_feedback_many?: Maybe<Array<Maybe<Feedback_Mutation_Response>>>;
  /** update data of the table: "invitation" */
  update_invitation?: Maybe<Invitation_Mutation_Response>;
  /** update single row of the table: "invitation" */
  update_invitation_by_pk?: Maybe<Invitation>;
  /** update multiples rows of table: "invitation" */
  update_invitation_many?: Maybe<Array<Maybe<Invitation_Mutation_Response>>>;
  /** update data of the table: "issue" */
  update_issue?: Maybe<Issue_Mutation_Response>;
  /** update single row of the table: "issue" */
  update_issue_by_pk?: Maybe<Issue>;
  /** update multiples rows of table: "issue" */
  update_issue_many?: Maybe<Array<Maybe<Issue_Mutation_Response>>>;
  /** update data of the table: "issue_status" */
  update_issue_status?: Maybe<Issue_Status_Mutation_Response>;
  /** update single row of the table: "issue_status" */
  update_issue_status_by_pk?: Maybe<Issue_Status>;
  /** update multiples rows of table: "issue_status" */
  update_issue_status_many?: Maybe<Array<Maybe<Issue_Status_Mutation_Response>>>;
  /** update data of the table: "item_bom" */
  update_item_bom?: Maybe<Item_Bom_Mutation_Response>;
  /** update single row of the table: "item_bom" */
  update_item_bom_by_pk?: Maybe<Item_Bom>;
  /** update multiples rows of table: "item_bom" */
  update_item_bom_many?: Maybe<Array<Maybe<Item_Bom_Mutation_Response>>>;
  /** update data of the table: "item_type" */
  update_item_type?: Maybe<Item_Type_Mutation_Response>;
  /** update single row of the table: "item_type" */
  update_item_type_by_pk?: Maybe<Item_Type>;
  /** update multiples rows of table: "item_type" */
  update_item_type_many?: Maybe<Array<Maybe<Item_Type_Mutation_Response>>>;
  /** update data of the table: "manufacturer" */
  update_manufacturer?: Maybe<Manufacturer_Mutation_Response>;
  /** update single row of the table: "manufacturer" */
  update_manufacturer_by_pk?: Maybe<Manufacturer>;
  /** update multiples rows of table: "manufacturer" */
  update_manufacturer_many?: Maybe<Array<Maybe<Manufacturer_Mutation_Response>>>;
  /** update data of the table: "manufacturer_parts" */
  update_manufacturer_parts?: Maybe<Manufacturer_Parts_Mutation_Response>;
  /** update single row of the table: "manufacturer_parts" */
  update_manufacturer_parts_by_pk?: Maybe<Manufacturer_Parts>;
  /** update multiples rows of table: "manufacturer_parts" */
  update_manufacturer_parts_many?: Maybe<Array<Maybe<Manufacturer_Parts_Mutation_Response>>>;
  /** update data of the table: "milestone" */
  update_milestone?: Maybe<Milestone_Mutation_Response>;
  /** update multiples rows of table: "milestone" */
  update_milestone_many?: Maybe<Array<Maybe<Milestone_Mutation_Response>>>;
  /** update data of the table: "part" */
  update_part?: Maybe<Part_Mutation_Response>;
  /** update single row of the table: "part" */
  update_part_by_pk?: Maybe<Part>;
  /** update multiples rows of table: "part" */
  update_part_many?: Maybe<Array<Maybe<Part_Mutation_Response>>>;
  /** update data of the table: "part_number_history" */
  update_part_number_history?: Maybe<Part_Number_History_Mutation_Response>;
  /** update single row of the table: "part_number_history" */
  update_part_number_history_by_pk?: Maybe<Part_Number_History>;
  /** update multiples rows of table: "part_number_history" */
  update_part_number_history_many?: Maybe<Array<Maybe<Part_Number_History_Mutation_Response>>>;
  /** update data of the table: "part_request" */
  update_part_request?: Maybe<Part_Request_Mutation_Response>;
  /** update single row of the table: "part_request" */
  update_part_request_by_pk?: Maybe<Part_Request>;
  /** update multiples rows of table: "part_request" */
  update_part_request_many?: Maybe<Array<Maybe<Part_Request_Mutation_Response>>>;
  /** update data of the table: "part_request_reason" */
  update_part_request_reason?: Maybe<Part_Request_Reason_Mutation_Response>;
  /** update single row of the table: "part_request_reason" */
  update_part_request_reason_by_pk?: Maybe<Part_Request_Reason>;
  /** update multiples rows of table: "part_request_reason" */
  update_part_request_reason_many?: Maybe<Array<Maybe<Part_Request_Reason_Mutation_Response>>>;
  /** update data of the table: "part_request_status" */
  update_part_request_status?: Maybe<Part_Request_Status_Mutation_Response>;
  /** update single row of the table: "part_request_status" */
  update_part_request_status_by_pk?: Maybe<Part_Request_Status>;
  /** update multiples rows of table: "part_request_status" */
  update_part_request_status_many?: Maybe<Array<Maybe<Part_Request_Status_Mutation_Response>>>;
  /** update data of the table: "part_request_type" */
  update_part_request_type?: Maybe<Part_Request_Type_Mutation_Response>;
  /** update single row of the table: "part_request_type" */
  update_part_request_type_by_pk?: Maybe<Part_Request_Type>;
  /** update multiples rows of table: "part_request_type" */
  update_part_request_type_many?: Maybe<Array<Maybe<Part_Request_Type_Mutation_Response>>>;
  /** update data of the table: "part_status" */
  update_part_status?: Maybe<Part_Status_Mutation_Response>;
  /** update single row of the table: "part_status" */
  update_part_status_by_pk?: Maybe<Part_Status>;
  /** update multiples rows of table: "part_status" */
  update_part_status_many?: Maybe<Array<Maybe<Part_Status_Mutation_Response>>>;
  /** update data of the table: "part_sync" */
  update_part_sync?: Maybe<Part_Sync_Mutation_Response>;
  /** update single row of the table: "part_sync" */
  update_part_sync_by_pk?: Maybe<Part_Sync>;
  /** update multiples rows of table: "part_sync" */
  update_part_sync_many?: Maybe<Array<Maybe<Part_Sync_Mutation_Response>>>;
  /** update data of the table: "part_type" */
  update_part_type?: Maybe<Part_Type_Mutation_Response>;
  /** update single row of the table: "part_type" */
  update_part_type_by_pk?: Maybe<Part_Type>;
  /** update multiples rows of table: "part_type" */
  update_part_type_many?: Maybe<Array<Maybe<Part_Type_Mutation_Response>>>;
  /** update data of the table: "part_warehouse_detail" */
  update_part_warehouse_detail?: Maybe<Part_Warehouse_Detail_Mutation_Response>;
  /** update single row of the table: "part_warehouse_detail" */
  update_part_warehouse_detail_by_pk?: Maybe<Part_Warehouse_Detail>;
  /** update multiples rows of table: "part_warehouse_detail" */
  update_part_warehouse_detail_many?: Maybe<Array<Maybe<Part_Warehouse_Detail_Mutation_Response>>>;
  /** update data of the table: "parts_related" */
  update_parts_related?: Maybe<Parts_Related_Mutation_Response>;
  /** update single row of the table: "parts_related" */
  update_parts_related_by_pk?: Maybe<Parts_Related>;
  /** update multiples rows of table: "parts_related" */
  update_parts_related_many?: Maybe<Array<Maybe<Parts_Related_Mutation_Response>>>;
  /** update data of the table: "permissions" */
  update_permissions?: Maybe<Permissions_Mutation_Response>;
  /** update single row of the table: "permissions" */
  update_permissions_by_pk?: Maybe<Permissions>;
  /** update multiples rows of table: "permissions" */
  update_permissions_many?: Maybe<Array<Maybe<Permissions_Mutation_Response>>>;
  /** update data of the table: "phase" */
  update_phase?: Maybe<Phase_Mutation_Response>;
  /** update single row of the table: "phase" */
  update_phase_by_pk?: Maybe<Phase>;
  /** update multiples rows of table: "phase" */
  update_phase_many?: Maybe<Array<Maybe<Phase_Mutation_Response>>>;
  /** update data of the table: "platform" */
  update_platform?: Maybe<Platform_Mutation_Response>;
  /** update single row of the table: "platform" */
  update_platform_by_pk?: Maybe<Platform>;
  /** update multiples rows of table: "platform" */
  update_platform_many?: Maybe<Array<Maybe<Platform_Mutation_Response>>>;
  /** update data of the table: "platform_requirement" */
  update_platform_requirement?: Maybe<Platform_Requirement_Mutation_Response>;
  /** update single row of the table: "platform_requirement" */
  update_platform_requirement_by_pk?: Maybe<Platform_Requirement>;
  /** update multiples rows of table: "platform_requirement" */
  update_platform_requirement_many?: Maybe<Array<Maybe<Platform_Requirement_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_option" */
  update_product_option?: Maybe<Product_Option_Mutation_Response>;
  /** update single row of the table: "product_option" */
  update_product_option_by_pk?: Maybe<Product_Option>;
  /** update data of the table: "product_option_choice" */
  update_product_option_choice?: Maybe<Product_Option_Choice_Mutation_Response>;
  /** update single row of the table: "product_option_choice" */
  update_product_option_choice_by_pk?: Maybe<Product_Option_Choice>;
  /** update multiples rows of table: "product_option_choice" */
  update_product_option_choice_many?: Maybe<Array<Maybe<Product_Option_Choice_Mutation_Response>>>;
  /** update multiples rows of table: "product_option" */
  update_product_option_many?: Maybe<Array<Maybe<Product_Option_Mutation_Response>>>;
  /** update data of the table: "product_type" */
  update_product_type?: Maybe<Product_Type_Mutation_Response>;
  /** update single row of the table: "product_type" */
  update_product_type_by_pk?: Maybe<Product_Type>;
  /** update multiples rows of table: "product_type" */
  update_product_type_many?: Maybe<Array<Maybe<Product_Type_Mutation_Response>>>;
  /** update data of the table: "program" */
  update_program?: Maybe<Program_Mutation_Response>;
  /** update single row of the table: "program" */
  update_program_by_pk?: Maybe<Program>;
  /** update multiples rows of table: "program" */
  update_program_many?: Maybe<Array<Maybe<Program_Mutation_Response>>>;
  /** update data of the table: "project" */
  update_project?: Maybe<Project_Mutation_Response>;
  /** update data of the table: "project_base_product_quantities" */
  update_project_base_product_quantities?: Maybe<Project_Base_Product_Quantities_Mutation_Response>;
  /** update single row of the table: "project_base_product_quantities" */
  update_project_base_product_quantities_by_pk?: Maybe<Project_Base_Product_Quantities>;
  /** update multiples rows of table: "project_base_product_quantities" */
  update_project_base_product_quantities_many?: Maybe<Array<Maybe<Project_Base_Product_Quantities_Mutation_Response>>>;
  /** update single row of the table: "project" */
  update_project_by_pk?: Maybe<Project>;
  /** update data of the table: "project_comment" */
  update_project_comment?: Maybe<Project_Comment_Mutation_Response>;
  /** update single row of the table: "project_comment" */
  update_project_comment_by_pk?: Maybe<Project_Comment>;
  /** update multiples rows of table: "project_comment" */
  update_project_comment_many?: Maybe<Array<Maybe<Project_Comment_Mutation_Response>>>;
  /** update data of the table: "project_contacts" */
  update_project_contacts?: Maybe<Project_Contacts_Mutation_Response>;
  /** update single row of the table: "project_contacts" */
  update_project_contacts_by_pk?: Maybe<Project_Contacts>;
  /** update multiples rows of table: "project_contacts" */
  update_project_contacts_many?: Maybe<Array<Maybe<Project_Contacts_Mutation_Response>>>;
  /** update multiples rows of table: "project" */
  update_project_many?: Maybe<Array<Maybe<Project_Mutation_Response>>>;
  /** update data of the table: "project_milestone" */
  update_project_milestone?: Maybe<Project_Milestone_Mutation_Response>;
  /** update single row of the table: "project_milestone" */
  update_project_milestone_by_pk?: Maybe<Project_Milestone>;
  /** update multiples rows of table: "project_milestone" */
  update_project_milestone_many?: Maybe<Array<Maybe<Project_Milestone_Mutation_Response>>>;
  /** update data of the table: "project_module" */
  update_project_module?: Maybe<Project_Module_Mutation_Response>;
  /** update single row of the table: "project_module" */
  update_project_module_by_pk?: Maybe<Project_Module>;
  /** update multiples rows of table: "project_module" */
  update_project_module_many?: Maybe<Array<Maybe<Project_Module_Mutation_Response>>>;
  /** update data of the table: "project_status" */
  update_project_status?: Maybe<Project_Status_Mutation_Response>;
  /** update single row of the table: "project_status" */
  update_project_status_by_pk?: Maybe<Project_Status>;
  /** update multiples rows of table: "project_status" */
  update_project_status_many?: Maybe<Array<Maybe<Project_Status_Mutation_Response>>>;
  /** update data of the table: "project_users" */
  update_project_users?: Maybe<Project_Users_Mutation_Response>;
  /** update single row of the table: "project_users" */
  update_project_users_by_pk?: Maybe<Project_Users>;
  /** update multiples rows of table: "project_users" */
  update_project_users_many?: Maybe<Array<Maybe<Project_Users_Mutation_Response>>>;
  /** update data of the table: "purchase_type" */
  update_purchase_type?: Maybe<Purchase_Type_Mutation_Response>;
  /** update single row of the table: "purchase_type" */
  update_purchase_type_by_pk?: Maybe<Purchase_Type>;
  /** update multiples rows of table: "purchase_type" */
  update_purchase_type_many?: Maybe<Array<Maybe<Purchase_Type_Mutation_Response>>>;
  /** update data of the table: "qb_items" */
  update_qb_items?: Maybe<Qb_Items_Mutation_Response>;
  /** update single row of the table: "qb_items" */
  update_qb_items_by_pk?: Maybe<Qb_Items>;
  /** update multiples rows of table: "qb_items" */
  update_qb_items_many?: Maybe<Array<Maybe<Qb_Items_Mutation_Response>>>;
  /** update data of the table: "relation_type" */
  update_relation_type?: Maybe<Relation_Type_Mutation_Response>;
  /** update single row of the table: "relation_type" */
  update_relation_type_by_pk?: Maybe<Relation_Type>;
  /** update multiples rows of table: "relation_type" */
  update_relation_type_many?: Maybe<Array<Maybe<Relation_Type_Mutation_Response>>>;
  /** update data of the table: "report" */
  update_report?: Maybe<Report_Mutation_Response>;
  /** update single row of the table: "report" */
  update_report_by_pk?: Maybe<Report>;
  /** update multiples rows of table: "report" */
  update_report_many?: Maybe<Array<Maybe<Report_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "role_permissions" */
  update_role_permissions?: Maybe<Role_Permissions_Mutation_Response>;
  /** update single row of the table: "role_permissions" */
  update_role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** update multiples rows of table: "role_permissions" */
  update_role_permissions_many?: Maybe<Array<Maybe<Role_Permissions_Mutation_Response>>>;
  /** update data of the table: "serial_numbers" */
  update_serial_numbers?: Maybe<Serial_Numbers_Mutation_Response>;
  /** update single row of the table: "serial_numbers" */
  update_serial_numbers_by_pk?: Maybe<Serial_Numbers>;
  /** update multiples rows of table: "serial_numbers" */
  update_serial_numbers_many?: Maybe<Array<Maybe<Serial_Numbers_Mutation_Response>>>;
  /** update data of the table: "short_url" */
  update_short_url?: Maybe<Short_Url_Mutation_Response>;
  /** update single row of the table: "short_url" */
  update_short_url_by_pk?: Maybe<Short_Url>;
  /** update multiples rows of table: "short_url" */
  update_short_url_many?: Maybe<Array<Maybe<Short_Url_Mutation_Response>>>;
  /** update data of the table: "system_event" */
  update_system_event?: Maybe<System_Event_Mutation_Response>;
  /** update single row of the table: "system_event" */
  update_system_event_by_pk?: Maybe<System_Event>;
  /** update multiples rows of table: "system_event" */
  update_system_event_many?: Maybe<Array<Maybe<System_Event_Mutation_Response>>>;
  /** update data of the table: "tag_entity" */
  update_tag_entity?: Maybe<Tag_Entity_Mutation_Response>;
  /** update single row of the table: "tag_entity" */
  update_tag_entity_by_pk?: Maybe<Tag_Entity>;
  /** update multiples rows of table: "tag_entity" */
  update_tag_entity_many?: Maybe<Array<Maybe<Tag_Entity_Mutation_Response>>>;
  /** update data of the table: "tag_path" */
  update_tag_path?: Maybe<Tag_Path_Mutation_Response>;
  /** update single row of the table: "tag_path" */
  update_tag_path_by_pk?: Maybe<Tag_Path>;
  /** update multiples rows of table: "tag_path" */
  update_tag_path_many?: Maybe<Array<Maybe<Tag_Path_Mutation_Response>>>;
  /** update data of the table: "tag_set" */
  update_tag_set?: Maybe<Tag_Set_Mutation_Response>;
  /** update single row of the table: "tag_set" */
  update_tag_set_by_pk?: Maybe<Tag_Set>;
  /** update multiples rows of table: "tag_set" */
  update_tag_set_many?: Maybe<Array<Maybe<Tag_Set_Mutation_Response>>>;
  /** update data of the table: "tag_type" */
  update_tag_type?: Maybe<Tag_Type_Mutation_Response>;
  /** update single row of the table: "tag_type" */
  update_tag_type_by_pk?: Maybe<Tag_Type>;
  /** update multiples rows of table: "tag_type" */
  update_tag_type_many?: Maybe<Array<Maybe<Tag_Type_Mutation_Response>>>;
  /** update data of the table: "tags" */
  update_tags?: Maybe<Tags_Mutation_Response>;
  /** update single row of the table: "tags" */
  update_tags_by_pk?: Maybe<Tags>;
  /** update multiples rows of table: "tags" */
  update_tags_many?: Maybe<Array<Maybe<Tags_Mutation_Response>>>;
  /** update data of the table: "unit" */
  update_unit?: Maybe<Unit_Mutation_Response>;
  /** update single row of the table: "unit" */
  update_unit_by_pk?: Maybe<Unit>;
  /** update multiples rows of table: "unit" */
  update_unit_many?: Maybe<Array<Maybe<Unit_Mutation_Response>>>;
  /** update data of the table: "unit_product_option_choice" */
  update_unit_product_option_choice?: Maybe<Unit_Product_Option_Choice_Mutation_Response>;
  /** update single row of the table: "unit_product_option_choice" */
  update_unit_product_option_choice_by_pk?: Maybe<Unit_Product_Option_Choice>;
  /** update multiples rows of table: "unit_product_option_choice" */
  update_unit_product_option_choice_many?: Maybe<Array<Maybe<Unit_Product_Option_Choice_Mutation_Response>>>;
  /** update data of the table: "uom" */
  update_uom?: Maybe<Uom_Mutation_Response>;
  /** update single row of the table: "uom" */
  update_uom_by_pk?: Maybe<Uom>;
  /** update data of the table: "uom_classification" */
  update_uom_classification?: Maybe<Uom_Classification_Mutation_Response>;
  /** update single row of the table: "uom_classification" */
  update_uom_classification_by_pk?: Maybe<Uom_Classification>;
  /** update multiples rows of table: "uom_classification" */
  update_uom_classification_many?: Maybe<Array<Maybe<Uom_Classification_Mutation_Response>>>;
  /** update data of the table: "uom_conversion" */
  update_uom_conversion?: Maybe<Uom_Conversion_Mutation_Response>;
  /** update single row of the table: "uom_conversion" */
  update_uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** update multiples rows of table: "uom_conversion" */
  update_uom_conversion_many?: Maybe<Array<Maybe<Uom_Conversion_Mutation_Response>>>;
  /** update data of the table: "uom_csi_conversion" */
  update_uom_csi_conversion?: Maybe<Uom_Csi_Conversion_Mutation_Response>;
  /** update single row of the table: "uom_csi_conversion" */
  update_uom_csi_conversion_by_pk?: Maybe<Uom_Csi_Conversion>;
  /** update multiples rows of table: "uom_csi_conversion" */
  update_uom_csi_conversion_many?: Maybe<Array<Maybe<Uom_Csi_Conversion_Mutation_Response>>>;
  /** update multiples rows of table: "uom" */
  update_uom_many?: Maybe<Array<Maybe<Uom_Mutation_Response>>>;
  /** update data of the table: "uom_scope" */
  update_uom_scope?: Maybe<Uom_Scope_Mutation_Response>;
  /** update single row of the table: "uom_scope" */
  update_uom_scope_by_pk?: Maybe<Uom_Scope>;
  /** update multiples rows of table: "uom_scope" */
  update_uom_scope_many?: Maybe<Array<Maybe<Uom_Scope_Mutation_Response>>>;
  /** update data of the table: "uom_scope_part" */
  update_uom_scope_part?: Maybe<Uom_Scope_Part_Mutation_Response>;
  /** update single row of the table: "uom_scope_part" */
  update_uom_scope_part_by_pk?: Maybe<Uom_Scope_Part>;
  /** update multiples rows of table: "uom_scope_part" */
  update_uom_scope_part_many?: Maybe<Array<Maybe<Uom_Scope_Part_Mutation_Response>>>;
  /** update data of the table: "uom_system_conversion" */
  update_uom_system_conversion?: Maybe<Uom_System_Conversion_Mutation_Response>;
  /** update single row of the table: "uom_system_conversion" */
  update_uom_system_conversion_by_pk?: Maybe<Uom_System_Conversion>;
  /** update multiples rows of table: "uom_system_conversion" */
  update_uom_system_conversion_many?: Maybe<Array<Maybe<Uom_System_Conversion_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_info" */
  update_user_info?: Maybe<User_Info_Mutation_Response>;
  /** update multiples rows of table: "user_info" */
  update_user_info_many?: Maybe<Array<Maybe<User_Info_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_permissions" */
  update_user_permissions?: Maybe<User_Permissions_Mutation_Response>;
  /** update single row of the table: "user_permissions" */
  update_user_permissions_by_pk?: Maybe<User_Permissions>;
  /** update multiples rows of table: "user_permissions" */
  update_user_permissions_many?: Maybe<Array<Maybe<User_Permissions_Mutation_Response>>>;
  /** update data of the table: "user_role" */
  update_user_role?: Maybe<User_Role_Mutation_Response>;
  /** update single row of the table: "user_role" */
  update_user_role_by_pk?: Maybe<User_Role>;
  /** update multiples rows of table: "user_role" */
  update_user_role_many?: Maybe<Array<Maybe<User_Role_Mutation_Response>>>;
  /** update data of the table: "vendor" */
  update_vendor?: Maybe<Vendor_Mutation_Response>;
  /** update single row of the table: "vendor" */
  update_vendor_by_pk?: Maybe<Vendor>;
  /** update data of the table: "vendor_cleanup_audit" */
  update_vendor_cleanup_audit?: Maybe<Vendor_Cleanup_Audit_Mutation_Response>;
  /** update single row of the table: "vendor_cleanup_audit" */
  update_vendor_cleanup_audit_by_pk?: Maybe<Vendor_Cleanup_Audit>;
  /** update multiples rows of table: "vendor_cleanup_audit" */
  update_vendor_cleanup_audit_many?: Maybe<Array<Maybe<Vendor_Cleanup_Audit_Mutation_Response>>>;
  /** update data of the table: "vendor_cleanup_wevr_mapping_lookup" */
  update_vendor_cleanup_wevr_mapping_lookup?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Mutation_Response>;
  /** update single row of the table: "vendor_cleanup_wevr_mapping_lookup" */
  update_vendor_cleanup_wevr_mapping_lookup_by_pk?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** update multiples rows of table: "vendor_cleanup_wevr_mapping_lookup" */
  update_vendor_cleanup_wevr_mapping_lookup_many?: Maybe<Array<Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Mutation_Response>>>;
  /** update multiples rows of table: "vendor" */
  update_vendor_many?: Maybe<Array<Maybe<Vendor_Mutation_Response>>>;
  /** update data of the table: "vendor_parts" */
  update_vendor_parts?: Maybe<Vendor_Parts_Mutation_Response>;
  /** update single row of the table: "vendor_parts" */
  update_vendor_parts_by_pk?: Maybe<Vendor_Parts>;
  /** update multiples rows of table: "vendor_parts" */
  update_vendor_parts_many?: Maybe<Array<Maybe<Vendor_Parts_Mutation_Response>>>;
  /** update data of the table: "workflow" */
  update_workflow?: Maybe<Workflow_Mutation_Response>;
  /** update single row of the table: "workflow" */
  update_workflow_by_pk?: Maybe<Workflow>;
  /** update multiples rows of table: "workflow" */
  update_workflow_many?: Maybe<Array<Maybe<Workflow_Mutation_Response>>>;
  updatechoiceNodes: UpdatechoiceNodesMutationResponse;
  updatecsiNodes: UpdatecsiNodesMutationResponse;
  updatecustomerNodes: UpdatecustomerNodesMutationResponse;
  updateitemNodes: UpdateitemNodesMutationResponse;
  updateorderNodes: UpdateorderNodesMutationResponse;
  updateplatformNodes: UpdateplatformNodesMutationResponse;
  updateproductNodes: UpdateproductNodesMutationResponse;
  updateproductOptionNodes: UpdateproductOptionNodesMutationResponse;
  updateprogramNodes: UpdateprogramNodesMutationResponse;
  updateprojectNodes: UpdateprojectNodesMutationResponse;
  updateunitNodes: UpdateunitNodesMutationResponse;
  updateuomNodes: UpdateuomNodesMutationResponse;
  updateuomScopeNodes: UpdateuomScopeNodesMutationResponse;
  updateuomSupplierNodes: UpdateuomSupplierNodesMutationResponse;
};


/** mutation root */
export type Mutation_RootCreateBomVersionArgs = {
  criteria: BomVersionCriteria;
};


/** mutation root */
export type Mutation_RootCreateItemTagArgs = {
  CreateItemTagInput: CreateItemTagInput;
};


/** mutation root */
export type Mutation_RootCreateTagArgs = {
  createTagInput: CreateTagInput;
};


/** mutation root */
export type Mutation_RootCreateTagTypeArgs = {
  CreateTagTypeInput: CreateTagTypeInput;
};


/** mutation root */
export type Mutation_RootUpdateItemTagArgs = {
  UpdateItemTagInput: UpdateItemTagInput;
};


/** mutation root */
export type Mutation_RootUpdateTagArgs = {
  UpdateTagInput: UpdateTagInput;
};


/** mutation root */
export type Mutation_RootAssignNewPartNumberArgs = {
  partId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCloneUnmodeledBomArgs = {
  input: CloneUnmodeledBomInput;
};


/** mutation root */
export type Mutation_RootCreatechoiceNodesArgs = {
  input: Array<ChoiceNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreatecsiNodesArgs = {
  input: Array<CsiNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreatecustomerNodesArgs = {
  input: Array<CustomerNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateitemNodesArgs = {
  input: Array<ItemNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateorderNodesArgs = {
  input: Array<OrderNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateplatformNodesArgs = {
  input: Array<PlatformNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateproductNodesArgs = {
  input: Array<ProductNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateproductOptionNodesArgs = {
  input: Array<ProductOptionNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateprogramNodesArgs = {
  input: Array<ProgramNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateprojectNodesArgs = {
  input: Array<ProjectNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateunitNodesArgs = {
  input: Array<UnitNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateuomNodesArgs = {
  input: Array<UomNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateuomScopeNodesArgs = {
  input: Array<UomScopeNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootCreateuomSupplierNodesArgs = {
  input: Array<UomSupplierNodeCreateInput>;
};


/** mutation root */
export type Mutation_RootDelete_Base_ProductArgs = {
  where: Base_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Base_Product_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Bom_DetailArgs = {
  where: Bom_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bom_Detail_By_PkArgs = {
  partId: Scalars['String'];
  productId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Bom_Item_Tag_SetArgs = {
  where: Bom_Item_Tag_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bom_Item_Tag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Boms_ViewArgs = {
  where: Boms_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumable_Bom_DetailArgs = {
  where: Consumable_Bom_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consumable_Bom_Detail_By_PkArgs = {
  baseProductId: Scalars['String'];
  partId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CountersArgs = {
  where: Counters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Counters_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CsiArgs = {
  where: Csi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Csi_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CustomerArgs = {
  where: Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_AdminArgs = {
  where: Customer_Admin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Customer_Admin_By_PkArgs = {
  customerId: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Customer_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Email_TemplatesArgs = {
  where: Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_EmailsArgs = {
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emails_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FeedbackArgs = {
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Feedback_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InvitationArgs = {
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invitation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_IssueArgs = {
  where: Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Issue_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Issue_StatusArgs = {
  where: Issue_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Issue_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Item_BomArgs = {
  where: Item_Bom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Item_Bom_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Item_TypeArgs = {
  where: Item_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Item_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ManufacturerArgs = {
  where: Manufacturer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_PartsArgs = {
  where: Manufacturer_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Manufacturer_Parts_By_PkArgs = {
  manufacturerId: Scalars['String'];
  partId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_MilestoneArgs = {
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_PartArgs = {
  where: Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_Number_HistoryArgs = {
  where: Part_Number_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Number_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Part_RequestArgs = {
  where: Part_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_ReasonArgs = {
  where: Part_Request_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_Reason_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_StatusArgs = {
  where: Part_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_TypeArgs = {
  where: Part_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Request_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_StatusArgs = {
  where: Part_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Status_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_SyncArgs = {
  where: Part_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Sync_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Part_TypeArgs = {
  where: Part_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Part_Warehouse_DetailArgs = {
  where: Part_Warehouse_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Part_Warehouse_Detail_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Parts_RelatedArgs = {
  where: Parts_Related_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Parts_Related_By_PkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PermissionsArgs = {
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Permissions_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PhaseArgs = {
  where: Phase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phase_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PlatformArgs = {
  where: Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Platform_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Platform_RequirementArgs = {
  where: Platform_Requirement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Platform_Requirement_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Product_OptionArgs = {
  where: Product_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Option_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Product_Option_ChoiceArgs = {
  where: Product_Option_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Option_Choice_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Product_TypeArgs = {
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProgramArgs = {
  where: Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Program_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ProjectArgs = {
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Base_Product_QuantitiesArgs = {
  where: Project_Base_Product_Quantities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Base_Product_Quantities_By_PkArgs = {
  base_product_id: Scalars['String'];
  project_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_CommentArgs = {
  where: Project_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ContactsArgs = {
  where: Project_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_MilestoneArgs = {
  where: Project_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_ModuleArgs = {
  where: Project_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Module_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Project_StatusArgs = {
  where: Project_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Status_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Project_UsersArgs = {
  where: Project_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Project_Users_By_PkArgs = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Purchase_TypeArgs = {
  where: Purchase_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Purchase_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Qb_ItemsArgs = {
  where: Qb_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Qb_Items_By_PkArgs = {
  item: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Relation_TypeArgs = {
  where: Relation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Relation_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ReportArgs = {
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Report_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Role_PermissionsArgs = {
  where: Role_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  roleId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Serial_NumbersArgs = {
  where: Serial_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Serial_Numbers_By_PkArgs = {
  base_product_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Short_UrlArgs = {
  where: Short_Url_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Short_Url_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_System_EventArgs = {
  where: System_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_System_Event_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_EntityArgs = {
  where: Tag_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_PathArgs = {
  where: Tag_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Path_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_SetArgs = {
  where: Tag_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_TypeArgs = {
  where: Tag_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Type_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TagsArgs = {
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tags_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UnitArgs = {
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Unit_Product_Option_ChoiceArgs = {
  where: Unit_Product_Option_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Unit_Product_Option_Choice_By_PkArgs = {
  product_option_choice_id: Scalars['String'];
  unit_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UomArgs = {
  where: Uom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_ClassificationArgs = {
  where: Uom_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Classification_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_ConversionArgs = {
  where: Uom_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_Csi_ConversionArgs = {
  where: Uom_Csi_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Csi_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_ScopeArgs = {
  where: Uom_Scope_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Scope_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_Scope_PartArgs = {
  where: Uom_Scope_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_Scope_Part_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Uom_System_ConversionArgs = {
  where: Uom_System_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uom_System_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_InfoArgs = {
  where: User_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_PermissionsArgs = {
  where: User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_RoleArgs = {
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Role_By_PkArgs = {
  roleId: Scalars['String'];
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_VendorArgs = {
  where: Vendor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Cleanup_AuditArgs = {
  where: Vendor_Cleanup_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Cleanup_Audit_By_PkArgs = {
  id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Cleanup_Wevr_Mapping_LookupArgs = {
  where: Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Cleanup_Wevr_Mapping_Lookup_By_PkArgs = {
  matapp_vendor_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Vendor_PartsArgs = {
  where: Vendor_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Vendor_Parts_By_PkArgs = {
  partId: Scalars['String'];
  vendorId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_WorkflowArgs = {
  where: Workflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Workflow_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeletechoiceNodesArgs = {
  delete?: InputMaybe<ChoiceNodeDeleteInput>;
  where?: InputMaybe<ChoiceNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeletecsiNodesArgs = {
  delete?: InputMaybe<CsiNodeDeleteInput>;
  where?: InputMaybe<CsiNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeletecustomerNodesArgs = {
  delete?: InputMaybe<CustomerNodeDeleteInput>;
  where?: InputMaybe<CustomerNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteitemNodesArgs = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<ItemNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteorderNodesArgs = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<OrderNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteplatformNodesArgs = {
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  where?: InputMaybe<PlatformNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteproductNodesArgs = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<ProductNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteproductOptionNodesArgs = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteprogramNodesArgs = {
  delete?: InputMaybe<ProgramNodeDeleteInput>;
  where?: InputMaybe<ProgramNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteprojectNodesArgs = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteunitNodesArgs = {
  delete?: InputMaybe<UnitNodeDeleteInput>;
  where?: InputMaybe<UnitNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteuomNodesArgs = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteuomScopeNodesArgs = {
  delete?: InputMaybe<UomScopeNodeDeleteInput>;
  where?: InputMaybe<UomScopeNodeWhere>;
};


/** mutation root */
export type Mutation_RootDeleteuomSupplierNodesArgs = {
  delete?: InputMaybe<UomSupplierNodeDeleteInput>;
  where?: InputMaybe<UomSupplierNodeWhere>;
};


/** mutation root */
export type Mutation_RootFileUploadArgs = {
  base64str: Scalars['String'];
  metadata?: InputMaybe<Scalars['jsonb']>;
  name: Scalars['String'];
  randomize?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_Base_ProductArgs = {
  objects: Array<Base_Product_Insert_Input>;
  on_conflict?: InputMaybe<Base_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Base_Product_OneArgs = {
  object: Base_Product_Insert_Input;
  on_conflict?: InputMaybe<Base_Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bom_DetailArgs = {
  objects: Array<Bom_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Bom_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bom_Detail_OneArgs = {
  object: Bom_Detail_Insert_Input;
  on_conflict?: InputMaybe<Bom_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bom_Item_Tag_SetArgs = {
  objects: Array<Bom_Item_Tag_Set_Insert_Input>;
  on_conflict?: InputMaybe<Bom_Item_Tag_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bom_Item_Tag_Set_OneArgs = {
  object: Bom_Item_Tag_Set_Insert_Input;
  on_conflict?: InputMaybe<Bom_Item_Tag_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Boms_ViewArgs = {
  objects: Array<Boms_View_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Boms_View_OneArgs = {
  object: Boms_View_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Consumable_Bom_DetailArgs = {
  objects: Array<Consumable_Bom_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Consumable_Bom_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consumable_Bom_Detail_OneArgs = {
  object: Consumable_Bom_Detail_Insert_Input;
  on_conflict?: InputMaybe<Consumable_Bom_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountersArgs = {
  objects: Array<Counters_Insert_Input>;
  on_conflict?: InputMaybe<Counters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Counters_OneArgs = {
  object: Counters_Insert_Input;
  on_conflict?: InputMaybe<Counters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CsiArgs = {
  objects: Array<Csi_Insert_Input>;
  on_conflict?: InputMaybe<Csi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Csi_OneArgs = {
  object: Csi_Insert_Input;
  on_conflict?: InputMaybe<Csi_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CustomerArgs = {
  objects: Array<Customer_Insert_Input>;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_AdminArgs = {
  objects: Array<Customer_Admin_Insert_Input>;
  on_conflict?: InputMaybe<Customer_Admin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_Admin_OneArgs = {
  object: Customer_Admin_Insert_Input;
  on_conflict?: InputMaybe<Customer_Admin_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Customer_OneArgs = {
  object: Customer_Insert_Input;
  on_conflict?: InputMaybe<Customer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_TemplatesArgs = {
  objects: Array<Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_OneArgs = {
  object: Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmailsArgs = {
  objects: Array<Emails_Insert_Input>;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emails_OneArgs = {
  object: Emails_Insert_Input;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FeedbackArgs = {
  objects: Array<Feedback_Insert_Input>;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Feedback_OneArgs = {
  object: Feedback_Insert_Input;
  on_conflict?: InputMaybe<Feedback_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationArgs = {
  objects: Array<Invitation_Insert_Input>;
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitation_OneArgs = {
  object: Invitation_Insert_Input;
  on_conflict?: InputMaybe<Invitation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IssueArgs = {
  objects: Array<Issue_Insert_Input>;
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_OneArgs = {
  object: Issue_Insert_Input;
  on_conflict?: InputMaybe<Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_StatusArgs = {
  objects: Array<Issue_Status_Insert_Input>;
  on_conflict?: InputMaybe<Issue_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Issue_Status_OneArgs = {
  object: Issue_Status_Insert_Input;
  on_conflict?: InputMaybe<Issue_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Item_BomArgs = {
  objects: Array<Item_Bom_Insert_Input>;
  on_conflict?: InputMaybe<Item_Bom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Item_Bom_OneArgs = {
  object: Item_Bom_Insert_Input;
  on_conflict?: InputMaybe<Item_Bom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Item_TypeArgs = {
  objects: Array<Item_Type_Insert_Input>;
  on_conflict?: InputMaybe<Item_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Item_Type_OneArgs = {
  object: Item_Type_Insert_Input;
  on_conflict?: InputMaybe<Item_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ManufacturerArgs = {
  objects: Array<Manufacturer_Insert_Input>;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_OneArgs = {
  object: Manufacturer_Insert_Input;
  on_conflict?: InputMaybe<Manufacturer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_PartsArgs = {
  objects: Array<Manufacturer_Parts_Insert_Input>;
  on_conflict?: InputMaybe<Manufacturer_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Manufacturer_Parts_OneArgs = {
  object: Manufacturer_Parts_Insert_Input;
  on_conflict?: InputMaybe<Manufacturer_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MilestoneArgs = {
  objects: Array<Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Milestone_OneArgs = {
  object: Milestone_Insert_Input;
  on_conflict?: InputMaybe<Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PartArgs = {
  objects: Array<Part_Insert_Input>;
  on_conflict?: InputMaybe<Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Number_HistoryArgs = {
  objects: Array<Part_Number_History_Insert_Input>;
  on_conflict?: InputMaybe<Part_Number_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Number_History_OneArgs = {
  object: Part_Number_History_Insert_Input;
  on_conflict?: InputMaybe<Part_Number_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_OneArgs = {
  object: Part_Insert_Input;
  on_conflict?: InputMaybe<Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_RequestArgs = {
  objects: Array<Part_Request_Insert_Input>;
  on_conflict?: InputMaybe<Part_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_OneArgs = {
  object: Part_Request_Insert_Input;
  on_conflict?: InputMaybe<Part_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_ReasonArgs = {
  objects: Array<Part_Request_Reason_Insert_Input>;
  on_conflict?: InputMaybe<Part_Request_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_Reason_OneArgs = {
  object: Part_Request_Reason_Insert_Input;
  on_conflict?: InputMaybe<Part_Request_Reason_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_StatusArgs = {
  objects: Array<Part_Request_Status_Insert_Input>;
  on_conflict?: InputMaybe<Part_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_Status_OneArgs = {
  object: Part_Request_Status_Insert_Input;
  on_conflict?: InputMaybe<Part_Request_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_TypeArgs = {
  objects: Array<Part_Request_Type_Insert_Input>;
  on_conflict?: InputMaybe<Part_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Request_Type_OneArgs = {
  object: Part_Request_Type_Insert_Input;
  on_conflict?: InputMaybe<Part_Request_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_StatusArgs = {
  objects: Array<Part_Status_Insert_Input>;
  on_conflict?: InputMaybe<Part_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Status_OneArgs = {
  object: Part_Status_Insert_Input;
  on_conflict?: InputMaybe<Part_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_SyncArgs = {
  objects: Array<Part_Sync_Insert_Input>;
  on_conflict?: InputMaybe<Part_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Sync_OneArgs = {
  object: Part_Sync_Insert_Input;
  on_conflict?: InputMaybe<Part_Sync_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_TypeArgs = {
  objects: Array<Part_Type_Insert_Input>;
  on_conflict?: InputMaybe<Part_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Type_OneArgs = {
  object: Part_Type_Insert_Input;
  on_conflict?: InputMaybe<Part_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Warehouse_DetailArgs = {
  objects: Array<Part_Warehouse_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Part_Warehouse_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Part_Warehouse_Detail_OneArgs = {
  object: Part_Warehouse_Detail_Insert_Input;
  on_conflict?: InputMaybe<Part_Warehouse_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parts_RelatedArgs = {
  objects: Array<Parts_Related_Insert_Input>;
  on_conflict?: InputMaybe<Parts_Related_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Parts_Related_OneArgs = {
  object: Parts_Related_Insert_Input;
  on_conflict?: InputMaybe<Parts_Related_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PermissionsArgs = {
  objects: Array<Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Permissions_OneArgs = {
  object: Permissions_Insert_Input;
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PhaseArgs = {
  objects: Array<Phase_Insert_Input>;
  on_conflict?: InputMaybe<Phase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phase_OneArgs = {
  object: Phase_Insert_Input;
  on_conflict?: InputMaybe<Phase_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlatformArgs = {
  objects: Array<Platform_Insert_Input>;
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_OneArgs = {
  object: Platform_Insert_Input;
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_RequirementArgs = {
  objects: Array<Platform_Requirement_Insert_Input>;
  on_conflict?: InputMaybe<Platform_Requirement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_Requirement_OneArgs = {
  object: Platform_Requirement_Insert_Input;
  on_conflict?: InputMaybe<Platform_Requirement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OptionArgs = {
  objects: Array<Product_Option_Insert_Input>;
  on_conflict?: InputMaybe<Product_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Option_ChoiceArgs = {
  objects: Array<Product_Option_Choice_Insert_Input>;
  on_conflict?: InputMaybe<Product_Option_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Option_Choice_OneArgs = {
  object: Product_Option_Choice_Insert_Input;
  on_conflict?: InputMaybe<Product_Option_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Option_OneArgs = {
  object: Product_Option_Insert_Input;
  on_conflict?: InputMaybe<Product_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_TypeArgs = {
  objects: Array<Product_Type_Insert_Input>;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Type_OneArgs = {
  object: Product_Type_Insert_Input;
  on_conflict?: InputMaybe<Product_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProgramArgs = {
  objects: Array<Program_Insert_Input>;
  on_conflict?: InputMaybe<Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Program_OneArgs = {
  object: Program_Insert_Input;
  on_conflict?: InputMaybe<Program_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProjectArgs = {
  objects: Array<Project_Insert_Input>;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Base_Product_QuantitiesArgs = {
  objects: Array<Project_Base_Product_Quantities_Insert_Input>;
  on_conflict?: InputMaybe<Project_Base_Product_Quantities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Base_Product_Quantities_OneArgs = {
  object: Project_Base_Product_Quantities_Insert_Input;
  on_conflict?: InputMaybe<Project_Base_Product_Quantities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_CommentArgs = {
  objects: Array<Project_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Comment_OneArgs = {
  object: Project_Comment_Insert_Input;
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ContactsArgs = {
  objects: Array<Project_Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Project_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Contacts_OneArgs = {
  object: Project_Contacts_Insert_Input;
  on_conflict?: InputMaybe<Project_Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_MilestoneArgs = {
  objects: Array<Project_Milestone_Insert_Input>;
  on_conflict?: InputMaybe<Project_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Milestone_OneArgs = {
  object: Project_Milestone_Insert_Input;
  on_conflict?: InputMaybe<Project_Milestone_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_ModuleArgs = {
  objects: Array<Project_Module_Insert_Input>;
  on_conflict?: InputMaybe<Project_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Module_OneArgs = {
  object: Project_Module_Insert_Input;
  on_conflict?: InputMaybe<Project_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_OneArgs = {
  object: Project_Insert_Input;
  on_conflict?: InputMaybe<Project_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_StatusArgs = {
  objects: Array<Project_Status_Insert_Input>;
  on_conflict?: InputMaybe<Project_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Status_OneArgs = {
  object: Project_Status_Insert_Input;
  on_conflict?: InputMaybe<Project_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_UsersArgs = {
  objects: Array<Project_Users_Insert_Input>;
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Project_Users_OneArgs = {
  object: Project_Users_Insert_Input;
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_TypeArgs = {
  objects: Array<Purchase_Type_Insert_Input>;
  on_conflict?: InputMaybe<Purchase_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Purchase_Type_OneArgs = {
  object: Purchase_Type_Insert_Input;
  on_conflict?: InputMaybe<Purchase_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qb_ItemsArgs = {
  objects: Array<Qb_Items_Insert_Input>;
  on_conflict?: InputMaybe<Qb_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Qb_Items_OneArgs = {
  object: Qb_Items_Insert_Input;
  on_conflict?: InputMaybe<Qb_Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relation_TypeArgs = {
  objects: Array<Relation_Type_Insert_Input>;
  on_conflict?: InputMaybe<Relation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Relation_Type_OneArgs = {
  object: Relation_Type_Insert_Input;
  on_conflict?: InputMaybe<Relation_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReportArgs = {
  objects: Array<Report_Insert_Input>;
  on_conflict?: InputMaybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Report_OneArgs = {
  object: Report_Insert_Input;
  on_conflict?: InputMaybe<Report_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_PermissionsArgs = {
  objects: Array<Role_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_Permissions_OneArgs = {
  object: Role_Permissions_Insert_Input;
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Serial_NumbersArgs = {
  objects: Array<Serial_Numbers_Insert_Input>;
  on_conflict?: InputMaybe<Serial_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Serial_Numbers_OneArgs = {
  object: Serial_Numbers_Insert_Input;
  on_conflict?: InputMaybe<Serial_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Short_UrlArgs = {
  objects: Array<Short_Url_Insert_Input>;
  on_conflict?: InputMaybe<Short_Url_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Short_Url_OneArgs = {
  object: Short_Url_Insert_Input;
  on_conflict?: InputMaybe<Short_Url_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_EventArgs = {
  objects: Array<System_Event_Insert_Input>;
  on_conflict?: InputMaybe<System_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_System_Event_OneArgs = {
  object: System_Event_Insert_Input;
  on_conflict?: InputMaybe<System_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_EntityArgs = {
  objects: Array<Tag_Entity_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Entity_OneArgs = {
  object: Tag_Entity_Insert_Input;
  on_conflict?: InputMaybe<Tag_Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_PathArgs = {
  objects: Array<Tag_Path_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Path_OneArgs = {
  object: Tag_Path_Insert_Input;
  on_conflict?: InputMaybe<Tag_Path_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_SetArgs = {
  objects: Array<Tag_Set_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Set_OneArgs = {
  object: Tag_Set_Insert_Input;
  on_conflict?: InputMaybe<Tag_Set_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_TypeArgs = {
  objects: Array<Tag_Type_Insert_Input>;
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Type_OneArgs = {
  object: Tag_Type_Insert_Input;
  on_conflict?: InputMaybe<Tag_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TagsArgs = {
  objects: Array<Tags_Insert_Input>;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tags_OneArgs = {
  object: Tags_Insert_Input;
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UnitArgs = {
  objects: Array<Unit_Insert_Input>;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_OneArgs = {
  object: Unit_Insert_Input;
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Product_Option_ChoiceArgs = {
  objects: Array<Unit_Product_Option_Choice_Insert_Input>;
  on_conflict?: InputMaybe<Unit_Product_Option_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Unit_Product_Option_Choice_OneArgs = {
  object: Unit_Product_Option_Choice_Insert_Input;
  on_conflict?: InputMaybe<Unit_Product_Option_Choice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UomArgs = {
  objects: Array<Uom_Insert_Input>;
  on_conflict?: InputMaybe<Uom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_ClassificationArgs = {
  objects: Array<Uom_Classification_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Classification_OneArgs = {
  object: Uom_Classification_Insert_Input;
  on_conflict?: InputMaybe<Uom_Classification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_ConversionArgs = {
  objects: Array<Uom_Conversion_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Conversion_OneArgs = {
  object: Uom_Conversion_Insert_Input;
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Csi_ConversionArgs = {
  objects: Array<Uom_Csi_Conversion_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Csi_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Csi_Conversion_OneArgs = {
  object: Uom_Csi_Conversion_Insert_Input;
  on_conflict?: InputMaybe<Uom_Csi_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_OneArgs = {
  object: Uom_Insert_Input;
  on_conflict?: InputMaybe<Uom_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_ScopeArgs = {
  objects: Array<Uom_Scope_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Scope_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Scope_OneArgs = {
  object: Uom_Scope_Insert_Input;
  on_conflict?: InputMaybe<Uom_Scope_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Scope_PartArgs = {
  objects: Array<Uom_Scope_Part_Insert_Input>;
  on_conflict?: InputMaybe<Uom_Scope_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_Scope_Part_OneArgs = {
  object: Uom_Scope_Part_Insert_Input;
  on_conflict?: InputMaybe<Uom_Scope_Part_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_System_ConversionArgs = {
  objects: Array<Uom_System_Conversion_Insert_Input>;
  on_conflict?: InputMaybe<Uom_System_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uom_System_Conversion_OneArgs = {
  object: Uom_System_Conversion_Insert_Input;
  on_conflict?: InputMaybe<Uom_System_Conversion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_InfoArgs = {
  objects: Array<User_Info_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_User_Info_OneArgs = {
  object: User_Info_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PermissionsArgs = {
  objects: Array<User_Permissions_Insert_Input>;
  on_conflict?: InputMaybe<User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permissions_OneArgs = {
  object: User_Permissions_Insert_Input;
  on_conflict?: InputMaybe<User_Permissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_RoleArgs = {
  objects: Array<User_Role_Insert_Input>;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Role_OneArgs = {
  object: User_Role_Insert_Input;
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VendorArgs = {
  objects: Array<Vendor_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Cleanup_AuditArgs = {
  objects: Array<Vendor_Cleanup_Audit_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Cleanup_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Cleanup_Audit_OneArgs = {
  object: Vendor_Cleanup_Audit_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Cleanup_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Cleanup_Wevr_Mapping_LookupArgs = {
  objects: Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Cleanup_Wevr_Mapping_Lookup_OneArgs = {
  object: Vendor_Cleanup_Wevr_Mapping_Lookup_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_OneArgs = {
  object: Vendor_Insert_Input;
  on_conflict?: InputMaybe<Vendor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_PartsArgs = {
  objects: Array<Vendor_Parts_Insert_Input>;
  on_conflict?: InputMaybe<Vendor_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Vendor_Parts_OneArgs = {
  object: Vendor_Parts_Insert_Input;
  on_conflict?: InputMaybe<Vendor_Parts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WorkflowArgs = {
  objects: Array<Workflow_Insert_Input>;
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Workflow_OneArgs = {
  object: Workflow_Insert_Input;
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootSendEmailArgs = {
  email: EmailInput;
};


/** mutation root */
export type Mutation_RootUpdate_Base_ProductArgs = {
  _append?: InputMaybe<Base_Product_Append_Input>;
  _delete_at_path?: InputMaybe<Base_Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_Product_Delete_Key_Input>;
  _inc?: InputMaybe<Base_Product_Inc_Input>;
  _prepend?: InputMaybe<Base_Product_Prepend_Input>;
  _set?: InputMaybe<Base_Product_Set_Input>;
  where: Base_Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Product_By_PkArgs = {
  _append?: InputMaybe<Base_Product_Append_Input>;
  _delete_at_path?: InputMaybe<Base_Product_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Base_Product_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Base_Product_Delete_Key_Input>;
  _inc?: InputMaybe<Base_Product_Inc_Input>;
  _prepend?: InputMaybe<Base_Product_Prepend_Input>;
  _set?: InputMaybe<Base_Product_Set_Input>;
  pk_columns: Base_Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Base_Product_ManyArgs = {
  updates: Array<Base_Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_DetailArgs = {
  _append?: InputMaybe<Bom_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Bom_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Bom_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Bom_Detail_Delete_Key_Input>;
  _inc?: InputMaybe<Bom_Detail_Inc_Input>;
  _prepend?: InputMaybe<Bom_Detail_Prepend_Input>;
  _set?: InputMaybe<Bom_Detail_Set_Input>;
  where: Bom_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_Detail_By_PkArgs = {
  _append?: InputMaybe<Bom_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Bom_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Bom_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Bom_Detail_Delete_Key_Input>;
  _inc?: InputMaybe<Bom_Detail_Inc_Input>;
  _prepend?: InputMaybe<Bom_Detail_Prepend_Input>;
  _set?: InputMaybe<Bom_Detail_Set_Input>;
  pk_columns: Bom_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_Detail_ManyArgs = {
  updates: Array<Bom_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_Item_Tag_SetArgs = {
  _inc?: InputMaybe<Bom_Item_Tag_Set_Inc_Input>;
  _set?: InputMaybe<Bom_Item_Tag_Set_Set_Input>;
  where: Bom_Item_Tag_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_Item_Tag_Set_By_PkArgs = {
  _inc?: InputMaybe<Bom_Item_Tag_Set_Inc_Input>;
  _set?: InputMaybe<Bom_Item_Tag_Set_Set_Input>;
  pk_columns: Bom_Item_Tag_Set_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bom_Item_Tag_Set_ManyArgs = {
  updates: Array<Bom_Item_Tag_Set_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Boms_ViewArgs = {
  _append?: InputMaybe<Boms_View_Append_Input>;
  _delete_at_path?: InputMaybe<Boms_View_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Boms_View_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Boms_View_Delete_Key_Input>;
  _inc?: InputMaybe<Boms_View_Inc_Input>;
  _prepend?: InputMaybe<Boms_View_Prepend_Input>;
  _set?: InputMaybe<Boms_View_Set_Input>;
  where: Boms_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Boms_View_ManyArgs = {
  updates: Array<Boms_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consumable_Bom_DetailArgs = {
  _append?: InputMaybe<Consumable_Bom_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Consumable_Bom_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consumable_Bom_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consumable_Bom_Detail_Delete_Key_Input>;
  _inc?: InputMaybe<Consumable_Bom_Detail_Inc_Input>;
  _prepend?: InputMaybe<Consumable_Bom_Detail_Prepend_Input>;
  _set?: InputMaybe<Consumable_Bom_Detail_Set_Input>;
  where: Consumable_Bom_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consumable_Bom_Detail_By_PkArgs = {
  _append?: InputMaybe<Consumable_Bom_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Consumable_Bom_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consumable_Bom_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consumable_Bom_Detail_Delete_Key_Input>;
  _inc?: InputMaybe<Consumable_Bom_Detail_Inc_Input>;
  _prepend?: InputMaybe<Consumable_Bom_Detail_Prepend_Input>;
  _set?: InputMaybe<Consumable_Bom_Detail_Set_Input>;
  pk_columns: Consumable_Bom_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consumable_Bom_Detail_ManyArgs = {
  updates: Array<Consumable_Bom_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountersArgs = {
  _inc?: InputMaybe<Counters_Inc_Input>;
  _set?: InputMaybe<Counters_Set_Input>;
  where: Counters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Counters_By_PkArgs = {
  _inc?: InputMaybe<Counters_Inc_Input>;
  _set?: InputMaybe<Counters_Set_Input>;
  pk_columns: Counters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Counters_ManyArgs = {
  updates: Array<Counters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CsiArgs = {
  _set?: InputMaybe<Csi_Set_Input>;
  where: Csi_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Csi_By_PkArgs = {
  _set?: InputMaybe<Csi_Set_Input>;
  pk_columns: Csi_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Csi_ManyArgs = {
  updates: Array<Csi_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CustomerArgs = {
  _set?: InputMaybe<Customer_Set_Input>;
  where: Customer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_AdminArgs = {
  _set?: InputMaybe<Customer_Admin_Set_Input>;
  where: Customer_Admin_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Admin_By_PkArgs = {
  _set?: InputMaybe<Customer_Admin_Set_Input>;
  pk_columns: Customer_Admin_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_Admin_ManyArgs = {
  updates: Array<Customer_Admin_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_By_PkArgs = {
  _set?: InputMaybe<Customer_Set_Input>;
  pk_columns: Customer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Customer_ManyArgs = {
  updates: Array<Customer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_TemplatesArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  where: Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_By_PkArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  pk_columns: Email_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_ManyArgs = {
  updates: Array<Email_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EmailsArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_By_PkArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  pk_columns: Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_ManyArgs = {
  updates: Array<Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FeedbackArgs = {
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  where: Feedback_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_By_PkArgs = {
  _inc?: InputMaybe<Feedback_Inc_Input>;
  _set?: InputMaybe<Feedback_Set_Input>;
  pk_columns: Feedback_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Feedback_ManyArgs = {
  updates: Array<Feedback_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationArgs = {
  _append?: InputMaybe<Invitation_Append_Input>;
  _delete_at_path?: InputMaybe<Invitation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invitation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invitation_Delete_Key_Input>;
  _prepend?: InputMaybe<Invitation_Prepend_Input>;
  _set?: InputMaybe<Invitation_Set_Input>;
  where: Invitation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_By_PkArgs = {
  _append?: InputMaybe<Invitation_Append_Input>;
  _delete_at_path?: InputMaybe<Invitation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invitation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invitation_Delete_Key_Input>;
  _prepend?: InputMaybe<Invitation_Prepend_Input>;
  _set?: InputMaybe<Invitation_Set_Input>;
  pk_columns: Invitation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitation_ManyArgs = {
  updates: Array<Invitation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IssueArgs = {
  _append?: InputMaybe<Issue_Append_Input>;
  _delete_at_path?: InputMaybe<Issue_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Issue_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Issue_Delete_Key_Input>;
  _inc?: InputMaybe<Issue_Inc_Input>;
  _prepend?: InputMaybe<Issue_Prepend_Input>;
  _set?: InputMaybe<Issue_Set_Input>;
  where: Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_By_PkArgs = {
  _append?: InputMaybe<Issue_Append_Input>;
  _delete_at_path?: InputMaybe<Issue_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Issue_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Issue_Delete_Key_Input>;
  _inc?: InputMaybe<Issue_Inc_Input>;
  _prepend?: InputMaybe<Issue_Prepend_Input>;
  _set?: InputMaybe<Issue_Set_Input>;
  pk_columns: Issue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_ManyArgs = {
  updates: Array<Issue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_StatusArgs = {
  _set?: InputMaybe<Issue_Status_Set_Input>;
  where: Issue_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_Status_By_PkArgs = {
  _set?: InputMaybe<Issue_Status_Set_Input>;
  pk_columns: Issue_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Issue_Status_ManyArgs = {
  updates: Array<Issue_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Item_BomArgs = {
  _append?: InputMaybe<Item_Bom_Append_Input>;
  _delete_at_path?: InputMaybe<Item_Bom_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Item_Bom_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Item_Bom_Delete_Key_Input>;
  _inc?: InputMaybe<Item_Bom_Inc_Input>;
  _prepend?: InputMaybe<Item_Bom_Prepend_Input>;
  _set?: InputMaybe<Item_Bom_Set_Input>;
  where: Item_Bom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Item_Bom_By_PkArgs = {
  _append?: InputMaybe<Item_Bom_Append_Input>;
  _delete_at_path?: InputMaybe<Item_Bom_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Item_Bom_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Item_Bom_Delete_Key_Input>;
  _inc?: InputMaybe<Item_Bom_Inc_Input>;
  _prepend?: InputMaybe<Item_Bom_Prepend_Input>;
  _set?: InputMaybe<Item_Bom_Set_Input>;
  pk_columns: Item_Bom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Item_Bom_ManyArgs = {
  updates: Array<Item_Bom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Item_TypeArgs = {
  _set?: InputMaybe<Item_Type_Set_Input>;
  where: Item_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Item_Type_By_PkArgs = {
  _set?: InputMaybe<Item_Type_Set_Input>;
  pk_columns: Item_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Item_Type_ManyArgs = {
  updates: Array<Item_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ManufacturerArgs = {
  _set?: InputMaybe<Manufacturer_Set_Input>;
  where: Manufacturer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_By_PkArgs = {
  _set?: InputMaybe<Manufacturer_Set_Input>;
  pk_columns: Manufacturer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_ManyArgs = {
  updates: Array<Manufacturer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_PartsArgs = {
  _set?: InputMaybe<Manufacturer_Parts_Set_Input>;
  where: Manufacturer_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_Parts_By_PkArgs = {
  _set?: InputMaybe<Manufacturer_Parts_Set_Input>;
  pk_columns: Manufacturer_Parts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Manufacturer_Parts_ManyArgs = {
  updates: Array<Manufacturer_Parts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MilestoneArgs = {
  _inc?: InputMaybe<Milestone_Inc_Input>;
  _set?: InputMaybe<Milestone_Set_Input>;
  where: Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Milestone_ManyArgs = {
  updates: Array<Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PartArgs = {
  _inc?: InputMaybe<Part_Inc_Input>;
  _set?: InputMaybe<Part_Set_Input>;
  where: Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_By_PkArgs = {
  _inc?: InputMaybe<Part_Inc_Input>;
  _set?: InputMaybe<Part_Set_Input>;
  pk_columns: Part_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_ManyArgs = {
  updates: Array<Part_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Number_HistoryArgs = {
  _set?: InputMaybe<Part_Number_History_Set_Input>;
  where: Part_Number_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Number_History_By_PkArgs = {
  _set?: InputMaybe<Part_Number_History_Set_Input>;
  pk_columns: Part_Number_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Number_History_ManyArgs = {
  updates: Array<Part_Number_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_RequestArgs = {
  _append?: InputMaybe<Part_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Part_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Part_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Part_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Part_Request_Inc_Input>;
  _prepend?: InputMaybe<Part_Request_Prepend_Input>;
  _set?: InputMaybe<Part_Request_Set_Input>;
  where: Part_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_By_PkArgs = {
  _append?: InputMaybe<Part_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Part_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Part_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Part_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Part_Request_Inc_Input>;
  _prepend?: InputMaybe<Part_Request_Prepend_Input>;
  _set?: InputMaybe<Part_Request_Set_Input>;
  pk_columns: Part_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_ManyArgs = {
  updates: Array<Part_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_ReasonArgs = {
  _set?: InputMaybe<Part_Request_Reason_Set_Input>;
  where: Part_Request_Reason_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Reason_By_PkArgs = {
  _set?: InputMaybe<Part_Request_Reason_Set_Input>;
  pk_columns: Part_Request_Reason_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Reason_ManyArgs = {
  updates: Array<Part_Request_Reason_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_StatusArgs = {
  _set?: InputMaybe<Part_Request_Status_Set_Input>;
  where: Part_Request_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Status_By_PkArgs = {
  _set?: InputMaybe<Part_Request_Status_Set_Input>;
  pk_columns: Part_Request_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Status_ManyArgs = {
  updates: Array<Part_Request_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_TypeArgs = {
  _set?: InputMaybe<Part_Request_Type_Set_Input>;
  where: Part_Request_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Type_By_PkArgs = {
  _set?: InputMaybe<Part_Request_Type_Set_Input>;
  pk_columns: Part_Request_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Request_Type_ManyArgs = {
  updates: Array<Part_Request_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_StatusArgs = {
  _set?: InputMaybe<Part_Status_Set_Input>;
  where: Part_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Status_By_PkArgs = {
  _set?: InputMaybe<Part_Status_Set_Input>;
  pk_columns: Part_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Status_ManyArgs = {
  updates: Array<Part_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_SyncArgs = {
  _inc?: InputMaybe<Part_Sync_Inc_Input>;
  _set?: InputMaybe<Part_Sync_Set_Input>;
  where: Part_Sync_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Sync_By_PkArgs = {
  _inc?: InputMaybe<Part_Sync_Inc_Input>;
  _set?: InputMaybe<Part_Sync_Set_Input>;
  pk_columns: Part_Sync_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Sync_ManyArgs = {
  updates: Array<Part_Sync_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_TypeArgs = {
  _set?: InputMaybe<Part_Type_Set_Input>;
  where: Part_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Type_By_PkArgs = {
  _set?: InputMaybe<Part_Type_Set_Input>;
  pk_columns: Part_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Type_ManyArgs = {
  updates: Array<Part_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Warehouse_DetailArgs = {
  _append?: InputMaybe<Part_Warehouse_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Part_Warehouse_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Part_Warehouse_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Part_Warehouse_Detail_Delete_Key_Input>;
  _prepend?: InputMaybe<Part_Warehouse_Detail_Prepend_Input>;
  _set?: InputMaybe<Part_Warehouse_Detail_Set_Input>;
  where: Part_Warehouse_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Warehouse_Detail_By_PkArgs = {
  _append?: InputMaybe<Part_Warehouse_Detail_Append_Input>;
  _delete_at_path?: InputMaybe<Part_Warehouse_Detail_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Part_Warehouse_Detail_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Part_Warehouse_Detail_Delete_Key_Input>;
  _prepend?: InputMaybe<Part_Warehouse_Detail_Prepend_Input>;
  _set?: InputMaybe<Part_Warehouse_Detail_Set_Input>;
  pk_columns: Part_Warehouse_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Part_Warehouse_Detail_ManyArgs = {
  updates: Array<Part_Warehouse_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Parts_RelatedArgs = {
  _set?: InputMaybe<Parts_Related_Set_Input>;
  where: Parts_Related_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Parts_Related_By_PkArgs = {
  _set?: InputMaybe<Parts_Related_Set_Input>;
  pk_columns: Parts_Related_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Parts_Related_ManyArgs = {
  updates: Array<Parts_Related_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PermissionsArgs = {
  _set?: InputMaybe<Permissions_Set_Input>;
  where: Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_By_PkArgs = {
  _set?: InputMaybe<Permissions_Set_Input>;
  pk_columns: Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Permissions_ManyArgs = {
  updates: Array<Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PhaseArgs = {
  _inc?: InputMaybe<Phase_Inc_Input>;
  _set?: InputMaybe<Phase_Set_Input>;
  where: Phase_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phase_By_PkArgs = {
  _inc?: InputMaybe<Phase_Inc_Input>;
  _set?: InputMaybe<Phase_Set_Input>;
  pk_columns: Phase_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phase_ManyArgs = {
  updates: Array<Phase_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlatformArgs = {
  _append?: InputMaybe<Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  _set?: InputMaybe<Platform_Set_Input>;
  where: Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_By_PkArgs = {
  _append?: InputMaybe<Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  _set?: InputMaybe<Platform_Set_Input>;
  pk_columns: Platform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_ManyArgs = {
  updates: Array<Platform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_RequirementArgs = {
  _append?: InputMaybe<Platform_Requirement_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Requirement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Requirement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Requirement_Delete_Key_Input>;
  _prepend?: InputMaybe<Platform_Requirement_Prepend_Input>;
  _set?: InputMaybe<Platform_Requirement_Set_Input>;
  where: Platform_Requirement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_Requirement_By_PkArgs = {
  _append?: InputMaybe<Platform_Requirement_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Requirement_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Requirement_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Requirement_Delete_Key_Input>;
  _prepend?: InputMaybe<Platform_Requirement_Prepend_Input>;
  _set?: InputMaybe<Platform_Requirement_Set_Input>;
  pk_columns: Platform_Requirement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_Requirement_ManyArgs = {
  updates: Array<Platform_Requirement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_OptionArgs = {
  _inc?: InputMaybe<Product_Option_Inc_Input>;
  _set?: InputMaybe<Product_Option_Set_Input>;
  where: Product_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Option_By_PkArgs = {
  _inc?: InputMaybe<Product_Option_Inc_Input>;
  _set?: InputMaybe<Product_Option_Set_Input>;
  pk_columns: Product_Option_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Option_ChoiceArgs = {
  _append?: InputMaybe<Product_Option_Choice_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Option_Choice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Option_Choice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Option_Choice_Delete_Key_Input>;
  _inc?: InputMaybe<Product_Option_Choice_Inc_Input>;
  _prepend?: InputMaybe<Product_Option_Choice_Prepend_Input>;
  _set?: InputMaybe<Product_Option_Choice_Set_Input>;
  where: Product_Option_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Option_Choice_By_PkArgs = {
  _append?: InputMaybe<Product_Option_Choice_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Option_Choice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Option_Choice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Option_Choice_Delete_Key_Input>;
  _inc?: InputMaybe<Product_Option_Choice_Inc_Input>;
  _prepend?: InputMaybe<Product_Option_Choice_Prepend_Input>;
  _set?: InputMaybe<Product_Option_Choice_Set_Input>;
  pk_columns: Product_Option_Choice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Option_Choice_ManyArgs = {
  updates: Array<Product_Option_Choice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Option_ManyArgs = {
  updates: Array<Product_Option_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_TypeArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  where: Product_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_By_PkArgs = {
  _set?: InputMaybe<Product_Type_Set_Input>;
  pk_columns: Product_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Type_ManyArgs = {
  updates: Array<Product_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProgramArgs = {
  _set?: InputMaybe<Program_Set_Input>;
  where: Program_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Program_By_PkArgs = {
  _set?: InputMaybe<Program_Set_Input>;
  pk_columns: Program_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Program_ManyArgs = {
  updates: Array<Program_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProjectArgs = {
  _append?: InputMaybe<Project_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Inc_Input>;
  _prepend?: InputMaybe<Project_Prepend_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  where: Project_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Base_Product_QuantitiesArgs = {
  _inc?: InputMaybe<Project_Base_Product_Quantities_Inc_Input>;
  _set?: InputMaybe<Project_Base_Product_Quantities_Set_Input>;
  where: Project_Base_Product_Quantities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Base_Product_Quantities_By_PkArgs = {
  _inc?: InputMaybe<Project_Base_Product_Quantities_Inc_Input>;
  _set?: InputMaybe<Project_Base_Product_Quantities_Set_Input>;
  pk_columns: Project_Base_Product_Quantities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Base_Product_Quantities_ManyArgs = {
  updates: Array<Project_Base_Product_Quantities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_By_PkArgs = {
  _append?: InputMaybe<Project_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Inc_Input>;
  _prepend?: InputMaybe<Project_Prepend_Input>;
  _set?: InputMaybe<Project_Set_Input>;
  pk_columns: Project_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_CommentArgs = {
  _append?: InputMaybe<Project_Comment_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Comment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Comment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Comment_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Comment_Inc_Input>;
  _prepend?: InputMaybe<Project_Comment_Prepend_Input>;
  _set?: InputMaybe<Project_Comment_Set_Input>;
  where: Project_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Comment_By_PkArgs = {
  _append?: InputMaybe<Project_Comment_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Comment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Comment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Comment_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Comment_Inc_Input>;
  _prepend?: InputMaybe<Project_Comment_Prepend_Input>;
  _set?: InputMaybe<Project_Comment_Set_Input>;
  pk_columns: Project_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Comment_ManyArgs = {
  updates: Array<Project_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ContactsArgs = {
  _inc?: InputMaybe<Project_Contacts_Inc_Input>;
  _set?: InputMaybe<Project_Contacts_Set_Input>;
  where: Project_Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contacts_By_PkArgs = {
  _inc?: InputMaybe<Project_Contacts_Inc_Input>;
  _set?: InputMaybe<Project_Contacts_Set_Input>;
  pk_columns: Project_Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Contacts_ManyArgs = {
  updates: Array<Project_Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ManyArgs = {
  updates: Array<Project_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_MilestoneArgs = {
  _inc?: InputMaybe<Project_Milestone_Inc_Input>;
  _set?: InputMaybe<Project_Milestone_Set_Input>;
  where: Project_Milestone_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Milestone_By_PkArgs = {
  _inc?: InputMaybe<Project_Milestone_Inc_Input>;
  _set?: InputMaybe<Project_Milestone_Set_Input>;
  pk_columns: Project_Milestone_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Milestone_ManyArgs = {
  updates: Array<Project_Milestone_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_ModuleArgs = {
  _append?: InputMaybe<Project_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Module_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Module_Inc_Input>;
  _prepend?: InputMaybe<Project_Module_Prepend_Input>;
  _set?: InputMaybe<Project_Module_Set_Input>;
  where: Project_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Module_By_PkArgs = {
  _append?: InputMaybe<Project_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Project_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Project_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Project_Module_Delete_Key_Input>;
  _inc?: InputMaybe<Project_Module_Inc_Input>;
  _prepend?: InputMaybe<Project_Module_Prepend_Input>;
  _set?: InputMaybe<Project_Module_Set_Input>;
  pk_columns: Project_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Module_ManyArgs = {
  updates: Array<Project_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_StatusArgs = {
  _inc?: InputMaybe<Project_Status_Inc_Input>;
  _set?: InputMaybe<Project_Status_Set_Input>;
  where: Project_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Status_By_PkArgs = {
  _inc?: InputMaybe<Project_Status_Inc_Input>;
  _set?: InputMaybe<Project_Status_Set_Input>;
  pk_columns: Project_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Status_ManyArgs = {
  updates: Array<Project_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Project_UsersArgs = {
  _set?: InputMaybe<Project_Users_Set_Input>;
  where: Project_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Users_By_PkArgs = {
  _set?: InputMaybe<Project_Users_Set_Input>;
  pk_columns: Project_Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Project_Users_ManyArgs = {
  updates: Array<Project_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_TypeArgs = {
  _inc?: InputMaybe<Purchase_Type_Inc_Input>;
  _set?: InputMaybe<Purchase_Type_Set_Input>;
  where: Purchase_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Type_By_PkArgs = {
  _inc?: InputMaybe<Purchase_Type_Inc_Input>;
  _set?: InputMaybe<Purchase_Type_Set_Input>;
  pk_columns: Purchase_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Purchase_Type_ManyArgs = {
  updates: Array<Purchase_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Qb_ItemsArgs = {
  _inc?: InputMaybe<Qb_Items_Inc_Input>;
  _set?: InputMaybe<Qb_Items_Set_Input>;
  where: Qb_Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Qb_Items_By_PkArgs = {
  _inc?: InputMaybe<Qb_Items_Inc_Input>;
  _set?: InputMaybe<Qb_Items_Set_Input>;
  pk_columns: Qb_Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Qb_Items_ManyArgs = {
  updates: Array<Qb_Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Relation_TypeArgs = {
  _set?: InputMaybe<Relation_Type_Set_Input>;
  where: Relation_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Relation_Type_By_PkArgs = {
  _set?: InputMaybe<Relation_Type_Set_Input>;
  pk_columns: Relation_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Relation_Type_ManyArgs = {
  updates: Array<Relation_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportArgs = {
  _append?: InputMaybe<Report_Append_Input>;
  _delete_at_path?: InputMaybe<Report_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Report_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Report_Delete_Key_Input>;
  _prepend?: InputMaybe<Report_Prepend_Input>;
  _set?: InputMaybe<Report_Set_Input>;
  where: Report_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Report_By_PkArgs = {
  _append?: InputMaybe<Report_Append_Input>;
  _delete_at_path?: InputMaybe<Report_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Report_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Report_Delete_Key_Input>;
  _prepend?: InputMaybe<Report_Prepend_Input>;
  _set?: InputMaybe<Report_Set_Input>;
  pk_columns: Report_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Report_ManyArgs = {
  updates: Array<Report_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Role_PermissionsArgs = {
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  where: Role_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Permissions_By_PkArgs = {
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  pk_columns: Role_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_Permissions_ManyArgs = {
  updates: Array<Role_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Serial_NumbersArgs = {
  _inc?: InputMaybe<Serial_Numbers_Inc_Input>;
  _set?: InputMaybe<Serial_Numbers_Set_Input>;
  where: Serial_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Serial_Numbers_By_PkArgs = {
  _inc?: InputMaybe<Serial_Numbers_Inc_Input>;
  _set?: InputMaybe<Serial_Numbers_Set_Input>;
  pk_columns: Serial_Numbers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Serial_Numbers_ManyArgs = {
  updates: Array<Serial_Numbers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Short_UrlArgs = {
  _append?: InputMaybe<Short_Url_Append_Input>;
  _delete_at_path?: InputMaybe<Short_Url_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Short_Url_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Short_Url_Delete_Key_Input>;
  _inc?: InputMaybe<Short_Url_Inc_Input>;
  _prepend?: InputMaybe<Short_Url_Prepend_Input>;
  _set?: InputMaybe<Short_Url_Set_Input>;
  where: Short_Url_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Short_Url_By_PkArgs = {
  _append?: InputMaybe<Short_Url_Append_Input>;
  _delete_at_path?: InputMaybe<Short_Url_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Short_Url_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Short_Url_Delete_Key_Input>;
  _inc?: InputMaybe<Short_Url_Inc_Input>;
  _prepend?: InputMaybe<Short_Url_Prepend_Input>;
  _set?: InputMaybe<Short_Url_Set_Input>;
  pk_columns: Short_Url_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Short_Url_ManyArgs = {
  updates: Array<Short_Url_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_System_EventArgs = {
  _inc?: InputMaybe<System_Event_Inc_Input>;
  _set?: InputMaybe<System_Event_Set_Input>;
  where: System_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_System_Event_By_PkArgs = {
  _inc?: InputMaybe<System_Event_Inc_Input>;
  _set?: InputMaybe<System_Event_Set_Input>;
  pk_columns: System_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_System_Event_ManyArgs = {
  updates: Array<System_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_EntityArgs = {
  _inc?: InputMaybe<Tag_Entity_Inc_Input>;
  _set?: InputMaybe<Tag_Entity_Set_Input>;
  where: Tag_Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Entity_By_PkArgs = {
  _inc?: InputMaybe<Tag_Entity_Inc_Input>;
  _set?: InputMaybe<Tag_Entity_Set_Input>;
  pk_columns: Tag_Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Entity_ManyArgs = {
  updates: Array<Tag_Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_PathArgs = {
  _inc?: InputMaybe<Tag_Path_Inc_Input>;
  _set?: InputMaybe<Tag_Path_Set_Input>;
  where: Tag_Path_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Path_By_PkArgs = {
  _inc?: InputMaybe<Tag_Path_Inc_Input>;
  _set?: InputMaybe<Tag_Path_Set_Input>;
  pk_columns: Tag_Path_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Path_ManyArgs = {
  updates: Array<Tag_Path_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_SetArgs = {
  _append?: InputMaybe<Tag_Set_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Set_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Set_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Set_Delete_Key_Input>;
  _inc?: InputMaybe<Tag_Set_Inc_Input>;
  _prepend?: InputMaybe<Tag_Set_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Set_Input>;
  where: Tag_Set_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Set_By_PkArgs = {
  _append?: InputMaybe<Tag_Set_Append_Input>;
  _delete_at_path?: InputMaybe<Tag_Set_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tag_Set_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tag_Set_Delete_Key_Input>;
  _inc?: InputMaybe<Tag_Set_Inc_Input>;
  _prepend?: InputMaybe<Tag_Set_Prepend_Input>;
  _set?: InputMaybe<Tag_Set_Set_Input>;
  pk_columns: Tag_Set_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Set_ManyArgs = {
  updates: Array<Tag_Set_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_TypeArgs = {
  _inc?: InputMaybe<Tag_Type_Inc_Input>;
  _set?: InputMaybe<Tag_Type_Set_Input>;
  where: Tag_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_By_PkArgs = {
  _inc?: InputMaybe<Tag_Type_Inc_Input>;
  _set?: InputMaybe<Tag_Type_Set_Input>;
  pk_columns: Tag_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Type_ManyArgs = {
  updates: Array<Tag_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TagsArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  where: Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_By_PkArgs = {
  _inc?: InputMaybe<Tags_Inc_Input>;
  _set?: InputMaybe<Tags_Set_Input>;
  pk_columns: Tags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tags_ManyArgs = {
  updates: Array<Tags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UnitArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  where: Unit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_By_PkArgs = {
  _inc?: InputMaybe<Unit_Inc_Input>;
  _set?: InputMaybe<Unit_Set_Input>;
  pk_columns: Unit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_ManyArgs = {
  updates: Array<Unit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Product_Option_ChoiceArgs = {
  _set?: InputMaybe<Unit_Product_Option_Choice_Set_Input>;
  where: Unit_Product_Option_Choice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Product_Option_Choice_By_PkArgs = {
  _set?: InputMaybe<Unit_Product_Option_Choice_Set_Input>;
  pk_columns: Unit_Product_Option_Choice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Unit_Product_Option_Choice_ManyArgs = {
  updates: Array<Unit_Product_Option_Choice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UomArgs = {
  _inc?: InputMaybe<Uom_Inc_Input>;
  _set?: InputMaybe<Uom_Set_Input>;
  where: Uom_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_By_PkArgs = {
  _inc?: InputMaybe<Uom_Inc_Input>;
  _set?: InputMaybe<Uom_Set_Input>;
  pk_columns: Uom_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_ClassificationArgs = {
  _set?: InputMaybe<Uom_Classification_Set_Input>;
  where: Uom_Classification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Classification_By_PkArgs = {
  _set?: InputMaybe<Uom_Classification_Set_Input>;
  pk_columns: Uom_Classification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Classification_ManyArgs = {
  updates: Array<Uom_Classification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_ConversionArgs = {
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  where: Uom_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Conversion_By_PkArgs = {
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  pk_columns: Uom_Conversion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Conversion_ManyArgs = {
  updates: Array<Uom_Conversion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Csi_ConversionArgs = {
  _set?: InputMaybe<Uom_Csi_Conversion_Set_Input>;
  where: Uom_Csi_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Csi_Conversion_By_PkArgs = {
  _set?: InputMaybe<Uom_Csi_Conversion_Set_Input>;
  pk_columns: Uom_Csi_Conversion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Csi_Conversion_ManyArgs = {
  updates: Array<Uom_Csi_Conversion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_ManyArgs = {
  updates: Array<Uom_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_ScopeArgs = {
  _set?: InputMaybe<Uom_Scope_Set_Input>;
  where: Uom_Scope_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Scope_By_PkArgs = {
  _set?: InputMaybe<Uom_Scope_Set_Input>;
  pk_columns: Uom_Scope_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Scope_ManyArgs = {
  updates: Array<Uom_Scope_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Scope_PartArgs = {
  _inc?: InputMaybe<Uom_Scope_Part_Inc_Input>;
  _set?: InputMaybe<Uom_Scope_Part_Set_Input>;
  where: Uom_Scope_Part_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Scope_Part_By_PkArgs = {
  _inc?: InputMaybe<Uom_Scope_Part_Inc_Input>;
  _set?: InputMaybe<Uom_Scope_Part_Set_Input>;
  pk_columns: Uom_Scope_Part_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_Scope_Part_ManyArgs = {
  updates: Array<Uom_Scope_Part_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_System_ConversionArgs = {
  _inc?: InputMaybe<Uom_System_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_System_Conversion_Set_Input>;
  where: Uom_System_Conversion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_System_Conversion_By_PkArgs = {
  _inc?: InputMaybe<Uom_System_Conversion_Inc_Input>;
  _set?: InputMaybe<Uom_System_Conversion_Set_Input>;
  pk_columns: Uom_System_Conversion_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uom_System_Conversion_ManyArgs = {
  updates: Array<Uom_System_Conversion_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _inc?: InputMaybe<User_Inc_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _inc?: InputMaybe<User_Inc_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_InfoArgs = {
  _inc?: InputMaybe<User_Info_Inc_Input>;
  _set?: InputMaybe<User_Info_Set_Input>;
  where: User_Info_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Info_ManyArgs = {
  updates: Array<User_Info_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PermissionsArgs = {
  _set?: InputMaybe<User_Permissions_Set_Input>;
  where: User_Permissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permissions_By_PkArgs = {
  _set?: InputMaybe<User_Permissions_Set_Input>;
  pk_columns: User_Permissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permissions_ManyArgs = {
  updates: Array<User_Permissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_RoleArgs = {
  _set?: InputMaybe<User_Role_Set_Input>;
  where: User_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Role_By_PkArgs = {
  _set?: InputMaybe<User_Role_Set_Input>;
  pk_columns: User_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Role_ManyArgs = {
  updates: Array<User_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VendorArgs = {
  _set?: InputMaybe<Vendor_Set_Input>;
  where: Vendor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_By_PkArgs = {
  _set?: InputMaybe<Vendor_Set_Input>;
  pk_columns: Vendor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_AuditArgs = {
  _append?: InputMaybe<Vendor_Cleanup_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Vendor_Cleanup_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Vendor_Cleanup_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Vendor_Cleanup_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Vendor_Cleanup_Audit_Inc_Input>;
  _prepend?: InputMaybe<Vendor_Cleanup_Audit_Prepend_Input>;
  _set?: InputMaybe<Vendor_Cleanup_Audit_Set_Input>;
  where: Vendor_Cleanup_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_Audit_By_PkArgs = {
  _append?: InputMaybe<Vendor_Cleanup_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Vendor_Cleanup_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Vendor_Cleanup_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Vendor_Cleanup_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Vendor_Cleanup_Audit_Inc_Input>;
  _prepend?: InputMaybe<Vendor_Cleanup_Audit_Prepend_Input>;
  _set?: InputMaybe<Vendor_Cleanup_Audit_Set_Input>;
  pk_columns: Vendor_Cleanup_Audit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_Audit_ManyArgs = {
  updates: Array<Vendor_Cleanup_Audit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_Wevr_Mapping_LookupArgs = {
  _set?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Set_Input>;
  where: Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_Wevr_Mapping_Lookup_By_PkArgs = {
  _set?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Set_Input>;
  pk_columns: Vendor_Cleanup_Wevr_Mapping_Lookup_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Cleanup_Wevr_Mapping_Lookup_ManyArgs = {
  updates: Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_ManyArgs = {
  updates: Array<Vendor_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_PartsArgs = {
  _inc?: InputMaybe<Vendor_Parts_Inc_Input>;
  _set?: InputMaybe<Vendor_Parts_Set_Input>;
  where: Vendor_Parts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Parts_By_PkArgs = {
  _inc?: InputMaybe<Vendor_Parts_Inc_Input>;
  _set?: InputMaybe<Vendor_Parts_Set_Input>;
  pk_columns: Vendor_Parts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Vendor_Parts_ManyArgs = {
  updates: Array<Vendor_Parts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WorkflowArgs = {
  _append?: InputMaybe<Workflow_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  _set?: InputMaybe<Workflow_Set_Input>;
  where: Workflow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_By_PkArgs = {
  _append?: InputMaybe<Workflow_Append_Input>;
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  _inc?: InputMaybe<Workflow_Inc_Input>;
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  _set?: InputMaybe<Workflow_Set_Input>;
  pk_columns: Workflow_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Workflow_ManyArgs = {
  updates: Array<Workflow_Updates>;
};


/** mutation root */
export type Mutation_RootUpdatechoiceNodesArgs = {
  connect?: InputMaybe<ChoiceNodeConnectInput>;
  create?: InputMaybe<ChoiceNodeRelationInput>;
  delete?: InputMaybe<ChoiceNodeDeleteInput>;
  disconnect?: InputMaybe<ChoiceNodeDisconnectInput>;
  update?: InputMaybe<ChoiceNodeUpdateInput>;
  where?: InputMaybe<ChoiceNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdatecsiNodesArgs = {
  connect?: InputMaybe<CsiNodeConnectInput>;
  create?: InputMaybe<CsiNodeRelationInput>;
  delete?: InputMaybe<CsiNodeDeleteInput>;
  disconnect?: InputMaybe<CsiNodeDisconnectInput>;
  update?: InputMaybe<CsiNodeUpdateInput>;
  where?: InputMaybe<CsiNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdatecustomerNodesArgs = {
  connect?: InputMaybe<CustomerNodeConnectInput>;
  create?: InputMaybe<CustomerNodeRelationInput>;
  delete?: InputMaybe<CustomerNodeDeleteInput>;
  disconnect?: InputMaybe<CustomerNodeDisconnectInput>;
  update?: InputMaybe<CustomerNodeUpdateInput>;
  where?: InputMaybe<CustomerNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateitemNodesArgs = {
  connect?: InputMaybe<ItemNodeConnectInput>;
  create?: InputMaybe<ItemNodeRelationInput>;
  delete?: InputMaybe<ItemNodeDeleteInput>;
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  update?: InputMaybe<ItemNodeUpdateInput>;
  where?: InputMaybe<ItemNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateorderNodesArgs = {
  connect?: InputMaybe<OrderNodeConnectInput>;
  create?: InputMaybe<OrderNodeRelationInput>;
  delete?: InputMaybe<OrderNodeDeleteInput>;
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  update?: InputMaybe<OrderNodeUpdateInput>;
  where?: InputMaybe<OrderNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateplatformNodesArgs = {
  connect?: InputMaybe<PlatformNodeConnectInput>;
  create?: InputMaybe<PlatformNodeRelationInput>;
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  disconnect?: InputMaybe<PlatformNodeDisconnectInput>;
  update?: InputMaybe<PlatformNodeUpdateInput>;
  where?: InputMaybe<PlatformNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateproductNodesArgs = {
  connect?: InputMaybe<ProductNodeConnectInput>;
  create?: InputMaybe<ProductNodeRelationInput>;
  delete?: InputMaybe<ProductNodeDeleteInput>;
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  update?: InputMaybe<ProductNodeUpdateInput>;
  where?: InputMaybe<ProductNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateproductOptionNodesArgs = {
  connect?: InputMaybe<ProductOptionNodeConnectInput>;
  create?: InputMaybe<ProductOptionNodeRelationInput>;
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  update?: InputMaybe<ProductOptionNodeUpdateInput>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateprogramNodesArgs = {
  connect?: InputMaybe<ProgramNodeConnectInput>;
  create?: InputMaybe<ProgramNodeRelationInput>;
  delete?: InputMaybe<ProgramNodeDeleteInput>;
  disconnect?: InputMaybe<ProgramNodeDisconnectInput>;
  update?: InputMaybe<ProgramNodeUpdateInput>;
  where?: InputMaybe<ProgramNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateprojectNodesArgs = {
  connect?: InputMaybe<ProjectNodeConnectInput>;
  create?: InputMaybe<ProjectNodeRelationInput>;
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  update?: InputMaybe<ProjectNodeUpdateInput>;
  where?: InputMaybe<ProjectNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateunitNodesArgs = {
  connect?: InputMaybe<UnitNodeConnectInput>;
  create?: InputMaybe<UnitNodeRelationInput>;
  delete?: InputMaybe<UnitNodeDeleteInput>;
  disconnect?: InputMaybe<UnitNodeDisconnectInput>;
  update?: InputMaybe<UnitNodeUpdateInput>;
  where?: InputMaybe<UnitNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateuomNodesArgs = {
  connect?: InputMaybe<UomNodeConnectInput>;
  create?: InputMaybe<UomNodeRelationInput>;
  delete?: InputMaybe<UomNodeDeleteInput>;
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  update?: InputMaybe<UomNodeUpdateInput>;
  where?: InputMaybe<UomNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateuomScopeNodesArgs = {
  connect?: InputMaybe<UomScopeNodeConnectInput>;
  create?: InputMaybe<UomScopeNodeRelationInput>;
  delete?: InputMaybe<UomScopeNodeDeleteInput>;
  disconnect?: InputMaybe<UomScopeNodeDisconnectInput>;
  update?: InputMaybe<UomScopeNodeUpdateInput>;
  where?: InputMaybe<UomScopeNodeWhere>;
};


/** mutation root */
export type Mutation_RootUpdateuomSupplierNodesArgs = {
  connect?: InputMaybe<UomSupplierNodeConnectInput>;
  create?: InputMaybe<UomSupplierNodeRelationInput>;
  delete?: InputMaybe<UomSupplierNodeDeleteInput>;
  disconnect?: InputMaybe<UomSupplierNodeDisconnectInput>;
  update?: InputMaybe<UomSupplierNodeUpdateInput>;
  where?: InputMaybe<UomSupplierNodeWhere>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

export type OrderNode = {
  __typename?: 'orderNode';
  confirmations?: Maybe<Array<Maybe<OrderNode>>>;
  confirmationsAggregate?: Maybe<OrderNodeorderNodeConfirmationsAggregationSelection>;
  confirmationsConnection: OrderNodeConfirmationsConnection;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  projects?: Maybe<Array<Maybe<ProjectNode>>>;
  projectsAggregate?: Maybe<OrderNodeprojectNodeProjectsAggregationSelection>;
  projectsConnection: OrderNodeProjectsConnection;
  requests?: Maybe<Array<Maybe<OrderNode>>>;
  requestsAggregate?: Maybe<OrderNodeorderNodeRequestsAggregationSelection>;
  requestsConnection: OrderNodeRequestsConnection;
  wevrId?: Maybe<Scalars['String']>;
};


export type OrderNodeConfirmationsArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type OrderNodeConfirmationsAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type OrderNodeConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<OrderNodeConfirmationsConnectionSort>>;
  where?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
};


export type OrderNodeProjectsArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type OrderNodeProjectsAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type OrderNodeProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<OrderNodeProjectsConnectionSort>>;
  where?: InputMaybe<OrderNodeProjectsConnectionWhere>;
};


export type OrderNodeRequestsArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type OrderNodeRequestsAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type OrderNodeRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<OrderNodeRequestsConnectionSort>>;
  where?: InputMaybe<OrderNodeRequestsConnectionWhere>;
};

export type OrderNodeAggregateSelection = {
  __typename?: 'orderNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type OrderNodeConfirmationsAggregateInput = {
  AND?: InputMaybe<Array<OrderNodeConfirmationsAggregateInput>>;
  OR?: InputMaybe<Array<OrderNodeConfirmationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<OrderNodeConfirmationsNodeAggregationWhereInput>;
};

export type OrderNodeConfirmationsConnectFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConnectInput>>;
  where?: InputMaybe<OrderNodeConnectWhere>;
};

export type OrderNodeConfirmationsConnection = {
  __typename?: 'orderNodeConfirmationsConnection';
  edges: Array<OrderNodeConfirmationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrderNodeConfirmationsConnectionSort = {
  node?: InputMaybe<OrderNodeSort>;
};

export type OrderNodeConfirmationsConnectionWhere = {
  AND?: InputMaybe<Array<OrderNodeConfirmationsConnectionWhere>>;
  OR?: InputMaybe<Array<OrderNodeConfirmationsConnectionWhere>>;
  node?: InputMaybe<OrderNodeWhere>;
  node_NOT?: InputMaybe<OrderNodeWhere>;
};

export type OrderNodeConfirmationsCreateFieldInput = {
  node: OrderNodeCreateInput;
};

export type OrderNodeConfirmationsDeleteFieldInput = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
};

export type OrderNodeConfirmationsDisconnectFieldInput = {
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  where?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
};

export type OrderNodeConfirmationsFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConfirmationsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeConfirmationsCreateFieldInput>>;
};

export type OrderNodeConfirmationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrderNodeConfirmationsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<OrderNodeConfirmationsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type OrderNodeConfirmationsRelationship = {
  __typename?: 'orderNodeConfirmationsRelationship';
  cursor: Scalars['String'];
  node: OrderNode;
};

export type OrderNodeConfirmationsUpdateConnectionInput = {
  node?: InputMaybe<OrderNodeUpdateInput>;
};

export type OrderNodeConfirmationsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConfirmationsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeConfirmationsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrderNodeConfirmationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrderNodeConfirmationsDisconnectFieldInput>>;
  update?: InputMaybe<OrderNodeConfirmationsUpdateConnectionInput>;
  where?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
};

export type OrderNodeConnectInput = {
  confirmations?: InputMaybe<Array<OrderNodeConfirmationsConnectFieldInput>>;
  projects?: InputMaybe<Array<OrderNodeProjectsConnectFieldInput>>;
  requests?: InputMaybe<Array<OrderNodeRequestsConnectFieldInput>>;
};

export type OrderNodeConnectWhere = {
  node: OrderNodeWhere;
};

export type OrderNodeCreateInput = {
  confirmations?: InputMaybe<OrderNodeConfirmationsFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<OrderNodeProjectsFieldInput>;
  requests?: InputMaybe<OrderNodeRequestsFieldInput>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type OrderNodeDeleteInput = {
  confirmations?: InputMaybe<Array<OrderNodeConfirmationsDeleteFieldInput>>;
  projects?: InputMaybe<Array<OrderNodeProjectsDeleteFieldInput>>;
  requests?: InputMaybe<Array<OrderNodeRequestsDeleteFieldInput>>;
};

export type OrderNodeDisconnectInput = {
  confirmations?: InputMaybe<Array<OrderNodeConfirmationsDisconnectFieldInput>>;
  projects?: InputMaybe<Array<OrderNodeProjectsDisconnectFieldInput>>;
  requests?: InputMaybe<Array<OrderNodeRequestsDisconnectFieldInput>>;
};

export type OrderNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more orderNodeSort objects to sort orderNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<OrderNodeSort>>>;
};

export type OrderNodeProjectsAggregateInput = {
  AND?: InputMaybe<Array<OrderNodeProjectsAggregateInput>>;
  OR?: InputMaybe<Array<OrderNodeProjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<OrderNodeProjectsNodeAggregationWhereInput>;
};

export type OrderNodeProjectsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeConnectInput>>;
  where?: InputMaybe<ProjectNodeConnectWhere>;
};

export type OrderNodeProjectsConnection = {
  __typename?: 'orderNodeProjectsConnection';
  edges: Array<OrderNodeProjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrderNodeProjectsConnectionSort = {
  node?: InputMaybe<ProjectNodeSort>;
};

export type OrderNodeProjectsConnectionWhere = {
  AND?: InputMaybe<Array<OrderNodeProjectsConnectionWhere>>;
  OR?: InputMaybe<Array<OrderNodeProjectsConnectionWhere>>;
  node?: InputMaybe<ProjectNodeWhere>;
  node_NOT?: InputMaybe<ProjectNodeWhere>;
};

export type OrderNodeProjectsCreateFieldInput = {
  node: ProjectNodeCreateInput;
};

export type OrderNodeProjectsDeleteFieldInput = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<OrderNodeProjectsConnectionWhere>;
};

export type OrderNodeProjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  where?: InputMaybe<OrderNodeProjectsConnectionWhere>;
};

export type OrderNodeProjectsFieldInput = {
  connect?: InputMaybe<Array<OrderNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeProjectsCreateFieldInput>>;
};

export type OrderNodeProjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrderNodeProjectsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<OrderNodeProjectsNodeAggregationWhereInput>>;
  bloxProjectNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_EQUAL?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type OrderNodeProjectsRelationship = {
  __typename?: 'orderNodeProjectsRelationship';
  cursor: Scalars['String'];
  node: ProjectNode;
};

export type OrderNodeProjectsUpdateConnectionInput = {
  node?: InputMaybe<ProjectNodeUpdateInput>;
};

export type OrderNodeProjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrderNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeProjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrderNodeProjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrderNodeProjectsDisconnectFieldInput>>;
  update?: InputMaybe<OrderNodeProjectsUpdateConnectionInput>;
  where?: InputMaybe<OrderNodeProjectsConnectionWhere>;
};

export type OrderNodeRelationInput = {
  confirmations?: InputMaybe<Array<OrderNodeConfirmationsCreateFieldInput>>;
  projects?: InputMaybe<Array<OrderNodeProjectsCreateFieldInput>>;
  requests?: InputMaybe<Array<OrderNodeRequestsCreateFieldInput>>;
};

export type OrderNodeRequestsAggregateInput = {
  AND?: InputMaybe<Array<OrderNodeRequestsAggregateInput>>;
  OR?: InputMaybe<Array<OrderNodeRequestsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<OrderNodeRequestsNodeAggregationWhereInput>;
};

export type OrderNodeRequestsConnectFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConnectInput>>;
  where?: InputMaybe<OrderNodeConnectWhere>;
};

export type OrderNodeRequestsConnection = {
  __typename?: 'orderNodeRequestsConnection';
  edges: Array<OrderNodeRequestsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrderNodeRequestsConnectionSort = {
  node?: InputMaybe<OrderNodeSort>;
};

export type OrderNodeRequestsConnectionWhere = {
  AND?: InputMaybe<Array<OrderNodeRequestsConnectionWhere>>;
  OR?: InputMaybe<Array<OrderNodeRequestsConnectionWhere>>;
  node?: InputMaybe<OrderNodeWhere>;
  node_NOT?: InputMaybe<OrderNodeWhere>;
};

export type OrderNodeRequestsCreateFieldInput = {
  node: OrderNodeCreateInput;
};

export type OrderNodeRequestsDeleteFieldInput = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<OrderNodeRequestsConnectionWhere>;
};

export type OrderNodeRequestsDisconnectFieldInput = {
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  where?: InputMaybe<OrderNodeRequestsConnectionWhere>;
};

export type OrderNodeRequestsFieldInput = {
  connect?: InputMaybe<Array<OrderNodeRequestsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeRequestsCreateFieldInput>>;
};

export type OrderNodeRequestsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<OrderNodeRequestsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<OrderNodeRequestsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type OrderNodeRequestsRelationship = {
  __typename?: 'orderNodeRequestsRelationship';
  cursor: Scalars['String'];
  node: OrderNode;
};

export type OrderNodeRequestsUpdateConnectionInput = {
  node?: InputMaybe<OrderNodeUpdateInput>;
};

export type OrderNodeRequestsUpdateFieldInput = {
  connect?: InputMaybe<Array<OrderNodeRequestsConnectFieldInput>>;
  create?: InputMaybe<Array<OrderNodeRequestsCreateFieldInput>>;
  delete?: InputMaybe<Array<OrderNodeRequestsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<OrderNodeRequestsDisconnectFieldInput>>;
  update?: InputMaybe<OrderNodeRequestsUpdateConnectionInput>;
  where?: InputMaybe<OrderNodeRequestsConnectionWhere>;
};

/** Fields to sort orderNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one orderNodeSort object. */
export type OrderNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type OrderNodeUpdateInput = {
  confirmations?: InputMaybe<Array<OrderNodeConfirmationsUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<OrderNodeProjectsUpdateFieldInput>>;
  requests?: InputMaybe<Array<OrderNodeRequestsUpdateFieldInput>>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type OrderNodeWhere = {
  AND?: InputMaybe<Array<OrderNodeWhere>>;
  OR?: InputMaybe<Array<OrderNodeWhere>>;
  confirmations?: InputMaybe<OrderNodeWhere>;
  confirmationsAggregate?: InputMaybe<OrderNodeConfirmationsAggregateInput>;
  confirmationsConnection?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
  confirmationsConnection_NOT?: InputMaybe<OrderNodeConfirmationsConnectionWhere>;
  confirmations_NOT?: InputMaybe<OrderNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<ProjectNodeWhere>;
  projectsAggregate?: InputMaybe<OrderNodeProjectsAggregateInput>;
  projectsConnection?: InputMaybe<OrderNodeProjectsConnectionWhere>;
  projectsConnection_NOT?: InputMaybe<OrderNodeProjectsConnectionWhere>;
  projects_NOT?: InputMaybe<ProjectNodeWhere>;
  requests?: InputMaybe<OrderNodeWhere>;
  requestsAggregate?: InputMaybe<OrderNodeRequestsAggregateInput>;
  requestsConnection?: InputMaybe<OrderNodeRequestsConnectionWhere>;
  requestsConnection_NOT?: InputMaybe<OrderNodeRequestsConnectionWhere>;
  requests_NOT?: InputMaybe<OrderNodeWhere>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type OrderNodeorderNodeConfirmationsAggregationSelection = {
  __typename?: 'orderNodeorderNodeConfirmationsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<OrderNodeorderNodeConfirmationsNodeAggregateSelection>;
};

export type OrderNodeorderNodeConfirmationsNodeAggregateSelection = {
  __typename?: 'orderNodeorderNodeConfirmationsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type OrderNodeorderNodeRequestsAggregationSelection = {
  __typename?: 'orderNodeorderNodeRequestsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<OrderNodeorderNodeRequestsNodeAggregateSelection>;
};

export type OrderNodeorderNodeRequestsNodeAggregateSelection = {
  __typename?: 'orderNodeorderNodeRequestsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type OrderNodeprojectNodeProjectsAggregationSelection = {
  __typename?: 'orderNodeprojectNodeProjectsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<OrderNodeprojectNodeProjectsNodeAggregateSelection>;
};

export type OrderNodeprojectNodeProjectsNodeAggregateSelection = {
  __typename?: 'orderNodeprojectNodeProjectsNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** column ordering options */
export type Order_By =
  /** in ascending order, nulls last */
  | 'asc'
  /** in ascending order, nulls first */
  | 'asc_nulls_first'
  /** in ascending order, nulls last */
  | 'asc_nulls_last'
  /** in descending order, nulls first */
  | 'desc'
  /** in descending order, nulls first */
  | 'desc_nulls_first'
  /** in descending order, nulls last */
  | 'desc_nulls_last';

/** columns and relationships of "part" */
export type Part = {
  __typename?: 'part';
  /** An array relationship */
  bom_details: Array<Bom_Detail>;
  /** An aggregate relationship */
  bom_details_aggregate: Bom_Detail_Aggregate;
  /** An array relationship */
  bom_tags: Array<Tag_Entity>;
  /** An aggregate relationship */
  bom_tags_aggregate: Tag_Entity_Aggregate;
  /** An array relationship */
  boms: Array<Item_Bom>;
  /** An aggregate relationship */
  boms_aggregate: Item_Bom_Aggregate;
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  consumable_bom_details: Array<Consumable_Bom_Detail>;
  /** An aggregate relationship */
  consumable_bom_details_aggregate: Consumable_Bom_Detail_Aggregate;
  conversionRateCommodity?: Maybe<Scalars['numeric']>;
  conversionRateEstimate?: Maybe<Scalars['numeric']>;
  conversionRateMaterial?: Maybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  created_by_user?: Maybe<User_Info>;
  /** An object relationship */
  csi: Csi;
  csiId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  finishColor?: Maybe<Scalars['String']>;
  hasLedgerEntries?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  inBLOXCatalog?: Maybe<Scalars['Boolean']>;
  inventoryClassification?: Maybe<Scalars['String']>;
  isApprovedByAppDesign: Scalars['Boolean'];
  isApprovedByFinance?: Maybe<Scalars['Boolean']>;
  isApprovedBySupplyChain?: Maybe<Scalars['Boolean']>;
  isInQuickBooks?: Maybe<Scalars['Boolean']>;
  itemType?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  manufacturers: Array<Manufacturer_Parts>;
  /** An aggregate relationship */
  manufacturers_aggregate: Manufacturer_Parts_Aggregate;
  material?: Maybe<Scalars['String']>;
  maxDailyConsumption?: Maybe<Scalars['String']>;
  /** An array relationship */
  measures: Array<Uom_Scope_Part>;
  /** An aggregate relationship */
  measures_aggregate: Uom_Scope_Part_Aggregate;
  name: Scalars['String'];
  on_pfep: Scalars['Boolean'];
  part: Array<TaggedItem>;
  partNumber: Scalars['String'];
  partType?: Maybe<Scalars['String']>;
  /** An array relationship */
  part_number_histories: Array<Part_Number_History>;
  /** An aggregate relationship */
  part_number_histories_aggregate: Part_Number_History_Aggregate;
  /** An object relationship */
  part_status?: Maybe<Part_Status>;
  part_type: Scalars['String'];
  /** An object relationship */
  purchaseType?: Maybe<Purchase_Type>;
  purchaseTypeId?: Maybe<Scalars['Int']>;
  purchaseTypeStatus?: Maybe<Scalars['String']>;
  /** An object relationship */
  qb_details?: Maybe<Qb_Items>;
  /** An array relationship */
  related_from: Array<Parts_Related>;
  /** An aggregate relationship */
  related_from_aggregate: Parts_Related_Aggregate;
  /** An array relationship */
  related_to: Array<Parts_Related>;
  /** An aggregate relationship */
  related_to_aggregate: Parts_Related_Aggregate;
  /** An array relationship */
  request: Array<Part_Request>;
  /** An aggregate relationship */
  request_aggregate: Part_Request_Aggregate;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Part_Status_Enum>;
  unitCostEstimate?: Maybe<Scalars['numeric']>;
  unitCostMaterial?: Maybe<Scalars['money']>;
  /** An object relationship */
  uomCommodity?: Maybe<Uom>;
  uomCommodityId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  uomEstimate?: Maybe<Uom>;
  uomEstimateId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  uomMaterial?: Maybe<Uom>;
  uomMaterialId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  uomMaterialIssued?: Maybe<Uom>;
  uomMaterialIssuedId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  uomTakeOff?: Maybe<Uom>;
  uomTakeOffId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  updated_by_user?: Maybe<User_Info>;
  /** An array relationship */
  vendors: Array<Vendor_Parts>;
  /** An aggregate relationship */
  vendors_aggregate: Vendor_Parts_Aggregate;
  /** An array relationship */
  warehouse_details: Array<Part_Warehouse_Detail>;
  /** An aggregate relationship */
  warehouse_details_aggregate: Part_Warehouse_Detail_Aggregate;
  wasteMaterial?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  workflows: Array<Workflow>;
  /** An aggregate relationship */
  workflows_aggregate: Workflow_Aggregate;
};


/** columns and relationships of "part" */
export type PartBom_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartBom_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartBom_TagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartBom_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartBomsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartBoms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartConsumable_Bom_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartConsumable_Bom_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartManufacturersArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartManufacturers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartMeasuresArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartMeasures_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartPart_Number_HistoriesArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartPart_Number_Histories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRelated_FromArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRelated_From_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRelated_ToArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRelated_To_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRequestArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartRequest_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartVendorsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartVendors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartWarehouse_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartWarehouse_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartWorkflowsArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


/** columns and relationships of "part" */
export type PartWorkflows_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};

/** aggregated selection of "part" */
export type Part_Aggregate = {
  __typename?: 'part_aggregate';
  aggregate?: Maybe<Part_Aggregate_Fields>;
  nodes: Array<Part>;
};

export type Part_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Part_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Part_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Part_Aggregate_Bool_Exp_Count>;
};

export type Part_Aggregate_Bool_Exp_Bool_And = {
  arguments: Part_Select_Column_Part_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Part_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Part_Select_Column_Part_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Part_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "part" */
export type Part_Aggregate_Fields = {
  __typename?: 'part_aggregate_fields';
  avg?: Maybe<Part_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Part_Max_Fields>;
  min?: Maybe<Part_Min_Fields>;
  stddev?: Maybe<Part_Stddev_Fields>;
  stddev_pop?: Maybe<Part_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Part_Stddev_Samp_Fields>;
  sum?: Maybe<Part_Sum_Fields>;
  var_pop?: Maybe<Part_Var_Pop_Fields>;
  var_samp?: Maybe<Part_Var_Samp_Fields>;
  variance?: Maybe<Part_Variance_Fields>;
};


/** aggregate fields of "part" */
export type Part_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "part" */
export type Part_Aggregate_Order_By = {
  avg?: InputMaybe<Part_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Part_Max_Order_By>;
  min?: InputMaybe<Part_Min_Order_By>;
  stddev?: InputMaybe<Part_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Part_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Part_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Part_Sum_Order_By>;
  var_pop?: InputMaybe<Part_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Part_Var_Samp_Order_By>;
  variance?: InputMaybe<Part_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "part" */
export type Part_Arr_Rel_Insert_Input = {
  data: Array<Part_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_On_Conflict>;
};

/** aggregate avg on columns */
export type Part_Avg_Fields = {
  __typename?: 'part_avg_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "part" */
export type Part_Avg_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "part". All fields are combined with a logical 'AND'. */
export type Part_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Bool_Exp>>;
  _not?: InputMaybe<Part_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Bool_Exp>>;
  bom_details?: InputMaybe<Bom_Detail_Bool_Exp>;
  bom_details_aggregate?: InputMaybe<Bom_Detail_Aggregate_Bool_Exp>;
  bom_tags?: InputMaybe<Tag_Entity_Bool_Exp>;
  bom_tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Bool_Exp>;
  boms?: InputMaybe<Item_Bom_Bool_Exp>;
  boms_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  consumable_bom_details?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
  consumable_bom_details_aggregate?: InputMaybe<Consumable_Bom_Detail_Aggregate_Bool_Exp>;
  conversionRateCommodity?: InputMaybe<Numeric_Comparison_Exp>;
  conversionRateEstimate?: InputMaybe<Numeric_Comparison_Exp>;
  conversionRateMaterial?: InputMaybe<Numeric_Comparison_Exp>;
  conversionRateMaterialIssued?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Info_Bool_Exp>;
  csi?: InputMaybe<Csi_Bool_Exp>;
  csiId?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  est_daily_consumption?: InputMaybe<String_Comparison_Exp>;
  finishColor?: InputMaybe<String_Comparison_Exp>;
  hasLedgerEntries?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  inBLOXCatalog?: InputMaybe<Boolean_Comparison_Exp>;
  inventoryClassification?: InputMaybe<String_Comparison_Exp>;
  isApprovedByAppDesign?: InputMaybe<Boolean_Comparison_Exp>;
  isApprovedByFinance?: InputMaybe<Boolean_Comparison_Exp>;
  isApprovedBySupplyChain?: InputMaybe<Boolean_Comparison_Exp>;
  isInQuickBooks?: InputMaybe<Boolean_Comparison_Exp>;
  itemType?: InputMaybe<String_Comparison_Exp>;
  kbb_id?: InputMaybe<String_Comparison_Exp>;
  manufacturers?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
  manufacturers_aggregate?: InputMaybe<Manufacturer_Parts_Aggregate_Bool_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  maxDailyConsumption?: InputMaybe<String_Comparison_Exp>;
  measures?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
  measures_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  on_pfep?: InputMaybe<Boolean_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
  partType?: InputMaybe<String_Comparison_Exp>;
  part_number_histories?: InputMaybe<Part_Number_History_Bool_Exp>;
  part_number_histories_aggregate?: InputMaybe<Part_Number_History_Aggregate_Bool_Exp>;
  part_status?: InputMaybe<Part_Status_Bool_Exp>;
  part_type?: InputMaybe<String_Comparison_Exp>;
  purchaseType?: InputMaybe<Purchase_Type_Bool_Exp>;
  purchaseTypeId?: InputMaybe<Int_Comparison_Exp>;
  purchaseTypeStatus?: InputMaybe<String_Comparison_Exp>;
  qb_details?: InputMaybe<Qb_Items_Bool_Exp>;
  related_from?: InputMaybe<Parts_Related_Bool_Exp>;
  related_from_aggregate?: InputMaybe<Parts_Related_Aggregate_Bool_Exp>;
  related_to?: InputMaybe<Parts_Related_Bool_Exp>;
  related_to_aggregate?: InputMaybe<Parts_Related_Aggregate_Bool_Exp>;
  request?: InputMaybe<Part_Request_Bool_Exp>;
  request_aggregate?: InputMaybe<Part_Request_Aggregate_Bool_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  sourceUrl?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Part_Status_Enum_Comparison_Exp>;
  unitCostEstimate?: InputMaybe<Numeric_Comparison_Exp>;
  unitCostMaterial?: InputMaybe<Money_Comparison_Exp>;
  uomCommodity?: InputMaybe<Uom_Bool_Exp>;
  uomCommodityId?: InputMaybe<Int_Comparison_Exp>;
  uomEstimate?: InputMaybe<Uom_Bool_Exp>;
  uomEstimateId?: InputMaybe<Int_Comparison_Exp>;
  uomMaterial?: InputMaybe<Uom_Bool_Exp>;
  uomMaterialId?: InputMaybe<Int_Comparison_Exp>;
  uomMaterialIssued?: InputMaybe<Uom_Bool_Exp>;
  uomMaterialIssuedId?: InputMaybe<Int_Comparison_Exp>;
  uomTakeOff?: InputMaybe<Uom_Bool_Exp>;
  uomTakeOffId?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Info_Bool_Exp>;
  vendors?: InputMaybe<Vendor_Parts_Bool_Exp>;
  vendors_aggregate?: InputMaybe<Vendor_Parts_Aggregate_Bool_Exp>;
  warehouse_details?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
  warehouse_details_aggregate?: InputMaybe<Part_Warehouse_Detail_Aggregate_Bool_Exp>;
  wasteMaterial?: InputMaybe<Numeric_Comparison_Exp>;
  workflows?: InputMaybe<Workflow_Bool_Exp>;
  workflows_aggregate?: InputMaybe<Workflow_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "part" */
export type Part_Constraint =
  /** unique or primary key constraint on columns "partNumber" */
  | 'part_partNumber_key'
  /** unique or primary key constraint on columns "id" */
  | 'part_pkey';

/** columns and relationships of "part_download_view" */
export type Part_Download_View = {
  __typename?: 'part_download_view';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  csi_level_1?: Maybe<Scalars['String']>;
  csi_level_2?: Maybe<Scalars['String']>;
  csi_level_3?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  inventory_classification?: Maybe<Scalars['String']>;
  is_app_design_approved?: Maybe<Scalars['Boolean']>;
  is_finance_approved?: Maybe<Scalars['Boolean']>;
  is_in_accounting_system?: Maybe<Scalars['Boolean']>;
  is_supply_chain_approved?: Maybe<Scalars['Boolean']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};

/** aggregated selection of "part_download_view" */
export type Part_Download_View_Aggregate = {
  __typename?: 'part_download_view_aggregate';
  aggregate?: Maybe<Part_Download_View_Aggregate_Fields>;
  nodes: Array<Part_Download_View>;
};

/** aggregate fields of "part_download_view" */
export type Part_Download_View_Aggregate_Fields = {
  __typename?: 'part_download_view_aggregate_fields';
  avg?: Maybe<Part_Download_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Part_Download_View_Max_Fields>;
  min?: Maybe<Part_Download_View_Min_Fields>;
  stddev?: Maybe<Part_Download_View_Stddev_Fields>;
  stddev_pop?: Maybe<Part_Download_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Part_Download_View_Stddev_Samp_Fields>;
  sum?: Maybe<Part_Download_View_Sum_Fields>;
  var_pop?: Maybe<Part_Download_View_Var_Pop_Fields>;
  var_samp?: Maybe<Part_Download_View_Var_Samp_Fields>;
  variance?: Maybe<Part_Download_View_Variance_Fields>;
};


/** aggregate fields of "part_download_view" */
export type Part_Download_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Download_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Part_Download_View_Avg_Fields = {
  __typename?: 'part_download_view_avg_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "part_download_view". All fields are combined with a logical 'AND'. */
export type Part_Download_View_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Download_View_Bool_Exp>>;
  _not?: InputMaybe<Part_Download_View_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Download_View_Bool_Exp>>;
  accounting_base_measure?: InputMaybe<Numeric_Comparison_Exp>;
  accounting_base_uom?: InputMaybe<String_Comparison_Exp>;
  ae_responsible?: InputMaybe<String_Comparison_Exp>;
  buyer?: InputMaybe<String_Comparison_Exp>;
  cogs_account?: InputMaybe<String_Comparison_Exp>;
  conversion_rate?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  csi_division?: InputMaybe<String_Comparison_Exp>;
  csi_level_1?: InputMaybe<String_Comparison_Exp>;
  csi_level_2?: InputMaybe<String_Comparison_Exp>;
  csi_level_3?: InputMaybe<String_Comparison_Exp>;
  cut_sheet_url?: InputMaybe<String_Comparison_Exp>;
  design_measure?: InputMaybe<Numeric_Comparison_Exp>;
  design_uom?: InputMaybe<String_Comparison_Exp>;
  est_daily_consumption?: InputMaybe<String_Comparison_Exp>;
  estimating_measure?: InputMaybe<Numeric_Comparison_Exp>;
  estimating_uom?: InputMaybe<String_Comparison_Exp>;
  finish_color?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  inventory_classification?: InputMaybe<String_Comparison_Exp>;
  is_app_design_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_finance_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_accounting_system?: InputMaybe<Boolean_Comparison_Exp>;
  is_supply_chain_approved?: InputMaybe<Boolean_Comparison_Exp>;
  issuing_measure?: InputMaybe<Numeric_Comparison_Exp>;
  issuing_uom?: InputMaybe<String_Comparison_Exp>;
  item_type?: InputMaybe<String_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  lot_size?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  manufacturer_part_number?: InputMaybe<String_Comparison_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  material_issued_uom?: InputMaybe<String_Comparison_Exp>;
  max_daily_consumption?: InputMaybe<String_Comparison_Exp>;
  minimum_order_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  old_part_numbers?: InputMaybe<String_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  preferred_supplier?: InputMaybe<String_Comparison_Exp>;
  preferred_supplier_part_number?: InputMaybe<String_Comparison_Exp>;
  purchase_type?: InputMaybe<String_Comparison_Exp>;
  purchase_uom?: InputMaybe<String_Comparison_Exp>;
  purchasing_measure?: InputMaybe<Numeric_Comparison_Exp>;
  purchasing_uom?: InputMaybe<String_Comparison_Exp>;
  receiving_measure?: InputMaybe<Numeric_Comparison_Exp>;
  receiving_uom?: InputMaybe<String_Comparison_Exp>;
  searchable_key_words?: InputMaybe<String_Comparison_Exp>;
  shipping_measure?: InputMaybe<Numeric_Comparison_Exp>;
  shipping_uom?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  standard_container_height?: InputMaybe<String_Comparison_Exp>;
  standard_container_length?: InputMaybe<String_Comparison_Exp>;
  standard_container_width?: InputMaybe<String_Comparison_Exp>;
  standard_lead_time_days?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  take_off_uom?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  warehouse_name?: InputMaybe<String_Comparison_Exp>;
  waste_material?: InputMaybe<Numeric_Comparison_Exp>;
  weight?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "part_download_view" */
export type Part_Download_View_Insert_Input = {
  accounting_base_measure?: InputMaybe<Scalars['numeric']>;
  accounting_base_uom?: InputMaybe<Scalars['String']>;
  ae_responsible?: InputMaybe<Scalars['String']>;
  buyer?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  conversion_rate?: InputMaybe<Scalars['numeric']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_division?: InputMaybe<Scalars['String']>;
  csi_level_1?: InputMaybe<Scalars['String']>;
  csi_level_2?: InputMaybe<Scalars['String']>;
  csi_level_3?: InputMaybe<Scalars['String']>;
  cut_sheet_url?: InputMaybe<Scalars['String']>;
  design_measure?: InputMaybe<Scalars['numeric']>;
  design_uom?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  estimating_measure?: InputMaybe<Scalars['numeric']>;
  estimating_uom?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  inventory_classification?: InputMaybe<Scalars['String']>;
  is_app_design_approved?: InputMaybe<Scalars['Boolean']>;
  is_finance_approved?: InputMaybe<Scalars['Boolean']>;
  is_in_accounting_system?: InputMaybe<Scalars['Boolean']>;
  is_supply_chain_approved?: InputMaybe<Scalars['Boolean']>;
  issuing_measure?: InputMaybe<Scalars['numeric']>;
  issuing_uom?: InputMaybe<Scalars['String']>;
  item_type?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  lot_size?: InputMaybe<Scalars['numeric']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  material_issued_uom?: InputMaybe<Scalars['String']>;
  max_daily_consumption?: InputMaybe<Scalars['String']>;
  minimum_order_quantity?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  old_part_numbers?: InputMaybe<Scalars['String']>;
  part_number?: InputMaybe<Scalars['String']>;
  preferred_supplier?: InputMaybe<Scalars['String']>;
  preferred_supplier_part_number?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  purchase_uom?: InputMaybe<Scalars['String']>;
  purchasing_measure?: InputMaybe<Scalars['numeric']>;
  purchasing_uom?: InputMaybe<Scalars['String']>;
  receiving_measure?: InputMaybe<Scalars['numeric']>;
  receiving_uom?: InputMaybe<Scalars['String']>;
  searchable_key_words?: InputMaybe<Scalars['String']>;
  shipping_measure?: InputMaybe<Scalars['numeric']>;
  shipping_uom?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  standard_container_height?: InputMaybe<Scalars['String']>;
  standard_container_length?: InputMaybe<Scalars['String']>;
  standard_container_width?: InputMaybe<Scalars['String']>;
  standard_lead_time_days?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  take_off_uom?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
  waste_material?: InputMaybe<Scalars['numeric']>;
  weight?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Download_View_Max_Fields = {
  __typename?: 'part_download_view_max_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  csi_level_1?: Maybe<Scalars['String']>;
  csi_level_2?: Maybe<Scalars['String']>;
  csi_level_3?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  inventory_classification?: Maybe<Scalars['String']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Download_View_Min_Fields = {
  __typename?: 'part_download_view_min_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  csi_level_1?: Maybe<Scalars['String']>;
  csi_level_2?: Maybe<Scalars['String']>;
  csi_level_3?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  inventory_classification?: Maybe<Scalars['String']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "part_download_view" */
export type Part_Download_View_Obj_Rel_Insert_Input = {
  data: Part_Download_View_Insert_Input;
};

/** Ordering options when selecting data from "part_download_view". */
export type Part_Download_View_Order_By = {
  accounting_base_measure?: InputMaybe<Order_By>;
  accounting_base_uom?: InputMaybe<Order_By>;
  ae_responsible?: InputMaybe<Order_By>;
  buyer?: InputMaybe<Order_By>;
  cogs_account?: InputMaybe<Order_By>;
  conversion_rate?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  csi_division?: InputMaybe<Order_By>;
  csi_level_1?: InputMaybe<Order_By>;
  csi_level_2?: InputMaybe<Order_By>;
  csi_level_3?: InputMaybe<Order_By>;
  cut_sheet_url?: InputMaybe<Order_By>;
  design_measure?: InputMaybe<Order_By>;
  design_uom?: InputMaybe<Order_By>;
  est_daily_consumption?: InputMaybe<Order_By>;
  estimating_measure?: InputMaybe<Order_By>;
  estimating_uom?: InputMaybe<Order_By>;
  finish_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  inventory_classification?: InputMaybe<Order_By>;
  is_app_design_approved?: InputMaybe<Order_By>;
  is_finance_approved?: InputMaybe<Order_By>;
  is_in_accounting_system?: InputMaybe<Order_By>;
  is_supply_chain_approved?: InputMaybe<Order_By>;
  issuing_measure?: InputMaybe<Order_By>;
  issuing_uom?: InputMaybe<Order_By>;
  item_type?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  material_issued_uom?: InputMaybe<Order_By>;
  max_daily_consumption?: InputMaybe<Order_By>;
  minimum_order_quantity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_part_numbers?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  preferred_supplier?: InputMaybe<Order_By>;
  preferred_supplier_part_number?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  purchase_uom?: InputMaybe<Order_By>;
  purchasing_measure?: InputMaybe<Order_By>;
  purchasing_uom?: InputMaybe<Order_By>;
  receiving_measure?: InputMaybe<Order_By>;
  receiving_uom?: InputMaybe<Order_By>;
  searchable_key_words?: InputMaybe<Order_By>;
  shipping_measure?: InputMaybe<Order_By>;
  shipping_uom?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  standard_container_height?: InputMaybe<Order_By>;
  standard_container_length?: InputMaybe<Order_By>;
  standard_container_width?: InputMaybe<Order_By>;
  standard_lead_time_days?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  take_off_uom?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  warehouse_name?: InputMaybe<Order_By>;
  waste_material?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** select columns of table "part_download_view" */
export type Part_Download_View_Select_Column =
  /** column name */
  | 'accounting_base_measure'
  /** column name */
  | 'accounting_base_uom'
  /** column name */
  | 'ae_responsible'
  /** column name */
  | 'buyer'
  /** column name */
  | 'cogs_account'
  /** column name */
  | 'conversion_rate'
  /** column name */
  | 'cost'
  /** column name */
  | 'csi_division'
  /** column name */
  | 'csi_level_1'
  /** column name */
  | 'csi_level_2'
  /** column name */
  | 'csi_level_3'
  /** column name */
  | 'cut_sheet_url'
  /** column name */
  | 'design_measure'
  /** column name */
  | 'design_uom'
  /** column name */
  | 'est_daily_consumption'
  /** column name */
  | 'estimating_measure'
  /** column name */
  | 'estimating_uom'
  /** column name */
  | 'finish_color'
  /** column name */
  | 'id'
  /** column name */
  | 'image_url'
  /** column name */
  | 'inventory_classification'
  /** column name */
  | 'is_app_design_approved'
  /** column name */
  | 'is_finance_approved'
  /** column name */
  | 'is_in_accounting_system'
  /** column name */
  | 'is_supply_chain_approved'
  /** column name */
  | 'issuing_measure'
  /** column name */
  | 'issuing_uom'
  /** column name */
  | 'item_type'
  /** column name */
  | 'location_name'
  /** column name */
  | 'lot_size'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'material'
  /** column name */
  | 'material_issued_uom'
  /** column name */
  | 'max_daily_consumption'
  /** column name */
  | 'minimum_order_quantity'
  /** column name */
  | 'name'
  /** column name */
  | 'old_part_numbers'
  /** column name */
  | 'part_number'
  /** column name */
  | 'preferred_supplier'
  /** column name */
  | 'preferred_supplier_part_number'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'purchase_uom'
  /** column name */
  | 'purchasing_measure'
  /** column name */
  | 'purchasing_uom'
  /** column name */
  | 'receiving_measure'
  /** column name */
  | 'receiving_uom'
  /** column name */
  | 'searchable_key_words'
  /** column name */
  | 'shipping_measure'
  /** column name */
  | 'shipping_uom'
  /** column name */
  | 'size'
  /** column name */
  | 'standard_container_height'
  /** column name */
  | 'standard_container_length'
  /** column name */
  | 'standard_container_width'
  /** column name */
  | 'standard_lead_time_days'
  /** column name */
  | 'status'
  /** column name */
  | 'take_off_uom'
  /** column name */
  | 'type'
  /** column name */
  | 'warehouse_name'
  /** column name */
  | 'waste_material'
  /** column name */
  | 'weight';

/** aggregate stddev on columns */
export type Part_Download_View_Stddev_Fields = {
  __typename?: 'part_download_view_stddev_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Part_Download_View_Stddev_Pop_Fields = {
  __typename?: 'part_download_view_stddev_pop_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Part_Download_View_Stddev_Samp_Fields = {
  __typename?: 'part_download_view_stddev_samp_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "part_download_view" */
export type Part_Download_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Download_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Download_View_Stream_Cursor_Value_Input = {
  accounting_base_measure?: InputMaybe<Scalars['numeric']>;
  accounting_base_uom?: InputMaybe<Scalars['String']>;
  ae_responsible?: InputMaybe<Scalars['String']>;
  buyer?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  conversion_rate?: InputMaybe<Scalars['numeric']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_division?: InputMaybe<Scalars['String']>;
  csi_level_1?: InputMaybe<Scalars['String']>;
  csi_level_2?: InputMaybe<Scalars['String']>;
  csi_level_3?: InputMaybe<Scalars['String']>;
  cut_sheet_url?: InputMaybe<Scalars['String']>;
  design_measure?: InputMaybe<Scalars['numeric']>;
  design_uom?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  estimating_measure?: InputMaybe<Scalars['numeric']>;
  estimating_uom?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  inventory_classification?: InputMaybe<Scalars['String']>;
  is_app_design_approved?: InputMaybe<Scalars['Boolean']>;
  is_finance_approved?: InputMaybe<Scalars['Boolean']>;
  is_in_accounting_system?: InputMaybe<Scalars['Boolean']>;
  is_supply_chain_approved?: InputMaybe<Scalars['Boolean']>;
  issuing_measure?: InputMaybe<Scalars['numeric']>;
  issuing_uom?: InputMaybe<Scalars['String']>;
  item_type?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  lot_size?: InputMaybe<Scalars['numeric']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  material_issued_uom?: InputMaybe<Scalars['String']>;
  max_daily_consumption?: InputMaybe<Scalars['String']>;
  minimum_order_quantity?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  old_part_numbers?: InputMaybe<Scalars['String']>;
  part_number?: InputMaybe<Scalars['String']>;
  preferred_supplier?: InputMaybe<Scalars['String']>;
  preferred_supplier_part_number?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  purchase_uom?: InputMaybe<Scalars['String']>;
  purchasing_measure?: InputMaybe<Scalars['numeric']>;
  purchasing_uom?: InputMaybe<Scalars['String']>;
  receiving_measure?: InputMaybe<Scalars['numeric']>;
  receiving_uom?: InputMaybe<Scalars['String']>;
  searchable_key_words?: InputMaybe<Scalars['String']>;
  shipping_measure?: InputMaybe<Scalars['numeric']>;
  shipping_uom?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  standard_container_height?: InputMaybe<Scalars['String']>;
  standard_container_length?: InputMaybe<Scalars['String']>;
  standard_container_width?: InputMaybe<Scalars['String']>;
  standard_lead_time_days?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  take_off_uom?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
  waste_material?: InputMaybe<Scalars['numeric']>;
  weight?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Part_Download_View_Sum_Fields = {
  __typename?: 'part_download_view_sum_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  design_measure?: Maybe<Scalars['numeric']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  lot_size?: Maybe<Scalars['numeric']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  waste_material?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Part_Download_View_Var_Pop_Fields = {
  __typename?: 'part_download_view_var_pop_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Part_Download_View_Var_Samp_Fields = {
  __typename?: 'part_download_view_var_samp_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Part_Download_View_Variance_Fields = {
  __typename?: 'part_download_view_variance_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** input type for incrementing numeric columns in table "part" */
export type Part_Inc_Input = {
  conversionRateCommodity?: InputMaybe<Scalars['numeric']>;
  conversionRateEstimate?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterial?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: InputMaybe<Scalars['numeric']>;
  purchaseTypeId?: InputMaybe<Scalars['Int']>;
  unitCostEstimate?: InputMaybe<Scalars['numeric']>;
  unitCostMaterial?: InputMaybe<Scalars['money']>;
  uomCommodityId?: InputMaybe<Scalars['Int']>;
  uomEstimateId?: InputMaybe<Scalars['Int']>;
  uomMaterialId?: InputMaybe<Scalars['Int']>;
  uomMaterialIssuedId?: InputMaybe<Scalars['Int']>;
  uomTakeOffId?: InputMaybe<Scalars['Int']>;
  wasteMaterial?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "part" */
export type Part_Insert_Input = {
  bom_details?: InputMaybe<Bom_Detail_Arr_Rel_Insert_Input>;
  bom_tags?: InputMaybe<Tag_Entity_Arr_Rel_Insert_Input>;
  boms?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  category?: InputMaybe<Scalars['String']>;
  consumable_bom_details?: InputMaybe<Consumable_Bom_Detail_Arr_Rel_Insert_Input>;
  conversionRateCommodity?: InputMaybe<Scalars['numeric']>;
  conversionRateEstimate?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterial?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  csi?: InputMaybe<Csi_Obj_Rel_Insert_Input>;
  csiId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  finishColor?: InputMaybe<Scalars['String']>;
  hasLedgerEntries?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inBLOXCatalog?: InputMaybe<Scalars['Boolean']>;
  inventoryClassification?: InputMaybe<Scalars['String']>;
  isApprovedByAppDesign?: InputMaybe<Scalars['Boolean']>;
  isApprovedByFinance?: InputMaybe<Scalars['Boolean']>;
  isApprovedBySupplyChain?: InputMaybe<Scalars['Boolean']>;
  isInQuickBooks?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  kbb_id?: InputMaybe<Scalars['String']>;
  manufacturers?: InputMaybe<Manufacturer_Parts_Arr_Rel_Insert_Input>;
  material?: InputMaybe<Scalars['String']>;
  maxDailyConsumption?: InputMaybe<Scalars['String']>;
  measures?: InputMaybe<Uom_Scope_Part_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  on_pfep?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  part_number_histories?: InputMaybe<Part_Number_History_Arr_Rel_Insert_Input>;
  part_status?: InputMaybe<Part_Status_Obj_Rel_Insert_Input>;
  part_type?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Purchase_Type_Obj_Rel_Insert_Input>;
  purchaseTypeId?: InputMaybe<Scalars['Int']>;
  purchaseTypeStatus?: InputMaybe<Scalars['String']>;
  qb_details?: InputMaybe<Qb_Items_Obj_Rel_Insert_Input>;
  related_from?: InputMaybe<Parts_Related_Arr_Rel_Insert_Input>;
  related_to?: InputMaybe<Parts_Related_Arr_Rel_Insert_Input>;
  request?: InputMaybe<Part_Request_Arr_Rel_Insert_Input>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Part_Status_Enum>;
  unitCostEstimate?: InputMaybe<Scalars['numeric']>;
  unitCostMaterial?: InputMaybe<Scalars['money']>;
  uomCommodity?: InputMaybe<Uom_Obj_Rel_Insert_Input>;
  uomCommodityId?: InputMaybe<Scalars['Int']>;
  uomEstimate?: InputMaybe<Uom_Obj_Rel_Insert_Input>;
  uomEstimateId?: InputMaybe<Scalars['Int']>;
  uomMaterial?: InputMaybe<Uom_Obj_Rel_Insert_Input>;
  uomMaterialId?: InputMaybe<Scalars['Int']>;
  uomMaterialIssued?: InputMaybe<Uom_Obj_Rel_Insert_Input>;
  uomMaterialIssuedId?: InputMaybe<Scalars['Int']>;
  uomTakeOff?: InputMaybe<Uom_Obj_Rel_Insert_Input>;
  uomTakeOffId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  updated_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  vendors?: InputMaybe<Vendor_Parts_Arr_Rel_Insert_Input>;
  warehouse_details?: InputMaybe<Part_Warehouse_Detail_Arr_Rel_Insert_Input>;
  wasteMaterial?: InputMaybe<Scalars['numeric']>;
  workflows?: InputMaybe<Workflow_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Part_Max_Fields = {
  __typename?: 'part_max_fields';
  category?: Maybe<Scalars['String']>;
  conversionRateCommodity?: Maybe<Scalars['numeric']>;
  conversionRateEstimate?: Maybe<Scalars['numeric']>;
  conversionRateMaterial?: Maybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  csiId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  finishColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  inventoryClassification?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxDailyConsumption?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partType?: Maybe<Scalars['String']>;
  part_type?: Maybe<Scalars['String']>;
  purchaseTypeId?: Maybe<Scalars['Int']>;
  purchaseTypeStatus?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  unitCostEstimate?: Maybe<Scalars['numeric']>;
  unitCostMaterial?: Maybe<Scalars['money']>;
  uomCommodityId?: Maybe<Scalars['Int']>;
  uomEstimateId?: Maybe<Scalars['Int']>;
  uomMaterialId?: Maybe<Scalars['Int']>;
  uomMaterialIssuedId?: Maybe<Scalars['Int']>;
  uomTakeOffId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  wasteMaterial?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "part" */
export type Part_Max_Order_By = {
  category?: InputMaybe<Order_By>;
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  csiId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  est_daily_consumption?: InputMaybe<Order_By>;
  finishColor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  inventoryClassification?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  kbb_id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  maxDailyConsumption?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  part_type?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  purchaseTypeStatus?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Part_Min_Fields = {
  __typename?: 'part_min_fields';
  category?: Maybe<Scalars['String']>;
  conversionRateCommodity?: Maybe<Scalars['numeric']>;
  conversionRateEstimate?: Maybe<Scalars['numeric']>;
  conversionRateMaterial?: Maybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  csiId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  finishColor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  inventoryClassification?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  kbb_id?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  maxDailyConsumption?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  partType?: Maybe<Scalars['String']>;
  part_type?: Maybe<Scalars['String']>;
  purchaseTypeId?: Maybe<Scalars['Int']>;
  purchaseTypeStatus?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  unitCostEstimate?: Maybe<Scalars['numeric']>;
  unitCostMaterial?: Maybe<Scalars['money']>;
  uomCommodityId?: Maybe<Scalars['Int']>;
  uomEstimateId?: Maybe<Scalars['Int']>;
  uomMaterialId?: Maybe<Scalars['Int']>;
  uomMaterialIssuedId?: Maybe<Scalars['Int']>;
  uomTakeOffId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  wasteMaterial?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "part" */
export type Part_Min_Order_By = {
  category?: InputMaybe<Order_By>;
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  csiId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  est_daily_consumption?: InputMaybe<Order_By>;
  finishColor?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  inventoryClassification?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  kbb_id?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  maxDailyConsumption?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  part_type?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  purchaseTypeStatus?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "part" */
export type Part_Mutation_Response = {
  __typename?: 'part_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part>;
};

/** columns and relationships of "part_number_history" */
export type Part_Number_History = {
  __typename?: 'part_number_history';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  id: Scalars['uuid'];
  new_part_number: Scalars['String'];
  old_part_number: Scalars['String'];
  /** An object relationship */
  part: Part;
  partId: Scalars['String'];
};

/** aggregated selection of "part_number_history" */
export type Part_Number_History_Aggregate = {
  __typename?: 'part_number_history_aggregate';
  aggregate?: Maybe<Part_Number_History_Aggregate_Fields>;
  nodes: Array<Part_Number_History>;
};

export type Part_Number_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Part_Number_History_Aggregate_Bool_Exp_Count>;
};

export type Part_Number_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Number_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "part_number_history" */
export type Part_Number_History_Aggregate_Fields = {
  __typename?: 'part_number_history_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Number_History_Max_Fields>;
  min?: Maybe<Part_Number_History_Min_Fields>;
};


/** aggregate fields of "part_number_history" */
export type Part_Number_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "part_number_history" */
export type Part_Number_History_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Part_Number_History_Max_Order_By>;
  min?: InputMaybe<Part_Number_History_Min_Order_By>;
};

/** input type for inserting array relation for remote table "part_number_history" */
export type Part_Number_History_Arr_Rel_Insert_Input = {
  data: Array<Part_Number_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_Number_History_On_Conflict>;
};

/** Boolean expression to filter rows from the table "part_number_history". All fields are combined with a logical 'AND'. */
export type Part_Number_History_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Number_History_Bool_Exp>>;
  _not?: InputMaybe<Part_Number_History_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Number_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  new_part_number?: InputMaybe<String_Comparison_Exp>;
  old_part_number?: InputMaybe<String_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  partId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_number_history" */
export type Part_Number_History_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'part_number_history_pkey';

/** input type for inserting data into table "part_number_history" */
export type Part_Number_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_part_number?: InputMaybe<Scalars['String']>;
  old_part_number?: InputMaybe<Scalars['String']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  partId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Number_History_Max_Fields = {
  __typename?: 'part_number_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  new_part_number?: Maybe<Scalars['String']>;
  old_part_number?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "part_number_history" */
export type Part_Number_History_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_part_number?: InputMaybe<Order_By>;
  old_part_number?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Part_Number_History_Min_Fields = {
  __typename?: 'part_number_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  new_part_number?: Maybe<Scalars['String']>;
  old_part_number?: Maybe<Scalars['String']>;
  partId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "part_number_history" */
export type Part_Number_History_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_part_number?: InputMaybe<Order_By>;
  old_part_number?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "part_number_history" */
export type Part_Number_History_Mutation_Response = {
  __typename?: 'part_number_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Number_History>;
};

/** on_conflict condition type for table "part_number_history" */
export type Part_Number_History_On_Conflict = {
  constraint: Part_Number_History_Constraint;
  update_columns?: Array<Part_Number_History_Update_Column>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};

/** Ordering options when selecting data from "part_number_history". */
export type Part_Number_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_part_number?: InputMaybe<Order_By>;
  old_part_number?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  partId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_number_history */
export type Part_Number_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "part_number_history" */
export type Part_Number_History_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'new_part_number'
  /** column name */
  | 'old_part_number'
  /** column name */
  | 'partId';

/** input type for updating data in table "part_number_history" */
export type Part_Number_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_part_number?: InputMaybe<Scalars['String']>;
  old_part_number?: InputMaybe<Scalars['String']>;
  partId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_number_history" */
export type Part_Number_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Number_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Number_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  new_part_number?: InputMaybe<Scalars['String']>;
  old_part_number?: InputMaybe<Scalars['String']>;
  partId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_number_history" */
export type Part_Number_History_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'new_part_number'
  /** column name */
  | 'old_part_number'
  /** column name */
  | 'partId';

export type Part_Number_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Number_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Number_History_Bool_Exp;
};

/** columns and relationships of "part_number_lookup_view" */
export type Part_Number_Lookup_View = {
  __typename?: 'part_number_lookup_view';
  current?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
};

/** aggregated selection of "part_number_lookup_view" */
export type Part_Number_Lookup_View_Aggregate = {
  __typename?: 'part_number_lookup_view_aggregate';
  aggregate?: Maybe<Part_Number_Lookup_View_Aggregate_Fields>;
  nodes: Array<Part_Number_Lookup_View>;
};

/** aggregate fields of "part_number_lookup_view" */
export type Part_Number_Lookup_View_Aggregate_Fields = {
  __typename?: 'part_number_lookup_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Number_Lookup_View_Max_Fields>;
  min?: Maybe<Part_Number_Lookup_View_Min_Fields>;
};


/** aggregate fields of "part_number_lookup_view" */
export type Part_Number_Lookup_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Number_Lookup_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_number_lookup_view". All fields are combined with a logical 'AND'. */
export type Part_Number_Lookup_View_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Number_Lookup_View_Bool_Exp>>;
  _not?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Number_Lookup_View_Bool_Exp>>;
  current?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  partNumber?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Part_Number_Lookup_View_Max_Fields = {
  __typename?: 'part_number_lookup_view_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Number_Lookup_View_Min_Fields = {
  __typename?: 'part_number_lookup_view_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "part_number_lookup_view". */
export type Part_Number_Lookup_View_Order_By = {
  current?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
};

/** select columns of table "part_number_lookup_view" */
export type Part_Number_Lookup_View_Select_Column =
  /** column name */
  | 'current'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'partNumber';

/** Streaming cursor of the table "part_number_lookup_view" */
export type Part_Number_Lookup_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Number_Lookup_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Number_Lookup_View_Stream_Cursor_Value_Input = {
  current?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "part" */
export type Part_Obj_Rel_Insert_Input = {
  data: Part_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_On_Conflict>;
};

/** on_conflict condition type for table "part" */
export type Part_On_Conflict = {
  constraint: Part_Constraint;
  update_columns?: Array<Part_Update_Column>;
  where?: InputMaybe<Part_Bool_Exp>;
};

/** Ordering options when selecting data from "part". */
export type Part_Order_By = {
  bom_details_aggregate?: InputMaybe<Bom_Detail_Aggregate_Order_By>;
  bom_tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Order_By>;
  boms_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  category?: InputMaybe<Order_By>;
  consumable_bom_details_aggregate?: InputMaybe<Consumable_Bom_Detail_Aggregate_Order_By>;
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Info_Order_By>;
  csi?: InputMaybe<Csi_Order_By>;
  csiId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  est_daily_consumption?: InputMaybe<Order_By>;
  finishColor?: InputMaybe<Order_By>;
  hasLedgerEntries?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  inBLOXCatalog?: InputMaybe<Order_By>;
  inventoryClassification?: InputMaybe<Order_By>;
  isApprovedByAppDesign?: InputMaybe<Order_By>;
  isApprovedByFinance?: InputMaybe<Order_By>;
  isApprovedBySupplyChain?: InputMaybe<Order_By>;
  isInQuickBooks?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  kbb_id?: InputMaybe<Order_By>;
  manufacturers_aggregate?: InputMaybe<Manufacturer_Parts_Aggregate_Order_By>;
  material?: InputMaybe<Order_By>;
  maxDailyConsumption?: InputMaybe<Order_By>;
  measures_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  on_pfep?: InputMaybe<Order_By>;
  partNumber?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  part_number_histories_aggregate?: InputMaybe<Part_Number_History_Aggregate_Order_By>;
  part_status?: InputMaybe<Part_Status_Order_By>;
  part_type?: InputMaybe<Order_By>;
  purchaseType?: InputMaybe<Purchase_Type_Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  purchaseTypeStatus?: InputMaybe<Order_By>;
  qb_details?: InputMaybe<Qb_Items_Order_By>;
  related_from_aggregate?: InputMaybe<Parts_Related_Aggregate_Order_By>;
  related_to_aggregate?: InputMaybe<Parts_Related_Aggregate_Order_By>;
  request_aggregate?: InputMaybe<Part_Request_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodity?: InputMaybe<Uom_Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimate?: InputMaybe<Uom_Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterial?: InputMaybe<Uom_Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssued?: InputMaybe<Uom_Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOff?: InputMaybe<Uom_Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Info_Order_By>;
  vendors_aggregate?: InputMaybe<Vendor_Parts_Aggregate_Order_By>;
  warehouse_details_aggregate?: InputMaybe<Part_Warehouse_Detail_Aggregate_Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
  workflows_aggregate?: InputMaybe<Workflow_Aggregate_Order_By>;
};

/** primary key columns input for table: part */
export type Part_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** columns and relationships of "part_request" */
export type Part_Request = {
  __typename?: 'part_request';
  ai_audit?: Maybe<Scalars['jsonb']>;
  approved_by?: Maybe<Scalars['String']>;
  blox_part_number: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  created_by_user?: Maybe<User_Info>;
  /** An object relationship */
  created_part?: Maybe<Part>;
  created_part_id?: Maybe<Scalars['String']>;
  csi_division?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  itemType?: Maybe<Scalars['String']>;
  lead_time_days?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  packageUrl?: Maybe<Scalars['String']>;
  partType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  program?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  reason_select?: Maybe<Scalars['String']>;
  reason_text?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplier?: Maybe<Scalars['String']>;
  supplyChainDataUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  updated_by_user?: Maybe<User_Info>;
};


/** columns and relationships of "part_request" */
export type Part_RequestAi_AuditArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "part_request" */
export type Part_Request_Aggregate = {
  __typename?: 'part_request_aggregate';
  aggregate?: Maybe<Part_Request_Aggregate_Fields>;
  nodes: Array<Part_Request>;
};

export type Part_Request_Aggregate_Bool_Exp = {
  count?: InputMaybe<Part_Request_Aggregate_Bool_Exp_Count>;
};

export type Part_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Part_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "part_request" */
export type Part_Request_Aggregate_Fields = {
  __typename?: 'part_request_aggregate_fields';
  avg?: Maybe<Part_Request_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Part_Request_Max_Fields>;
  min?: Maybe<Part_Request_Min_Fields>;
  stddev?: Maybe<Part_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Part_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Part_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Part_Request_Sum_Fields>;
  var_pop?: Maybe<Part_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Part_Request_Var_Samp_Fields>;
  variance?: Maybe<Part_Request_Variance_Fields>;
};


/** aggregate fields of "part_request" */
export type Part_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "part_request" */
export type Part_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Part_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Part_Request_Max_Order_By>;
  min?: InputMaybe<Part_Request_Min_Order_By>;
  stddev?: InputMaybe<Part_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Part_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Part_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Part_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Part_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Part_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Part_Request_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Part_Request_Append_Input = {
  ai_audit?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "part_request" */
export type Part_Request_Arr_Rel_Insert_Input = {
  data: Array<Part_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Part_Request_Avg_Fields = {
  __typename?: 'part_request_avg_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "part_request" */
export type Part_Request_Avg_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "part_request". All fields are combined with a logical 'AND'. */
export type Part_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Request_Bool_Exp>>;
  _not?: InputMaybe<Part_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Request_Bool_Exp>>;
  ai_audit?: InputMaybe<Jsonb_Comparison_Exp>;
  approved_by?: InputMaybe<String_Comparison_Exp>;
  blox_part_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Info_Bool_Exp>;
  created_part?: InputMaybe<Part_Bool_Exp>;
  created_part_id?: InputMaybe<String_Comparison_Exp>;
  csi_division?: InputMaybe<String_Comparison_Exp>;
  cutSheetUrl?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  finish_color?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  itemType?: InputMaybe<String_Comparison_Exp>;
  lead_time_days?: InputMaybe<Int_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  manufacturer_part_number?: InputMaybe<String_Comparison_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  packageUrl?: InputMaybe<String_Comparison_Exp>;
  partType?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  program?: InputMaybe<String_Comparison_Exp>;
  purchase_type?: InputMaybe<String_Comparison_Exp>;
  reason_select?: InputMaybe<String_Comparison_Exp>;
  reason_text?: InputMaybe<String_Comparison_Exp>;
  rejected_reason?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  sourceUrl?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplier?: InputMaybe<String_Comparison_Exp>;
  supplyChainDataUrl?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Bpchar_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Info_Bool_Exp>;
};

/** unique or primary key constraints on table "part_request" */
export type Part_Request_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'part_request_pkey';

/** columns and relationships of "part_request_cycle_time" */
export type Part_Request_Cycle_Time = {
  __typename?: 'part_request_cycle_time';
  interval?: Maybe<Scalars['interval']>;
};

/** aggregated selection of "part_request_cycle_time" */
export type Part_Request_Cycle_Time_Aggregate = {
  __typename?: 'part_request_cycle_time_aggregate';
  aggregate?: Maybe<Part_Request_Cycle_Time_Aggregate_Fields>;
  nodes: Array<Part_Request_Cycle_Time>;
};

/** aggregate fields of "part_request_cycle_time" */
export type Part_Request_Cycle_Time_Aggregate_Fields = {
  __typename?: 'part_request_cycle_time_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "part_request_cycle_time" */
export type Part_Request_Cycle_Time_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Request_Cycle_Time_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_request_cycle_time". All fields are combined with a logical 'AND'. */
export type Part_Request_Cycle_Time_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Request_Cycle_Time_Bool_Exp>>;
  _not?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Request_Cycle_Time_Bool_Exp>>;
  interval?: InputMaybe<Interval_Comparison_Exp>;
};

/** Ordering options when selecting data from "part_request_cycle_time". */
export type Part_Request_Cycle_Time_Order_By = {
  interval?: InputMaybe<Order_By>;
};

/** select columns of table "part_request_cycle_time" */
export type Part_Request_Cycle_Time_Select_Column =
  /** column name */
  | 'interval';

/** Streaming cursor of the table "part_request_cycle_time" */
export type Part_Request_Cycle_Time_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Request_Cycle_Time_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Request_Cycle_Time_Stream_Cursor_Value_Input = {
  interval?: InputMaybe<Scalars['interval']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Part_Request_Delete_At_Path_Input = {
  ai_audit?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Part_Request_Delete_Elem_Input = {
  ai_audit?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Part_Request_Delete_Key_Input = {
  ai_audit?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "part_request" */
export type Part_Request_Inc_Input = {
  lead_time_days?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "part_request" */
export type Part_Request_Insert_Input = {
  ai_audit?: InputMaybe<Scalars['jsonb']>;
  approved_by?: InputMaybe<Scalars['String']>;
  blox_part_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  created_part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  created_part_id?: InputMaybe<Scalars['String']>;
  csi_division?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  lead_time_days?: InputMaybe<Scalars['Int']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  packageUrl?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  program?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  reason_select?: InputMaybe<Scalars['String']>;
  reason_text?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier?: InputMaybe<Scalars['String']>;
  supplyChainDataUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  updated_by_user?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Part_Request_Max_Fields = {
  __typename?: 'part_request_max_fields';
  approved_by?: Maybe<Scalars['String']>;
  blox_part_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  created_part_id?: Maybe<Scalars['String']>;
  csi_division?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  lead_time_days?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  packageUrl?: Maybe<Scalars['String']>;
  partType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  program?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  reason_select?: Maybe<Scalars['String']>;
  reason_text?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplier?: Maybe<Scalars['String']>;
  supplyChainDataUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "part_request" */
export type Part_Request_Max_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  blox_part_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_part_id?: InputMaybe<Order_By>;
  csi_division?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  finish_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  packageUrl?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  reason_select?: InputMaybe<Order_By>;
  reason_text?: InputMaybe<Order_By>;
  rejected_reason?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  supplyChainDataUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Part_Request_Min_Fields = {
  __typename?: 'part_request_min_fields';
  approved_by?: Maybe<Scalars['String']>;
  blox_part_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  created_part_id?: Maybe<Scalars['String']>;
  csi_division?: Maybe<Scalars['String']>;
  cutSheetUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  lead_time_days?: Maybe<Scalars['Int']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  packageUrl?: Maybe<Scalars['String']>;
  partType?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  program?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  reason_select?: Maybe<Scalars['String']>;
  reason_text?: Maybe<Scalars['String']>;
  rejected_reason?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  supplier?: Maybe<Scalars['String']>;
  supplyChainDataUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['bpchar']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "part_request" */
export type Part_Request_Min_Order_By = {
  approved_by?: InputMaybe<Order_By>;
  blox_part_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_part_id?: InputMaybe<Order_By>;
  csi_division?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  finish_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  packageUrl?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  reason_select?: InputMaybe<Order_By>;
  reason_text?: InputMaybe<Order_By>;
  rejected_reason?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  supplyChainDataUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "part_request" */
export type Part_Request_Mutation_Response = {
  __typename?: 'part_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Request>;
};

/** on_conflict condition type for table "part_request" */
export type Part_Request_On_Conflict = {
  constraint: Part_Request_Constraint;
  update_columns?: Array<Part_Request_Update_Column>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "part_request". */
export type Part_Request_Order_By = {
  ai_audit?: InputMaybe<Order_By>;
  approved_by?: InputMaybe<Order_By>;
  blox_part_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Info_Order_By>;
  created_part?: InputMaybe<Part_Order_By>;
  created_part_id?: InputMaybe<Order_By>;
  csi_division?: InputMaybe<Order_By>;
  cutSheetUrl?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  finish_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemType?: InputMaybe<Order_By>;
  lead_time_days?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  packageUrl?: InputMaybe<Order_By>;
  partType?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  reason_select?: InputMaybe<Order_By>;
  reason_text?: InputMaybe<Order_By>;
  rejected_reason?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  sourceUrl?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplier?: InputMaybe<Order_By>;
  supplyChainDataUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Info_Order_By>;
};

/** primary key columns input for table: part_request */
export type Part_Request_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Part_Request_Prepend_Input = {
  ai_audit?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "part_request_reason" */
export type Part_Request_Reason = {
  __typename?: 'part_request_reason';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "part_request_reason" */
export type Part_Request_Reason_Aggregate = {
  __typename?: 'part_request_reason_aggregate';
  aggregate?: Maybe<Part_Request_Reason_Aggregate_Fields>;
  nodes: Array<Part_Request_Reason>;
};

/** aggregate fields of "part_request_reason" */
export type Part_Request_Reason_Aggregate_Fields = {
  __typename?: 'part_request_reason_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Request_Reason_Max_Fields>;
  min?: Maybe<Part_Request_Reason_Min_Fields>;
};


/** aggregate fields of "part_request_reason" */
export type Part_Request_Reason_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Request_Reason_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_request_reason". All fields are combined with a logical 'AND'. */
export type Part_Request_Reason_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Request_Reason_Bool_Exp>>;
  _not?: InputMaybe<Part_Request_Reason_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Request_Reason_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_request_reason" */
export type Part_Request_Reason_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'part_request_reason_pkey';

/** input type for inserting data into table "part_request_reason" */
export type Part_Request_Reason_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Request_Reason_Max_Fields = {
  __typename?: 'part_request_reason_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Request_Reason_Min_Fields = {
  __typename?: 'part_request_reason_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_request_reason" */
export type Part_Request_Reason_Mutation_Response = {
  __typename?: 'part_request_reason_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Request_Reason>;
};

/** on_conflict condition type for table "part_request_reason" */
export type Part_Request_Reason_On_Conflict = {
  constraint: Part_Request_Reason_Constraint;
  update_columns?: Array<Part_Request_Reason_Update_Column>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};

/** Ordering options when selecting data from "part_request_reason". */
export type Part_Request_Reason_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_request_reason */
export type Part_Request_Reason_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "part_request_reason" */
export type Part_Request_Reason_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "part_request_reason" */
export type Part_Request_Reason_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_request_reason" */
export type Part_Request_Reason_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Request_Reason_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Request_Reason_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_request_reason" */
export type Part_Request_Reason_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Part_Request_Reason_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Request_Reason_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Request_Reason_Bool_Exp;
};

/** select columns of table "part_request" */
export type Part_Request_Select_Column =
  /** column name */
  | 'ai_audit'
  /** column name */
  | 'approved_by'
  /** column name */
  | 'blox_part_number'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'created_part_id'
  /** column name */
  | 'csi_division'
  /** column name */
  | 'cutSheetUrl'
  /** column name */
  | 'description'
  /** column name */
  | 'finish_color'
  /** column name */
  | 'id'
  /** column name */
  | 'itemType'
  /** column name */
  | 'lead_time_days'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'material'
  /** column name */
  | 'notes'
  /** column name */
  | 'packageUrl'
  /** column name */
  | 'partType'
  /** column name */
  | 'price'
  /** column name */
  | 'program'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'reason_select'
  /** column name */
  | 'reason_text'
  /** column name */
  | 'rejected_reason'
  /** column name */
  | 'size'
  /** column name */
  | 'sourceUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier'
  /** column name */
  | 'supplyChainDataUrl'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for updating data in table "part_request" */
export type Part_Request_Set_Input = {
  ai_audit?: InputMaybe<Scalars['jsonb']>;
  approved_by?: InputMaybe<Scalars['String']>;
  blox_part_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_part_id?: InputMaybe<Scalars['String']>;
  csi_division?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  lead_time_days?: InputMaybe<Scalars['Int']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  packageUrl?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  program?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  reason_select?: InputMaybe<Scalars['String']>;
  reason_text?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier?: InputMaybe<Scalars['String']>;
  supplyChainDataUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "part_request_status" */
export type Part_Request_Status = {
  __typename?: 'part_request_status';
  description: Scalars['String'];
  /** An array relationship */
  part_requests: Array<Part_Request>;
  /** An aggregate relationship */
  part_requests_aggregate: Part_Request_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "part_request_status" */
export type Part_Request_StatusPart_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


/** columns and relationships of "part_request_status" */
export type Part_Request_StatusPart_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};

/** aggregated selection of "part_request_status" */
export type Part_Request_Status_Aggregate = {
  __typename?: 'part_request_status_aggregate';
  aggregate?: Maybe<Part_Request_Status_Aggregate_Fields>;
  nodes: Array<Part_Request_Status>;
};

/** aggregate fields of "part_request_status" */
export type Part_Request_Status_Aggregate_Fields = {
  __typename?: 'part_request_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Request_Status_Max_Fields>;
  min?: Maybe<Part_Request_Status_Min_Fields>;
};


/** aggregate fields of "part_request_status" */
export type Part_Request_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Request_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_request_status". All fields are combined with a logical 'AND'. */
export type Part_Request_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Request_Status_Bool_Exp>>;
  _not?: InputMaybe<Part_Request_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Request_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  part_requests?: InputMaybe<Part_Request_Bool_Exp>;
  part_requests_aggregate?: InputMaybe<Part_Request_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_request_status" */
export type Part_Request_Status_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'part_request_status_pkey';

/** input type for inserting data into table "part_request_status" */
export type Part_Request_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  part_requests?: InputMaybe<Part_Request_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Request_Status_Max_Fields = {
  __typename?: 'part_request_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Request_Status_Min_Fields = {
  __typename?: 'part_request_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_request_status" */
export type Part_Request_Status_Mutation_Response = {
  __typename?: 'part_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Request_Status>;
};

/** on_conflict condition type for table "part_request_status" */
export type Part_Request_Status_On_Conflict = {
  constraint: Part_Request_Status_Constraint;
  update_columns?: Array<Part_Request_Status_Update_Column>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "part_request_status". */
export type Part_Request_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  part_requests_aggregate?: InputMaybe<Part_Request_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_request_status */
export type Part_Request_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "part_request_status" */
export type Part_Request_Status_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "part_request_status" */
export type Part_Request_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_request_status" */
export type Part_Request_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Request_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Request_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_request_status" */
export type Part_Request_Status_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Part_Request_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Request_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Request_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Part_Request_Stddev_Fields = {
  __typename?: 'part_request_stddev_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "part_request" */
export type Part_Request_Stddev_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Part_Request_Stddev_Pop_Fields = {
  __typename?: 'part_request_stddev_pop_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "part_request" */
export type Part_Request_Stddev_Pop_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Part_Request_Stddev_Samp_Fields = {
  __typename?: 'part_request_stddev_samp_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "part_request" */
export type Part_Request_Stddev_Samp_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "part_request" */
export type Part_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Request_Stream_Cursor_Value_Input = {
  ai_audit?: InputMaybe<Scalars['jsonb']>;
  approved_by?: InputMaybe<Scalars['String']>;
  blox_part_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_part_id?: InputMaybe<Scalars['String']>;
  csi_division?: InputMaybe<Scalars['String']>;
  cutSheetUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  lead_time_days?: InputMaybe<Scalars['Int']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  packageUrl?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  program?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  reason_select?: InputMaybe<Scalars['String']>;
  reason_text?: InputMaybe<Scalars['String']>;
  rejected_reason?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier?: InputMaybe<Scalars['String']>;
  supplyChainDataUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['bpchar']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Part_Request_Sum_Fields = {
  __typename?: 'part_request_sum_fields';
  lead_time_days?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "part_request" */
export type Part_Request_Sum_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "part_request_type" */
export type Part_Request_Type = {
  __typename?: 'part_request_type';
  description: Scalars['String'];
  value: Scalars['String'];
};

/** aggregated selection of "part_request_type" */
export type Part_Request_Type_Aggregate = {
  __typename?: 'part_request_type_aggregate';
  aggregate?: Maybe<Part_Request_Type_Aggregate_Fields>;
  nodes: Array<Part_Request_Type>;
};

/** aggregate fields of "part_request_type" */
export type Part_Request_Type_Aggregate_Fields = {
  __typename?: 'part_request_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Request_Type_Max_Fields>;
  min?: Maybe<Part_Request_Type_Min_Fields>;
};


/** aggregate fields of "part_request_type" */
export type Part_Request_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Request_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_request_type". All fields are combined with a logical 'AND'. */
export type Part_Request_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Request_Type_Bool_Exp>>;
  _not?: InputMaybe<Part_Request_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Request_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_request_type" */
export type Part_Request_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'part_request_type_pkey';

/** input type for inserting data into table "part_request_type" */
export type Part_Request_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Request_Type_Max_Fields = {
  __typename?: 'part_request_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Request_Type_Min_Fields = {
  __typename?: 'part_request_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_request_type" */
export type Part_Request_Type_Mutation_Response = {
  __typename?: 'part_request_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Request_Type>;
};

/** on_conflict condition type for table "part_request_type" */
export type Part_Request_Type_On_Conflict = {
  constraint: Part_Request_Type_Constraint;
  update_columns?: Array<Part_Request_Type_Update_Column>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "part_request_type". */
export type Part_Request_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_request_type */
export type Part_Request_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "part_request_type" */
export type Part_Request_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "part_request_type" */
export type Part_Request_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_request_type" */
export type Part_Request_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Request_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Request_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_request_type" */
export type Part_Request_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Part_Request_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Request_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Request_Type_Bool_Exp;
};

/** update columns of table "part_request" */
export type Part_Request_Update_Column =
  /** column name */
  | 'ai_audit'
  /** column name */
  | 'approved_by'
  /** column name */
  | 'blox_part_number'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'created_part_id'
  /** column name */
  | 'csi_division'
  /** column name */
  | 'cutSheetUrl'
  /** column name */
  | 'description'
  /** column name */
  | 'finish_color'
  /** column name */
  | 'id'
  /** column name */
  | 'itemType'
  /** column name */
  | 'lead_time_days'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'material'
  /** column name */
  | 'notes'
  /** column name */
  | 'packageUrl'
  /** column name */
  | 'partType'
  /** column name */
  | 'price'
  /** column name */
  | 'program'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'reason_select'
  /** column name */
  | 'reason_text'
  /** column name */
  | 'rejected_reason'
  /** column name */
  | 'size'
  /** column name */
  | 'sourceUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'supplier'
  /** column name */
  | 'supplyChainDataUrl'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Part_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Part_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Part_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Part_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Part_Request_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Part_Request_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Part_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Part_Request_Var_Pop_Fields = {
  __typename?: 'part_request_var_pop_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "part_request" */
export type Part_Request_Var_Pop_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Part_Request_Var_Samp_Fields = {
  __typename?: 'part_request_var_samp_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "part_request" */
export type Part_Request_Var_Samp_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Part_Request_Variance_Fields = {
  __typename?: 'part_request_variance_fields';
  lead_time_days?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "part_request" */
export type Part_Request_Variance_Order_By = {
  lead_time_days?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** select columns of table "part" */
export type Part_Select_Column =
  /** column name */
  | 'category'
  /** column name */
  | 'conversionRateCommodity'
  /** column name */
  | 'conversionRateEstimate'
  /** column name */
  | 'conversionRateMaterial'
  /** column name */
  | 'conversionRateMaterialIssued'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'csiId'
  /** column name */
  | 'description'
  /** column name */
  | 'est_daily_consumption'
  /** column name */
  | 'finishColor'
  /** column name */
  | 'hasLedgerEntries'
  /** column name */
  | 'id'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'inBLOXCatalog'
  /** column name */
  | 'inventoryClassification'
  /** column name */
  | 'isApprovedByAppDesign'
  /** column name */
  | 'isApprovedByFinance'
  /** column name */
  | 'isApprovedBySupplyChain'
  /** column name */
  | 'isInQuickBooks'
  /** column name */
  | 'itemType'
  /** column name */
  | 'kbb_id'
  /** column name */
  | 'material'
  /** column name */
  | 'maxDailyConsumption'
  /** column name */
  | 'name'
  /** column name */
  | 'on_pfep'
  /** column name */
  | 'partNumber'
  /** column name */
  | 'partType'
  /** column name */
  | 'part_type'
  /** column name */
  | 'purchaseTypeId'
  /** column name */
  | 'purchaseTypeStatus'
  /** column name */
  | 'size'
  /** column name */
  | 'sourceUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'unitCostEstimate'
  /** column name */
  | 'unitCostMaterial'
  /** column name */
  | 'uomCommodityId'
  /** column name */
  | 'uomEstimateId'
  /** column name */
  | 'uomMaterialId'
  /** column name */
  | 'uomMaterialIssuedId'
  /** column name */
  | 'uomTakeOffId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'wasteMaterial';

/** select "part_aggregate_bool_exp_bool_and_arguments_columns" columns of table "part" */
export type Part_Select_Column_Part_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'hasLedgerEntries'
  /** column name */
  | 'inBLOXCatalog'
  /** column name */
  | 'isApprovedByAppDesign'
  /** column name */
  | 'isApprovedByFinance'
  /** column name */
  | 'isApprovedBySupplyChain'
  /** column name */
  | 'isInQuickBooks'
  /** column name */
  | 'on_pfep';

/** select "part_aggregate_bool_exp_bool_or_arguments_columns" columns of table "part" */
export type Part_Select_Column_Part_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'hasLedgerEntries'
  /** column name */
  | 'inBLOXCatalog'
  /** column name */
  | 'isApprovedByAppDesign'
  /** column name */
  | 'isApprovedByFinance'
  /** column name */
  | 'isApprovedBySupplyChain'
  /** column name */
  | 'isInQuickBooks'
  /** column name */
  | 'on_pfep';

/** input type for updating data in table "part" */
export type Part_Set_Input = {
  category?: InputMaybe<Scalars['String']>;
  conversionRateCommodity?: InputMaybe<Scalars['numeric']>;
  conversionRateEstimate?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterial?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  csiId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  finishColor?: InputMaybe<Scalars['String']>;
  hasLedgerEntries?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inBLOXCatalog?: InputMaybe<Scalars['Boolean']>;
  inventoryClassification?: InputMaybe<Scalars['String']>;
  isApprovedByAppDesign?: InputMaybe<Scalars['Boolean']>;
  isApprovedByFinance?: InputMaybe<Scalars['Boolean']>;
  isApprovedBySupplyChain?: InputMaybe<Scalars['Boolean']>;
  isInQuickBooks?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  kbb_id?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxDailyConsumption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  on_pfep?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  part_type?: InputMaybe<Scalars['String']>;
  purchaseTypeId?: InputMaybe<Scalars['Int']>;
  purchaseTypeStatus?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Part_Status_Enum>;
  unitCostEstimate?: InputMaybe<Scalars['numeric']>;
  unitCostMaterial?: InputMaybe<Scalars['money']>;
  uomCommodityId?: InputMaybe<Scalars['Int']>;
  uomEstimateId?: InputMaybe<Scalars['Int']>;
  uomMaterialId?: InputMaybe<Scalars['Int']>;
  uomMaterialIssuedId?: InputMaybe<Scalars['Int']>;
  uomTakeOffId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  wasteMaterial?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "part_status" */
export type Part_Status = {
  __typename?: 'part_status';
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  parts: Array<Part>;
  /** An aggregate relationship */
  parts_aggregate: Part_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "part_status" */
export type Part_StatusPartsArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


/** columns and relationships of "part_status" */
export type Part_StatusParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};

/** aggregated selection of "part_status" */
export type Part_Status_Aggregate = {
  __typename?: 'part_status_aggregate';
  aggregate?: Maybe<Part_Status_Aggregate_Fields>;
  nodes: Array<Part_Status>;
};

/** aggregate fields of "part_status" */
export type Part_Status_Aggregate_Fields = {
  __typename?: 'part_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Status_Max_Fields>;
  min?: Maybe<Part_Status_Min_Fields>;
};


/** aggregate fields of "part_status" */
export type Part_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_status". All fields are combined with a logical 'AND'. */
export type Part_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Status_Bool_Exp>>;
  _not?: InputMaybe<Part_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Status_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  parts?: InputMaybe<Part_Bool_Exp>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_status" */
export type Part_Status_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'part_status_pkey';

export type Part_Status_Enum =
  /** Active */
  | 'ACTIVE'
  /** Inactive */
  | 'INACTIVE'
  /** Obsolete */
  | 'OBSOLETE'
  /** Sunsetting */
  | 'SUNSETTING';

/** Boolean expression to compare columns of type "part_status_enum". All fields are combined with logical 'AND'. */
export type Part_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Part_Status_Enum>;
  _in?: InputMaybe<Array<Part_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Part_Status_Enum>;
  _nin?: InputMaybe<Array<Part_Status_Enum>>;
};

/** input type for inserting data into table "part_status" */
export type Part_Status_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  parts?: InputMaybe<Part_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Status_Max_Fields = {
  __typename?: 'part_status_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Status_Min_Fields = {
  __typename?: 'part_status_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_status" */
export type Part_Status_Mutation_Response = {
  __typename?: 'part_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Status>;
};

/** input type for inserting object relation for remote table "part_status" */
export type Part_Status_Obj_Rel_Insert_Input = {
  data: Part_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_Status_On_Conflict>;
};

/** on_conflict condition type for table "part_status" */
export type Part_Status_On_Conflict = {
  constraint: Part_Status_Constraint;
  update_columns?: Array<Part_Status_Update_Column>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "part_status". */
export type Part_Status_Order_By = {
  description?: InputMaybe<Order_By>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_status */
export type Part_Status_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "part_status" */
export type Part_Status_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "part_status" */
export type Part_Status_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_status" */
export type Part_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Status_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_status" */
export type Part_Status_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Part_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Part_Stddev_Fields = {
  __typename?: 'part_stddev_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "part" */
export type Part_Stddev_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Part_Stddev_Pop_Fields = {
  __typename?: 'part_stddev_pop_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "part" */
export type Part_Stddev_Pop_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Part_Stddev_Samp_Fields = {
  __typename?: 'part_stddev_samp_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "part" */
export type Part_Stddev_Samp_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "part" */
export type Part_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']>;
  conversionRateCommodity?: InputMaybe<Scalars['numeric']>;
  conversionRateEstimate?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterial?: InputMaybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  csiId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  finishColor?: InputMaybe<Scalars['String']>;
  hasLedgerEntries?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inBLOXCatalog?: InputMaybe<Scalars['Boolean']>;
  inventoryClassification?: InputMaybe<Scalars['String']>;
  isApprovedByAppDesign?: InputMaybe<Scalars['Boolean']>;
  isApprovedByFinance?: InputMaybe<Scalars['Boolean']>;
  isApprovedBySupplyChain?: InputMaybe<Scalars['Boolean']>;
  isInQuickBooks?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  kbb_id?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  maxDailyConsumption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  on_pfep?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  partType?: InputMaybe<Scalars['String']>;
  part_type?: InputMaybe<Scalars['String']>;
  purchaseTypeId?: InputMaybe<Scalars['Int']>;
  purchaseTypeStatus?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Part_Status_Enum>;
  unitCostEstimate?: InputMaybe<Scalars['numeric']>;
  unitCostMaterial?: InputMaybe<Scalars['money']>;
  uomCommodityId?: InputMaybe<Scalars['Int']>;
  uomEstimateId?: InputMaybe<Scalars['Int']>;
  uomMaterialId?: InputMaybe<Scalars['Int']>;
  uomMaterialIssuedId?: InputMaybe<Scalars['Int']>;
  uomTakeOffId?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  wasteMaterial?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Part_Sum_Fields = {
  __typename?: 'part_sum_fields';
  conversionRateCommodity?: Maybe<Scalars['numeric']>;
  conversionRateEstimate?: Maybe<Scalars['numeric']>;
  conversionRateMaterial?: Maybe<Scalars['numeric']>;
  conversionRateMaterialIssued?: Maybe<Scalars['numeric']>;
  purchaseTypeId?: Maybe<Scalars['Int']>;
  unitCostEstimate?: Maybe<Scalars['numeric']>;
  unitCostMaterial?: Maybe<Scalars['money']>;
  uomCommodityId?: Maybe<Scalars['Int']>;
  uomEstimateId?: Maybe<Scalars['Int']>;
  uomMaterialId?: Maybe<Scalars['Int']>;
  uomMaterialIssuedId?: Maybe<Scalars['Int']>;
  uomTakeOffId?: Maybe<Scalars['Int']>;
  wasteMaterial?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "part" */
export type Part_Sum_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** Table used for syncing parts from MA to WEVR */
export type Part_Sync = {
  __typename?: 'part_sync';
  id: Scalars['Int'];
  operation: Scalars['String'];
  part_identifier: Scalars['String'];
  processed: Scalars['Boolean'];
  processed_at?: Maybe<Scalars['timestamptz']>;
  source_table: Scalars['String'];
  source_table_updated_at: Scalars['timestamptz'];
  source_table_updated_by: Scalars['String'];
};

/** aggregated selection of "part_sync" */
export type Part_Sync_Aggregate = {
  __typename?: 'part_sync_aggregate';
  aggregate?: Maybe<Part_Sync_Aggregate_Fields>;
  nodes: Array<Part_Sync>;
};

/** aggregate fields of "part_sync" */
export type Part_Sync_Aggregate_Fields = {
  __typename?: 'part_sync_aggregate_fields';
  avg?: Maybe<Part_Sync_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Part_Sync_Max_Fields>;
  min?: Maybe<Part_Sync_Min_Fields>;
  stddev?: Maybe<Part_Sync_Stddev_Fields>;
  stddev_pop?: Maybe<Part_Sync_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Part_Sync_Stddev_Samp_Fields>;
  sum?: Maybe<Part_Sync_Sum_Fields>;
  var_pop?: Maybe<Part_Sync_Var_Pop_Fields>;
  var_samp?: Maybe<Part_Sync_Var_Samp_Fields>;
  variance?: Maybe<Part_Sync_Variance_Fields>;
};


/** aggregate fields of "part_sync" */
export type Part_Sync_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Sync_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Part_Sync_Avg_Fields = {
  __typename?: 'part_sync_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "part_sync". All fields are combined with a logical 'AND'. */
export type Part_Sync_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Sync_Bool_Exp>>;
  _not?: InputMaybe<Part_Sync_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Sync_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  part_identifier?: InputMaybe<String_Comparison_Exp>;
  processed?: InputMaybe<Boolean_Comparison_Exp>;
  processed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_table?: InputMaybe<String_Comparison_Exp>;
  source_table_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_table_updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_sync" */
export type Part_Sync_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'part_sync_pkey';

/** input type for incrementing numeric columns in table "part_sync" */
export type Part_Sync_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "part_sync" */
export type Part_Sync_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  part_identifier?: InputMaybe<Scalars['String']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  processed_at?: InputMaybe<Scalars['timestamptz']>;
  source_table?: InputMaybe<Scalars['String']>;
  source_table_updated_at?: InputMaybe<Scalars['timestamptz']>;
  source_table_updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Sync_Max_Fields = {
  __typename?: 'part_sync_max_fields';
  id?: Maybe<Scalars['Int']>;
  operation?: Maybe<Scalars['String']>;
  part_identifier?: Maybe<Scalars['String']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  source_table?: Maybe<Scalars['String']>;
  source_table_updated_at?: Maybe<Scalars['timestamptz']>;
  source_table_updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Sync_Min_Fields = {
  __typename?: 'part_sync_min_fields';
  id?: Maybe<Scalars['Int']>;
  operation?: Maybe<Scalars['String']>;
  part_identifier?: Maybe<Scalars['String']>;
  processed_at?: Maybe<Scalars['timestamptz']>;
  source_table?: Maybe<Scalars['String']>;
  source_table_updated_at?: Maybe<Scalars['timestamptz']>;
  source_table_updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_sync" */
export type Part_Sync_Mutation_Response = {
  __typename?: 'part_sync_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Sync>;
};

/** on_conflict condition type for table "part_sync" */
export type Part_Sync_On_Conflict = {
  constraint: Part_Sync_Constraint;
  update_columns?: Array<Part_Sync_Update_Column>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};

/** Ordering options when selecting data from "part_sync". */
export type Part_Sync_Order_By = {
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  part_identifier?: InputMaybe<Order_By>;
  processed?: InputMaybe<Order_By>;
  processed_at?: InputMaybe<Order_By>;
  source_table?: InputMaybe<Order_By>;
  source_table_updated_at?: InputMaybe<Order_By>;
  source_table_updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_sync */
export type Part_Sync_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "part_sync" */
export type Part_Sync_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'operation'
  /** column name */
  | 'part_identifier'
  /** column name */
  | 'processed'
  /** column name */
  | 'processed_at'
  /** column name */
  | 'source_table'
  /** column name */
  | 'source_table_updated_at'
  /** column name */
  | 'source_table_updated_by';

/** input type for updating data in table "part_sync" */
export type Part_Sync_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  part_identifier?: InputMaybe<Scalars['String']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  processed_at?: InputMaybe<Scalars['timestamptz']>;
  source_table?: InputMaybe<Scalars['String']>;
  source_table_updated_at?: InputMaybe<Scalars['timestamptz']>;
  source_table_updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Part_Sync_Stddev_Fields = {
  __typename?: 'part_sync_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Part_Sync_Stddev_Pop_Fields = {
  __typename?: 'part_sync_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Part_Sync_Stddev_Samp_Fields = {
  __typename?: 'part_sync_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "part_sync" */
export type Part_Sync_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Sync_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Sync_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  part_identifier?: InputMaybe<Scalars['String']>;
  processed?: InputMaybe<Scalars['Boolean']>;
  processed_at?: InputMaybe<Scalars['timestamptz']>;
  source_table?: InputMaybe<Scalars['String']>;
  source_table_updated_at?: InputMaybe<Scalars['timestamptz']>;
  source_table_updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Part_Sync_Sum_Fields = {
  __typename?: 'part_sync_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "part_sync" */
export type Part_Sync_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'operation'
  /** column name */
  | 'part_identifier'
  /** column name */
  | 'processed'
  /** column name */
  | 'processed_at'
  /** column name */
  | 'source_table'
  /** column name */
  | 'source_table_updated_at'
  /** column name */
  | 'source_table_updated_by';

export type Part_Sync_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Part_Sync_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Sync_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Sync_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Part_Sync_Var_Pop_Fields = {
  __typename?: 'part_sync_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Part_Sync_Var_Samp_Fields = {
  __typename?: 'part_sync_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Part_Sync_Variance_Fields = {
  __typename?: 'part_sync_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "part_type" */
export type Part_Type = {
  __typename?: 'part_type';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "part_type" */
export type Part_Type_Aggregate = {
  __typename?: 'part_type_aggregate';
  aggregate?: Maybe<Part_Type_Aggregate_Fields>;
  nodes: Array<Part_Type>;
};

/** aggregate fields of "part_type" */
export type Part_Type_Aggregate_Fields = {
  __typename?: 'part_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Type_Max_Fields>;
  min?: Maybe<Part_Type_Min_Fields>;
};


/** aggregate fields of "part_type" */
export type Part_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "part_type". All fields are combined with a logical 'AND'. */
export type Part_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Type_Bool_Exp>>;
  _not?: InputMaybe<Part_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_type" */
export type Part_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'part_type_pkey';

/** input type for inserting data into table "part_type" */
export type Part_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Type_Max_Fields = {
  __typename?: 'part_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Part_Type_Min_Fields = {
  __typename?: 'part_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "part_type" */
export type Part_Type_Mutation_Response = {
  __typename?: 'part_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Type>;
};

/** on_conflict condition type for table "part_type" */
export type Part_Type_On_Conflict = {
  constraint: Part_Type_Constraint;
  update_columns?: Array<Part_Type_Update_Column>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "part_type". */
export type Part_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_type */
export type Part_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "part_type" */
export type Part_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "part_type" */
export type Part_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_type" */
export type Part_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_type" */
export type Part_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Part_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Type_Bool_Exp;
};

/** update columns of table "part" */
export type Part_Update_Column =
  /** column name */
  | 'category'
  /** column name */
  | 'conversionRateCommodity'
  /** column name */
  | 'conversionRateEstimate'
  /** column name */
  | 'conversionRateMaterial'
  /** column name */
  | 'conversionRateMaterialIssued'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'csiId'
  /** column name */
  | 'description'
  /** column name */
  | 'est_daily_consumption'
  /** column name */
  | 'finishColor'
  /** column name */
  | 'hasLedgerEntries'
  /** column name */
  | 'id'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'inBLOXCatalog'
  /** column name */
  | 'inventoryClassification'
  /** column name */
  | 'isApprovedByAppDesign'
  /** column name */
  | 'isApprovedByFinance'
  /** column name */
  | 'isApprovedBySupplyChain'
  /** column name */
  | 'isInQuickBooks'
  /** column name */
  | 'itemType'
  /** column name */
  | 'kbb_id'
  /** column name */
  | 'material'
  /** column name */
  | 'maxDailyConsumption'
  /** column name */
  | 'name'
  /** column name */
  | 'on_pfep'
  /** column name */
  | 'partNumber'
  /** column name */
  | 'partType'
  /** column name */
  | 'part_type'
  /** column name */
  | 'purchaseTypeId'
  /** column name */
  | 'purchaseTypeStatus'
  /** column name */
  | 'size'
  /** column name */
  | 'sourceUrl'
  /** column name */
  | 'status'
  /** column name */
  | 'unitCostEstimate'
  /** column name */
  | 'unitCostMaterial'
  /** column name */
  | 'uomCommodityId'
  /** column name */
  | 'uomEstimateId'
  /** column name */
  | 'uomMaterialId'
  /** column name */
  | 'uomMaterialIssuedId'
  /** column name */
  | 'uomTakeOffId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'wasteMaterial';

export type Part_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Part_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Part_Var_Pop_Fields = {
  __typename?: 'part_var_pop_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "part" */
export type Part_Var_Pop_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Part_Var_Samp_Fields = {
  __typename?: 'part_var_samp_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "part" */
export type Part_Var_Samp_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Part_Variance_Fields = {
  __typename?: 'part_variance_fields';
  conversionRateCommodity?: Maybe<Scalars['Float']>;
  conversionRateEstimate?: Maybe<Scalars['Float']>;
  conversionRateMaterial?: Maybe<Scalars['Float']>;
  conversionRateMaterialIssued?: Maybe<Scalars['Float']>;
  purchaseTypeId?: Maybe<Scalars['Float']>;
  unitCostEstimate?: Maybe<Scalars['Float']>;
  unitCostMaterial?: Maybe<Scalars['Float']>;
  uomCommodityId?: Maybe<Scalars['Float']>;
  uomEstimateId?: Maybe<Scalars['Float']>;
  uomMaterialId?: Maybe<Scalars['Float']>;
  uomMaterialIssuedId?: Maybe<Scalars['Float']>;
  uomTakeOffId?: Maybe<Scalars['Float']>;
  wasteMaterial?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "part" */
export type Part_Variance_Order_By = {
  conversionRateCommodity?: InputMaybe<Order_By>;
  conversionRateEstimate?: InputMaybe<Order_By>;
  conversionRateMaterial?: InputMaybe<Order_By>;
  conversionRateMaterialIssued?: InputMaybe<Order_By>;
  purchaseTypeId?: InputMaybe<Order_By>;
  unitCostEstimate?: InputMaybe<Order_By>;
  unitCostMaterial?: InputMaybe<Order_By>;
  uomCommodityId?: InputMaybe<Order_By>;
  uomEstimateId?: InputMaybe<Order_By>;
  uomMaterialId?: InputMaybe<Order_By>;
  uomMaterialIssuedId?: InputMaybe<Order_By>;
  uomTakeOffId?: InputMaybe<Order_By>;
  wasteMaterial?: InputMaybe<Order_By>;
};

/** columns and relationships of "part_warehouse_detail" */
export type Part_Warehouse_Detail = {
  __typename?: 'part_warehouse_detail';
  created_at: Scalars['timestamptz'];
  created_by?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location_name: Scalars['String'];
  options?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  part: Part;
  part_number: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by?: Maybe<Scalars['String']>;
  warehouse_name: Scalars['String'];
};


/** columns and relationships of "part_warehouse_detail" */
export type Part_Warehouse_DetailOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "part_warehouse_detail" */
export type Part_Warehouse_Detail_Aggregate = {
  __typename?: 'part_warehouse_detail_aggregate';
  aggregate?: Maybe<Part_Warehouse_Detail_Aggregate_Fields>;
  nodes: Array<Part_Warehouse_Detail>;
};

export type Part_Warehouse_Detail_Aggregate_Bool_Exp = {
  count?: InputMaybe<Part_Warehouse_Detail_Aggregate_Bool_Exp_Count>;
};

export type Part_Warehouse_Detail_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "part_warehouse_detail" */
export type Part_Warehouse_Detail_Aggregate_Fields = {
  __typename?: 'part_warehouse_detail_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Part_Warehouse_Detail_Max_Fields>;
  min?: Maybe<Part_Warehouse_Detail_Min_Fields>;
};


/** aggregate fields of "part_warehouse_detail" */
export type Part_Warehouse_Detail_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Part_Warehouse_Detail_Max_Order_By>;
  min?: InputMaybe<Part_Warehouse_Detail_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Part_Warehouse_Detail_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Arr_Rel_Insert_Input = {
  data: Array<Part_Warehouse_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Part_Warehouse_Detail_On_Conflict>;
};

/** Boolean expression to filter rows from the table "part_warehouse_detail". All fields are combined with a logical 'AND'. */
export type Part_Warehouse_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Part_Warehouse_Detail_Bool_Exp>>;
  _not?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Part_Warehouse_Detail_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  warehouse_name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'part_warehouse_detail_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Part_Warehouse_Detail_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Part_Warehouse_Detail_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Part_Warehouse_Detail_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  part_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Part_Warehouse_Detail_Max_Fields = {
  __typename?: 'part_warehouse_detail_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  warehouse_name?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Part_Warehouse_Detail_Min_Fields = {
  __typename?: 'part_warehouse_detail_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  warehouse_name?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Mutation_Response = {
  __typename?: 'part_warehouse_detail_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Part_Warehouse_Detail>;
};

/** on_conflict condition type for table "part_warehouse_detail" */
export type Part_Warehouse_Detail_On_Conflict = {
  constraint: Part_Warehouse_Detail_Constraint;
  update_columns?: Array<Part_Warehouse_Detail_Update_Column>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};

/** Ordering options when selecting data from "part_warehouse_detail". */
export type Part_Warehouse_Detail_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  part_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  warehouse_name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: part_warehouse_detail */
export type Part_Warehouse_Detail_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Part_Warehouse_Detail_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'location_name'
  /** column name */
  | 'options'
  /** column name */
  | 'part_number'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'warehouse_name';

/** input type for updating data in table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  part_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Part_Warehouse_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Part_Warehouse_Detail_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  part_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "part_warehouse_detail" */
export type Part_Warehouse_Detail_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'location_name'
  /** column name */
  | 'options'
  /** column name */
  | 'part_number'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'warehouse_name';

export type Part_Warehouse_Detail_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Part_Warehouse_Detail_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Part_Warehouse_Detail_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Part_Warehouse_Detail_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Part_Warehouse_Detail_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Part_Warehouse_Detail_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Part_Warehouse_Detail_Set_Input>;
  /** filter the rows which have to be updated */
  where: Part_Warehouse_Detail_Bool_Exp;
};

/** columns and relationships of "parts_related" */
export type Parts_Related = {
  __typename?: 'parts_related';
  created_at: Scalars['timestamptz'];
  from: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  relation_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  source_part: Part;
  /** An object relationship */
  target_part: Part;
  to: Scalars['String'];
};

/** aggregated selection of "parts_related" */
export type Parts_Related_Aggregate = {
  __typename?: 'parts_related_aggregate';
  aggregate?: Maybe<Parts_Related_Aggregate_Fields>;
  nodes: Array<Parts_Related>;
};

export type Parts_Related_Aggregate_Bool_Exp = {
  count?: InputMaybe<Parts_Related_Aggregate_Bool_Exp_Count>;
};

export type Parts_Related_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Parts_Related_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Parts_Related_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "parts_related" */
export type Parts_Related_Aggregate_Fields = {
  __typename?: 'parts_related_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Parts_Related_Max_Fields>;
  min?: Maybe<Parts_Related_Min_Fields>;
};


/** aggregate fields of "parts_related" */
export type Parts_Related_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parts_Related_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "parts_related" */
export type Parts_Related_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Parts_Related_Max_Order_By>;
  min?: InputMaybe<Parts_Related_Min_Order_By>;
};

/** input type for inserting array relation for remote table "parts_related" */
export type Parts_Related_Arr_Rel_Insert_Input = {
  data: Array<Parts_Related_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Parts_Related_On_Conflict>;
};

/** Boolean expression to filter rows from the table "parts_related". All fields are combined with a logical 'AND'. */
export type Parts_Related_Bool_Exp = {
  _and?: InputMaybe<Array<Parts_Related_Bool_Exp>>;
  _not?: InputMaybe<Parts_Related_Bool_Exp>;
  _or?: InputMaybe<Array<Parts_Related_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  relation_type?: InputMaybe<String_Comparison_Exp>;
  source_part?: InputMaybe<Part_Bool_Exp>;
  target_part?: InputMaybe<Part_Bool_Exp>;
  to?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "parts_related" */
export type Parts_Related_Constraint =
  /** unique or primary key constraint on columns "from", "to" */
  | 'parts_related_pkey';

/** input type for inserting data into table "parts_related" */
export type Parts_Related_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  relation_type?: InputMaybe<Scalars['String']>;
  source_part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  target_part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  to?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Parts_Related_Max_Fields = {
  __typename?: 'parts_related_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  relation_type?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "parts_related" */
export type Parts_Related_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  relation_type?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Parts_Related_Min_Fields = {
  __typename?: 'parts_related_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  from?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  relation_type?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "parts_related" */
export type Parts_Related_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  relation_type?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "parts_related" */
export type Parts_Related_Mutation_Response = {
  __typename?: 'parts_related_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Parts_Related>;
};

/** on_conflict condition type for table "parts_related" */
export type Parts_Related_On_Conflict = {
  constraint: Parts_Related_Constraint;
  update_columns?: Array<Parts_Related_Update_Column>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};

/** Ordering options when selecting data from "parts_related". */
export type Parts_Related_Order_By = {
  created_at?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  relation_type?: InputMaybe<Order_By>;
  source_part?: InputMaybe<Part_Order_By>;
  target_part?: InputMaybe<Part_Order_By>;
  to?: InputMaybe<Order_By>;
};

/** primary key columns input for table: parts_related */
export type Parts_Related_Pk_Columns_Input = {
  from: Scalars['String'];
  to: Scalars['String'];
};

/** select columns of table "parts_related" */
export type Parts_Related_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'from'
  /** column name */
  | 'note'
  /** column name */
  | 'relation_type'
  /** column name */
  | 'to';

/** input type for updating data in table "parts_related" */
export type Parts_Related_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  relation_type?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "parts_related" */
export type Parts_Related_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parts_Related_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parts_Related_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  from?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  relation_type?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

/** update columns of table "parts_related" */
export type Parts_Related_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'from'
  /** column name */
  | 'note'
  /** column name */
  | 'relation_type'
  /** column name */
  | 'to';

export type Parts_Related_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Parts_Related_Set_Input>;
  /** filter the rows which have to be updated */
  where: Parts_Related_Bool_Exp;
};

/** columns and relationships of "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View = {
  __typename?: 'parts_workflow_counts_view';
  count?: Maybe<Scalars['bigint']>;
  workflow_stage?: Maybe<Scalars['String']>;
};

/** aggregated selection of "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View_Aggregate = {
  __typename?: 'parts_workflow_counts_view_aggregate';
  aggregate?: Maybe<Parts_Workflow_Counts_View_Aggregate_Fields>;
  nodes: Array<Parts_Workflow_Counts_View>;
};

/** aggregate fields of "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View_Aggregate_Fields = {
  __typename?: 'parts_workflow_counts_view_aggregate_fields';
  avg?: Maybe<Parts_Workflow_Counts_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Parts_Workflow_Counts_View_Max_Fields>;
  min?: Maybe<Parts_Workflow_Counts_View_Min_Fields>;
  stddev?: Maybe<Parts_Workflow_Counts_View_Stddev_Fields>;
  stddev_pop?: Maybe<Parts_Workflow_Counts_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Parts_Workflow_Counts_View_Stddev_Samp_Fields>;
  sum?: Maybe<Parts_Workflow_Counts_View_Sum_Fields>;
  var_pop?: Maybe<Parts_Workflow_Counts_View_Var_Pop_Fields>;
  var_samp?: Maybe<Parts_Workflow_Counts_View_Var_Samp_Fields>;
  variance?: Maybe<Parts_Workflow_Counts_View_Variance_Fields>;
};


/** aggregate fields of "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Parts_Workflow_Counts_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Parts_Workflow_Counts_View_Avg_Fields = {
  __typename?: 'parts_workflow_counts_view_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "parts_workflow_counts_view". All fields are combined with a logical 'AND'. */
export type Parts_Workflow_Counts_View_Bool_Exp = {
  _and?: InputMaybe<Array<Parts_Workflow_Counts_View_Bool_Exp>>;
  _not?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
  _or?: InputMaybe<Array<Parts_Workflow_Counts_View_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  workflow_stage?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Parts_Workflow_Counts_View_Max_Fields = {
  __typename?: 'parts_workflow_counts_view_max_fields';
  count?: Maybe<Scalars['bigint']>;
  workflow_stage?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Parts_Workflow_Counts_View_Min_Fields = {
  __typename?: 'parts_workflow_counts_view_min_fields';
  count?: Maybe<Scalars['bigint']>;
  workflow_stage?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "parts_workflow_counts_view". */
export type Parts_Workflow_Counts_View_Order_By = {
  count?: InputMaybe<Order_By>;
  workflow_stage?: InputMaybe<Order_By>;
};

/** select columns of table "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View_Select_Column =
  /** column name */
  | 'count'
  /** column name */
  | 'workflow_stage';

/** aggregate stddev on columns */
export type Parts_Workflow_Counts_View_Stddev_Fields = {
  __typename?: 'parts_workflow_counts_view_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Parts_Workflow_Counts_View_Stddev_Pop_Fields = {
  __typename?: 'parts_workflow_counts_view_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Parts_Workflow_Counts_View_Stddev_Samp_Fields = {
  __typename?: 'parts_workflow_counts_view_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "parts_workflow_counts_view" */
export type Parts_Workflow_Counts_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Parts_Workflow_Counts_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Parts_Workflow_Counts_View_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  workflow_stage?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Parts_Workflow_Counts_View_Sum_Fields = {
  __typename?: 'parts_workflow_counts_view_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Parts_Workflow_Counts_View_Var_Pop_Fields = {
  __typename?: 'parts_workflow_counts_view_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Parts_Workflow_Counts_View_Var_Samp_Fields = {
  __typename?: 'parts_workflow_counts_view_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Parts_Workflow_Counts_View_Variance_Fields = {
  __typename?: 'parts_workflow_counts_view_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "permissions" */
export type Permissions = {
  __typename?: 'permissions';
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** An array relationship */
  user_permissions: Array<User_Permissions>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permissions_Aggregate;
};


/** columns and relationships of "permissions" */
export type PermissionsRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


/** columns and relationships of "permissions" */
export type PermissionsUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};

/** aggregated selection of "permissions" */
export type Permissions_Aggregate = {
  __typename?: 'permissions_aggregate';
  aggregate?: Maybe<Permissions_Aggregate_Fields>;
  nodes: Array<Permissions>;
};

/** aggregate fields of "permissions" */
export type Permissions_Aggregate_Fields = {
  __typename?: 'permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Permissions_Max_Fields>;
  min?: Maybe<Permissions_Min_Fields>;
};


/** aggregate fields of "permissions" */
export type Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "permissions". All fields are combined with a logical 'AND'. */
export type Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Permissions_Bool_Exp>>;
  _not?: InputMaybe<Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Permissions_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_permissions?: InputMaybe<Role_Permissions_Bool_Exp>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp>;
  user_permissions?: InputMaybe<User_Permissions_Bool_Exp>;
  user_permissions_aggregate?: InputMaybe<User_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "permissions" */
export type Permissions_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'permissions_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'permissions_pkey';

/** input type for inserting data into table "permissions" */
export type Permissions_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role_permissions?: InputMaybe<Role_Permissions_Arr_Rel_Insert_Input>;
  user_permissions?: InputMaybe<User_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Permissions_Max_Fields = {
  __typename?: 'permissions_max_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Permissions_Min_Fields = {
  __typename?: 'permissions_min_fields';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "permissions" */
export type Permissions_Mutation_Response = {
  __typename?: 'permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Permissions>;
};

/** input type for inserting object relation for remote table "permissions" */
export type Permissions_Obj_Rel_Insert_Input = {
  data: Permissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Permissions_On_Conflict>;
};

/** on_conflict condition type for table "permissions" */
export type Permissions_On_Conflict = {
  constraint: Permissions_Constraint;
  update_columns?: Array<Permissions_Update_Column>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "permissions". */
export type Permissions_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permissions_Aggregate_Order_By>;
};

/** primary key columns input for table: permissions */
export type Permissions_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "permissions" */
export type Permissions_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "permissions" */
export type Permissions_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "permissions" */
export type Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permissions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "permissions" */
export type Permissions_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Permissions_Bool_Exp;
};

/** columns and relationships of "phase" */
export type Phase = {
  __typename?: 'phase';
  id: Scalars['Int'];
  /** An array relationship */
  milestones: Array<Project_Milestone>;
  /** An aggregate relationship */
  milestones_aggregate: Project_Milestone_Aggregate;
  name: Scalars['String'];
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['String'];
};


/** columns and relationships of "phase" */
export type PhaseMilestonesArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


/** columns and relationships of "phase" */
export type PhaseMilestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};

/** aggregated selection of "phase" */
export type Phase_Aggregate = {
  __typename?: 'phase_aggregate';
  aggregate?: Maybe<Phase_Aggregate_Fields>;
  nodes: Array<Phase>;
};

/** aggregate fields of "phase" */
export type Phase_Aggregate_Fields = {
  __typename?: 'phase_aggregate_fields';
  avg?: Maybe<Phase_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Phase_Max_Fields>;
  min?: Maybe<Phase_Min_Fields>;
  stddev?: Maybe<Phase_Stddev_Fields>;
  stddev_pop?: Maybe<Phase_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Phase_Stddev_Samp_Fields>;
  sum?: Maybe<Phase_Sum_Fields>;
  var_pop?: Maybe<Phase_Var_Pop_Fields>;
  var_samp?: Maybe<Phase_Var_Samp_Fields>;
  variance?: Maybe<Phase_Variance_Fields>;
};


/** aggregate fields of "phase" */
export type Phase_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phase_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Phase_Avg_Fields = {
  __typename?: 'phase_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "phase". All fields are combined with a logical 'AND'. */
export type Phase_Bool_Exp = {
  _and?: InputMaybe<Array<Phase_Bool_Exp>>;
  _not?: InputMaybe<Phase_Bool_Exp>;
  _or?: InputMaybe<Array<Phase_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  milestones?: InputMaybe<Project_Milestone_Bool_Exp>;
  milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "phase" */
export type Phase_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'phase_pkey'
  /** unique or primary key constraint on columns "name", "projectId" */
  | 'phase_projectId_name_key';

/** input type for incrementing numeric columns in table "phase" */
export type Phase_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "phase" */
export type Phase_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  milestones?: InputMaybe<Project_Milestone_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Phase_Max_Fields = {
  __typename?: 'phase_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Phase_Min_Fields = {
  __typename?: 'phase_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "phase" */
export type Phase_Mutation_Response = {
  __typename?: 'phase_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Phase>;
};

/** input type for inserting object relation for remote table "phase" */
export type Phase_Obj_Rel_Insert_Input = {
  data: Phase_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Phase_On_Conflict>;
};

/** on_conflict condition type for table "phase" */
export type Phase_On_Conflict = {
  constraint: Phase_Constraint;
  update_columns?: Array<Phase_Update_Column>;
  where?: InputMaybe<Phase_Bool_Exp>;
};

/** Ordering options when selecting data from "phase". */
export type Phase_Order_By = {
  id?: InputMaybe<Order_By>;
  milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phase */
export type Phase_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "phase" */
export type Phase_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'projectId';

/** input type for updating data in table "phase" */
export type Phase_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Phase_Stddev_Fields = {
  __typename?: 'phase_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Phase_Stddev_Pop_Fields = {
  __typename?: 'phase_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Phase_Stddev_Samp_Fields = {
  __typename?: 'phase_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "phase" */
export type Phase_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phase_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phase_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Phase_Sum_Fields = {
  __typename?: 'phase_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "phase" */
export type Phase_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'projectId';

export type Phase_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Phase_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phase_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phase_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Phase_Var_Pop_Fields = {
  __typename?: 'phase_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Phase_Var_Samp_Fields = {
  __typename?: 'phase_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Phase_Variance_Fields = {
  __typename?: 'phase_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "platform" */
export type Platform = {
  __typename?: 'platform';
  /** An array relationship */
  base_products: Array<Base_Product>;
  /** An aggregate relationship */
  base_products_aggregate: Base_Product_Aggregate;
  /** An array relationship */
  children: Array<Platform>;
  /** An aggregate relationship */
  children_aggregate: Platform_Aggregate;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  derived_from?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** An array relationship */
  items: Array<Item_Bom>;
  /** An aggregate relationship */
  items_aggregate: Item_Bom_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  parent?: Maybe<Platform>;
  /** An array relationship */
  requirements: Array<Platform_Requirement>;
  /** An aggregate relationship */
  requirements_aggregate: Platform_Requirement_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "platform" */
export type PlatformBase_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformBase_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformChildrenArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformItemsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformRequirementsArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformRequirements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};

export type PlatformNode = {
  __typename?: 'platformNode';
  childPlatforms?: Maybe<Array<Maybe<PlatformNode>>>;
  childPlatformsAggregate?: Maybe<PlatformNodeplatformNodeChildPlatformsAggregationSelection>;
  childPlatformsConnection: PlatformNodeChildPlatformsConnection;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<PlatformNodeitemNodeItemsAggregationSelection>;
  itemsConnection: PlatformNodeItemsConnection;
  name?: Maybe<Scalars['String']>;
  parentPlatform?: Maybe<PlatformNode>;
  parentPlatformAggregate?: Maybe<PlatformNodeplatformNodeParentPlatformAggregationSelection>;
  parentPlatformConnection: PlatformNodeParentPlatformConnection;
  products?: Maybe<Array<Maybe<ProductNode>>>;
  productsAggregate?: Maybe<PlatformNodeproductNodeProductsAggregationSelection>;
  productsConnection: PlatformNodeProductsConnection;
  tagpathid?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type PlatformNodeChildPlatformsArgs = {
  options?: InputMaybe<PlatformNodeOptions>;
  where?: InputMaybe<PlatformNodeWhere>;
};


export type PlatformNodeChildPlatformsAggregateArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type PlatformNodeChildPlatformsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PlatformNodeChildPlatformsConnectionSort>>;
  where?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
};


export type PlatformNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type PlatformNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type PlatformNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PlatformNodeItemsConnectionSort>>;
  where?: InputMaybe<PlatformNodeItemsConnectionWhere>;
};


export type PlatformNodeParentPlatformArgs = {
  options?: InputMaybe<PlatformNodeOptions>;
  where?: InputMaybe<PlatformNodeWhere>;
};


export type PlatformNodeParentPlatformAggregateArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type PlatformNodeParentPlatformConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PlatformNodeParentPlatformConnectionSort>>;
  where?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
};


export type PlatformNodeProductsArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type PlatformNodeProductsAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type PlatformNodeProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<PlatformNodeProductsConnectionSort>>;
  where?: InputMaybe<PlatformNodeProductsConnectionWhere>;
};

export type PlatformNodeAggregateSelection = {
  __typename?: 'platformNodeAggregateSelection';
  code: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type PlatformNodeChildPlatformsAggregateInput = {
  AND?: InputMaybe<Array<PlatformNodeChildPlatformsAggregateInput>>;
  OR?: InputMaybe<Array<PlatformNodeChildPlatformsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<PlatformNodeChildPlatformsNodeAggregationWhereInput>;
};

export type PlatformNodeChildPlatformsConnectFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeConnectInput>>;
  where?: InputMaybe<PlatformNodeConnectWhere>;
};

export type PlatformNodeChildPlatformsConnection = {
  __typename?: 'platformNodeChildPlatformsConnection';
  edges: Array<PlatformNodeChildPlatformsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PlatformNodeChildPlatformsConnectionSort = {
  node?: InputMaybe<PlatformNodeSort>;
};

export type PlatformNodeChildPlatformsConnectionWhere = {
  AND?: InputMaybe<Array<PlatformNodeChildPlatformsConnectionWhere>>;
  OR?: InputMaybe<Array<PlatformNodeChildPlatformsConnectionWhere>>;
  node?: InputMaybe<PlatformNodeWhere>;
  node_NOT?: InputMaybe<PlatformNodeWhere>;
};

export type PlatformNodeChildPlatformsCreateFieldInput = {
  node: PlatformNodeCreateInput;
};

export type PlatformNodeChildPlatformsDeleteFieldInput = {
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  where?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
};

export type PlatformNodeChildPlatformsDisconnectFieldInput = {
  disconnect?: InputMaybe<PlatformNodeDisconnectInput>;
  where?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
};

export type PlatformNodeChildPlatformsFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeChildPlatformsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeChildPlatformsCreateFieldInput>>;
};

export type PlatformNodeChildPlatformsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PlatformNodeChildPlatformsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<PlatformNodeChildPlatformsNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type PlatformNodeChildPlatformsRelationship = {
  __typename?: 'platformNodeChildPlatformsRelationship';
  cursor: Scalars['String'];
  node: PlatformNode;
};

export type PlatformNodeChildPlatformsUpdateConnectionInput = {
  node?: InputMaybe<PlatformNodeUpdateInput>;
};

export type PlatformNodeChildPlatformsUpdateFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeChildPlatformsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeChildPlatformsCreateFieldInput>>;
  delete?: InputMaybe<Array<PlatformNodeChildPlatformsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PlatformNodeChildPlatformsDisconnectFieldInput>>;
  update?: InputMaybe<PlatformNodeChildPlatformsUpdateConnectionInput>;
  where?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
};

export type PlatformNodeConnectInput = {
  childPlatforms?: InputMaybe<Array<PlatformNodeChildPlatformsConnectFieldInput>>;
  items?: InputMaybe<Array<PlatformNodeItemsConnectFieldInput>>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformConnectFieldInput>;
  products?: InputMaybe<Array<PlatformNodeProductsConnectFieldInput>>;
};

export type PlatformNodeConnectWhere = {
  node: PlatformNodeWhere;
};

export type PlatformNodeCreateInput = {
  childPlatforms?: InputMaybe<PlatformNodeChildPlatformsFieldInput>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<PlatformNodeItemsFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformFieldInput>;
  products?: InputMaybe<PlatformNodeProductsFieldInput>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type PlatformNodeDeleteInput = {
  childPlatforms?: InputMaybe<Array<PlatformNodeChildPlatformsDeleteFieldInput>>;
  items?: InputMaybe<Array<PlatformNodeItemsDeleteFieldInput>>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformDeleteFieldInput>;
  products?: InputMaybe<Array<PlatformNodeProductsDeleteFieldInput>>;
};

export type PlatformNodeDisconnectInput = {
  childPlatforms?: InputMaybe<Array<PlatformNodeChildPlatformsDisconnectFieldInput>>;
  items?: InputMaybe<Array<PlatformNodeItemsDisconnectFieldInput>>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformDisconnectFieldInput>;
  products?: InputMaybe<Array<PlatformNodeProductsDisconnectFieldInput>>;
};

export type PlatformNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<PlatformNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<PlatformNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<PlatformNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<PlatformNodeItemsNodeAggregationWhereInput>;
};

export type PlatformNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type PlatformNodeItemsConnection = {
  __typename?: 'platformNodeItemsConnection';
  edges: Array<PlatformNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PlatformNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type PlatformNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<PlatformNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<PlatformNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type PlatformNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type PlatformNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<PlatformNodeItemsConnectionWhere>;
};

export type PlatformNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<PlatformNodeItemsConnectionWhere>;
};

export type PlatformNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<PlatformNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<PlatformNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type PlatformNodeItemsFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeItemsCreateFieldInput>>;
};

export type PlatformNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PlatformNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<PlatformNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type PlatformNodeItemsRelationship = Quantity & {
  __typename?: 'platformNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type PlatformNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type PlatformNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<PlatformNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PlatformNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<PlatformNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<PlatformNodeItemsConnectionWhere>;
};

export type PlatformNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more platformNodeSort objects to sort platformNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<PlatformNodeSort>>>;
};

export type PlatformNodeParentPlatformAggregateInput = {
  AND?: InputMaybe<Array<PlatformNodeParentPlatformAggregateInput>>;
  OR?: InputMaybe<Array<PlatformNodeParentPlatformAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<PlatformNodeParentPlatformNodeAggregationWhereInput>;
};

export type PlatformNodeParentPlatformConnectFieldInput = {
  connect?: InputMaybe<PlatformNodeConnectInput>;
  where?: InputMaybe<PlatformNodeConnectWhere>;
};

export type PlatformNodeParentPlatformConnection = {
  __typename?: 'platformNodeParentPlatformConnection';
  edges: Array<PlatformNodeParentPlatformRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PlatformNodeParentPlatformConnectionSort = {
  node?: InputMaybe<PlatformNodeSort>;
};

export type PlatformNodeParentPlatformConnectionWhere = {
  AND?: InputMaybe<Array<PlatformNodeParentPlatformConnectionWhere>>;
  OR?: InputMaybe<Array<PlatformNodeParentPlatformConnectionWhere>>;
  node?: InputMaybe<PlatformNodeWhere>;
  node_NOT?: InputMaybe<PlatformNodeWhere>;
};

export type PlatformNodeParentPlatformCreateFieldInput = {
  node: PlatformNodeCreateInput;
};

export type PlatformNodeParentPlatformDeleteFieldInput = {
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  where?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
};

export type PlatformNodeParentPlatformDisconnectFieldInput = {
  disconnect?: InputMaybe<PlatformNodeDisconnectInput>;
  where?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
};

export type PlatformNodeParentPlatformFieldInput = {
  connect?: InputMaybe<PlatformNodeParentPlatformConnectFieldInput>;
  create?: InputMaybe<PlatformNodeParentPlatformCreateFieldInput>;
};

export type PlatformNodeParentPlatformNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PlatformNodeParentPlatformNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<PlatformNodeParentPlatformNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type PlatformNodeParentPlatformRelationship = {
  __typename?: 'platformNodeParentPlatformRelationship';
  cursor: Scalars['String'];
  node: PlatformNode;
};

export type PlatformNodeParentPlatformUpdateConnectionInput = {
  node?: InputMaybe<PlatformNodeUpdateInput>;
};

export type PlatformNodeParentPlatformUpdateFieldInput = {
  connect?: InputMaybe<PlatformNodeParentPlatformConnectFieldInput>;
  create?: InputMaybe<PlatformNodeParentPlatformCreateFieldInput>;
  delete?: InputMaybe<PlatformNodeParentPlatformDeleteFieldInput>;
  disconnect?: InputMaybe<PlatformNodeParentPlatformDisconnectFieldInput>;
  update?: InputMaybe<PlatformNodeParentPlatformUpdateConnectionInput>;
  where?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
};

export type PlatformNodeProductsAggregateInput = {
  AND?: InputMaybe<Array<PlatformNodeProductsAggregateInput>>;
  OR?: InputMaybe<Array<PlatformNodeProductsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<PlatformNodeProductsNodeAggregationWhereInput>;
};

export type PlatformNodeProductsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConnectInput>>;
  where?: InputMaybe<ProductNodeConnectWhere>;
};

export type PlatformNodeProductsConnection = {
  __typename?: 'platformNodeProductsConnection';
  edges: Array<PlatformNodeProductsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PlatformNodeProductsConnectionSort = {
  node?: InputMaybe<ProductNodeSort>;
};

export type PlatformNodeProductsConnectionWhere = {
  AND?: InputMaybe<Array<PlatformNodeProductsConnectionWhere>>;
  OR?: InputMaybe<Array<PlatformNodeProductsConnectionWhere>>;
  node?: InputMaybe<ProductNodeWhere>;
  node_NOT?: InputMaybe<ProductNodeWhere>;
};

export type PlatformNodeProductsCreateFieldInput = {
  node: ProductNodeCreateInput;
};

export type PlatformNodeProductsDeleteFieldInput = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<PlatformNodeProductsConnectionWhere>;
};

export type PlatformNodeProductsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  where?: InputMaybe<PlatformNodeProductsConnectionWhere>;
};

export type PlatformNodeProductsFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeProductsCreateFieldInput>>;
};

export type PlatformNodeProductsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<PlatformNodeProductsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<PlatformNodeProductsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sku_EQUAL?: InputMaybe<Scalars['String']>;
  sku_GT?: InputMaybe<Scalars['Int']>;
  sku_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_LT?: InputMaybe<Scalars['Int']>;
  sku_LTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type PlatformNodeProductsRelationship = {
  __typename?: 'platformNodeProductsRelationship';
  cursor: Scalars['String'];
  node: ProductNode;
};

export type PlatformNodeProductsUpdateConnectionInput = {
  node?: InputMaybe<ProductNodeUpdateInput>;
};

export type PlatformNodeProductsUpdateFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<PlatformNodeProductsCreateFieldInput>>;
  delete?: InputMaybe<Array<PlatformNodeProductsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<PlatformNodeProductsDisconnectFieldInput>>;
  update?: InputMaybe<PlatformNodeProductsUpdateConnectionInput>;
  where?: InputMaybe<PlatformNodeProductsConnectionWhere>;
};

export type PlatformNodeRelationInput = {
  childPlatforms?: InputMaybe<Array<PlatformNodeChildPlatformsCreateFieldInput>>;
  items?: InputMaybe<Array<PlatformNodeItemsCreateFieldInput>>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformCreateFieldInput>;
  products?: InputMaybe<Array<PlatformNodeProductsCreateFieldInput>>;
};

/** Fields to sort platformNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one platformNodeSort object. */
export type PlatformNodeSort = {
  code?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tagpathid?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type PlatformNodeUpdateInput = {
  childPlatforms?: InputMaybe<Array<PlatformNodeChildPlatformsUpdateFieldInput>>;
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<PlatformNodeItemsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  parentPlatform?: InputMaybe<PlatformNodeParentPlatformUpdateFieldInput>;
  products?: InputMaybe<Array<PlatformNodeProductsUpdateFieldInput>>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type PlatformNodeWhere = {
  AND?: InputMaybe<Array<PlatformNodeWhere>>;
  OR?: InputMaybe<Array<PlatformNodeWhere>>;
  childPlatforms?: InputMaybe<PlatformNodeWhere>;
  childPlatformsAggregate?: InputMaybe<PlatformNodeChildPlatformsAggregateInput>;
  childPlatformsConnection?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
  childPlatformsConnection_NOT?: InputMaybe<PlatformNodeChildPlatformsConnectionWhere>;
  childPlatforms_NOT?: InputMaybe<PlatformNodeWhere>;
  code?: InputMaybe<Scalars['String']>;
  code_CONTAINS?: InputMaybe<Scalars['String']>;
  code_ENDS_WITH?: InputMaybe<Scalars['String']>;
  code_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code_NOT?: InputMaybe<Scalars['String']>;
  code_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  code_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  code_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  code_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  code_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<PlatformNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<PlatformNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<PlatformNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  parentPlatform?: InputMaybe<PlatformNodeWhere>;
  parentPlatformAggregate?: InputMaybe<PlatformNodeParentPlatformAggregateInput>;
  parentPlatformConnection?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
  parentPlatformConnection_NOT?: InputMaybe<PlatformNodeParentPlatformConnectionWhere>;
  parentPlatform_NOT?: InputMaybe<PlatformNodeWhere>;
  products?: InputMaybe<ProductNodeWhere>;
  productsAggregate?: InputMaybe<PlatformNodeProductsAggregateInput>;
  productsConnection?: InputMaybe<PlatformNodeProductsConnectionWhere>;
  productsConnection_NOT?: InputMaybe<PlatformNodeProductsConnectionWhere>;
  products_NOT?: InputMaybe<ProductNodeWhere>;
  tagpathid?: InputMaybe<Scalars['String']>;
  tagpathid_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type PlatformNodeitemNodeItemsAggregationSelection = {
  __typename?: 'platformNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<PlatformNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<PlatformNodeitemNodeItemsNodeAggregateSelection>;
};

export type PlatformNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'platformNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type PlatformNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'platformNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type PlatformNodeplatformNodeChildPlatformsAggregationSelection = {
  __typename?: 'platformNodeplatformNodeChildPlatformsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<PlatformNodeplatformNodeChildPlatformsNodeAggregateSelection>;
};

export type PlatformNodeplatformNodeChildPlatformsNodeAggregateSelection = {
  __typename?: 'platformNodeplatformNodeChildPlatformsNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type PlatformNodeplatformNodeParentPlatformAggregationSelection = {
  __typename?: 'platformNodeplatformNodeParentPlatformAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<PlatformNodeplatformNodeParentPlatformNodeAggregateSelection>;
};

export type PlatformNodeplatformNodeParentPlatformNodeAggregateSelection = {
  __typename?: 'platformNodeplatformNodeParentPlatformNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type PlatformNodeproductNodeProductsAggregationSelection = {
  __typename?: 'platformNodeproductNodeProductsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<PlatformNodeproductNodeProductsNodeAggregateSelection>;
};

export type PlatformNodeproductNodeProductsNodeAggregateSelection = {
  __typename?: 'platformNodeproductNodeProductsNodeAggregateSelection';
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "platform" */
export type Platform_Aggregate = {
  __typename?: 'platform_aggregate';
  aggregate?: Maybe<Platform_Aggregate_Fields>;
  nodes: Array<Platform>;
};

export type Platform_Aggregate_Bool_Exp = {
  count?: InputMaybe<Platform_Aggregate_Bool_Exp_Count>;
};

export type Platform_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Platform_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "platform" */
export type Platform_Aggregate_Fields = {
  __typename?: 'platform_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Platform_Max_Fields>;
  min?: Maybe<Platform_Min_Fields>;
};


/** aggregate fields of "platform" */
export type Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "platform" */
export type Platform_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Platform_Max_Order_By>;
  min?: InputMaybe<Platform_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Platform_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "platform" */
export type Platform_Arr_Rel_Insert_Input = {
  data: Array<Platform_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};

/** Boolean expression to filter rows from the table "platform". All fields are combined with a logical 'AND'. */
export type Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Platform_Bool_Exp>>;
  _not?: InputMaybe<Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Platform_Bool_Exp>>;
  base_products?: InputMaybe<Base_Product_Bool_Exp>;
  base_products_aggregate?: InputMaybe<Base_Product_Aggregate_Bool_Exp>;
  children?: InputMaybe<Platform_Bool_Exp>;
  children_aggregate?: InputMaybe<Platform_Aggregate_Bool_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  derived_from?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  items?: InputMaybe<Item_Bom_Bool_Exp>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent?: InputMaybe<Platform_Bool_Exp>;
  requirements?: InputMaybe<Platform_Requirement_Bool_Exp>;
  requirements_aggregate?: InputMaybe<Platform_Requirement_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "platform" */
export type Platform_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'platform_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'platform_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Platform_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Platform_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Platform_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "platform" */
export type Platform_Insert_Input = {
  base_products?: InputMaybe<Base_Product_Arr_Rel_Insert_Input>;
  children?: InputMaybe<Platform_Arr_Rel_Insert_Input>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  derived_from?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Platform_Obj_Rel_Insert_Input>;
  requirements?: InputMaybe<Platform_Requirement_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Platform_Max_Fields = {
  __typename?: 'platform_max_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  derived_from?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "platform" */
export type Platform_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  derived_from?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Platform_Min_Fields = {
  __typename?: 'platform_min_fields';
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  derived_from?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "platform" */
export type Platform_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  derived_from?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "platform" */
export type Platform_Mutation_Response = {
  __typename?: 'platform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Platform>;
};

/** input type for inserting object relation for remote table "platform" */
export type Platform_Obj_Rel_Insert_Input = {
  data: Platform_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};

/** on_conflict condition type for table "platform" */
export type Platform_On_Conflict = {
  constraint: Platform_Constraint;
  update_columns?: Array<Platform_Update_Column>;
  where?: InputMaybe<Platform_Bool_Exp>;
};

/** Ordering options when selecting data from "platform". */
export type Platform_Order_By = {
  base_products_aggregate?: InputMaybe<Base_Product_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Platform_Aggregate_Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  derived_from?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent?: InputMaybe<Platform_Order_By>;
  requirements_aggregate?: InputMaybe<Platform_Requirement_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: platform */
export type Platform_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Platform_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "platform_requirement" */
export type Platform_Requirement = {
  __typename?: 'platform_requirement';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  /** An array relationship */
  fulfilled_by: Array<Product_Option>;
  /** An aggregate relationship */
  fulfilled_by_aggregate: Product_Option_Aggregate;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An object relationship */
  platform: Platform;
  platform_id: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "platform_requirement" */
export type Platform_RequirementFulfilled_ByArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "platform_requirement" */
export type Platform_RequirementFulfilled_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "platform_requirement" */
export type Platform_RequirementMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "platform_requirement" */
export type Platform_Requirement_Aggregate = {
  __typename?: 'platform_requirement_aggregate';
  aggregate?: Maybe<Platform_Requirement_Aggregate_Fields>;
  nodes: Array<Platform_Requirement>;
};

export type Platform_Requirement_Aggregate_Bool_Exp = {
  count?: InputMaybe<Platform_Requirement_Aggregate_Bool_Exp_Count>;
};

export type Platform_Requirement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Platform_Requirement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "platform_requirement" */
export type Platform_Requirement_Aggregate_Fields = {
  __typename?: 'platform_requirement_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Platform_Requirement_Max_Fields>;
  min?: Maybe<Platform_Requirement_Min_Fields>;
};


/** aggregate fields of "platform_requirement" */
export type Platform_Requirement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "platform_requirement" */
export type Platform_Requirement_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Platform_Requirement_Max_Order_By>;
  min?: InputMaybe<Platform_Requirement_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Platform_Requirement_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "platform_requirement" */
export type Platform_Requirement_Arr_Rel_Insert_Input = {
  data: Array<Platform_Requirement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_Requirement_On_Conflict>;
};

/** Boolean expression to filter rows from the table "platform_requirement". All fields are combined with a logical 'AND'. */
export type Platform_Requirement_Bool_Exp = {
  _and?: InputMaybe<Array<Platform_Requirement_Bool_Exp>>;
  _not?: InputMaybe<Platform_Requirement_Bool_Exp>;
  _or?: InputMaybe<Array<Platform_Requirement_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fulfilled_by?: InputMaybe<Product_Option_Bool_Exp>;
  fulfilled_by_aggregate?: InputMaybe<Product_Option_Aggregate_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  platform_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "platform_requirement" */
export type Platform_Requirement_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'platform_requirement_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Platform_Requirement_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Platform_Requirement_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Platform_Requirement_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "platform_requirement" */
export type Platform_Requirement_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  fulfilled_by?: InputMaybe<Product_Option_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Platform_Obj_Rel_Insert_Input>;
  platform_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Platform_Requirement_Max_Fields = {
  __typename?: 'platform_requirement_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "platform_requirement" */
export type Platform_Requirement_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Platform_Requirement_Min_Fields = {
  __typename?: 'platform_requirement_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "platform_requirement" */
export type Platform_Requirement_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "platform_requirement" */
export type Platform_Requirement_Mutation_Response = {
  __typename?: 'platform_requirement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Platform_Requirement>;
};

/** input type for inserting object relation for remote table "platform_requirement" */
export type Platform_Requirement_Obj_Rel_Insert_Input = {
  data: Platform_Requirement_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_Requirement_On_Conflict>;
};

/** on_conflict condition type for table "platform_requirement" */
export type Platform_Requirement_On_Conflict = {
  constraint: Platform_Requirement_Constraint;
  update_columns?: Array<Platform_Requirement_Update_Column>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};

/** Ordering options when selecting data from "platform_requirement". */
export type Platform_Requirement_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fulfilled_by_aggregate?: InputMaybe<Product_Option_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  platform_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: platform_requirement */
export type Platform_Requirement_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Platform_Requirement_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "platform_requirement" */
export type Platform_Requirement_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "platform_requirement" */
export type Platform_Requirement_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "platform_requirement" */
export type Platform_Requirement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platform_Requirement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platform_Requirement_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  platform_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "platform_requirement" */
export type Platform_Requirement_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'platform_id'
  /** column name */
  | 'updated_at';

export type Platform_Requirement_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Platform_Requirement_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Platform_Requirement_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Platform_Requirement_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Platform_Requirement_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Platform_Requirement_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Platform_Requirement_Set_Input>;
  /** filter the rows which have to be updated */
  where: Platform_Requirement_Bool_Exp;
};

/** select columns of table "platform" */
export type Platform_Select_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'derived_from'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "platform" */
export type Platform_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  derived_from?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "platform" */
export type Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platform_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  derived_from?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "platform" */
export type Platform_Update_Column =
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'derived_from'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at';

export type Platform_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Platform_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Platform_Set_Input>;
  /** filter the rows which have to be updated */
  where: Platform_Bool_Exp;
};

/** columns and relationships of "platform_utilization_view" */
export type Platform_Utilization_View = {
  __typename?: 'platform_utilization_view';
  current?: Maybe<Scalars['Int']>;
  domain?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['float8']>;
  program?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "platform_utilization_view" */
export type Platform_Utilization_View_Aggregate = {
  __typename?: 'platform_utilization_view_aggregate';
  aggregate?: Maybe<Platform_Utilization_View_Aggregate_Fields>;
  nodes: Array<Platform_Utilization_View>;
};

/** aggregate fields of "platform_utilization_view" */
export type Platform_Utilization_View_Aggregate_Fields = {
  __typename?: 'platform_utilization_view_aggregate_fields';
  avg?: Maybe<Platform_Utilization_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Platform_Utilization_View_Max_Fields>;
  min?: Maybe<Platform_Utilization_View_Min_Fields>;
  stddev?: Maybe<Platform_Utilization_View_Stddev_Fields>;
  stddev_pop?: Maybe<Platform_Utilization_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Platform_Utilization_View_Stddev_Samp_Fields>;
  sum?: Maybe<Platform_Utilization_View_Sum_Fields>;
  var_pop?: Maybe<Platform_Utilization_View_Var_Pop_Fields>;
  var_samp?: Maybe<Platform_Utilization_View_Var_Samp_Fields>;
  variance?: Maybe<Platform_Utilization_View_Variance_Fields>;
};


/** aggregate fields of "platform_utilization_view" */
export type Platform_Utilization_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platform_Utilization_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Platform_Utilization_View_Avg_Fields = {
  __typename?: 'platform_utilization_view_avg_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "platform_utilization_view". All fields are combined with a logical 'AND'. */
export type Platform_Utilization_View_Bool_Exp = {
  _and?: InputMaybe<Array<Platform_Utilization_View_Bool_Exp>>;
  _not?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
  _or?: InputMaybe<Array<Platform_Utilization_View_Bool_Exp>>;
  current?: InputMaybe<Int_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  percent?: InputMaybe<Float8_Comparison_Exp>;
  program?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Platform_Utilization_View_Max_Fields = {
  __typename?: 'platform_utilization_view_max_fields';
  current?: Maybe<Scalars['Int']>;
  domain?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['float8']>;
  program?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Platform_Utilization_View_Min_Fields = {
  __typename?: 'platform_utilization_view_min_fields';
  current?: Maybe<Scalars['Int']>;
  domain?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['float8']>;
  program?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "platform_utilization_view". */
export type Platform_Utilization_View_Order_By = {
  current?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  percent?: InputMaybe<Order_By>;
  program?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "platform_utilization_view" */
export type Platform_Utilization_View_Select_Column =
  /** column name */
  | 'current'
  /** column name */
  | 'domain'
  /** column name */
  | 'percent'
  /** column name */
  | 'program'
  /** column name */
  | 'total';

/** aggregate stddev on columns */
export type Platform_Utilization_View_Stddev_Fields = {
  __typename?: 'platform_utilization_view_stddev_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Platform_Utilization_View_Stddev_Pop_Fields = {
  __typename?: 'platform_utilization_view_stddev_pop_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Platform_Utilization_View_Stddev_Samp_Fields = {
  __typename?: 'platform_utilization_view_stddev_samp_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "platform_utilization_view" */
export type Platform_Utilization_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platform_Utilization_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platform_Utilization_View_Stream_Cursor_Value_Input = {
  current?: InputMaybe<Scalars['Int']>;
  domain?: InputMaybe<Scalars['String']>;
  percent?: InputMaybe<Scalars['float8']>;
  program?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Platform_Utilization_View_Sum_Fields = {
  __typename?: 'platform_utilization_view_sum_fields';
  current?: Maybe<Scalars['Int']>;
  percent?: Maybe<Scalars['float8']>;
  total?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Platform_Utilization_View_Var_Pop_Fields = {
  __typename?: 'platform_utilization_view_var_pop_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Platform_Utilization_View_Var_Samp_Fields = {
  __typename?: 'platform_utilization_view_var_samp_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Platform_Utilization_View_Variance_Fields = {
  __typename?: 'platform_utilization_view_variance_fields';
  current?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  baseProductId?: Maybe<Scalars['String']>;
  /** An object relationship */
  base_product?: Maybe<Base_Product>;
  /** An array relationship */
  bom_details: Array<Bom_Detail>;
  /** An aggregate relationship */
  bom_details_aggregate: Bom_Detail_Aggregate;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sku: Scalars['String'];
  status: Scalars['String'];
};


/** columns and relationships of "product" */
export type ProductBom_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductBom_Details_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};

export type ProductNode = {
  __typename?: 'productNode';
  configurations?: Maybe<Array<Maybe<UnitNode>>>;
  configurationsAggregate?: Maybe<ProductNodeunitNodeConfigurationsAggregationSelection>;
  configurationsConnection: ProductNodeConfigurationsConnection;
  derivedFrom?: Maybe<Array<Maybe<PlatformNode>>>;
  derivedFromAggregate?: Maybe<ProductNodeplatformNodeDerivedFromAggregationSelection>;
  derivedFromConnection: ProductNodeDerivedFromConnection;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<ProductNodeitemNodeItemsAggregationSelection>;
  itemsConnection: ProductNodeItemsConnection;
  productOptions?: Maybe<Array<Maybe<ProductOptionNode>>>;
  productOptionsAggregate?: Maybe<ProductNodeproductOptionNodeProductOptionsAggregationSelection>;
  productOptionsConnection: ProductNodeProductOptionsConnection;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  programsAggregate?: Maybe<ProductNodeprogramNodeProgramsAggregationSelection>;
  programsConnection: ProductNodeProgramsConnection;
  requiredOptions?: Maybe<Array<Maybe<ProductOptionNode>>>;
  requiredOptionsAggregate?: Maybe<ProductNodeproductOptionNodeRequiredOptionsAggregationSelection>;
  requiredOptionsConnection: ProductNodeRequiredOptionsConnection;
  sku?: Maybe<Scalars['String']>;
  tagpathid?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type ProductNodeConfigurationsArgs = {
  options?: InputMaybe<UnitNodeOptions>;
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProductNodeConfigurationsAggregateArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProductNodeConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeConfigurationsConnectionSort>>;
  where?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
};


export type ProductNodeDerivedFromArgs = {
  options?: InputMaybe<PlatformNodeOptions>;
  where?: InputMaybe<PlatformNodeWhere>;
};


export type ProductNodeDerivedFromAggregateArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type ProductNodeDerivedFromConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeDerivedFromConnectionSort>>;
  where?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
};


export type ProductNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProductNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProductNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeItemsConnectionSort>>;
  where?: InputMaybe<ProductNodeItemsConnectionWhere>;
};


export type ProductNodeProductOptionsArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ProductNodeProductOptionsAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ProductNodeProductOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeProductOptionsConnectionSort>>;
  where?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
};


export type ProductNodeProgramsArgs = {
  options?: InputMaybe<ProgramNodeOptions>;
  where?: InputMaybe<ProgramNodeWhere>;
};


export type ProductNodeProgramsAggregateArgs = {
  where?: InputMaybe<ProgramNodeWhere>;
};


export type ProductNodeProgramsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeProgramsConnectionSort>>;
  where?: InputMaybe<ProductNodeProgramsConnectionWhere>;
};


export type ProductNodeRequiredOptionsArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ProductNodeRequiredOptionsAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type ProductNodeRequiredOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductNodeRequiredOptionsConnectionSort>>;
  where?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
};

export type ProductNodeAggregateSelection = {
  __typename?: 'productNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeConfigurationsAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeConfigurationsAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeConfigurationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductNodeConfigurationsNodeAggregationWhereInput>;
};

export type ProductNodeConfigurationsConnectFieldInput = {
  connect?: InputMaybe<Array<UnitNodeConnectInput>>;
  where?: InputMaybe<UnitNodeConnectWhere>;
};

export type ProductNodeConfigurationsConnection = {
  __typename?: 'productNodeConfigurationsConnection';
  edges: Array<ProductNodeConfigurationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeConfigurationsConnectionSort = {
  node?: InputMaybe<UnitNodeSort>;
};

export type ProductNodeConfigurationsConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeConfigurationsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeConfigurationsConnectionWhere>>;
  node?: InputMaybe<UnitNodeWhere>;
  node_NOT?: InputMaybe<UnitNodeWhere>;
};

export type ProductNodeConfigurationsCreateFieldInput = {
  node: UnitNodeCreateInput;
};

export type ProductNodeConfigurationsDeleteFieldInput = {
  delete?: InputMaybe<UnitNodeDeleteInput>;
  where?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
};

export type ProductNodeConfigurationsDisconnectFieldInput = {
  disconnect?: InputMaybe<UnitNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
};

export type ProductNodeConfigurationsFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConfigurationsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeConfigurationsCreateFieldInput>>;
};

export type ProductNodeConfigurationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeConfigurationsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeConfigurationsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeConfigurationsRelationship = {
  __typename?: 'productNodeConfigurationsRelationship';
  cursor: Scalars['String'];
  node: UnitNode;
};

export type ProductNodeConfigurationsUpdateConnectionInput = {
  node?: InputMaybe<UnitNodeUpdateInput>;
};

export type ProductNodeConfigurationsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConfigurationsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeConfigurationsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeConfigurationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeConfigurationsDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeConfigurationsUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
};

export type ProductNodeConnectInput = {
  configurations?: InputMaybe<Array<ProductNodeConfigurationsConnectFieldInput>>;
  derivedFrom?: InputMaybe<Array<ProductNodeDerivedFromConnectFieldInput>>;
  items?: InputMaybe<Array<ProductNodeItemsConnectFieldInput>>;
  productOptions?: InputMaybe<Array<ProductNodeProductOptionsConnectFieldInput>>;
  programs?: InputMaybe<Array<ProductNodeProgramsConnectFieldInput>>;
  requiredOptions?: InputMaybe<Array<ProductNodeRequiredOptionsConnectFieldInput>>;
};

export type ProductNodeConnectWhere = {
  node: ProductNodeWhere;
};

export type ProductNodeCreateInput = {
  configurations?: InputMaybe<ProductNodeConfigurationsFieldInput>;
  derivedFrom?: InputMaybe<ProductNodeDerivedFromFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ProductNodeItemsFieldInput>;
  productOptions?: InputMaybe<ProductNodeProductOptionsFieldInput>;
  programs?: InputMaybe<ProductNodeProgramsFieldInput>;
  requiredOptions?: InputMaybe<ProductNodeRequiredOptionsFieldInput>;
  sku?: InputMaybe<Scalars['String']>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProductNodeDeleteInput = {
  configurations?: InputMaybe<Array<ProductNodeConfigurationsDeleteFieldInput>>;
  derivedFrom?: InputMaybe<Array<ProductNodeDerivedFromDeleteFieldInput>>;
  items?: InputMaybe<Array<ProductNodeItemsDeleteFieldInput>>;
  productOptions?: InputMaybe<Array<ProductNodeProductOptionsDeleteFieldInput>>;
  programs?: InputMaybe<Array<ProductNodeProgramsDeleteFieldInput>>;
  requiredOptions?: InputMaybe<Array<ProductNodeRequiredOptionsDeleteFieldInput>>;
};

export type ProductNodeDerivedFromAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeDerivedFromAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeDerivedFromAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductNodeDerivedFromNodeAggregationWhereInput>;
};

export type ProductNodeDerivedFromConnectFieldInput = {
  connect?: InputMaybe<Array<PlatformNodeConnectInput>>;
  where?: InputMaybe<PlatformNodeConnectWhere>;
};

export type ProductNodeDerivedFromConnection = {
  __typename?: 'productNodeDerivedFromConnection';
  edges: Array<ProductNodeDerivedFromRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeDerivedFromConnectionSort = {
  node?: InputMaybe<PlatformNodeSort>;
};

export type ProductNodeDerivedFromConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeDerivedFromConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeDerivedFromConnectionWhere>>;
  node?: InputMaybe<PlatformNodeWhere>;
  node_NOT?: InputMaybe<PlatformNodeWhere>;
};

export type ProductNodeDerivedFromCreateFieldInput = {
  node: PlatformNodeCreateInput;
};

export type ProductNodeDerivedFromDeleteFieldInput = {
  delete?: InputMaybe<PlatformNodeDeleteInput>;
  where?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
};

export type ProductNodeDerivedFromDisconnectFieldInput = {
  disconnect?: InputMaybe<PlatformNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
};

export type ProductNodeDerivedFromFieldInput = {
  connect?: InputMaybe<Array<ProductNodeDerivedFromConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeDerivedFromCreateFieldInput>>;
};

export type ProductNodeDerivedFromNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeDerivedFromNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeDerivedFromNodeAggregationWhereInput>>;
  code_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  code_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  code_EQUAL?: InputMaybe<Scalars['String']>;
  code_GT?: InputMaybe<Scalars['Int']>;
  code_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  code_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  code_LT?: InputMaybe<Scalars['Int']>;
  code_LTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  code_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeDerivedFromRelationship = {
  __typename?: 'productNodeDerivedFromRelationship';
  cursor: Scalars['String'];
  node: PlatformNode;
};

export type ProductNodeDerivedFromUpdateConnectionInput = {
  node?: InputMaybe<PlatformNodeUpdateInput>;
};

export type ProductNodeDerivedFromUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeDerivedFromConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeDerivedFromCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeDerivedFromDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeDerivedFromDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeDerivedFromUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
};

export type ProductNodeDisconnectInput = {
  configurations?: InputMaybe<Array<ProductNodeConfigurationsDisconnectFieldInput>>;
  derivedFrom?: InputMaybe<Array<ProductNodeDerivedFromDisconnectFieldInput>>;
  items?: InputMaybe<Array<ProductNodeItemsDisconnectFieldInput>>;
  productOptions?: InputMaybe<Array<ProductNodeProductOptionsDisconnectFieldInput>>;
  programs?: InputMaybe<Array<ProductNodeProgramsDisconnectFieldInput>>;
  requiredOptions?: InputMaybe<Array<ProductNodeRequiredOptionsDisconnectFieldInput>>;
};

export type ProductNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ProductNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<ProductNodeItemsNodeAggregationWhereInput>;
};

export type ProductNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type ProductNodeItemsConnection = {
  __typename?: 'productNodeItemsConnection';
  edges: Array<ProductNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type ProductNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type ProductNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type ProductNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<ProductNodeItemsConnectionWhere>;
};

export type ProductNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeItemsConnectionWhere>;
};

export type ProductNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ProductNodeItemsFieldInput = {
  connect?: InputMaybe<Array<ProductNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeItemsCreateFieldInput>>;
};

export type ProductNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeItemsRelationship = Quantity & {
  __typename?: 'productNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type ProductNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type ProductNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeItemsConnectionWhere>;
};

export type ProductNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more productNodeSort objects to sort productNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ProductNodeSort>>>;
};

export type ProductNodeProductOptionsAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeProductOptionsAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeProductOptionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductNodeProductOptionsNodeAggregationWhereInput>;
};

export type ProductNodeProductOptionsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeConnectInput>>;
  where?: InputMaybe<ProductOptionNodeConnectWhere>;
};

export type ProductNodeProductOptionsConnection = {
  __typename?: 'productNodeProductOptionsConnection';
  edges: Array<ProductNodeProductOptionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeProductOptionsConnectionSort = {
  node?: InputMaybe<ProductOptionNodeSort>;
};

export type ProductNodeProductOptionsConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeProductOptionsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeProductOptionsConnectionWhere>>;
  node?: InputMaybe<ProductOptionNodeWhere>;
  node_NOT?: InputMaybe<ProductOptionNodeWhere>;
};

export type ProductNodeProductOptionsCreateFieldInput = {
  node: ProductOptionNodeCreateInput;
};

export type ProductNodeProductOptionsDeleteFieldInput = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
};

export type ProductNodeProductOptionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
};

export type ProductNodeProductOptionsFieldInput = {
  connect?: InputMaybe<Array<ProductNodeProductOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeProductOptionsCreateFieldInput>>;
};

export type ProductNodeProductOptionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeProductOptionsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeProductOptionsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeProductOptionsRelationship = {
  __typename?: 'productNodeProductOptionsRelationship';
  cursor: Scalars['String'];
  node: ProductOptionNode;
};

export type ProductNodeProductOptionsUpdateConnectionInput = {
  node?: InputMaybe<ProductOptionNodeUpdateInput>;
};

export type ProductNodeProductOptionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeProductOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeProductOptionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeProductOptionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeProductOptionsDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeProductOptionsUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
};

export type ProductNodeProgramsAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeProgramsAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeProgramsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductNodeProgramsNodeAggregationWhereInput>;
};

export type ProductNodeProgramsConnectFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeConnectInput>>;
  where?: InputMaybe<ProgramNodeConnectWhere>;
};

export type ProductNodeProgramsConnection = {
  __typename?: 'productNodeProgramsConnection';
  edges: Array<ProductNodeProgramsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeProgramsConnectionSort = {
  node?: InputMaybe<ProgramNodeSort>;
};

export type ProductNodeProgramsConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeProgramsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeProgramsConnectionWhere>>;
  node?: InputMaybe<ProgramNodeWhere>;
  node_NOT?: InputMaybe<ProgramNodeWhere>;
};

export type ProductNodeProgramsCreateFieldInput = {
  node: ProgramNodeCreateInput;
};

export type ProductNodeProgramsDeleteFieldInput = {
  delete?: InputMaybe<ProgramNodeDeleteInput>;
  where?: InputMaybe<ProductNodeProgramsConnectionWhere>;
};

export type ProductNodeProgramsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProgramNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeProgramsConnectionWhere>;
};

export type ProductNodeProgramsFieldInput = {
  connect?: InputMaybe<Array<ProductNodeProgramsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeProgramsCreateFieldInput>>;
};

export type ProductNodeProgramsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeProgramsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeProgramsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeProgramsRelationship = {
  __typename?: 'productNodeProgramsRelationship';
  cursor: Scalars['String'];
  node: ProgramNode;
};

export type ProductNodeProgramsUpdateConnectionInput = {
  node?: InputMaybe<ProgramNodeUpdateInput>;
};

export type ProductNodeProgramsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeProgramsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeProgramsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeProgramsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeProgramsDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeProgramsUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeProgramsConnectionWhere>;
};

export type ProductNodeRelationInput = {
  configurations?: InputMaybe<Array<ProductNodeConfigurationsCreateFieldInput>>;
  derivedFrom?: InputMaybe<Array<ProductNodeDerivedFromCreateFieldInput>>;
  items?: InputMaybe<Array<ProductNodeItemsCreateFieldInput>>;
  productOptions?: InputMaybe<Array<ProductNodeProductOptionsCreateFieldInput>>;
  programs?: InputMaybe<Array<ProductNodeProgramsCreateFieldInput>>;
  requiredOptions?: InputMaybe<Array<ProductNodeRequiredOptionsCreateFieldInput>>;
};

export type ProductNodeRequiredOptionsAggregateInput = {
  AND?: InputMaybe<Array<ProductNodeRequiredOptionsAggregateInput>>;
  OR?: InputMaybe<Array<ProductNodeRequiredOptionsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductNodeRequiredOptionsNodeAggregationWhereInput>;
};

export type ProductNodeRequiredOptionsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeConnectInput>>;
  where?: InputMaybe<ProductOptionNodeConnectWhere>;
};

export type ProductNodeRequiredOptionsConnection = {
  __typename?: 'productNodeRequiredOptionsConnection';
  edges: Array<ProductNodeRequiredOptionsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductNodeRequiredOptionsConnectionSort = {
  node?: InputMaybe<ProductOptionNodeSort>;
};

export type ProductNodeRequiredOptionsConnectionWhere = {
  AND?: InputMaybe<Array<ProductNodeRequiredOptionsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductNodeRequiredOptionsConnectionWhere>>;
  node?: InputMaybe<ProductOptionNodeWhere>;
  node_NOT?: InputMaybe<ProductOptionNodeWhere>;
};

export type ProductNodeRequiredOptionsCreateFieldInput = {
  node: ProductOptionNodeCreateInput;
};

export type ProductNodeRequiredOptionsDeleteFieldInput = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
};

export type ProductNodeRequiredOptionsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  where?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
};

export type ProductNodeRequiredOptionsFieldInput = {
  connect?: InputMaybe<Array<ProductNodeRequiredOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeRequiredOptionsCreateFieldInput>>;
};

export type ProductNodeRequiredOptionsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductNodeRequiredOptionsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductNodeRequiredOptionsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductNodeRequiredOptionsRelationship = {
  __typename?: 'productNodeRequiredOptionsRelationship';
  cursor: Scalars['String'];
  node: ProductOptionNode;
};

export type ProductNodeRequiredOptionsUpdateConnectionInput = {
  node?: InputMaybe<ProductOptionNodeUpdateInput>;
};

export type ProductNodeRequiredOptionsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductNodeRequiredOptionsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductNodeRequiredOptionsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductNodeRequiredOptionsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductNodeRequiredOptionsDisconnectFieldInput>>;
  update?: InputMaybe<ProductNodeRequiredOptionsUpdateConnectionInput>;
  where?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
};

/** Fields to sort productNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one productNodeSort object. */
export type ProductNodeSort = {
  description?: InputMaybe<SortDirection>;
  sku?: InputMaybe<SortDirection>;
  tagpathid?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ProductNodeUpdateInput = {
  configurations?: InputMaybe<Array<ProductNodeConfigurationsUpdateFieldInput>>;
  derivedFrom?: InputMaybe<Array<ProductNodeDerivedFromUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ProductNodeItemsUpdateFieldInput>>;
  productOptions?: InputMaybe<Array<ProductNodeProductOptionsUpdateFieldInput>>;
  programs?: InputMaybe<Array<ProductNodeProgramsUpdateFieldInput>>;
  requiredOptions?: InputMaybe<Array<ProductNodeRequiredOptionsUpdateFieldInput>>;
  sku?: InputMaybe<Scalars['String']>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProductNodeWhere = {
  AND?: InputMaybe<Array<ProductNodeWhere>>;
  OR?: InputMaybe<Array<ProductNodeWhere>>;
  configurations?: InputMaybe<UnitNodeWhere>;
  configurationsAggregate?: InputMaybe<ProductNodeConfigurationsAggregateInput>;
  configurationsConnection?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
  configurationsConnection_NOT?: InputMaybe<ProductNodeConfigurationsConnectionWhere>;
  configurations_NOT?: InputMaybe<UnitNodeWhere>;
  derivedFrom?: InputMaybe<PlatformNodeWhere>;
  derivedFromAggregate?: InputMaybe<ProductNodeDerivedFromAggregateInput>;
  derivedFromConnection?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
  derivedFromConnection_NOT?: InputMaybe<ProductNodeDerivedFromConnectionWhere>;
  derivedFrom_NOT?: InputMaybe<PlatformNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<ProductNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<ProductNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<ProductNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  productOptions?: InputMaybe<ProductOptionNodeWhere>;
  productOptionsAggregate?: InputMaybe<ProductNodeProductOptionsAggregateInput>;
  productOptionsConnection?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
  productOptionsConnection_NOT?: InputMaybe<ProductNodeProductOptionsConnectionWhere>;
  productOptions_NOT?: InputMaybe<ProductOptionNodeWhere>;
  programs?: InputMaybe<ProgramNodeWhere>;
  programsAggregate?: InputMaybe<ProductNodeProgramsAggregateInput>;
  programsConnection?: InputMaybe<ProductNodeProgramsConnectionWhere>;
  programsConnection_NOT?: InputMaybe<ProductNodeProgramsConnectionWhere>;
  programs_NOT?: InputMaybe<ProgramNodeWhere>;
  requiredOptions?: InputMaybe<ProductOptionNodeWhere>;
  requiredOptionsAggregate?: InputMaybe<ProductNodeRequiredOptionsAggregateInput>;
  requiredOptionsConnection?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
  requiredOptionsConnection_NOT?: InputMaybe<ProductNodeRequiredOptionsConnectionWhere>;
  requiredOptions_NOT?: InputMaybe<ProductOptionNodeWhere>;
  sku?: InputMaybe<Scalars['String']>;
  sku_CONTAINS?: InputMaybe<Scalars['String']>;
  sku_ENDS_WITH?: InputMaybe<Scalars['String']>;
  sku_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku_NOT?: InputMaybe<Scalars['String']>;
  sku_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  sku_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  sku_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  sku_STARTS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid?: InputMaybe<Scalars['String']>;
  tagpathid_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ProductNodeitemNodeItemsAggregationSelection = {
  __typename?: 'productNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ProductNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<ProductNodeitemNodeItemsNodeAggregateSelection>;
};

export type ProductNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'productNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ProductNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'productNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeplatformNodeDerivedFromAggregationSelection = {
  __typename?: 'productNodeplatformNodeDerivedFromAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductNodeplatformNodeDerivedFromNodeAggregateSelection>;
};

export type ProductNodeplatformNodeDerivedFromNodeAggregateSelection = {
  __typename?: 'productNodeplatformNodeDerivedFromNodeAggregateSelection';
  code: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeproductOptionNodeProductOptionsAggregationSelection = {
  __typename?: 'productNodeproductOptionNodeProductOptionsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductNodeproductOptionNodeProductOptionsNodeAggregateSelection>;
};

export type ProductNodeproductOptionNodeProductOptionsNodeAggregateSelection = {
  __typename?: 'productNodeproductOptionNodeProductOptionsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeproductOptionNodeRequiredOptionsAggregationSelection = {
  __typename?: 'productNodeproductOptionNodeRequiredOptionsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductNodeproductOptionNodeRequiredOptionsNodeAggregateSelection>;
};

export type ProductNodeproductOptionNodeRequiredOptionsNodeAggregateSelection = {
  __typename?: 'productNodeproductOptionNodeRequiredOptionsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeprogramNodeProgramsAggregationSelection = {
  __typename?: 'productNodeprogramNodeProgramsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductNodeprogramNodeProgramsNodeAggregateSelection>;
};

export type ProductNodeprogramNodeProgramsNodeAggregateSelection = {
  __typename?: 'productNodeprogramNodeProgramsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductNodeunitNodeConfigurationsAggregationSelection = {
  __typename?: 'productNodeunitNodeConfigurationsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductNodeunitNodeConfigurationsNodeAggregateSelection>;
};

export type ProductNodeunitNodeConfigurationsNodeAggregateSelection = {
  __typename?: 'productNodeunitNodeConfigurationsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductOptionNode = {
  __typename?: 'productOptionNode';
  choices?: Maybe<Array<Maybe<ChoiceNode>>>;
  choicesAggregate?: Maybe<ProductOptionNodechoiceNodeChoicesAggregationSelection>;
  choicesConnection: ProductOptionNodeChoicesConnection;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<ProductOptionNodeitemNodeItemsAggregationSelection>;
  itemsConnection: ProductOptionNodeItemsConnection;
  name?: Maybe<Scalars['String']>;
  partOf?: Maybe<Array<Maybe<UnitNode>>>;
  partOfAggregate?: Maybe<ProductOptionNodeunitNodePartOfAggregationSelection>;
  partOfConnection: ProductOptionNodePartOfConnection;
  products?: Maybe<Array<Maybe<ProductNode>>>;
  productsAggregate?: Maybe<ProductOptionNodeproductNodeProductsAggregationSelection>;
  productsConnection: ProductOptionNodeProductsConnection;
  tagpathid?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type ProductOptionNodeChoicesArgs = {
  options?: InputMaybe<ChoiceNodeOptions>;
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type ProductOptionNodeChoicesAggregateArgs = {
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type ProductOptionNodeChoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductOptionNodeChoicesConnectionSort>>;
  where?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
};


export type ProductOptionNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProductOptionNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProductOptionNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductOptionNodeItemsConnectionSort>>;
  where?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
};


export type ProductOptionNodePartOfArgs = {
  options?: InputMaybe<UnitNodeOptions>;
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProductOptionNodePartOfAggregateArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProductOptionNodePartOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductOptionNodePartOfConnectionSort>>;
  where?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
};


export type ProductOptionNodeProductsArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type ProductOptionNodeProductsAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type ProductOptionNodeProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProductOptionNodeProductsConnectionSort>>;
  where?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
};

export type ProductOptionNodeAggregateSelection = {
  __typename?: 'productOptionNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductOptionNodeChoicesAggregateInput = {
  AND?: InputMaybe<Array<ProductOptionNodeChoicesAggregateInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeChoicesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductOptionNodeChoicesNodeAggregationWhereInput>;
};

export type ProductOptionNodeChoicesConnectFieldInput = {
  connect?: InputMaybe<Array<ChoiceNodeConnectInput>>;
  where?: InputMaybe<ChoiceNodeConnectWhere>;
};

export type ProductOptionNodeChoicesConnection = {
  __typename?: 'productOptionNodeChoicesConnection';
  edges: Array<ProductOptionNodeChoicesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductOptionNodeChoicesConnectionSort = {
  node?: InputMaybe<ChoiceNodeSort>;
};

export type ProductOptionNodeChoicesConnectionWhere = {
  AND?: InputMaybe<Array<ProductOptionNodeChoicesConnectionWhere>>;
  OR?: InputMaybe<Array<ProductOptionNodeChoicesConnectionWhere>>;
  node?: InputMaybe<ChoiceNodeWhere>;
  node_NOT?: InputMaybe<ChoiceNodeWhere>;
};

export type ProductOptionNodeChoicesCreateFieldInput = {
  node: ChoiceNodeCreateInput;
};

export type ProductOptionNodeChoicesDeleteFieldInput = {
  delete?: InputMaybe<ChoiceNodeDeleteInput>;
  where?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
};

export type ProductOptionNodeChoicesDisconnectFieldInput = {
  disconnect?: InputMaybe<ChoiceNodeDisconnectInput>;
  where?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
};

export type ProductOptionNodeChoicesFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeChoicesCreateFieldInput>>;
};

export type ProductOptionNodeChoicesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductOptionNodeChoicesNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeChoicesNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  label_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  label_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  label_EQUAL?: InputMaybe<Scalars['String']>;
  label_GT?: InputMaybe<Scalars['Int']>;
  label_GTE?: InputMaybe<Scalars['Int']>;
  label_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  label_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  label_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  label_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  label_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  label_LT?: InputMaybe<Scalars['Int']>;
  label_LTE?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  label_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sort_order_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sort_order_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_GT?: InputMaybe<Scalars['Int']>;
  sort_order_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_LT?: InputMaybe<Scalars['Int']>;
  sort_order_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_GT?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_LT?: InputMaybe<Scalars['Int']>;
  sort_order_MAX_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_GT?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_LT?: InputMaybe<Scalars['Int']>;
  sort_order_MIN_LTE?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_EQUAL?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_GT?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_GTE?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_LT?: InputMaybe<Scalars['Int']>;
  sort_order_SUM_LTE?: InputMaybe<Scalars['Int']>;
  value_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  value_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  value_EQUAL?: InputMaybe<Scalars['String']>;
  value_GT?: InputMaybe<Scalars['Int']>;
  value_GTE?: InputMaybe<Scalars['Int']>;
  value_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  value_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  value_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  value_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  value_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  value_LT?: InputMaybe<Scalars['Int']>;
  value_LTE?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  value_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductOptionNodeChoicesRelationship = {
  __typename?: 'productOptionNodeChoicesRelationship';
  cursor: Scalars['String'];
  node: ChoiceNode;
};

export type ProductOptionNodeChoicesUpdateConnectionInput = {
  node?: InputMaybe<ChoiceNodeUpdateInput>;
};

export type ProductOptionNodeChoicesUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeChoicesCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductOptionNodeChoicesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductOptionNodeChoicesDisconnectFieldInput>>;
  update?: InputMaybe<ProductOptionNodeChoicesUpdateConnectionInput>;
  where?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
};

export type ProductOptionNodeConnectInput = {
  choices?: InputMaybe<Array<ProductOptionNodeChoicesConnectFieldInput>>;
  items?: InputMaybe<Array<ProductOptionNodeItemsConnectFieldInput>>;
  partOf?: InputMaybe<Array<ProductOptionNodePartOfConnectFieldInput>>;
  products?: InputMaybe<Array<ProductOptionNodeProductsConnectFieldInput>>;
};

export type ProductOptionNodeConnectWhere = {
  node: ProductOptionNodeWhere;
};

export type ProductOptionNodeCreateInput = {
  choices?: InputMaybe<ProductOptionNodeChoicesFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ProductOptionNodeItemsFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  partOf?: InputMaybe<ProductOptionNodePartOfFieldInput>;
  products?: InputMaybe<ProductOptionNodeProductsFieldInput>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProductOptionNodeDeleteInput = {
  choices?: InputMaybe<Array<ProductOptionNodeChoicesDeleteFieldInput>>;
  items?: InputMaybe<Array<ProductOptionNodeItemsDeleteFieldInput>>;
  partOf?: InputMaybe<Array<ProductOptionNodePartOfDeleteFieldInput>>;
  products?: InputMaybe<Array<ProductOptionNodeProductsDeleteFieldInput>>;
};

export type ProductOptionNodeDisconnectInput = {
  choices?: InputMaybe<Array<ProductOptionNodeChoicesDisconnectFieldInput>>;
  items?: InputMaybe<Array<ProductOptionNodeItemsDisconnectFieldInput>>;
  partOf?: InputMaybe<Array<ProductOptionNodePartOfDisconnectFieldInput>>;
  products?: InputMaybe<Array<ProductOptionNodeProductsDisconnectFieldInput>>;
};

export type ProductOptionNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<ProductOptionNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ProductOptionNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<ProductOptionNodeItemsNodeAggregationWhereInput>;
};

export type ProductOptionNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type ProductOptionNodeItemsConnection = {
  __typename?: 'productOptionNodeItemsConnection';
  edges: Array<ProductOptionNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductOptionNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type ProductOptionNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<ProductOptionNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductOptionNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type ProductOptionNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type ProductOptionNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
};

export type ProductOptionNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
};

export type ProductOptionNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductOptionNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ProductOptionNodeItemsFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeItemsCreateFieldInput>>;
};

export type ProductOptionNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductOptionNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductOptionNodeItemsRelationship = Quantity & {
  __typename?: 'productOptionNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type ProductOptionNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type ProductOptionNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductOptionNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductOptionNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<ProductOptionNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
};

export type ProductOptionNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more productOptionNodeSort objects to sort productOptionNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ProductOptionNodeSort>>>;
};

export type ProductOptionNodePartOfAggregateInput = {
  AND?: InputMaybe<Array<ProductOptionNodePartOfAggregateInput>>;
  OR?: InputMaybe<Array<ProductOptionNodePartOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductOptionNodePartOfNodeAggregationWhereInput>;
};

export type ProductOptionNodePartOfConnectFieldInput = {
  connect?: InputMaybe<Array<UnitNodeConnectInput>>;
  where?: InputMaybe<UnitNodeConnectWhere>;
};

export type ProductOptionNodePartOfConnection = {
  __typename?: 'productOptionNodePartOfConnection';
  edges: Array<ProductOptionNodePartOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductOptionNodePartOfConnectionSort = {
  node?: InputMaybe<UnitNodeSort>;
};

export type ProductOptionNodePartOfConnectionWhere = {
  AND?: InputMaybe<Array<ProductOptionNodePartOfConnectionWhere>>;
  OR?: InputMaybe<Array<ProductOptionNodePartOfConnectionWhere>>;
  node?: InputMaybe<UnitNodeWhere>;
  node_NOT?: InputMaybe<UnitNodeWhere>;
};

export type ProductOptionNodePartOfCreateFieldInput = {
  node: UnitNodeCreateInput;
};

export type ProductOptionNodePartOfDeleteFieldInput = {
  delete?: InputMaybe<UnitNodeDeleteInput>;
  where?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
};

export type ProductOptionNodePartOfDisconnectFieldInput = {
  disconnect?: InputMaybe<UnitNodeDisconnectInput>;
  where?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
};

export type ProductOptionNodePartOfFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodePartOfConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodePartOfCreateFieldInput>>;
};

export type ProductOptionNodePartOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductOptionNodePartOfNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionNodePartOfNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductOptionNodePartOfRelationship = {
  __typename?: 'productOptionNodePartOfRelationship';
  cursor: Scalars['String'];
  node: UnitNode;
};

export type ProductOptionNodePartOfUpdateConnectionInput = {
  node?: InputMaybe<UnitNodeUpdateInput>;
};

export type ProductOptionNodePartOfUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodePartOfConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodePartOfCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductOptionNodePartOfDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductOptionNodePartOfDisconnectFieldInput>>;
  update?: InputMaybe<ProductOptionNodePartOfUpdateConnectionInput>;
  where?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
};

export type ProductOptionNodeProductsAggregateInput = {
  AND?: InputMaybe<Array<ProductOptionNodeProductsAggregateInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeProductsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProductOptionNodeProductsNodeAggregationWhereInput>;
};

export type ProductOptionNodeProductsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConnectInput>>;
  where?: InputMaybe<ProductNodeConnectWhere>;
};

export type ProductOptionNodeProductsConnection = {
  __typename?: 'productOptionNodeProductsConnection';
  edges: Array<ProductOptionNodeProductsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProductOptionNodeProductsConnectionSort = {
  node?: InputMaybe<ProductNodeSort>;
};

export type ProductOptionNodeProductsConnectionWhere = {
  AND?: InputMaybe<Array<ProductOptionNodeProductsConnectionWhere>>;
  OR?: InputMaybe<Array<ProductOptionNodeProductsConnectionWhere>>;
  node?: InputMaybe<ProductNodeWhere>;
  node_NOT?: InputMaybe<ProductNodeWhere>;
};

export type ProductOptionNodeProductsCreateFieldInput = {
  node: ProductNodeCreateInput;
};

export type ProductOptionNodeProductsDeleteFieldInput = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
};

export type ProductOptionNodeProductsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  where?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
};

export type ProductOptionNodeProductsFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeProductsCreateFieldInput>>;
};

export type ProductOptionNodeProductsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProductOptionNodeProductsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProductOptionNodeProductsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sku_EQUAL?: InputMaybe<Scalars['String']>;
  sku_GT?: InputMaybe<Scalars['Int']>;
  sku_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_LT?: InputMaybe<Scalars['Int']>;
  sku_LTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProductOptionNodeProductsRelationship = {
  __typename?: 'productOptionNodeProductsRelationship';
  cursor: Scalars['String'];
  node: ProductNode;
};

export type ProductOptionNodeProductsUpdateConnectionInput = {
  node?: InputMaybe<ProductNodeUpdateInput>;
};

export type ProductOptionNodeProductsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ProductOptionNodeProductsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProductOptionNodeProductsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProductOptionNodeProductsDisconnectFieldInput>>;
  update?: InputMaybe<ProductOptionNodeProductsUpdateConnectionInput>;
  where?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
};

export type ProductOptionNodeRelationInput = {
  choices?: InputMaybe<Array<ProductOptionNodeChoicesCreateFieldInput>>;
  items?: InputMaybe<Array<ProductOptionNodeItemsCreateFieldInput>>;
  partOf?: InputMaybe<Array<ProductOptionNodePartOfCreateFieldInput>>;
  products?: InputMaybe<Array<ProductOptionNodeProductsCreateFieldInput>>;
};

/** Fields to sort productOptionNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one productOptionNodeSort object. */
export type ProductOptionNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tagpathid?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ProductOptionNodeUpdateInput = {
  choices?: InputMaybe<Array<ProductOptionNodeChoicesUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ProductOptionNodeItemsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  partOf?: InputMaybe<Array<ProductOptionNodePartOfUpdateFieldInput>>;
  products?: InputMaybe<Array<ProductOptionNodeProductsUpdateFieldInput>>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProductOptionNodeWhere = {
  AND?: InputMaybe<Array<ProductOptionNodeWhere>>;
  OR?: InputMaybe<Array<ProductOptionNodeWhere>>;
  choices?: InputMaybe<ChoiceNodeWhere>;
  choicesAggregate?: InputMaybe<ProductOptionNodeChoicesAggregateInput>;
  choicesConnection?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
  choicesConnection_NOT?: InputMaybe<ProductOptionNodeChoicesConnectionWhere>;
  choices_NOT?: InputMaybe<ChoiceNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<ProductOptionNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<ProductOptionNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  partOf?: InputMaybe<UnitNodeWhere>;
  partOfAggregate?: InputMaybe<ProductOptionNodePartOfAggregateInput>;
  partOfConnection?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
  partOfConnection_NOT?: InputMaybe<ProductOptionNodePartOfConnectionWhere>;
  partOf_NOT?: InputMaybe<UnitNodeWhere>;
  products?: InputMaybe<ProductNodeWhere>;
  productsAggregate?: InputMaybe<ProductOptionNodeProductsAggregateInput>;
  productsConnection?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
  productsConnection_NOT?: InputMaybe<ProductOptionNodeProductsConnectionWhere>;
  products_NOT?: InputMaybe<ProductNodeWhere>;
  tagpathid?: InputMaybe<Scalars['String']>;
  tagpathid_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ProductOptionNodechoiceNodeChoicesAggregationSelection = {
  __typename?: 'productOptionNodechoiceNodeChoicesAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductOptionNodechoiceNodeChoicesNodeAggregateSelection>;
};

export type ProductOptionNodechoiceNodeChoicesNodeAggregateSelection = {
  __typename?: 'productOptionNodechoiceNodeChoicesNodeAggregateSelection';
  description: StringAggregateSelection;
  label: StringAggregateSelection;
  name: StringAggregateSelection;
  sort_order: IntAggregateSelection;
  value: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductOptionNodeitemNodeItemsAggregationSelection = {
  __typename?: 'productOptionNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ProductOptionNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<ProductOptionNodeitemNodeItemsNodeAggregateSelection>;
};

export type ProductOptionNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'productOptionNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ProductOptionNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'productOptionNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductOptionNodeproductNodeProductsAggregationSelection = {
  __typename?: 'productOptionNodeproductNodeProductsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductOptionNodeproductNodeProductsNodeAggregateSelection>;
};

export type ProductOptionNodeproductNodeProductsNodeAggregateSelection = {
  __typename?: 'productOptionNodeproductNodeProductsNodeAggregateSelection';
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProductOptionNodeunitNodePartOfAggregationSelection = {
  __typename?: 'productOptionNodeunitNodePartOfAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProductOptionNodeunitNodePartOfNodeAggregateSelection>;
};

export type ProductOptionNodeunitNodePartOfNodeAggregateSelection = {
  __typename?: 'productOptionNodeunitNodePartOfNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

export type Product_Aggregate_Bool_Exp = {
  count?: InputMaybe<Product_Aggregate_Bool_Exp_Count>;
};

export type Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product" */
export type Product_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Max_Order_By>;
  min?: InputMaybe<Product_Min_Order_By>;
};

/** input type for inserting array relation for remote table "product" */
export type Product_Arr_Rel_Insert_Input = {
  data: Array<Product_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  baseProductId?: InputMaybe<String_Comparison_Exp>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  bom_details?: InputMaybe<Bom_Detail_Bool_Exp>;
  bom_details_aggregate?: InputMaybe<Bom_Detail_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product" */
export type Product_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_pkey'
  /** unique or primary key constraint on columns "sku" */
  | 'product_sku_key';

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  bom_details?: InputMaybe<Bom_Detail_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  baseProductId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "product" */
export type Product_Max_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  baseProductId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "product" */
export type Product_Min_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** columns and relationships of "product_option" */
export type Product_Option = {
  __typename?: 'product_option';
  allow_multiple: Scalars['Boolean'];
  /** An object relationship */
  base_product: Base_Product;
  base_product_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from_choice?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** An object relationship */
  platform_requirement?: Maybe<Platform_Requirement>;
  platform_requirement_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  product_option?: Maybe<Product_Option>;
  /** An object relationship */
  product_option_choice?: Maybe<Product_Option_Choice>;
  /** An array relationship */
  product_option_choices: Array<Product_Option_Choice>;
  /** An aggregate relationship */
  product_option_choices_aggregate: Product_Option_Choice_Aggregate;
  /** An array relationship */
  product_options: Array<Product_Option>;
  /** An aggregate relationship */
  product_options_aggregate: Product_Option_Aggregate;
  root_option?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "product_option" */
export type Product_OptionProduct_Option_ChoicesArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


/** columns and relationships of "product_option" */
export type Product_OptionProduct_Option_Choices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


/** columns and relationships of "product_option" */
export type Product_OptionProduct_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "product_option" */
export type Product_OptionProduct_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};

/** aggregated selection of "product_option" */
export type Product_Option_Aggregate = {
  __typename?: 'product_option_aggregate';
  aggregate?: Maybe<Product_Option_Aggregate_Fields>;
  nodes: Array<Product_Option>;
};

export type Product_Option_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Option_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Option_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Option_Aggregate_Bool_Exp_Count>;
};

export type Product_Option_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Option_Select_Column_Product_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Option_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Option_Select_Column_Product_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Option_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_option" */
export type Product_Option_Aggregate_Fields = {
  __typename?: 'product_option_aggregate_fields';
  avg?: Maybe<Product_Option_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Option_Max_Fields>;
  min?: Maybe<Product_Option_Min_Fields>;
  stddev?: Maybe<Product_Option_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Option_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Option_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Option_Sum_Fields>;
  var_pop?: Maybe<Product_Option_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Option_Var_Samp_Fields>;
  variance?: Maybe<Product_Option_Variance_Fields>;
};


/** aggregate fields of "product_option" */
export type Product_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_option" */
export type Product_Option_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Option_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Option_Max_Order_By>;
  min?: InputMaybe<Product_Option_Min_Order_By>;
  stddev?: InputMaybe<Product_Option_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Option_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Option_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Option_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Option_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Option_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Option_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "product_option" */
export type Product_Option_Arr_Rel_Insert_Input = {
  data: Array<Product_Option_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Option_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Option_Avg_Fields = {
  __typename?: 'product_option_avg_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_option" */
export type Product_Option_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_option". All fields are combined with a logical 'AND'. */
export type Product_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Option_Bool_Exp>>;
  _not?: InputMaybe<Product_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Option_Bool_Exp>>;
  allow_multiple?: InputMaybe<Boolean_Comparison_Exp>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  base_product_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  from_choice?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  platform_requirement?: InputMaybe<Platform_Requirement_Bool_Exp>;
  platform_requirement_id?: InputMaybe<String_Comparison_Exp>;
  product_option?: InputMaybe<Product_Option_Bool_Exp>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  product_option_choices?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  product_option_choices_aggregate?: InputMaybe<Product_Option_Choice_Aggregate_Bool_Exp>;
  product_options?: InputMaybe<Product_Option_Bool_Exp>;
  product_options_aggregate?: InputMaybe<Product_Option_Aggregate_Bool_Exp>;
  root_option?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "product_option_choice" */
export type Product_Option_Choice = {
  __typename?: 'product_option_choice';
  bom_name?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['String'];
  is_default?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  items: Array<Item_Bom>;
  /** An aggregate relationship */
  items_aggregate: Item_Bom_Aggregate;
  metadata?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  /** An array relationship */
  parent_options: Array<Product_Option>;
  /** An aggregate relationship */
  parent_options_aggregate: Product_Option_Aggregate;
  /** An object relationship */
  product_option: Product_Option;
  product_option_id: Scalars['String'];
  sort_order?: Maybe<Scalars['Int']>;
  /** An array relationship */
  units: Array<Unit_Product_Option_Choice>;
  /** An aggregate relationship */
  units_aggregate: Unit_Product_Option_Choice_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceItemsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceMetadataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceParent_OptionsArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceParent_Options_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


/** columns and relationships of "product_option_choice" */
export type Product_Option_ChoiceUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};

/** aggregated selection of "product_option_choice" */
export type Product_Option_Choice_Aggregate = {
  __typename?: 'product_option_choice_aggregate';
  aggregate?: Maybe<Product_Option_Choice_Aggregate_Fields>;
  nodes: Array<Product_Option_Choice>;
};

export type Product_Option_Choice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_Option_Choice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_Option_Choice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_Option_Choice_Aggregate_Bool_Exp_Count>;
};

export type Product_Option_Choice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_Option_Choice_Select_Column_Product_Option_Choice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Option_Choice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_Option_Choice_Select_Column_Product_Option_Choice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_Option_Choice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_option_choice" */
export type Product_Option_Choice_Aggregate_Fields = {
  __typename?: 'product_option_choice_aggregate_fields';
  avg?: Maybe<Product_Option_Choice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Option_Choice_Max_Fields>;
  min?: Maybe<Product_Option_Choice_Min_Fields>;
  stddev?: Maybe<Product_Option_Choice_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Option_Choice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Option_Choice_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Option_Choice_Sum_Fields>;
  var_pop?: Maybe<Product_Option_Choice_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Option_Choice_Var_Samp_Fields>;
  variance?: Maybe<Product_Option_Choice_Variance_Fields>;
};


/** aggregate fields of "product_option_choice" */
export type Product_Option_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "product_option_choice" */
export type Product_Option_Choice_Aggregate_Order_By = {
  avg?: InputMaybe<Product_Option_Choice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Option_Choice_Max_Order_By>;
  min?: InputMaybe<Product_Option_Choice_Min_Order_By>;
  stddev?: InputMaybe<Product_Option_Choice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_Option_Choice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_Option_Choice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_Option_Choice_Sum_Order_By>;
  var_pop?: InputMaybe<Product_Option_Choice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_Option_Choice_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_Option_Choice_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Product_Option_Choice_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "product_option_choice" */
export type Product_Option_Choice_Arr_Rel_Insert_Input = {
  data: Array<Product_Option_Choice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Option_Choice_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_Option_Choice_Avg_Fields = {
  __typename?: 'product_option_choice_avg_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "product_option_choice" */
export type Product_Option_Choice_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_option_choice". All fields are combined with a logical 'AND'. */
export type Product_Option_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Option_Choice_Bool_Exp>>;
  _not?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Option_Choice_Bool_Exp>>;
  bom_name?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  items?: InputMaybe<Item_Bom_Bool_Exp>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parent_options?: InputMaybe<Product_Option_Bool_Exp>;
  parent_options_aggregate?: InputMaybe<Product_Option_Aggregate_Bool_Exp>;
  product_option?: InputMaybe<Product_Option_Bool_Exp>;
  product_option_id?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  units?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
  units_aggregate?: InputMaybe<Unit_Product_Option_Choice_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_option_choice" */
export type Product_Option_Choice_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_option_choice_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Product_Option_Choice_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Product_Option_Choice_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Product_Option_Choice_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "product_option_choice" */
export type Product_Option_Choice_Inc_Input = {
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_option_choice" */
export type Product_Option_Choice_Insert_Input = {
  bom_name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  parent_options?: InputMaybe<Product_Option_Arr_Rel_Insert_Input>;
  product_option?: InputMaybe<Product_Option_Obj_Rel_Insert_Input>;
  product_option_id?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Unit_Product_Option_Choice_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Product_Option_Choice_Max_Fields = {
  __typename?: 'product_option_choice_max_fields';
  bom_name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_option_id?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_option_choice" */
export type Product_Option_Choice_Max_Order_By = {
  bom_name?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_option_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Option_Choice_Min_Fields = {
  __typename?: 'product_option_choice_min_fields';
  bom_name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_option_id?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_option_choice" */
export type Product_Option_Choice_Min_Order_By = {
  bom_name?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_option_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_option_choice" */
export type Product_Option_Choice_Mutation_Response = {
  __typename?: 'product_option_choice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Option_Choice>;
};

/** input type for inserting object relation for remote table "product_option_choice" */
export type Product_Option_Choice_Obj_Rel_Insert_Input = {
  data: Product_Option_Choice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Option_Choice_On_Conflict>;
};

/** on_conflict condition type for table "product_option_choice" */
export type Product_Option_Choice_On_Conflict = {
  constraint: Product_Option_Choice_Constraint;
  update_columns?: Array<Product_Option_Choice_Update_Column>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};

/** Ordering options when selecting data from "product_option_choice". */
export type Product_Option_Choice_Order_By = {
  bom_name?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parent_options_aggregate?: InputMaybe<Product_Option_Aggregate_Order_By>;
  product_option?: InputMaybe<Product_Option_Order_By>;
  product_option_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Product_Option_Choice_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_option_choice */
export type Product_Option_Choice_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Product_Option_Choice_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "product_option_choice" */
export type Product_Option_Choice_Select_Column =
  /** column name */
  | 'bom_name'
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'is_default'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'product_option_id'
  /** column name */
  | 'sort_order'
  /** column name */
  | 'updated_at';

/** select "product_option_choice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_option_choice" */
export type Product_Option_Choice_Select_Column_Product_Option_Choice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_default';

/** select "product_option_choice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_option_choice" */
export type Product_Option_Choice_Select_Column_Product_Option_Choice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_default';

/** input type for updating data in table "product_option_choice" */
export type Product_Option_Choice_Set_Input = {
  bom_name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  product_option_id?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Product_Option_Choice_Stddev_Fields = {
  __typename?: 'product_option_choice_stddev_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_option_choice" */
export type Product_Option_Choice_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Option_Choice_Stddev_Pop_Fields = {
  __typename?: 'product_option_choice_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_option_choice" */
export type Product_Option_Choice_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Option_Choice_Stddev_Samp_Fields = {
  __typename?: 'product_option_choice_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_option_choice" */
export type Product_Option_Choice_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_option_choice" */
export type Product_Option_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Option_Choice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Option_Choice_Stream_Cursor_Value_Input = {
  bom_name?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  is_default?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  product_option_id?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Product_Option_Choice_Sum_Fields = {
  __typename?: 'product_option_choice_sum_fields';
  sort_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_option_choice" */
export type Product_Option_Choice_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "product_option_choice" */
export type Product_Option_Choice_Update_Column =
  /** column name */
  | 'bom_name'
  /** column name */
  | 'code'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'is_default'
  /** column name */
  | 'metadata'
  /** column name */
  | 'name'
  /** column name */
  | 'product_option_id'
  /** column name */
  | 'sort_order'
  /** column name */
  | 'updated_at';

export type Product_Option_Choice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Product_Option_Choice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Product_Option_Choice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Product_Option_Choice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Product_Option_Choice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Option_Choice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Product_Option_Choice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Option_Choice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Option_Choice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Option_Choice_Var_Pop_Fields = {
  __typename?: 'product_option_choice_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_option_choice" */
export type Product_Option_Choice_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Option_Choice_Var_Samp_Fields = {
  __typename?: 'product_option_choice_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_option_choice" */
export type Product_Option_Choice_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Option_Choice_Variance_Fields = {
  __typename?: 'product_option_choice_variance_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_option_choice" */
export type Product_Option_Choice_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "product_option" */
export type Product_Option_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'product_option_pkey';

/** input type for incrementing numeric columns in table "product_option" */
export type Product_Option_Inc_Input = {
  sort_order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "product_option" */
export type Product_Option_Insert_Input = {
  allow_multiple?: InputMaybe<Scalars['Boolean']>;
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  from_choice?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform_requirement?: InputMaybe<Platform_Requirement_Obj_Rel_Insert_Input>;
  platform_requirement_id?: InputMaybe<Scalars['String']>;
  product_option?: InputMaybe<Product_Option_Obj_Rel_Insert_Input>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Obj_Rel_Insert_Input>;
  product_option_choices?: InputMaybe<Product_Option_Choice_Arr_Rel_Insert_Input>;
  product_options?: InputMaybe<Product_Option_Arr_Rel_Insert_Input>;
  root_option?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Product_Option_Max_Fields = {
  __typename?: 'product_option_max_fields';
  base_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from_choice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform_requirement_id?: Maybe<Scalars['String']>;
  root_option?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "product_option" */
export type Product_Option_Max_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from_choice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_requirement_id?: InputMaybe<Order_By>;
  root_option?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Option_Min_Fields = {
  __typename?: 'product_option_min_fields';
  base_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  from_choice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  platform_requirement_id?: Maybe<Scalars['String']>;
  root_option?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "product_option" */
export type Product_Option_Min_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from_choice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_requirement_id?: InputMaybe<Order_By>;
  root_option?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_option" */
export type Product_Option_Mutation_Response = {
  __typename?: 'product_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Option>;
};

/** input type for inserting object relation for remote table "product_option" */
export type Product_Option_Obj_Rel_Insert_Input = {
  data: Product_Option_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Option_On_Conflict>;
};

/** on_conflict condition type for table "product_option" */
export type Product_Option_On_Conflict = {
  constraint: Product_Option_Constraint;
  update_columns?: Array<Product_Option_Update_Column>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "product_option". */
export type Product_Option_Order_By = {
  allow_multiple?: InputMaybe<Order_By>;
  base_product?: InputMaybe<Base_Product_Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  from_choice?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  platform_requirement?: InputMaybe<Platform_Requirement_Order_By>;
  platform_requirement_id?: InputMaybe<Order_By>;
  product_option?: InputMaybe<Product_Option_Order_By>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Order_By>;
  product_option_choices_aggregate?: InputMaybe<Product_Option_Choice_Aggregate_Order_By>;
  product_options_aggregate?: InputMaybe<Product_Option_Aggregate_Order_By>;
  root_option?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_option */
export type Product_Option_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "product_option" */
export type Product_Option_Select_Column =
  /** column name */
  | 'allow_multiple'
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'from_choice'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'platform_requirement_id'
  /** column name */
  | 'root_option'
  /** column name */
  | 'sort_order'
  /** column name */
  | 'updated_at';

/** select "product_option_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_option" */
export type Product_Option_Select_Column_Product_Option_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'allow_multiple';

/** select "product_option_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_option" */
export type Product_Option_Select_Column_Product_Option_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'allow_multiple';

/** input type for updating data in table "product_option" */
export type Product_Option_Set_Input = {
  allow_multiple?: InputMaybe<Scalars['Boolean']>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  from_choice?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform_requirement_id?: InputMaybe<Scalars['String']>;
  root_option?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Product_Option_Stddev_Fields = {
  __typename?: 'product_option_stddev_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "product_option" */
export type Product_Option_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_Option_Stddev_Pop_Fields = {
  __typename?: 'product_option_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "product_option" */
export type Product_Option_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_Option_Stddev_Samp_Fields = {
  __typename?: 'product_option_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "product_option" */
export type Product_Option_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_option" */
export type Product_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Option_Stream_Cursor_Value_Input = {
  allow_multiple?: InputMaybe<Scalars['Boolean']>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  from_choice?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  platform_requirement_id?: InputMaybe<Scalars['String']>;
  root_option?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Product_Option_Sum_Fields = {
  __typename?: 'product_option_sum_fields';
  sort_order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "product_option" */
export type Product_Option_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "product_option" */
export type Product_Option_Update_Column =
  /** column name */
  | 'allow_multiple'
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'from_choice'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'platform_requirement_id'
  /** column name */
  | 'root_option'
  /** column name */
  | 'sort_order'
  /** column name */
  | 'updated_at';

export type Product_Option_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_Option_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Option_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Option_Var_Pop_Fields = {
  __typename?: 'product_option_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "product_option" */
export type Product_Option_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_Option_Var_Samp_Fields = {
  __typename?: 'product_option_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "product_option" */
export type Product_Option_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_Option_Variance_Fields = {
  __typename?: 'product_option_variance_fields';
  sort_order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "product_option" */
export type Product_Option_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  baseProductId?: InputMaybe<Order_By>;
  base_product?: InputMaybe<Base_Product_Order_By>;
  bom_details_aggregate?: InputMaybe<Bom_Detail_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "product" */
export type Product_Select_Column =
  /** column name */
  | 'baseProductId'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'sku'
  /** column name */
  | 'status';

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  baseProductId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "product_type" */
export type Product_Type = {
  __typename?: 'product_type';
  description?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "product_type" */
export type Product_Type_Aggregate = {
  __typename?: 'product_type_aggregate';
  aggregate?: Maybe<Product_Type_Aggregate_Fields>;
  nodes: Array<Product_Type>;
};

/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_Fields = {
  __typename?: 'product_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Product_Type_Max_Fields>;
  min?: Maybe<Product_Type_Min_Fields>;
};


/** aggregate fields of "product_type" */
export type Product_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "product_type". All fields are combined with a logical 'AND'. */
export type Product_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  _not?: InputMaybe<Product_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_type" */
export type Product_Type_Constraint =
  /** unique or primary key constraint on columns "value" */
  | 'product_type_pkey';

/** input type for inserting data into table "product_type" */
export type Product_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Product_Type_Max_Fields = {
  __typename?: 'product_type_max_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Product_Type_Min_Fields = {
  __typename?: 'product_type_min_fields';
  description?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "product_type" */
export type Product_Type_Mutation_Response = {
  __typename?: 'product_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Type>;
};

/** on_conflict condition type for table "product_type" */
export type Product_Type_On_Conflict = {
  constraint: Product_Type_Constraint;
  update_columns?: Array<Product_Type_Update_Column>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "product_type". */
export type Product_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_type */
export type Product_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "product_type" */
export type Product_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

/** input type for updating data in table "product_type" */
export type Product_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "product_type" */
export type Product_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "product_type" */
export type Product_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'value';

export type Product_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Type_Bool_Exp;
};

/** update columns of table "product" */
export type Product_Update_Column =
  /** column name */
  | 'baseProductId'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'sku'
  /** column name */
  | 'status';

export type Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** columns and relationships of "program" */
export type Program = {
  __typename?: 'program';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  designed_for?: Maybe<Scalars['String']>;
  /** An object relationship */
  designed_for_customer?: Maybe<Customer>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  products: Array<Base_Product>;
  /** An aggregate relationship */
  products_aggregate: Base_Product_Aggregate;
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['String'];
};


/** columns and relationships of "program" */
export type ProgramProductsArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "program" */
export type ProgramProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


/** columns and relationships of "program" */
export type ProgramProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "program" */
export type ProgramProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

export type ProgramNode = {
  __typename?: 'programNode';
  customer?: Maybe<Array<Maybe<CustomerNode>>>;
  customerAggregate?: Maybe<ProgramNodecustomerNodeCustomerAggregationSelection>;
  customerConnection: ProgramNodeCustomerConnection;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Maybe<ProductNode>>>;
  productsAggregate?: Maybe<ProgramNodeproductNodeProductsAggregationSelection>;
  productsConnection: ProgramNodeProductsConnection;
  projects?: Maybe<Array<Maybe<ProjectNode>>>;
  projectsAggregate?: Maybe<ProgramNodeprojectNodeProjectsAggregationSelection>;
  projectsConnection: ProgramNodeProjectsConnection;
  wevrId?: Maybe<Scalars['String']>;
};


export type ProgramNodeCustomerArgs = {
  options?: InputMaybe<CustomerNodeOptions>;
  where?: InputMaybe<CustomerNodeWhere>;
};


export type ProgramNodeCustomerAggregateArgs = {
  where?: InputMaybe<CustomerNodeWhere>;
};


export type ProgramNodeCustomerConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProgramNodeCustomerConnectionSort>>;
  where?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
};


export type ProgramNodeProductsArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type ProgramNodeProductsAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type ProgramNodeProductsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProgramNodeProductsConnectionSort>>;
  where?: InputMaybe<ProgramNodeProductsConnectionWhere>;
};


export type ProgramNodeProjectsArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type ProgramNodeProjectsAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type ProgramNodeProjectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProgramNodeProjectsConnectionSort>>;
  where?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
};

export type ProgramNodeAggregateSelection = {
  __typename?: 'programNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProgramNodeConnectInput = {
  customer?: InputMaybe<Array<ProgramNodeCustomerConnectFieldInput>>;
  products?: InputMaybe<Array<ProgramNodeProductsConnectFieldInput>>;
  projects?: InputMaybe<Array<ProgramNodeProjectsConnectFieldInput>>;
};

export type ProgramNodeConnectWhere = {
  node: ProgramNodeWhere;
};

export type ProgramNodeCreateInput = {
  customer?: InputMaybe<ProgramNodeCustomerFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProgramNodeProductsFieldInput>;
  projects?: InputMaybe<ProgramNodeProjectsFieldInput>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProgramNodeCustomerAggregateInput = {
  AND?: InputMaybe<Array<ProgramNodeCustomerAggregateInput>>;
  OR?: InputMaybe<Array<ProgramNodeCustomerAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProgramNodeCustomerNodeAggregationWhereInput>;
};

export type ProgramNodeCustomerConnectFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeConnectInput>>;
  where?: InputMaybe<CustomerNodeConnectWhere>;
};

export type ProgramNodeCustomerConnection = {
  __typename?: 'programNodeCustomerConnection';
  edges: Array<ProgramNodeCustomerRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProgramNodeCustomerConnectionSort = {
  node?: InputMaybe<CustomerNodeSort>;
};

export type ProgramNodeCustomerConnectionWhere = {
  AND?: InputMaybe<Array<ProgramNodeCustomerConnectionWhere>>;
  OR?: InputMaybe<Array<ProgramNodeCustomerConnectionWhere>>;
  node?: InputMaybe<CustomerNodeWhere>;
  node_NOT?: InputMaybe<CustomerNodeWhere>;
};

export type ProgramNodeCustomerCreateFieldInput = {
  node: CustomerNodeCreateInput;
};

export type ProgramNodeCustomerDeleteFieldInput = {
  delete?: InputMaybe<CustomerNodeDeleteInput>;
  where?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
};

export type ProgramNodeCustomerDisconnectFieldInput = {
  disconnect?: InputMaybe<CustomerNodeDisconnectInput>;
  where?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
};

export type ProgramNodeCustomerFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeCustomerConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeCustomerCreateFieldInput>>;
};

export type ProgramNodeCustomerNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProgramNodeCustomerNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProgramNodeCustomerNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProgramNodeCustomerRelationship = {
  __typename?: 'programNodeCustomerRelationship';
  cursor: Scalars['String'];
  node: CustomerNode;
};

export type ProgramNodeCustomerUpdateConnectionInput = {
  node?: InputMaybe<CustomerNodeUpdateInput>;
};

export type ProgramNodeCustomerUpdateFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeCustomerConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeCustomerCreateFieldInput>>;
  delete?: InputMaybe<Array<ProgramNodeCustomerDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProgramNodeCustomerDisconnectFieldInput>>;
  update?: InputMaybe<ProgramNodeCustomerUpdateConnectionInput>;
  where?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
};

export type ProgramNodeDeleteInput = {
  customer?: InputMaybe<Array<ProgramNodeCustomerDeleteFieldInput>>;
  products?: InputMaybe<Array<ProgramNodeProductsDeleteFieldInput>>;
  projects?: InputMaybe<Array<ProgramNodeProjectsDeleteFieldInput>>;
};

export type ProgramNodeDisconnectInput = {
  customer?: InputMaybe<Array<ProgramNodeCustomerDisconnectFieldInput>>;
  products?: InputMaybe<Array<ProgramNodeProductsDisconnectFieldInput>>;
  projects?: InputMaybe<Array<ProgramNodeProjectsDisconnectFieldInput>>;
};

export type ProgramNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more programNodeSort objects to sort programNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ProgramNodeSort>>>;
};

export type ProgramNodeProductsAggregateInput = {
  AND?: InputMaybe<Array<ProgramNodeProductsAggregateInput>>;
  OR?: InputMaybe<Array<ProgramNodeProductsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProgramNodeProductsNodeAggregationWhereInput>;
};

export type ProgramNodeProductsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConnectInput>>;
  where?: InputMaybe<ProductNodeConnectWhere>;
};

export type ProgramNodeProductsConnection = {
  __typename?: 'programNodeProductsConnection';
  edges: Array<ProgramNodeProductsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProgramNodeProductsConnectionSort = {
  node?: InputMaybe<ProductNodeSort>;
};

export type ProgramNodeProductsConnectionWhere = {
  AND?: InputMaybe<Array<ProgramNodeProductsConnectionWhere>>;
  OR?: InputMaybe<Array<ProgramNodeProductsConnectionWhere>>;
  node?: InputMaybe<ProductNodeWhere>;
  node_NOT?: InputMaybe<ProductNodeWhere>;
};

export type ProgramNodeProductsCreateFieldInput = {
  node: ProductNodeCreateInput;
};

export type ProgramNodeProductsDeleteFieldInput = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<ProgramNodeProductsConnectionWhere>;
};

export type ProgramNodeProductsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  where?: InputMaybe<ProgramNodeProductsConnectionWhere>;
};

export type ProgramNodeProductsFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeProductsCreateFieldInput>>;
};

export type ProgramNodeProductsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProgramNodeProductsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProgramNodeProductsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sku_EQUAL?: InputMaybe<Scalars['String']>;
  sku_GT?: InputMaybe<Scalars['Int']>;
  sku_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_LT?: InputMaybe<Scalars['Int']>;
  sku_LTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProgramNodeProductsRelationship = {
  __typename?: 'programNodeProductsRelationship';
  cursor: Scalars['String'];
  node: ProductNode;
};

export type ProgramNodeProductsUpdateConnectionInput = {
  node?: InputMaybe<ProductNodeUpdateInput>;
};

export type ProgramNodeProductsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeProductsConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeProductsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProgramNodeProductsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProgramNodeProductsDisconnectFieldInput>>;
  update?: InputMaybe<ProgramNodeProductsUpdateConnectionInput>;
  where?: InputMaybe<ProgramNodeProductsConnectionWhere>;
};

export type ProgramNodeProjectsAggregateInput = {
  AND?: InputMaybe<Array<ProgramNodeProjectsAggregateInput>>;
  OR?: InputMaybe<Array<ProgramNodeProjectsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProgramNodeProjectsNodeAggregationWhereInput>;
};

export type ProgramNodeProjectsConnectFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeConnectInput>>;
  where?: InputMaybe<ProjectNodeConnectWhere>;
};

export type ProgramNodeProjectsConnection = {
  __typename?: 'programNodeProjectsConnection';
  edges: Array<ProgramNodeProjectsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProgramNodeProjectsConnectionSort = {
  node?: InputMaybe<ProjectNodeSort>;
};

export type ProgramNodeProjectsConnectionWhere = {
  AND?: InputMaybe<Array<ProgramNodeProjectsConnectionWhere>>;
  OR?: InputMaybe<Array<ProgramNodeProjectsConnectionWhere>>;
  node?: InputMaybe<ProjectNodeWhere>;
  node_NOT?: InputMaybe<ProjectNodeWhere>;
};

export type ProgramNodeProjectsCreateFieldInput = {
  node: ProjectNodeCreateInput;
};

export type ProgramNodeProjectsDeleteFieldInput = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
};

export type ProgramNodeProjectsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  where?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
};

export type ProgramNodeProjectsFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeProjectsCreateFieldInput>>;
};

export type ProgramNodeProjectsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProgramNodeProjectsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProgramNodeProjectsNodeAggregationWhereInput>>;
  bloxProjectNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_EQUAL?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProgramNodeProjectsRelationship = {
  __typename?: 'programNodeProjectsRelationship';
  cursor: Scalars['String'];
  node: ProjectNode;
};

export type ProgramNodeProjectsUpdateConnectionInput = {
  node?: InputMaybe<ProjectNodeUpdateInput>;
};

export type ProgramNodeProjectsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeProjectsConnectFieldInput>>;
  create?: InputMaybe<Array<ProgramNodeProjectsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProgramNodeProjectsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProgramNodeProjectsDisconnectFieldInput>>;
  update?: InputMaybe<ProgramNodeProjectsUpdateConnectionInput>;
  where?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
};

export type ProgramNodeRelationInput = {
  customer?: InputMaybe<Array<ProgramNodeCustomerCreateFieldInput>>;
  products?: InputMaybe<Array<ProgramNodeProductsCreateFieldInput>>;
  projects?: InputMaybe<Array<ProgramNodeProjectsCreateFieldInput>>;
};

/** Fields to sort programNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one programNodeSort object. */
export type ProgramNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ProgramNodeUpdateInput = {
  customer?: InputMaybe<Array<ProgramNodeCustomerUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<ProgramNodeProductsUpdateFieldInput>>;
  projects?: InputMaybe<Array<ProgramNodeProjectsUpdateFieldInput>>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProgramNodeWhere = {
  AND?: InputMaybe<Array<ProgramNodeWhere>>;
  OR?: InputMaybe<Array<ProgramNodeWhere>>;
  customer?: InputMaybe<CustomerNodeWhere>;
  customerAggregate?: InputMaybe<ProgramNodeCustomerAggregateInput>;
  customerConnection?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
  customerConnection_NOT?: InputMaybe<ProgramNodeCustomerConnectionWhere>;
  customer_NOT?: InputMaybe<CustomerNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductNodeWhere>;
  productsAggregate?: InputMaybe<ProgramNodeProductsAggregateInput>;
  productsConnection?: InputMaybe<ProgramNodeProductsConnectionWhere>;
  productsConnection_NOT?: InputMaybe<ProgramNodeProductsConnectionWhere>;
  products_NOT?: InputMaybe<ProductNodeWhere>;
  projects?: InputMaybe<ProjectNodeWhere>;
  projectsAggregate?: InputMaybe<ProgramNodeProjectsAggregateInput>;
  projectsConnection?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
  projectsConnection_NOT?: InputMaybe<ProgramNodeProjectsConnectionWhere>;
  projects_NOT?: InputMaybe<ProjectNodeWhere>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ProgramNodecustomerNodeCustomerAggregationSelection = {
  __typename?: 'programNodecustomerNodeCustomerAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProgramNodecustomerNodeCustomerNodeAggregateSelection>;
};

export type ProgramNodecustomerNodeCustomerNodeAggregateSelection = {
  __typename?: 'programNodecustomerNodeCustomerNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProgramNodeproductNodeProductsAggregationSelection = {
  __typename?: 'programNodeproductNodeProductsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProgramNodeproductNodeProductsNodeAggregateSelection>;
};

export type ProgramNodeproductNodeProductsNodeAggregateSelection = {
  __typename?: 'programNodeproductNodeProductsNodeAggregateSelection';
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProgramNodeprojectNodeProjectsAggregationSelection = {
  __typename?: 'programNodeprojectNodeProjectsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProgramNodeprojectNodeProjectsNodeAggregateSelection>;
};

export type ProgramNodeprojectNodeProjectsNodeAggregateSelection = {
  __typename?: 'programNodeprojectNodeProjectsNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "program" */
export type Program_Aggregate = {
  __typename?: 'program_aggregate';
  aggregate?: Maybe<Program_Aggregate_Fields>;
  nodes: Array<Program>;
};

export type Program_Aggregate_Bool_Exp = {
  count?: InputMaybe<Program_Aggregate_Bool_Exp_Count>;
};

export type Program_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Program_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Program_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "program" */
export type Program_Aggregate_Fields = {
  __typename?: 'program_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Program_Max_Fields>;
  min?: Maybe<Program_Min_Fields>;
};


/** aggregate fields of "program" */
export type Program_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Program_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "program" */
export type Program_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Program_Max_Order_By>;
  min?: InputMaybe<Program_Min_Order_By>;
};

/** input type for inserting array relation for remote table "program" */
export type Program_Arr_Rel_Insert_Input = {
  data: Array<Program_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Program_On_Conflict>;
};

/** Boolean expression to filter rows from the table "program". All fields are combined with a logical 'AND'. */
export type Program_Bool_Exp = {
  _and?: InputMaybe<Array<Program_Bool_Exp>>;
  _not?: InputMaybe<Program_Bool_Exp>;
  _or?: InputMaybe<Array<Program_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  designed_for?: InputMaybe<String_Comparison_Exp>;
  designed_for_customer?: InputMaybe<Customer_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Base_Product_Bool_Exp>;
  products_aggregate?: InputMaybe<Base_Product_Aggregate_Bool_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "program" */
export type Program_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'program_pkey';

/** input type for inserting data into table "program" */
export type Program_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  designed_for_customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Base_Product_Arr_Rel_Insert_Input>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Program_Max_Fields = {
  __typename?: 'program_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designed_for?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "program" */
export type Program_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Program_Min_Fields = {
  __typename?: 'program_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  designed_for?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "program" */
export type Program_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "program" */
export type Program_Mutation_Response = {
  __typename?: 'program_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Program>;
};

/** input type for inserting object relation for remote table "program" */
export type Program_Obj_Rel_Insert_Input = {
  data: Program_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Program_On_Conflict>;
};

/** on_conflict condition type for table "program" */
export type Program_On_Conflict = {
  constraint: Program_Constraint;
  update_columns?: Array<Program_Update_Column>;
  where?: InputMaybe<Program_Bool_Exp>;
};

/** Ordering options when selecting data from "program". */
export type Program_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designed_for?: InputMaybe<Order_By>;
  designed_for_customer?: InputMaybe<Customer_Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Base_Product_Aggregate_Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: program */
export type Program_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "program" */
export type Program_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'designed_for'
  /** column name */
  | 'id'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for updating data in table "program" */
export type Program_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "program" */
export type Program_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Program_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Program_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  designed_for?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** update columns of table "program" */
export type Program_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'designed_for'
  /** column name */
  | 'id'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Program_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Program_Set_Input>;
  /** filter the rows which have to be updated */
  where: Program_Bool_Exp;
};

/** columns and relationships of "project" */
export type Project = {
  __typename?: 'project';
  /** An array relationship */
  base_product_quantities: Array<Project_Base_Product_Quantities>;
  /** An aggregate relationship */
  base_product_quantities_aggregate: Project_Base_Product_Quantities_Aggregate;
  bloxApproved?: Maybe<Scalars['Boolean']>;
  bloxProjectNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  /** An array relationship */
  contacts: Array<Project_Contacts>;
  /** An aggregate relationship */
  contacts_aggregate: Project_Contacts_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer: Customer;
  customerId: Scalars['String'];
  id: Scalars['String'];
  /** An array relationship */
  items: Array<Item_Bom>;
  /** An aggregate relationship */
  items_aggregate: Item_Bom_Aggregate;
  /** An array relationship */
  milestones: Array<Project_Milestone>;
  /** An aggregate relationship */
  milestones_aggregate: Project_Milestone_Aggregate;
  /** An array relationship */
  modules: Array<Project_Module>;
  /** An aggregate relationship */
  modules_aggregate: Project_Module_Aggregate;
  name: Scalars['String'];
  options?: Maybe<Scalars['jsonb']>;
  postalCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  program?: Maybe<Program>;
  programId?: Maybe<Scalars['String']>;
  /** An array relationship */
  project_comments: Array<Project_Comment>;
  /** An aggregate relationship */
  project_comments_aggregate: Project_Comment_Aggregate;
  state?: Maybe<Scalars['String']>;
  /** An object relationship */
  status: Project_Status;
  statusId: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  /** An array relationship */
  units: Array<Unit>;
  /** An aggregate relationship */
  units_aggregate: Unit_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<Project_Users>;
  /** An aggregate relationship */
  users_aggregate: Project_Users_Aggregate;
  year?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "project" */
export type ProjectBase_Product_QuantitiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectBase_Product_Quantities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContactsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectItemsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectMilestonesArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectMilestones_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectModulesArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "project" */
export type ProjectProject_CommentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectProject_Comments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUnitsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUnits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


/** columns and relationships of "project" */
export type ProjectUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};

export type ProjectNode = {
  __typename?: 'projectNode';
  bloxProjectNumber?: Maybe<Scalars['String']>;
  customers?: Maybe<Array<Maybe<CustomerNode>>>;
  customersAggregate?: Maybe<ProjectNodecustomerNodeCustomersAggregationSelection>;
  customersConnection: ProjectNodeCustomersConnection;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<ProjectNodeitemNodeItemsAggregationSelection>;
  itemsConnection: ProjectNodeItemsConnection;
  name?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Maybe<OrderNode>>>;
  ordersAggregate?: Maybe<ProjectNodeorderNodeOrdersAggregationSelection>;
  ordersConnection: ProjectNodeOrdersConnection;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  programsAggregate?: Maybe<ProjectNodeprogramNodeProgramsAggregationSelection>;
  programsConnection: ProjectNodeProgramsConnection;
  units?: Maybe<Array<Maybe<UnitNode>>>;
  unitsAggregate?: Maybe<ProjectNodeunitNodeUnitsAggregationSelection>;
  unitsConnection: ProjectNodeUnitsConnection;
  wevrId?: Maybe<Scalars['String']>;
};


export type ProjectNodeCustomersArgs = {
  options?: InputMaybe<CustomerNodeOptions>;
  where?: InputMaybe<CustomerNodeWhere>;
};


export type ProjectNodeCustomersAggregateArgs = {
  where?: InputMaybe<CustomerNodeWhere>;
};


export type ProjectNodeCustomersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProjectNodeCustomersConnectionSort>>;
  where?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
};


export type ProjectNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProjectNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type ProjectNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProjectNodeItemsConnectionSort>>;
  where?: InputMaybe<ProjectNodeItemsConnectionWhere>;
};


export type ProjectNodeOrdersArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type ProjectNodeOrdersAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type ProjectNodeOrdersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProjectNodeOrdersConnectionSort>>;
  where?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
};


export type ProjectNodeProgramsArgs = {
  options?: InputMaybe<ProgramNodeOptions>;
  where?: InputMaybe<ProgramNodeWhere>;
};


export type ProjectNodeProgramsAggregateArgs = {
  where?: InputMaybe<ProgramNodeWhere>;
};


export type ProjectNodeProgramsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProjectNodeProgramsConnectionSort>>;
  where?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
};


export type ProjectNodeUnitsArgs = {
  options?: InputMaybe<UnitNodeOptions>;
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProjectNodeUnitsAggregateArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type ProjectNodeUnitsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<ProjectNodeUnitsConnectionSort>>;
  where?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
};

export type ProjectNodeAggregateSelection = {
  __typename?: 'projectNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProjectNodeConnectInput = {
  customers?: InputMaybe<Array<ProjectNodeCustomersConnectFieldInput>>;
  items?: InputMaybe<Array<ProjectNodeItemsConnectFieldInput>>;
  orders?: InputMaybe<Array<ProjectNodeOrdersConnectFieldInput>>;
  programs?: InputMaybe<Array<ProjectNodeProgramsConnectFieldInput>>;
  units?: InputMaybe<Array<ProjectNodeUnitsConnectFieldInput>>;
};

export type ProjectNodeConnectWhere = {
  node: ProjectNodeWhere;
};

export type ProjectNodeCreateInput = {
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<ProjectNodeCustomersFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ProjectNodeItemsFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<ProjectNodeOrdersFieldInput>;
  programs?: InputMaybe<ProjectNodeProgramsFieldInput>;
  units?: InputMaybe<ProjectNodeUnitsFieldInput>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProjectNodeCustomersAggregateInput = {
  AND?: InputMaybe<Array<ProjectNodeCustomersAggregateInput>>;
  OR?: InputMaybe<Array<ProjectNodeCustomersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProjectNodeCustomersNodeAggregationWhereInput>;
};

export type ProjectNodeCustomersConnectFieldInput = {
  connect?: InputMaybe<Array<CustomerNodeConnectInput>>;
  where?: InputMaybe<CustomerNodeConnectWhere>;
};

export type ProjectNodeCustomersConnection = {
  __typename?: 'projectNodeCustomersConnection';
  edges: Array<ProjectNodeCustomersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectNodeCustomersConnectionSort = {
  node?: InputMaybe<CustomerNodeSort>;
};

export type ProjectNodeCustomersConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNodeCustomersConnectionWhere>>;
  OR?: InputMaybe<Array<ProjectNodeCustomersConnectionWhere>>;
  node?: InputMaybe<CustomerNodeWhere>;
  node_NOT?: InputMaybe<CustomerNodeWhere>;
};

export type ProjectNodeCustomersCreateFieldInput = {
  node: CustomerNodeCreateInput;
};

export type ProjectNodeCustomersDeleteFieldInput = {
  delete?: InputMaybe<CustomerNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
};

export type ProjectNodeCustomersDisconnectFieldInput = {
  disconnect?: InputMaybe<CustomerNodeDisconnectInput>;
  where?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
};

export type ProjectNodeCustomersFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeCustomersConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeCustomersCreateFieldInput>>;
};

export type ProjectNodeCustomersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeCustomersNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeCustomersNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProjectNodeCustomersRelationship = {
  __typename?: 'projectNodeCustomersRelationship';
  cursor: Scalars['String'];
  node: CustomerNode;
};

export type ProjectNodeCustomersUpdateConnectionInput = {
  node?: InputMaybe<CustomerNodeUpdateInput>;
};

export type ProjectNodeCustomersUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeCustomersConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeCustomersCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNodeCustomersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNodeCustomersDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNodeCustomersUpdateConnectionInput>;
  where?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
};

export type ProjectNodeDeleteInput = {
  customers?: InputMaybe<Array<ProjectNodeCustomersDeleteFieldInput>>;
  items?: InputMaybe<Array<ProjectNodeItemsDeleteFieldInput>>;
  orders?: InputMaybe<Array<ProjectNodeOrdersDeleteFieldInput>>;
  programs?: InputMaybe<Array<ProjectNodeProgramsDeleteFieldInput>>;
  units?: InputMaybe<Array<ProjectNodeUnitsDeleteFieldInput>>;
};

export type ProjectNodeDisconnectInput = {
  customers?: InputMaybe<Array<ProjectNodeCustomersDisconnectFieldInput>>;
  items?: InputMaybe<Array<ProjectNodeItemsDisconnectFieldInput>>;
  orders?: InputMaybe<Array<ProjectNodeOrdersDisconnectFieldInput>>;
  programs?: InputMaybe<Array<ProjectNodeProgramsDisconnectFieldInput>>;
  units?: InputMaybe<Array<ProjectNodeUnitsDisconnectFieldInput>>;
};

export type ProjectNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<ProjectNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<ProjectNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<ProjectNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<ProjectNodeItemsNodeAggregationWhereInput>;
};

export type ProjectNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type ProjectNodeItemsConnection = {
  __typename?: 'projectNodeItemsConnection';
  edges: Array<ProjectNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type ProjectNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<ProjectNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type ProjectNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type ProjectNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeItemsConnectionWhere>;
};

export type ProjectNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<ProjectNodeItemsConnectionWhere>;
};

export type ProjectNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type ProjectNodeItemsFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeItemsCreateFieldInput>>;
};

export type ProjectNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProjectNodeItemsRelationship = Quantity & {
  __typename?: 'projectNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type ProjectNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type ProjectNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<ProjectNodeItemsConnectionWhere>;
};

export type ProjectNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more projectNodeSort objects to sort projectNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<ProjectNodeSort>>>;
};

export type ProjectNodeOrdersAggregateInput = {
  AND?: InputMaybe<Array<ProjectNodeOrdersAggregateInput>>;
  OR?: InputMaybe<Array<ProjectNodeOrdersAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProjectNodeOrdersNodeAggregationWhereInput>;
};

export type ProjectNodeOrdersConnectFieldInput = {
  connect?: InputMaybe<Array<OrderNodeConnectInput>>;
  where?: InputMaybe<OrderNodeConnectWhere>;
};

export type ProjectNodeOrdersConnection = {
  __typename?: 'projectNodeOrdersConnection';
  edges: Array<ProjectNodeOrdersRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectNodeOrdersConnectionSort = {
  node?: InputMaybe<OrderNodeSort>;
};

export type ProjectNodeOrdersConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNodeOrdersConnectionWhere>>;
  OR?: InputMaybe<Array<ProjectNodeOrdersConnectionWhere>>;
  node?: InputMaybe<OrderNodeWhere>;
  node_NOT?: InputMaybe<OrderNodeWhere>;
};

export type ProjectNodeOrdersCreateFieldInput = {
  node: OrderNodeCreateInput;
};

export type ProjectNodeOrdersDeleteFieldInput = {
  delete?: InputMaybe<OrderNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
};

export type ProjectNodeOrdersDisconnectFieldInput = {
  disconnect?: InputMaybe<OrderNodeDisconnectInput>;
  where?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
};

export type ProjectNodeOrdersFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeOrdersConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeOrdersCreateFieldInput>>;
};

export type ProjectNodeOrdersNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeOrdersNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeOrdersNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProjectNodeOrdersRelationship = {
  __typename?: 'projectNodeOrdersRelationship';
  cursor: Scalars['String'];
  node: OrderNode;
};

export type ProjectNodeOrdersUpdateConnectionInput = {
  node?: InputMaybe<OrderNodeUpdateInput>;
};

export type ProjectNodeOrdersUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeOrdersConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeOrdersCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNodeOrdersDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNodeOrdersDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNodeOrdersUpdateConnectionInput>;
  where?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
};

export type ProjectNodeProgramsAggregateInput = {
  AND?: InputMaybe<Array<ProjectNodeProgramsAggregateInput>>;
  OR?: InputMaybe<Array<ProjectNodeProgramsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProjectNodeProgramsNodeAggregationWhereInput>;
};

export type ProjectNodeProgramsConnectFieldInput = {
  connect?: InputMaybe<Array<ProgramNodeConnectInput>>;
  where?: InputMaybe<ProgramNodeConnectWhere>;
};

export type ProjectNodeProgramsConnection = {
  __typename?: 'projectNodeProgramsConnection';
  edges: Array<ProjectNodeProgramsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectNodeProgramsConnectionSort = {
  node?: InputMaybe<ProgramNodeSort>;
};

export type ProjectNodeProgramsConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNodeProgramsConnectionWhere>>;
  OR?: InputMaybe<Array<ProjectNodeProgramsConnectionWhere>>;
  node?: InputMaybe<ProgramNodeWhere>;
  node_NOT?: InputMaybe<ProgramNodeWhere>;
};

export type ProjectNodeProgramsCreateFieldInput = {
  node: ProgramNodeCreateInput;
};

export type ProjectNodeProgramsDeleteFieldInput = {
  delete?: InputMaybe<ProgramNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
};

export type ProjectNodeProgramsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProgramNodeDisconnectInput>;
  where?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
};

export type ProjectNodeProgramsFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeProgramsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeProgramsCreateFieldInput>>;
};

export type ProjectNodeProgramsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeProgramsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeProgramsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProjectNodeProgramsRelationship = {
  __typename?: 'projectNodeProgramsRelationship';
  cursor: Scalars['String'];
  node: ProgramNode;
};

export type ProjectNodeProgramsUpdateConnectionInput = {
  node?: InputMaybe<ProgramNodeUpdateInput>;
};

export type ProjectNodeProgramsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeProgramsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeProgramsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNodeProgramsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNodeProgramsDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNodeProgramsUpdateConnectionInput>;
  where?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
};

export type ProjectNodeRelationInput = {
  customers?: InputMaybe<Array<ProjectNodeCustomersCreateFieldInput>>;
  items?: InputMaybe<Array<ProjectNodeItemsCreateFieldInput>>;
  orders?: InputMaybe<Array<ProjectNodeOrdersCreateFieldInput>>;
  programs?: InputMaybe<Array<ProjectNodeProgramsCreateFieldInput>>;
  units?: InputMaybe<Array<ProjectNodeUnitsCreateFieldInput>>;
};

/** Fields to sort projectNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one projectNodeSort object. */
export type ProjectNodeSort = {
  bloxProjectNumber?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type ProjectNodeUnitsAggregateInput = {
  AND?: InputMaybe<Array<ProjectNodeUnitsAggregateInput>>;
  OR?: InputMaybe<Array<ProjectNodeUnitsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<ProjectNodeUnitsNodeAggregationWhereInput>;
};

export type ProjectNodeUnitsConnectFieldInput = {
  connect?: InputMaybe<Array<UnitNodeConnectInput>>;
  where?: InputMaybe<UnitNodeConnectWhere>;
};

export type ProjectNodeUnitsConnection = {
  __typename?: 'projectNodeUnitsConnection';
  edges: Array<ProjectNodeUnitsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ProjectNodeUnitsConnectionSort = {
  node?: InputMaybe<UnitNodeSort>;
};

export type ProjectNodeUnitsConnectionWhere = {
  AND?: InputMaybe<Array<ProjectNodeUnitsConnectionWhere>>;
  OR?: InputMaybe<Array<ProjectNodeUnitsConnectionWhere>>;
  node?: InputMaybe<UnitNodeWhere>;
  node_NOT?: InputMaybe<UnitNodeWhere>;
};

export type ProjectNodeUnitsCreateFieldInput = {
  node: UnitNodeCreateInput;
};

export type ProjectNodeUnitsDeleteFieldInput = {
  delete?: InputMaybe<UnitNodeDeleteInput>;
  where?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
};

export type ProjectNodeUnitsDisconnectFieldInput = {
  disconnect?: InputMaybe<UnitNodeDisconnectInput>;
  where?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
};

export type ProjectNodeUnitsFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeUnitsCreateFieldInput>>;
};

export type ProjectNodeUnitsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<ProjectNodeUnitsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<ProjectNodeUnitsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type ProjectNodeUnitsRelationship = {
  __typename?: 'projectNodeUnitsRelationship';
  cursor: Scalars['String'];
  node: UnitNode;
};

export type ProjectNodeUnitsUpdateConnectionInput = {
  node?: InputMaybe<UnitNodeUpdateInput>;
};

export type ProjectNodeUnitsUpdateFieldInput = {
  connect?: InputMaybe<Array<ProjectNodeUnitsConnectFieldInput>>;
  create?: InputMaybe<Array<ProjectNodeUnitsCreateFieldInput>>;
  delete?: InputMaybe<Array<ProjectNodeUnitsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<ProjectNodeUnitsDisconnectFieldInput>>;
  update?: InputMaybe<ProjectNodeUnitsUpdateConnectionInput>;
  where?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
};

export type ProjectNodeUpdateInput = {
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<Array<ProjectNodeCustomersUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<ProjectNodeItemsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Array<ProjectNodeOrdersUpdateFieldInput>>;
  programs?: InputMaybe<Array<ProjectNodeProgramsUpdateFieldInput>>;
  units?: InputMaybe<Array<ProjectNodeUnitsUpdateFieldInput>>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type ProjectNodeWhere = {
  AND?: InputMaybe<Array<ProjectNodeWhere>>;
  OR?: InputMaybe<Array<ProjectNodeWhere>>;
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_CONTAINS?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_ENDS_WITH?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bloxProjectNumber_NOT?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bloxProjectNumber_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_STARTS_WITH?: InputMaybe<Scalars['String']>;
  customers?: InputMaybe<CustomerNodeWhere>;
  customersAggregate?: InputMaybe<ProjectNodeCustomersAggregateInput>;
  customersConnection?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
  customersConnection_NOT?: InputMaybe<ProjectNodeCustomersConnectionWhere>;
  customers_NOT?: InputMaybe<CustomerNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<ProjectNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<ProjectNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<ProjectNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<OrderNodeWhere>;
  ordersAggregate?: InputMaybe<ProjectNodeOrdersAggregateInput>;
  ordersConnection?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
  ordersConnection_NOT?: InputMaybe<ProjectNodeOrdersConnectionWhere>;
  orders_NOT?: InputMaybe<OrderNodeWhere>;
  programs?: InputMaybe<ProgramNodeWhere>;
  programsAggregate?: InputMaybe<ProjectNodeProgramsAggregateInput>;
  programsConnection?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
  programsConnection_NOT?: InputMaybe<ProjectNodeProgramsConnectionWhere>;
  programs_NOT?: InputMaybe<ProgramNodeWhere>;
  units?: InputMaybe<UnitNodeWhere>;
  unitsAggregate?: InputMaybe<ProjectNodeUnitsAggregateInput>;
  unitsConnection?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
  unitsConnection_NOT?: InputMaybe<ProjectNodeUnitsConnectionWhere>;
  units_NOT?: InputMaybe<UnitNodeWhere>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type ProjectNodecustomerNodeCustomersAggregationSelection = {
  __typename?: 'projectNodecustomerNodeCustomersAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProjectNodecustomerNodeCustomersNodeAggregateSelection>;
};

export type ProjectNodecustomerNodeCustomersNodeAggregateSelection = {
  __typename?: 'projectNodecustomerNodeCustomersNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProjectNodeitemNodeItemsAggregationSelection = {
  __typename?: 'projectNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<ProjectNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<ProjectNodeitemNodeItemsNodeAggregateSelection>;
};

export type ProjectNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'projectNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type ProjectNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'projectNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProjectNodeorderNodeOrdersAggregationSelection = {
  __typename?: 'projectNodeorderNodeOrdersAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProjectNodeorderNodeOrdersNodeAggregateSelection>;
};

export type ProjectNodeorderNodeOrdersNodeAggregateSelection = {
  __typename?: 'projectNodeorderNodeOrdersNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProjectNodeprogramNodeProgramsAggregationSelection = {
  __typename?: 'projectNodeprogramNodeProgramsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProjectNodeprogramNodeProgramsNodeAggregateSelection>;
};

export type ProjectNodeprogramNodeProgramsNodeAggregateSelection = {
  __typename?: 'projectNodeprogramNodeProgramsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type ProjectNodeunitNodeUnitsAggregationSelection = {
  __typename?: 'projectNodeunitNodeUnitsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<ProjectNodeunitNodeUnitsNodeAggregateSelection>;
};

export type ProjectNodeunitNodeUnitsNodeAggregateSelection = {
  __typename?: 'projectNodeunitNodeUnitsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "project" */
export type Project_Aggregate = {
  __typename?: 'project_aggregate';
  aggregate?: Maybe<Project_Aggregate_Fields>;
  nodes: Array<Project>;
};

export type Project_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Aggregate_Bool_Exp_Count>;
};

export type Project_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project" */
export type Project_Aggregate_Fields = {
  __typename?: 'project_aggregate_fields';
  avg?: Maybe<Project_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Max_Fields>;
  min?: Maybe<Project_Min_Fields>;
  stddev?: Maybe<Project_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Sum_Fields>;
  var_pop?: Maybe<Project_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Var_Samp_Fields>;
  variance?: Maybe<Project_Variance_Fields>;
};


/** aggregate fields of "project" */
export type Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project" */
export type Project_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Max_Order_By>;
  min?: InputMaybe<Project_Min_Order_By>;
  stddev?: InputMaybe<Project_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project" */
export type Project_Arr_Rel_Insert_Input = {
  data: Array<Project_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Avg_Fields = {
  __typename?: 'project_avg_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project" */
export type Project_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_base_product_quantities" */
export type Project_Base_Product_Quantities = {
  __typename?: 'project_base_product_quantities';
  /** An object relationship */
  base_product: Base_Product;
  base_product_id: Scalars['String'];
  /** An object relationship */
  project: Project;
  project_id: Scalars['String'];
  quantity: Scalars['Int'];
};

/** aggregated selection of "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Aggregate = {
  __typename?: 'project_base_product_quantities_aggregate';
  aggregate?: Maybe<Project_Base_Product_Quantities_Aggregate_Fields>;
  nodes: Array<Project_Base_Product_Quantities>;
};

export type Project_Base_Product_Quantities_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Base_Product_Quantities_Aggregate_Bool_Exp_Count>;
};

export type Project_Base_Product_Quantities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Aggregate_Fields = {
  __typename?: 'project_base_product_quantities_aggregate_fields';
  avg?: Maybe<Project_Base_Product_Quantities_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Base_Product_Quantities_Max_Fields>;
  min?: Maybe<Project_Base_Product_Quantities_Min_Fields>;
  stddev?: Maybe<Project_Base_Product_Quantities_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Base_Product_Quantities_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Base_Product_Quantities_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Base_Product_Quantities_Sum_Fields>;
  var_pop?: Maybe<Project_Base_Product_Quantities_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Base_Product_Quantities_Var_Samp_Fields>;
  variance?: Maybe<Project_Base_Product_Quantities_Variance_Fields>;
};


/** aggregate fields of "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Base_Product_Quantities_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Base_Product_Quantities_Max_Order_By>;
  min?: InputMaybe<Project_Base_Product_Quantities_Min_Order_By>;
  stddev?: InputMaybe<Project_Base_Product_Quantities_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Base_Product_Quantities_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Base_Product_Quantities_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Base_Product_Quantities_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Base_Product_Quantities_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Base_Product_Quantities_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Base_Product_Quantities_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Arr_Rel_Insert_Input = {
  data: Array<Project_Base_Product_Quantities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Base_Product_Quantities_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Base_Product_Quantities_Avg_Fields = {
  __typename?: 'project_base_product_quantities_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_base_product_quantities". All fields are combined with a logical 'AND'. */
export type Project_Base_Product_Quantities_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Base_Product_Quantities_Bool_Exp>>;
  _not?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Base_Product_Quantities_Bool_Exp>>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  base_product_id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Constraint =
  /** unique or primary key constraint on columns "project_id", "base_product_id" */
  | 'project_base_product_quantities_pkey';

/** input type for incrementing numeric columns in table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Insert_Input = {
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  base_product_id?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Project_Base_Product_Quantities_Max_Fields = {
  __typename?: 'project_base_product_quantities_max_fields';
  base_product_id?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Max_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Base_Product_Quantities_Min_Fields = {
  __typename?: 'project_base_product_quantities_min_fields';
  base_product_id?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Min_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Mutation_Response = {
  __typename?: 'project_base_product_quantities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Base_Product_Quantities>;
};

/** on_conflict condition type for table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_On_Conflict = {
  constraint: Project_Base_Product_Quantities_Constraint;
  update_columns?: Array<Project_Base_Product_Quantities_Update_Column>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};

/** Ordering options when selecting data from "project_base_product_quantities". */
export type Project_Base_Product_Quantities_Order_By = {
  base_product?: InputMaybe<Base_Product_Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_base_product_quantities */
export type Project_Base_Product_Quantities_Pk_Columns_Input = {
  base_product_id: Scalars['String'];
  project_id: Scalars['String'];
};

/** select columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Select_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'project_id'
  /** column name */
  | 'quantity';

/** input type for updating data in table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Set_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Project_Base_Product_Quantities_Stddev_Fields = {
  __typename?: 'project_base_product_quantities_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Base_Product_Quantities_Stddev_Pop_Fields = {
  __typename?: 'project_base_product_quantities_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Base_Product_Quantities_Stddev_Samp_Fields = {
  __typename?: 'project_base_product_quantities_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Base_Product_Quantities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Base_Product_Quantities_Stream_Cursor_Value_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Project_Base_Product_Quantities_Sum_Fields = {
  __typename?: 'project_base_product_quantities_sum_fields';
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Update_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'project_id'
  /** column name */
  | 'quantity';

export type Project_Base_Product_Quantities_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Base_Product_Quantities_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Base_Product_Quantities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Base_Product_Quantities_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Base_Product_Quantities_Var_Pop_Fields = {
  __typename?: 'project_base_product_quantities_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Base_Product_Quantities_Var_Samp_Fields = {
  __typename?: 'project_base_product_quantities_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Base_Product_Quantities_Variance_Fields = {
  __typename?: 'project_base_product_quantities_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_base_product_quantities" */
export type Project_Base_Product_Quantities_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project". All fields are combined with a logical 'AND'. */
export type Project_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Bool_Exp>>;
  _not?: InputMaybe<Project_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Bool_Exp>>;
  base_product_quantities?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
  base_product_quantities_aggregate?: InputMaybe<Project_Base_Product_Quantities_Aggregate_Bool_Exp>;
  bloxApproved?: InputMaybe<Boolean_Comparison_Exp>;
  bloxProjectNumber?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  contacts?: InputMaybe<Project_Contacts_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Project_Contacts_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  customerId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  items?: InputMaybe<Item_Bom_Bool_Exp>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  milestones?: InputMaybe<Project_Milestone_Bool_Exp>;
  milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Bool_Exp>;
  modules?: InputMaybe<Project_Module_Bool_Exp>;
  modules_aggregate?: InputMaybe<Project_Module_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  postalCode?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  program?: InputMaybe<Program_Bool_Exp>;
  programId?: InputMaybe<String_Comparison_Exp>;
  project_comments?: InputMaybe<Project_Comment_Bool_Exp>;
  project_comments_aggregate?: InputMaybe<Project_Comment_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Project_Status_Bool_Exp>;
  statusId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  units?: InputMaybe<Unit_Bool_Exp>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Project_Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Project_Users_Aggregate_Bool_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "project_comment" */
export type Project_Comment = {
  __typename?: 'project_comment';
  comment: Scalars['String'];
  created_at: Scalars['timestamptz'];
  fileUri?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  options: Scalars['jsonb'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};


/** columns and relationships of "project_comment" */
export type Project_CommentOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_comment" */
export type Project_Comment_Aggregate = {
  __typename?: 'project_comment_aggregate';
  aggregate?: Maybe<Project_Comment_Aggregate_Fields>;
  nodes: Array<Project_Comment>;
};

export type Project_Comment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Comment_Aggregate_Bool_Exp_Count>;
};

export type Project_Comment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Comment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_comment" */
export type Project_Comment_Aggregate_Fields = {
  __typename?: 'project_comment_aggregate_fields';
  avg?: Maybe<Project_Comment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Comment_Max_Fields>;
  min?: Maybe<Project_Comment_Min_Fields>;
  stddev?: Maybe<Project_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Comment_Sum_Fields>;
  var_pop?: Maybe<Project_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Comment_Var_Samp_Fields>;
  variance?: Maybe<Project_Comment_Variance_Fields>;
};


/** aggregate fields of "project_comment" */
export type Project_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_comment" */
export type Project_Comment_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Comment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Comment_Max_Order_By>;
  min?: InputMaybe<Project_Comment_Min_Order_By>;
  stddev?: InputMaybe<Project_Comment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Comment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Comment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Comment_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Comment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Comment_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Comment_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Comment_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_comment" */
export type Project_Comment_Arr_Rel_Insert_Input = {
  data: Array<Project_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Comment_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Comment_Avg_Fields = {
  __typename?: 'project_comment_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_comment" */
export type Project_Comment_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_comment". All fields are combined with a logical 'AND'. */
export type Project_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Comment_Bool_Exp>>;
  _not?: InputMaybe<Project_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Comment_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fileUri?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_comment" */
export type Project_Comment_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'project_comment_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Comment_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Comment_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Comment_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_comment" */
export type Project_Comment_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_comment" */
export type Project_Comment_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Comment_Max_Fields = {
  __typename?: 'project_comment_max_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fileUri?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_comment" */
export type Project_Comment_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fileUri?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Comment_Min_Fields = {
  __typename?: 'project_comment_min_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fileUri?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_comment" */
export type Project_Comment_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fileUri?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_comment" */
export type Project_Comment_Mutation_Response = {
  __typename?: 'project_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Comment>;
};

/** on_conflict condition type for table "project_comment" */
export type Project_Comment_On_Conflict = {
  constraint: Project_Comment_Constraint;
  update_columns?: Array<Project_Comment_Update_Column>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "project_comment". */
export type Project_Comment_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fileUri?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_comment */
export type Project_Comment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Comment_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_comment" */
export type Project_Comment_Select_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'created_at'
  /** column name */
  | 'fileUri'
  /** column name */
  | 'id'
  /** column name */
  | 'options'
  /** column name */
  | 'projectId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'userId';

/** input type for updating data in table "project_comment" */
export type Project_Comment_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  projectId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Comment_Stddev_Fields = {
  __typename?: 'project_comment_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_comment" */
export type Project_Comment_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Comment_Stddev_Pop_Fields = {
  __typename?: 'project_comment_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_comment" */
export type Project_Comment_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Comment_Stddev_Samp_Fields = {
  __typename?: 'project_comment_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_comment" */
export type Project_Comment_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_comment" */
export type Project_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Comment_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fileUri?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  options?: InputMaybe<Scalars['jsonb']>;
  projectId?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Comment_Sum_Fields = {
  __typename?: 'project_comment_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_comment" */
export type Project_Comment_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "project_comment" */
export type Project_Comment_Update_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'created_at'
  /** column name */
  | 'fileUri'
  /** column name */
  | 'id'
  /** column name */
  | 'options'
  /** column name */
  | 'projectId'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'userId';

export type Project_Comment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Comment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Comment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Comment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Comment_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Comment_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Comment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Comment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Comment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Comment_Var_Pop_Fields = {
  __typename?: 'project_comment_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_comment" */
export type Project_Comment_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Comment_Var_Samp_Fields = {
  __typename?: 'project_comment_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_comment" */
export type Project_Comment_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Comment_Variance_Fields = {
  __typename?: 'project_comment_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_comment" */
export type Project_Comment_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "project" */
export type Project_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'catalog_project_pkey';

/** columns and relationships of "project_contacts" */
export type Project_Contacts = {
  __typename?: 'project_contacts';
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  other: Scalars['json'];
  phone: Scalars['String'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['String'];
  title: Scalars['String'];
};


/** columns and relationships of "project_contacts" */
export type Project_ContactsOtherArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_contacts" */
export type Project_Contacts_Aggregate = {
  __typename?: 'project_contacts_aggregate';
  aggregate?: Maybe<Project_Contacts_Aggregate_Fields>;
  nodes: Array<Project_Contacts>;
};

export type Project_Contacts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Contacts_Aggregate_Bool_Exp_Count>;
};

export type Project_Contacts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Contacts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_contacts" */
export type Project_Contacts_Aggregate_Fields = {
  __typename?: 'project_contacts_aggregate_fields';
  avg?: Maybe<Project_Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Contacts_Max_Fields>;
  min?: Maybe<Project_Contacts_Min_Fields>;
  stddev?: Maybe<Project_Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Contacts_Sum_Fields>;
  var_pop?: Maybe<Project_Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Contacts_Var_Samp_Fields>;
  variance?: Maybe<Project_Contacts_Variance_Fields>;
};


/** aggregate fields of "project_contacts" */
export type Project_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_contacts" */
export type Project_Contacts_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Contacts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Contacts_Max_Order_By>;
  min?: InputMaybe<Project_Contacts_Min_Order_By>;
  stddev?: InputMaybe<Project_Contacts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Contacts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Contacts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Contacts_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Contacts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Contacts_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Contacts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_contacts" */
export type Project_Contacts_Arr_Rel_Insert_Input = {
  data: Array<Project_Contacts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Contacts_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Contacts_Avg_Fields = {
  __typename?: 'project_contacts_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_contacts" */
export type Project_Contacts_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_contacts". All fields are combined with a logical 'AND'. */
export type Project_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Project_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Contacts_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  other?: InputMaybe<Json_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_contacts" */
export type Project_Contacts_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'catalog_project_contacts_pkey';

/** input type for incrementing numeric columns in table "project_contacts" */
export type Project_Contacts_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_contacts" */
export type Project_Contacts_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['json']>;
  phone?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Contacts_Max_Fields = {
  __typename?: 'project_contacts_max_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_contacts" */
export type Project_Contacts_Max_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Contacts_Min_Fields = {
  __typename?: 'project_contacts_min_fields';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_contacts" */
export type Project_Contacts_Min_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_contacts" */
export type Project_Contacts_Mutation_Response = {
  __typename?: 'project_contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Contacts>;
};

/** on_conflict condition type for table "project_contacts" */
export type Project_Contacts_On_Conflict = {
  constraint: Project_Contacts_Constraint;
  update_columns?: Array<Project_Contacts_Update_Column>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "project_contacts". */
export type Project_Contacts_Order_By = {
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  other?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_contacts */
export type Project_Contacts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_contacts" */
export type Project_Contacts_Select_Column =
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'other'
  /** column name */
  | 'phone'
  /** column name */
  | 'projectId'
  /** column name */
  | 'title';

/** input type for updating data in table "project_contacts" */
export type Project_Contacts_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['json']>;
  phone?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Contacts_Stddev_Fields = {
  __typename?: 'project_contacts_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_contacts" */
export type Project_Contacts_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Contacts_Stddev_Pop_Fields = {
  __typename?: 'project_contacts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_contacts" */
export type Project_Contacts_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Contacts_Stddev_Samp_Fields = {
  __typename?: 'project_contacts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_contacts" */
export type Project_Contacts_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_contacts" */
export type Project_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Contacts_Stream_Cursor_Value_Input = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  other?: InputMaybe<Scalars['json']>;
  phone?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Contacts_Sum_Fields = {
  __typename?: 'project_contacts_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_contacts" */
export type Project_Contacts_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "project_contacts" */
export type Project_Contacts_Update_Column =
  /** column name */
  | 'email'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'other'
  /** column name */
  | 'phone'
  /** column name */
  | 'projectId'
  /** column name */
  | 'title';

export type Project_Contacts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Contacts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Contacts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Contacts_Var_Pop_Fields = {
  __typename?: 'project_contacts_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_contacts" */
export type Project_Contacts_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Contacts_Var_Samp_Fields = {
  __typename?: 'project_contacts_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_contacts" */
export type Project_Contacts_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Contacts_Variance_Fields = {
  __typename?: 'project_contacts_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_contacts" */
export type Project_Contacts_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project" */
export type Project_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
  statusId?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project" */
export type Project_Insert_Input = {
  base_product_quantities?: InputMaybe<Project_Base_Product_Quantities_Arr_Rel_Insert_Input>;
  bloxApproved?: InputMaybe<Scalars['Boolean']>;
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Project_Contacts_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  customer?: InputMaybe<Customer_Obj_Rel_Insert_Input>;
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  milestones?: InputMaybe<Project_Milestone_Arr_Rel_Insert_Input>;
  modules?: InputMaybe<Project_Module_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  postalCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  program?: InputMaybe<Program_Obj_Rel_Insert_Input>;
  programId?: InputMaybe<Scalars['String']>;
  project_comments?: InputMaybe<Project_Comment_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Project_Status_Obj_Rel_Insert_Input>;
  statusId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Unit_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Project_Users_Arr_Rel_Insert_Input>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Project_Max_Fields = {
  __typename?: 'project_max_fields';
  bloxProjectNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  programId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "project" */
export type Project_Max_Order_By = {
  bloxProjectNumber?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  programId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_milestone" */
export type Project_Milestone = {
  __typename?: 'project_milestone';
  end?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  /** An object relationship */
  milestone: Milestone;
  milestoneId: Scalars['Int'];
  /** An object relationship */
  phase?: Maybe<Phase>;
  phaseId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  project: Project;
  projectId: Scalars['String'];
  start?: Maybe<Scalars['date']>;
};

/** aggregated selection of "project_milestone" */
export type Project_Milestone_Aggregate = {
  __typename?: 'project_milestone_aggregate';
  aggregate?: Maybe<Project_Milestone_Aggregate_Fields>;
  nodes: Array<Project_Milestone>;
};

export type Project_Milestone_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Milestone_Aggregate_Bool_Exp_Count>;
};

export type Project_Milestone_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Milestone_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_milestone" */
export type Project_Milestone_Aggregate_Fields = {
  __typename?: 'project_milestone_aggregate_fields';
  avg?: Maybe<Project_Milestone_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Milestone_Max_Fields>;
  min?: Maybe<Project_Milestone_Min_Fields>;
  stddev?: Maybe<Project_Milestone_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Milestone_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Milestone_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Milestone_Sum_Fields>;
  var_pop?: Maybe<Project_Milestone_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Milestone_Var_Samp_Fields>;
  variance?: Maybe<Project_Milestone_Variance_Fields>;
};


/** aggregate fields of "project_milestone" */
export type Project_Milestone_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_milestone" */
export type Project_Milestone_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Milestone_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Milestone_Max_Order_By>;
  min?: InputMaybe<Project_Milestone_Min_Order_By>;
  stddev?: InputMaybe<Project_Milestone_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Milestone_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Milestone_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Milestone_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Milestone_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Milestone_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Milestone_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "project_milestone" */
export type Project_Milestone_Arr_Rel_Insert_Input = {
  data: Array<Project_Milestone_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Milestone_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Milestone_Avg_Fields = {
  __typename?: 'project_milestone_avg_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_milestone" */
export type Project_Milestone_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_milestone". All fields are combined with a logical 'AND'. */
export type Project_Milestone_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Milestone_Bool_Exp>>;
  _not?: InputMaybe<Project_Milestone_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Milestone_Bool_Exp>>;
  end?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  milestone?: InputMaybe<Milestone_Bool_Exp>;
  milestoneId?: InputMaybe<Int_Comparison_Exp>;
  phase?: InputMaybe<Phase_Bool_Exp>;
  phaseId?: InputMaybe<Int_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  start?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_milestone" */
export type Project_Milestone_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'project_milestone_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'project_milestone_pkey'
  /** unique or primary key constraint on columns "milestoneId", "projectId", "phaseId" */
  | 'project_milestone_projectId_milestoneId_phaseId_key';

/** input type for incrementing numeric columns in table "project_milestone" */
export type Project_Milestone_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  milestoneId?: InputMaybe<Scalars['Int']>;
  phaseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_milestone" */
export type Project_Milestone_Insert_Input = {
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  milestone?: InputMaybe<Milestone_Obj_Rel_Insert_Input>;
  milestoneId?: InputMaybe<Scalars['Int']>;
  phase?: InputMaybe<Phase_Obj_Rel_Insert_Input>;
  phaseId?: InputMaybe<Scalars['Int']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Project_Milestone_Max_Fields = {
  __typename?: 'project_milestone_max_fields';
  end?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  milestoneId?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "project_milestone" */
export type Project_Milestone_Max_Order_By = {
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Milestone_Min_Fields = {
  __typename?: 'project_milestone_min_fields';
  end?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  milestoneId?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['Int']>;
  projectId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "project_milestone" */
export type Project_Milestone_Min_Order_By = {
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_milestone" */
export type Project_Milestone_Mutation_Response = {
  __typename?: 'project_milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Milestone>;
};

/** on_conflict condition type for table "project_milestone" */
export type Project_Milestone_On_Conflict = {
  constraint: Project_Milestone_Constraint;
  update_columns?: Array<Project_Milestone_Update_Column>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};

/** Ordering options when selecting data from "project_milestone". */
export type Project_Milestone_Order_By = {
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  milestone?: InputMaybe<Milestone_Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phase?: InputMaybe<Phase_Order_By>;
  phaseId?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_milestone */
export type Project_Milestone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_milestone" */
export type Project_Milestone_Select_Column =
  /** column name */
  | 'end'
  /** column name */
  | 'id'
  /** column name */
  | 'milestoneId'
  /** column name */
  | 'phaseId'
  /** column name */
  | 'projectId'
  /** column name */
  | 'start';

/** input type for updating data in table "project_milestone" */
export type Project_Milestone_Set_Input = {
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  milestoneId?: InputMaybe<Scalars['Int']>;
  phaseId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
};

/** aggregate stddev on columns */
export type Project_Milestone_Stddev_Fields = {
  __typename?: 'project_milestone_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_milestone" */
export type Project_Milestone_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Milestone_Stddev_Pop_Fields = {
  __typename?: 'project_milestone_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_milestone" */
export type Project_Milestone_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Milestone_Stddev_Samp_Fields = {
  __typename?: 'project_milestone_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_milestone" */
export type Project_Milestone_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_milestone" */
export type Project_Milestone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Milestone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Milestone_Stream_Cursor_Value_Input = {
  end?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  milestoneId?: InputMaybe<Scalars['Int']>;
  phaseId?: InputMaybe<Scalars['Int']>;
  projectId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Project_Milestone_Sum_Fields = {
  __typename?: 'project_milestone_sum_fields';
  id?: Maybe<Scalars['Int']>;
  milestoneId?: Maybe<Scalars['Int']>;
  phaseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_milestone" */
export type Project_Milestone_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** update columns of table "project_milestone" */
export type Project_Milestone_Update_Column =
  /** column name */
  | 'end'
  /** column name */
  | 'id'
  /** column name */
  | 'milestoneId'
  /** column name */
  | 'phaseId'
  /** column name */
  | 'projectId'
  /** column name */
  | 'start';

export type Project_Milestone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Milestone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Milestone_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Milestone_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Milestone_Var_Pop_Fields = {
  __typename?: 'project_milestone_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_milestone" */
export type Project_Milestone_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Milestone_Var_Samp_Fields = {
  __typename?: 'project_milestone_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_milestone" */
export type Project_Milestone_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Milestone_Variance_Fields = {
  __typename?: 'project_milestone_variance_fields';
  id?: Maybe<Scalars['Float']>;
  milestoneId?: Maybe<Scalars['Float']>;
  phaseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_milestone" */
export type Project_Milestone_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  milestoneId?: InputMaybe<Order_By>;
  phaseId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Min_Fields = {
  __typename?: 'project_min_fields';
  bloxProjectNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  programId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "project" */
export type Project_Min_Order_By = {
  bloxProjectNumber?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  programId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "project_module" */
export type Project_Module = {
  __typename?: 'project_module';
  config?: Maybe<Scalars['jsonb']>;
  id: Scalars['String'];
  /** An object relationship */
  project: Project;
  projectId: Scalars['String'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};


/** columns and relationships of "project_module" */
export type Project_ModuleConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "project_module" */
export type Project_Module_Aggregate = {
  __typename?: 'project_module_aggregate';
  aggregate?: Maybe<Project_Module_Aggregate_Fields>;
  nodes: Array<Project_Module>;
};

export type Project_Module_Aggregate_Bool_Exp = {
  count?: InputMaybe<Project_Module_Aggregate_Bool_Exp_Count>;
};

export type Project_Module_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Module_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_module" */
export type Project_Module_Aggregate_Fields = {
  __typename?: 'project_module_aggregate_fields';
  avg?: Maybe<Project_Module_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Module_Max_Fields>;
  min?: Maybe<Project_Module_Min_Fields>;
  stddev?: Maybe<Project_Module_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Module_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Module_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Module_Sum_Fields>;
  var_pop?: Maybe<Project_Module_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Module_Var_Samp_Fields>;
  variance?: Maybe<Project_Module_Variance_Fields>;
};


/** aggregate fields of "project_module" */
export type Project_Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_module" */
export type Project_Module_Aggregate_Order_By = {
  avg?: InputMaybe<Project_Module_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Module_Max_Order_By>;
  min?: InputMaybe<Project_Module_Min_Order_By>;
  stddev?: InputMaybe<Project_Module_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Project_Module_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Project_Module_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Project_Module_Sum_Order_By>;
  var_pop?: InputMaybe<Project_Module_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Project_Module_Var_Samp_Order_By>;
  variance?: InputMaybe<Project_Module_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Project_Module_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "project_module" */
export type Project_Module_Arr_Rel_Insert_Input = {
  data: Array<Project_Module_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Module_On_Conflict>;
};

/** aggregate avg on columns */
export type Project_Module_Avg_Fields = {
  __typename?: 'project_module_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "project_module" */
export type Project_Module_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "project_module". All fields are combined with a logical 'AND'. */
export type Project_Module_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Module_Bool_Exp>>;
  _not?: InputMaybe<Project_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Module_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_module" */
export type Project_Module_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'catalog_project_module_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Project_Module_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Project_Module_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Project_Module_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "project_module" */
export type Project_Module_Inc_Input = {
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_module" */
export type Project_Module_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Module_Max_Fields = {
  __typename?: 'project_module_max_fields';
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_module" */
export type Project_Module_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Module_Min_Fields = {
  __typename?: 'project_module_min_fields';
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_module" */
export type Project_Module_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  projectId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_module" */
export type Project_Module_Mutation_Response = {
  __typename?: 'project_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Module>;
};

/** on_conflict condition type for table "project_module" */
export type Project_Module_On_Conflict = {
  constraint: Project_Module_Constraint;
  update_columns?: Array<Project_Module_Update_Column>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "project_module". */
export type Project_Module_Order_By = {
  config?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_module */
export type Project_Module_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Module_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project_module" */
export type Project_Module_Select_Column =
  /** column name */
  | 'config'
  /** column name */
  | 'id'
  /** column name */
  | 'projectId'
  /** column name */
  | 'quantity'
  /** column name */
  | 'sku';

/** input type for updating data in table "project_module" */
export type Project_Module_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Module_Stddev_Fields = {
  __typename?: 'project_module_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project_module" */
export type Project_Module_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Module_Stddev_Pop_Fields = {
  __typename?: 'project_module_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project_module" */
export type Project_Module_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Module_Stddev_Samp_Fields = {
  __typename?: 'project_module_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project_module" */
export type Project_Module_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project_module" */
export type Project_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Module_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Module_Sum_Fields = {
  __typename?: 'project_module_sum_fields';
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project_module" */
export type Project_Module_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "project_module" */
export type Project_Module_Update_Column =
  /** column name */
  | 'config'
  /** column name */
  | 'id'
  /** column name */
  | 'projectId'
  /** column name */
  | 'quantity'
  /** column name */
  | 'sku';

export type Project_Module_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Module_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Module_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Module_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Module_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Module_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Module_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Module_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Module_Var_Pop_Fields = {
  __typename?: 'project_module_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project_module" */
export type Project_Module_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Module_Var_Samp_Fields = {
  __typename?: 'project_module_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project_module" */
export type Project_Module_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Module_Variance_Fields = {
  __typename?: 'project_module_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project_module" */
export type Project_Module_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project" */
export type Project_Mutation_Response = {
  __typename?: 'project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project>;
};

/** input type for inserting object relation for remote table "project" */
export type Project_Obj_Rel_Insert_Input = {
  data: Project_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_On_Conflict>;
};

/** on_conflict condition type for table "project" */
export type Project_On_Conflict = {
  constraint: Project_Constraint;
  update_columns?: Array<Project_Update_Column>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** Ordering options when selecting data from "project". */
export type Project_Order_By = {
  base_product_quantities_aggregate?: InputMaybe<Project_Base_Product_Quantities_Aggregate_Order_By>;
  bloxApproved?: InputMaybe<Order_By>;
  bloxProjectNumber?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Project_Contacts_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  customerId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  milestones_aggregate?: InputMaybe<Project_Milestone_Aggregate_Order_By>;
  modules_aggregate?: InputMaybe<Project_Module_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  postalCode?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  program?: InputMaybe<Program_Order_By>;
  programId?: InputMaybe<Order_By>;
  project_comments_aggregate?: InputMaybe<Project_Comment_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Project_Status_Order_By>;
  statusId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  units_aggregate?: InputMaybe<Unit_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Project_Users_Aggregate_Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project */
export type Project_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Project_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "project" */
export type Project_Select_Column =
  /** column name */
  | 'bloxApproved'
  /** column name */
  | 'bloxProjectNumber'
  /** column name */
  | 'city'
  /** column name */
  | 'comments'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'customerId'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'options'
  /** column name */
  | 'postalCode'
  /** column name */
  | 'price'
  /** column name */
  | 'programId'
  /** column name */
  | 'state'
  /** column name */
  | 'statusId'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'year';

/** select "project_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project" */
export type Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'bloxApproved';

/** select "project_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project" */
export type Project_Select_Column_Project_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'bloxApproved';

/** input type for updating data in table "project" */
export type Project_Set_Input = {
  bloxApproved?: InputMaybe<Scalars['Boolean']>;
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  postalCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  programId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "project_status" */
export type Project_Status = {
  __typename?: 'project_status';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  projects: Array<Project>;
  /** An aggregate relationship */
  projects_aggregate: Project_Aggregate;
};


/** columns and relationships of "project_status" */
export type Project_StatusProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


/** columns and relationships of "project_status" */
export type Project_StatusProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};

/** aggregated selection of "project_status" */
export type Project_Status_Aggregate = {
  __typename?: 'project_status_aggregate';
  aggregate?: Maybe<Project_Status_Aggregate_Fields>;
  nodes: Array<Project_Status>;
};

/** aggregate fields of "project_status" */
export type Project_Status_Aggregate_Fields = {
  __typename?: 'project_status_aggregate_fields';
  avg?: Maybe<Project_Status_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Project_Status_Max_Fields>;
  min?: Maybe<Project_Status_Min_Fields>;
  stddev?: Maybe<Project_Status_Stddev_Fields>;
  stddev_pop?: Maybe<Project_Status_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Project_Status_Stddev_Samp_Fields>;
  sum?: Maybe<Project_Status_Sum_Fields>;
  var_pop?: Maybe<Project_Status_Var_Pop_Fields>;
  var_samp?: Maybe<Project_Status_Var_Samp_Fields>;
  variance?: Maybe<Project_Status_Variance_Fields>;
};


/** aggregate fields of "project_status" */
export type Project_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Project_Status_Avg_Fields = {
  __typename?: 'project_status_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "project_status". All fields are combined with a logical 'AND'. */
export type Project_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Status_Bool_Exp>>;
  _not?: InputMaybe<Project_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Status_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  projects?: InputMaybe<Project_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "project_status" */
export type Project_Status_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'project_status_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'project_status_pkey';

/** input type for incrementing numeric columns in table "project_status" */
export type Project_Status_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "project_status" */
export type Project_Status_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Project_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Project_Status_Max_Fields = {
  __typename?: 'project_status_max_fields';
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Status_Min_Fields = {
  __typename?: 'project_status_min_fields';
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_status" */
export type Project_Status_Mutation_Response = {
  __typename?: 'project_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Status>;
};

/** input type for inserting object relation for remote table "project_status" */
export type Project_Status_Obj_Rel_Insert_Input = {
  data: Project_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Status_On_Conflict>;
};

/** on_conflict condition type for table "project_status" */
export type Project_Status_On_Conflict = {
  constraint: Project_Status_Constraint;
  update_columns?: Array<Project_Status_Update_Column>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "project_status". */
export type Project_Status_Order_By = {
  comment?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Project_Aggregate_Order_By>;
};

/** primary key columns input for table: project_status */
export type Project_Status_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "project_status" */
export type Project_Status_Select_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "project_status" */
export type Project_Status_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Project_Status_Stddev_Fields = {
  __typename?: 'project_status_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Project_Status_Stddev_Pop_Fields = {
  __typename?: 'project_status_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Project_Status_Stddev_Samp_Fields = {
  __typename?: 'project_status_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "project_status" */
export type Project_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Status_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Project_Status_Sum_Fields = {
  __typename?: 'project_status_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "project_status" */
export type Project_Status_Update_Column =
  /** column name */
  | 'comment'
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Project_Status_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Status_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Status_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Status_Var_Pop_Fields = {
  __typename?: 'project_status_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Project_Status_Var_Samp_Fields = {
  __typename?: 'project_status_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Project_Status_Variance_Fields = {
  __typename?: 'project_status_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev on columns */
export type Project_Stddev_Fields = {
  __typename?: 'project_stddev_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "project" */
export type Project_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Project_Stddev_Pop_Fields = {
  __typename?: 'project_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "project" */
export type Project_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Project_Stddev_Samp_Fields = {
  __typename?: 'project_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "project" */
export type Project_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "project" */
export type Project_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Stream_Cursor_Value_Input = {
  bloxApproved?: InputMaybe<Scalars['Boolean']>;
  bloxProjectNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  postalCode?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  programId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Project_Sum_Fields = {
  __typename?: 'project_sum_fields';
  price?: Maybe<Scalars['numeric']>;
  statusId?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "project" */
export type Project_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "project" */
export type Project_Update_Column =
  /** column name */
  | 'bloxApproved'
  /** column name */
  | 'bloxProjectNumber'
  /** column name */
  | 'city'
  /** column name */
  | 'comments'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'customerId'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'options'
  /** column name */
  | 'postalCode'
  /** column name */
  | 'price'
  /** column name */
  | 'programId'
  /** column name */
  | 'state'
  /** column name */
  | 'statusId'
  /** column name */
  | 'type'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'year';

export type Project_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Project_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Project_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Project_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Project_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Project_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Project_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Bool_Exp;
};

/** columns and relationships of "project_users" */
export type Project_Users = {
  __typename?: 'project_users';
  /** An object relationship */
  project?: Maybe<Project>;
  projectId: Scalars['String'];
  readOnly?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "project_users" */
export type Project_Users_Aggregate = {
  __typename?: 'project_users_aggregate';
  aggregate?: Maybe<Project_Users_Aggregate_Fields>;
  nodes: Array<Project_Users>;
};

export type Project_Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Project_Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Project_Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Project_Users_Aggregate_Bool_Exp_Count>;
};

export type Project_Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Project_Users_Select_Column_Project_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Project_Users_Select_Column_Project_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Project_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Project_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Project_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "project_users" */
export type Project_Users_Aggregate_Fields = {
  __typename?: 'project_users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Users_Max_Fields>;
  min?: Maybe<Project_Users_Min_Fields>;
};


/** aggregate fields of "project_users" */
export type Project_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_users" */
export type Project_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Users_Max_Order_By>;
  min?: InputMaybe<Project_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_users" */
export type Project_Users_Arr_Rel_Insert_Input = {
  data: Array<Project_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_users". All fields are combined with a logical 'AND'. */
export type Project_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Users_Bool_Exp>>;
  _not?: InputMaybe<Project_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Users_Bool_Exp>>;
  project?: InputMaybe<Project_Bool_Exp>;
  projectId?: InputMaybe<String_Comparison_Exp>;
  readOnly?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_users" */
export type Project_Users_Constraint =
  /** unique or primary key constraint on columns "projectId", "userId" */
  | 'project_users_pkey';

/** input type for inserting data into table "project_users" */
export type Project_Users_Insert_Input = {
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  projectId?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Users_Max_Fields = {
  __typename?: 'project_users_max_fields';
  projectId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_users" */
export type Project_Users_Max_Order_By = {
  projectId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Users_Min_Fields = {
  __typename?: 'project_users_min_fields';
  projectId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_users" */
export type Project_Users_Min_Order_By = {
  projectId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_users" */
export type Project_Users_Mutation_Response = {
  __typename?: 'project_users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Users>;
};

/** on_conflict condition type for table "project_users" */
export type Project_Users_On_Conflict = {
  constraint: Project_Users_Constraint;
  update_columns?: Array<Project_Users_Update_Column>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "project_users". */
export type Project_Users_Order_By = {
  project?: InputMaybe<Project_Order_By>;
  projectId?: InputMaybe<Order_By>;
  readOnly?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_users */
export type Project_Users_Pk_Columns_Input = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};

/** select columns of table "project_users" */
export type Project_Users_Select_Column =
  /** column name */
  | 'projectId'
  /** column name */
  | 'readOnly'
  /** column name */
  | 'userId';

/** select "project_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "project_users" */
export type Project_Users_Select_Column_Project_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'readOnly';

/** select "project_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "project_users" */
export type Project_Users_Select_Column_Project_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'readOnly';

/** input type for updating data in table "project_users" */
export type Project_Users_Set_Input = {
  projectId?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "project_users" */
export type Project_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Project_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Project_Users_Stream_Cursor_Value_Input = {
  projectId?: InputMaybe<Scalars['String']>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_users" */
export type Project_Users_Update_Column =
  /** column name */
  | 'projectId'
  /** column name */
  | 'readOnly'
  /** column name */
  | 'userId';

export type Project_Users_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Project_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Project_Var_Pop_Fields = {
  __typename?: 'project_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "project" */
export type Project_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Project_Var_Samp_Fields = {
  __typename?: 'project_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "project" */
export type Project_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Project_Variance_Fields = {
  __typename?: 'project_variance_fields';
  price?: Maybe<Scalars['Float']>;
  statusId?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "project" */
export type Project_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  statusId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "purchase_type" */
export type Purchase_Type = {
  __typename?: 'purchase_type';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  parts: Array<Part>;
  /** An aggregate relationship */
  parts_aggregate: Part_Aggregate;
};


/** columns and relationships of "purchase_type" */
export type Purchase_TypePartsArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


/** columns and relationships of "purchase_type" */
export type Purchase_TypeParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};

/** aggregated selection of "purchase_type" */
export type Purchase_Type_Aggregate = {
  __typename?: 'purchase_type_aggregate';
  aggregate?: Maybe<Purchase_Type_Aggregate_Fields>;
  nodes: Array<Purchase_Type>;
};

/** aggregate fields of "purchase_type" */
export type Purchase_Type_Aggregate_Fields = {
  __typename?: 'purchase_type_aggregate_fields';
  avg?: Maybe<Purchase_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Purchase_Type_Max_Fields>;
  min?: Maybe<Purchase_Type_Min_Fields>;
  stddev?: Maybe<Purchase_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Purchase_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Purchase_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Purchase_Type_Sum_Fields>;
  var_pop?: Maybe<Purchase_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Purchase_Type_Var_Samp_Fields>;
  variance?: Maybe<Purchase_Type_Variance_Fields>;
};


/** aggregate fields of "purchase_type" */
export type Purchase_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Purchase_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Purchase_Type_Avg_Fields = {
  __typename?: 'purchase_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "purchase_type". All fields are combined with a logical 'AND'. */
export type Purchase_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Purchase_Type_Bool_Exp>>;
  _not?: InputMaybe<Purchase_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Purchase_Type_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parts?: InputMaybe<Part_Bool_Exp>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "purchase_type" */
export type Purchase_Type_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'purchase_type_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'purchase_type_pkey';

/** input type for incrementing numeric columns in table "purchase_type" */
export type Purchase_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "purchase_type" */
export type Purchase_Type_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parts?: InputMaybe<Part_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Purchase_Type_Max_Fields = {
  __typename?: 'purchase_type_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Purchase_Type_Min_Fields = {
  __typename?: 'purchase_type_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "purchase_type" */
export type Purchase_Type_Mutation_Response = {
  __typename?: 'purchase_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Purchase_Type>;
};

/** input type for inserting object relation for remote table "purchase_type" */
export type Purchase_Type_Obj_Rel_Insert_Input = {
  data: Purchase_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Purchase_Type_On_Conflict>;
};

/** on_conflict condition type for table "purchase_type" */
export type Purchase_Type_On_Conflict = {
  constraint: Purchase_Type_Constraint;
  update_columns?: Array<Purchase_Type_Update_Column>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "purchase_type". */
export type Purchase_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parts_aggregate?: InputMaybe<Part_Aggregate_Order_By>;
};

/** primary key columns input for table: purchase_type */
export type Purchase_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "purchase_type" */
export type Purchase_Type_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "purchase_type" */
export type Purchase_Type_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Purchase_Type_Stddev_Fields = {
  __typename?: 'purchase_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Purchase_Type_Stddev_Pop_Fields = {
  __typename?: 'purchase_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Purchase_Type_Stddev_Samp_Fields = {
  __typename?: 'purchase_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "purchase_type" */
export type Purchase_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Purchase_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Purchase_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Purchase_Type_Sum_Fields = {
  __typename?: 'purchase_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "purchase_type" */
export type Purchase_Type_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Purchase_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Purchase_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Purchase_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Purchase_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Purchase_Type_Var_Pop_Fields = {
  __typename?: 'purchase_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Purchase_Type_Var_Samp_Fields = {
  __typename?: 'purchase_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Purchase_Type_Variance_Fields = {
  __typename?: 'purchase_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "qb_items" */
export type Qb_Items = {
  __typename?: 'qb_items';
  avg_lead_time?: Maybe<Scalars['String']>;
  bin_location?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  color_finish_gauge?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_group?: Maybe<Scalars['String']>;
  csi_subgroup?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  item: Scalars['String'];
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_description?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  on_hand_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  part?: Maybe<Part>;
  po_quantity?: Maybe<Scalars['numeric']>;
  preferred_vendor?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  uom?: Maybe<Scalars['String']>;
};

/** aggregated selection of "qb_items" */
export type Qb_Items_Aggregate = {
  __typename?: 'qb_items_aggregate';
  aggregate?: Maybe<Qb_Items_Aggregate_Fields>;
  nodes: Array<Qb_Items>;
};

/** aggregate fields of "qb_items" */
export type Qb_Items_Aggregate_Fields = {
  __typename?: 'qb_items_aggregate_fields';
  avg?: Maybe<Qb_Items_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Qb_Items_Max_Fields>;
  min?: Maybe<Qb_Items_Min_Fields>;
  stddev?: Maybe<Qb_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Qb_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Qb_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Qb_Items_Sum_Fields>;
  var_pop?: Maybe<Qb_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Qb_Items_Var_Samp_Fields>;
  variance?: Maybe<Qb_Items_Variance_Fields>;
};


/** aggregate fields of "qb_items" */
export type Qb_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Qb_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Qb_Items_Avg_Fields = {
  __typename?: 'qb_items_avg_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "qb_items". All fields are combined with a logical 'AND'. */
export type Qb_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Qb_Items_Bool_Exp>>;
  _not?: InputMaybe<Qb_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Qb_Items_Bool_Exp>>;
  avg_lead_time?: InputMaybe<String_Comparison_Exp>;
  bin_location?: InputMaybe<String_Comparison_Exp>;
  class?: InputMaybe<String_Comparison_Exp>;
  cogs_account?: InputMaybe<String_Comparison_Exp>;
  color_finish_gauge?: InputMaybe<String_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  csi_group?: InputMaybe<String_Comparison_Exp>;
  csi_subgroup?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  item?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  manufacturer_description?: InputMaybe<String_Comparison_Exp>;
  manufacturer_part_number?: InputMaybe<String_Comparison_Exp>;
  on_hand_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  po_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  preferred_vendor?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  uom?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "qb_items" */
export type Qb_Items_Constraint =
  /** unique or primary key constraint on columns "item" */
  | 'qb_items_pkey';

/** input type for incrementing numeric columns in table "qb_items" */
export type Qb_Items_Inc_Input = {
  cost?: InputMaybe<Scalars['numeric']>;
  on_hand_quantity?: InputMaybe<Scalars['numeric']>;
  po_quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "qb_items" */
export type Qb_Items_Insert_Input = {
  avg_lead_time?: InputMaybe<Scalars['String']>;
  bin_location?: InputMaybe<Scalars['String']>;
  class?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  color_finish_gauge?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_group?: InputMaybe<Scalars['String']>;
  csi_subgroup?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_description?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  on_hand_quantity?: InputMaybe<Scalars['numeric']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  po_quantity?: InputMaybe<Scalars['numeric']>;
  preferred_vendor?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Qb_Items_Max_Fields = {
  __typename?: 'qb_items_max_fields';
  avg_lead_time?: Maybe<Scalars['String']>;
  bin_location?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  color_finish_gauge?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_group?: Maybe<Scalars['String']>;
  csi_subgroup?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_description?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  on_hand_quantity?: Maybe<Scalars['numeric']>;
  po_quantity?: Maybe<Scalars['numeric']>;
  preferred_vendor?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Qb_Items_Min_Fields = {
  __typename?: 'qb_items_min_fields';
  avg_lead_time?: Maybe<Scalars['String']>;
  bin_location?: Maybe<Scalars['String']>;
  class?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  color_finish_gauge?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_group?: Maybe<Scalars['String']>;
  csi_subgroup?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  item?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_description?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  on_hand_quantity?: Maybe<Scalars['numeric']>;
  po_quantity?: Maybe<Scalars['numeric']>;
  preferred_vendor?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "qb_items" */
export type Qb_Items_Mutation_Response = {
  __typename?: 'qb_items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Qb_Items>;
};

/** input type for inserting object relation for remote table "qb_items" */
export type Qb_Items_Obj_Rel_Insert_Input = {
  data: Qb_Items_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Qb_Items_On_Conflict>;
};

/** on_conflict condition type for table "qb_items" */
export type Qb_Items_On_Conflict = {
  constraint: Qb_Items_Constraint;
  update_columns?: Array<Qb_Items_Update_Column>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};

/** Ordering options when selecting data from "qb_items". */
export type Qb_Items_Order_By = {
  avg_lead_time?: InputMaybe<Order_By>;
  bin_location?: InputMaybe<Order_By>;
  class?: InputMaybe<Order_By>;
  cogs_account?: InputMaybe<Order_By>;
  color_finish_gauge?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  csi_group?: InputMaybe<Order_By>;
  csi_subgroup?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  item?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_description?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  on_hand_quantity?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  po_quantity?: InputMaybe<Order_By>;
  preferred_vendor?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
};

/** primary key columns input for table: qb_items */
export type Qb_Items_Pk_Columns_Input = {
  item: Scalars['String'];
};

/** select columns of table "qb_items" */
export type Qb_Items_Select_Column =
  /** column name */
  | 'avg_lead_time'
  /** column name */
  | 'bin_location'
  /** column name */
  | 'class'
  /** column name */
  | 'cogs_account'
  /** column name */
  | 'color_finish_gauge'
  /** column name */
  | 'cost'
  /** column name */
  | 'csi_group'
  /** column name */
  | 'csi_subgroup'
  /** column name */
  | 'description'
  /** column name */
  | 'item'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_description'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'on_hand_quantity'
  /** column name */
  | 'po_quantity'
  /** column name */
  | 'preferred_vendor'
  /** column name */
  | 'size'
  /** column name */
  | 'status'
  /** column name */
  | 'type'
  /** column name */
  | 'uom';

/** input type for updating data in table "qb_items" */
export type Qb_Items_Set_Input = {
  avg_lead_time?: InputMaybe<Scalars['String']>;
  bin_location?: InputMaybe<Scalars['String']>;
  class?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  color_finish_gauge?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_group?: InputMaybe<Scalars['String']>;
  csi_subgroup?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_description?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  on_hand_quantity?: InputMaybe<Scalars['numeric']>;
  po_quantity?: InputMaybe<Scalars['numeric']>;
  preferred_vendor?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Qb_Items_Stddev_Fields = {
  __typename?: 'qb_items_stddev_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Qb_Items_Stddev_Pop_Fields = {
  __typename?: 'qb_items_stddev_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Qb_Items_Stddev_Samp_Fields = {
  __typename?: 'qb_items_stddev_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "qb_items" */
export type Qb_Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Qb_Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Qb_Items_Stream_Cursor_Value_Input = {
  avg_lead_time?: InputMaybe<Scalars['String']>;
  bin_location?: InputMaybe<Scalars['String']>;
  class?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  color_finish_gauge?: InputMaybe<Scalars['String']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_group?: InputMaybe<Scalars['String']>;
  csi_subgroup?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  item?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_description?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  on_hand_quantity?: InputMaybe<Scalars['numeric']>;
  po_quantity?: InputMaybe<Scalars['numeric']>;
  preferred_vendor?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Qb_Items_Sum_Fields = {
  __typename?: 'qb_items_sum_fields';
  cost?: Maybe<Scalars['numeric']>;
  on_hand_quantity?: Maybe<Scalars['numeric']>;
  po_quantity?: Maybe<Scalars['numeric']>;
};

/** update columns of table "qb_items" */
export type Qb_Items_Update_Column =
  /** column name */
  | 'avg_lead_time'
  /** column name */
  | 'bin_location'
  /** column name */
  | 'class'
  /** column name */
  | 'cogs_account'
  /** column name */
  | 'color_finish_gauge'
  /** column name */
  | 'cost'
  /** column name */
  | 'csi_group'
  /** column name */
  | 'csi_subgroup'
  /** column name */
  | 'description'
  /** column name */
  | 'item'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_description'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'on_hand_quantity'
  /** column name */
  | 'po_quantity'
  /** column name */
  | 'preferred_vendor'
  /** column name */
  | 'size'
  /** column name */
  | 'status'
  /** column name */
  | 'type'
  /** column name */
  | 'uom';

export type Qb_Items_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Qb_Items_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Qb_Items_Set_Input>;
  /** filter the rows which have to be updated */
  where: Qb_Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Qb_Items_Var_Pop_Fields = {
  __typename?: 'qb_items_var_pop_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Qb_Items_Var_Samp_Fields = {
  __typename?: 'qb_items_var_samp_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Qb_Items_Variance_Fields = {
  __typename?: 'qb_items_variance_fields';
  cost?: Maybe<Scalars['Float']>;
  on_hand_quantity?: Maybe<Scalars['Float']>;
  po_quantity?: Maybe<Scalars['Float']>;
};

export type Quantity = {
  include_waste: Scalars['Boolean'];
  quantity: Scalars['Float'];
};

export type QuantityCreateInput = {
  include_waste?: Scalars['Boolean'];
  quantity: Scalars['Float'];
};

export type QuantitySort = {
  include_waste?: InputMaybe<SortDirection>;
  quantity?: InputMaybe<SortDirection>;
};

export type QuantityUpdateInput = {
  include_waste?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

export type QuantityWhere = {
  AND?: InputMaybe<Array<QuantityWhere>>;
  OR?: InputMaybe<Array<QuantityWhere>>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  include_waste_NOT?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_NOT?: InputMaybe<Scalars['Float']>;
  quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type Query_Root = {
  __typename?: 'query_root';
  BomIndexList: BomIndexSearchResults;
  BomVersion: BomResult;
  ItemTag: ItemTag;
  ItemTags: Array<ItemTag>;
  QueryResults: TaggedResult;
  Tag?: Maybe<Tag>;
  TagType: TagType;
  TagTypes: Array<TagType>;
  Tags: Array<Tag>;
  /** fetch data from the table: "all_boms_view" */
  all_boms_view: Array<All_Boms_View>;
  /** fetch aggregated fields from the table: "all_boms_view" */
  all_boms_view_aggregate: All_Boms_View_Aggregate;
  /** fetch data from the table: "base_product" */
  base_product: Array<Base_Product>;
  /** fetch aggregated fields from the table: "base_product" */
  base_product_aggregate: Base_Product_Aggregate;
  /** fetch data from the table: "base_product" using primary key columns */
  base_product_by_pk?: Maybe<Base_Product>;
  /** fetch data from the table: "bom_detail" */
  bom_detail: Array<Bom_Detail>;
  /** fetch aggregated fields from the table: "bom_detail" */
  bom_detail_aggregate: Bom_Detail_Aggregate;
  /** fetch data from the table: "bom_detail" using primary key columns */
  bom_detail_by_pk?: Maybe<Bom_Detail>;
  /** fetch data from the table: "bom_item_tag_set" */
  bom_item_tag_set: Array<Bom_Item_Tag_Set>;
  /** fetch aggregated fields from the table: "bom_item_tag_set" */
  bom_item_tag_set_aggregate: Bom_Item_Tag_Set_Aggregate;
  /** fetch data from the table: "bom_item_tag_set" using primary key columns */
  bom_item_tag_set_by_pk?: Maybe<Bom_Item_Tag_Set>;
  /** fetch data from the table: "boms_view" */
  boms_view: Array<Boms_View>;
  /** fetch aggregated fields from the table: "boms_view" */
  boms_view_aggregate: Boms_View_Aggregate;
  choiceNodes: Array<ChoiceNode>;
  choiceNodesAggregate: ChoiceNodeAggregateSelection;
  choiceNodesCount: Scalars['Int'];
  /** fetch data from the table: "consumable_bom_detail" */
  consumable_bom_detail: Array<Consumable_Bom_Detail>;
  /** fetch aggregated fields from the table: "consumable_bom_detail" */
  consumable_bom_detail_aggregate: Consumable_Bom_Detail_Aggregate;
  /** fetch data from the table: "consumable_bom_detail" using primary key columns */
  consumable_bom_detail_by_pk?: Maybe<Consumable_Bom_Detail>;
  /** fetch data from the table: "counters" */
  counters: Array<Counters>;
  /** fetch aggregated fields from the table: "counters" */
  counters_aggregate: Counters_Aggregate;
  /** fetch data from the table: "counters" using primary key columns */
  counters_by_pk?: Maybe<Counters>;
  /** fetch data from the table: "csi" */
  csi: Array<Csi>;
  csiNodes: Array<CsiNode>;
  csiNodesAggregate: CsiNodeAggregateSelection;
  csiNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "csi" */
  csi_aggregate: Csi_Aggregate;
  /** fetch data from the table: "csi" using primary key columns */
  csi_by_pk?: Maybe<Csi>;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  customerNodes: Array<CustomerNode>;
  customerNodesAggregate: CustomerNodeAggregateSelection;
  customerNodesCount: Scalars['Int'];
  /** fetch data from the table: "customer_admin" */
  customer_admin: Array<Customer_Admin>;
  /** fetch aggregated fields from the table: "customer_admin" */
  customer_admin_aggregate: Customer_Admin_Aggregate;
  /** fetch data from the table: "customer_admin" using primary key columns */
  customer_admin_by_pk?: Maybe<Customer_Admin>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>;
  /** fetch data from the table: "email_templates" */
  email_templates: Array<Email_Templates>;
  /** fetch aggregated fields from the table: "email_templates" */
  email_templates_aggregate: Email_Templates_Aggregate;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** fetch data from the table: "emails" */
  emails: Array<Emails>;
  /** fetch aggregated fields from the table: "emails" */
  emails_aggregate: Emails_Aggregate;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table: "issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table: "issue_status" */
  issue_status: Array<Issue_Status>;
  /** fetch aggregated fields from the table: "issue_status" */
  issue_status_aggregate: Issue_Status_Aggregate;
  /** fetch data from the table: "issue_status" using primary key columns */
  issue_status_by_pk?: Maybe<Issue_Status>;
  itemNodes: Array<ItemNode>;
  itemNodesAggregate: ItemNodeAggregateSelection;
  itemNodesCount: Scalars['Int'];
  /** fetch data from the table: "item_bom" */
  item_bom: Array<Item_Bom>;
  /** fetch aggregated fields from the table: "item_bom" */
  item_bom_aggregate: Item_Bom_Aggregate;
  /** fetch data from the table: "item_bom" using primary key columns */
  item_bom_by_pk?: Maybe<Item_Bom>;
  /** fetch data from the table: "item_type" */
  item_type: Array<Item_Type>;
  /** fetch aggregated fields from the table: "item_type" */
  item_type_aggregate: Item_Type_Aggregate;
  /** fetch data from the table: "item_type" using primary key columns */
  item_type_by_pk?: Maybe<Item_Type>;
  /** fetch data from the table: "kbb_parts_view" */
  kbb_parts_view: Array<Kbb_Parts_View>;
  /** fetch aggregated fields from the table: "kbb_parts_view" */
  kbb_parts_view_aggregate: Kbb_Parts_View_Aggregate;
  /** fetch data from the table: "lookup_view" */
  lookup: Array<Lookup>;
  /** fetch aggregated fields from the table: "lookup_view" */
  lookup_aggregate: Lookup_Aggregate;
  /** fetch data from the table: "manufacturer" */
  manufacturer: Array<Manufacturer>;
  /** fetch aggregated fields from the table: "manufacturer" */
  manufacturer_aggregate: Manufacturer_Aggregate;
  /** fetch data from the table: "manufacturer" using primary key columns */
  manufacturer_by_pk?: Maybe<Manufacturer>;
  /** fetch data from the table: "manufacturer_parts" */
  manufacturer_parts: Array<Manufacturer_Parts>;
  /** fetch aggregated fields from the table: "manufacturer_parts" */
  manufacturer_parts_aggregate: Manufacturer_Parts_Aggregate;
  /** fetch data from the table: "manufacturer_parts" using primary key columns */
  manufacturer_parts_by_pk?: Maybe<Manufacturer_Parts>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  orderNodes: Array<OrderNode>;
  orderNodesAggregate: OrderNodeAggregateSelection;
  orderNodesCount: Scalars['Int'];
  /** fetch data from the table: "part" */
  part: Array<Part>;
  /** fetch aggregated fields from the table: "part" */
  part_aggregate: Part_Aggregate;
  /** fetch data from the table: "part" using primary key columns */
  part_by_pk?: Maybe<Part>;
  /** fetch data from the table: "part_download_view" */
  part_download_view: Array<Part_Download_View>;
  /** fetch aggregated fields from the table: "part_download_view" */
  part_download_view_aggregate: Part_Download_View_Aggregate;
  /** fetch data from the table: "part_number_history" */
  part_number_history: Array<Part_Number_History>;
  /** fetch aggregated fields from the table: "part_number_history" */
  part_number_history_aggregate: Part_Number_History_Aggregate;
  /** fetch data from the table: "part_number_history" using primary key columns */
  part_number_history_by_pk?: Maybe<Part_Number_History>;
  /** fetch data from the table: "part_number_lookup_view" */
  part_number_lookup_view: Array<Part_Number_Lookup_View>;
  /** fetch aggregated fields from the table: "part_number_lookup_view" */
  part_number_lookup_view_aggregate: Part_Number_Lookup_View_Aggregate;
  /** fetch data from the table: "part_request" */
  part_request: Array<Part_Request>;
  /** fetch aggregated fields from the table: "part_request" */
  part_request_aggregate: Part_Request_Aggregate;
  /** fetch data from the table: "part_request" using primary key columns */
  part_request_by_pk?: Maybe<Part_Request>;
  /** fetch data from the table: "part_request_cycle_time" */
  part_request_cycle_time: Array<Part_Request_Cycle_Time>;
  /** fetch aggregated fields from the table: "part_request_cycle_time" */
  part_request_cycle_time_aggregate: Part_Request_Cycle_Time_Aggregate;
  /** fetch data from the table: "part_request_reason" */
  part_request_reason: Array<Part_Request_Reason>;
  /** fetch aggregated fields from the table: "part_request_reason" */
  part_request_reason_aggregate: Part_Request_Reason_Aggregate;
  /** fetch data from the table: "part_request_reason" using primary key columns */
  part_request_reason_by_pk?: Maybe<Part_Request_Reason>;
  /** fetch data from the table: "part_request_status" */
  part_request_status: Array<Part_Request_Status>;
  /** fetch aggregated fields from the table: "part_request_status" */
  part_request_status_aggregate: Part_Request_Status_Aggregate;
  /** fetch data from the table: "part_request_status" using primary key columns */
  part_request_status_by_pk?: Maybe<Part_Request_Status>;
  /** fetch data from the table: "part_request_type" */
  part_request_type: Array<Part_Request_Type>;
  /** fetch aggregated fields from the table: "part_request_type" */
  part_request_type_aggregate: Part_Request_Type_Aggregate;
  /** fetch data from the table: "part_request_type" using primary key columns */
  part_request_type_by_pk?: Maybe<Part_Request_Type>;
  /** fetch data from the table: "part_status" */
  part_status: Array<Part_Status>;
  /** fetch aggregated fields from the table: "part_status" */
  part_status_aggregate: Part_Status_Aggregate;
  /** fetch data from the table: "part_status" using primary key columns */
  part_status_by_pk?: Maybe<Part_Status>;
  /** fetch data from the table: "part_sync" */
  part_sync: Array<Part_Sync>;
  /** fetch aggregated fields from the table: "part_sync" */
  part_sync_aggregate: Part_Sync_Aggregate;
  /** fetch data from the table: "part_sync" using primary key columns */
  part_sync_by_pk?: Maybe<Part_Sync>;
  /** fetch data from the table: "part_type" */
  part_type: Array<Part_Type>;
  /** fetch aggregated fields from the table: "part_type" */
  part_type_aggregate: Part_Type_Aggregate;
  /** fetch data from the table: "part_type" using primary key columns */
  part_type_by_pk?: Maybe<Part_Type>;
  /** fetch data from the table: "part_warehouse_detail" */
  part_warehouse_detail: Array<Part_Warehouse_Detail>;
  /** fetch aggregated fields from the table: "part_warehouse_detail" */
  part_warehouse_detail_aggregate: Part_Warehouse_Detail_Aggregate;
  /** fetch data from the table: "part_warehouse_detail" using primary key columns */
  part_warehouse_detail_by_pk?: Maybe<Part_Warehouse_Detail>;
  /** fetch data from the table: "parts_related" */
  parts_related: Array<Parts_Related>;
  /** fetch aggregated fields from the table: "parts_related" */
  parts_related_aggregate: Parts_Related_Aggregate;
  /** fetch data from the table: "parts_related" using primary key columns */
  parts_related_by_pk?: Maybe<Parts_Related>;
  /** fetch data from the table: "parts_workflow_counts_view" */
  parts_workflow_counts_view: Array<Parts_Workflow_Counts_View>;
  /** fetch aggregated fields from the table: "parts_workflow_counts_view" */
  parts_workflow_counts_view_aggregate: Parts_Workflow_Counts_View_Aggregate;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table: "phase" */
  phase: Array<Phase>;
  /** fetch aggregated fields from the table: "phase" */
  phase_aggregate: Phase_Aggregate;
  /** fetch data from the table: "phase" using primary key columns */
  phase_by_pk?: Maybe<Phase>;
  /** fetch data from the table: "platform" */
  platform: Array<Platform>;
  platformNodes: Array<PlatformNode>;
  platformNodesAggregate: PlatformNodeAggregateSelection;
  platformNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "platform" */
  platform_aggregate: Platform_Aggregate;
  /** fetch data from the table: "platform" using primary key columns */
  platform_by_pk?: Maybe<Platform>;
  /** fetch data from the table: "platform_requirement" */
  platform_requirement: Array<Platform_Requirement>;
  /** fetch aggregated fields from the table: "platform_requirement" */
  platform_requirement_aggregate: Platform_Requirement_Aggregate;
  /** fetch data from the table: "platform_requirement" using primary key columns */
  platform_requirement_by_pk?: Maybe<Platform_Requirement>;
  /** fetch data from the table: "platform_utilization_view" */
  platform_utilization_view: Array<Platform_Utilization_View>;
  /** fetch aggregated fields from the table: "platform_utilization_view" */
  platform_utilization_view_aggregate: Platform_Utilization_View_Aggregate;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  productBOMGraph: Neo4JGraphResult;
  productNodes: Array<ProductNode>;
  productNodesAggregate: ProductNodeAggregateSelection;
  productNodesCount: Scalars['Int'];
  productOptionNodes: Array<ProductOptionNode>;
  productOptionNodesAggregate: ProductOptionNodeAggregateSelection;
  productOptionNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_option" */
  product_option: Array<Product_Option>;
  /** fetch aggregated fields from the table: "product_option" */
  product_option_aggregate: Product_Option_Aggregate;
  /** fetch data from the table: "product_option" using primary key columns */
  product_option_by_pk?: Maybe<Product_Option>;
  /** fetch data from the table: "product_option_choice" */
  product_option_choice: Array<Product_Option_Choice>;
  /** fetch aggregated fields from the table: "product_option_choice" */
  product_option_choice_aggregate: Product_Option_Choice_Aggregate;
  /** fetch data from the table: "product_option_choice" using primary key columns */
  product_option_choice_by_pk?: Maybe<Product_Option_Choice>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table: "program" */
  program: Array<Program>;
  programNodes: Array<ProgramNode>;
  programNodesAggregate: ProgramNodeAggregateSelection;
  programNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "program" */
  program_aggregate: Program_Aggregate;
  /** fetch data from the table: "program" using primary key columns */
  program_by_pk?: Maybe<Program>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  projectBOM: ProjectBomResult;
  projectBOMGraph: Neo4JGraphResult;
  projectFiles?: Maybe<ProjectFilesOutput>;
  projectNodes: Array<ProjectNode>;
  projectNodesAggregate: ProjectNodeAggregateSelection;
  projectNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project_base_product_quantities" */
  project_base_product_quantities: Array<Project_Base_Product_Quantities>;
  /** fetch aggregated fields from the table: "project_base_product_quantities" */
  project_base_product_quantities_aggregate: Project_Base_Product_Quantities_Aggregate;
  /** fetch data from the table: "project_base_product_quantities" using primary key columns */
  project_base_product_quantities_by_pk?: Maybe<Project_Base_Product_Quantities>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_comment" */
  project_comment: Array<Project_Comment>;
  /** fetch aggregated fields from the table: "project_comment" */
  project_comment_aggregate: Project_Comment_Aggregate;
  /** fetch data from the table: "project_comment" using primary key columns */
  project_comment_by_pk?: Maybe<Project_Comment>;
  /** fetch data from the table: "project_contacts" */
  project_contacts: Array<Project_Contacts>;
  /** fetch aggregated fields from the table: "project_contacts" */
  project_contacts_aggregate: Project_Contacts_Aggregate;
  /** fetch data from the table: "project_contacts" using primary key columns */
  project_contacts_by_pk?: Maybe<Project_Contacts>;
  /** fetch data from the table: "project_milestone" */
  project_milestone: Array<Project_Milestone>;
  /** fetch aggregated fields from the table: "project_milestone" */
  project_milestone_aggregate: Project_Milestone_Aggregate;
  /** fetch data from the table: "project_milestone" using primary key columns */
  project_milestone_by_pk?: Maybe<Project_Milestone>;
  /** fetch data from the table: "project_module" */
  project_module: Array<Project_Module>;
  /** fetch aggregated fields from the table: "project_module" */
  project_module_aggregate: Project_Module_Aggregate;
  /** fetch data from the table: "project_module" using primary key columns */
  project_module_by_pk?: Maybe<Project_Module>;
  /** fetch data from the table: "project_status" */
  project_status: Array<Project_Status>;
  /** fetch aggregated fields from the table: "project_status" */
  project_status_aggregate: Project_Status_Aggregate;
  /** fetch data from the table: "project_status" using primary key columns */
  project_status_by_pk?: Maybe<Project_Status>;
  /** fetch data from the table: "project_users" */
  project_users: Array<Project_Users>;
  /** fetch aggregated fields from the table: "project_users" */
  project_users_aggregate: Project_Users_Aggregate;
  /** fetch data from the table: "project_users" using primary key columns */
  project_users_by_pk?: Maybe<Project_Users>;
  /** fetch data from the table: "purchase_type" */
  purchase_type: Array<Purchase_Type>;
  /** fetch aggregated fields from the table: "purchase_type" */
  purchase_type_aggregate: Purchase_Type_Aggregate;
  /** fetch data from the table: "purchase_type" using primary key columns */
  purchase_type_by_pk?: Maybe<Purchase_Type>;
  /** fetch data from the table: "qb_items" */
  qb_items: Array<Qb_Items>;
  /** fetch aggregated fields from the table: "qb_items" */
  qb_items_aggregate: Qb_Items_Aggregate;
  /** fetch data from the table: "qb_items" using primary key columns */
  qb_items_by_pk?: Maybe<Qb_Items>;
  /** fetch data from the table: "relation_type" */
  relation_type: Array<Relation_Type>;
  /** fetch aggregated fields from the table: "relation_type" */
  relation_type_aggregate: Relation_Type_Aggregate;
  /** fetch data from the table: "relation_type" using primary key columns */
  relation_type_by_pk?: Maybe<Relation_Type>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<Report>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** fetch data from the table: "scope_part_conversion_view" */
  scope_part_conversion_view: Array<Scope_Part_Conversion_View>;
  /** fetch aggregated fields from the table: "scope_part_conversion_view" */
  scope_part_conversion_view_aggregate: Scope_Part_Conversion_View_Aggregate;
  /** fetch data from the table: "search_parts_view" */
  search_parts_view: Array<Search_Parts_View>;
  /** fetch aggregated fields from the table: "search_parts_view" */
  search_parts_view_aggregate: Search_Parts_View_Aggregate;
  /** fetch data from the table: "serial_numbers" */
  serial_numbers: Array<Serial_Numbers>;
  /** fetch aggregated fields from the table: "serial_numbers" */
  serial_numbers_aggregate: Serial_Numbers_Aggregate;
  /** fetch data from the table: "serial_numbers" using primary key columns */
  serial_numbers_by_pk?: Maybe<Serial_Numbers>;
  /** fetch data from the table: "short_url" */
  short_url: Array<Short_Url>;
  /** fetch aggregated fields from the table: "short_url" */
  short_url_aggregate: Short_Url_Aggregate;
  /** fetch data from the table: "short_url" using primary key columns */
  short_url_by_pk?: Maybe<Short_Url>;
  /** fetch data from the table: "system_event" */
  system_event: Array<System_Event>;
  /** fetch aggregated fields from the table: "system_event" */
  system_event_aggregate: System_Event_Aggregate;
  /** fetch data from the table: "system_event" using primary key columns */
  system_event_by_pk?: Maybe<System_Event>;
  tagPartSearch?: Maybe<TagPartSearchResult>;
  /** fetch data from the table: "tag_entity" */
  tag_entity: Array<Tag_Entity>;
  /** fetch aggregated fields from the table: "tag_entity" */
  tag_entity_aggregate: Tag_Entity_Aggregate;
  /** fetch data from the table: "tag_entity" using primary key columns */
  tag_entity_by_pk?: Maybe<Tag_Entity>;
  /** fetch data from the table: "tag_path" */
  tag_path: Array<Tag_Path>;
  /** fetch aggregated fields from the table: "tag_path" */
  tag_path_aggregate: Tag_Path_Aggregate;
  /** fetch data from the table: "tag_path" using primary key columns */
  tag_path_by_pk?: Maybe<Tag_Path>;
  /** fetch data from the table: "tag_path_segment_view" */
  tag_path_segment_view: Array<Tag_Path_Segment_View>;
  /** fetch aggregated fields from the table: "tag_path_segment_view" */
  tag_path_segment_view_aggregate: Tag_Path_Segment_View_Aggregate;
  /** fetch data from the table: "tag_set" */
  tag_set: Array<Tag_Set>;
  /** fetch aggregated fields from the table: "tag_set" */
  tag_set_aggregate: Tag_Set_Aggregate;
  /** fetch data from the table: "tag_set" using primary key columns */
  tag_set_by_pk?: Maybe<Tag_Set>;
  /** fetch data from the table: "tag_type" */
  tag_type: Array<Tag_Type>;
  /** fetch aggregated fields from the table: "tag_type" */
  tag_type_aggregate: Tag_Type_Aggregate;
  /** fetch data from the table: "tag_type" using primary key columns */
  tag_type_by_pk?: Maybe<Tag_Type>;
  taggedBom: TagPathResult;
  /** fetch data from the table: "tagged_part_download_view" */
  tagged_part_download_view: Array<Tagged_Part_Download_View>;
  /** fetch aggregated fields from the table: "tagged_part_download_view" */
  tagged_part_download_view_aggregate: Tagged_Part_Download_View_Aggregate;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table: "toimport_view" */
  toimport_view: Array<Toimport_View>;
  /** fetch aggregated fields from the table: "toimport_view" */
  toimport_view_aggregate: Toimport_View_Aggregate;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  unitBOM: UnitBomResult;
  unitBOMGraph: Neo4JGraphResult;
  unitNodes: Array<UnitNode>;
  unitNodesAggregate: UnitNodeAggregateSelection;
  unitNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit_bom_entity_view" */
  unit_bom_entity_view: Array<Unit_Bom_Entity_View>;
  /** fetch aggregated fields from the table: "unit_bom_entity_view" */
  unit_bom_entity_view_aggregate: Unit_Bom_Entity_View_Aggregate;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "unit_product_option_choice" */
  unit_product_option_choice: Array<Unit_Product_Option_Choice>;
  /** fetch aggregated fields from the table: "unit_product_option_choice" */
  unit_product_option_choice_aggregate: Unit_Product_Option_Choice_Aggregate;
  /** fetch data from the table: "unit_product_option_choice" using primary key columns */
  unit_product_option_choice_by_pk?: Maybe<Unit_Product_Option_Choice>;
  /** fetch data from the table: "unit_tag_path_view" */
  unit_tag_path_view: Array<Unit_Tag_Path_View>;
  /** fetch aggregated fields from the table: "unit_tag_path_view" */
  unit_tag_path_view_aggregate: Unit_Tag_Path_View_Aggregate;
  /** fetch data from the table: "unit_tag_view" */
  unit_tag_view: Array<Unit_Tag_View>;
  /** fetch aggregated fields from the table: "unit_tag_view" */
  unit_tag_view_aggregate: Unit_Tag_View_Aggregate;
  /** fetch data from the table: "uom" */
  uom: Array<Uom>;
  uomNodes: Array<UomNode>;
  uomNodesAggregate: UomNodeAggregateSelection;
  uomNodesCount: Scalars['Int'];
  uomScopeNodes: Array<UomScopeNode>;
  uomScopeNodesAggregate: UomScopeNodeAggregateSelection;
  uomScopeNodesCount: Scalars['Int'];
  uomSupplierNodes: Array<UomSupplierNode>;
  uomSupplierNodesAggregate: UomSupplierNodeAggregateSelection;
  uomSupplierNodesCount: Scalars['Int'];
  /** fetch aggregated fields from the table: "uom" */
  uom_aggregate: Uom_Aggregate;
  /** fetch data from the table: "uom" using primary key columns */
  uom_by_pk?: Maybe<Uom>;
  /** fetch data from the table: "uom_classification" */
  uom_classification: Array<Uom_Classification>;
  /** fetch aggregated fields from the table: "uom_classification" */
  uom_classification_aggregate: Uom_Classification_Aggregate;
  /** fetch data from the table: "uom_classification" using primary key columns */
  uom_classification_by_pk?: Maybe<Uom_Classification>;
  /** fetch data from the table: "uom_conversion" */
  uom_conversion: Array<Uom_Conversion>;
  /** fetch aggregated fields from the table: "uom_conversion" */
  uom_conversion_aggregate: Uom_Conversion_Aggregate;
  /** fetch data from the table: "uom_conversion" using primary key columns */
  uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** fetch data from the table: "uom_csi_conversion" */
  uom_csi_conversion: Array<Uom_Csi_Conversion>;
  /** fetch aggregated fields from the table: "uom_csi_conversion" */
  uom_csi_conversion_aggregate: Uom_Csi_Conversion_Aggregate;
  /** fetch data from the table: "uom_csi_conversion" using primary key columns */
  uom_csi_conversion_by_pk?: Maybe<Uom_Csi_Conversion>;
  /** fetch data from the table: "uom_scope" */
  uom_scope: Array<Uom_Scope>;
  /** fetch aggregated fields from the table: "uom_scope" */
  uom_scope_aggregate: Uom_Scope_Aggregate;
  /** fetch data from the table: "uom_scope" using primary key columns */
  uom_scope_by_pk?: Maybe<Uom_Scope>;
  /** fetch data from the table: "uom_scope_part" */
  uom_scope_part: Array<Uom_Scope_Part>;
  /** fetch aggregated fields from the table: "uom_scope_part" */
  uom_scope_part_aggregate: Uom_Scope_Part_Aggregate;
  /** fetch data from the table: "uom_scope_part" using primary key columns */
  uom_scope_part_by_pk?: Maybe<Uom_Scope_Part>;
  /** fetch data from the table: "uom_system_conversion" */
  uom_system_conversion: Array<Uom_System_Conversion>;
  /** fetch aggregated fields from the table: "uom_system_conversion" */
  uom_system_conversion_aggregate: Uom_System_Conversion_Aggregate;
  /** fetch data from the table: "uom_system_conversion" using primary key columns */
  uom_system_conversion_by_pk?: Maybe<Uom_System_Conversion>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_info" */
  user_info: Array<User_Info>;
  /** fetch aggregated fields from the table: "user_info" */
  user_info_aggregate: User_Info_Aggregate;
  /** An array relationship */
  user_permissions: Array<User_Permissions>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permissions_Aggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  user_permissions_by_pk?: Maybe<User_Permissions>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table: "vendor" */
  vendor: Array<Vendor>;
  /** fetch aggregated fields from the table: "vendor" */
  vendor_aggregate: Vendor_Aggregate;
  /** fetch data from the table: "vendor" using primary key columns */
  vendor_by_pk?: Maybe<Vendor>;
  /** fetch data from the table: "vendor_cleanup_audit" */
  vendor_cleanup_audit: Array<Vendor_Cleanup_Audit>;
  /** fetch aggregated fields from the table: "vendor_cleanup_audit" */
  vendor_cleanup_audit_aggregate: Vendor_Cleanup_Audit_Aggregate;
  /** fetch data from the table: "vendor_cleanup_audit" using primary key columns */
  vendor_cleanup_audit_by_pk?: Maybe<Vendor_Cleanup_Audit>;
  /** fetch data from the table: "vendor_cleanup_wevr_mapping_lookup" */
  vendor_cleanup_wevr_mapping_lookup: Array<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** fetch aggregated fields from the table: "vendor_cleanup_wevr_mapping_lookup" */
  vendor_cleanup_wevr_mapping_lookup_aggregate: Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate;
  /** fetch data from the table: "vendor_cleanup_wevr_mapping_lookup" using primary key columns */
  vendor_cleanup_wevr_mapping_lookup_by_pk?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** fetch data from the table: "vendor_parts" */
  vendor_parts: Array<Vendor_Parts>;
  /** fetch aggregated fields from the table: "vendor_parts" */
  vendor_parts_aggregate: Vendor_Parts_Aggregate;
  /** fetch data from the table: "vendor_parts" using primary key columns */
  vendor_parts_by_pk?: Maybe<Vendor_Parts>;
  /** fetch data from the table: "workflow" */
  workflow: Array<Workflow>;
  /** fetch aggregated fields from the table: "workflow" */
  workflow_aggregate: Workflow_Aggregate;
  /** fetch data from the table: "workflow" using primary key columns */
  workflow_by_pk?: Maybe<Workflow>;
};


export type Query_RootBomIndexListArgs = {
  criteria: BomIndexCriteria;
};


export type Query_RootBomVersionArgs = {
  criteria: BomQueryCriteria;
};


export type Query_RootItemTagArgs = {
  id: Scalars['Int'];
};


export type Query_RootQueryResultsArgs = {
  SearchCriteria?: InputMaybe<TaggedCriteria>;
};


export type Query_RootTagArgs = {
  id: Scalars['Int'];
};


export type Query_RootTagTypeArgs = {
  name: Scalars['String'];
};


export type Query_RootAll_Boms_ViewArgs = {
  distinct_on?: InputMaybe<Array<All_Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<All_Boms_View_Order_By>>;
  where?: InputMaybe<All_Boms_View_Bool_Exp>;
};


export type Query_RootAll_Boms_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<All_Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<All_Boms_View_Order_By>>;
  where?: InputMaybe<All_Boms_View_Bool_Exp>;
};


export type Query_RootBase_ProductArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


export type Query_RootBase_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


export type Query_RootBase_Product_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootBom_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


export type Query_RootBom_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


export type Query_RootBom_Detail_By_PkArgs = {
  partId: Scalars['String'];
  productId: Scalars['String'];
};


export type Query_RootBom_Item_Tag_SetArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


export type Query_RootBom_Item_Tag_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


export type Query_RootBom_Item_Tag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBoms_ViewArgs = {
  distinct_on?: InputMaybe<Array<Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boms_View_Order_By>>;
  where?: InputMaybe<Boms_View_Bool_Exp>;
};


export type Query_RootBoms_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boms_View_Order_By>>;
  where?: InputMaybe<Boms_View_Bool_Exp>;
};


export type Query_RootChoiceNodesArgs = {
  options?: InputMaybe<ChoiceNodeOptions>;
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type Query_RootChoiceNodesAggregateArgs = {
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type Query_RootChoiceNodesCountArgs = {
  where?: InputMaybe<ChoiceNodeWhere>;
};


export type Query_RootConsumable_Bom_DetailArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


export type Query_RootConsumable_Bom_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


export type Query_RootConsumable_Bom_Detail_By_PkArgs = {
  baseProductId: Scalars['String'];
  partId: Scalars['String'];
};


export type Query_RootCountersArgs = {
  distinct_on?: InputMaybe<Array<Counters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Counters_Order_By>>;
  where?: InputMaybe<Counters_Bool_Exp>;
};


export type Query_RootCounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Counters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Counters_Order_By>>;
  where?: InputMaybe<Counters_Bool_Exp>;
};


export type Query_RootCounters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCsiArgs = {
  distinct_on?: InputMaybe<Array<Csi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Csi_Order_By>>;
  where?: InputMaybe<Csi_Bool_Exp>;
};


export type Query_RootCsiNodesArgs = {
  options?: InputMaybe<CsiNodeOptions>;
  where?: InputMaybe<CsiNodeWhere>;
};


export type Query_RootCsiNodesAggregateArgs = {
  where?: InputMaybe<CsiNodeWhere>;
};


export type Query_RootCsiNodesCountArgs = {
  where?: InputMaybe<CsiNodeWhere>;
};


export type Query_RootCsi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Csi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Csi_Order_By>>;
  where?: InputMaybe<Csi_Bool_Exp>;
};


export type Query_RootCsi_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomerNodesArgs = {
  options?: InputMaybe<CustomerNodeOptions>;
  where?: InputMaybe<CustomerNodeWhere>;
};


export type Query_RootCustomerNodesAggregateArgs = {
  where?: InputMaybe<CustomerNodeWhere>;
};


export type Query_RootCustomerNodesCountArgs = {
  where?: InputMaybe<CustomerNodeWhere>;
};


export type Query_RootCustomer_AdminArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


export type Query_RootCustomer_Admin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


export type Query_RootCustomer_Admin_By_PkArgs = {
  customerId: Scalars['String'];
  userId: Scalars['String'];
};


export type Query_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomer_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Query_RootEmail_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Query_RootEmail_Templates_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Query_RootFeedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvitationArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Query_RootInvitation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Query_RootIssue_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIssue_StatusArgs = {
  distinct_on?: InputMaybe<Array<Issue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Status_Order_By>>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};


export type Query_RootIssue_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Status_Order_By>>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};


export type Query_RootIssue_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootItemNodesArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type Query_RootItemNodesAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type Query_RootItemNodesCountArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type Query_RootItem_BomArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


export type Query_RootItem_Bom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


export type Query_RootItem_Bom_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootItem_TypeArgs = {
  distinct_on?: InputMaybe<Array<Item_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Type_Order_By>>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};


export type Query_RootItem_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Type_Order_By>>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};


export type Query_RootItem_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootKbb_Parts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Kbb_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kbb_Parts_View_Order_By>>;
  where?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
};


export type Query_RootKbb_Parts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kbb_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kbb_Parts_View_Order_By>>;
  where?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
};


export type Query_RootLookupArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lookup_Order_By>>;
  where?: InputMaybe<Lookup_Bool_Exp>;
};


export type Query_RootLookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lookup_Order_By>>;
  where?: InputMaybe<Lookup_Bool_Exp>;
};


export type Query_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Query_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Query_RootManufacturer_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootManufacturer_PartsArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


export type Query_RootManufacturer_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


export type Query_RootManufacturer_Parts_By_PkArgs = {
  manufacturerId: Scalars['String'];
  partId: Scalars['String'];
};


export type Query_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Query_RootOrderNodesArgs = {
  options?: InputMaybe<OrderNodeOptions>;
  where?: InputMaybe<OrderNodeWhere>;
};


export type Query_RootOrderNodesAggregateArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type Query_RootOrderNodesCountArgs = {
  where?: InputMaybe<OrderNodeWhere>;
};


export type Query_RootPartArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


export type Query_RootPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


export type Query_RootPart_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPart_Download_ViewArgs = {
  distinct_on?: InputMaybe<Array<Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Download_View_Order_By>>;
  where?: InputMaybe<Part_Download_View_Bool_Exp>;
};


export type Query_RootPart_Download_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Download_View_Order_By>>;
  where?: InputMaybe<Part_Download_View_Bool_Exp>;
};


export type Query_RootPart_Number_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


export type Query_RootPart_Number_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


export type Query_RootPart_Number_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPart_Number_Lookup_ViewArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_Lookup_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_Lookup_View_Order_By>>;
  where?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
};


export type Query_RootPart_Number_Lookup_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_Lookup_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_Lookup_View_Order_By>>;
  where?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
};


export type Query_RootPart_RequestArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


export type Query_RootPart_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


export type Query_RootPart_Request_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPart_Request_Cycle_TimeArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Cycle_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Cycle_Time_Order_By>>;
  where?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
};


export type Query_RootPart_Request_Cycle_Time_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Cycle_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Cycle_Time_Order_By>>;
  where?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
};


export type Query_RootPart_Request_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Reason_Order_By>>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};


export type Query_RootPart_Request_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Reason_Order_By>>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};


export type Query_RootPart_Request_Reason_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPart_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Status_Order_By>>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};


export type Query_RootPart_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Status_Order_By>>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};


export type Query_RootPart_Request_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPart_Request_TypeArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Type_Order_By>>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};


export type Query_RootPart_Request_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Type_Order_By>>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};


export type Query_RootPart_Request_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPart_StatusArgs = {
  distinct_on?: InputMaybe<Array<Part_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Status_Order_By>>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};


export type Query_RootPart_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Status_Order_By>>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};


export type Query_RootPart_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPart_SyncArgs = {
  distinct_on?: InputMaybe<Array<Part_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Sync_Order_By>>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};


export type Query_RootPart_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Sync_Order_By>>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};


export type Query_RootPart_Sync_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPart_TypeArgs = {
  distinct_on?: InputMaybe<Array<Part_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Type_Order_By>>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};


export type Query_RootPart_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Type_Order_By>>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};


export type Query_RootPart_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootPart_Warehouse_DetailArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


export type Query_RootPart_Warehouse_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


export type Query_RootPart_Warehouse_Detail_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootParts_RelatedArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


export type Query_RootParts_Related_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


export type Query_RootParts_Related_By_PkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type Query_RootParts_Workflow_Counts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Parts_Workflow_Counts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Workflow_Counts_View_Order_By>>;
  where?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
};


export type Query_RootParts_Workflow_Counts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Workflow_Counts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Workflow_Counts_View_Order_By>>;
  where?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
};


export type Query_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Query_RootPermissions_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPhaseArgs = {
  distinct_on?: InputMaybe<Array<Phase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phase_Order_By>>;
  where?: InputMaybe<Phase_Bool_Exp>;
};


export type Query_RootPhase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phase_Order_By>>;
  where?: InputMaybe<Phase_Bool_Exp>;
};


export type Query_RootPhase_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Query_RootPlatformNodesArgs = {
  options?: InputMaybe<PlatformNodeOptions>;
  where?: InputMaybe<PlatformNodeWhere>;
};


export type Query_RootPlatformNodesAggregateArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type Query_RootPlatformNodesCountArgs = {
  where?: InputMaybe<PlatformNodeWhere>;
};


export type Query_RootPlatform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Query_RootPlatform_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPlatform_RequirementArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


export type Query_RootPlatform_Requirement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


export type Query_RootPlatform_Requirement_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPlatform_Utilization_ViewArgs = {
  distinct_on?: InputMaybe<Array<Platform_Utilization_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Utilization_View_Order_By>>;
  where?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
};


export type Query_RootPlatform_Utilization_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Utilization_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Utilization_View_Order_By>>;
  where?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProductBomGraphArgs = {
  id: Scalars['String'];
};


export type Query_RootProductNodesArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type Query_RootProductNodesAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type Query_RootProductNodesCountArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type Query_RootProductOptionNodesArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type Query_RootProductOptionNodesAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type Query_RootProductOptionNodesCountArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProduct_OptionArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


export type Query_RootProduct_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


export type Query_RootProduct_Option_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProduct_Option_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


export type Query_RootProduct_Option_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


export type Query_RootProduct_Option_Choice_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Query_RootProduct_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootProgramArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


export type Query_RootProgramNodesArgs = {
  options?: InputMaybe<ProgramNodeOptions>;
  where?: InputMaybe<ProgramNodeWhere>;
};


export type Query_RootProgramNodesAggregateArgs = {
  where?: InputMaybe<ProgramNodeWhere>;
};


export type Query_RootProgramNodesCountArgs = {
  where?: InputMaybe<ProgramNodeWhere>;
};


export type Query_RootProgram_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


export type Query_RootProgram_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProjectBomArgs = {
  id: Scalars['String'];
};


export type Query_RootProjectBomGraphArgs = {
  id: Scalars['String'];
};


export type Query_RootProjectFilesArgs = {
  jobNumber: Scalars['String'];
  versions?: InputMaybe<Scalars['Boolean']>;
};


export type Query_RootProjectNodesArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type Query_RootProjectNodesAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type Query_RootProjectNodesCountArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type Query_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Query_RootProject_Base_Product_QuantitiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


export type Query_RootProject_Base_Product_Quantities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


export type Query_RootProject_Base_Product_Quantities_By_PkArgs = {
  base_product_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type Query_RootProject_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProject_CommentArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Query_RootProject_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Query_RootProject_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


export type Query_RootProject_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


export type Query_RootProject_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


export type Query_RootProject_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


export type Query_RootProject_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


export type Query_RootProject_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


export type Query_RootProject_Module_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootProject_StatusArgs = {
  distinct_on?: InputMaybe<Array<Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Status_Order_By>>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};


export type Query_RootProject_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Status_Order_By>>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};


export type Query_RootProject_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProject_UsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Query_RootProject_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Query_RootProject_Users_By_PkArgs = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type Query_RootPurchase_TypeArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Type_Order_By>>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};


export type Query_RootPurchase_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Type_Order_By>>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};


export type Query_RootPurchase_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootQb_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Qb_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Qb_Items_Order_By>>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};


export type Query_RootQb_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qb_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Qb_Items_Order_By>>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};


export type Query_RootQb_Items_By_PkArgs = {
  item: Scalars['String'];
};


export type Query_RootRelation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Relation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relation_Type_Order_By>>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};


export type Query_RootRelation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relation_Type_Order_By>>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};


export type Query_RootRelation_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Query_RootRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Query_RootRole_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  roleId: Scalars['String'];
};


export type Query_RootScope_Part_Conversion_ViewArgs = {
  distinct_on?: InputMaybe<Array<Scope_Part_Conversion_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scope_Part_Conversion_View_Order_By>>;
  where?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
};


export type Query_RootScope_Part_Conversion_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scope_Part_Conversion_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scope_Part_Conversion_View_Order_By>>;
  where?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
};


export type Query_RootSearch_Parts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Search_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Parts_View_Order_By>>;
  where?: InputMaybe<Search_Parts_View_Bool_Exp>;
};


export type Query_RootSearch_Parts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Parts_View_Order_By>>;
  where?: InputMaybe<Search_Parts_View_Bool_Exp>;
};


export type Query_RootSerial_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Serial_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Serial_Numbers_Order_By>>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};


export type Query_RootSerial_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Serial_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Serial_Numbers_Order_By>>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};


export type Query_RootSerial_Numbers_By_PkArgs = {
  base_product_id: Scalars['String'];
};


export type Query_RootShort_UrlArgs = {
  distinct_on?: InputMaybe<Array<Short_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Short_Url_Order_By>>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};


export type Query_RootShort_Url_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Short_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Short_Url_Order_By>>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};


export type Query_RootShort_Url_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSystem_EventArgs = {
  distinct_on?: InputMaybe<Array<System_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<System_Event_Order_By>>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};


export type Query_RootSystem_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<System_Event_Order_By>>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};


export type Query_RootSystem_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTagPartSearchArgs = {
  criteria?: InputMaybe<TagPartSearchInput>;
};


export type Query_RootTag_EntityArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


export type Query_RootTag_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


export type Query_RootTag_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTag_PathArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Order_By>>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};


export type Query_RootTag_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Order_By>>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};


export type Query_RootTag_Path_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTag_Path_Segment_ViewArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


export type Query_RootTag_Path_Segment_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


export type Query_RootTag_SetArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


export type Query_RootTag_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


export type Query_RootTag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTag_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Query_RootTag_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Query_RootTag_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTaggedBomArgs = {
  SearchCriteria?: InputMaybe<TagPathCriteria>;
};


export type Query_RootTagged_Part_Download_ViewArgs = {
  distinct_on?: InputMaybe<Array<Tagged_Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tagged_Part_Download_View_Order_By>>;
  where?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
};


export type Query_RootTagged_Part_Download_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tagged_Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tagged_Part_Download_View_Order_By>>;
  where?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
};


export type Query_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Query_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootToimport_ViewArgs = {
  distinct_on?: InputMaybe<Array<Toimport_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Toimport_View_Order_By>>;
  where?: InputMaybe<Toimport_View_Bool_Exp>;
};


export type Query_RootToimport_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Toimport_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Toimport_View_Order_By>>;
  where?: InputMaybe<Toimport_View_Bool_Exp>;
};


export type Query_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnitBomArgs = {
  id: Scalars['String'];
};


export type Query_RootUnitBomGraphArgs = {
  id: Scalars['String'];
};


export type Query_RootUnitNodesArgs = {
  options?: InputMaybe<UnitNodeOptions>;
  where?: InputMaybe<UnitNodeWhere>;
};


export type Query_RootUnitNodesAggregateArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type Query_RootUnitNodesCountArgs = {
  where?: InputMaybe<UnitNodeWhere>;
};


export type Query_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Query_RootUnit_Bom_Entity_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


export type Query_RootUnit_Bom_Entity_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


export type Query_RootUnit_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUnit_Product_Option_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


export type Query_RootUnit_Product_Option_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


export type Query_RootUnit_Product_Option_Choice_By_PkArgs = {
  product_option_choice_id: Scalars['String'];
  unit_id: Scalars['String'];
};


export type Query_RootUnit_Tag_Path_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_Path_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_Path_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
};


export type Query_RootUnit_Tag_Path_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_Path_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_Path_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
};


export type Query_RootUnit_Tag_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


export type Query_RootUnit_Tag_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


export type Query_RootUomArgs = {
  distinct_on?: InputMaybe<Array<Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Order_By>>;
  where?: InputMaybe<Uom_Bool_Exp>;
};


export type Query_RootUomNodesArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type Query_RootUomNodesAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type Query_RootUomNodesCountArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type Query_RootUomScopeNodesArgs = {
  options?: InputMaybe<UomScopeNodeOptions>;
  where?: InputMaybe<UomScopeNodeWhere>;
};


export type Query_RootUomScopeNodesAggregateArgs = {
  where?: InputMaybe<UomScopeNodeWhere>;
};


export type Query_RootUomScopeNodesCountArgs = {
  where?: InputMaybe<UomScopeNodeWhere>;
};


export type Query_RootUomSupplierNodesArgs = {
  options?: InputMaybe<UomSupplierNodeOptions>;
  where?: InputMaybe<UomSupplierNodeWhere>;
};


export type Query_RootUomSupplierNodesAggregateArgs = {
  where?: InputMaybe<UomSupplierNodeWhere>;
};


export type Query_RootUomSupplierNodesCountArgs = {
  where?: InputMaybe<UomSupplierNodeWhere>;
};


export type Query_RootUom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Order_By>>;
  where?: InputMaybe<Uom_Bool_Exp>;
};


export type Query_RootUom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUom_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Uom_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Classification_Order_By>>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};


export type Query_RootUom_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Classification_Order_By>>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};


export type Query_RootUom_Classification_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUom_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Query_RootUom_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Query_RootUom_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUom_Csi_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


export type Query_RootUom_Csi_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


export type Query_RootUom_Csi_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUom_ScopeArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Order_By>>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};


export type Query_RootUom_Scope_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Order_By>>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};


export type Query_RootUom_Scope_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUom_Scope_PartArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


export type Query_RootUom_Scope_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


export type Query_RootUom_Scope_Part_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUom_System_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


export type Query_RootUom_System_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


export type Query_RootUom_System_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_InfoArgs = {
  distinct_on?: InputMaybe<Array<User_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Info_Order_By>>;
  where?: InputMaybe<User_Info_Bool_Exp>;
};


export type Query_RootUser_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Info_Order_By>>;
  where?: InputMaybe<User_Info_Bool_Exp>;
};


export type Query_RootUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Query_RootUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Query_RootUser_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  userId: Scalars['String'];
};


export type Query_RootUser_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Query_RootUser_Role_By_PkArgs = {
  roleId: Scalars['String'];
  userId: Scalars['String'];
};


export type Query_RootVendorArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Order_By>>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};


export type Query_RootVendor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Order_By>>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};


export type Query_RootVendor_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootVendor_Cleanup_AuditArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Audit_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};


export type Query_RootVendor_Cleanup_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Audit_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};


export type Query_RootVendor_Cleanup_Audit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootVendor_Cleanup_Wevr_Mapping_LookupArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};


export type Query_RootVendor_Cleanup_Wevr_Mapping_Lookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};


export type Query_RootVendor_Cleanup_Wevr_Mapping_Lookup_By_PkArgs = {
  matapp_vendor_id: Scalars['String'];
};


export type Query_RootVendor_PartsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


export type Query_RootVendor_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


export type Query_RootVendor_Parts_By_PkArgs = {
  partId: Scalars['String'];
  vendorId: Scalars['String'];
};


export type Query_RootWorkflowArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Query_RootWorkflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Query_RootWorkflow_By_PkArgs = {
  id: Scalars['Int'];
};

/** columns and relationships of "relation_type" */
export type Relation_Type = {
  __typename?: 'relation_type';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

/** aggregated selection of "relation_type" */
export type Relation_Type_Aggregate = {
  __typename?: 'relation_type_aggregate';
  aggregate?: Maybe<Relation_Type_Aggregate_Fields>;
  nodes: Array<Relation_Type>;
};

/** aggregate fields of "relation_type" */
export type Relation_Type_Aggregate_Fields = {
  __typename?: 'relation_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Relation_Type_Max_Fields>;
  min?: Maybe<Relation_Type_Min_Fields>;
};


/** aggregate fields of "relation_type" */
export type Relation_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Relation_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "relation_type". All fields are combined with a logical 'AND'. */
export type Relation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Relation_Type_Bool_Exp>>;
  _not?: InputMaybe<Relation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Relation_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "relation_type" */
export type Relation_Type_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'relation_type_pkey';

/** input type for inserting data into table "relation_type" */
export type Relation_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Relation_Type_Max_Fields = {
  __typename?: 'relation_type_max_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Relation_Type_Min_Fields = {
  __typename?: 'relation_type_min_fields';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "relation_type" */
export type Relation_Type_Mutation_Response = {
  __typename?: 'relation_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Relation_Type>;
};

/** on_conflict condition type for table "relation_type" */
export type Relation_Type_On_Conflict = {
  constraint: Relation_Type_Constraint;
  update_columns?: Array<Relation_Type_Update_Column>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "relation_type". */
export type Relation_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relation_type */
export type Relation_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "relation_type" */
export type Relation_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'name';

/** input type for updating data in table "relation_type" */
export type Relation_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "relation_type" */
export type Relation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Relation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Relation_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "relation_type" */
export type Relation_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'name';

export type Relation_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Relation_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Relation_Type_Bool_Exp;
};

/** columns and relationships of "report" */
export type Report = {
  __typename?: 'report';
  embed_url: Scalars['String'];
  id: Scalars['String'];
  meta?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  permission?: Maybe<Scalars['String']>;
};


/** columns and relationships of "report" */
export type ReportMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "report" */
export type Report_Aggregate = {
  __typename?: 'report_aggregate';
  aggregate?: Maybe<Report_Aggregate_Fields>;
  nodes: Array<Report>;
};

/** aggregate fields of "report" */
export type Report_Aggregate_Fields = {
  __typename?: 'report_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Report_Max_Fields>;
  min?: Maybe<Report_Min_Fields>;
};


/** aggregate fields of "report" */
export type Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Report_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "report". All fields are combined with a logical 'AND'. */
export type Report_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Bool_Exp>>;
  _not?: InputMaybe<Report_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Bool_Exp>>;
  embed_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  permission?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "report" */
export type Report_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'report_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Report_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Report_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Report_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "report" */
export type Report_Insert_Input = {
  embed_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Report_Max_Fields = {
  __typename?: 'report_max_fields';
  embed_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Report_Min_Fields = {
  __typename?: 'report_min_fields';
  embed_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "report" */
export type Report_Mutation_Response = {
  __typename?: 'report_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Report>;
};

/** on_conflict condition type for table "report" */
export type Report_On_Conflict = {
  constraint: Report_Constraint;
  update_columns?: Array<Report_Update_Column>;
  where?: InputMaybe<Report_Bool_Exp>;
};

/** Ordering options when selecting data from "report". */
export type Report_Order_By = {
  embed_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  permission?: InputMaybe<Order_By>;
};

/** primary key columns input for table: report */
export type Report_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Report_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "report" */
export type Report_Select_Column =
  /** column name */
  | 'embed_url'
  /** column name */
  | 'id'
  /** column name */
  | 'meta'
  /** column name */
  | 'name'
  /** column name */
  | 'permission';

/** input type for updating data in table "report" */
export type Report_Set_Input = {
  embed_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report" */
export type Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Stream_Cursor_Value_Input = {
  embed_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['String']>;
};

/** update columns of table "report" */
export type Report_Update_Column =
  /** column name */
  | 'embed_url'
  /** column name */
  | 'id'
  /** column name */
  | 'meta'
  /** column name */
  | 'name'
  /** column name */
  | 'permission';

export type Report_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Report_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Report_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Report_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Report_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Report_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Report_Set_Input>;
  /** filter the rows which have to be updated */
  where: Report_Bool_Exp;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  applicationId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** An array relationship */
  roles: Array<User_Role>;
  /** An aggregate relationship */
  roles_aggregate: User_Role_Aggregate;
};


/** columns and relationships of "role" */
export type RoleRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  applicationId?: InputMaybe<String_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  role_permissions?: InputMaybe<Role_Permissions_Bool_Exp>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp>;
  roles?: InputMaybe<User_Role_Bool_Exp>;
  roles_aggregate?: InputMaybe<User_Role_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "role" */
export type Role_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'role_pkey';

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  applicationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role_permissions?: InputMaybe<Role_Permissions_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<User_Role_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  applicationId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  applicationId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  applicationId?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  role_permissions_aggregate?: InputMaybe<Role_Permissions_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<User_Role_Aggregate_Order_By>;
};

/** columns and relationships of "role_permissions" */
export type Role_Permissions = {
  __typename?: 'role_permissions';
  /** An object relationship */
  permission: Permissions;
  permissionId: Scalars['String'];
  /** An object relationship */
  role: Role;
  roleId: Scalars['String'];
};

/** aggregated selection of "role_permissions" */
export type Role_Permissions_Aggregate = {
  __typename?: 'role_permissions_aggregate';
  aggregate?: Maybe<Role_Permissions_Aggregate_Fields>;
  nodes: Array<Role_Permissions>;
};

export type Role_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Role_Permissions_Aggregate_Bool_Exp_Count>;
};

export type Role_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Role_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "role_permissions" */
export type Role_Permissions_Aggregate_Fields = {
  __typename?: 'role_permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Role_Permissions_Max_Fields>;
  min?: Maybe<Role_Permissions_Min_Fields>;
};


/** aggregate fields of "role_permissions" */
export type Role_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "role_permissions" */
export type Role_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Role_Permissions_Max_Order_By>;
  min?: InputMaybe<Role_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "role_permissions" */
export type Role_Permissions_Arr_Rel_Insert_Input = {
  data: Array<Role_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "role_permissions". All fields are combined with a logical 'AND'. */
export type Role_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  _not?: InputMaybe<Role_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Permissions_Bool_Exp>>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permissionId?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  roleId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "role_permissions" */
export type Role_Permissions_Constraint =
  /** unique or primary key constraint on columns "permissionId", "roleId" */
  | 'role_permissions_pkey';

/** input type for inserting data into table "role_permissions" */
export type Role_Permissions_Insert_Input = {
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permissionId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Role_Permissions_Max_Fields = {
  __typename?: 'role_permissions_max_fields';
  permissionId?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "role_permissions" */
export type Role_Permissions_Max_Order_By = {
  permissionId?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Role_Permissions_Min_Fields = {
  __typename?: 'role_permissions_min_fields';
  permissionId?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "role_permissions" */
export type Role_Permissions_Min_Order_By = {
  permissionId?: InputMaybe<Order_By>;
  roleId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "role_permissions" */
export type Role_Permissions_Mutation_Response = {
  __typename?: 'role_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role_Permissions>;
};

/** on_conflict condition type for table "role_permissions" */
export type Role_Permissions_On_Conflict = {
  constraint: Role_Permissions_Constraint;
  update_columns?: Array<Role_Permissions_Update_Column>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "role_permissions". */
export type Role_Permissions_Order_By = {
  permission?: InputMaybe<Permissions_Order_By>;
  permissionId?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  roleId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role_permissions */
export type Role_Permissions_Pk_Columns_Input = {
  permissionId: Scalars['String'];
  roleId: Scalars['String'];
};

/** select columns of table "role_permissions" */
export type Role_Permissions_Select_Column =
  /** column name */
  | 'permissionId'
  /** column name */
  | 'roleId';

/** input type for updating data in table "role_permissions" */
export type Role_Permissions_Set_Input = {
  permissionId?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "role_permissions" */
export type Role_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Permissions_Stream_Cursor_Value_Input = {
  permissionId?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "role_permissions" */
export type Role_Permissions_Update_Column =
  /** column name */
  | 'permissionId'
  /** column name */
  | 'roleId';

export type Role_Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Permissions_Bool_Exp;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "role" */
export type Role_Select_Column =
  /** column name */
  | 'applicationId'
  /** column name */
  | 'externalId'
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  applicationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  applicationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "role" */
export type Role_Update_Column =
  /** column name */
  | 'applicationId'
  /** column name */
  | 'externalId'
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** columns and relationships of "scope_part_conversion_view" */
export type Scope_Part_Conversion_View = {
  __typename?: 'scope_part_conversion_view';
  part_id?: Maybe<Scalars['String']>;
  uom_conversion_description?: Maybe<Scalars['String']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  uom_scope_description?: Maybe<Scalars['String']>;
  uom_scope_id?: Maybe<Scalars['String']>;
  uom_scope_part_description?: Maybe<Scalars['String']>;
  uom_scope_part_id?: Maybe<Scalars['String']>;
  uom_scope_part_measurement?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "scope_part_conversion_view" */
export type Scope_Part_Conversion_View_Aggregate = {
  __typename?: 'scope_part_conversion_view_aggregate';
  aggregate?: Maybe<Scope_Part_Conversion_View_Aggregate_Fields>;
  nodes: Array<Scope_Part_Conversion_View>;
};

/** aggregate fields of "scope_part_conversion_view" */
export type Scope_Part_Conversion_View_Aggregate_Fields = {
  __typename?: 'scope_part_conversion_view_aggregate_fields';
  avg?: Maybe<Scope_Part_Conversion_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Scope_Part_Conversion_View_Max_Fields>;
  min?: Maybe<Scope_Part_Conversion_View_Min_Fields>;
  stddev?: Maybe<Scope_Part_Conversion_View_Stddev_Fields>;
  stddev_pop?: Maybe<Scope_Part_Conversion_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scope_Part_Conversion_View_Stddev_Samp_Fields>;
  sum?: Maybe<Scope_Part_Conversion_View_Sum_Fields>;
  var_pop?: Maybe<Scope_Part_Conversion_View_Var_Pop_Fields>;
  var_samp?: Maybe<Scope_Part_Conversion_View_Var_Samp_Fields>;
  variance?: Maybe<Scope_Part_Conversion_View_Variance_Fields>;
};


/** aggregate fields of "scope_part_conversion_view" */
export type Scope_Part_Conversion_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scope_Part_Conversion_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Scope_Part_Conversion_View_Avg_Fields = {
  __typename?: 'scope_part_conversion_view_avg_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scope_part_conversion_view". All fields are combined with a logical 'AND'. */
export type Scope_Part_Conversion_View_Bool_Exp = {
  _and?: InputMaybe<Array<Scope_Part_Conversion_View_Bool_Exp>>;
  _not?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
  _or?: InputMaybe<Array<Scope_Part_Conversion_View_Bool_Exp>>;
  part_id?: InputMaybe<String_Comparison_Exp>;
  uom_conversion_description?: InputMaybe<String_Comparison_Exp>;
  uom_conversion_id?: InputMaybe<String_Comparison_Exp>;
  uom_scope_description?: InputMaybe<String_Comparison_Exp>;
  uom_scope_id?: InputMaybe<String_Comparison_Exp>;
  uom_scope_part_description?: InputMaybe<String_Comparison_Exp>;
  uom_scope_part_id?: InputMaybe<String_Comparison_Exp>;
  uom_scope_part_measurement?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Scope_Part_Conversion_View_Max_Fields = {
  __typename?: 'scope_part_conversion_view_max_fields';
  part_id?: Maybe<Scalars['String']>;
  uom_conversion_description?: Maybe<Scalars['String']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  uom_scope_description?: Maybe<Scalars['String']>;
  uom_scope_id?: Maybe<Scalars['String']>;
  uom_scope_part_description?: Maybe<Scalars['String']>;
  uom_scope_part_id?: Maybe<Scalars['String']>;
  uom_scope_part_measurement?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Scope_Part_Conversion_View_Min_Fields = {
  __typename?: 'scope_part_conversion_view_min_fields';
  part_id?: Maybe<Scalars['String']>;
  uom_conversion_description?: Maybe<Scalars['String']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  uom_scope_description?: Maybe<Scalars['String']>;
  uom_scope_id?: Maybe<Scalars['String']>;
  uom_scope_part_description?: Maybe<Scalars['String']>;
  uom_scope_part_id?: Maybe<Scalars['String']>;
  uom_scope_part_measurement?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "scope_part_conversion_view". */
export type Scope_Part_Conversion_View_Order_By = {
  part_id?: InputMaybe<Order_By>;
  uom_conversion_description?: InputMaybe<Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
  uom_scope_description?: InputMaybe<Order_By>;
  uom_scope_id?: InputMaybe<Order_By>;
  uom_scope_part_description?: InputMaybe<Order_By>;
  uom_scope_part_id?: InputMaybe<Order_By>;
  uom_scope_part_measurement?: InputMaybe<Order_By>;
};

/** select columns of table "scope_part_conversion_view" */
export type Scope_Part_Conversion_View_Select_Column =
  /** column name */
  | 'part_id'
  /** column name */
  | 'uom_conversion_description'
  /** column name */
  | 'uom_conversion_id'
  /** column name */
  | 'uom_scope_description'
  /** column name */
  | 'uom_scope_id'
  /** column name */
  | 'uom_scope_part_description'
  /** column name */
  | 'uom_scope_part_id'
  /** column name */
  | 'uom_scope_part_measurement';

/** aggregate stddev on columns */
export type Scope_Part_Conversion_View_Stddev_Fields = {
  __typename?: 'scope_part_conversion_view_stddev_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Scope_Part_Conversion_View_Stddev_Pop_Fields = {
  __typename?: 'scope_part_conversion_view_stddev_pop_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Scope_Part_Conversion_View_Stddev_Samp_Fields = {
  __typename?: 'scope_part_conversion_view_stddev_samp_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scope_part_conversion_view" */
export type Scope_Part_Conversion_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scope_Part_Conversion_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scope_Part_Conversion_View_Stream_Cursor_Value_Input = {
  part_id?: InputMaybe<Scalars['String']>;
  uom_conversion_description?: InputMaybe<Scalars['String']>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
  uom_scope_description?: InputMaybe<Scalars['String']>;
  uom_scope_id?: InputMaybe<Scalars['String']>;
  uom_scope_part_description?: InputMaybe<Scalars['String']>;
  uom_scope_part_id?: InputMaybe<Scalars['String']>;
  uom_scope_part_measurement?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Scope_Part_Conversion_View_Sum_Fields = {
  __typename?: 'scope_part_conversion_view_sum_fields';
  uom_scope_part_measurement?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Scope_Part_Conversion_View_Var_Pop_Fields = {
  __typename?: 'scope_part_conversion_view_var_pop_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Scope_Part_Conversion_View_Var_Samp_Fields = {
  __typename?: 'scope_part_conversion_view_var_samp_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Scope_Part_Conversion_View_Variance_Fields = {
  __typename?: 'scope_part_conversion_view_variance_fields';
  uom_scope_part_measurement?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "search_parts_view" */
export type Search_Parts_View = {
  __typename?: 'search_parts_view';
  approval_stage?: Maybe<Scalars['_text']>;
  csi_level1?: Maybe<Scalars['String']>;
  csi_level2?: Maybe<Scalars['String']>;
  csi_level3?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['_text']>;
  manufacturer_part_number?: Maybe<Scalars['_text']>;
  name?: Maybe<Scalars['String']>;
  objectID?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  part_number_histories?: Maybe<Scalars['_text']>;
  purchase_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tagged_choices?: Maybe<Scalars['_text']>;
  tagged_domains?: Maybe<Scalars['_text']>;
  tagged_platforms?: Maybe<Scalars['_text']>;
  tagged_processes?: Maybe<Scalars['_text']>;
  tagged_products?: Maybe<Scalars['_text']>;
  tagged_programs?: Maybe<Scalars['_text']>;
  tags?: Maybe<Scalars['jsonb']>;
  vendor?: Maybe<Scalars['_text']>;
};


/** columns and relationships of "search_parts_view" */
export type Search_Parts_ViewTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "search_parts_view" */
export type Search_Parts_View_Aggregate = {
  __typename?: 'search_parts_view_aggregate';
  aggregate?: Maybe<Search_Parts_View_Aggregate_Fields>;
  nodes: Array<Search_Parts_View>;
};

/** aggregate fields of "search_parts_view" */
export type Search_Parts_View_Aggregate_Fields = {
  __typename?: 'search_parts_view_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Search_Parts_View_Max_Fields>;
  min?: Maybe<Search_Parts_View_Min_Fields>;
};


/** aggregate fields of "search_parts_view" */
export type Search_Parts_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Parts_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "search_parts_view". All fields are combined with a logical 'AND'. */
export type Search_Parts_View_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Parts_View_Bool_Exp>>;
  _not?: InputMaybe<Search_Parts_View_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Parts_View_Bool_Exp>>;
  approval_stage?: InputMaybe<_Text_Comparison_Exp>;
  csi_level1?: InputMaybe<String_Comparison_Exp>;
  csi_level2?: InputMaybe<String_Comparison_Exp>;
  csi_level3?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  manufacturer?: InputMaybe<_Text_Comparison_Exp>;
  manufacturer_part_number?: InputMaybe<_Text_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  objectID?: InputMaybe<String_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  part_number_histories?: InputMaybe<_Text_Comparison_Exp>;
  purchase_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tagged_choices?: InputMaybe<_Text_Comparison_Exp>;
  tagged_domains?: InputMaybe<_Text_Comparison_Exp>;
  tagged_platforms?: InputMaybe<_Text_Comparison_Exp>;
  tagged_processes?: InputMaybe<_Text_Comparison_Exp>;
  tagged_products?: InputMaybe<_Text_Comparison_Exp>;
  tagged_programs?: InputMaybe<_Text_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  vendor?: InputMaybe<_Text_Comparison_Exp>;
};

/** aggregate max on columns */
export type Search_Parts_View_Max_Fields = {
  __typename?: 'search_parts_view_max_fields';
  csi_level1?: Maybe<Scalars['String']>;
  csi_level2?: Maybe<Scalars['String']>;
  csi_level3?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  objectID?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Search_Parts_View_Min_Fields = {
  __typename?: 'search_parts_view_min_fields';
  csi_level1?: Maybe<Scalars['String']>;
  csi_level2?: Maybe<Scalars['String']>;
  csi_level3?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  objectID?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "search_parts_view". */
export type Search_Parts_View_Order_By = {
  approval_stage?: InputMaybe<Order_By>;
  csi_level1?: InputMaybe<Order_By>;
  csi_level2?: InputMaybe<Order_By>;
  csi_level3?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  objectID?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  part_number_histories?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tagged_choices?: InputMaybe<Order_By>;
  tagged_domains?: InputMaybe<Order_By>;
  tagged_platforms?: InputMaybe<Order_By>;
  tagged_processes?: InputMaybe<Order_By>;
  tagged_products?: InputMaybe<Order_By>;
  tagged_programs?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Order_By>;
};

/** select columns of table "search_parts_view" */
export type Search_Parts_View_Select_Column =
  /** column name */
  | 'approval_stage'
  /** column name */
  | 'csi_level1'
  /** column name */
  | 'csi_level2'
  /** column name */
  | 'csi_level3'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'imageUrl'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'name'
  /** column name */
  | 'objectID'
  /** column name */
  | 'part_number'
  /** column name */
  | 'part_number_histories'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'status'
  /** column name */
  | 'tagged_choices'
  /** column name */
  | 'tagged_domains'
  /** column name */
  | 'tagged_platforms'
  /** column name */
  | 'tagged_processes'
  /** column name */
  | 'tagged_products'
  /** column name */
  | 'tagged_programs'
  /** column name */
  | 'tags'
  /** column name */
  | 'vendor';

/** Streaming cursor of the table "search_parts_view" */
export type Search_Parts_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Parts_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Parts_View_Stream_Cursor_Value_Input = {
  approval_stage?: InputMaybe<Scalars['_text']>;
  csi_level1?: InputMaybe<Scalars['String']>;
  csi_level2?: InputMaybe<Scalars['String']>;
  csi_level3?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['_text']>;
  manufacturer_part_number?: InputMaybe<Scalars['_text']>;
  name?: InputMaybe<Scalars['String']>;
  objectID?: InputMaybe<Scalars['String']>;
  part_number?: InputMaybe<Scalars['String']>;
  part_number_histories?: InputMaybe<Scalars['_text']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tagged_choices?: InputMaybe<Scalars['_text']>;
  tagged_domains?: InputMaybe<Scalars['_text']>;
  tagged_platforms?: InputMaybe<Scalars['_text']>;
  tagged_processes?: InputMaybe<Scalars['_text']>;
  tagged_products?: InputMaybe<Scalars['_text']>;
  tagged_programs?: InputMaybe<Scalars['_text']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  vendor?: InputMaybe<Scalars['_text']>;
};

/** columns and relationships of "serial_numbers" */
export type Serial_Numbers = {
  __typename?: 'serial_numbers';
  base_product_id: Scalars['String'];
  next_serial: Scalars['numeric'];
};

/** aggregated selection of "serial_numbers" */
export type Serial_Numbers_Aggregate = {
  __typename?: 'serial_numbers_aggregate';
  aggregate?: Maybe<Serial_Numbers_Aggregate_Fields>;
  nodes: Array<Serial_Numbers>;
};

/** aggregate fields of "serial_numbers" */
export type Serial_Numbers_Aggregate_Fields = {
  __typename?: 'serial_numbers_aggregate_fields';
  avg?: Maybe<Serial_Numbers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Serial_Numbers_Max_Fields>;
  min?: Maybe<Serial_Numbers_Min_Fields>;
  stddev?: Maybe<Serial_Numbers_Stddev_Fields>;
  stddev_pop?: Maybe<Serial_Numbers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Serial_Numbers_Stddev_Samp_Fields>;
  sum?: Maybe<Serial_Numbers_Sum_Fields>;
  var_pop?: Maybe<Serial_Numbers_Var_Pop_Fields>;
  var_samp?: Maybe<Serial_Numbers_Var_Samp_Fields>;
  variance?: Maybe<Serial_Numbers_Variance_Fields>;
};


/** aggregate fields of "serial_numbers" */
export type Serial_Numbers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Serial_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Serial_Numbers_Avg_Fields = {
  __typename?: 'serial_numbers_avg_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "serial_numbers". All fields are combined with a logical 'AND'. */
export type Serial_Numbers_Bool_Exp = {
  _and?: InputMaybe<Array<Serial_Numbers_Bool_Exp>>;
  _not?: InputMaybe<Serial_Numbers_Bool_Exp>;
  _or?: InputMaybe<Array<Serial_Numbers_Bool_Exp>>;
  base_product_id?: InputMaybe<String_Comparison_Exp>;
  next_serial?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "serial_numbers" */
export type Serial_Numbers_Constraint =
  /** unique or primary key constraint on columns "base_product_id" */
  | 'serial_numbers_pkey';

/** input type for incrementing numeric columns in table "serial_numbers" */
export type Serial_Numbers_Inc_Input = {
  next_serial?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "serial_numbers" */
export type Serial_Numbers_Insert_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  next_serial?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Serial_Numbers_Max_Fields = {
  __typename?: 'serial_numbers_max_fields';
  base_product_id?: Maybe<Scalars['String']>;
  next_serial?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Serial_Numbers_Min_Fields = {
  __typename?: 'serial_numbers_min_fields';
  base_product_id?: Maybe<Scalars['String']>;
  next_serial?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "serial_numbers" */
export type Serial_Numbers_Mutation_Response = {
  __typename?: 'serial_numbers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Serial_Numbers>;
};

/** on_conflict condition type for table "serial_numbers" */
export type Serial_Numbers_On_Conflict = {
  constraint: Serial_Numbers_Constraint;
  update_columns?: Array<Serial_Numbers_Update_Column>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};

/** Ordering options when selecting data from "serial_numbers". */
export type Serial_Numbers_Order_By = {
  base_product_id?: InputMaybe<Order_By>;
  next_serial?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serial_numbers */
export type Serial_Numbers_Pk_Columns_Input = {
  base_product_id: Scalars['String'];
};

/** select columns of table "serial_numbers" */
export type Serial_Numbers_Select_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'next_serial';

/** input type for updating data in table "serial_numbers" */
export type Serial_Numbers_Set_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  next_serial?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Serial_Numbers_Stddev_Fields = {
  __typename?: 'serial_numbers_stddev_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Serial_Numbers_Stddev_Pop_Fields = {
  __typename?: 'serial_numbers_stddev_pop_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Serial_Numbers_Stddev_Samp_Fields = {
  __typename?: 'serial_numbers_stddev_samp_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "serial_numbers" */
export type Serial_Numbers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Serial_Numbers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Serial_Numbers_Stream_Cursor_Value_Input = {
  base_product_id?: InputMaybe<Scalars['String']>;
  next_serial?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Serial_Numbers_Sum_Fields = {
  __typename?: 'serial_numbers_sum_fields';
  next_serial?: Maybe<Scalars['numeric']>;
};

/** update columns of table "serial_numbers" */
export type Serial_Numbers_Update_Column =
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'next_serial';

export type Serial_Numbers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Serial_Numbers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Serial_Numbers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Serial_Numbers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Serial_Numbers_Var_Pop_Fields = {
  __typename?: 'serial_numbers_var_pop_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Serial_Numbers_Var_Samp_Fields = {
  __typename?: 'serial_numbers_var_samp_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Serial_Numbers_Variance_Fields = {
  __typename?: 'serial_numbers_variance_fields';
  next_serial?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "short_url" */
export type Short_Url = {
  __typename?: 'short_url';
  active: Scalars['Boolean'];
  clicks: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  link_tags?: Maybe<Scalars['jsonb']>;
  name?: Maybe<Scalars['String']>;
  qrcode_url?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};


/** columns and relationships of "short_url" */
export type Short_UrlLink_TagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "short_url" */
export type Short_Url_Aggregate = {
  __typename?: 'short_url_aggregate';
  aggregate?: Maybe<Short_Url_Aggregate_Fields>;
  nodes: Array<Short_Url>;
};

/** aggregate fields of "short_url" */
export type Short_Url_Aggregate_Fields = {
  __typename?: 'short_url_aggregate_fields';
  avg?: Maybe<Short_Url_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Short_Url_Max_Fields>;
  min?: Maybe<Short_Url_Min_Fields>;
  stddev?: Maybe<Short_Url_Stddev_Fields>;
  stddev_pop?: Maybe<Short_Url_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Short_Url_Stddev_Samp_Fields>;
  sum?: Maybe<Short_Url_Sum_Fields>;
  var_pop?: Maybe<Short_Url_Var_Pop_Fields>;
  var_samp?: Maybe<Short_Url_Var_Samp_Fields>;
  variance?: Maybe<Short_Url_Variance_Fields>;
};


/** aggregate fields of "short_url" */
export type Short_Url_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Short_Url_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Short_Url_Append_Input = {
  link_tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Short_Url_Avg_Fields = {
  __typename?: 'short_url_avg_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "short_url". All fields are combined with a logical 'AND'. */
export type Short_Url_Bool_Exp = {
  _and?: InputMaybe<Array<Short_Url_Bool_Exp>>;
  _not?: InputMaybe<Short_Url_Bool_Exp>;
  _or?: InputMaybe<Array<Short_Url_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  clicks?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  link_tags?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  qrcode_url?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "short_url" */
export type Short_Url_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'short_url_pkey'
  /** unique or primary key constraint on columns "slug" */
  | 'short_url_slug_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Short_Url_Delete_At_Path_Input = {
  link_tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Short_Url_Delete_Elem_Input = {
  link_tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Short_Url_Delete_Key_Input = {
  link_tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "short_url" */
export type Short_Url_Inc_Input = {
  clicks?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "short_url" */
export type Short_Url_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  clicks?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  link_tags?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  qrcode_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Short_Url_Max_Fields = {
  __typename?: 'short_url_max_fields';
  clicks?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  qrcode_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Short_Url_Min_Fields = {
  __typename?: 'short_url_min_fields';
  clicks?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  qrcode_url?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "short_url" */
export type Short_Url_Mutation_Response = {
  __typename?: 'short_url_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Short_Url>;
};

/** on_conflict condition type for table "short_url" */
export type Short_Url_On_Conflict = {
  constraint: Short_Url_Constraint;
  update_columns?: Array<Short_Url_Update_Column>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};

/** Ordering options when selecting data from "short_url". */
export type Short_Url_Order_By = {
  active?: InputMaybe<Order_By>;
  clicks?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link_tags?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  qrcode_url?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: short_url */
export type Short_Url_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Short_Url_Prepend_Input = {
  link_tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "short_url" */
export type Short_Url_Select_Column =
  /** column name */
  | 'active'
  /** column name */
  | 'clicks'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'link_tags'
  /** column name */
  | 'name'
  /** column name */
  | 'qrcode_url'
  /** column name */
  | 'slug'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'url';

/** input type for updating data in table "short_url" */
export type Short_Url_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  clicks?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  link_tags?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  qrcode_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Short_Url_Stddev_Fields = {
  __typename?: 'short_url_stddev_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Short_Url_Stddev_Pop_Fields = {
  __typename?: 'short_url_stddev_pop_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Short_Url_Stddev_Samp_Fields = {
  __typename?: 'short_url_stddev_samp_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "short_url" */
export type Short_Url_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Short_Url_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Short_Url_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  clicks?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  link_tags?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  qrcode_url?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Short_Url_Sum_Fields = {
  __typename?: 'short_url_sum_fields';
  clicks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "short_url" */
export type Short_Url_Update_Column =
  /** column name */
  | 'active'
  /** column name */
  | 'clicks'
  /** column name */
  | 'created_at'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'link_tags'
  /** column name */
  | 'name'
  /** column name */
  | 'qrcode_url'
  /** column name */
  | 'slug'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'url';

export type Short_Url_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Short_Url_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Short_Url_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Short_Url_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Short_Url_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Short_Url_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Short_Url_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Short_Url_Set_Input>;
  /** filter the rows which have to be updated */
  where: Short_Url_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Short_Url_Var_Pop_Fields = {
  __typename?: 'short_url_var_pop_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Short_Url_Var_Samp_Fields = {
  __typename?: 'short_url_var_samp_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Short_Url_Variance_Fields = {
  __typename?: 'short_url_variance_fields';
  clicks?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "all_boms_view" */
  all_boms_view: Array<All_Boms_View>;
  /** fetch aggregated fields from the table: "all_boms_view" */
  all_boms_view_aggregate: All_Boms_View_Aggregate;
  /** fetch data from the table in a streaming manner: "all_boms_view" */
  all_boms_view_stream: Array<All_Boms_View>;
  /** fetch data from the table: "base_product" */
  base_product: Array<Base_Product>;
  /** fetch aggregated fields from the table: "base_product" */
  base_product_aggregate: Base_Product_Aggregate;
  /** fetch data from the table: "base_product" using primary key columns */
  base_product_by_pk?: Maybe<Base_Product>;
  /** fetch data from the table in a streaming manner: "base_product" */
  base_product_stream: Array<Base_Product>;
  /** fetch data from the table: "bom_detail" */
  bom_detail: Array<Bom_Detail>;
  /** fetch aggregated fields from the table: "bom_detail" */
  bom_detail_aggregate: Bom_Detail_Aggregate;
  /** fetch data from the table: "bom_detail" using primary key columns */
  bom_detail_by_pk?: Maybe<Bom_Detail>;
  /** fetch data from the table in a streaming manner: "bom_detail" */
  bom_detail_stream: Array<Bom_Detail>;
  /** fetch data from the table: "bom_item_tag_set" */
  bom_item_tag_set: Array<Bom_Item_Tag_Set>;
  /** fetch aggregated fields from the table: "bom_item_tag_set" */
  bom_item_tag_set_aggregate: Bom_Item_Tag_Set_Aggregate;
  /** fetch data from the table: "bom_item_tag_set" using primary key columns */
  bom_item_tag_set_by_pk?: Maybe<Bom_Item_Tag_Set>;
  /** fetch data from the table in a streaming manner: "bom_item_tag_set" */
  bom_item_tag_set_stream: Array<Bom_Item_Tag_Set>;
  /** fetch data from the table: "boms_view" */
  boms_view: Array<Boms_View>;
  /** fetch aggregated fields from the table: "boms_view" */
  boms_view_aggregate: Boms_View_Aggregate;
  /** fetch data from the table in a streaming manner: "boms_view" */
  boms_view_stream: Array<Boms_View>;
  /** fetch data from the table: "consumable_bom_detail" */
  consumable_bom_detail: Array<Consumable_Bom_Detail>;
  /** fetch aggregated fields from the table: "consumable_bom_detail" */
  consumable_bom_detail_aggregate: Consumable_Bom_Detail_Aggregate;
  /** fetch data from the table: "consumable_bom_detail" using primary key columns */
  consumable_bom_detail_by_pk?: Maybe<Consumable_Bom_Detail>;
  /** fetch data from the table in a streaming manner: "consumable_bom_detail" */
  consumable_bom_detail_stream: Array<Consumable_Bom_Detail>;
  /** fetch data from the table: "counters" */
  counters: Array<Counters>;
  /** fetch aggregated fields from the table: "counters" */
  counters_aggregate: Counters_Aggregate;
  /** fetch data from the table: "counters" using primary key columns */
  counters_by_pk?: Maybe<Counters>;
  /** fetch data from the table in a streaming manner: "counters" */
  counters_stream: Array<Counters>;
  /** fetch data from the table: "csi" */
  csi: Array<Csi>;
  /** fetch aggregated fields from the table: "csi" */
  csi_aggregate: Csi_Aggregate;
  /** fetch data from the table: "csi" using primary key columns */
  csi_by_pk?: Maybe<Csi>;
  /** fetch data from the table in a streaming manner: "csi" */
  csi_stream: Array<Csi>;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  /** fetch data from the table: "customer_admin" */
  customer_admin: Array<Customer_Admin>;
  /** fetch aggregated fields from the table: "customer_admin" */
  customer_admin_aggregate: Customer_Admin_Aggregate;
  /** fetch data from the table: "customer_admin" using primary key columns */
  customer_admin_by_pk?: Maybe<Customer_Admin>;
  /** fetch data from the table in a streaming manner: "customer_admin" */
  customer_admin_stream: Array<Customer_Admin>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer" using primary key columns */
  customer_by_pk?: Maybe<Customer>;
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<Customer>;
  /** fetch data from the table: "email_templates" */
  email_templates: Array<Email_Templates>;
  /** fetch aggregated fields from the table: "email_templates" */
  email_templates_aggregate: Email_Templates_Aggregate;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** fetch data from the table in a streaming manner: "email_templates" */
  email_templates_stream: Array<Email_Templates>;
  /** fetch data from the table: "emails" */
  emails: Array<Emails>;
  /** fetch aggregated fields from the table: "emails" */
  emails_aggregate: Emails_Aggregate;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table in a streaming manner: "emails" */
  emails_stream: Array<Emails>;
  /** fetch data from the table: "feedback" */
  feedback: Array<Feedback>;
  /** fetch aggregated fields from the table: "feedback" */
  feedback_aggregate: Feedback_Aggregate;
  /** fetch data from the table: "feedback" using primary key columns */
  feedback_by_pk?: Maybe<Feedback>;
  /** fetch data from the table in a streaming manner: "feedback" */
  feedback_stream: Array<Feedback>;
  /** fetch data from the table: "invitation" */
  invitation: Array<Invitation>;
  /** fetch aggregated fields from the table: "invitation" */
  invitation_aggregate: Invitation_Aggregate;
  /** fetch data from the table: "invitation" using primary key columns */
  invitation_by_pk?: Maybe<Invitation>;
  /** fetch data from the table in a streaming manner: "invitation" */
  invitation_stream: Array<Invitation>;
  /** fetch data from the table: "issue" */
  issue: Array<Issue>;
  /** fetch aggregated fields from the table: "issue" */
  issue_aggregate: Issue_Aggregate;
  /** fetch data from the table: "issue" using primary key columns */
  issue_by_pk?: Maybe<Issue>;
  /** fetch data from the table: "issue_status" */
  issue_status: Array<Issue_Status>;
  /** fetch aggregated fields from the table: "issue_status" */
  issue_status_aggregate: Issue_Status_Aggregate;
  /** fetch data from the table: "issue_status" using primary key columns */
  issue_status_by_pk?: Maybe<Issue_Status>;
  /** fetch data from the table in a streaming manner: "issue_status" */
  issue_status_stream: Array<Issue_Status>;
  /** fetch data from the table in a streaming manner: "issue" */
  issue_stream: Array<Issue>;
  /** fetch data from the table: "item_bom" */
  item_bom: Array<Item_Bom>;
  /** fetch aggregated fields from the table: "item_bom" */
  item_bom_aggregate: Item_Bom_Aggregate;
  /** fetch data from the table: "item_bom" using primary key columns */
  item_bom_by_pk?: Maybe<Item_Bom>;
  /** fetch data from the table in a streaming manner: "item_bom" */
  item_bom_stream: Array<Item_Bom>;
  /** fetch data from the table: "item_type" */
  item_type: Array<Item_Type>;
  /** fetch aggregated fields from the table: "item_type" */
  item_type_aggregate: Item_Type_Aggregate;
  /** fetch data from the table: "item_type" using primary key columns */
  item_type_by_pk?: Maybe<Item_Type>;
  /** fetch data from the table in a streaming manner: "item_type" */
  item_type_stream: Array<Item_Type>;
  /** fetch data from the table: "kbb_parts_view" */
  kbb_parts_view: Array<Kbb_Parts_View>;
  /** fetch aggregated fields from the table: "kbb_parts_view" */
  kbb_parts_view_aggregate: Kbb_Parts_View_Aggregate;
  /** fetch data from the table in a streaming manner: "kbb_parts_view" */
  kbb_parts_view_stream: Array<Kbb_Parts_View>;
  /** fetch data from the table: "lookup_view" */
  lookup: Array<Lookup>;
  /** fetch aggregated fields from the table: "lookup_view" */
  lookup_aggregate: Lookup_Aggregate;
  /** fetch data from the table in a streaming manner: "lookup_view" */
  lookup_stream: Array<Lookup>;
  /** fetch data from the table: "manufacturer" */
  manufacturer: Array<Manufacturer>;
  /** fetch aggregated fields from the table: "manufacturer" */
  manufacturer_aggregate: Manufacturer_Aggregate;
  /** fetch data from the table: "manufacturer" using primary key columns */
  manufacturer_by_pk?: Maybe<Manufacturer>;
  /** fetch data from the table: "manufacturer_parts" */
  manufacturer_parts: Array<Manufacturer_Parts>;
  /** fetch aggregated fields from the table: "manufacturer_parts" */
  manufacturer_parts_aggregate: Manufacturer_Parts_Aggregate;
  /** fetch data from the table: "manufacturer_parts" using primary key columns */
  manufacturer_parts_by_pk?: Maybe<Manufacturer_Parts>;
  /** fetch data from the table in a streaming manner: "manufacturer_parts" */
  manufacturer_parts_stream: Array<Manufacturer_Parts>;
  /** fetch data from the table in a streaming manner: "manufacturer" */
  manufacturer_stream: Array<Manufacturer>;
  /** fetch data from the table: "milestone" */
  milestone: Array<Milestone>;
  /** fetch aggregated fields from the table: "milestone" */
  milestone_aggregate: Milestone_Aggregate;
  /** fetch data from the table in a streaming manner: "milestone" */
  milestone_stream: Array<Milestone>;
  /** fetch data from the table: "part" */
  part: Array<Part>;
  /** fetch aggregated fields from the table: "part" */
  part_aggregate: Part_Aggregate;
  /** fetch data from the table: "part" using primary key columns */
  part_by_pk?: Maybe<Part>;
  /** fetch data from the table: "part_download_view" */
  part_download_view: Array<Part_Download_View>;
  /** fetch aggregated fields from the table: "part_download_view" */
  part_download_view_aggregate: Part_Download_View_Aggregate;
  /** fetch data from the table in a streaming manner: "part_download_view" */
  part_download_view_stream: Array<Part_Download_View>;
  /** fetch data from the table: "part_number_history" */
  part_number_history: Array<Part_Number_History>;
  /** fetch aggregated fields from the table: "part_number_history" */
  part_number_history_aggregate: Part_Number_History_Aggregate;
  /** fetch data from the table: "part_number_history" using primary key columns */
  part_number_history_by_pk?: Maybe<Part_Number_History>;
  /** fetch data from the table in a streaming manner: "part_number_history" */
  part_number_history_stream: Array<Part_Number_History>;
  /** fetch data from the table: "part_number_lookup_view" */
  part_number_lookup_view: Array<Part_Number_Lookup_View>;
  /** fetch aggregated fields from the table: "part_number_lookup_view" */
  part_number_lookup_view_aggregate: Part_Number_Lookup_View_Aggregate;
  /** fetch data from the table in a streaming manner: "part_number_lookup_view" */
  part_number_lookup_view_stream: Array<Part_Number_Lookup_View>;
  /** fetch data from the table: "part_request" */
  part_request: Array<Part_Request>;
  /** fetch aggregated fields from the table: "part_request" */
  part_request_aggregate: Part_Request_Aggregate;
  /** fetch data from the table: "part_request" using primary key columns */
  part_request_by_pk?: Maybe<Part_Request>;
  /** fetch data from the table: "part_request_cycle_time" */
  part_request_cycle_time: Array<Part_Request_Cycle_Time>;
  /** fetch aggregated fields from the table: "part_request_cycle_time" */
  part_request_cycle_time_aggregate: Part_Request_Cycle_Time_Aggregate;
  /** fetch data from the table in a streaming manner: "part_request_cycle_time" */
  part_request_cycle_time_stream: Array<Part_Request_Cycle_Time>;
  /** fetch data from the table: "part_request_reason" */
  part_request_reason: Array<Part_Request_Reason>;
  /** fetch aggregated fields from the table: "part_request_reason" */
  part_request_reason_aggregate: Part_Request_Reason_Aggregate;
  /** fetch data from the table: "part_request_reason" using primary key columns */
  part_request_reason_by_pk?: Maybe<Part_Request_Reason>;
  /** fetch data from the table in a streaming manner: "part_request_reason" */
  part_request_reason_stream: Array<Part_Request_Reason>;
  /** fetch data from the table: "part_request_status" */
  part_request_status: Array<Part_Request_Status>;
  /** fetch aggregated fields from the table: "part_request_status" */
  part_request_status_aggregate: Part_Request_Status_Aggregate;
  /** fetch data from the table: "part_request_status" using primary key columns */
  part_request_status_by_pk?: Maybe<Part_Request_Status>;
  /** fetch data from the table in a streaming manner: "part_request_status" */
  part_request_status_stream: Array<Part_Request_Status>;
  /** fetch data from the table in a streaming manner: "part_request" */
  part_request_stream: Array<Part_Request>;
  /** fetch data from the table: "part_request_type" */
  part_request_type: Array<Part_Request_Type>;
  /** fetch aggregated fields from the table: "part_request_type" */
  part_request_type_aggregate: Part_Request_Type_Aggregate;
  /** fetch data from the table: "part_request_type" using primary key columns */
  part_request_type_by_pk?: Maybe<Part_Request_Type>;
  /** fetch data from the table in a streaming manner: "part_request_type" */
  part_request_type_stream: Array<Part_Request_Type>;
  /** fetch data from the table: "part_status" */
  part_status: Array<Part_Status>;
  /** fetch aggregated fields from the table: "part_status" */
  part_status_aggregate: Part_Status_Aggregate;
  /** fetch data from the table: "part_status" using primary key columns */
  part_status_by_pk?: Maybe<Part_Status>;
  /** fetch data from the table in a streaming manner: "part_status" */
  part_status_stream: Array<Part_Status>;
  /** fetch data from the table in a streaming manner: "part" */
  part_stream: Array<Part>;
  /** fetch data from the table: "part_sync" */
  part_sync: Array<Part_Sync>;
  /** fetch aggregated fields from the table: "part_sync" */
  part_sync_aggregate: Part_Sync_Aggregate;
  /** fetch data from the table: "part_sync" using primary key columns */
  part_sync_by_pk?: Maybe<Part_Sync>;
  /** fetch data from the table in a streaming manner: "part_sync" */
  part_sync_stream: Array<Part_Sync>;
  /** fetch data from the table: "part_type" */
  part_type: Array<Part_Type>;
  /** fetch aggregated fields from the table: "part_type" */
  part_type_aggregate: Part_Type_Aggregate;
  /** fetch data from the table: "part_type" using primary key columns */
  part_type_by_pk?: Maybe<Part_Type>;
  /** fetch data from the table in a streaming manner: "part_type" */
  part_type_stream: Array<Part_Type>;
  /** fetch data from the table: "part_warehouse_detail" */
  part_warehouse_detail: Array<Part_Warehouse_Detail>;
  /** fetch aggregated fields from the table: "part_warehouse_detail" */
  part_warehouse_detail_aggregate: Part_Warehouse_Detail_Aggregate;
  /** fetch data from the table: "part_warehouse_detail" using primary key columns */
  part_warehouse_detail_by_pk?: Maybe<Part_Warehouse_Detail>;
  /** fetch data from the table in a streaming manner: "part_warehouse_detail" */
  part_warehouse_detail_stream: Array<Part_Warehouse_Detail>;
  /** fetch data from the table: "parts_related" */
  parts_related: Array<Parts_Related>;
  /** fetch aggregated fields from the table: "parts_related" */
  parts_related_aggregate: Parts_Related_Aggregate;
  /** fetch data from the table: "parts_related" using primary key columns */
  parts_related_by_pk?: Maybe<Parts_Related>;
  /** fetch data from the table in a streaming manner: "parts_related" */
  parts_related_stream: Array<Parts_Related>;
  /** fetch data from the table: "parts_workflow_counts_view" */
  parts_workflow_counts_view: Array<Parts_Workflow_Counts_View>;
  /** fetch aggregated fields from the table: "parts_workflow_counts_view" */
  parts_workflow_counts_view_aggregate: Parts_Workflow_Counts_View_Aggregate;
  /** fetch data from the table in a streaming manner: "parts_workflow_counts_view" */
  parts_workflow_counts_view_stream: Array<Parts_Workflow_Counts_View>;
  /** fetch data from the table: "permissions" */
  permissions: Array<Permissions>;
  /** fetch aggregated fields from the table: "permissions" */
  permissions_aggregate: Permissions_Aggregate;
  /** fetch data from the table: "permissions" using primary key columns */
  permissions_by_pk?: Maybe<Permissions>;
  /** fetch data from the table in a streaming manner: "permissions" */
  permissions_stream: Array<Permissions>;
  /** fetch data from the table: "phase" */
  phase: Array<Phase>;
  /** fetch aggregated fields from the table: "phase" */
  phase_aggregate: Phase_Aggregate;
  /** fetch data from the table: "phase" using primary key columns */
  phase_by_pk?: Maybe<Phase>;
  /** fetch data from the table in a streaming manner: "phase" */
  phase_stream: Array<Phase>;
  /** fetch data from the table: "platform" */
  platform: Array<Platform>;
  /** fetch aggregated fields from the table: "platform" */
  platform_aggregate: Platform_Aggregate;
  /** fetch data from the table: "platform" using primary key columns */
  platform_by_pk?: Maybe<Platform>;
  /** fetch data from the table: "platform_requirement" */
  platform_requirement: Array<Platform_Requirement>;
  /** fetch aggregated fields from the table: "platform_requirement" */
  platform_requirement_aggregate: Platform_Requirement_Aggregate;
  /** fetch data from the table: "platform_requirement" using primary key columns */
  platform_requirement_by_pk?: Maybe<Platform_Requirement>;
  /** fetch data from the table in a streaming manner: "platform_requirement" */
  platform_requirement_stream: Array<Platform_Requirement>;
  /** fetch data from the table in a streaming manner: "platform" */
  platform_stream: Array<Platform>;
  /** fetch data from the table: "platform_utilization_view" */
  platform_utilization_view: Array<Platform_Utilization_View>;
  /** fetch aggregated fields from the table: "platform_utilization_view" */
  platform_utilization_view_aggregate: Platform_Utilization_View_Aggregate;
  /** fetch data from the table in a streaming manner: "platform_utilization_view" */
  platform_utilization_view_stream: Array<Platform_Utilization_View>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_option" */
  product_option: Array<Product_Option>;
  /** fetch aggregated fields from the table: "product_option" */
  product_option_aggregate: Product_Option_Aggregate;
  /** fetch data from the table: "product_option" using primary key columns */
  product_option_by_pk?: Maybe<Product_Option>;
  /** fetch data from the table: "product_option_choice" */
  product_option_choice: Array<Product_Option_Choice>;
  /** fetch aggregated fields from the table: "product_option_choice" */
  product_option_choice_aggregate: Product_Option_Choice_Aggregate;
  /** fetch data from the table: "product_option_choice" using primary key columns */
  product_option_choice_by_pk?: Maybe<Product_Option_Choice>;
  /** fetch data from the table in a streaming manner: "product_option_choice" */
  product_option_choice_stream: Array<Product_Option_Choice>;
  /** fetch data from the table in a streaming manner: "product_option" */
  product_option_stream: Array<Product_Option>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_type" */
  product_type: Array<Product_Type>;
  /** fetch aggregated fields from the table: "product_type" */
  product_type_aggregate: Product_Type_Aggregate;
  /** fetch data from the table: "product_type" using primary key columns */
  product_type_by_pk?: Maybe<Product_Type>;
  /** fetch data from the table in a streaming manner: "product_type" */
  product_type_stream: Array<Product_Type>;
  /** fetch data from the table: "program" */
  program: Array<Program>;
  /** fetch aggregated fields from the table: "program" */
  program_aggregate: Program_Aggregate;
  /** fetch data from the table: "program" using primary key columns */
  program_by_pk?: Maybe<Program>;
  /** fetch data from the table in a streaming manner: "program" */
  program_stream: Array<Program>;
  /** fetch data from the table: "project" */
  project: Array<Project>;
  /** fetch aggregated fields from the table: "project" */
  project_aggregate: Project_Aggregate;
  /** fetch data from the table: "project_base_product_quantities" */
  project_base_product_quantities: Array<Project_Base_Product_Quantities>;
  /** fetch aggregated fields from the table: "project_base_product_quantities" */
  project_base_product_quantities_aggregate: Project_Base_Product_Quantities_Aggregate;
  /** fetch data from the table: "project_base_product_quantities" using primary key columns */
  project_base_product_quantities_by_pk?: Maybe<Project_Base_Product_Quantities>;
  /** fetch data from the table in a streaming manner: "project_base_product_quantities" */
  project_base_product_quantities_stream: Array<Project_Base_Product_Quantities>;
  /** fetch data from the table: "project" using primary key columns */
  project_by_pk?: Maybe<Project>;
  /** fetch data from the table: "project_comment" */
  project_comment: Array<Project_Comment>;
  /** fetch aggregated fields from the table: "project_comment" */
  project_comment_aggregate: Project_Comment_Aggregate;
  /** fetch data from the table: "project_comment" using primary key columns */
  project_comment_by_pk?: Maybe<Project_Comment>;
  /** fetch data from the table in a streaming manner: "project_comment" */
  project_comment_stream: Array<Project_Comment>;
  /** fetch data from the table: "project_contacts" */
  project_contacts: Array<Project_Contacts>;
  /** fetch aggregated fields from the table: "project_contacts" */
  project_contacts_aggregate: Project_Contacts_Aggregate;
  /** fetch data from the table: "project_contacts" using primary key columns */
  project_contacts_by_pk?: Maybe<Project_Contacts>;
  /** fetch data from the table in a streaming manner: "project_contacts" */
  project_contacts_stream: Array<Project_Contacts>;
  /** fetch data from the table: "project_milestone" */
  project_milestone: Array<Project_Milestone>;
  /** fetch aggregated fields from the table: "project_milestone" */
  project_milestone_aggregate: Project_Milestone_Aggregate;
  /** fetch data from the table: "project_milestone" using primary key columns */
  project_milestone_by_pk?: Maybe<Project_Milestone>;
  /** fetch data from the table in a streaming manner: "project_milestone" */
  project_milestone_stream: Array<Project_Milestone>;
  /** fetch data from the table: "project_module" */
  project_module: Array<Project_Module>;
  /** fetch aggregated fields from the table: "project_module" */
  project_module_aggregate: Project_Module_Aggregate;
  /** fetch data from the table: "project_module" using primary key columns */
  project_module_by_pk?: Maybe<Project_Module>;
  /** fetch data from the table in a streaming manner: "project_module" */
  project_module_stream: Array<Project_Module>;
  /** fetch data from the table: "project_status" */
  project_status: Array<Project_Status>;
  /** fetch aggregated fields from the table: "project_status" */
  project_status_aggregate: Project_Status_Aggregate;
  /** fetch data from the table: "project_status" using primary key columns */
  project_status_by_pk?: Maybe<Project_Status>;
  /** fetch data from the table in a streaming manner: "project_status" */
  project_status_stream: Array<Project_Status>;
  /** fetch data from the table in a streaming manner: "project" */
  project_stream: Array<Project>;
  /** fetch data from the table: "project_users" */
  project_users: Array<Project_Users>;
  /** fetch aggregated fields from the table: "project_users" */
  project_users_aggregate: Project_Users_Aggregate;
  /** fetch data from the table: "project_users" using primary key columns */
  project_users_by_pk?: Maybe<Project_Users>;
  /** fetch data from the table in a streaming manner: "project_users" */
  project_users_stream: Array<Project_Users>;
  /** fetch data from the table: "purchase_type" */
  purchase_type: Array<Purchase_Type>;
  /** fetch aggregated fields from the table: "purchase_type" */
  purchase_type_aggregate: Purchase_Type_Aggregate;
  /** fetch data from the table: "purchase_type" using primary key columns */
  purchase_type_by_pk?: Maybe<Purchase_Type>;
  /** fetch data from the table in a streaming manner: "purchase_type" */
  purchase_type_stream: Array<Purchase_Type>;
  /** fetch data from the table: "qb_items" */
  qb_items: Array<Qb_Items>;
  /** fetch aggregated fields from the table: "qb_items" */
  qb_items_aggregate: Qb_Items_Aggregate;
  /** fetch data from the table: "qb_items" using primary key columns */
  qb_items_by_pk?: Maybe<Qb_Items>;
  /** fetch data from the table in a streaming manner: "qb_items" */
  qb_items_stream: Array<Qb_Items>;
  /** fetch data from the table: "relation_type" */
  relation_type: Array<Relation_Type>;
  /** fetch aggregated fields from the table: "relation_type" */
  relation_type_aggregate: Relation_Type_Aggregate;
  /** fetch data from the table: "relation_type" using primary key columns */
  relation_type_by_pk?: Maybe<Relation_Type>;
  /** fetch data from the table in a streaming manner: "relation_type" */
  relation_type_stream: Array<Relation_Type>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk?: Maybe<Report>;
  /** fetch data from the table in a streaming manner: "report" */
  report_stream: Array<Report>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** An array relationship */
  role_permissions: Array<Role_Permissions>;
  /** An aggregate relationship */
  role_permissions_aggregate: Role_Permissions_Aggregate;
  /** fetch data from the table: "role_permissions" using primary key columns */
  role_permissions_by_pk?: Maybe<Role_Permissions>;
  /** fetch data from the table in a streaming manner: "role_permissions" */
  role_permissions_stream: Array<Role_Permissions>;
  /** fetch data from the table in a streaming manner: "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "scope_part_conversion_view" */
  scope_part_conversion_view: Array<Scope_Part_Conversion_View>;
  /** fetch aggregated fields from the table: "scope_part_conversion_view" */
  scope_part_conversion_view_aggregate: Scope_Part_Conversion_View_Aggregate;
  /** fetch data from the table in a streaming manner: "scope_part_conversion_view" */
  scope_part_conversion_view_stream: Array<Scope_Part_Conversion_View>;
  /** fetch data from the table: "search_parts_view" */
  search_parts_view: Array<Search_Parts_View>;
  /** fetch aggregated fields from the table: "search_parts_view" */
  search_parts_view_aggregate: Search_Parts_View_Aggregate;
  /** fetch data from the table in a streaming manner: "search_parts_view" */
  search_parts_view_stream: Array<Search_Parts_View>;
  /** fetch data from the table: "serial_numbers" */
  serial_numbers: Array<Serial_Numbers>;
  /** fetch aggregated fields from the table: "serial_numbers" */
  serial_numbers_aggregate: Serial_Numbers_Aggregate;
  /** fetch data from the table: "serial_numbers" using primary key columns */
  serial_numbers_by_pk?: Maybe<Serial_Numbers>;
  /** fetch data from the table in a streaming manner: "serial_numbers" */
  serial_numbers_stream: Array<Serial_Numbers>;
  /** fetch data from the table: "short_url" */
  short_url: Array<Short_Url>;
  /** fetch aggregated fields from the table: "short_url" */
  short_url_aggregate: Short_Url_Aggregate;
  /** fetch data from the table: "short_url" using primary key columns */
  short_url_by_pk?: Maybe<Short_Url>;
  /** fetch data from the table in a streaming manner: "short_url" */
  short_url_stream: Array<Short_Url>;
  /** fetch data from the table: "system_event" */
  system_event: Array<System_Event>;
  /** fetch aggregated fields from the table: "system_event" */
  system_event_aggregate: System_Event_Aggregate;
  /** fetch data from the table: "system_event" using primary key columns */
  system_event_by_pk?: Maybe<System_Event>;
  /** fetch data from the table in a streaming manner: "system_event" */
  system_event_stream: Array<System_Event>;
  /** fetch data from the table: "tag_entity" */
  tag_entity: Array<Tag_Entity>;
  /** fetch aggregated fields from the table: "tag_entity" */
  tag_entity_aggregate: Tag_Entity_Aggregate;
  /** fetch data from the table: "tag_entity" using primary key columns */
  tag_entity_by_pk?: Maybe<Tag_Entity>;
  /** fetch data from the table in a streaming manner: "tag_entity" */
  tag_entity_stream: Array<Tag_Entity>;
  /** fetch data from the table: "tag_path" */
  tag_path: Array<Tag_Path>;
  /** fetch aggregated fields from the table: "tag_path" */
  tag_path_aggregate: Tag_Path_Aggregate;
  /** fetch data from the table: "tag_path" using primary key columns */
  tag_path_by_pk?: Maybe<Tag_Path>;
  /** fetch data from the table: "tag_path_segment_view" */
  tag_path_segment_view: Array<Tag_Path_Segment_View>;
  /** fetch aggregated fields from the table: "tag_path_segment_view" */
  tag_path_segment_view_aggregate: Tag_Path_Segment_View_Aggregate;
  /** fetch data from the table in a streaming manner: "tag_path_segment_view" */
  tag_path_segment_view_stream: Array<Tag_Path_Segment_View>;
  /** fetch data from the table in a streaming manner: "tag_path" */
  tag_path_stream: Array<Tag_Path>;
  /** fetch data from the table: "tag_set" */
  tag_set: Array<Tag_Set>;
  /** fetch aggregated fields from the table: "tag_set" */
  tag_set_aggregate: Tag_Set_Aggregate;
  /** fetch data from the table: "tag_set" using primary key columns */
  tag_set_by_pk?: Maybe<Tag_Set>;
  /** fetch data from the table in a streaming manner: "tag_set" */
  tag_set_stream: Array<Tag_Set>;
  /** fetch data from the table: "tag_type" */
  tag_type: Array<Tag_Type>;
  /** fetch aggregated fields from the table: "tag_type" */
  tag_type_aggregate: Tag_Type_Aggregate;
  /** fetch data from the table: "tag_type" using primary key columns */
  tag_type_by_pk?: Maybe<Tag_Type>;
  /** fetch data from the table in a streaming manner: "tag_type" */
  tag_type_stream: Array<Tag_Type>;
  /** fetch data from the table: "tagged_part_download_view" */
  tagged_part_download_view: Array<Tagged_Part_Download_View>;
  /** fetch aggregated fields from the table: "tagged_part_download_view" */
  tagged_part_download_view_aggregate: Tagged_Part_Download_View_Aggregate;
  /** fetch data from the table in a streaming manner: "tagged_part_download_view" */
  tagged_part_download_view_stream: Array<Tagged_Part_Download_View>;
  /** fetch data from the table: "tags" */
  tags: Array<Tags>;
  /** fetch aggregated fields from the table: "tags" */
  tags_aggregate: Tags_Aggregate;
  /** fetch data from the table: "tags" using primary key columns */
  tags_by_pk?: Maybe<Tags>;
  /** fetch data from the table in a streaming manner: "tags" */
  tags_stream: Array<Tags>;
  /** fetch data from the table: "toimport_view" */
  toimport_view: Array<Toimport_View>;
  /** fetch aggregated fields from the table: "toimport_view" */
  toimport_view_aggregate: Toimport_View_Aggregate;
  /** fetch data from the table in a streaming manner: "toimport_view" */
  toimport_view_stream: Array<Toimport_View>;
  /** fetch data from the table: "unit" */
  unit: Array<Unit>;
  /** fetch aggregated fields from the table: "unit" */
  unit_aggregate: Unit_Aggregate;
  /** fetch data from the table: "unit_bom_entity_view" */
  unit_bom_entity_view: Array<Unit_Bom_Entity_View>;
  /** fetch aggregated fields from the table: "unit_bom_entity_view" */
  unit_bom_entity_view_aggregate: Unit_Bom_Entity_View_Aggregate;
  /** fetch data from the table in a streaming manner: "unit_bom_entity_view" */
  unit_bom_entity_view_stream: Array<Unit_Bom_Entity_View>;
  /** fetch data from the table: "unit" using primary key columns */
  unit_by_pk?: Maybe<Unit>;
  /** fetch data from the table: "unit_product_option_choice" */
  unit_product_option_choice: Array<Unit_Product_Option_Choice>;
  /** fetch aggregated fields from the table: "unit_product_option_choice" */
  unit_product_option_choice_aggregate: Unit_Product_Option_Choice_Aggregate;
  /** fetch data from the table: "unit_product_option_choice" using primary key columns */
  unit_product_option_choice_by_pk?: Maybe<Unit_Product_Option_Choice>;
  /** fetch data from the table in a streaming manner: "unit_product_option_choice" */
  unit_product_option_choice_stream: Array<Unit_Product_Option_Choice>;
  /** fetch data from the table in a streaming manner: "unit" */
  unit_stream: Array<Unit>;
  /** fetch data from the table: "unit_tag_path_view" */
  unit_tag_path_view: Array<Unit_Tag_Path_View>;
  /** fetch aggregated fields from the table: "unit_tag_path_view" */
  unit_tag_path_view_aggregate: Unit_Tag_Path_View_Aggregate;
  /** fetch data from the table in a streaming manner: "unit_tag_path_view" */
  unit_tag_path_view_stream: Array<Unit_Tag_Path_View>;
  /** fetch data from the table: "unit_tag_view" */
  unit_tag_view: Array<Unit_Tag_View>;
  /** fetch aggregated fields from the table: "unit_tag_view" */
  unit_tag_view_aggregate: Unit_Tag_View_Aggregate;
  /** fetch data from the table in a streaming manner: "unit_tag_view" */
  unit_tag_view_stream: Array<Unit_Tag_View>;
  /** fetch data from the table: "uom" */
  uom: Array<Uom>;
  /** fetch aggregated fields from the table: "uom" */
  uom_aggregate: Uom_Aggregate;
  /** fetch data from the table: "uom" using primary key columns */
  uom_by_pk?: Maybe<Uom>;
  /** fetch data from the table: "uom_classification" */
  uom_classification: Array<Uom_Classification>;
  /** fetch aggregated fields from the table: "uom_classification" */
  uom_classification_aggregate: Uom_Classification_Aggregate;
  /** fetch data from the table: "uom_classification" using primary key columns */
  uom_classification_by_pk?: Maybe<Uom_Classification>;
  /** fetch data from the table in a streaming manner: "uom_classification" */
  uom_classification_stream: Array<Uom_Classification>;
  /** fetch data from the table: "uom_conversion" */
  uom_conversion: Array<Uom_Conversion>;
  /** fetch aggregated fields from the table: "uom_conversion" */
  uom_conversion_aggregate: Uom_Conversion_Aggregate;
  /** fetch data from the table: "uom_conversion" using primary key columns */
  uom_conversion_by_pk?: Maybe<Uom_Conversion>;
  /** fetch data from the table in a streaming manner: "uom_conversion" */
  uom_conversion_stream: Array<Uom_Conversion>;
  /** fetch data from the table: "uom_csi_conversion" */
  uom_csi_conversion: Array<Uom_Csi_Conversion>;
  /** fetch aggregated fields from the table: "uom_csi_conversion" */
  uom_csi_conversion_aggregate: Uom_Csi_Conversion_Aggregate;
  /** fetch data from the table: "uom_csi_conversion" using primary key columns */
  uom_csi_conversion_by_pk?: Maybe<Uom_Csi_Conversion>;
  /** fetch data from the table in a streaming manner: "uom_csi_conversion" */
  uom_csi_conversion_stream: Array<Uom_Csi_Conversion>;
  /** fetch data from the table: "uom_scope" */
  uom_scope: Array<Uom_Scope>;
  /** fetch aggregated fields from the table: "uom_scope" */
  uom_scope_aggregate: Uom_Scope_Aggregate;
  /** fetch data from the table: "uom_scope" using primary key columns */
  uom_scope_by_pk?: Maybe<Uom_Scope>;
  /** fetch data from the table: "uom_scope_part" */
  uom_scope_part: Array<Uom_Scope_Part>;
  /** fetch aggregated fields from the table: "uom_scope_part" */
  uom_scope_part_aggregate: Uom_Scope_Part_Aggregate;
  /** fetch data from the table: "uom_scope_part" using primary key columns */
  uom_scope_part_by_pk?: Maybe<Uom_Scope_Part>;
  /** fetch data from the table in a streaming manner: "uom_scope_part" */
  uom_scope_part_stream: Array<Uom_Scope_Part>;
  /** fetch data from the table in a streaming manner: "uom_scope" */
  uom_scope_stream: Array<Uom_Scope>;
  /** fetch data from the table in a streaming manner: "uom" */
  uom_stream: Array<Uom>;
  /** fetch data from the table: "uom_system_conversion" */
  uom_system_conversion: Array<Uom_System_Conversion>;
  /** fetch aggregated fields from the table: "uom_system_conversion" */
  uom_system_conversion_aggregate: Uom_System_Conversion_Aggregate;
  /** fetch data from the table: "uom_system_conversion" using primary key columns */
  uom_system_conversion_by_pk?: Maybe<Uom_System_Conversion>;
  /** fetch data from the table in a streaming manner: "uom_system_conversion" */
  uom_system_conversion_stream: Array<Uom_System_Conversion>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_info" */
  user_info: Array<User_Info>;
  /** fetch aggregated fields from the table: "user_info" */
  user_info_aggregate: User_Info_Aggregate;
  /** fetch data from the table in a streaming manner: "user_info" */
  user_info_stream: Array<User_Info>;
  /** An array relationship */
  user_permissions: Array<User_Permissions>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permissions_Aggregate;
  /** fetch data from the table: "user_permissions" using primary key columns */
  user_permissions_by_pk?: Maybe<User_Permissions>;
  /** fetch data from the table in a streaming manner: "user_permissions" */
  user_permissions_stream: Array<User_Permissions>;
  /** fetch data from the table: "user_role" */
  user_role: Array<User_Role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: User_Role_Aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<User_Role>;
  /** fetch data from the table in a streaming manner: "user_role" */
  user_role_stream: Array<User_Role>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "vendor" */
  vendor: Array<Vendor>;
  /** fetch aggregated fields from the table: "vendor" */
  vendor_aggregate: Vendor_Aggregate;
  /** fetch data from the table: "vendor" using primary key columns */
  vendor_by_pk?: Maybe<Vendor>;
  /** fetch data from the table: "vendor_cleanup_audit" */
  vendor_cleanup_audit: Array<Vendor_Cleanup_Audit>;
  /** fetch aggregated fields from the table: "vendor_cleanup_audit" */
  vendor_cleanup_audit_aggregate: Vendor_Cleanup_Audit_Aggregate;
  /** fetch data from the table: "vendor_cleanup_audit" using primary key columns */
  vendor_cleanup_audit_by_pk?: Maybe<Vendor_Cleanup_Audit>;
  /** fetch data from the table in a streaming manner: "vendor_cleanup_audit" */
  vendor_cleanup_audit_stream: Array<Vendor_Cleanup_Audit>;
  /** fetch data from the table: "vendor_cleanup_wevr_mapping_lookup" */
  vendor_cleanup_wevr_mapping_lookup: Array<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** fetch aggregated fields from the table: "vendor_cleanup_wevr_mapping_lookup" */
  vendor_cleanup_wevr_mapping_lookup_aggregate: Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate;
  /** fetch data from the table: "vendor_cleanup_wevr_mapping_lookup" using primary key columns */
  vendor_cleanup_wevr_mapping_lookup_by_pk?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** fetch data from the table in a streaming manner: "vendor_cleanup_wevr_mapping_lookup" */
  vendor_cleanup_wevr_mapping_lookup_stream: Array<Vendor_Cleanup_Wevr_Mapping_Lookup>;
  /** fetch data from the table: "vendor_parts" */
  vendor_parts: Array<Vendor_Parts>;
  /** fetch aggregated fields from the table: "vendor_parts" */
  vendor_parts_aggregate: Vendor_Parts_Aggregate;
  /** fetch data from the table: "vendor_parts" using primary key columns */
  vendor_parts_by_pk?: Maybe<Vendor_Parts>;
  /** fetch data from the table in a streaming manner: "vendor_parts" */
  vendor_parts_stream: Array<Vendor_Parts>;
  /** fetch data from the table in a streaming manner: "vendor" */
  vendor_stream: Array<Vendor>;
  /** fetch data from the table: "workflow" */
  workflow: Array<Workflow>;
  /** fetch aggregated fields from the table: "workflow" */
  workflow_aggregate: Workflow_Aggregate;
  /** fetch data from the table: "workflow" using primary key columns */
  workflow_by_pk?: Maybe<Workflow>;
  /** fetch data from the table in a streaming manner: "workflow" */
  workflow_stream: Array<Workflow>;
};


export type Subscription_RootAll_Boms_ViewArgs = {
  distinct_on?: InputMaybe<Array<All_Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<All_Boms_View_Order_By>>;
  where?: InputMaybe<All_Boms_View_Bool_Exp>;
};


export type Subscription_RootAll_Boms_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<All_Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<All_Boms_View_Order_By>>;
  where?: InputMaybe<All_Boms_View_Bool_Exp>;
};


export type Subscription_RootAll_Boms_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<All_Boms_View_Stream_Cursor_Input>>;
  where?: InputMaybe<All_Boms_View_Bool_Exp>;
};


export type Subscription_RootBase_ProductArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


export type Subscription_RootBase_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Base_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Base_Product_Order_By>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


export type Subscription_RootBase_Product_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootBase_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Base_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
};


export type Subscription_RootBom_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


export type Subscription_RootBom_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Detail_Order_By>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


export type Subscription_RootBom_Detail_By_PkArgs = {
  partId: Scalars['String'];
  productId: Scalars['String'];
};


export type Subscription_RootBom_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bom_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Bom_Detail_Bool_Exp>;
};


export type Subscription_RootBom_Item_Tag_SetArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


export type Subscription_RootBom_Item_Tag_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


export type Subscription_RootBom_Item_Tag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBom_Item_Tag_Set_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bom_Item_Tag_Set_Stream_Cursor_Input>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


export type Subscription_RootBoms_ViewArgs = {
  distinct_on?: InputMaybe<Array<Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boms_View_Order_By>>;
  where?: InputMaybe<Boms_View_Bool_Exp>;
};


export type Subscription_RootBoms_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Boms_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Boms_View_Order_By>>;
  where?: InputMaybe<Boms_View_Bool_Exp>;
};


export type Subscription_RootBoms_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Boms_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Boms_View_Bool_Exp>;
};


export type Subscription_RootConsumable_Bom_DetailArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


export type Subscription_RootConsumable_Bom_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumable_Bom_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumable_Bom_Detail_Order_By>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


export type Subscription_RootConsumable_Bom_Detail_By_PkArgs = {
  baseProductId: Scalars['String'];
  partId: Scalars['String'];
};


export type Subscription_RootConsumable_Bom_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consumable_Bom_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumable_Bom_Detail_Bool_Exp>;
};


export type Subscription_RootCountersArgs = {
  distinct_on?: InputMaybe<Array<Counters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Counters_Order_By>>;
  where?: InputMaybe<Counters_Bool_Exp>;
};


export type Subscription_RootCounters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Counters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Counters_Order_By>>;
  where?: InputMaybe<Counters_Bool_Exp>;
};


export type Subscription_RootCounters_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCounters_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Counters_Stream_Cursor_Input>>;
  where?: InputMaybe<Counters_Bool_Exp>;
};


export type Subscription_RootCsiArgs = {
  distinct_on?: InputMaybe<Array<Csi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Csi_Order_By>>;
  where?: InputMaybe<Csi_Bool_Exp>;
};


export type Subscription_RootCsi_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Csi_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Csi_Order_By>>;
  where?: InputMaybe<Csi_Bool_Exp>;
};


export type Subscription_RootCsi_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCsi_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Csi_Stream_Cursor_Input>>;
  where?: InputMaybe<Csi_Bool_Exp>;
};


export type Subscription_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_AdminArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


export type Subscription_RootCustomer_Admin_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


export type Subscription_RootCustomer_Admin_By_PkArgs = {
  customerId: Scalars['String'];
  userId: Scalars['String'];
};


export type Subscription_RootCustomer_Admin_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Admin_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


export type Subscription_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmail_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmail_Templates_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEmail_Templates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootFeedbackArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Feedback_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feedback_Order_By>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootFeedback_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFeedback_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feedback_Stream_Cursor_Input>>;
  where?: InputMaybe<Feedback_Bool_Exp>;
};


export type Subscription_RootInvitationArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootInvitation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootInvitation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invitation_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


export type Subscription_RootIssueArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Order_By>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootIssue_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootIssue_StatusArgs = {
  distinct_on?: InputMaybe<Array<Issue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Status_Order_By>>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};


export type Subscription_RootIssue_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Issue_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Issue_Status_Order_By>>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};


export type Subscription_RootIssue_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIssue_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issue_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Status_Bool_Exp>;
};


export type Subscription_RootIssue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Issue_Stream_Cursor_Input>>;
  where?: InputMaybe<Issue_Bool_Exp>;
};


export type Subscription_RootItem_BomArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


export type Subscription_RootItem_Bom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


export type Subscription_RootItem_Bom_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootItem_Bom_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Item_Bom_Stream_Cursor_Input>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


export type Subscription_RootItem_TypeArgs = {
  distinct_on?: InputMaybe<Array<Item_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Type_Order_By>>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};


export type Subscription_RootItem_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Type_Order_By>>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};


export type Subscription_RootItem_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootItem_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Item_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Item_Type_Bool_Exp>;
};


export type Subscription_RootKbb_Parts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Kbb_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kbb_Parts_View_Order_By>>;
  where?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
};


export type Subscription_RootKbb_Parts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kbb_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kbb_Parts_View_Order_By>>;
  where?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
};


export type Subscription_RootKbb_Parts_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kbb_Parts_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Kbb_Parts_View_Bool_Exp>;
};


export type Subscription_RootLookupArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lookup_Order_By>>;
  where?: InputMaybe<Lookup_Bool_Exp>;
};


export type Subscription_RootLookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Lookup_Order_By>>;
  where?: InputMaybe<Lookup_Bool_Exp>;
};


export type Subscription_RootLookup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Lookup_Stream_Cursor_Input>>;
  where?: InputMaybe<Lookup_Bool_Exp>;
};


export type Subscription_RootManufacturerArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootManufacturer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Order_By>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootManufacturer_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootManufacturer_PartsArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


export type Subscription_RootManufacturer_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Manufacturer_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Manufacturer_Parts_Order_By>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


export type Subscription_RootManufacturer_Parts_By_PkArgs = {
  manufacturerId: Scalars['String'];
  partId: Scalars['String'];
};


export type Subscription_RootManufacturer_Parts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturer_Parts_Stream_Cursor_Input>>;
  where?: InputMaybe<Manufacturer_Parts_Bool_Exp>;
};


export type Subscription_RootManufacturer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Manufacturer_Stream_Cursor_Input>>;
  where?: InputMaybe<Manufacturer_Bool_Exp>;
};


export type Subscription_RootMilestoneArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Milestone_Order_By>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootMilestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Milestone_Bool_Exp>;
};


export type Subscription_RootPartArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


export type Subscription_RootPart_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Order_By>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


export type Subscription_RootPart_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPart_Download_ViewArgs = {
  distinct_on?: InputMaybe<Array<Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Download_View_Order_By>>;
  where?: InputMaybe<Part_Download_View_Bool_Exp>;
};


export type Subscription_RootPart_Download_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Download_View_Order_By>>;
  where?: InputMaybe<Part_Download_View_Bool_Exp>;
};


export type Subscription_RootPart_Download_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Download_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Download_View_Bool_Exp>;
};


export type Subscription_RootPart_Number_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


export type Subscription_RootPart_Number_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_History_Order_By>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


export type Subscription_RootPart_Number_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPart_Number_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Number_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Number_History_Bool_Exp>;
};


export type Subscription_RootPart_Number_Lookup_ViewArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_Lookup_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_Lookup_View_Order_By>>;
  where?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
};


export type Subscription_RootPart_Number_Lookup_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Number_Lookup_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Number_Lookup_View_Order_By>>;
  where?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
};


export type Subscription_RootPart_Number_Lookup_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Number_Lookup_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Number_Lookup_View_Bool_Exp>;
};


export type Subscription_RootPart_RequestArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


export type Subscription_RootPart_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Order_By>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


export type Subscription_RootPart_Request_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPart_Request_Cycle_TimeArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Cycle_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Cycle_Time_Order_By>>;
  where?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
};


export type Subscription_RootPart_Request_Cycle_Time_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Cycle_Time_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Cycle_Time_Order_By>>;
  where?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
};


export type Subscription_RootPart_Request_Cycle_Time_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Request_Cycle_Time_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Request_Cycle_Time_Bool_Exp>;
};


export type Subscription_RootPart_Request_ReasonArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Reason_Order_By>>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};


export type Subscription_RootPart_Request_Reason_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Reason_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Reason_Order_By>>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};


export type Subscription_RootPart_Request_Reason_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPart_Request_Reason_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Request_Reason_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Request_Reason_Bool_Exp>;
};


export type Subscription_RootPart_Request_StatusArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Status_Order_By>>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};


export type Subscription_RootPart_Request_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Status_Order_By>>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};


export type Subscription_RootPart_Request_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPart_Request_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Request_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Request_Status_Bool_Exp>;
};


export type Subscription_RootPart_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Request_Bool_Exp>;
};


export type Subscription_RootPart_Request_TypeArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Type_Order_By>>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};


export type Subscription_RootPart_Request_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Request_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Request_Type_Order_By>>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};


export type Subscription_RootPart_Request_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPart_Request_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Request_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Request_Type_Bool_Exp>;
};


export type Subscription_RootPart_StatusArgs = {
  distinct_on?: InputMaybe<Array<Part_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Status_Order_By>>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};


export type Subscription_RootPart_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Status_Order_By>>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};


export type Subscription_RootPart_Status_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPart_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Status_Bool_Exp>;
};


export type Subscription_RootPart_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Bool_Exp>;
};


export type Subscription_RootPart_SyncArgs = {
  distinct_on?: InputMaybe<Array<Part_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Sync_Order_By>>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};


export type Subscription_RootPart_Sync_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Sync_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Sync_Order_By>>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};


export type Subscription_RootPart_Sync_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPart_Sync_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Sync_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Sync_Bool_Exp>;
};


export type Subscription_RootPart_TypeArgs = {
  distinct_on?: InputMaybe<Array<Part_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Type_Order_By>>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};


export type Subscription_RootPart_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Type_Order_By>>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};


export type Subscription_RootPart_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPart_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Type_Bool_Exp>;
};


export type Subscription_RootPart_Warehouse_DetailArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


export type Subscription_RootPart_Warehouse_Detail_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Part_Warehouse_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Part_Warehouse_Detail_Order_By>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


export type Subscription_RootPart_Warehouse_Detail_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPart_Warehouse_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Part_Warehouse_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Part_Warehouse_Detail_Bool_Exp>;
};


export type Subscription_RootParts_RelatedArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


export type Subscription_RootParts_Related_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Related_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Related_Order_By>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


export type Subscription_RootParts_Related_By_PkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type Subscription_RootParts_Related_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Parts_Related_Stream_Cursor_Input>>;
  where?: InputMaybe<Parts_Related_Bool_Exp>;
};


export type Subscription_RootParts_Workflow_Counts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Parts_Workflow_Counts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Workflow_Counts_View_Order_By>>;
  where?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
};


export type Subscription_RootParts_Workflow_Counts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Parts_Workflow_Counts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Parts_Workflow_Counts_View_Order_By>>;
  where?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
};


export type Subscription_RootParts_Workflow_Counts_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Parts_Workflow_Counts_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Parts_Workflow_Counts_View_Bool_Exp>;
};


export type Subscription_RootPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permissions_Order_By>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPermissions_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPermissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Permissions_Bool_Exp>;
};


export type Subscription_RootPhaseArgs = {
  distinct_on?: InputMaybe<Array<Phase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phase_Order_By>>;
  where?: InputMaybe<Phase_Bool_Exp>;
};


export type Subscription_RootPhase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phase_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Phase_Order_By>>;
  where?: InputMaybe<Phase_Bool_Exp>;
};


export type Subscription_RootPhase_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPhase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Phase_Stream_Cursor_Input>>;
  where?: InputMaybe<Phase_Bool_Exp>;
};


export type Subscription_RootPlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPlatform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPlatform_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPlatform_RequirementArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


export type Subscription_RootPlatform_Requirement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Requirement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Requirement_Order_By>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


export type Subscription_RootPlatform_Requirement_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPlatform_Requirement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platform_Requirement_Stream_Cursor_Input>>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
};


export type Subscription_RootPlatform_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPlatform_Utilization_ViewArgs = {
  distinct_on?: InputMaybe<Array<Platform_Utilization_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Utilization_View_Order_By>>;
  where?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
};


export type Subscription_RootPlatform_Utilization_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Utilization_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Utilization_View_Order_By>>;
  where?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
};


export type Subscription_RootPlatform_Utilization_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platform_Utilization_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Platform_Utilization_View_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProduct_OptionArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


export type Subscription_RootProduct_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Order_By>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


export type Subscription_RootProduct_Option_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProduct_Option_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Option_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Option_Choice_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProduct_Option_Choice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Option_Choice_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootProduct_Option_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_TypeArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Type_Order_By>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProduct_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootProduct_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Type_Bool_Exp>;
};


export type Subscription_RootProgramArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


export type Subscription_RootProgram_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Program_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Program_Order_By>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


export type Subscription_RootProgram_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProgram_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Program_Stream_Cursor_Input>>;
  where?: InputMaybe<Program_Bool_Exp>;
};


export type Subscription_RootProjectArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Order_By>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_Base_Product_QuantitiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


export type Subscription_RootProject_Base_Product_Quantities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Base_Product_Quantities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Base_Product_Quantities_Order_By>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


export type Subscription_RootProject_Base_Product_Quantities_By_PkArgs = {
  base_product_id: Scalars['String'];
  project_id: Scalars['String'];
};


export type Subscription_RootProject_Base_Product_Quantities_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Base_Product_Quantities_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Base_Product_Quantities_Bool_Exp>;
};


export type Subscription_RootProject_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProject_CommentArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_Comment_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Comment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


export type Subscription_RootProject_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


export type Subscription_RootProject_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Contacts_Order_By>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


export type Subscription_RootProject_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Contacts_Bool_Exp>;
};


export type Subscription_RootProject_MilestoneArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


export type Subscription_RootProject_Milestone_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Milestone_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Milestone_Order_By>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


export type Subscription_RootProject_Milestone_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Milestone_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Milestone_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Milestone_Bool_Exp>;
};


export type Subscription_RootProject_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


export type Subscription_RootProject_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Module_Order_By>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


export type Subscription_RootProject_Module_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProject_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Module_Bool_Exp>;
};


export type Subscription_RootProject_StatusArgs = {
  distinct_on?: InputMaybe<Array<Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Status_Order_By>>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};


export type Subscription_RootProject_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Status_Order_By>>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};


export type Subscription_RootProject_Status_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProject_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Status_Bool_Exp>;
};


export type Subscription_RootProject_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Bool_Exp>;
};


export type Subscription_RootProject_UsersArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Subscription_RootProject_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Subscription_RootProject_Users_By_PkArgs = {
  projectId: Scalars['String'];
  userId: Scalars['String'];
};


export type Subscription_RootProject_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Project_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


export type Subscription_RootPurchase_TypeArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Type_Order_By>>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};


export type Subscription_RootPurchase_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Purchase_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Purchase_Type_Order_By>>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};


export type Subscription_RootPurchase_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPurchase_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Purchase_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Purchase_Type_Bool_Exp>;
};


export type Subscription_RootQb_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Qb_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Qb_Items_Order_By>>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};


export type Subscription_RootQb_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Qb_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Qb_Items_Order_By>>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};


export type Subscription_RootQb_Items_By_PkArgs = {
  item: Scalars['String'];
};


export type Subscription_RootQb_Items_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Qb_Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Qb_Items_Bool_Exp>;
};


export type Subscription_RootRelation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Relation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relation_Type_Order_By>>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};


export type Subscription_RootRelation_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Relation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Relation_Type_Order_By>>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};


export type Subscription_RootRelation_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootRelation_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Relation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Relation_Type_Bool_Exp>;
};


export type Subscription_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootReport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRole_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Permissions_Order_By>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  roleId: Scalars['String'];
};


export type Subscription_RootRole_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Permissions_Bool_Exp>;
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootScope_Part_Conversion_ViewArgs = {
  distinct_on?: InputMaybe<Array<Scope_Part_Conversion_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scope_Part_Conversion_View_Order_By>>;
  where?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
};


export type Subscription_RootScope_Part_Conversion_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scope_Part_Conversion_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scope_Part_Conversion_View_Order_By>>;
  where?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
};


export type Subscription_RootScope_Part_Conversion_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scope_Part_Conversion_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Scope_Part_Conversion_View_Bool_Exp>;
};


export type Subscription_RootSearch_Parts_ViewArgs = {
  distinct_on?: InputMaybe<Array<Search_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Parts_View_Order_By>>;
  where?: InputMaybe<Search_Parts_View_Bool_Exp>;
};


export type Subscription_RootSearch_Parts_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Parts_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Parts_View_Order_By>>;
  where?: InputMaybe<Search_Parts_View_Bool_Exp>;
};


export type Subscription_RootSearch_Parts_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Parts_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Parts_View_Bool_Exp>;
};


export type Subscription_RootSerial_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Serial_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Serial_Numbers_Order_By>>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};


export type Subscription_RootSerial_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Serial_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Serial_Numbers_Order_By>>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};


export type Subscription_RootSerial_Numbers_By_PkArgs = {
  base_product_id: Scalars['String'];
};


export type Subscription_RootSerial_Numbers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Serial_Numbers_Stream_Cursor_Input>>;
  where?: InputMaybe<Serial_Numbers_Bool_Exp>;
};


export type Subscription_RootShort_UrlArgs = {
  distinct_on?: InputMaybe<Array<Short_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Short_Url_Order_By>>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};


export type Subscription_RootShort_Url_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Short_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Short_Url_Order_By>>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};


export type Subscription_RootShort_Url_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShort_Url_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Short_Url_Stream_Cursor_Input>>;
  where?: InputMaybe<Short_Url_Bool_Exp>;
};


export type Subscription_RootSystem_EventArgs = {
  distinct_on?: InputMaybe<Array<System_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<System_Event_Order_By>>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};


export type Subscription_RootSystem_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<System_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<System_Event_Order_By>>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};


export type Subscription_RootSystem_Event_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSystem_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<System_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};


export type Subscription_RootTag_EntityArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


export type Subscription_RootTag_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


export type Subscription_RootTag_Entity_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTag_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


export type Subscription_RootTag_PathArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Order_By>>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};


export type Subscription_RootTag_Path_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Order_By>>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};


export type Subscription_RootTag_Path_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTag_Path_Segment_ViewArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


export type Subscription_RootTag_Path_Segment_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


export type Subscription_RootTag_Path_Segment_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Path_Segment_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


export type Subscription_RootTag_Path_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Path_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};


export type Subscription_RootTag_SetArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


export type Subscription_RootTag_Set_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


export type Subscription_RootTag_Set_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTag_Set_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Set_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


export type Subscription_RootTag_TypeArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Subscription_RootTag_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Type_Order_By>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Subscription_RootTag_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTag_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tag_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};


export type Subscription_RootTagged_Part_Download_ViewArgs = {
  distinct_on?: InputMaybe<Array<Tagged_Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tagged_Part_Download_View_Order_By>>;
  where?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
};


export type Subscription_RootTagged_Part_Download_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tagged_Part_Download_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tagged_Part_Download_View_Order_By>>;
  where?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
};


export type Subscription_RootTagged_Part_Download_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tagged_Part_Download_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
};


export type Subscription_RootTagsArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tags_Order_By>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootTags_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Tags_Bool_Exp>;
};


export type Subscription_RootToimport_ViewArgs = {
  distinct_on?: InputMaybe<Array<Toimport_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Toimport_View_Order_By>>;
  where?: InputMaybe<Toimport_View_Bool_Exp>;
};


export type Subscription_RootToimport_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Toimport_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Toimport_View_Order_By>>;
  where?: InputMaybe<Toimport_View_Bool_Exp>;
};


export type Subscription_RootToimport_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Toimport_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Toimport_View_Bool_Exp>;
};


export type Subscription_RootUnitArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Order_By>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_Bom_Entity_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


export type Subscription_RootUnit_Bom_Entity_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


export type Subscription_RootUnit_Bom_Entity_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Bom_Entity_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


export type Subscription_RootUnit_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUnit_Product_Option_ChoiceArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootUnit_Product_Option_Choice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootUnit_Product_Option_Choice_By_PkArgs = {
  product_option_choice_id: Scalars['String'];
  unit_id: Scalars['String'];
};


export type Subscription_RootUnit_Product_Option_Choice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Product_Option_Choice_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


export type Subscription_RootUnit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_Path_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_Path_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_Path_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_Path_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_Path_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_Path_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_Path_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Tag_Path_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_ViewArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


export type Subscription_RootUnit_Tag_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Unit_Tag_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


export type Subscription_RootUomArgs = {
  distinct_on?: InputMaybe<Array<Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Order_By>>;
  where?: InputMaybe<Uom_Bool_Exp>;
};


export type Subscription_RootUom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Order_By>>;
  where?: InputMaybe<Uom_Bool_Exp>;
};


export type Subscription_RootUom_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUom_ClassificationArgs = {
  distinct_on?: InputMaybe<Array<Uom_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Classification_Order_By>>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};


export type Subscription_RootUom_Classification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Classification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Classification_Order_By>>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};


export type Subscription_RootUom_Classification_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_Classification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Classification_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};


export type Subscription_RootUom_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_Conversion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Conversion_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Csi_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Csi_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_Csi_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_Csi_Conversion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Csi_Conversion_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_ScopeArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Order_By>>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};


export type Subscription_RootUom_Scope_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Order_By>>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};


export type Subscription_RootUom_Scope_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_Scope_PartArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


export type Subscription_RootUom_Scope_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


export type Subscription_RootUom_Scope_Part_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_Scope_Part_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Scope_Part_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


export type Subscription_RootUom_Scope_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Scope_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};


export type Subscription_RootUom_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_Bool_Exp>;
};


export type Subscription_RootUom_System_ConversionArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_System_Conversion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


export type Subscription_RootUom_System_Conversion_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUom_System_Conversion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Uom_System_Conversion_Stream_Cursor_Input>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_InfoArgs = {
  distinct_on?: InputMaybe<Array<User_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Info_Order_By>>;
  where?: InputMaybe<User_Info_Bool_Exp>;
};


export type Subscription_RootUser_Info_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Info_Order_By>>;
  where?: InputMaybe<User_Info_Bool_Exp>;
};


export type Subscription_RootUser_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Info_Bool_Exp>;
};


export type Subscription_RootUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_Permissions_By_PkArgs = {
  permissionId: Scalars['String'];
  userId: Scalars['String'];
};


export type Subscription_RootUser_Permissions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Permissions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


export type Subscription_RootUser_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_Role_By_PkArgs = {
  roleId: Scalars['String'];
  userId: Scalars['String'];
};


export type Subscription_RootUser_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootVendorArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Order_By>>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};


export type Subscription_RootVendor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Order_By>>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};


export type Subscription_RootVendor_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootVendor_Cleanup_AuditArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Audit_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};


export type Subscription_RootVendor_Cleanup_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Audit_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};


export type Subscription_RootVendor_Cleanup_Audit_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootVendor_Cleanup_Audit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vendor_Cleanup_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};


export type Subscription_RootVendor_Cleanup_Wevr_Mapping_LookupArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};


export type Subscription_RootVendor_Cleanup_Wevr_Mapping_Lookup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Order_By>>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};


export type Subscription_RootVendor_Cleanup_Wevr_Mapping_Lookup_By_PkArgs = {
  matapp_vendor_id: Scalars['String'];
};


export type Subscription_RootVendor_Cleanup_Wevr_Mapping_Lookup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};


export type Subscription_RootVendor_PartsArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


export type Subscription_RootVendor_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


export type Subscription_RootVendor_Parts_By_PkArgs = {
  partId: Scalars['String'];
  vendorId: Scalars['String'];
};


export type Subscription_RootVendor_Parts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vendor_Parts_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


export type Subscription_RootVendor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vendor_Stream_Cursor_Input>>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};


export type Subscription_RootWorkflowArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Subscription_RootWorkflow_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Workflow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Workflow_Order_By>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};


export type Subscription_RootWorkflow_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootWorkflow_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Workflow_Stream_Cursor_Input>>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};

/** columns and relationships of "system_event" */
export type System_Event = {
  __typename?: 'system_event';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** aggregated selection of "system_event" */
export type System_Event_Aggregate = {
  __typename?: 'system_event_aggregate';
  aggregate?: Maybe<System_Event_Aggregate_Fields>;
  nodes: Array<System_Event>;
};

/** aggregate fields of "system_event" */
export type System_Event_Aggregate_Fields = {
  __typename?: 'system_event_aggregate_fields';
  avg?: Maybe<System_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<System_Event_Max_Fields>;
  min?: Maybe<System_Event_Min_Fields>;
  stddev?: Maybe<System_Event_Stddev_Fields>;
  stddev_pop?: Maybe<System_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<System_Event_Stddev_Samp_Fields>;
  sum?: Maybe<System_Event_Sum_Fields>;
  var_pop?: Maybe<System_Event_Var_Pop_Fields>;
  var_samp?: Maybe<System_Event_Var_Samp_Fields>;
  variance?: Maybe<System_Event_Variance_Fields>;
};


/** aggregate fields of "system_event" */
export type System_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<System_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type System_Event_Avg_Fields = {
  __typename?: 'system_event_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "system_event". All fields are combined with a logical 'AND'. */
export type System_Event_Bool_Exp = {
  _and?: InputMaybe<Array<System_Event_Bool_Exp>>;
  _not?: InputMaybe<System_Event_Bool_Exp>;
  _or?: InputMaybe<Array<System_Event_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "system_event" */
export type System_Event_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'system_event_pkey';

/** input type for incrementing numeric columns in table "system_event" */
export type System_Event_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "system_event" */
export type System_Event_Insert_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type System_Event_Max_Fields = {
  __typename?: 'system_event_max_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type System_Event_Min_Fields = {
  __typename?: 'system_event_min_fields';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "system_event" */
export type System_Event_Mutation_Response = {
  __typename?: 'system_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<System_Event>;
};

/** on_conflict condition type for table "system_event" */
export type System_Event_On_Conflict = {
  constraint: System_Event_Constraint;
  update_columns?: Array<System_Event_Update_Column>;
  where?: InputMaybe<System_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "system_event". */
export type System_Event_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: system_event */
export type System_Event_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "system_event" */
export type System_Event_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

/** input type for updating data in table "system_event" */
export type System_Event_Set_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type System_Event_Stddev_Fields = {
  __typename?: 'system_event_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type System_Event_Stddev_Pop_Fields = {
  __typename?: 'system_event_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type System_Event_Stddev_Samp_Fields = {
  __typename?: 'system_event_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "system_event" */
export type System_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: System_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type System_Event_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type System_Event_Sum_Fields = {
  __typename?: 'system_event_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "system_event" */
export type System_Event_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name';

export type System_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<System_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<System_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: System_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type System_Event_Var_Pop_Fields = {
  __typename?: 'system_event_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type System_Event_Var_Samp_Fields = {
  __typename?: 'system_event_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type System_Event_Variance_Fields = {
  __typename?: 'system_event_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Used to track the relationships between tags and other records in our db. */
export type Tag_Entity = {
  __typename?: 'tag_entity';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  entity_id: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  tag: Tags;
  tag_id: Scalars['Int'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregated selection of "tag_entity" */
export type Tag_Entity_Aggregate = {
  __typename?: 'tag_entity_aggregate';
  aggregate?: Maybe<Tag_Entity_Aggregate_Fields>;
  nodes: Array<Tag_Entity>;
};

export type Tag_Entity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tag_Entity_Aggregate_Bool_Exp_Count>;
};

export type Tag_Entity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Entity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tag_entity" */
export type Tag_Entity_Aggregate_Fields = {
  __typename?: 'tag_entity_aggregate_fields';
  avg?: Maybe<Tag_Entity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Entity_Max_Fields>;
  min?: Maybe<Tag_Entity_Min_Fields>;
  stddev?: Maybe<Tag_Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Entity_Sum_Fields>;
  var_pop?: Maybe<Tag_Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Entity_Var_Samp_Fields>;
  variance?: Maybe<Tag_Entity_Variance_Fields>;
};


/** aggregate fields of "tag_entity" */
export type Tag_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tag_entity" */
export type Tag_Entity_Aggregate_Order_By = {
  avg?: InputMaybe<Tag_Entity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Entity_Max_Order_By>;
  min?: InputMaybe<Tag_Entity_Min_Order_By>;
  stddev?: InputMaybe<Tag_Entity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tag_Entity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tag_Entity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tag_Entity_Sum_Order_By>;
  var_pop?: InputMaybe<Tag_Entity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tag_Entity_Var_Samp_Order_By>;
  variance?: InputMaybe<Tag_Entity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tag_entity" */
export type Tag_Entity_Arr_Rel_Insert_Input = {
  data: Array<Tag_Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Entity_On_Conflict>;
};

/** aggregate avg on columns */
export type Tag_Entity_Avg_Fields = {
  __typename?: 'tag_entity_avg_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tag_entity" */
export type Tag_Entity_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tag_entity". All fields are combined with a logical 'AND'. */
export type Tag_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Entity_Bool_Exp>>;
  _not?: InputMaybe<Tag_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Entity_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  tag?: InputMaybe<Tags_Bool_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_entity" */
export type Tag_Entity_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'tag_entity_pkey'
  /** unique or primary key constraint on columns "entity_id", "tag_id" */
  | 'tag_entity_tag_id_entity_id_key';

/** input type for incrementing numeric columns in table "tag_entity" */
export type Tag_Entity_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag_entity" */
export type Tag_Entity_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Tags_Obj_Rel_Insert_Input>;
  tag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tag_Entity_Max_Fields = {
  __typename?: 'tag_entity_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "tag_entity" */
export type Tag_Entity_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tag_Entity_Min_Fields = {
  __typename?: 'tag_entity_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "tag_entity" */
export type Tag_Entity_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tag_entity" */
export type Tag_Entity_Mutation_Response = {
  __typename?: 'tag_entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Entity>;
};

/** on_conflict condition type for table "tag_entity" */
export type Tag_Entity_On_Conflict = {
  constraint: Tag_Entity_Constraint;
  update_columns?: Array<Tag_Entity_Update_Column>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_entity". */
export type Tag_Entity_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tag?: InputMaybe<Tags_Order_By>;
  tag_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_entity */
export type Tag_Entity_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tag_entity" */
export type Tag_Entity_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'entity_id'
  /** column name */
  | 'id'
  /** column name */
  | 'tag_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for updating data in table "tag_entity" */
export type Tag_Entity_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tag_Entity_Stddev_Fields = {
  __typename?: 'tag_entity_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tag_entity" */
export type Tag_Entity_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tag_Entity_Stddev_Pop_Fields = {
  __typename?: 'tag_entity_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tag_entity" */
export type Tag_Entity_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tag_Entity_Stddev_Samp_Fields = {
  __typename?: 'tag_entity_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tag_entity" */
export type Tag_Entity_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tag_entity" */
export type Tag_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Entity_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tag_Entity_Sum_Fields = {
  __typename?: 'tag_entity_sum_fields';
  id?: Maybe<Scalars['Int']>;
  tag_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tag_entity" */
export type Tag_Entity_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** update columns of table "tag_entity" */
export type Tag_Entity_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'entity_id'
  /** column name */
  | 'id'
  /** column name */
  | 'tag_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Tag_Entity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Entity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Entity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tag_Entity_Var_Pop_Fields = {
  __typename?: 'tag_entity_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tag_entity" */
export type Tag_Entity_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tag_Entity_Var_Samp_Fields = {
  __typename?: 'tag_entity_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tag_entity" */
export type Tag_Entity_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tag_Entity_Variance_Fields = {
  __typename?: 'tag_entity_variance_fields';
  id?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tag_entity" */
export type Tag_Entity_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "tag_path" */
export type Tag_Path = {
  __typename?: 'tag_path';
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  path: Scalars['ltree'];
  /** An array relationship */
  path_segments: Array<Tag_Path_Segment_View>;
  /** An aggregate relationship */
  path_segments_aggregate: Tag_Path_Segment_View_Aggregate;
  /** An array relationship */
  tag_sets: Array<Tag_Set>;
  /** An aggregate relationship */
  tag_sets_aggregate: Tag_Set_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "tag_path" */
export type Tag_PathPath_SegmentsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


/** columns and relationships of "tag_path" */
export type Tag_PathPath_Segments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Path_Segment_View_Order_By>>;
  where?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
};


/** columns and relationships of "tag_path" */
export type Tag_PathTag_SetsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};


/** columns and relationships of "tag_path" */
export type Tag_PathTag_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Set_Order_By>>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};

/** aggregated selection of "tag_path" */
export type Tag_Path_Aggregate = {
  __typename?: 'tag_path_aggregate';
  aggregate?: Maybe<Tag_Path_Aggregate_Fields>;
  nodes: Array<Tag_Path>;
};

/** aggregate fields of "tag_path" */
export type Tag_Path_Aggregate_Fields = {
  __typename?: 'tag_path_aggregate_fields';
  avg?: Maybe<Tag_Path_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Path_Max_Fields>;
  min?: Maybe<Tag_Path_Min_Fields>;
  stddev?: Maybe<Tag_Path_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Path_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Path_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Path_Sum_Fields>;
  var_pop?: Maybe<Tag_Path_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Path_Var_Samp_Fields>;
  variance?: Maybe<Tag_Path_Variance_Fields>;
};


/** aggregate fields of "tag_path" */
export type Tag_Path_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Path_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tag_Path_Avg_Fields = {
  __typename?: 'tag_path_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tag_path". All fields are combined with a logical 'AND'. */
export type Tag_Path_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Path_Bool_Exp>>;
  _not?: InputMaybe<Tag_Path_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Path_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<Ltree_Comparison_Exp>;
  path_segments?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
  path_segments_aggregate?: InputMaybe<Tag_Path_Segment_View_Aggregate_Bool_Exp>;
  tag_sets?: InputMaybe<Tag_Set_Bool_Exp>;
  tag_sets_aggregate?: InputMaybe<Tag_Set_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_path" */
export type Tag_Path_Constraint =
  /** unique or primary key constraint on columns "path" */
  | 'tag_path_path_key'
  /** unique or primary key constraint on columns "id" */
  | 'tag_path_pkey';

/** input type for incrementing numeric columns in table "tag_path" */
export type Tag_Path_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag_path" */
export type Tag_Path_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  path_segments?: InputMaybe<Tag_Path_Segment_View_Arr_Rel_Insert_Input>;
  tag_sets?: InputMaybe<Tag_Set_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Tag_Path_Max_Fields = {
  __typename?: 'tag_path_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Tag_Path_Min_Fields = {
  __typename?: 'tag_path_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['ltree']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "tag_path" */
export type Tag_Path_Mutation_Response = {
  __typename?: 'tag_path_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Path>;
};

/** input type for inserting object relation for remote table "tag_path" */
export type Tag_Path_Obj_Rel_Insert_Input = {
  data: Tag_Path_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Path_On_Conflict>;
};

/** on_conflict condition type for table "tag_path" */
export type Tag_Path_On_Conflict = {
  constraint: Tag_Path_Constraint;
  update_columns?: Array<Tag_Path_Update_Column>;
  where?: InputMaybe<Tag_Path_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_path". */
export type Tag_Path_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  path_segments_aggregate?: InputMaybe<Tag_Path_Segment_View_Aggregate_Order_By>;
  tag_sets_aggregate?: InputMaybe<Tag_Set_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_path */
export type Tag_Path_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "tag_path_segment_view" */
export type Tag_Path_Segment_View = {
  __typename?: 'tag_path_segment_view';
  segment?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
  tag_name?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_type_sequence?: Maybe<Scalars['Int']>;
  tag_type_value?: Maybe<Scalars['String']>;
  tag_value?: Maybe<Scalars['String']>;
};

/** aggregated selection of "tag_path_segment_view" */
export type Tag_Path_Segment_View_Aggregate = {
  __typename?: 'tag_path_segment_view_aggregate';
  aggregate?: Maybe<Tag_Path_Segment_View_Aggregate_Fields>;
  nodes: Array<Tag_Path_Segment_View>;
};

export type Tag_Path_Segment_View_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tag_Path_Segment_View_Aggregate_Bool_Exp_Count>;
};

export type Tag_Path_Segment_View_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tag_path_segment_view" */
export type Tag_Path_Segment_View_Aggregate_Fields = {
  __typename?: 'tag_path_segment_view_aggregate_fields';
  avg?: Maybe<Tag_Path_Segment_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Path_Segment_View_Max_Fields>;
  min?: Maybe<Tag_Path_Segment_View_Min_Fields>;
  stddev?: Maybe<Tag_Path_Segment_View_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Path_Segment_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Path_Segment_View_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Path_Segment_View_Sum_Fields>;
  var_pop?: Maybe<Tag_Path_Segment_View_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Path_Segment_View_Var_Samp_Fields>;
  variance?: Maybe<Tag_Path_Segment_View_Variance_Fields>;
};


/** aggregate fields of "tag_path_segment_view" */
export type Tag_Path_Segment_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Path_Segment_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Aggregate_Order_By = {
  avg?: InputMaybe<Tag_Path_Segment_View_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Path_Segment_View_Max_Order_By>;
  min?: InputMaybe<Tag_Path_Segment_View_Min_Order_By>;
  stddev?: InputMaybe<Tag_Path_Segment_View_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tag_Path_Segment_View_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tag_Path_Segment_View_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tag_Path_Segment_View_Sum_Order_By>;
  var_pop?: InputMaybe<Tag_Path_Segment_View_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tag_Path_Segment_View_Var_Samp_Order_By>;
  variance?: InputMaybe<Tag_Path_Segment_View_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Arr_Rel_Insert_Input = {
  data: Array<Tag_Path_Segment_View_Insert_Input>;
};

/** aggregate avg on columns */
export type Tag_Path_Segment_View_Avg_Fields = {
  __typename?: 'tag_path_segment_view_avg_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Avg_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tag_path_segment_view". All fields are combined with a logical 'AND'. */
export type Tag_Path_Segment_View_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Path_Segment_View_Bool_Exp>>;
  _not?: InputMaybe<Tag_Path_Segment_View_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Path_Segment_View_Bool_Exp>>;
  segment?: InputMaybe<String_Comparison_Exp>;
  sort_order?: InputMaybe<Bigint_Comparison_Exp>;
  tag_id?: InputMaybe<Int_Comparison_Exp>;
  tag_name?: InputMaybe<String_Comparison_Exp>;
  tag_path?: InputMaybe<Ltree_Comparison_Exp>;
  tag_path_id?: InputMaybe<Int_Comparison_Exp>;
  tag_type_sequence?: InputMaybe<Int_Comparison_Exp>;
  tag_type_value?: InputMaybe<String_Comparison_Exp>;
  tag_value?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Insert_Input = {
  segment?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['bigint']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  tag_name?: InputMaybe<Scalars['String']>;
  tag_path?: InputMaybe<Scalars['ltree']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
  tag_type_sequence?: InputMaybe<Scalars['Int']>;
  tag_type_value?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tag_Path_Segment_View_Max_Fields = {
  __typename?: 'tag_path_segment_view_max_fields';
  segment?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
  tag_name?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_type_sequence?: Maybe<Scalars['Int']>;
  tag_type_value?: Maybe<Scalars['String']>;
  tag_value?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Max_Order_By = {
  segment?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
  tag_path?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
  tag_type_value?: InputMaybe<Order_By>;
  tag_value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tag_Path_Segment_View_Min_Fields = {
  __typename?: 'tag_path_segment_view_min_fields';
  segment?: Maybe<Scalars['String']>;
  sort_order?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
  tag_name?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_type_sequence?: Maybe<Scalars['Int']>;
  tag_type_value?: Maybe<Scalars['String']>;
  tag_value?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Min_Order_By = {
  segment?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
  tag_path?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
  tag_type_value?: InputMaybe<Order_By>;
  tag_value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tag_path_segment_view". */
export type Tag_Path_Segment_View_Order_By = {
  segment?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_name?: InputMaybe<Order_By>;
  tag_path?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
  tag_type_value?: InputMaybe<Order_By>;
  tag_value?: InputMaybe<Order_By>;
};

/** select columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Select_Column =
  /** column name */
  | 'segment'
  /** column name */
  | 'sort_order'
  /** column name */
  | 'tag_id'
  /** column name */
  | 'tag_name'
  /** column name */
  | 'tag_path'
  /** column name */
  | 'tag_path_id'
  /** column name */
  | 'tag_type_sequence'
  /** column name */
  | 'tag_type_value'
  /** column name */
  | 'tag_value';

/** aggregate stddev on columns */
export type Tag_Path_Segment_View_Stddev_Fields = {
  __typename?: 'tag_path_segment_view_stddev_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Stddev_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tag_Path_Segment_View_Stddev_Pop_Fields = {
  __typename?: 'tag_path_segment_view_stddev_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Stddev_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tag_Path_Segment_View_Stddev_Samp_Fields = {
  __typename?: 'tag_path_segment_view_stddev_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Stddev_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Path_Segment_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Path_Segment_View_Stream_Cursor_Value_Input = {
  segment?: InputMaybe<Scalars['String']>;
  sort_order?: InputMaybe<Scalars['bigint']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  tag_name?: InputMaybe<Scalars['String']>;
  tag_path?: InputMaybe<Scalars['ltree']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
  tag_type_sequence?: InputMaybe<Scalars['Int']>;
  tag_type_value?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tag_Path_Segment_View_Sum_Fields = {
  __typename?: 'tag_path_segment_view_sum_fields';
  sort_order?: Maybe<Scalars['bigint']>;
  tag_id?: Maybe<Scalars['Int']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_type_sequence?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Sum_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Tag_Path_Segment_View_Var_Pop_Fields = {
  __typename?: 'tag_path_segment_view_var_pop_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Var_Pop_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tag_Path_Segment_View_Var_Samp_Fields = {
  __typename?: 'tag_path_segment_view_var_samp_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Var_Samp_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tag_Path_Segment_View_Variance_Fields = {
  __typename?: 'tag_path_segment_view_variance_fields';
  sort_order?: Maybe<Scalars['Float']>;
  tag_id?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  tag_type_sequence?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tag_path_segment_view" */
export type Tag_Path_Segment_View_Variance_Order_By = {
  sort_order?: InputMaybe<Order_By>;
  tag_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_type_sequence?: InputMaybe<Order_By>;
};

/** select columns of table "tag_path" */
export type Tag_Path_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'path'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "tag_path" */
export type Tag_Path_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Tag_Path_Stddev_Fields = {
  __typename?: 'tag_path_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tag_Path_Stddev_Pop_Fields = {
  __typename?: 'tag_path_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tag_Path_Stddev_Samp_Fields = {
  __typename?: 'tag_path_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tag_path" */
export type Tag_Path_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Path_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Path_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  path?: InputMaybe<Scalars['ltree']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Tag_Path_Sum_Fields = {
  __typename?: 'tag_path_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "tag_path" */
export type Tag_Path_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'path'
  /** column name */
  | 'updated_at';

export type Tag_Path_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Path_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Path_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Path_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tag_Path_Var_Pop_Fields = {
  __typename?: 'tag_path_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tag_Path_Var_Samp_Fields = {
  __typename?: 'tag_path_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tag_Path_Variance_Fields = {
  __typename?: 'tag_path_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tag_set" */
export type Tag_Set = {
  __typename?: 'tag_set';
  /** An array relationship */
  bom_item_tag_sets: Array<Bom_Item_Tag_Set>;
  /** An aggregate relationship */
  bom_item_tag_sets_aggregate: Bom_Item_Tag_Set_Aggregate;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  selected_json?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  tag_path: Tag_Path;
  tag_path_id: Scalars['Int'];
};


/** columns and relationships of "tag_set" */
export type Tag_SetBom_Item_Tag_SetsArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


/** columns and relationships of "tag_set" */
export type Tag_SetBom_Item_Tag_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bom_Item_Tag_Set_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bom_Item_Tag_Set_Order_By>>;
  where?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
};


/** columns and relationships of "tag_set" */
export type Tag_SetSelected_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tag_set" */
export type Tag_Set_Aggregate = {
  __typename?: 'tag_set_aggregate';
  aggregate?: Maybe<Tag_Set_Aggregate_Fields>;
  nodes: Array<Tag_Set>;
};

export type Tag_Set_Aggregate_Bool_Exp = {
  count?: InputMaybe<Tag_Set_Aggregate_Bool_Exp_Count>;
};

export type Tag_Set_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Tag_Set_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Tag_Set_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tag_set" */
export type Tag_Set_Aggregate_Fields = {
  __typename?: 'tag_set_aggregate_fields';
  avg?: Maybe<Tag_Set_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Set_Max_Fields>;
  min?: Maybe<Tag_Set_Min_Fields>;
  stddev?: Maybe<Tag_Set_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Set_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Set_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Set_Sum_Fields>;
  var_pop?: Maybe<Tag_Set_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Set_Var_Samp_Fields>;
  variance?: Maybe<Tag_Set_Variance_Fields>;
};


/** aggregate fields of "tag_set" */
export type Tag_Set_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Set_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tag_set" */
export type Tag_Set_Aggregate_Order_By = {
  avg?: InputMaybe<Tag_Set_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Tag_Set_Max_Order_By>;
  min?: InputMaybe<Tag_Set_Min_Order_By>;
  stddev?: InputMaybe<Tag_Set_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Tag_Set_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Tag_Set_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Tag_Set_Sum_Order_By>;
  var_pop?: InputMaybe<Tag_Set_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Tag_Set_Var_Samp_Order_By>;
  variance?: InputMaybe<Tag_Set_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tag_Set_Append_Input = {
  selected_json?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "tag_set" */
export type Tag_Set_Arr_Rel_Insert_Input = {
  data: Array<Tag_Set_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Set_On_Conflict>;
};

/** aggregate avg on columns */
export type Tag_Set_Avg_Fields = {
  __typename?: 'tag_set_avg_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tag_set" */
export type Tag_Set_Avg_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tag_set". All fields are combined with a logical 'AND'. */
export type Tag_Set_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Set_Bool_Exp>>;
  _not?: InputMaybe<Tag_Set_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Set_Bool_Exp>>;
  bom_item_tag_sets?: InputMaybe<Bom_Item_Tag_Set_Bool_Exp>;
  bom_item_tag_sets_aggregate?: InputMaybe<Bom_Item_Tag_Set_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  selected_json?: InputMaybe<Jsonb_Comparison_Exp>;
  tag_path?: InputMaybe<Tag_Path_Bool_Exp>;
  tag_path_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_set" */
export type Tag_Set_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'tag_set_pkey'
  /** unique or primary key constraint on columns "selected_json" */
  | 'unique_json';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tag_Set_Delete_At_Path_Input = {
  selected_json?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tag_Set_Delete_Elem_Input = {
  selected_json?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tag_Set_Delete_Key_Input = {
  selected_json?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "tag_set" */
export type Tag_Set_Inc_Input = {
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag_set" */
export type Tag_Set_Insert_Input = {
  bom_item_tag_sets?: InputMaybe<Bom_Item_Tag_Set_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  selected_json?: InputMaybe<Scalars['jsonb']>;
  tag_path?: InputMaybe<Tag_Path_Obj_Rel_Insert_Input>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Tag_Set_Max_Fields = {
  __typename?: 'tag_set_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "tag_set" */
export type Tag_Set_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Tag_Set_Min_Fields = {
  __typename?: 'tag_set_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "tag_set" */
export type Tag_Set_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tag_set" */
export type Tag_Set_Mutation_Response = {
  __typename?: 'tag_set_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Set>;
};

/** input type for inserting object relation for remote table "tag_set" */
export type Tag_Set_Obj_Rel_Insert_Input = {
  data: Tag_Set_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Set_On_Conflict>;
};

/** on_conflict condition type for table "tag_set" */
export type Tag_Set_On_Conflict = {
  constraint: Tag_Set_Constraint;
  update_columns?: Array<Tag_Set_Update_Column>;
  where?: InputMaybe<Tag_Set_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_set". */
export type Tag_Set_Order_By = {
  bom_item_tag_sets_aggregate?: InputMaybe<Bom_Item_Tag_Set_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  selected_json?: InputMaybe<Order_By>;
  tag_path?: InputMaybe<Tag_Path_Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_set */
export type Tag_Set_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tag_Set_Prepend_Input = {
  selected_json?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tag_set" */
export type Tag_Set_Select_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'selected_json'
  /** column name */
  | 'tag_path_id';

/** input type for updating data in table "tag_set" */
export type Tag_Set_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  selected_json?: InputMaybe<Scalars['jsonb']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Tag_Set_Stddev_Fields = {
  __typename?: 'tag_set_stddev_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tag_set" */
export type Tag_Set_Stddev_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Tag_Set_Stddev_Pop_Fields = {
  __typename?: 'tag_set_stddev_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tag_set" */
export type Tag_Set_Stddev_Pop_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Tag_Set_Stddev_Samp_Fields = {
  __typename?: 'tag_set_stddev_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tag_set" */
export type Tag_Set_Stddev_Samp_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tag_set" */
export type Tag_Set_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Set_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Set_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  selected_json?: InputMaybe<Scalars['jsonb']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Tag_Set_Sum_Fields = {
  __typename?: 'tag_set_sum_fields';
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "tag_set" */
export type Tag_Set_Sum_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** update columns of table "tag_set" */
export type Tag_Set_Update_Column =
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'selected_json'
  /** column name */
  | 'tag_path_id';

export type Tag_Set_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tag_Set_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tag_Set_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tag_Set_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tag_Set_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Set_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tag_Set_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Set_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tag_Set_Var_Pop_Fields = {
  __typename?: 'tag_set_var_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tag_set" */
export type Tag_Set_Var_Pop_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Tag_Set_Var_Samp_Fields = {
  __typename?: 'tag_set_var_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tag_set" */
export type Tag_Set_Var_Samp_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Tag_Set_Variance_Fields = {
  __typename?: 'tag_set_variance_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tag_set" */
export type Tag_Set_Variance_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** Table defining various tag types. */
export type Tag_Type = {
  __typename?: 'tag_type';
  description: Scalars['String'];
  id: Scalars['Int'];
  sequence?: Maybe<Scalars['Int']>;
  value: Scalars['String'];
};

/** aggregated selection of "tag_type" */
export type Tag_Type_Aggregate = {
  __typename?: 'tag_type_aggregate';
  aggregate?: Maybe<Tag_Type_Aggregate_Fields>;
  nodes: Array<Tag_Type>;
};

/** aggregate fields of "tag_type" */
export type Tag_Type_Aggregate_Fields = {
  __typename?: 'tag_type_aggregate_fields';
  avg?: Maybe<Tag_Type_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tag_Type_Max_Fields>;
  min?: Maybe<Tag_Type_Min_Fields>;
  stddev?: Maybe<Tag_Type_Stddev_Fields>;
  stddev_pop?: Maybe<Tag_Type_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tag_Type_Stddev_Samp_Fields>;
  sum?: Maybe<Tag_Type_Sum_Fields>;
  var_pop?: Maybe<Tag_Type_Var_Pop_Fields>;
  var_samp?: Maybe<Tag_Type_Var_Samp_Fields>;
  variance?: Maybe<Tag_Type_Variance_Fields>;
};


/** aggregate fields of "tag_type" */
export type Tag_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tag_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tag_Type_Avg_Fields = {
  __typename?: 'tag_type_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tag_type". All fields are combined with a logical 'AND'. */
export type Tag_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Tag_Type_Bool_Exp>>;
  _not?: InputMaybe<Tag_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Tag_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tag_type" */
export type Tag_Type_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'tag_type_pkey';

/** input type for incrementing numeric columns in table "tag_type" */
export type Tag_Type_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tag_type" */
export type Tag_Type_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tag_Type_Max_Fields = {
  __typename?: 'tag_type_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sequence?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tag_Type_Min_Fields = {
  __typename?: 'tag_type_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sequence?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tag_type" */
export type Tag_Type_Mutation_Response = {
  __typename?: 'tag_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Type>;
};

/** on_conflict condition type for table "tag_type" */
export type Tag_Type_On_Conflict = {
  constraint: Tag_Type_Constraint;
  update_columns?: Array<Tag_Type_Update_Column>;
  where?: InputMaybe<Tag_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "tag_type". */
export type Tag_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tag_type */
export type Tag_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tag_type" */
export type Tag_Type_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'sequence'
  /** column name */
  | 'value';

/** input type for updating data in table "tag_type" */
export type Tag_Type_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tag_Type_Stddev_Fields = {
  __typename?: 'tag_type_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tag_Type_Stddev_Pop_Fields = {
  __typename?: 'tag_type_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tag_Type_Stddev_Samp_Fields = {
  __typename?: 'tag_type_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tag_type" */
export type Tag_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tag_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tag_Type_Sum_Fields = {
  __typename?: 'tag_type_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sequence?: Maybe<Scalars['Int']>;
};

/** update columns of table "tag_type" */
export type Tag_Type_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'sequence'
  /** column name */
  | 'value';

export type Tag_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tag_Type_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tag_Type_Var_Pop_Fields = {
  __typename?: 'tag_type_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tag_Type_Var_Samp_Fields = {
  __typename?: 'tag_type_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tag_Type_Variance_Fields = {
  __typename?: 'tag_type_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tagged_part_download_view" */
export type Tagged_Part_Download_View = {
  __typename?: 'tagged_part_download_view';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  bom_item_tag_set_id?: Maybe<Scalars['uuid']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  include_waste?: Maybe<Scalars['Boolean']>;
  inventory_classification?: Maybe<Scalars['String']>;
  is_app_design_approved?: Maybe<Scalars['Boolean']>;
  is_finance_approved?: Maybe<Scalars['Boolean']>;
  is_in_accounting_system?: Maybe<Scalars['Boolean']>;
  is_supply_chain_approved?: Maybe<Scalars['Boolean']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  selected_json?: Maybe<Scalars['jsonb']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  tag_set_name?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};


/** columns and relationships of "tagged_part_download_view" */
export type Tagged_Part_Download_ViewSelected_JsonArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tagged_part_download_view" */
export type Tagged_Part_Download_View_Aggregate = {
  __typename?: 'tagged_part_download_view_aggregate';
  aggregate?: Maybe<Tagged_Part_Download_View_Aggregate_Fields>;
  nodes: Array<Tagged_Part_Download_View>;
};

/** aggregate fields of "tagged_part_download_view" */
export type Tagged_Part_Download_View_Aggregate_Fields = {
  __typename?: 'tagged_part_download_view_aggregate_fields';
  avg?: Maybe<Tagged_Part_Download_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tagged_Part_Download_View_Max_Fields>;
  min?: Maybe<Tagged_Part_Download_View_Min_Fields>;
  stddev?: Maybe<Tagged_Part_Download_View_Stddev_Fields>;
  stddev_pop?: Maybe<Tagged_Part_Download_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tagged_Part_Download_View_Stddev_Samp_Fields>;
  sum?: Maybe<Tagged_Part_Download_View_Sum_Fields>;
  var_pop?: Maybe<Tagged_Part_Download_View_Var_Pop_Fields>;
  var_samp?: Maybe<Tagged_Part_Download_View_Var_Samp_Fields>;
  variance?: Maybe<Tagged_Part_Download_View_Variance_Fields>;
};


/** aggregate fields of "tagged_part_download_view" */
export type Tagged_Part_Download_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tagged_Part_Download_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tagged_Part_Download_View_Avg_Fields = {
  __typename?: 'tagged_part_download_view_avg_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tagged_part_download_view". All fields are combined with a logical 'AND'. */
export type Tagged_Part_Download_View_Bool_Exp = {
  _and?: InputMaybe<Array<Tagged_Part_Download_View_Bool_Exp>>;
  _not?: InputMaybe<Tagged_Part_Download_View_Bool_Exp>;
  _or?: InputMaybe<Array<Tagged_Part_Download_View_Bool_Exp>>;
  accounting_base_measure?: InputMaybe<Numeric_Comparison_Exp>;
  accounting_base_uom?: InputMaybe<String_Comparison_Exp>;
  ae_responsible?: InputMaybe<String_Comparison_Exp>;
  bom_item_tag_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer?: InputMaybe<String_Comparison_Exp>;
  cogs_account?: InputMaybe<String_Comparison_Exp>;
  conversion_rate?: InputMaybe<Numeric_Comparison_Exp>;
  cost?: InputMaybe<Numeric_Comparison_Exp>;
  csi_division?: InputMaybe<String_Comparison_Exp>;
  cut_sheet_url?: InputMaybe<String_Comparison_Exp>;
  design_measure?: InputMaybe<Numeric_Comparison_Exp>;
  design_uom?: InputMaybe<String_Comparison_Exp>;
  est_daily_consumption?: InputMaybe<String_Comparison_Exp>;
  estimating_measure?: InputMaybe<Numeric_Comparison_Exp>;
  estimating_uom?: InputMaybe<String_Comparison_Exp>;
  finish_color?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  include_waste?: InputMaybe<Boolean_Comparison_Exp>;
  inventory_classification?: InputMaybe<String_Comparison_Exp>;
  is_app_design_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_finance_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_in_accounting_system?: InputMaybe<Boolean_Comparison_Exp>;
  is_supply_chain_approved?: InputMaybe<Boolean_Comparison_Exp>;
  issuing_measure?: InputMaybe<Numeric_Comparison_Exp>;
  issuing_uom?: InputMaybe<String_Comparison_Exp>;
  item_type?: InputMaybe<String_Comparison_Exp>;
  location_name?: InputMaybe<String_Comparison_Exp>;
  lot_size?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturer?: InputMaybe<String_Comparison_Exp>;
  manufacturer_part_number?: InputMaybe<String_Comparison_Exp>;
  material?: InputMaybe<String_Comparison_Exp>;
  material_issued_uom?: InputMaybe<String_Comparison_Exp>;
  max_daily_consumption?: InputMaybe<String_Comparison_Exp>;
  minimum_order_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  old_part_numbers?: InputMaybe<String_Comparison_Exp>;
  part_number?: InputMaybe<String_Comparison_Exp>;
  preferred_supplier?: InputMaybe<String_Comparison_Exp>;
  preferred_supplier_part_number?: InputMaybe<String_Comparison_Exp>;
  purchase_type?: InputMaybe<String_Comparison_Exp>;
  purchase_uom?: InputMaybe<String_Comparison_Exp>;
  purchasing_measure?: InputMaybe<Numeric_Comparison_Exp>;
  purchasing_uom?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  receiving_measure?: InputMaybe<Numeric_Comparison_Exp>;
  receiving_uom?: InputMaybe<String_Comparison_Exp>;
  searchable_key_words?: InputMaybe<String_Comparison_Exp>;
  selected_json?: InputMaybe<Jsonb_Comparison_Exp>;
  shipping_measure?: InputMaybe<Numeric_Comparison_Exp>;
  shipping_uom?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  standard_container_height?: InputMaybe<String_Comparison_Exp>;
  standard_container_length?: InputMaybe<String_Comparison_Exp>;
  standard_container_width?: InputMaybe<String_Comparison_Exp>;
  standard_lead_time_days?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tag_path?: InputMaybe<Ltree_Comparison_Exp>;
  tag_path_id?: InputMaybe<Int_Comparison_Exp>;
  tag_set_id?: InputMaybe<Uuid_Comparison_Exp>;
  tag_set_name?: InputMaybe<String_Comparison_Exp>;
  take_off_uom?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  warehouse_name?: InputMaybe<String_Comparison_Exp>;
  waste_material?: InputMaybe<Numeric_Comparison_Exp>;
  weight?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Tagged_Part_Download_View_Max_Fields = {
  __typename?: 'tagged_part_download_view_max_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  bom_item_tag_set_id?: Maybe<Scalars['uuid']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  inventory_classification?: Maybe<Scalars['String']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  tag_set_name?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tagged_Part_Download_View_Min_Fields = {
  __typename?: 'tagged_part_download_view_min_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  accounting_base_uom?: Maybe<Scalars['String']>;
  ae_responsible?: Maybe<Scalars['String']>;
  bom_item_tag_set_id?: Maybe<Scalars['uuid']>;
  buyer?: Maybe<Scalars['String']>;
  cogs_account?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  csi_division?: Maybe<Scalars['String']>;
  cut_sheet_url?: Maybe<Scalars['String']>;
  design_measure?: Maybe<Scalars['numeric']>;
  design_uom?: Maybe<Scalars['String']>;
  est_daily_consumption?: Maybe<Scalars['String']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  estimating_uom?: Maybe<Scalars['String']>;
  finish_color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_url?: Maybe<Scalars['String']>;
  inventory_classification?: Maybe<Scalars['String']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  issuing_uom?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  location_name?: Maybe<Scalars['String']>;
  lot_size?: Maybe<Scalars['numeric']>;
  manufacturer?: Maybe<Scalars['String']>;
  manufacturer_part_number?: Maybe<Scalars['String']>;
  material?: Maybe<Scalars['String']>;
  material_issued_uom?: Maybe<Scalars['String']>;
  max_daily_consumption?: Maybe<Scalars['String']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  old_part_numbers?: Maybe<Scalars['String']>;
  part_number?: Maybe<Scalars['String']>;
  preferred_supplier?: Maybe<Scalars['String']>;
  preferred_supplier_part_number?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchase_uom?: Maybe<Scalars['String']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  purchasing_uom?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  receiving_uom?: Maybe<Scalars['String']>;
  searchable_key_words?: Maybe<Scalars['String']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  shipping_uom?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  standard_container_height?: Maybe<Scalars['String']>;
  standard_container_length?: Maybe<Scalars['String']>;
  standard_container_width?: Maybe<Scalars['String']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tag_path?: Maybe<Scalars['ltree']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  tag_set_id?: Maybe<Scalars['uuid']>;
  tag_set_name?: Maybe<Scalars['String']>;
  take_off_uom?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouse_name?: Maybe<Scalars['String']>;
  waste_material?: Maybe<Scalars['numeric']>;
  weight?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "tagged_part_download_view". */
export type Tagged_Part_Download_View_Order_By = {
  accounting_base_measure?: InputMaybe<Order_By>;
  accounting_base_uom?: InputMaybe<Order_By>;
  ae_responsible?: InputMaybe<Order_By>;
  bom_item_tag_set_id?: InputMaybe<Order_By>;
  buyer?: InputMaybe<Order_By>;
  cogs_account?: InputMaybe<Order_By>;
  conversion_rate?: InputMaybe<Order_By>;
  cost?: InputMaybe<Order_By>;
  csi_division?: InputMaybe<Order_By>;
  cut_sheet_url?: InputMaybe<Order_By>;
  design_measure?: InputMaybe<Order_By>;
  design_uom?: InputMaybe<Order_By>;
  est_daily_consumption?: InputMaybe<Order_By>;
  estimating_measure?: InputMaybe<Order_By>;
  estimating_uom?: InputMaybe<Order_By>;
  finish_color?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  include_waste?: InputMaybe<Order_By>;
  inventory_classification?: InputMaybe<Order_By>;
  is_app_design_approved?: InputMaybe<Order_By>;
  is_finance_approved?: InputMaybe<Order_By>;
  is_in_accounting_system?: InputMaybe<Order_By>;
  is_supply_chain_approved?: InputMaybe<Order_By>;
  issuing_measure?: InputMaybe<Order_By>;
  issuing_uom?: InputMaybe<Order_By>;
  item_type?: InputMaybe<Order_By>;
  location_name?: InputMaybe<Order_By>;
  lot_size?: InputMaybe<Order_By>;
  manufacturer?: InputMaybe<Order_By>;
  manufacturer_part_number?: InputMaybe<Order_By>;
  material?: InputMaybe<Order_By>;
  material_issued_uom?: InputMaybe<Order_By>;
  max_daily_consumption?: InputMaybe<Order_By>;
  minimum_order_quantity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  old_part_numbers?: InputMaybe<Order_By>;
  part_number?: InputMaybe<Order_By>;
  preferred_supplier?: InputMaybe<Order_By>;
  preferred_supplier_part_number?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  purchase_uom?: InputMaybe<Order_By>;
  purchasing_measure?: InputMaybe<Order_By>;
  purchasing_uom?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  receiving_measure?: InputMaybe<Order_By>;
  receiving_uom?: InputMaybe<Order_By>;
  searchable_key_words?: InputMaybe<Order_By>;
  selected_json?: InputMaybe<Order_By>;
  shipping_measure?: InputMaybe<Order_By>;
  shipping_uom?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  standard_container_height?: InputMaybe<Order_By>;
  standard_container_length?: InputMaybe<Order_By>;
  standard_container_width?: InputMaybe<Order_By>;
  standard_lead_time_days?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tag_path?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
  tag_set_id?: InputMaybe<Order_By>;
  tag_set_name?: InputMaybe<Order_By>;
  take_off_uom?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  warehouse_name?: InputMaybe<Order_By>;
  waste_material?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** select columns of table "tagged_part_download_view" */
export type Tagged_Part_Download_View_Select_Column =
  /** column name */
  | 'accounting_base_measure'
  /** column name */
  | 'accounting_base_uom'
  /** column name */
  | 'ae_responsible'
  /** column name */
  | 'bom_item_tag_set_id'
  /** column name */
  | 'buyer'
  /** column name */
  | 'cogs_account'
  /** column name */
  | 'conversion_rate'
  /** column name */
  | 'cost'
  /** column name */
  | 'csi_division'
  /** column name */
  | 'cut_sheet_url'
  /** column name */
  | 'design_measure'
  /** column name */
  | 'design_uom'
  /** column name */
  | 'est_daily_consumption'
  /** column name */
  | 'estimating_measure'
  /** column name */
  | 'estimating_uom'
  /** column name */
  | 'finish_color'
  /** column name */
  | 'id'
  /** column name */
  | 'image_url'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'inventory_classification'
  /** column name */
  | 'is_app_design_approved'
  /** column name */
  | 'is_finance_approved'
  /** column name */
  | 'is_in_accounting_system'
  /** column name */
  | 'is_supply_chain_approved'
  /** column name */
  | 'issuing_measure'
  /** column name */
  | 'issuing_uom'
  /** column name */
  | 'item_type'
  /** column name */
  | 'location_name'
  /** column name */
  | 'lot_size'
  /** column name */
  | 'manufacturer'
  /** column name */
  | 'manufacturer_part_number'
  /** column name */
  | 'material'
  /** column name */
  | 'material_issued_uom'
  /** column name */
  | 'max_daily_consumption'
  /** column name */
  | 'minimum_order_quantity'
  /** column name */
  | 'name'
  /** column name */
  | 'old_part_numbers'
  /** column name */
  | 'part_number'
  /** column name */
  | 'preferred_supplier'
  /** column name */
  | 'preferred_supplier_part_number'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'purchase_uom'
  /** column name */
  | 'purchasing_measure'
  /** column name */
  | 'purchasing_uom'
  /** column name */
  | 'quantity'
  /** column name */
  | 'receiving_measure'
  /** column name */
  | 'receiving_uom'
  /** column name */
  | 'searchable_key_words'
  /** column name */
  | 'selected_json'
  /** column name */
  | 'shipping_measure'
  /** column name */
  | 'shipping_uom'
  /** column name */
  | 'size'
  /** column name */
  | 'standard_container_height'
  /** column name */
  | 'standard_container_length'
  /** column name */
  | 'standard_container_width'
  /** column name */
  | 'standard_lead_time_days'
  /** column name */
  | 'status'
  /** column name */
  | 'tag_path'
  /** column name */
  | 'tag_path_id'
  /** column name */
  | 'tag_set_id'
  /** column name */
  | 'tag_set_name'
  /** column name */
  | 'take_off_uom'
  /** column name */
  | 'type'
  /** column name */
  | 'warehouse_name'
  /** column name */
  | 'waste_material'
  /** column name */
  | 'weight';

/** aggregate stddev on columns */
export type Tagged_Part_Download_View_Stddev_Fields = {
  __typename?: 'tagged_part_download_view_stddev_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tagged_Part_Download_View_Stddev_Pop_Fields = {
  __typename?: 'tagged_part_download_view_stddev_pop_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tagged_Part_Download_View_Stddev_Samp_Fields = {
  __typename?: 'tagged_part_download_view_stddev_samp_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tagged_part_download_view" */
export type Tagged_Part_Download_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tagged_Part_Download_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tagged_Part_Download_View_Stream_Cursor_Value_Input = {
  accounting_base_measure?: InputMaybe<Scalars['numeric']>;
  accounting_base_uom?: InputMaybe<Scalars['String']>;
  ae_responsible?: InputMaybe<Scalars['String']>;
  bom_item_tag_set_id?: InputMaybe<Scalars['uuid']>;
  buyer?: InputMaybe<Scalars['String']>;
  cogs_account?: InputMaybe<Scalars['String']>;
  conversion_rate?: InputMaybe<Scalars['numeric']>;
  cost?: InputMaybe<Scalars['numeric']>;
  csi_division?: InputMaybe<Scalars['String']>;
  cut_sheet_url?: InputMaybe<Scalars['String']>;
  design_measure?: InputMaybe<Scalars['numeric']>;
  design_uom?: InputMaybe<Scalars['String']>;
  est_daily_consumption?: InputMaybe<Scalars['String']>;
  estimating_measure?: InputMaybe<Scalars['numeric']>;
  estimating_uom?: InputMaybe<Scalars['String']>;
  finish_color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image_url?: InputMaybe<Scalars['String']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  inventory_classification?: InputMaybe<Scalars['String']>;
  is_app_design_approved?: InputMaybe<Scalars['Boolean']>;
  is_finance_approved?: InputMaybe<Scalars['Boolean']>;
  is_in_accounting_system?: InputMaybe<Scalars['Boolean']>;
  is_supply_chain_approved?: InputMaybe<Scalars['Boolean']>;
  issuing_measure?: InputMaybe<Scalars['numeric']>;
  issuing_uom?: InputMaybe<Scalars['String']>;
  item_type?: InputMaybe<Scalars['String']>;
  location_name?: InputMaybe<Scalars['String']>;
  lot_size?: InputMaybe<Scalars['numeric']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  manufacturer_part_number?: InputMaybe<Scalars['String']>;
  material?: InputMaybe<Scalars['String']>;
  material_issued_uom?: InputMaybe<Scalars['String']>;
  max_daily_consumption?: InputMaybe<Scalars['String']>;
  minimum_order_quantity?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  old_part_numbers?: InputMaybe<Scalars['String']>;
  part_number?: InputMaybe<Scalars['String']>;
  preferred_supplier?: InputMaybe<Scalars['String']>;
  preferred_supplier_part_number?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  purchase_uom?: InputMaybe<Scalars['String']>;
  purchasing_measure?: InputMaybe<Scalars['numeric']>;
  purchasing_uom?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  receiving_measure?: InputMaybe<Scalars['numeric']>;
  receiving_uom?: InputMaybe<Scalars['String']>;
  searchable_key_words?: InputMaybe<Scalars['String']>;
  selected_json?: InputMaybe<Scalars['jsonb']>;
  shipping_measure?: InputMaybe<Scalars['numeric']>;
  shipping_uom?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  standard_container_height?: InputMaybe<Scalars['String']>;
  standard_container_length?: InputMaybe<Scalars['String']>;
  standard_container_width?: InputMaybe<Scalars['String']>;
  standard_lead_time_days?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  tag_path?: InputMaybe<Scalars['ltree']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
  tag_set_id?: InputMaybe<Scalars['uuid']>;
  tag_set_name?: InputMaybe<Scalars['String']>;
  take_off_uom?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouse_name?: InputMaybe<Scalars['String']>;
  waste_material?: InputMaybe<Scalars['numeric']>;
  weight?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tagged_Part_Download_View_Sum_Fields = {
  __typename?: 'tagged_part_download_view_sum_fields';
  accounting_base_measure?: Maybe<Scalars['numeric']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  cost?: Maybe<Scalars['numeric']>;
  design_measure?: Maybe<Scalars['numeric']>;
  estimating_measure?: Maybe<Scalars['numeric']>;
  issuing_measure?: Maybe<Scalars['numeric']>;
  lot_size?: Maybe<Scalars['numeric']>;
  minimum_order_quantity?: Maybe<Scalars['numeric']>;
  purchasing_measure?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  receiving_measure?: Maybe<Scalars['numeric']>;
  shipping_measure?: Maybe<Scalars['numeric']>;
  standard_lead_time_days?: Maybe<Scalars['numeric']>;
  tag_path_id?: Maybe<Scalars['Int']>;
  waste_material?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Tagged_Part_Download_View_Var_Pop_Fields = {
  __typename?: 'tagged_part_download_view_var_pop_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tagged_Part_Download_View_Var_Samp_Fields = {
  __typename?: 'tagged_part_download_view_var_samp_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tagged_Part_Download_View_Variance_Fields = {
  __typename?: 'tagged_part_download_view_variance_fields';
  accounting_base_measure?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  cost?: Maybe<Scalars['Float']>;
  design_measure?: Maybe<Scalars['Float']>;
  estimating_measure?: Maybe<Scalars['Float']>;
  issuing_measure?: Maybe<Scalars['Float']>;
  lot_size?: Maybe<Scalars['Float']>;
  minimum_order_quantity?: Maybe<Scalars['Float']>;
  purchasing_measure?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  receiving_measure?: Maybe<Scalars['Float']>;
  shipping_measure?: Maybe<Scalars['Float']>;
  standard_lead_time_days?: Maybe<Scalars['Float']>;
  tag_path_id?: Maybe<Scalars['Float']>;
  waste_material?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tags" */
export type Tags = {
  __typename?: 'tags';
  created_at: Scalars['timestamptz'];
  created_by: Scalars['String'];
  /** An array relationship */
  entities: Array<Tag_Entity>;
  /** An aggregate relationship */
  entities_aggregate: Tag_Entity_Aggregate;
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  related_entity?: Maybe<Scalars['String']>;
  sequence: Scalars['Int'];
  tag_type_id: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  updated_by: Scalars['String'];
  value: Scalars['String'];
};


/** columns and relationships of "tags" */
export type TagsEntitiesArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "tags" */
export type TagsEntities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};

/** aggregated selection of "tags" */
export type Tags_Aggregate = {
  __typename?: 'tags_aggregate';
  aggregate?: Maybe<Tags_Aggregate_Fields>;
  nodes: Array<Tags>;
};

/** aggregate fields of "tags" */
export type Tags_Aggregate_Fields = {
  __typename?: 'tags_aggregate_fields';
  avg?: Maybe<Tags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tags_Max_Fields>;
  min?: Maybe<Tags_Min_Fields>;
  stddev?: Maybe<Tags_Stddev_Fields>;
  stddev_pop?: Maybe<Tags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tags_Stddev_Samp_Fields>;
  sum?: Maybe<Tags_Sum_Fields>;
  var_pop?: Maybe<Tags_Var_Pop_Fields>;
  var_samp?: Maybe<Tags_Var_Samp_Fields>;
  variance?: Maybe<Tags_Variance_Fields>;
};


/** aggregate fields of "tags" */
export type Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tags_Avg_Fields = {
  __typename?: 'tags_avg_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tags". All fields are combined with a logical 'AND'. */
export type Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Tags_Bool_Exp>>;
  _not?: InputMaybe<Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  entities?: InputMaybe<Tag_Entity_Bool_Exp>;
  entities_aggregate?: InputMaybe<Tag_Entity_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  related_entity?: InputMaybe<String_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  tag_type_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "tags" */
export type Tags_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'tags_pkey'
  /** unique or primary key constraint on columns "name", "tag_type_id", "value" */
  | 'tags_tag_type_id_name_value_key';

/** input type for incrementing numeric columns in table "tags" */
export type Tags_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tags" */
export type Tags_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Tag_Entity_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  related_entity?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  tag_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Tags_Max_Fields = {
  __typename?: 'tags_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  related_entity?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  tag_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tags_Min_Fields = {
  __typename?: 'tags_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  related_entity?: Maybe<Scalars['String']>;
  sequence?: Maybe<Scalars['Int']>;
  tag_type_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tags" */
export type Tags_Mutation_Response = {
  __typename?: 'tags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tags>;
};

/** input type for inserting object relation for remote table "tags" */
export type Tags_Obj_Rel_Insert_Input = {
  data: Tags_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tags_On_Conflict>;
};

/** on_conflict condition type for table "tags" */
export type Tags_On_Conflict = {
  constraint: Tags_Constraint;
  update_columns?: Array<Tags_Update_Column>;
  where?: InputMaybe<Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "tags". */
export type Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  entities_aggregate?: InputMaybe<Tag_Entity_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  related_entity?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  tag_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tags */
export type Tags_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "tags" */
export type Tags_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'label'
  /** column name */
  | 'name'
  /** column name */
  | 'notes'
  /** column name */
  | 'related_entity'
  /** column name */
  | 'sequence'
  /** column name */
  | 'tag_type_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'value';

/** input type for updating data in table "tags" */
export type Tags_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  related_entity?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  tag_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tags_Stddev_Fields = {
  __typename?: 'tags_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tags_Stddev_Pop_Fields = {
  __typename?: 'tags_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tags_Stddev_Samp_Fields = {
  __typename?: 'tags_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tags" */
export type Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  related_entity?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  tag_type_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tags_Sum_Fields = {
  __typename?: 'tags_sum_fields';
  id?: Maybe<Scalars['Int']>;
  sequence?: Maybe<Scalars['Int']>;
};

/** update columns of table "tags" */
export type Tags_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'label'
  /** column name */
  | 'name'
  /** column name */
  | 'notes'
  /** column name */
  | 'related_entity'
  /** column name */
  | 'sequence'
  /** column name */
  | 'tag_type_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'value';

export type Tags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tags_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tags_Var_Pop_Fields = {
  __typename?: 'tags_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tags_Var_Samp_Fields = {
  __typename?: 'tags_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tags_Variance_Fields = {
  __typename?: 'tags_variance_fields';
  id?: Maybe<Scalars['Float']>;
  sequence?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "toimport_view" */
export type Toimport_View = {
  __typename?: 'toimport_view';
  c_conversion_rate?: Maybe<Scalars['numeric']>;
  c_conversionratematerial?: Maybe<Scalars['numeric']>;
  c_issupplychainapproved?: Maybe<Scalars['Boolean']>;
  c_itemtype?: Maybe<Scalars['String']>;
  c_leadtimedays?: Maybe<Scalars['numeric']>;
  c_manufacturerpartnumber?: Maybe<Scalars['String']>;
  c_minorderquantity?: Maybe<Scalars['numeric']>;
  c_part_number?: Maybe<Scalars['String']>;
  c_preferredmanufacturer?: Maybe<Scalars['String']>;
  c_preferredvendor?: Maybe<Scalars['String']>;
  c_purchasetypeid?: Maybe<Scalars['Int']>;
  c_status?: Maybe<Scalars['String']>;
  c_unitcost?: Maybe<Scalars['numeric']>;
  c_uom_purchase_id?: Maybe<Scalars['Int']>;
  c_uom_takeoff_id?: Maybe<Scalars['Int']>;
  c_uommaterialid?: Maybe<Scalars['Int']>;
  c_uomtakeoffid?: Maybe<Scalars['Int']>;
  c_vendorpartnumber?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  conversionratematerial?: Maybe<Scalars['numeric']>;
  i_conversion_rate?: Maybe<Scalars['numeric']>;
  i_conversionrate?: Maybe<Scalars['numeric']>;
  i_issupplychainapproved?: Maybe<Scalars['Boolean']>;
  i_itemtype?: Maybe<Scalars['String']>;
  i_leadtimedays?: Maybe<Scalars['numeric']>;
  i_manufacturerpartnumber?: Maybe<Scalars['String']>;
  i_minorderquantity?: Maybe<Scalars['String']>;
  i_part_n?: Maybe<Scalars['String']>;
  i_preferredmanufacturer?: Maybe<Scalars['String']>;
  i_preferredvendor?: Maybe<Scalars['String']>;
  i_purchasetypeid?: Maybe<Scalars['Int']>;
  i_status?: Maybe<Scalars['String']>;
  i_unitcost?: Maybe<Scalars['String']>;
  i_uom_purchase_id?: Maybe<Scalars['Int']>;
  i_uom_takeoff_id?: Maybe<Scalars['Int']>;
  i_uommaterialid?: Maybe<Scalars['Int']>;
  i_uomtakeoff?: Maybe<Scalars['Int']>;
  i_vendorpartnumber?: Maybe<Scalars['String']>;
  issupplychainapproved?: Maybe<Scalars['Boolean']>;
  itemtype?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  manufacturerpartnumber?: Maybe<Scalars['String']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  part_id?: Maybe<Scalars['String']>;
  preferredmanufacturer?: Maybe<Scalars['String']>;
  preferredvendor?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchasetypeid?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['numeric']>;
  uom_purchase_id?: Maybe<Scalars['Int']>;
  uom_takeoff_id?: Maybe<Scalars['Int']>;
  uommaterialid?: Maybe<Scalars['Int']>;
  uomtakeoffid?: Maybe<Scalars['Int']>;
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** aggregated selection of "toimport_view" */
export type Toimport_View_Aggregate = {
  __typename?: 'toimport_view_aggregate';
  aggregate?: Maybe<Toimport_View_Aggregate_Fields>;
  nodes: Array<Toimport_View>;
};

/** aggregate fields of "toimport_view" */
export type Toimport_View_Aggregate_Fields = {
  __typename?: 'toimport_view_aggregate_fields';
  avg?: Maybe<Toimport_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Toimport_View_Max_Fields>;
  min?: Maybe<Toimport_View_Min_Fields>;
  stddev?: Maybe<Toimport_View_Stddev_Fields>;
  stddev_pop?: Maybe<Toimport_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Toimport_View_Stddev_Samp_Fields>;
  sum?: Maybe<Toimport_View_Sum_Fields>;
  var_pop?: Maybe<Toimport_View_Var_Pop_Fields>;
  var_samp?: Maybe<Toimport_View_Var_Samp_Fields>;
  variance?: Maybe<Toimport_View_Variance_Fields>;
};


/** aggregate fields of "toimport_view" */
export type Toimport_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Toimport_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Toimport_View_Avg_Fields = {
  __typename?: 'toimport_view_avg_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "toimport_view". All fields are combined with a logical 'AND'. */
export type Toimport_View_Bool_Exp = {
  _and?: InputMaybe<Array<Toimport_View_Bool_Exp>>;
  _not?: InputMaybe<Toimport_View_Bool_Exp>;
  _or?: InputMaybe<Array<Toimport_View_Bool_Exp>>;
  c_conversion_rate?: InputMaybe<Numeric_Comparison_Exp>;
  c_conversionratematerial?: InputMaybe<Numeric_Comparison_Exp>;
  c_issupplychainapproved?: InputMaybe<Boolean_Comparison_Exp>;
  c_itemtype?: InputMaybe<String_Comparison_Exp>;
  c_leadtimedays?: InputMaybe<Numeric_Comparison_Exp>;
  c_manufacturerpartnumber?: InputMaybe<String_Comparison_Exp>;
  c_minorderquantity?: InputMaybe<Numeric_Comparison_Exp>;
  c_part_number?: InputMaybe<String_Comparison_Exp>;
  c_preferredmanufacturer?: InputMaybe<String_Comparison_Exp>;
  c_preferredvendor?: InputMaybe<String_Comparison_Exp>;
  c_purchasetypeid?: InputMaybe<Int_Comparison_Exp>;
  c_status?: InputMaybe<String_Comparison_Exp>;
  c_unitcost?: InputMaybe<Numeric_Comparison_Exp>;
  c_uom_purchase_id?: InputMaybe<Int_Comparison_Exp>;
  c_uom_takeoff_id?: InputMaybe<Int_Comparison_Exp>;
  c_uommaterialid?: InputMaybe<Int_Comparison_Exp>;
  c_uomtakeoffid?: InputMaybe<Int_Comparison_Exp>;
  c_vendorpartnumber?: InputMaybe<String_Comparison_Exp>;
  conversion_rate?: InputMaybe<Numeric_Comparison_Exp>;
  conversionratematerial?: InputMaybe<Numeric_Comparison_Exp>;
  i_conversion_rate?: InputMaybe<Numeric_Comparison_Exp>;
  i_conversionrate?: InputMaybe<Numeric_Comparison_Exp>;
  i_issupplychainapproved?: InputMaybe<Boolean_Comparison_Exp>;
  i_itemtype?: InputMaybe<String_Comparison_Exp>;
  i_leadtimedays?: InputMaybe<Numeric_Comparison_Exp>;
  i_manufacturerpartnumber?: InputMaybe<String_Comparison_Exp>;
  i_minorderquantity?: InputMaybe<String_Comparison_Exp>;
  i_part_n?: InputMaybe<String_Comparison_Exp>;
  i_preferredmanufacturer?: InputMaybe<String_Comparison_Exp>;
  i_preferredvendor?: InputMaybe<String_Comparison_Exp>;
  i_purchasetypeid?: InputMaybe<Int_Comparison_Exp>;
  i_status?: InputMaybe<String_Comparison_Exp>;
  i_unitcost?: InputMaybe<String_Comparison_Exp>;
  i_uom_purchase_id?: InputMaybe<Int_Comparison_Exp>;
  i_uom_takeoff_id?: InputMaybe<Int_Comparison_Exp>;
  i_uommaterialid?: InputMaybe<Int_Comparison_Exp>;
  i_uomtakeoff?: InputMaybe<Int_Comparison_Exp>;
  i_vendorpartnumber?: InputMaybe<String_Comparison_Exp>;
  issupplychainapproved?: InputMaybe<Boolean_Comparison_Exp>;
  itemtype?: InputMaybe<String_Comparison_Exp>;
  leadTimeDays?: InputMaybe<Numeric_Comparison_Exp>;
  manufacturerpartnumber?: InputMaybe<String_Comparison_Exp>;
  minOrderQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  part_id?: InputMaybe<String_Comparison_Exp>;
  preferredmanufacturer?: InputMaybe<String_Comparison_Exp>;
  preferredvendor?: InputMaybe<String_Comparison_Exp>;
  purchase_type?: InputMaybe<String_Comparison_Exp>;
  purchasetypeid?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  unitCost?: InputMaybe<Numeric_Comparison_Exp>;
  uom_purchase_id?: InputMaybe<Int_Comparison_Exp>;
  uom_takeoff_id?: InputMaybe<Int_Comparison_Exp>;
  uommaterialid?: InputMaybe<Int_Comparison_Exp>;
  uomtakeoffid?: InputMaybe<Int_Comparison_Exp>;
  vendorPartNumber?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Toimport_View_Max_Fields = {
  __typename?: 'toimport_view_max_fields';
  c_conversion_rate?: Maybe<Scalars['numeric']>;
  c_conversionratematerial?: Maybe<Scalars['numeric']>;
  c_itemtype?: Maybe<Scalars['String']>;
  c_leadtimedays?: Maybe<Scalars['numeric']>;
  c_manufacturerpartnumber?: Maybe<Scalars['String']>;
  c_minorderquantity?: Maybe<Scalars['numeric']>;
  c_part_number?: Maybe<Scalars['String']>;
  c_preferredmanufacturer?: Maybe<Scalars['String']>;
  c_preferredvendor?: Maybe<Scalars['String']>;
  c_purchasetypeid?: Maybe<Scalars['Int']>;
  c_status?: Maybe<Scalars['String']>;
  c_unitcost?: Maybe<Scalars['numeric']>;
  c_uom_purchase_id?: Maybe<Scalars['Int']>;
  c_uom_takeoff_id?: Maybe<Scalars['Int']>;
  c_uommaterialid?: Maybe<Scalars['Int']>;
  c_uomtakeoffid?: Maybe<Scalars['Int']>;
  c_vendorpartnumber?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  conversionratematerial?: Maybe<Scalars['numeric']>;
  i_conversion_rate?: Maybe<Scalars['numeric']>;
  i_conversionrate?: Maybe<Scalars['numeric']>;
  i_itemtype?: Maybe<Scalars['String']>;
  i_leadtimedays?: Maybe<Scalars['numeric']>;
  i_manufacturerpartnumber?: Maybe<Scalars['String']>;
  i_minorderquantity?: Maybe<Scalars['String']>;
  i_part_n?: Maybe<Scalars['String']>;
  i_preferredmanufacturer?: Maybe<Scalars['String']>;
  i_preferredvendor?: Maybe<Scalars['String']>;
  i_purchasetypeid?: Maybe<Scalars['Int']>;
  i_status?: Maybe<Scalars['String']>;
  i_unitcost?: Maybe<Scalars['String']>;
  i_uom_purchase_id?: Maybe<Scalars['Int']>;
  i_uom_takeoff_id?: Maybe<Scalars['Int']>;
  i_uommaterialid?: Maybe<Scalars['Int']>;
  i_uomtakeoff?: Maybe<Scalars['Int']>;
  i_vendorpartnumber?: Maybe<Scalars['String']>;
  itemtype?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  manufacturerpartnumber?: Maybe<Scalars['String']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  part_id?: Maybe<Scalars['String']>;
  preferredmanufacturer?: Maybe<Scalars['String']>;
  preferredvendor?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchasetypeid?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['numeric']>;
  uom_purchase_id?: Maybe<Scalars['Int']>;
  uom_takeoff_id?: Maybe<Scalars['Int']>;
  uommaterialid?: Maybe<Scalars['Int']>;
  uomtakeoffid?: Maybe<Scalars['Int']>;
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Toimport_View_Min_Fields = {
  __typename?: 'toimport_view_min_fields';
  c_conversion_rate?: Maybe<Scalars['numeric']>;
  c_conversionratematerial?: Maybe<Scalars['numeric']>;
  c_itemtype?: Maybe<Scalars['String']>;
  c_leadtimedays?: Maybe<Scalars['numeric']>;
  c_manufacturerpartnumber?: Maybe<Scalars['String']>;
  c_minorderquantity?: Maybe<Scalars['numeric']>;
  c_part_number?: Maybe<Scalars['String']>;
  c_preferredmanufacturer?: Maybe<Scalars['String']>;
  c_preferredvendor?: Maybe<Scalars['String']>;
  c_purchasetypeid?: Maybe<Scalars['Int']>;
  c_status?: Maybe<Scalars['String']>;
  c_unitcost?: Maybe<Scalars['numeric']>;
  c_uom_purchase_id?: Maybe<Scalars['Int']>;
  c_uom_takeoff_id?: Maybe<Scalars['Int']>;
  c_uommaterialid?: Maybe<Scalars['Int']>;
  c_uomtakeoffid?: Maybe<Scalars['Int']>;
  c_vendorpartnumber?: Maybe<Scalars['String']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  conversionratematerial?: Maybe<Scalars['numeric']>;
  i_conversion_rate?: Maybe<Scalars['numeric']>;
  i_conversionrate?: Maybe<Scalars['numeric']>;
  i_itemtype?: Maybe<Scalars['String']>;
  i_leadtimedays?: Maybe<Scalars['numeric']>;
  i_manufacturerpartnumber?: Maybe<Scalars['String']>;
  i_minorderquantity?: Maybe<Scalars['String']>;
  i_part_n?: Maybe<Scalars['String']>;
  i_preferredmanufacturer?: Maybe<Scalars['String']>;
  i_preferredvendor?: Maybe<Scalars['String']>;
  i_purchasetypeid?: Maybe<Scalars['Int']>;
  i_status?: Maybe<Scalars['String']>;
  i_unitcost?: Maybe<Scalars['String']>;
  i_uom_purchase_id?: Maybe<Scalars['Int']>;
  i_uom_takeoff_id?: Maybe<Scalars['Int']>;
  i_uommaterialid?: Maybe<Scalars['Int']>;
  i_uomtakeoff?: Maybe<Scalars['Int']>;
  i_vendorpartnumber?: Maybe<Scalars['String']>;
  itemtype?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  manufacturerpartnumber?: Maybe<Scalars['String']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  part_id?: Maybe<Scalars['String']>;
  preferredmanufacturer?: Maybe<Scalars['String']>;
  preferredvendor?: Maybe<Scalars['String']>;
  purchase_type?: Maybe<Scalars['String']>;
  purchasetypeid?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['numeric']>;
  uom_purchase_id?: Maybe<Scalars['Int']>;
  uom_takeoff_id?: Maybe<Scalars['Int']>;
  uommaterialid?: Maybe<Scalars['Int']>;
  uomtakeoffid?: Maybe<Scalars['Int']>;
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "toimport_view". */
export type Toimport_View_Order_By = {
  c_conversion_rate?: InputMaybe<Order_By>;
  c_conversionratematerial?: InputMaybe<Order_By>;
  c_issupplychainapproved?: InputMaybe<Order_By>;
  c_itemtype?: InputMaybe<Order_By>;
  c_leadtimedays?: InputMaybe<Order_By>;
  c_manufacturerpartnumber?: InputMaybe<Order_By>;
  c_minorderquantity?: InputMaybe<Order_By>;
  c_part_number?: InputMaybe<Order_By>;
  c_preferredmanufacturer?: InputMaybe<Order_By>;
  c_preferredvendor?: InputMaybe<Order_By>;
  c_purchasetypeid?: InputMaybe<Order_By>;
  c_status?: InputMaybe<Order_By>;
  c_unitcost?: InputMaybe<Order_By>;
  c_uom_purchase_id?: InputMaybe<Order_By>;
  c_uom_takeoff_id?: InputMaybe<Order_By>;
  c_uommaterialid?: InputMaybe<Order_By>;
  c_uomtakeoffid?: InputMaybe<Order_By>;
  c_vendorpartnumber?: InputMaybe<Order_By>;
  conversion_rate?: InputMaybe<Order_By>;
  conversionratematerial?: InputMaybe<Order_By>;
  i_conversion_rate?: InputMaybe<Order_By>;
  i_conversionrate?: InputMaybe<Order_By>;
  i_issupplychainapproved?: InputMaybe<Order_By>;
  i_itemtype?: InputMaybe<Order_By>;
  i_leadtimedays?: InputMaybe<Order_By>;
  i_manufacturerpartnumber?: InputMaybe<Order_By>;
  i_minorderquantity?: InputMaybe<Order_By>;
  i_part_n?: InputMaybe<Order_By>;
  i_preferredmanufacturer?: InputMaybe<Order_By>;
  i_preferredvendor?: InputMaybe<Order_By>;
  i_purchasetypeid?: InputMaybe<Order_By>;
  i_status?: InputMaybe<Order_By>;
  i_unitcost?: InputMaybe<Order_By>;
  i_uom_purchase_id?: InputMaybe<Order_By>;
  i_uom_takeoff_id?: InputMaybe<Order_By>;
  i_uommaterialid?: InputMaybe<Order_By>;
  i_uomtakeoff?: InputMaybe<Order_By>;
  i_vendorpartnumber?: InputMaybe<Order_By>;
  issupplychainapproved?: InputMaybe<Order_By>;
  itemtype?: InputMaybe<Order_By>;
  leadTimeDays?: InputMaybe<Order_By>;
  manufacturerpartnumber?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  preferredmanufacturer?: InputMaybe<Order_By>;
  preferredvendor?: InputMaybe<Order_By>;
  purchase_type?: InputMaybe<Order_By>;
  purchasetypeid?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
  uom_purchase_id?: InputMaybe<Order_By>;
  uom_takeoff_id?: InputMaybe<Order_By>;
  uommaterialid?: InputMaybe<Order_By>;
  uomtakeoffid?: InputMaybe<Order_By>;
  vendorPartNumber?: InputMaybe<Order_By>;
};

/** select columns of table "toimport_view" */
export type Toimport_View_Select_Column =
  /** column name */
  | 'c_conversion_rate'
  /** column name */
  | 'c_conversionratematerial'
  /** column name */
  | 'c_issupplychainapproved'
  /** column name */
  | 'c_itemtype'
  /** column name */
  | 'c_leadtimedays'
  /** column name */
  | 'c_manufacturerpartnumber'
  /** column name */
  | 'c_minorderquantity'
  /** column name */
  | 'c_part_number'
  /** column name */
  | 'c_preferredmanufacturer'
  /** column name */
  | 'c_preferredvendor'
  /** column name */
  | 'c_purchasetypeid'
  /** column name */
  | 'c_status'
  /** column name */
  | 'c_unitcost'
  /** column name */
  | 'c_uom_purchase_id'
  /** column name */
  | 'c_uom_takeoff_id'
  /** column name */
  | 'c_uommaterialid'
  /** column name */
  | 'c_uomtakeoffid'
  /** column name */
  | 'c_vendorpartnumber'
  /** column name */
  | 'conversion_rate'
  /** column name */
  | 'conversionratematerial'
  /** column name */
  | 'i_conversion_rate'
  /** column name */
  | 'i_conversionrate'
  /** column name */
  | 'i_issupplychainapproved'
  /** column name */
  | 'i_itemtype'
  /** column name */
  | 'i_leadtimedays'
  /** column name */
  | 'i_manufacturerpartnumber'
  /** column name */
  | 'i_minorderquantity'
  /** column name */
  | 'i_part_n'
  /** column name */
  | 'i_preferredmanufacturer'
  /** column name */
  | 'i_preferredvendor'
  /** column name */
  | 'i_purchasetypeid'
  /** column name */
  | 'i_status'
  /** column name */
  | 'i_unitcost'
  /** column name */
  | 'i_uom_purchase_id'
  /** column name */
  | 'i_uom_takeoff_id'
  /** column name */
  | 'i_uommaterialid'
  /** column name */
  | 'i_uomtakeoff'
  /** column name */
  | 'i_vendorpartnumber'
  /** column name */
  | 'issupplychainapproved'
  /** column name */
  | 'itemtype'
  /** column name */
  | 'leadTimeDays'
  /** column name */
  | 'manufacturerpartnumber'
  /** column name */
  | 'minOrderQuantity'
  /** column name */
  | 'part_id'
  /** column name */
  | 'preferredmanufacturer'
  /** column name */
  | 'preferredvendor'
  /** column name */
  | 'purchase_type'
  /** column name */
  | 'purchasetypeid'
  /** column name */
  | 'status'
  /** column name */
  | 'unitCost'
  /** column name */
  | 'uom_purchase_id'
  /** column name */
  | 'uom_takeoff_id'
  /** column name */
  | 'uommaterialid'
  /** column name */
  | 'uomtakeoffid'
  /** column name */
  | 'vendorPartNumber';

/** aggregate stddev on columns */
export type Toimport_View_Stddev_Fields = {
  __typename?: 'toimport_view_stddev_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Toimport_View_Stddev_Pop_Fields = {
  __typename?: 'toimport_view_stddev_pop_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Toimport_View_Stddev_Samp_Fields = {
  __typename?: 'toimport_view_stddev_samp_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "toimport_view" */
export type Toimport_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Toimport_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Toimport_View_Stream_Cursor_Value_Input = {
  c_conversion_rate?: InputMaybe<Scalars['numeric']>;
  c_conversionratematerial?: InputMaybe<Scalars['numeric']>;
  c_issupplychainapproved?: InputMaybe<Scalars['Boolean']>;
  c_itemtype?: InputMaybe<Scalars['String']>;
  c_leadtimedays?: InputMaybe<Scalars['numeric']>;
  c_manufacturerpartnumber?: InputMaybe<Scalars['String']>;
  c_minorderquantity?: InputMaybe<Scalars['numeric']>;
  c_part_number?: InputMaybe<Scalars['String']>;
  c_preferredmanufacturer?: InputMaybe<Scalars['String']>;
  c_preferredvendor?: InputMaybe<Scalars['String']>;
  c_purchasetypeid?: InputMaybe<Scalars['Int']>;
  c_status?: InputMaybe<Scalars['String']>;
  c_unitcost?: InputMaybe<Scalars['numeric']>;
  c_uom_purchase_id?: InputMaybe<Scalars['Int']>;
  c_uom_takeoff_id?: InputMaybe<Scalars['Int']>;
  c_uommaterialid?: InputMaybe<Scalars['Int']>;
  c_uomtakeoffid?: InputMaybe<Scalars['Int']>;
  c_vendorpartnumber?: InputMaybe<Scalars['String']>;
  conversion_rate?: InputMaybe<Scalars['numeric']>;
  conversionratematerial?: InputMaybe<Scalars['numeric']>;
  i_conversion_rate?: InputMaybe<Scalars['numeric']>;
  i_conversionrate?: InputMaybe<Scalars['numeric']>;
  i_issupplychainapproved?: InputMaybe<Scalars['Boolean']>;
  i_itemtype?: InputMaybe<Scalars['String']>;
  i_leadtimedays?: InputMaybe<Scalars['numeric']>;
  i_manufacturerpartnumber?: InputMaybe<Scalars['String']>;
  i_minorderquantity?: InputMaybe<Scalars['String']>;
  i_part_n?: InputMaybe<Scalars['String']>;
  i_preferredmanufacturer?: InputMaybe<Scalars['String']>;
  i_preferredvendor?: InputMaybe<Scalars['String']>;
  i_purchasetypeid?: InputMaybe<Scalars['Int']>;
  i_status?: InputMaybe<Scalars['String']>;
  i_unitcost?: InputMaybe<Scalars['String']>;
  i_uom_purchase_id?: InputMaybe<Scalars['Int']>;
  i_uom_takeoff_id?: InputMaybe<Scalars['Int']>;
  i_uommaterialid?: InputMaybe<Scalars['Int']>;
  i_uomtakeoff?: InputMaybe<Scalars['Int']>;
  i_vendorpartnumber?: InputMaybe<Scalars['String']>;
  issupplychainapproved?: InputMaybe<Scalars['Boolean']>;
  itemtype?: InputMaybe<Scalars['String']>;
  leadTimeDays?: InputMaybe<Scalars['numeric']>;
  manufacturerpartnumber?: InputMaybe<Scalars['String']>;
  minOrderQuantity?: InputMaybe<Scalars['numeric']>;
  part_id?: InputMaybe<Scalars['String']>;
  preferredmanufacturer?: InputMaybe<Scalars['String']>;
  preferredvendor?: InputMaybe<Scalars['String']>;
  purchase_type?: InputMaybe<Scalars['String']>;
  purchasetypeid?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitCost?: InputMaybe<Scalars['numeric']>;
  uom_purchase_id?: InputMaybe<Scalars['Int']>;
  uom_takeoff_id?: InputMaybe<Scalars['Int']>;
  uommaterialid?: InputMaybe<Scalars['Int']>;
  uomtakeoffid?: InputMaybe<Scalars['Int']>;
  vendorPartNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Toimport_View_Sum_Fields = {
  __typename?: 'toimport_view_sum_fields';
  c_conversion_rate?: Maybe<Scalars['numeric']>;
  c_conversionratematerial?: Maybe<Scalars['numeric']>;
  c_leadtimedays?: Maybe<Scalars['numeric']>;
  c_minorderquantity?: Maybe<Scalars['numeric']>;
  c_purchasetypeid?: Maybe<Scalars['Int']>;
  c_unitcost?: Maybe<Scalars['numeric']>;
  c_uom_purchase_id?: Maybe<Scalars['Int']>;
  c_uom_takeoff_id?: Maybe<Scalars['Int']>;
  c_uommaterialid?: Maybe<Scalars['Int']>;
  c_uomtakeoffid?: Maybe<Scalars['Int']>;
  conversion_rate?: Maybe<Scalars['numeric']>;
  conversionratematerial?: Maybe<Scalars['numeric']>;
  i_conversion_rate?: Maybe<Scalars['numeric']>;
  i_conversionrate?: Maybe<Scalars['numeric']>;
  i_leadtimedays?: Maybe<Scalars['numeric']>;
  i_purchasetypeid?: Maybe<Scalars['Int']>;
  i_uom_purchase_id?: Maybe<Scalars['Int']>;
  i_uom_takeoff_id?: Maybe<Scalars['Int']>;
  i_uommaterialid?: Maybe<Scalars['Int']>;
  i_uomtakeoff?: Maybe<Scalars['Int']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  purchasetypeid?: Maybe<Scalars['Int']>;
  unitCost?: Maybe<Scalars['numeric']>;
  uom_purchase_id?: Maybe<Scalars['Int']>;
  uom_takeoff_id?: Maybe<Scalars['Int']>;
  uommaterialid?: Maybe<Scalars['Int']>;
  uomtakeoffid?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Toimport_View_Var_Pop_Fields = {
  __typename?: 'toimport_view_var_pop_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Toimport_View_Var_Samp_Fields = {
  __typename?: 'toimport_view_var_samp_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Toimport_View_Variance_Fields = {
  __typename?: 'toimport_view_variance_fields';
  c_conversion_rate?: Maybe<Scalars['Float']>;
  c_conversionratematerial?: Maybe<Scalars['Float']>;
  c_leadtimedays?: Maybe<Scalars['Float']>;
  c_minorderquantity?: Maybe<Scalars['Float']>;
  c_purchasetypeid?: Maybe<Scalars['Float']>;
  c_unitcost?: Maybe<Scalars['Float']>;
  c_uom_purchase_id?: Maybe<Scalars['Float']>;
  c_uom_takeoff_id?: Maybe<Scalars['Float']>;
  c_uommaterialid?: Maybe<Scalars['Float']>;
  c_uomtakeoffid?: Maybe<Scalars['Float']>;
  conversion_rate?: Maybe<Scalars['Float']>;
  conversionratematerial?: Maybe<Scalars['Float']>;
  i_conversion_rate?: Maybe<Scalars['Float']>;
  i_conversionrate?: Maybe<Scalars['Float']>;
  i_leadtimedays?: Maybe<Scalars['Float']>;
  i_purchasetypeid?: Maybe<Scalars['Float']>;
  i_uom_purchase_id?: Maybe<Scalars['Float']>;
  i_uom_takeoff_id?: Maybe<Scalars['Float']>;
  i_uommaterialid?: Maybe<Scalars['Float']>;
  i_uomtakeoff?: Maybe<Scalars['Float']>;
  leadTimeDays?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  purchasetypeid?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
  uom_purchase_id?: Maybe<Scalars['Float']>;
  uom_takeoff_id?: Maybe<Scalars['Float']>;
  uommaterialid?: Maybe<Scalars['Float']>;
  uomtakeoffid?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "unit" */
export type Unit = {
  __typename?: 'unit';
  actual_off_date?: Maybe<Scalars['timestamptz']>;
  actual_on_date?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  base_product: Base_Product;
  base_product_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['String'];
  /** An array relationship */
  items: Array<Item_Bom>;
  /** An aggregate relationship */
  items_aggregate: Item_Bom_Aggregate;
  old_project?: Maybe<Scalars['String']>;
  old_serial_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  options: Array<Unit_Product_Option_Choice>;
  /** An aggregate relationship */
  options_aggregate: Unit_Product_Option_Choice_Aggregate;
  price?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  project: Project;
  project_id: Scalars['String'];
  schedule_off_date?: Maybe<Scalars['timestamptz']>;
  schedule_on_date?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  selected_tag_sets: Array<Unit_Tag_View>;
  /** An aggregate relationship */
  selected_tag_sets_aggregate: Unit_Tag_View_Aggregate;
  serial_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  tags: Array<Tag_Entity>;
  /** An aggregate relationship */
  tags_aggregate: Tag_Entity_Aggregate;
  /** An array relationship */
  unit_bom: Array<Unit_Bom_Entity_View>;
  /** An aggregate relationship */
  unit_bom_aggregate: Unit_Bom_Entity_View_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "unit" */
export type UnitItemsArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Item_Bom_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Item_Bom_Order_By>>;
  where?: InputMaybe<Item_Bom_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitOptionsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitOptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Product_Option_Choice_Order_By>>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitSelected_Tag_SetsArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitSelected_Tag_Sets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Tag_View_Order_By>>;
  where?: InputMaybe<Unit_Tag_View_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitTagsArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tag_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tag_Entity_Order_By>>;
  where?: InputMaybe<Tag_Entity_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitUnit_BomArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};


/** columns and relationships of "unit" */
export type UnitUnit_Bom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Unit_Bom_Entity_View_Order_By>>;
  where?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
};

export type UnitNode = {
  __typename?: 'unitNode';
  baseConfigurations?: Maybe<Array<Maybe<ProductNode>>>;
  baseConfigurationsAggregate?: Maybe<UnitNodeproductNodeBaseConfigurationsAggregationSelection>;
  baseConfigurationsConnection: UnitNodeBaseConfigurationsConnection;
  choices?: Maybe<Array<Maybe<ProductOptionNode>>>;
  choicesAggregate?: Maybe<UnitNodeproductOptionNodeChoicesAggregationSelection>;
  choicesConnection: UnitNodeChoicesConnection;
  description?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<ItemNode>>>;
  itemsAggregate?: Maybe<UnitNodeitemNodeItemsAggregationSelection>;
  itemsConnection: UnitNodeItemsConnection;
  name?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectNode>;
  projectAggregate?: Maybe<UnitNodeprojectNodeProjectAggregationSelection>;
  projectConnection: UnitNodeProjectConnection;
  tagpathid?: Maybe<Scalars['String']>;
  wevrId?: Maybe<Scalars['String']>;
};


export type UnitNodeBaseConfigurationsArgs = {
  options?: InputMaybe<ProductNodeOptions>;
  where?: InputMaybe<ProductNodeWhere>;
};


export type UnitNodeBaseConfigurationsAggregateArgs = {
  where?: InputMaybe<ProductNodeWhere>;
};


export type UnitNodeBaseConfigurationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectionSort>>;
  where?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
};


export type UnitNodeChoicesArgs = {
  options?: InputMaybe<ProductOptionNodeOptions>;
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type UnitNodeChoicesAggregateArgs = {
  where?: InputMaybe<ProductOptionNodeWhere>;
};


export type UnitNodeChoicesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UnitNodeChoicesConnectionSort>>;
  where?: InputMaybe<UnitNodeChoicesConnectionWhere>;
};


export type UnitNodeItemsArgs = {
  options?: InputMaybe<ItemNodeOptions>;
  where?: InputMaybe<ItemNodeWhere>;
};


export type UnitNodeItemsAggregateArgs = {
  where?: InputMaybe<ItemNodeWhere>;
};


export type UnitNodeItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UnitNodeItemsConnectionSort>>;
  where?: InputMaybe<UnitNodeItemsConnectionWhere>;
};


export type UnitNodeProjectArgs = {
  options?: InputMaybe<ProjectNodeOptions>;
  where?: InputMaybe<ProjectNodeWhere>;
};


export type UnitNodeProjectAggregateArgs = {
  where?: InputMaybe<ProjectNodeWhere>;
};


export type UnitNodeProjectConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UnitNodeProjectConnectionSort>>;
  where?: InputMaybe<UnitNodeProjectConnectionWhere>;
};

export type UnitNodeAggregateSelection = {
  __typename?: 'unitNodeAggregateSelection';
  count: Scalars['Int'];
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type UnitNodeBaseConfigurationsAggregateInput = {
  AND?: InputMaybe<Array<UnitNodeBaseConfigurationsAggregateInput>>;
  OR?: InputMaybe<Array<UnitNodeBaseConfigurationsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<UnitNodeBaseConfigurationsNodeAggregationWhereInput>;
};

export type UnitNodeBaseConfigurationsConnectFieldInput = {
  connect?: InputMaybe<Array<ProductNodeConnectInput>>;
  where?: InputMaybe<ProductNodeConnectWhere>;
};

export type UnitNodeBaseConfigurationsConnection = {
  __typename?: 'unitNodeBaseConfigurationsConnection';
  edges: Array<UnitNodeBaseConfigurationsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UnitNodeBaseConfigurationsConnectionSort = {
  node?: InputMaybe<ProductNodeSort>;
};

export type UnitNodeBaseConfigurationsConnectionWhere = {
  AND?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectionWhere>>;
  OR?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectionWhere>>;
  node?: InputMaybe<ProductNodeWhere>;
  node_NOT?: InputMaybe<ProductNodeWhere>;
};

export type UnitNodeBaseConfigurationsCreateFieldInput = {
  node: ProductNodeCreateInput;
};

export type UnitNodeBaseConfigurationsDeleteFieldInput = {
  delete?: InputMaybe<ProductNodeDeleteInput>;
  where?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
};

export type UnitNodeBaseConfigurationsDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductNodeDisconnectInput>;
  where?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
};

export type UnitNodeBaseConfigurationsFieldInput = {
  connect?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeBaseConfigurationsCreateFieldInput>>;
};

export type UnitNodeBaseConfigurationsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UnitNodeBaseConfigurationsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UnitNodeBaseConfigurationsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  sku_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  sku_EQUAL?: InputMaybe<Scalars['String']>;
  sku_GT?: InputMaybe<Scalars['Int']>;
  sku_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  sku_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  sku_LT?: InputMaybe<Scalars['Int']>;
  sku_LTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  sku_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UnitNodeBaseConfigurationsRelationship = {
  __typename?: 'unitNodeBaseConfigurationsRelationship';
  cursor: Scalars['String'];
  node: ProductNode;
};

export type UnitNodeBaseConfigurationsUpdateConnectionInput = {
  node?: InputMaybe<ProductNodeUpdateInput>;
};

export type UnitNodeBaseConfigurationsUpdateFieldInput = {
  connect?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeBaseConfigurationsCreateFieldInput>>;
  delete?: InputMaybe<Array<UnitNodeBaseConfigurationsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UnitNodeBaseConfigurationsDisconnectFieldInput>>;
  update?: InputMaybe<UnitNodeBaseConfigurationsUpdateConnectionInput>;
  where?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
};

export type UnitNodeChoicesAggregateInput = {
  AND?: InputMaybe<Array<UnitNodeChoicesAggregateInput>>;
  OR?: InputMaybe<Array<UnitNodeChoicesAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<UnitNodeChoicesNodeAggregationWhereInput>;
};

export type UnitNodeChoicesConnectFieldInput = {
  connect?: InputMaybe<Array<ProductOptionNodeConnectInput>>;
  where?: InputMaybe<ProductOptionNodeConnectWhere>;
};

export type UnitNodeChoicesConnection = {
  __typename?: 'unitNodeChoicesConnection';
  edges: Array<UnitNodeChoicesRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UnitNodeChoicesConnectionSort = {
  node?: InputMaybe<ProductOptionNodeSort>;
};

export type UnitNodeChoicesConnectionWhere = {
  AND?: InputMaybe<Array<UnitNodeChoicesConnectionWhere>>;
  OR?: InputMaybe<Array<UnitNodeChoicesConnectionWhere>>;
  node?: InputMaybe<ProductOptionNodeWhere>;
  node_NOT?: InputMaybe<ProductOptionNodeWhere>;
};

export type UnitNodeChoicesCreateFieldInput = {
  node: ProductOptionNodeCreateInput;
};

export type UnitNodeChoicesDeleteFieldInput = {
  delete?: InputMaybe<ProductOptionNodeDeleteInput>;
  where?: InputMaybe<UnitNodeChoicesConnectionWhere>;
};

export type UnitNodeChoicesDisconnectFieldInput = {
  disconnect?: InputMaybe<ProductOptionNodeDisconnectInput>;
  where?: InputMaybe<UnitNodeChoicesConnectionWhere>;
};

export type UnitNodeChoicesFieldInput = {
  connect?: InputMaybe<Array<UnitNodeChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeChoicesCreateFieldInput>>;
};

export type UnitNodeChoicesNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UnitNodeChoicesNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UnitNodeChoicesNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  tagpathid_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  tagpathid_EQUAL?: InputMaybe<Scalars['String']>;
  tagpathid_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_LTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  tagpathid_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UnitNodeChoicesRelationship = {
  __typename?: 'unitNodeChoicesRelationship';
  cursor: Scalars['String'];
  node: ProductOptionNode;
};

export type UnitNodeChoicesUpdateConnectionInput = {
  node?: InputMaybe<ProductOptionNodeUpdateInput>;
};

export type UnitNodeChoicesUpdateFieldInput = {
  connect?: InputMaybe<Array<UnitNodeChoicesConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeChoicesCreateFieldInput>>;
  delete?: InputMaybe<Array<UnitNodeChoicesDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UnitNodeChoicesDisconnectFieldInput>>;
  update?: InputMaybe<UnitNodeChoicesUpdateConnectionInput>;
  where?: InputMaybe<UnitNodeChoicesConnectionWhere>;
};

export type UnitNodeConnectInput = {
  baseConfigurations?: InputMaybe<Array<UnitNodeBaseConfigurationsConnectFieldInput>>;
  choices?: InputMaybe<Array<UnitNodeChoicesConnectFieldInput>>;
  items?: InputMaybe<Array<UnitNodeItemsConnectFieldInput>>;
  project?: InputMaybe<UnitNodeProjectConnectFieldInput>;
};

export type UnitNodeConnectWhere = {
  node: UnitNodeWhere;
};

export type UnitNodeCreateInput = {
  baseConfigurations?: InputMaybe<UnitNodeBaseConfigurationsFieldInput>;
  choices?: InputMaybe<UnitNodeChoicesFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<UnitNodeItemsFieldInput>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<UnitNodeProjectFieldInput>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type UnitNodeDeleteInput = {
  baseConfigurations?: InputMaybe<Array<UnitNodeBaseConfigurationsDeleteFieldInput>>;
  choices?: InputMaybe<Array<UnitNodeChoicesDeleteFieldInput>>;
  items?: InputMaybe<Array<UnitNodeItemsDeleteFieldInput>>;
  project?: InputMaybe<UnitNodeProjectDeleteFieldInput>;
};

export type UnitNodeDisconnectInput = {
  baseConfigurations?: InputMaybe<Array<UnitNodeBaseConfigurationsDisconnectFieldInput>>;
  choices?: InputMaybe<Array<UnitNodeChoicesDisconnectFieldInput>>;
  items?: InputMaybe<Array<UnitNodeItemsDisconnectFieldInput>>;
  project?: InputMaybe<UnitNodeProjectDisconnectFieldInput>;
};

export type UnitNodeItemsAggregateInput = {
  AND?: InputMaybe<Array<UnitNodeItemsAggregateInput>>;
  OR?: InputMaybe<Array<UnitNodeItemsAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UnitNodeItemsEdgeAggregationWhereInput>;
  node?: InputMaybe<UnitNodeItemsNodeAggregationWhereInput>;
};

export type UnitNodeItemsConnectFieldInput = {
  connect?: InputMaybe<Array<ItemNodeConnectInput>>;
  edge: QuantityCreateInput;
  where?: InputMaybe<ItemNodeConnectWhere>;
};

export type UnitNodeItemsConnection = {
  __typename?: 'unitNodeItemsConnection';
  edges: Array<UnitNodeItemsRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UnitNodeItemsConnectionSort = {
  edge?: InputMaybe<QuantitySort>;
  node?: InputMaybe<ItemNodeSort>;
};

export type UnitNodeItemsConnectionWhere = {
  AND?: InputMaybe<Array<UnitNodeItemsConnectionWhere>>;
  OR?: InputMaybe<Array<UnitNodeItemsConnectionWhere>>;
  edge?: InputMaybe<QuantityWhere>;
  edge_NOT?: InputMaybe<QuantityWhere>;
  node?: InputMaybe<ItemNodeWhere>;
  node_NOT?: InputMaybe<ItemNodeWhere>;
};

export type UnitNodeItemsCreateFieldInput = {
  edge: QuantityCreateInput;
  node: ItemNodeCreateInput;
};

export type UnitNodeItemsDeleteFieldInput = {
  delete?: InputMaybe<ItemNodeDeleteInput>;
  where?: InputMaybe<UnitNodeItemsConnectionWhere>;
};

export type UnitNodeItemsDisconnectFieldInput = {
  disconnect?: InputMaybe<ItemNodeDisconnectInput>;
  where?: InputMaybe<UnitNodeItemsConnectionWhere>;
};

export type UnitNodeItemsEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UnitNodeItemsEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UnitNodeItemsEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UnitNodeItemsFieldInput = {
  connect?: InputMaybe<Array<UnitNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeItemsCreateFieldInput>>;
};

export type UnitNodeItemsNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UnitNodeItemsNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UnitNodeItemsNodeAggregationWhereInput>>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  partNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  partNumber_EQUAL?: InputMaybe<Scalars['String']>;
  partNumber_GT?: InputMaybe<Scalars['Int']>;
  partNumber_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_LT?: InputMaybe<Scalars['Int']>;
  partNumber_LTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  partNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UnitNodeItemsRelationship = Quantity & {
  __typename?: 'unitNodeItemsRelationship';
  cursor: Scalars['String'];
  include_waste: Scalars['Boolean'];
  node: ItemNode;
  quantity: Scalars['Float'];
};

export type UnitNodeItemsUpdateConnectionInput = {
  edge?: InputMaybe<QuantityUpdateInput>;
  node?: InputMaybe<ItemNodeUpdateInput>;
};

export type UnitNodeItemsUpdateFieldInput = {
  connect?: InputMaybe<Array<UnitNodeItemsConnectFieldInput>>;
  create?: InputMaybe<Array<UnitNodeItemsCreateFieldInput>>;
  delete?: InputMaybe<Array<UnitNodeItemsDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UnitNodeItemsDisconnectFieldInput>>;
  update?: InputMaybe<UnitNodeItemsUpdateConnectionInput>;
  where?: InputMaybe<UnitNodeItemsConnectionWhere>;
};

export type UnitNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more unitNodeSort objects to sort unitNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<UnitNodeSort>>>;
};

export type UnitNodeProjectAggregateInput = {
  AND?: InputMaybe<Array<UnitNodeProjectAggregateInput>>;
  OR?: InputMaybe<Array<UnitNodeProjectAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  node?: InputMaybe<UnitNodeProjectNodeAggregationWhereInput>;
};

export type UnitNodeProjectConnectFieldInput = {
  connect?: InputMaybe<ProjectNodeConnectInput>;
  where?: InputMaybe<ProjectNodeConnectWhere>;
};

export type UnitNodeProjectConnection = {
  __typename?: 'unitNodeProjectConnection';
  edges: Array<UnitNodeProjectRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UnitNodeProjectConnectionSort = {
  node?: InputMaybe<ProjectNodeSort>;
};

export type UnitNodeProjectConnectionWhere = {
  AND?: InputMaybe<Array<UnitNodeProjectConnectionWhere>>;
  OR?: InputMaybe<Array<UnitNodeProjectConnectionWhere>>;
  node?: InputMaybe<ProjectNodeWhere>;
  node_NOT?: InputMaybe<ProjectNodeWhere>;
};

export type UnitNodeProjectCreateFieldInput = {
  node: ProjectNodeCreateInput;
};

export type UnitNodeProjectDeleteFieldInput = {
  delete?: InputMaybe<ProjectNodeDeleteInput>;
  where?: InputMaybe<UnitNodeProjectConnectionWhere>;
};

export type UnitNodeProjectDisconnectFieldInput = {
  disconnect?: InputMaybe<ProjectNodeDisconnectInput>;
  where?: InputMaybe<UnitNodeProjectConnectionWhere>;
};

export type UnitNodeProjectFieldInput = {
  connect?: InputMaybe<UnitNodeProjectConnectFieldInput>;
  create?: InputMaybe<UnitNodeProjectCreateFieldInput>;
};

export type UnitNodeProjectNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UnitNodeProjectNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UnitNodeProjectNodeAggregationWhereInput>>;
  bloxProjectNumber_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  bloxProjectNumber_EQUAL?: InputMaybe<Scalars['String']>;
  bloxProjectNumber_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_LTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  bloxProjectNumber_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  name_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  name_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  name_EQUAL?: InputMaybe<Scalars['String']>;
  name_GT?: InputMaybe<Scalars['Int']>;
  name_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  name_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  name_LT?: InputMaybe<Scalars['Int']>;
  name_LTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  name_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  wevrId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  wevrId_EQUAL?: InputMaybe<Scalars['String']>;
  wevrId_GT?: InputMaybe<Scalars['Int']>;
  wevrId_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_LT?: InputMaybe<Scalars['Int']>;
  wevrId_LTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  wevrId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UnitNodeProjectRelationship = {
  __typename?: 'unitNodeProjectRelationship';
  cursor: Scalars['String'];
  node: ProjectNode;
};

export type UnitNodeProjectUpdateConnectionInput = {
  node?: InputMaybe<ProjectNodeUpdateInput>;
};

export type UnitNodeProjectUpdateFieldInput = {
  connect?: InputMaybe<UnitNodeProjectConnectFieldInput>;
  create?: InputMaybe<UnitNodeProjectCreateFieldInput>;
  delete?: InputMaybe<UnitNodeProjectDeleteFieldInput>;
  disconnect?: InputMaybe<UnitNodeProjectDisconnectFieldInput>;
  update?: InputMaybe<UnitNodeProjectUpdateConnectionInput>;
  where?: InputMaybe<UnitNodeProjectConnectionWhere>;
};

export type UnitNodeRelationInput = {
  baseConfigurations?: InputMaybe<Array<UnitNodeBaseConfigurationsCreateFieldInput>>;
  choices?: InputMaybe<Array<UnitNodeChoicesCreateFieldInput>>;
  items?: InputMaybe<Array<UnitNodeItemsCreateFieldInput>>;
  project?: InputMaybe<UnitNodeProjectCreateFieldInput>;
};

/** Fields to sort unitNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one unitNodeSort object. */
export type UnitNodeSort = {
  description?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  tagpathid?: InputMaybe<SortDirection>;
  wevrId?: InputMaybe<SortDirection>;
};

export type UnitNodeUpdateInput = {
  baseConfigurations?: InputMaybe<Array<UnitNodeBaseConfigurationsUpdateFieldInput>>;
  choices?: InputMaybe<Array<UnitNodeChoicesUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<UnitNodeItemsUpdateFieldInput>>;
  name?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<UnitNodeProjectUpdateFieldInput>;
  tagpathid?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
};

export type UnitNodeWhere = {
  AND?: InputMaybe<Array<UnitNodeWhere>>;
  OR?: InputMaybe<Array<UnitNodeWhere>>;
  baseConfigurations?: InputMaybe<ProductNodeWhere>;
  baseConfigurationsAggregate?: InputMaybe<UnitNodeBaseConfigurationsAggregateInput>;
  baseConfigurationsConnection?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
  baseConfigurationsConnection_NOT?: InputMaybe<UnitNodeBaseConfigurationsConnectionWhere>;
  baseConfigurations_NOT?: InputMaybe<ProductNodeWhere>;
  choices?: InputMaybe<ProductOptionNodeWhere>;
  choicesAggregate?: InputMaybe<UnitNodeChoicesAggregateInput>;
  choicesConnection?: InputMaybe<UnitNodeChoicesConnectionWhere>;
  choicesConnection_NOT?: InputMaybe<UnitNodeChoicesConnectionWhere>;
  choices_NOT?: InputMaybe<ProductOptionNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<ItemNodeWhere>;
  itemsAggregate?: InputMaybe<UnitNodeItemsAggregateInput>;
  itemsConnection?: InputMaybe<UnitNodeItemsConnectionWhere>;
  itemsConnection_NOT?: InputMaybe<UnitNodeItemsConnectionWhere>;
  items_NOT?: InputMaybe<ItemNodeWhere>;
  name?: InputMaybe<Scalars['String']>;
  name_CONTAINS?: InputMaybe<Scalars['String']>;
  name_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT?: InputMaybe<Scalars['String']>;
  name_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  name_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  name_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  name_STARTS_WITH?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<ProjectNodeWhere>;
  projectAggregate?: InputMaybe<UnitNodeProjectAggregateInput>;
  projectConnection?: InputMaybe<UnitNodeProjectConnectionWhere>;
  projectConnection_NOT?: InputMaybe<UnitNodeProjectConnectionWhere>;
  project_NOT?: InputMaybe<ProjectNodeWhere>;
  tagpathid?: InputMaybe<Scalars['String']>;
  tagpathid_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tagpathid_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  tagpathid_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId?: InputMaybe<Scalars['String']>;
  wevrId_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT?: InputMaybe<Scalars['String']>;
  wevrId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  wevrId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  wevrId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  wevrId_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type UnitNodeitemNodeItemsAggregationSelection = {
  __typename?: 'unitNodeitemNodeItemsAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UnitNodeitemNodeItemsEdgeAggregateSelection>;
  node?: Maybe<UnitNodeitemNodeItemsNodeAggregateSelection>;
};

export type UnitNodeitemNodeItemsEdgeAggregateSelection = {
  __typename?: 'unitNodeitemNodeItemsEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type UnitNodeitemNodeItemsNodeAggregateSelection = {
  __typename?: 'unitNodeitemNodeItemsNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  partNumber: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type UnitNodeproductNodeBaseConfigurationsAggregationSelection = {
  __typename?: 'unitNodeproductNodeBaseConfigurationsAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<UnitNodeproductNodeBaseConfigurationsNodeAggregateSelection>;
};

export type UnitNodeproductNodeBaseConfigurationsNodeAggregateSelection = {
  __typename?: 'unitNodeproductNodeBaseConfigurationsNodeAggregateSelection';
  description: StringAggregateSelection;
  sku: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type UnitNodeproductOptionNodeChoicesAggregationSelection = {
  __typename?: 'unitNodeproductOptionNodeChoicesAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<UnitNodeproductOptionNodeChoicesNodeAggregateSelection>;
};

export type UnitNodeproductOptionNodeChoicesNodeAggregateSelection = {
  __typename?: 'unitNodeproductOptionNodeChoicesNodeAggregateSelection';
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  tagpathid: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

export type UnitNodeprojectNodeProjectAggregationSelection = {
  __typename?: 'unitNodeprojectNodeProjectAggregationSelection';
  count: Scalars['Int'];
  node?: Maybe<UnitNodeprojectNodeProjectNodeAggregateSelection>;
};

export type UnitNodeprojectNodeProjectNodeAggregateSelection = {
  __typename?: 'unitNodeprojectNodeProjectNodeAggregateSelection';
  bloxProjectNumber: StringAggregateSelection;
  description: StringAggregateSelection;
  name: StringAggregateSelection;
  wevrId: StringAggregateSelection;
};

/** aggregated selection of "unit" */
export type Unit_Aggregate = {
  __typename?: 'unit_aggregate';
  aggregate?: Maybe<Unit_Aggregate_Fields>;
  nodes: Array<Unit>;
};

export type Unit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Unit_Aggregate_Bool_Exp_Count>;
};

export type Unit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unit" */
export type Unit_Aggregate_Fields = {
  __typename?: 'unit_aggregate_fields';
  avg?: Maybe<Unit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Max_Fields>;
  min?: Maybe<Unit_Min_Fields>;
  stddev?: Maybe<Unit_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Sum_Fields>;
  var_pop?: Maybe<Unit_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Var_Samp_Fields>;
  variance?: Maybe<Unit_Variance_Fields>;
};


/** aggregate fields of "unit" */
export type Unit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit" */
export type Unit_Aggregate_Order_By = {
  avg?: InputMaybe<Unit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Max_Order_By>;
  min?: InputMaybe<Unit_Min_Order_By>;
  stddev?: InputMaybe<Unit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unit_Sum_Order_By>;
  var_pop?: InputMaybe<Unit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unit_Var_Samp_Order_By>;
  variance?: InputMaybe<Unit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unit" */
export type Unit_Arr_Rel_Insert_Input = {
  data: Array<Unit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** aggregate avg on columns */
export type Unit_Avg_Fields = {
  __typename?: 'unit_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unit" */
export type Unit_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "unit_bom_entity_view" */
export type Unit_Bom_Entity_View = {
  __typename?: 'unit_bom_entity_view';
  entity_id?: Maybe<Scalars['String']>;
  include_waste?: Maybe<Scalars['Boolean']>;
  quantity?: Maybe<Scalars['numeric']>;
  tag_path_ids?: Maybe<Scalars['_int4']>;
  tag_set_ids?: Maybe<Scalars['_uuid']>;
  tag_set_names?: Maybe<Scalars['_text']>;
  tag_set_quantities?: Maybe<Scalars['_numeric']>;
  /** An object relationship */
  unit_bom_entity?: Maybe<Part_Download_View>;
  unit_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Aggregate = {
  __typename?: 'unit_bom_entity_view_aggregate';
  aggregate?: Maybe<Unit_Bom_Entity_View_Aggregate_Fields>;
  nodes: Array<Unit_Bom_Entity_View>;
};

export type Unit_Bom_Entity_View_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Unit_Bom_Entity_View_Aggregate_Bool_Exp_Count>;
};

export type Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_And = {
  arguments: Unit_Bom_Entity_View_Select_Column_Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Unit_Bom_Entity_View_Select_Column_Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Unit_Bom_Entity_View_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Aggregate_Fields = {
  __typename?: 'unit_bom_entity_view_aggregate_fields';
  avg?: Maybe<Unit_Bom_Entity_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Bom_Entity_View_Max_Fields>;
  min?: Maybe<Unit_Bom_Entity_View_Min_Fields>;
  stddev?: Maybe<Unit_Bom_Entity_View_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Bom_Entity_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Bom_Entity_View_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Bom_Entity_View_Sum_Fields>;
  var_pop?: Maybe<Unit_Bom_Entity_View_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Bom_Entity_View_Var_Samp_Fields>;
  variance?: Maybe<Unit_Bom_Entity_View_Variance_Fields>;
};


/** aggregate fields of "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Bom_Entity_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Aggregate_Order_By = {
  avg?: InputMaybe<Unit_Bom_Entity_View_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Bom_Entity_View_Max_Order_By>;
  min?: InputMaybe<Unit_Bom_Entity_View_Min_Order_By>;
  stddev?: InputMaybe<Unit_Bom_Entity_View_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unit_Bom_Entity_View_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unit_Bom_Entity_View_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unit_Bom_Entity_View_Sum_Order_By>;
  var_pop?: InputMaybe<Unit_Bom_Entity_View_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unit_Bom_Entity_View_Var_Samp_Order_By>;
  variance?: InputMaybe<Unit_Bom_Entity_View_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Arr_Rel_Insert_Input = {
  data: Array<Unit_Bom_Entity_View_Insert_Input>;
};

/** aggregate avg on columns */
export type Unit_Bom_Entity_View_Avg_Fields = {
  __typename?: 'unit_bom_entity_view_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unit_bom_entity_view". All fields are combined with a logical 'AND'. */
export type Unit_Bom_Entity_View_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bom_Entity_View_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bom_Entity_View_Bool_Exp>>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  include_waste?: InputMaybe<Boolean_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tag_path_ids?: InputMaybe<_Int4_Comparison_Exp>;
  tag_set_ids?: InputMaybe<_Uuid_Comparison_Exp>;
  tag_set_names?: InputMaybe<_Text_Comparison_Exp>;
  tag_set_quantities?: InputMaybe<_Numeric_Comparison_Exp>;
  unit_bom_entity?: InputMaybe<Part_Download_View_Bool_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** input type for inserting data into table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Insert_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  tag_path_ids?: InputMaybe<Scalars['_int4']>;
  tag_set_ids?: InputMaybe<Scalars['_uuid']>;
  tag_set_names?: InputMaybe<Scalars['_text']>;
  tag_set_quantities?: InputMaybe<Scalars['_numeric']>;
  unit_bom_entity?: InputMaybe<Part_Download_View_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unit_Bom_Entity_View_Max_Fields = {
  __typename?: 'unit_bom_entity_view_max_fields';
  entity_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Max_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Bom_Entity_View_Min_Fields = {
  __typename?: 'unit_bom_entity_view_min_fields';
  entity_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Min_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "unit_bom_entity_view". */
export type Unit_Bom_Entity_View_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  include_waste?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tag_path_ids?: InputMaybe<Order_By>;
  tag_set_ids?: InputMaybe<Order_By>;
  tag_set_names?: InputMaybe<Order_By>;
  tag_set_quantities?: InputMaybe<Order_By>;
  unit_bom_entity?: InputMaybe<Part_Download_View_Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** select columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Select_Column =
  /** column name */
  | 'entity_id'
  /** column name */
  | 'include_waste'
  /** column name */
  | 'quantity'
  /** column name */
  | 'tag_path_ids'
  /** column name */
  | 'tag_set_ids'
  /** column name */
  | 'tag_set_names'
  /** column name */
  | 'tag_set_quantities'
  /** column name */
  | 'unit_id';

/** select "unit_bom_entity_view_aggregate_bool_exp_bool_and_arguments_columns" columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Select_Column_Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** select "unit_bom_entity_view_aggregate_bool_exp_bool_or_arguments_columns" columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Select_Column_Unit_Bom_Entity_View_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'include_waste';

/** aggregate stddev on columns */
export type Unit_Bom_Entity_View_Stddev_Fields = {
  __typename?: 'unit_bom_entity_view_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unit_Bom_Entity_View_Stddev_Pop_Fields = {
  __typename?: 'unit_bom_entity_view_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unit_Bom_Entity_View_Stddev_Samp_Fields = {
  __typename?: 'unit_bom_entity_view_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Bom_Entity_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Bom_Entity_View_Stream_Cursor_Value_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  include_waste?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  tag_path_ids?: InputMaybe<Scalars['_int4']>;
  tag_set_ids?: InputMaybe<Scalars['_uuid']>;
  tag_set_names?: InputMaybe<Scalars['_text']>;
  tag_set_quantities?: InputMaybe<Scalars['_numeric']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Unit_Bom_Entity_View_Sum_Fields = {
  __typename?: 'unit_bom_entity_view_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Unit_Bom_Entity_View_Var_Pop_Fields = {
  __typename?: 'unit_bom_entity_view_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unit_Bom_Entity_View_Var_Samp_Fields = {
  __typename?: 'unit_bom_entity_view_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unit_Bom_Entity_View_Variance_Fields = {
  __typename?: 'unit_bom_entity_view_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unit_bom_entity_view" */
export type Unit_Bom_Entity_View_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unit". All fields are combined with a logical 'AND'. */
export type Unit_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Bool_Exp>>;
  _not?: InputMaybe<Unit_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Bool_Exp>>;
  actual_off_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  actual_on_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  base_product?: InputMaybe<Base_Product_Bool_Exp>;
  base_product_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  items?: InputMaybe<Item_Bom_Bool_Exp>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Bool_Exp>;
  old_project?: InputMaybe<String_Comparison_Exp>;
  old_serial_number?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
  options_aggregate?: InputMaybe<Unit_Product_Option_Choice_Aggregate_Bool_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  project?: InputMaybe<Project_Bool_Exp>;
  project_id?: InputMaybe<String_Comparison_Exp>;
  schedule_off_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  schedule_on_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  selected_tag_sets?: InputMaybe<Unit_Tag_View_Bool_Exp>;
  selected_tag_sets_aggregate?: InputMaybe<Unit_Tag_View_Aggregate_Bool_Exp>;
  serial_number?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Tag_Entity_Bool_Exp>;
  tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Bool_Exp>;
  unit_bom?: InputMaybe<Unit_Bom_Entity_View_Bool_Exp>;
  unit_bom_aggregate?: InputMaybe<Unit_Bom_Entity_View_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit" */
export type Unit_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'unit_pkey'
  /** unique or primary key constraint on columns "serial_number" */
  | 'unit_serial_number_key';

/** input type for incrementing numeric columns in table "unit" */
export type Unit_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "unit" */
export type Unit_Insert_Input = {
  actual_off_date?: InputMaybe<Scalars['timestamptz']>;
  actual_on_date?: InputMaybe<Scalars['timestamptz']>;
  base_product?: InputMaybe<Base_Product_Obj_Rel_Insert_Input>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Item_Bom_Arr_Rel_Insert_Input>;
  old_project?: InputMaybe<Scalars['String']>;
  old_serial_number?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Unit_Product_Option_Choice_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['numeric']>;
  project?: InputMaybe<Project_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['String']>;
  schedule_off_date?: InputMaybe<Scalars['timestamptz']>;
  schedule_on_date?: InputMaybe<Scalars['timestamptz']>;
  selected_tag_sets?: InputMaybe<Unit_Tag_View_Arr_Rel_Insert_Input>;
  serial_number?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Tag_Entity_Arr_Rel_Insert_Input>;
  unit_bom?: InputMaybe<Unit_Bom_Entity_View_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Unit_Max_Fields = {
  __typename?: 'unit_max_fields';
  actual_off_date?: Maybe<Scalars['timestamptz']>;
  actual_on_date?: Maybe<Scalars['timestamptz']>;
  base_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  old_project?: Maybe<Scalars['String']>;
  old_serial_number?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  project_id?: Maybe<Scalars['String']>;
  schedule_off_date?: Maybe<Scalars['timestamptz']>;
  schedule_on_date?: Maybe<Scalars['timestamptz']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "unit" */
export type Unit_Max_Order_By = {
  actual_off_date?: InputMaybe<Order_By>;
  actual_on_date?: InputMaybe<Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_project?: InputMaybe<Order_By>;
  old_serial_number?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  schedule_off_date?: InputMaybe<Order_By>;
  schedule_on_date?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Min_Fields = {
  __typename?: 'unit_min_fields';
  actual_off_date?: Maybe<Scalars['timestamptz']>;
  actual_on_date?: Maybe<Scalars['timestamptz']>;
  base_product_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  old_project?: Maybe<Scalars['String']>;
  old_serial_number?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  project_id?: Maybe<Scalars['String']>;
  schedule_off_date?: Maybe<Scalars['timestamptz']>;
  schedule_on_date?: Maybe<Scalars['timestamptz']>;
  serial_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "unit" */
export type Unit_Min_Order_By = {
  actual_off_date?: InputMaybe<Order_By>;
  actual_on_date?: InputMaybe<Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  old_project?: InputMaybe<Order_By>;
  old_serial_number?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  schedule_off_date?: InputMaybe<Order_By>;
  schedule_on_date?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unit" */
export type Unit_Mutation_Response = {
  __typename?: 'unit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit>;
};

/** input type for inserting object relation for remote table "unit" */
export type Unit_Obj_Rel_Insert_Input = {
  data: Unit_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_On_Conflict>;
};

/** on_conflict condition type for table "unit" */
export type Unit_On_Conflict = {
  constraint: Unit_Constraint;
  update_columns?: Array<Unit_Update_Column>;
  where?: InputMaybe<Unit_Bool_Exp>;
};

/** Ordering options when selecting data from "unit". */
export type Unit_Order_By = {
  actual_off_date?: InputMaybe<Order_By>;
  actual_on_date?: InputMaybe<Order_By>;
  base_product?: InputMaybe<Base_Product_Order_By>;
  base_product_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items_aggregate?: InputMaybe<Item_Bom_Aggregate_Order_By>;
  old_project?: InputMaybe<Order_By>;
  old_serial_number?: InputMaybe<Order_By>;
  options_aggregate?: InputMaybe<Unit_Product_Option_Choice_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  project?: InputMaybe<Project_Order_By>;
  project_id?: InputMaybe<Order_By>;
  schedule_off_date?: InputMaybe<Order_By>;
  schedule_on_date?: InputMaybe<Order_By>;
  selected_tag_sets_aggregate?: InputMaybe<Unit_Tag_View_Aggregate_Order_By>;
  serial_number?: InputMaybe<Order_By>;
  tags_aggregate?: InputMaybe<Tag_Entity_Aggregate_Order_By>;
  unit_bom_aggregate?: InputMaybe<Unit_Bom_Entity_View_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit */
export type Unit_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** columns and relationships of "unit_product_option_choice" */
export type Unit_Product_Option_Choice = {
  __typename?: 'unit_product_option_choice';
  /** An object relationship */
  product_option_choice: Product_Option_Choice;
  product_option_choice_id: Scalars['String'];
  /** An object relationship */
  unit: Unit;
  unit_id: Scalars['String'];
};

/** aggregated selection of "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Aggregate = {
  __typename?: 'unit_product_option_choice_aggregate';
  aggregate?: Maybe<Unit_Product_Option_Choice_Aggregate_Fields>;
  nodes: Array<Unit_Product_Option_Choice>;
};

export type Unit_Product_Option_Choice_Aggregate_Bool_Exp = {
  count?: InputMaybe<Unit_Product_Option_Choice_Aggregate_Bool_Exp_Count>;
};

export type Unit_Product_Option_Choice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Aggregate_Fields = {
  __typename?: 'unit_product_option_choice_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Unit_Product_Option_Choice_Max_Fields>;
  min?: Maybe<Unit_Product_Option_Choice_Min_Fields>;
};


/** aggregate fields of "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Product_Option_Choice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Product_Option_Choice_Max_Order_By>;
  min?: InputMaybe<Unit_Product_Option_Choice_Min_Order_By>;
};

/** input type for inserting array relation for remote table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Arr_Rel_Insert_Input = {
  data: Array<Unit_Product_Option_Choice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Unit_Product_Option_Choice_On_Conflict>;
};

/** Boolean expression to filter rows from the table "unit_product_option_choice". All fields are combined with a logical 'AND'. */
export type Unit_Product_Option_Choice_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Product_Option_Choice_Bool_Exp>>;
  _not?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Product_Option_Choice_Bool_Exp>>;
  product_option_choice?: InputMaybe<Product_Option_Choice_Bool_Exp>;
  product_option_choice_id?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Unit_Bool_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Constraint =
  /** unique or primary key constraint on columns "unit_id", "product_option_choice_id" */
  | 'unit_product_option_choice_pkey';

/** input type for inserting data into table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Insert_Input = {
  product_option_choice?: InputMaybe<Product_Option_Choice_Obj_Rel_Insert_Input>;
  product_option_choice_id?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Unit_Obj_Rel_Insert_Input>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Unit_Product_Option_Choice_Max_Fields = {
  __typename?: 'unit_product_option_choice_max_fields';
  product_option_choice_id?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Max_Order_By = {
  product_option_choice_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Product_Option_Choice_Min_Fields = {
  __typename?: 'unit_product_option_choice_min_fields';
  product_option_choice_id?: Maybe<Scalars['String']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Min_Order_By = {
  product_option_choice_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Mutation_Response = {
  __typename?: 'unit_product_option_choice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Unit_Product_Option_Choice>;
};

/** on_conflict condition type for table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_On_Conflict = {
  constraint: Unit_Product_Option_Choice_Constraint;
  update_columns?: Array<Unit_Product_Option_Choice_Update_Column>;
  where?: InputMaybe<Unit_Product_Option_Choice_Bool_Exp>;
};

/** Ordering options when selecting data from "unit_product_option_choice". */
export type Unit_Product_Option_Choice_Order_By = {
  product_option_choice?: InputMaybe<Product_Option_Choice_Order_By>;
  product_option_choice_id?: InputMaybe<Order_By>;
  unit?: InputMaybe<Unit_Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: unit_product_option_choice */
export type Unit_Product_Option_Choice_Pk_Columns_Input = {
  product_option_choice_id: Scalars['String'];
  unit_id: Scalars['String'];
};

/** select columns of table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Select_Column =
  /** column name */
  | 'product_option_choice_id'
  /** column name */
  | 'unit_id';

/** input type for updating data in table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Set_Input = {
  product_option_choice_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Product_Option_Choice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Product_Option_Choice_Stream_Cursor_Value_Input = {
  product_option_choice_id?: InputMaybe<Scalars['String']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "unit_product_option_choice" */
export type Unit_Product_Option_Choice_Update_Column =
  /** column name */
  | 'product_option_choice_id'
  /** column name */
  | 'unit_id';

export type Unit_Product_Option_Choice_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Product_Option_Choice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Product_Option_Choice_Bool_Exp;
};

/** select columns of table "unit" */
export type Unit_Select_Column =
  /** column name */
  | 'actual_off_date'
  /** column name */
  | 'actual_on_date'
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'old_project'
  /** column name */
  | 'old_serial_number'
  /** column name */
  | 'price'
  /** column name */
  | 'project_id'
  /** column name */
  | 'schedule_off_date'
  /** column name */
  | 'schedule_on_date'
  /** column name */
  | 'serial_number'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "unit" */
export type Unit_Set_Input = {
  actual_off_date?: InputMaybe<Scalars['timestamptz']>;
  actual_on_date?: InputMaybe<Scalars['timestamptz']>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  old_project?: InputMaybe<Scalars['String']>;
  old_serial_number?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  project_id?: InputMaybe<Scalars['String']>;
  schedule_off_date?: InputMaybe<Scalars['timestamptz']>;
  schedule_on_date?: InputMaybe<Scalars['timestamptz']>;
  serial_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Unit_Stddev_Fields = {
  __typename?: 'unit_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unit" */
export type Unit_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unit_Stddev_Pop_Fields = {
  __typename?: 'unit_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unit" */
export type Unit_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unit_Stddev_Samp_Fields = {
  __typename?: 'unit_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unit" */
export type Unit_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unit" */
export type Unit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Stream_Cursor_Value_Input = {
  actual_off_date?: InputMaybe<Scalars['timestamptz']>;
  actual_on_date?: InputMaybe<Scalars['timestamptz']>;
  base_product_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  old_project?: InputMaybe<Scalars['String']>;
  old_serial_number?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  project_id?: InputMaybe<Scalars['String']>;
  schedule_off_date?: InputMaybe<Scalars['timestamptz']>;
  schedule_on_date?: InputMaybe<Scalars['timestamptz']>;
  serial_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Unit_Sum_Fields = {
  __typename?: 'unit_sum_fields';
  price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "unit" */
export type Unit_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "unit_tag_path_view" */
export type Unit_Tag_Path_View = {
  __typename?: 'unit_tag_path_view';
  tag_path_id?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "unit_tag_path_view" */
export type Unit_Tag_Path_View_Aggregate = {
  __typename?: 'unit_tag_path_view_aggregate';
  aggregate?: Maybe<Unit_Tag_Path_View_Aggregate_Fields>;
  nodes: Array<Unit_Tag_Path_View>;
};

/** aggregate fields of "unit_tag_path_view" */
export type Unit_Tag_Path_View_Aggregate_Fields = {
  __typename?: 'unit_tag_path_view_aggregate_fields';
  avg?: Maybe<Unit_Tag_Path_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Tag_Path_View_Max_Fields>;
  min?: Maybe<Unit_Tag_Path_View_Min_Fields>;
  stddev?: Maybe<Unit_Tag_Path_View_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Tag_Path_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Tag_Path_View_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Tag_Path_View_Sum_Fields>;
  var_pop?: Maybe<Unit_Tag_Path_View_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Tag_Path_View_Var_Samp_Fields>;
  variance?: Maybe<Unit_Tag_Path_View_Variance_Fields>;
};


/** aggregate fields of "unit_tag_path_view" */
export type Unit_Tag_Path_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Tag_Path_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Unit_Tag_Path_View_Avg_Fields = {
  __typename?: 'unit_tag_path_view_avg_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "unit_tag_path_view". All fields are combined with a logical 'AND'. */
export type Unit_Tag_Path_View_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Tag_Path_View_Bool_Exp>>;
  _not?: InputMaybe<Unit_Tag_Path_View_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Tag_Path_View_Bool_Exp>>;
  tag_path_id?: InputMaybe<Int_Comparison_Exp>;
  unit_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Unit_Tag_Path_View_Max_Fields = {
  __typename?: 'unit_tag_path_view_max_fields';
  tag_path_id?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Unit_Tag_Path_View_Min_Fields = {
  __typename?: 'unit_tag_path_view_min_fields';
  tag_path_id?: Maybe<Scalars['Int']>;
  unit_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "unit_tag_path_view". */
export type Unit_Tag_Path_View_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
  unit_id?: InputMaybe<Order_By>;
};

/** select columns of table "unit_tag_path_view" */
export type Unit_Tag_Path_View_Select_Column =
  /** column name */
  | 'tag_path_id'
  /** column name */
  | 'unit_id';

/** aggregate stddev on columns */
export type Unit_Tag_Path_View_Stddev_Fields = {
  __typename?: 'unit_tag_path_view_stddev_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Unit_Tag_Path_View_Stddev_Pop_Fields = {
  __typename?: 'unit_tag_path_view_stddev_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Unit_Tag_Path_View_Stddev_Samp_Fields = {
  __typename?: 'unit_tag_path_view_stddev_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "unit_tag_path_view" */
export type Unit_Tag_Path_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Tag_Path_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Tag_Path_View_Stream_Cursor_Value_Input = {
  tag_path_id?: InputMaybe<Scalars['Int']>;
  unit_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Unit_Tag_Path_View_Sum_Fields = {
  __typename?: 'unit_tag_path_view_sum_fields';
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Unit_Tag_Path_View_Var_Pop_Fields = {
  __typename?: 'unit_tag_path_view_var_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Unit_Tag_Path_View_Var_Samp_Fields = {
  __typename?: 'unit_tag_path_view_var_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Unit_Tag_Path_View_Variance_Fields = {
  __typename?: 'unit_tag_path_view_variance_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "unit_tag_view" */
export type Unit_Tag_View = {
  __typename?: 'unit_tag_view';
  entity_id?: Maybe<Scalars['String']>;
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "unit_tag_view" */
export type Unit_Tag_View_Aggregate = {
  __typename?: 'unit_tag_view_aggregate';
  aggregate?: Maybe<Unit_Tag_View_Aggregate_Fields>;
  nodes: Array<Unit_Tag_View>;
};

export type Unit_Tag_View_Aggregate_Bool_Exp = {
  count?: InputMaybe<Unit_Tag_View_Aggregate_Bool_Exp_Count>;
};

export type Unit_Tag_View_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Unit_Tag_View_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "unit_tag_view" */
export type Unit_Tag_View_Aggregate_Fields = {
  __typename?: 'unit_tag_view_aggregate_fields';
  avg?: Maybe<Unit_Tag_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Unit_Tag_View_Max_Fields>;
  min?: Maybe<Unit_Tag_View_Min_Fields>;
  stddev?: Maybe<Unit_Tag_View_Stddev_Fields>;
  stddev_pop?: Maybe<Unit_Tag_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unit_Tag_View_Stddev_Samp_Fields>;
  sum?: Maybe<Unit_Tag_View_Sum_Fields>;
  var_pop?: Maybe<Unit_Tag_View_Var_Pop_Fields>;
  var_samp?: Maybe<Unit_Tag_View_Var_Samp_Fields>;
  variance?: Maybe<Unit_Tag_View_Variance_Fields>;
};


/** aggregate fields of "unit_tag_view" */
export type Unit_Tag_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Unit_Tag_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "unit_tag_view" */
export type Unit_Tag_View_Aggregate_Order_By = {
  avg?: InputMaybe<Unit_Tag_View_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Unit_Tag_View_Max_Order_By>;
  min?: InputMaybe<Unit_Tag_View_Min_Order_By>;
  stddev?: InputMaybe<Unit_Tag_View_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Unit_Tag_View_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Unit_Tag_View_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Unit_Tag_View_Sum_Order_By>;
  var_pop?: InputMaybe<Unit_Tag_View_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Unit_Tag_View_Var_Samp_Order_By>;
  variance?: InputMaybe<Unit_Tag_View_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "unit_tag_view" */
export type Unit_Tag_View_Arr_Rel_Insert_Input = {
  data: Array<Unit_Tag_View_Insert_Input>;
};

/** aggregate avg on columns */
export type Unit_Tag_View_Avg_Fields = {
  __typename?: 'unit_tag_view_avg_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Avg_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "unit_tag_view". All fields are combined with a logical 'AND'. */
export type Unit_Tag_View_Bool_Exp = {
  _and?: InputMaybe<Array<Unit_Tag_View_Bool_Exp>>;
  _not?: InputMaybe<Unit_Tag_View_Bool_Exp>;
  _or?: InputMaybe<Array<Unit_Tag_View_Bool_Exp>>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  tag_path_id?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for inserting data into table "unit_tag_view" */
export type Unit_Tag_View_Insert_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Unit_Tag_View_Max_Fields = {
  __typename?: 'unit_tag_view_max_fields';
  entity_id?: Maybe<Scalars['String']>;
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Max_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Unit_Tag_View_Min_Fields = {
  __typename?: 'unit_tag_view_min_fields';
  entity_id?: Maybe<Scalars['String']>;
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Min_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "unit_tag_view". */
export type Unit_Tag_View_Order_By = {
  entity_id?: InputMaybe<Order_By>;
  tag_path_id?: InputMaybe<Order_By>;
};

/** select columns of table "unit_tag_view" */
export type Unit_Tag_View_Select_Column =
  /** column name */
  | 'entity_id'
  /** column name */
  | 'tag_path_id';

/** aggregate stddev on columns */
export type Unit_Tag_View_Stddev_Fields = {
  __typename?: 'unit_tag_view_stddev_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Stddev_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Unit_Tag_View_Stddev_Pop_Fields = {
  __typename?: 'unit_tag_view_stddev_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Stddev_Pop_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Unit_Tag_View_Stddev_Samp_Fields = {
  __typename?: 'unit_tag_view_stddev_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Stddev_Samp_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "unit_tag_view" */
export type Unit_Tag_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Unit_Tag_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Unit_Tag_View_Stream_Cursor_Value_Input = {
  entity_id?: InputMaybe<Scalars['String']>;
  tag_path_id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Unit_Tag_View_Sum_Fields = {
  __typename?: 'unit_tag_view_sum_fields';
  tag_path_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Sum_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Unit_Tag_View_Var_Pop_Fields = {
  __typename?: 'unit_tag_view_var_pop_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Var_Pop_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unit_Tag_View_Var_Samp_Fields = {
  __typename?: 'unit_tag_view_var_samp_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Var_Samp_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unit_Tag_View_Variance_Fields = {
  __typename?: 'unit_tag_view_variance_fields';
  tag_path_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unit_tag_view" */
export type Unit_Tag_View_Variance_Order_By = {
  tag_path_id?: InputMaybe<Order_By>;
};

/** update columns of table "unit" */
export type Unit_Update_Column =
  /** column name */
  | 'actual_off_date'
  /** column name */
  | 'actual_on_date'
  /** column name */
  | 'base_product_id'
  /** column name */
  | 'created_at'
  /** column name */
  | 'id'
  /** column name */
  | 'old_project'
  /** column name */
  | 'old_serial_number'
  /** column name */
  | 'price'
  /** column name */
  | 'project_id'
  /** column name */
  | 'schedule_off_date'
  /** column name */
  | 'schedule_on_date'
  /** column name */
  | 'serial_number'
  /** column name */
  | 'updated_at';

export type Unit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Unit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Unit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Unit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Unit_Var_Pop_Fields = {
  __typename?: 'unit_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "unit" */
export type Unit_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Unit_Var_Samp_Fields = {
  __typename?: 'unit_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "unit" */
export type Unit_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Unit_Variance_Fields = {
  __typename?: 'unit_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "unit" */
export type Unit_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "uom" */
export type Uom = {
  __typename?: 'uom';
  airtable_pfep_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  qb_set_uom?: Maybe<Scalars['String']>;
  qb_uom?: Maybe<Scalars['String']>;
};

export type UomNode = {
  __typename?: 'uomNode';
  abbreviation?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  classificationAbbreviation?: Maybe<Scalars['String']>;
  classificationId?: Maybe<Scalars['String']>;
  convertsTo?: Maybe<Array<Maybe<UomNode>>>;
  convertsToAggregate?: Maybe<UomNodeuomNodeConvertsToAggregationSelection>;
  convertsToConnection: UomNodeConvertsToConnection;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inTermsOf?: Maybe<Array<Maybe<UomNode>>>;
  inTermsOfAggregate?: Maybe<UomNodeuomNodeInTermsOfAggregationSelection>;
  inTermsOfConnection: UomNodeInTermsOfConnection;
};


export type UomNodeConvertsToArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomNodeConvertsToAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomNodeConvertsToConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomNodeConvertsToConnectionSort>>;
  where?: InputMaybe<UomNodeConvertsToConnectionWhere>;
};


export type UomNodeInTermsOfArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomNodeInTermsOfAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomNodeInTermsOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomNodeInTermsOfConnectionSort>>;
  where?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
};

export type UomNodeAggregateSelection = {
  __typename?: 'uomNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomNodeConnectInput = {
  convertsTo?: InputMaybe<Array<UomNodeConvertsToConnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomNodeInTermsOfConnectFieldInput>>;
};

export type UomNodeConnectWhere = {
  node: UomNodeWhere;
};

export type UomNodeConvertsToAggregateInput = {
  AND?: InputMaybe<Array<UomNodeConvertsToAggregateInput>>;
  OR?: InputMaybe<Array<UomNodeConvertsToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomNodeConvertsToEdgeAggregationWhereInput>;
  node?: InputMaybe<UomNodeConvertsToNodeAggregationWhereInput>;
};

export type UomNodeConvertsToConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: ConvertableCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomNodeConvertsToConnection = {
  __typename?: 'uomNodeConvertsToConnection';
  edges: Array<UomNodeConvertsToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomNodeConvertsToConnectionSort = {
  edge?: InputMaybe<ConvertableSort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomNodeConvertsToConnectionWhere = {
  AND?: InputMaybe<Array<UomNodeConvertsToConnectionWhere>>;
  OR?: InputMaybe<Array<UomNodeConvertsToConnectionWhere>>;
  edge?: InputMaybe<ConvertableWhere>;
  edge_NOT?: InputMaybe<ConvertableWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomNodeConvertsToCreateFieldInput = {
  edge: ConvertableCreateInput;
  node: UomNodeCreateInput;
};

export type UomNodeConvertsToDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomNodeConvertsToConnectionWhere>;
};

export type UomNodeConvertsToDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomNodeConvertsToConnectionWhere>;
};

export type UomNodeConvertsToEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomNodeConvertsToEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomNodeConvertsToEdgeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomNodeConvertsToFieldInput = {
  connect?: InputMaybe<Array<UomNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomNodeConvertsToCreateFieldInput>>;
};

export type UomNodeConvertsToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomNodeConvertsToNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomNodeConvertsToNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomNodeConvertsToRelationship = Convertable & {
  __typename?: 'uomNodeConvertsToRelationship';
  cursor: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomNodeConvertsToUpdateConnectionInput = {
  edge?: InputMaybe<ConvertableUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomNodeConvertsToUpdateFieldInput = {
  connect?: InputMaybe<Array<UomNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomNodeConvertsToCreateFieldInput>>;
  delete?: InputMaybe<Array<UomNodeConvertsToDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomNodeConvertsToDisconnectFieldInput>>;
  update?: InputMaybe<UomNodeConvertsToUpdateConnectionInput>;
  where?: InputMaybe<UomNodeConvertsToConnectionWhere>;
};

export type UomNodeCreateInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  classificationAbbreviation?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomNodeConvertsToFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomNodeInTermsOfFieldInput>;
};

export type UomNodeDeleteInput = {
  convertsTo?: InputMaybe<Array<UomNodeConvertsToDeleteFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomNodeInTermsOfDeleteFieldInput>>;
};

export type UomNodeDisconnectInput = {
  convertsTo?: InputMaybe<Array<UomNodeConvertsToDisconnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomNodeInTermsOfDisconnectFieldInput>>;
};

export type UomNodeInTermsOfAggregateInput = {
  AND?: InputMaybe<Array<UomNodeInTermsOfAggregateInput>>;
  OR?: InputMaybe<Array<UomNodeInTermsOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomNodeInTermsOfEdgeAggregationWhereInput>;
  node?: InputMaybe<UomNodeInTermsOfNodeAggregationWhereInput>;
};

export type UomNodeInTermsOfConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: UomquantityCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomNodeInTermsOfConnection = {
  __typename?: 'uomNodeInTermsOfConnection';
  edges: Array<UomNodeInTermsOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomNodeInTermsOfConnectionSort = {
  edge?: InputMaybe<UomquantitySort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomNodeInTermsOfConnectionWhere = {
  AND?: InputMaybe<Array<UomNodeInTermsOfConnectionWhere>>;
  OR?: InputMaybe<Array<UomNodeInTermsOfConnectionWhere>>;
  edge?: InputMaybe<UomquantityWhere>;
  edge_NOT?: InputMaybe<UomquantityWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomNodeInTermsOfCreateFieldInput = {
  edge: UomquantityCreateInput;
  node: UomNodeCreateInput;
};

export type UomNodeInTermsOfDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
};

export type UomNodeInTermsOfDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
};

export type UomNodeInTermsOfEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomNodeInTermsOfEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomNodeInTermsOfEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomNodeInTermsOfFieldInput = {
  connect?: InputMaybe<Array<UomNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomNodeInTermsOfCreateFieldInput>>;
};

export type UomNodeInTermsOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomNodeInTermsOfNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomNodeInTermsOfNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomNodeInTermsOfRelationship = Uomquantity & {
  __typename?: 'uomNodeInTermsOfRelationship';
  cursor: Scalars['String'];
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomNodeInTermsOfUpdateConnectionInput = {
  edge?: InputMaybe<UomquantityUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomNodeInTermsOfUpdateFieldInput = {
  connect?: InputMaybe<Array<UomNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomNodeInTermsOfCreateFieldInput>>;
  delete?: InputMaybe<Array<UomNodeInTermsOfDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomNodeInTermsOfDisconnectFieldInput>>;
  update?: InputMaybe<UomNodeInTermsOfUpdateConnectionInput>;
  where?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
};

export type UomNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more uomNodeSort objects to sort uomNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<UomNodeSort>>>;
};

export type UomNodeRelationInput = {
  convertsTo?: InputMaybe<Array<UomNodeConvertsToCreateFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomNodeInTermsOfCreateFieldInput>>;
};

/** Fields to sort uomNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one uomNodeSort object. */
export type UomNodeSort = {
  abbreviation?: InputMaybe<SortDirection>;
  classification?: InputMaybe<SortDirection>;
  classificationAbbreviation?: InputMaybe<SortDirection>;
  classificationId?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
};

export type UomNodeUpdateInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  classificationAbbreviation?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<Array<UomNodeConvertsToUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<Array<UomNodeInTermsOfUpdateFieldInput>>;
};

export type UomNodeWhere = {
  AND?: InputMaybe<Array<UomNodeWhere>>;
  OR?: InputMaybe<Array<UomNodeWhere>>;
  abbreviation?: InputMaybe<Scalars['String']>;
  abbreviation_CONTAINS?: InputMaybe<Scalars['String']>;
  abbreviation_ENDS_WITH?: InputMaybe<Scalars['String']>;
  abbreviation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  abbreviation_NOT?: InputMaybe<Scalars['String']>;
  abbreviation_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  abbreviation_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  abbreviation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  abbreviation_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  abbreviation_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification?: InputMaybe<Scalars['String']>;
  classificationAbbreviation?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationAbbreviation_NOT?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationAbbreviation_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  classificationId_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT?: InputMaybe<Scalars['String']>;
  classificationId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT?: InputMaybe<Scalars['String']>;
  classification_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_STARTS_WITH?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomNodeWhere>;
  convertsToAggregate?: InputMaybe<UomNodeConvertsToAggregateInput>;
  convertsToConnection?: InputMaybe<UomNodeConvertsToConnectionWhere>;
  convertsToConnection_NOT?: InputMaybe<UomNodeConvertsToConnectionWhere>;
  convertsTo_NOT?: InputMaybe<UomNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_CONTAINS?: InputMaybe<Scalars['String']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT?: InputMaybe<Scalars['String']>;
  id_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomNodeWhere>;
  inTermsOfAggregate?: InputMaybe<UomNodeInTermsOfAggregateInput>;
  inTermsOfConnection?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
  inTermsOfConnection_NOT?: InputMaybe<UomNodeInTermsOfConnectionWhere>;
  inTermsOf_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomNodeuomNodeConvertsToAggregationSelection = {
  __typename?: 'uomNodeuomNodeConvertsToAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomNodeuomNodeConvertsToEdgeAggregateSelection>;
  node?: Maybe<UomNodeuomNodeConvertsToNodeAggregateSelection>;
};

export type UomNodeuomNodeConvertsToEdgeAggregateSelection = {
  __typename?: 'uomNodeuomNodeConvertsToEdgeAggregateSelection';
  id: StringAggregateSelection;
  quantity: FloatAggregateSelection;
};

export type UomNodeuomNodeConvertsToNodeAggregateSelection = {
  __typename?: 'uomNodeuomNodeConvertsToNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomNodeuomNodeInTermsOfAggregationSelection = {
  __typename?: 'uomNodeuomNodeInTermsOfAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomNodeuomNodeInTermsOfEdgeAggregateSelection>;
  node?: Maybe<UomNodeuomNodeInTermsOfNodeAggregateSelection>;
};

export type UomNodeuomNodeInTermsOfEdgeAggregateSelection = {
  __typename?: 'uomNodeuomNodeInTermsOfEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type UomNodeuomNodeInTermsOfNodeAggregateSelection = {
  __typename?: 'uomNodeuomNodeInTermsOfNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomScopeNode = {
  __typename?: 'uomScopeNode';
  classification?: Maybe<Scalars['String']>;
  classificationId?: Maybe<Scalars['String']>;
  convertsTo?: Maybe<Array<Maybe<UomNode>>>;
  convertsToAggregate?: Maybe<UomScopeNodeuomNodeConvertsToAggregationSelection>;
  convertsToConnection: UomScopeNodeConvertsToConnection;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inTermsOf?: Maybe<Array<Maybe<UomNode>>>;
  inTermsOfAggregate?: Maybe<UomScopeNodeuomNodeInTermsOfAggregationSelection>;
  inTermsOfConnection: UomScopeNodeInTermsOfConnection;
  partId?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['String']>;
};


export type UomScopeNodeConvertsToArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomScopeNodeConvertsToAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomScopeNodeConvertsToConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomScopeNodeConvertsToConnectionSort>>;
  where?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
};


export type UomScopeNodeInTermsOfArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomScopeNodeInTermsOfAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomScopeNodeInTermsOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomScopeNodeInTermsOfConnectionSort>>;
  where?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
};

export type UomScopeNodeAggregateSelection = {
  __typename?: 'uomScopeNodeAggregateSelection';
  classification: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  id: StringAggregateSelection;
  partId: StringAggregateSelection;
  scope: StringAggregateSelection;
  scopeId: StringAggregateSelection;
};

export type UomScopeNodeConnectInput = {
  convertsTo?: InputMaybe<Array<UomScopeNodeConvertsToConnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomScopeNodeInTermsOfConnectFieldInput>>;
};

export type UomScopeNodeConvertsToAggregateInput = {
  AND?: InputMaybe<Array<UomScopeNodeConvertsToAggregateInput>>;
  OR?: InputMaybe<Array<UomScopeNodeConvertsToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomScopeNodeConvertsToEdgeAggregationWhereInput>;
  node?: InputMaybe<UomScopeNodeConvertsToNodeAggregationWhereInput>;
};

export type UomScopeNodeConvertsToConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: ConvertableCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomScopeNodeConvertsToConnection = {
  __typename?: 'uomScopeNodeConvertsToConnection';
  edges: Array<UomScopeNodeConvertsToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomScopeNodeConvertsToConnectionSort = {
  edge?: InputMaybe<ConvertableSort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomScopeNodeConvertsToConnectionWhere = {
  AND?: InputMaybe<Array<UomScopeNodeConvertsToConnectionWhere>>;
  OR?: InputMaybe<Array<UomScopeNodeConvertsToConnectionWhere>>;
  edge?: InputMaybe<ConvertableWhere>;
  edge_NOT?: InputMaybe<ConvertableWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomScopeNodeConvertsToCreateFieldInput = {
  edge: ConvertableCreateInput;
  node: UomNodeCreateInput;
};

export type UomScopeNodeConvertsToDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
};

export type UomScopeNodeConvertsToDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
};

export type UomScopeNodeConvertsToEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomScopeNodeConvertsToEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomScopeNodeConvertsToEdgeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomScopeNodeConvertsToFieldInput = {
  connect?: InputMaybe<Array<UomScopeNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomScopeNodeConvertsToCreateFieldInput>>;
};

export type UomScopeNodeConvertsToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomScopeNodeConvertsToNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomScopeNodeConvertsToNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomScopeNodeConvertsToRelationship = Convertable & {
  __typename?: 'uomScopeNodeConvertsToRelationship';
  cursor: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomScopeNodeConvertsToUpdateConnectionInput = {
  edge?: InputMaybe<ConvertableUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomScopeNodeConvertsToUpdateFieldInput = {
  connect?: InputMaybe<Array<UomScopeNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomScopeNodeConvertsToCreateFieldInput>>;
  delete?: InputMaybe<Array<UomScopeNodeConvertsToDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomScopeNodeConvertsToDisconnectFieldInput>>;
  update?: InputMaybe<UomScopeNodeConvertsToUpdateConnectionInput>;
  where?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
};

export type UomScopeNodeCreateInput = {
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomScopeNodeConvertsToFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomScopeNodeInTermsOfFieldInput>;
  partId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
};

export type UomScopeNodeDeleteInput = {
  convertsTo?: InputMaybe<Array<UomScopeNodeConvertsToDeleteFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomScopeNodeInTermsOfDeleteFieldInput>>;
};

export type UomScopeNodeDisconnectInput = {
  convertsTo?: InputMaybe<Array<UomScopeNodeConvertsToDisconnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomScopeNodeInTermsOfDisconnectFieldInput>>;
};

export type UomScopeNodeInTermsOfAggregateInput = {
  AND?: InputMaybe<Array<UomScopeNodeInTermsOfAggregateInput>>;
  OR?: InputMaybe<Array<UomScopeNodeInTermsOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomScopeNodeInTermsOfEdgeAggregationWhereInput>;
  node?: InputMaybe<UomScopeNodeInTermsOfNodeAggregationWhereInput>;
};

export type UomScopeNodeInTermsOfConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: UomquantityCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomScopeNodeInTermsOfConnection = {
  __typename?: 'uomScopeNodeInTermsOfConnection';
  edges: Array<UomScopeNodeInTermsOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomScopeNodeInTermsOfConnectionSort = {
  edge?: InputMaybe<UomquantitySort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomScopeNodeInTermsOfConnectionWhere = {
  AND?: InputMaybe<Array<UomScopeNodeInTermsOfConnectionWhere>>;
  OR?: InputMaybe<Array<UomScopeNodeInTermsOfConnectionWhere>>;
  edge?: InputMaybe<UomquantityWhere>;
  edge_NOT?: InputMaybe<UomquantityWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomScopeNodeInTermsOfCreateFieldInput = {
  edge: UomquantityCreateInput;
  node: UomNodeCreateInput;
};

export type UomScopeNodeInTermsOfDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
};

export type UomScopeNodeInTermsOfDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
};

export type UomScopeNodeInTermsOfEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomScopeNodeInTermsOfEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomScopeNodeInTermsOfEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomScopeNodeInTermsOfFieldInput = {
  connect?: InputMaybe<Array<UomScopeNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomScopeNodeInTermsOfCreateFieldInput>>;
};

export type UomScopeNodeInTermsOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomScopeNodeInTermsOfNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomScopeNodeInTermsOfNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomScopeNodeInTermsOfRelationship = Uomquantity & {
  __typename?: 'uomScopeNodeInTermsOfRelationship';
  cursor: Scalars['String'];
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomScopeNodeInTermsOfUpdateConnectionInput = {
  edge?: InputMaybe<UomquantityUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomScopeNodeInTermsOfUpdateFieldInput = {
  connect?: InputMaybe<Array<UomScopeNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomScopeNodeInTermsOfCreateFieldInput>>;
  delete?: InputMaybe<Array<UomScopeNodeInTermsOfDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomScopeNodeInTermsOfDisconnectFieldInput>>;
  update?: InputMaybe<UomScopeNodeInTermsOfUpdateConnectionInput>;
  where?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
};

export type UomScopeNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more uomScopeNodeSort objects to sort uomScopeNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<UomScopeNodeSort>>>;
};

export type UomScopeNodeRelationInput = {
  convertsTo?: InputMaybe<Array<UomScopeNodeConvertsToCreateFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomScopeNodeInTermsOfCreateFieldInput>>;
};

/** Fields to sort uomScopeNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one uomScopeNodeSort object. */
export type UomScopeNodeSort = {
  classification?: InputMaybe<SortDirection>;
  classificationId?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  partId?: InputMaybe<SortDirection>;
  scope?: InputMaybe<SortDirection>;
  scopeId?: InputMaybe<SortDirection>;
};

export type UomScopeNodeUpdateInput = {
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<Array<UomScopeNodeConvertsToUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<Array<UomScopeNodeInTermsOfUpdateFieldInput>>;
  partId?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
};

export type UomScopeNodeWhere = {
  AND?: InputMaybe<Array<UomScopeNodeWhere>>;
  OR?: InputMaybe<Array<UomScopeNodeWhere>>;
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  classificationId_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT?: InputMaybe<Scalars['String']>;
  classificationId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT?: InputMaybe<Scalars['String']>;
  classification_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_STARTS_WITH?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomNodeWhere>;
  convertsToAggregate?: InputMaybe<UomScopeNodeConvertsToAggregateInput>;
  convertsToConnection?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
  convertsToConnection_NOT?: InputMaybe<UomScopeNodeConvertsToConnectionWhere>;
  convertsTo_NOT?: InputMaybe<UomNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_CONTAINS?: InputMaybe<Scalars['String']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT?: InputMaybe<Scalars['String']>;
  id_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomNodeWhere>;
  inTermsOfAggregate?: InputMaybe<UomScopeNodeInTermsOfAggregateInput>;
  inTermsOfConnection?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
  inTermsOfConnection_NOT?: InputMaybe<UomScopeNodeInTermsOfConnectionWhere>;
  inTermsOf_NOT?: InputMaybe<UomNodeWhere>;
  partId?: InputMaybe<Scalars['String']>;
  partId_CONTAINS?: InputMaybe<Scalars['String']>;
  partId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partId_NOT?: InputMaybe<Scalars['String']>;
  partId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  partId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  partId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['String']>;
  scopeId_CONTAINS?: InputMaybe<Scalars['String']>;
  scopeId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  scopeId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeId_NOT?: InputMaybe<Scalars['String']>;
  scopeId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  scopeId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  scopeId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scopeId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  scopeId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  scope_CONTAINS?: InputMaybe<Scalars['String']>;
  scope_ENDS_WITH?: InputMaybe<Scalars['String']>;
  scope_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scope_NOT?: InputMaybe<Scalars['String']>;
  scope_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  scope_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  scope_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scope_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  scope_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type UomScopeNodeuomNodeConvertsToAggregationSelection = {
  __typename?: 'uomScopeNodeuomNodeConvertsToAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomScopeNodeuomNodeConvertsToEdgeAggregateSelection>;
  node?: Maybe<UomScopeNodeuomNodeConvertsToNodeAggregateSelection>;
};

export type UomScopeNodeuomNodeConvertsToEdgeAggregateSelection = {
  __typename?: 'uomScopeNodeuomNodeConvertsToEdgeAggregateSelection';
  id: StringAggregateSelection;
  quantity: FloatAggregateSelection;
};

export type UomScopeNodeuomNodeConvertsToNodeAggregateSelection = {
  __typename?: 'uomScopeNodeuomNodeConvertsToNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomScopeNodeuomNodeInTermsOfAggregationSelection = {
  __typename?: 'uomScopeNodeuomNodeInTermsOfAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomScopeNodeuomNodeInTermsOfEdgeAggregateSelection>;
  node?: Maybe<UomScopeNodeuomNodeInTermsOfNodeAggregateSelection>;
};

export type UomScopeNodeuomNodeInTermsOfEdgeAggregateSelection = {
  __typename?: 'uomScopeNodeuomNodeInTermsOfEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type UomScopeNodeuomNodeInTermsOfNodeAggregateSelection = {
  __typename?: 'uomScopeNodeuomNodeInTermsOfNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomSupplierNode = {
  __typename?: 'uomSupplierNode';
  classification?: Maybe<Scalars['String']>;
  classificationId?: Maybe<Scalars['String']>;
  convertsTo?: Maybe<Array<Maybe<UomNode>>>;
  convertsToAggregate?: Maybe<UomSupplierNodeuomNodeConvertsToAggregationSelection>;
  convertsToConnection: UomSupplierNodeConvertsToConnection;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inTermsOf?: Maybe<Array<Maybe<UomNode>>>;
  inTermsOfAggregate?: Maybe<UomSupplierNodeuomNodeInTermsOfAggregationSelection>;
  inTermsOfConnection: UomSupplierNodeInTermsOfConnection;
  partId?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
};


export type UomSupplierNodeConvertsToArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomSupplierNodeConvertsToAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomSupplierNodeConvertsToConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomSupplierNodeConvertsToConnectionSort>>;
  where?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
};


export type UomSupplierNodeInTermsOfArgs = {
  options?: InputMaybe<UomNodeOptions>;
  where?: InputMaybe<UomNodeWhere>;
};


export type UomSupplierNodeInTermsOfAggregateArgs = {
  where?: InputMaybe<UomNodeWhere>;
};


export type UomSupplierNodeInTermsOfConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectionSort>>;
  where?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
};

export type UomSupplierNodeAggregateSelection = {
  __typename?: 'uomSupplierNodeAggregateSelection';
  classification: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  count: Scalars['Int'];
  description: StringAggregateSelection;
  id: StringAggregateSelection;
  partId: StringAggregateSelection;
  supplierId: StringAggregateSelection;
  supplierName: StringAggregateSelection;
};

export type UomSupplierNodeConnectInput = {
  convertsTo?: InputMaybe<Array<UomSupplierNodeConvertsToConnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectFieldInput>>;
};

export type UomSupplierNodeConvertsToAggregateInput = {
  AND?: InputMaybe<Array<UomSupplierNodeConvertsToAggregateInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeConvertsToAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomSupplierNodeConvertsToEdgeAggregationWhereInput>;
  node?: InputMaybe<UomSupplierNodeConvertsToNodeAggregationWhereInput>;
};

export type UomSupplierNodeConvertsToConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: ConvertableCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomSupplierNodeConvertsToConnection = {
  __typename?: 'uomSupplierNodeConvertsToConnection';
  edges: Array<UomSupplierNodeConvertsToRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomSupplierNodeConvertsToConnectionSort = {
  edge?: InputMaybe<ConvertableSort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomSupplierNodeConvertsToConnectionWhere = {
  AND?: InputMaybe<Array<UomSupplierNodeConvertsToConnectionWhere>>;
  OR?: InputMaybe<Array<UomSupplierNodeConvertsToConnectionWhere>>;
  edge?: InputMaybe<ConvertableWhere>;
  edge_NOT?: InputMaybe<ConvertableWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomSupplierNodeConvertsToCreateFieldInput = {
  edge: ConvertableCreateInput;
  node: UomNodeCreateInput;
};

export type UomSupplierNodeConvertsToDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
};

export type UomSupplierNodeConvertsToDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
};

export type UomSupplierNodeConvertsToEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomSupplierNodeConvertsToEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeConvertsToEdgeAggregationWhereInput>>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomSupplierNodeConvertsToFieldInput = {
  connect?: InputMaybe<Array<UomSupplierNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomSupplierNodeConvertsToCreateFieldInput>>;
};

export type UomSupplierNodeConvertsToNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomSupplierNodeConvertsToNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeConvertsToNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomSupplierNodeConvertsToRelationship = Convertable & {
  __typename?: 'uomSupplierNodeConvertsToRelationship';
  cursor: Scalars['String'];
  id?: Maybe<Scalars['String']>;
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomSupplierNodeConvertsToUpdateConnectionInput = {
  edge?: InputMaybe<ConvertableUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomSupplierNodeConvertsToUpdateFieldInput = {
  connect?: InputMaybe<Array<UomSupplierNodeConvertsToConnectFieldInput>>;
  create?: InputMaybe<Array<UomSupplierNodeConvertsToCreateFieldInput>>;
  delete?: InputMaybe<Array<UomSupplierNodeConvertsToDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomSupplierNodeConvertsToDisconnectFieldInput>>;
  update?: InputMaybe<UomSupplierNodeConvertsToUpdateConnectionInput>;
  where?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
};

export type UomSupplierNodeCreateInput = {
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomSupplierNodeConvertsToFieldInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomSupplierNodeInTermsOfFieldInput>;
  partId?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierName?: InputMaybe<Scalars['String']>;
};

export type UomSupplierNodeDeleteInput = {
  convertsTo?: InputMaybe<Array<UomSupplierNodeConvertsToDeleteFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomSupplierNodeInTermsOfDeleteFieldInput>>;
};

export type UomSupplierNodeDisconnectInput = {
  convertsTo?: InputMaybe<Array<UomSupplierNodeConvertsToDisconnectFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomSupplierNodeInTermsOfDisconnectFieldInput>>;
};

export type UomSupplierNodeInTermsOfAggregateInput = {
  AND?: InputMaybe<Array<UomSupplierNodeInTermsOfAggregateInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeInTermsOfAggregateInput>>;
  count?: InputMaybe<Scalars['Int']>;
  count_GT?: InputMaybe<Scalars['Int']>;
  count_GTE?: InputMaybe<Scalars['Int']>;
  count_LT?: InputMaybe<Scalars['Int']>;
  count_LTE?: InputMaybe<Scalars['Int']>;
  edge?: InputMaybe<UomSupplierNodeInTermsOfEdgeAggregationWhereInput>;
  node?: InputMaybe<UomSupplierNodeInTermsOfNodeAggregationWhereInput>;
};

export type UomSupplierNodeInTermsOfConnectFieldInput = {
  connect?: InputMaybe<Array<UomNodeConnectInput>>;
  edge: UomquantityCreateInput;
  where?: InputMaybe<UomNodeConnectWhere>;
};

export type UomSupplierNodeInTermsOfConnection = {
  __typename?: 'uomSupplierNodeInTermsOfConnection';
  edges: Array<UomSupplierNodeInTermsOfRelationship>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UomSupplierNodeInTermsOfConnectionSort = {
  edge?: InputMaybe<UomquantitySort>;
  node?: InputMaybe<UomNodeSort>;
};

export type UomSupplierNodeInTermsOfConnectionWhere = {
  AND?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectionWhere>>;
  OR?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectionWhere>>;
  edge?: InputMaybe<UomquantityWhere>;
  edge_NOT?: InputMaybe<UomquantityWhere>;
  node?: InputMaybe<UomNodeWhere>;
  node_NOT?: InputMaybe<UomNodeWhere>;
};

export type UomSupplierNodeInTermsOfCreateFieldInput = {
  edge: UomquantityCreateInput;
  node: UomNodeCreateInput;
};

export type UomSupplierNodeInTermsOfDeleteFieldInput = {
  delete?: InputMaybe<UomNodeDeleteInput>;
  where?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
};

export type UomSupplierNodeInTermsOfDisconnectFieldInput = {
  disconnect?: InputMaybe<UomNodeDisconnectInput>;
  where?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
};

export type UomSupplierNodeInTermsOfEdgeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomSupplierNodeInTermsOfEdgeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeInTermsOfEdgeAggregationWhereInput>>;
  quantity_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  quantity_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  quantity_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LT?: InputMaybe<Scalars['Float']>;
  quantity_MAX_LTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_GTE?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LT?: InputMaybe<Scalars['Float']>;
  quantity_MIN_LTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_EQUAL?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_GTE?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LT?: InputMaybe<Scalars['Float']>;
  quantity_SUM_LTE?: InputMaybe<Scalars['Float']>;
};

export type UomSupplierNodeInTermsOfFieldInput = {
  connect?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomSupplierNodeInTermsOfCreateFieldInput>>;
};

export type UomSupplierNodeInTermsOfNodeAggregationWhereInput = {
  AND?: InputMaybe<Array<UomSupplierNodeInTermsOfNodeAggregationWhereInput>>;
  OR?: InputMaybe<Array<UomSupplierNodeInTermsOfNodeAggregationWhereInput>>;
  abbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  abbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  abbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  abbreviation_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_LTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  abbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationAbbreviation_EQUAL?: InputMaybe<Scalars['String']>;
  classificationAbbreviation_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_LTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationAbbreviation_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classificationId_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classificationId_EQUAL?: InputMaybe<Scalars['String']>;
  classificationId_GT?: InputMaybe<Scalars['Int']>;
  classificationId_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_LT?: InputMaybe<Scalars['Int']>;
  classificationId_LTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classificationId_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  classification_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  classification_EQUAL?: InputMaybe<Scalars['String']>;
  classification_GT?: InputMaybe<Scalars['Int']>;
  classification_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  classification_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  classification_LT?: InputMaybe<Scalars['Int']>;
  classification_LTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  classification_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  description_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  description_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  description_EQUAL?: InputMaybe<Scalars['String']>;
  description_GT?: InputMaybe<Scalars['Int']>;
  description_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  description_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  description_LT?: InputMaybe<Scalars['Int']>;
  description_LTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  description_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
  id_AVERAGE_EQUAL?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_GTE?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LT?: InputMaybe<Scalars['Float']>;
  id_AVERAGE_LTE?: InputMaybe<Scalars['Float']>;
  id_EQUAL?: InputMaybe<Scalars['String']>;
  id_GT?: InputMaybe<Scalars['Int']>;
  id_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_GTE?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LT?: InputMaybe<Scalars['Int']>;
  id_LONGEST_LTE?: InputMaybe<Scalars['Int']>;
  id_LT?: InputMaybe<Scalars['Int']>;
  id_LTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_EQUAL?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_GTE?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LT?: InputMaybe<Scalars['Int']>;
  id_SHORTEST_LTE?: InputMaybe<Scalars['Int']>;
};

export type UomSupplierNodeInTermsOfRelationship = Uomquantity & {
  __typename?: 'uomSupplierNodeInTermsOfRelationship';
  cursor: Scalars['String'];
  node: UomNode;
  quantity: Scalars['Float'];
};

export type UomSupplierNodeInTermsOfUpdateConnectionInput = {
  edge?: InputMaybe<UomquantityUpdateInput>;
  node?: InputMaybe<UomNodeUpdateInput>;
};

export type UomSupplierNodeInTermsOfUpdateFieldInput = {
  connect?: InputMaybe<Array<UomSupplierNodeInTermsOfConnectFieldInput>>;
  create?: InputMaybe<Array<UomSupplierNodeInTermsOfCreateFieldInput>>;
  delete?: InputMaybe<Array<UomSupplierNodeInTermsOfDeleteFieldInput>>;
  disconnect?: InputMaybe<Array<UomSupplierNodeInTermsOfDisconnectFieldInput>>;
  update?: InputMaybe<UomSupplierNodeInTermsOfUpdateConnectionInput>;
  where?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
};

export type UomSupplierNodeOptions = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  /** Specify one or more uomSupplierNodeSort objects to sort uomSupplierNodes by. The sorts will be applied in the order in which they are arranged in the array. */
  sort?: InputMaybe<Array<InputMaybe<UomSupplierNodeSort>>>;
};

export type UomSupplierNodeRelationInput = {
  convertsTo?: InputMaybe<Array<UomSupplierNodeConvertsToCreateFieldInput>>;
  inTermsOf?: InputMaybe<Array<UomSupplierNodeInTermsOfCreateFieldInput>>;
};

/** Fields to sort uomSupplierNodes by. The order in which sorts are applied is not guaranteed when specifying many fields in one uomSupplierNodeSort object. */
export type UomSupplierNodeSort = {
  classification?: InputMaybe<SortDirection>;
  classificationId?: InputMaybe<SortDirection>;
  description?: InputMaybe<SortDirection>;
  id?: InputMaybe<SortDirection>;
  partId?: InputMaybe<SortDirection>;
  supplierId?: InputMaybe<SortDirection>;
  supplierName?: InputMaybe<SortDirection>;
};

export type UomSupplierNodeUpdateInput = {
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<Array<UomSupplierNodeConvertsToUpdateFieldInput>>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<Array<UomSupplierNodeInTermsOfUpdateFieldInput>>;
  partId?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierName?: InputMaybe<Scalars['String']>;
};

export type UomSupplierNodeWhere = {
  AND?: InputMaybe<Array<UomSupplierNodeWhere>>;
  OR?: InputMaybe<Array<UomSupplierNodeWhere>>;
  classification?: InputMaybe<Scalars['String']>;
  classificationId?: InputMaybe<Scalars['String']>;
  classificationId_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT?: InputMaybe<Scalars['String']>;
  classificationId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classificationId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classificationId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classificationId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT?: InputMaybe<Scalars['String']>;
  classification_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  classification_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  classification_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  classification_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  classification_STARTS_WITH?: InputMaybe<Scalars['String']>;
  convertsTo?: InputMaybe<UomNodeWhere>;
  convertsToAggregate?: InputMaybe<UomSupplierNodeConvertsToAggregateInput>;
  convertsToConnection?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
  convertsToConnection_NOT?: InputMaybe<UomSupplierNodeConvertsToConnectionWhere>;
  convertsTo_NOT?: InputMaybe<UomNodeWhere>;
  description?: InputMaybe<Scalars['String']>;
  description_CONTAINS?: InputMaybe<Scalars['String']>;
  description_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT?: InputMaybe<Scalars['String']>;
  description_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  description_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  description_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  description_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  id_CONTAINS?: InputMaybe<Scalars['String']>;
  id_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT?: InputMaybe<Scalars['String']>;
  id_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  id_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  id_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  id_STARTS_WITH?: InputMaybe<Scalars['String']>;
  inTermsOf?: InputMaybe<UomNodeWhere>;
  inTermsOfAggregate?: InputMaybe<UomSupplierNodeInTermsOfAggregateInput>;
  inTermsOfConnection?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
  inTermsOfConnection_NOT?: InputMaybe<UomSupplierNodeInTermsOfConnectionWhere>;
  inTermsOf_NOT?: InputMaybe<UomNodeWhere>;
  partId?: InputMaybe<Scalars['String']>;
  partId_CONTAINS?: InputMaybe<Scalars['String']>;
  partId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partId_NOT?: InputMaybe<Scalars['String']>;
  partId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  partId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  partId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  partId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  supplierId?: InputMaybe<Scalars['String']>;
  supplierId_CONTAINS?: InputMaybe<Scalars['String']>;
  supplierId_ENDS_WITH?: InputMaybe<Scalars['String']>;
  supplierId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supplierId_NOT?: InputMaybe<Scalars['String']>;
  supplierId_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  supplierId_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  supplierId_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supplierId_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  supplierId_STARTS_WITH?: InputMaybe<Scalars['String']>;
  supplierName?: InputMaybe<Scalars['String']>;
  supplierName_CONTAINS?: InputMaybe<Scalars['String']>;
  supplierName_ENDS_WITH?: InputMaybe<Scalars['String']>;
  supplierName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supplierName_NOT?: InputMaybe<Scalars['String']>;
  supplierName_NOT_CONTAINS?: InputMaybe<Scalars['String']>;
  supplierName_NOT_ENDS_WITH?: InputMaybe<Scalars['String']>;
  supplierName_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  supplierName_NOT_STARTS_WITH?: InputMaybe<Scalars['String']>;
  supplierName_STARTS_WITH?: InputMaybe<Scalars['String']>;
};

export type UomSupplierNodeuomNodeConvertsToAggregationSelection = {
  __typename?: 'uomSupplierNodeuomNodeConvertsToAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomSupplierNodeuomNodeConvertsToEdgeAggregateSelection>;
  node?: Maybe<UomSupplierNodeuomNodeConvertsToNodeAggregateSelection>;
};

export type UomSupplierNodeuomNodeConvertsToEdgeAggregateSelection = {
  __typename?: 'uomSupplierNodeuomNodeConvertsToEdgeAggregateSelection';
  id: StringAggregateSelection;
  quantity: FloatAggregateSelection;
};

export type UomSupplierNodeuomNodeConvertsToNodeAggregateSelection = {
  __typename?: 'uomSupplierNodeuomNodeConvertsToNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

export type UomSupplierNodeuomNodeInTermsOfAggregationSelection = {
  __typename?: 'uomSupplierNodeuomNodeInTermsOfAggregationSelection';
  count: Scalars['Int'];
  edge?: Maybe<UomSupplierNodeuomNodeInTermsOfEdgeAggregateSelection>;
  node?: Maybe<UomSupplierNodeuomNodeInTermsOfNodeAggregateSelection>;
};

export type UomSupplierNodeuomNodeInTermsOfEdgeAggregateSelection = {
  __typename?: 'uomSupplierNodeuomNodeInTermsOfEdgeAggregateSelection';
  quantity: FloatAggregateSelection;
};

export type UomSupplierNodeuomNodeInTermsOfNodeAggregateSelection = {
  __typename?: 'uomSupplierNodeuomNodeInTermsOfNodeAggregateSelection';
  abbreviation: StringAggregateSelection;
  classification: StringAggregateSelection;
  classificationAbbreviation: StringAggregateSelection;
  classificationId: StringAggregateSelection;
  description: StringAggregateSelection;
  id: StringAggregateSelection;
};

/** aggregated selection of "uom" */
export type Uom_Aggregate = {
  __typename?: 'uom_aggregate';
  aggregate?: Maybe<Uom_Aggregate_Fields>;
  nodes: Array<Uom>;
};

/** aggregate fields of "uom" */
export type Uom_Aggregate_Fields = {
  __typename?: 'uom_aggregate_fields';
  avg?: Maybe<Uom_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Uom_Max_Fields>;
  min?: Maybe<Uom_Min_Fields>;
  stddev?: Maybe<Uom_Stddev_Fields>;
  stddev_pop?: Maybe<Uom_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uom_Stddev_Samp_Fields>;
  sum?: Maybe<Uom_Sum_Fields>;
  var_pop?: Maybe<Uom_Var_Pop_Fields>;
  var_samp?: Maybe<Uom_Var_Samp_Fields>;
  variance?: Maybe<Uom_Variance_Fields>;
};


/** aggregate fields of "uom" */
export type Uom_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Uom_Avg_Fields = {
  __typename?: 'uom_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "uom". All fields are combined with a logical 'AND'. */
export type Uom_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Bool_Exp>>;
  _not?: InputMaybe<Uom_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Bool_Exp>>;
  airtable_pfep_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  qb_set_uom?: InputMaybe<String_Comparison_Exp>;
  qb_uom?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "uom_classification" */
export type Uom_Classification = {
  __typename?: 'uom_classification';
  abbreviation?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  measurement: Scalars['String'];
  prefer_integer: Scalars['Boolean'];
  /** An array relationship */
  uom_conversions: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uom_conversions_aggregate: Uom_Conversion_Aggregate;
  /** An array relationship */
  uom_csi_conversions: Array<Uom_Csi_Conversion>;
  /** An aggregate relationship */
  uom_csi_conversions_aggregate: Uom_Csi_Conversion_Aggregate;
};


/** columns and relationships of "uom_classification" */
export type Uom_ClassificationUom_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_classification" */
export type Uom_ClassificationUom_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_classification" */
export type Uom_ClassificationUom_Csi_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_classification" */
export type Uom_ClassificationUom_Csi_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Csi_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};

/** aggregated selection of "uom_classification" */
export type Uom_Classification_Aggregate = {
  __typename?: 'uom_classification_aggregate';
  aggregate?: Maybe<Uom_Classification_Aggregate_Fields>;
  nodes: Array<Uom_Classification>;
};

/** aggregate fields of "uom_classification" */
export type Uom_Classification_Aggregate_Fields = {
  __typename?: 'uom_classification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Uom_Classification_Max_Fields>;
  min?: Maybe<Uom_Classification_Min_Fields>;
};


/** aggregate fields of "uom_classification" */
export type Uom_Classification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Classification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "uom_classification". All fields are combined with a logical 'AND'. */
export type Uom_Classification_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Classification_Bool_Exp>>;
  _not?: InputMaybe<Uom_Classification_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Classification_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  measurement?: InputMaybe<String_Comparison_Exp>;
  prefer_integer?: InputMaybe<Boolean_Comparison_Exp>;
  uom_conversions?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  uom_csi_conversions?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
  uom_csi_conversions_aggregate?: InputMaybe<Uom_Csi_Conversion_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_classification" */
export type Uom_Classification_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_classification_pkey';

/** input type for inserting data into table "uom_classification" */
export type Uom_Classification_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['String']>;
  prefer_integer?: InputMaybe<Scalars['Boolean']>;
  uom_conversions?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  uom_csi_conversions?: InputMaybe<Uom_Csi_Conversion_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_Classification_Max_Fields = {
  __typename?: 'uom_classification_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  measurement?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Uom_Classification_Min_Fields = {
  __typename?: 'uom_classification_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  measurement?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "uom_classification" */
export type Uom_Classification_Mutation_Response = {
  __typename?: 'uom_classification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Classification>;
};

/** input type for inserting object relation for remote table "uom_classification" */
export type Uom_Classification_Obj_Rel_Insert_Input = {
  data: Uom_Classification_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Classification_On_Conflict>;
};

/** on_conflict condition type for table "uom_classification" */
export type Uom_Classification_On_Conflict = {
  constraint: Uom_Classification_Constraint;
  update_columns?: Array<Uom_Classification_Update_Column>;
  where?: InputMaybe<Uom_Classification_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_classification". */
export type Uom_Classification_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement?: InputMaybe<Order_By>;
  prefer_integer?: InputMaybe<Order_By>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  uom_csi_conversions_aggregate?: InputMaybe<Uom_Csi_Conversion_Aggregate_Order_By>;
};

/** primary key columns input for table: uom_classification */
export type Uom_Classification_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_classification" */
export type Uom_Classification_Select_Column =
  /** column name */
  | 'abbreviation'
  /** column name */
  | 'id'
  /** column name */
  | 'measurement'
  /** column name */
  | 'prefer_integer';

/** input type for updating data in table "uom_classification" */
export type Uom_Classification_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['String']>;
  prefer_integer?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "uom_classification" */
export type Uom_Classification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Classification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Classification_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['String']>;
  prefer_integer?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "uom_classification" */
export type Uom_Classification_Update_Column =
  /** column name */
  | 'abbreviation'
  /** column name */
  | 'id'
  /** column name */
  | 'measurement'
  /** column name */
  | 'prefer_integer';

export type Uom_Classification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Classification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Classification_Bool_Exp;
};

/** unique or primary key constraints on table "uom" */
export type Uom_Constraint =
  /** unique or primary key constraint on columns "name" */
  | 'uom_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'uom_pkey';

/** columns and relationships of "uom_conversion" */
export type Uom_Conversion = {
  __typename?: 'uom_conversion';
  abbreviation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_selectable?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  part?: Maybe<Part>;
  part_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  terms_of_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  uomSystemConversionsByToId: Array<Uom_System_Conversion>;
  /** An aggregate relationship */
  uomSystemConversionsByToId_aggregate: Uom_System_Conversion_Aggregate;
  /** An object relationship */
  uom_classification: Uom_Classification;
  uom_classification_id: Scalars['String'];
  /** An object relationship */
  uom_conversion?: Maybe<Uom_Conversion>;
  /** An array relationship */
  uom_conversions: Array<Uom_Conversion>;
  /** An aggregate relationship */
  uom_conversions_aggregate: Uom_Conversion_Aggregate;
  /** An array relationship */
  uom_scope_parts: Array<Uom_Scope_Part>;
  /** An aggregate relationship */
  uom_scope_parts_aggregate: Uom_Scope_Part_Aggregate;
  /** An array relationship */
  uom_system_conversions: Array<Uom_System_Conversion>;
  /** An aggregate relationship */
  uom_system_conversions_aggregate: Uom_System_Conversion_Aggregate;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUomSystemConversionsByToIdArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUomSystemConversionsByToId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Conversion_Order_By>>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_Scope_PartsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_Scope_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_System_ConversionsArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};


/** columns and relationships of "uom_conversion" */
export type Uom_ConversionUom_System_Conversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_System_Conversion_Order_By>>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};

/** aggregated selection of "uom_conversion" */
export type Uom_Conversion_Aggregate = {
  __typename?: 'uom_conversion_aggregate';
  aggregate?: Maybe<Uom_Conversion_Aggregate_Fields>;
  nodes: Array<Uom_Conversion>;
};

export type Uom_Conversion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp_Count>;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Bool_And = {
  arguments: Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Uom_Conversion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_Conversion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uom_conversion" */
export type Uom_Conversion_Aggregate_Fields = {
  __typename?: 'uom_conversion_aggregate_fields';
  avg?: Maybe<Uom_Conversion_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Uom_Conversion_Max_Fields>;
  min?: Maybe<Uom_Conversion_Min_Fields>;
  stddev?: Maybe<Uom_Conversion_Stddev_Fields>;
  stddev_pop?: Maybe<Uom_Conversion_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uom_Conversion_Stddev_Samp_Fields>;
  sum?: Maybe<Uom_Conversion_Sum_Fields>;
  var_pop?: Maybe<Uom_Conversion_Var_Pop_Fields>;
  var_samp?: Maybe<Uom_Conversion_Var_Samp_Fields>;
  variance?: Maybe<Uom_Conversion_Variance_Fields>;
};


/** aggregate fields of "uom_conversion" */
export type Uom_Conversion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "uom_conversion" */
export type Uom_Conversion_Aggregate_Order_By = {
  avg?: InputMaybe<Uom_Conversion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uom_Conversion_Max_Order_By>;
  min?: InputMaybe<Uom_Conversion_Min_Order_By>;
  stddev?: InputMaybe<Uom_Conversion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uom_Conversion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uom_Conversion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uom_Conversion_Sum_Order_By>;
  var_pop?: InputMaybe<Uom_Conversion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uom_Conversion_Var_Samp_Order_By>;
  variance?: InputMaybe<Uom_Conversion_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uom_conversion" */
export type Uom_Conversion_Arr_Rel_Insert_Input = {
  data: Array<Uom_Conversion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};

/** aggregate avg on columns */
export type Uom_Conversion_Avg_Fields = {
  __typename?: 'uom_conversion_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "uom_conversion" */
export type Uom_Conversion_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uom_conversion". All fields are combined with a logical 'AND'. */
export type Uom_Conversion_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Conversion_Bool_Exp>>;
  _not?: InputMaybe<Uom_Conversion_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Conversion_Bool_Exp>>;
  abbreviation?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_selectable?: InputMaybe<Boolean_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  part_id?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  terms_of_id?: InputMaybe<String_Comparison_Exp>;
  uomSystemConversionsByToId?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
  uomSystemConversionsByToId_aggregate?: InputMaybe<Uom_System_Conversion_Aggregate_Bool_Exp>;
  uom_classification?: InputMaybe<Uom_Classification_Bool_Exp>;
  uom_classification_id?: InputMaybe<String_Comparison_Exp>;
  uom_conversion?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversions?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Bool_Exp>;
  uom_scope_parts?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
  uom_scope_parts_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Bool_Exp>;
  uom_system_conversions?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
  uom_system_conversions_aggregate?: InputMaybe<Uom_System_Conversion_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_conversion" */
export type Uom_Conversion_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_conversion_pkey';

/** input type for incrementing numeric columns in table "uom_conversion" */
export type Uom_Conversion_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "uom_conversion" */
export type Uom_Conversion_Insert_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_selectable?: InputMaybe<Scalars['Boolean']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  part_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  terms_of_id?: InputMaybe<Scalars['String']>;
  uomSystemConversionsByToId?: InputMaybe<Uom_System_Conversion_Arr_Rel_Insert_Input>;
  uom_classification?: InputMaybe<Uom_Classification_Obj_Rel_Insert_Input>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
  uom_conversion?: InputMaybe<Uom_Conversion_Obj_Rel_Insert_Input>;
  uom_conversions?: InputMaybe<Uom_Conversion_Arr_Rel_Insert_Input>;
  uom_scope_parts?: InputMaybe<Uom_Scope_Part_Arr_Rel_Insert_Input>;
  uom_system_conversions?: InputMaybe<Uom_System_Conversion_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_Conversion_Max_Fields = {
  __typename?: 'uom_conversion_max_fields';
  abbreviation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  part_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  terms_of_id?: Maybe<Scalars['String']>;
  uom_classification_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "uom_conversion" */
export type Uom_Conversion_Max_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  terms_of_id?: InputMaybe<Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uom_Conversion_Min_Fields = {
  __typename?: 'uom_conversion_min_fields';
  abbreviation?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  part_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  terms_of_id?: Maybe<Scalars['String']>;
  uom_classification_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "uom_conversion" */
export type Uom_Conversion_Min_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  terms_of_id?: InputMaybe<Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uom_conversion" */
export type Uom_Conversion_Mutation_Response = {
  __typename?: 'uom_conversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Conversion>;
};

/** input type for inserting object relation for remote table "uom_conversion" */
export type Uom_Conversion_Obj_Rel_Insert_Input = {
  data: Uom_Conversion_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Conversion_On_Conflict>;
};

/** on_conflict condition type for table "uom_conversion" */
export type Uom_Conversion_On_Conflict = {
  constraint: Uom_Conversion_Constraint;
  update_columns?: Array<Uom_Conversion_Update_Column>;
  where?: InputMaybe<Uom_Conversion_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_conversion". */
export type Uom_Conversion_Order_By = {
  abbreviation?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_selectable?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  part_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  terms_of_id?: InputMaybe<Order_By>;
  uomSystemConversionsByToId_aggregate?: InputMaybe<Uom_System_Conversion_Aggregate_Order_By>;
  uom_classification?: InputMaybe<Uom_Classification_Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
  uom_conversion?: InputMaybe<Uom_Conversion_Order_By>;
  uom_conversions_aggregate?: InputMaybe<Uom_Conversion_Aggregate_Order_By>;
  uom_scope_parts_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Order_By>;
  uom_system_conversions_aggregate?: InputMaybe<Uom_System_Conversion_Aggregate_Order_By>;
};

/** primary key columns input for table: uom_conversion */
export type Uom_Conversion_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_conversion" */
export type Uom_Conversion_Select_Column =
  /** column name */
  | 'abbreviation'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'is_selectable'
  /** column name */
  | 'part_id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'terms_of_id'
  /** column name */
  | 'uom_classification_id';

/** select "uom_conversion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "uom_conversion" */
export type Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'is_selectable';

/** select "uom_conversion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "uom_conversion" */
export type Uom_Conversion_Select_Column_Uom_Conversion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'is_selectable';

/** input type for updating data in table "uom_conversion" */
export type Uom_Conversion_Set_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_selectable?: InputMaybe<Scalars['Boolean']>;
  part_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  terms_of_id?: InputMaybe<Scalars['String']>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Uom_Conversion_Stddev_Fields = {
  __typename?: 'uom_conversion_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uom_Conversion_Stddev_Pop_Fields = {
  __typename?: 'uom_conversion_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uom_Conversion_Stddev_Samp_Fields = {
  __typename?: 'uom_conversion_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "uom_conversion" */
export type Uom_Conversion_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uom_conversion" */
export type Uom_Conversion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Conversion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Conversion_Stream_Cursor_Value_Input = {
  abbreviation?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_selectable?: InputMaybe<Scalars['Boolean']>;
  part_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  terms_of_id?: InputMaybe<Scalars['String']>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Uom_Conversion_Sum_Fields = {
  __typename?: 'uom_conversion_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "uom_conversion" */
export type Uom_Conversion_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "uom_conversion" */
export type Uom_Conversion_Update_Column =
  /** column name */
  | 'abbreviation'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'is_selectable'
  /** column name */
  | 'part_id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'terms_of_id'
  /** column name */
  | 'uom_classification_id';

export type Uom_Conversion_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uom_Conversion_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Conversion_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Conversion_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uom_Conversion_Var_Pop_Fields = {
  __typename?: 'uom_conversion_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "uom_conversion" */
export type Uom_Conversion_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uom_Conversion_Var_Samp_Fields = {
  __typename?: 'uom_conversion_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "uom_conversion" */
export type Uom_Conversion_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uom_Conversion_Variance_Fields = {
  __typename?: 'uom_conversion_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "uom_conversion" */
export type Uom_Conversion_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "uom_csi_conversion" */
export type Uom_Csi_Conversion = {
  __typename?: 'uom_csi_conversion';
  /** An object relationship */
  csi: Csi;
  csi_id: Scalars['String'];
  id: Scalars['String'];
  /** An object relationship */
  uom_classification: Uom_Classification;
  uom_classification_id: Scalars['String'];
};

/** aggregated selection of "uom_csi_conversion" */
export type Uom_Csi_Conversion_Aggregate = {
  __typename?: 'uom_csi_conversion_aggregate';
  aggregate?: Maybe<Uom_Csi_Conversion_Aggregate_Fields>;
  nodes: Array<Uom_Csi_Conversion>;
};

export type Uom_Csi_Conversion_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uom_Csi_Conversion_Aggregate_Bool_Exp_Count>;
};

export type Uom_Csi_Conversion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uom_csi_conversion" */
export type Uom_Csi_Conversion_Aggregate_Fields = {
  __typename?: 'uom_csi_conversion_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Uom_Csi_Conversion_Max_Fields>;
  min?: Maybe<Uom_Csi_Conversion_Min_Fields>;
};


/** aggregate fields of "uom_csi_conversion" */
export type Uom_Csi_Conversion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Csi_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uom_Csi_Conversion_Max_Order_By>;
  min?: InputMaybe<Uom_Csi_Conversion_Min_Order_By>;
};

/** input type for inserting array relation for remote table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Arr_Rel_Insert_Input = {
  data: Array<Uom_Csi_Conversion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Csi_Conversion_On_Conflict>;
};

/** Boolean expression to filter rows from the table "uom_csi_conversion". All fields are combined with a logical 'AND'. */
export type Uom_Csi_Conversion_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Csi_Conversion_Bool_Exp>>;
  _not?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Csi_Conversion_Bool_Exp>>;
  csi?: InputMaybe<Csi_Bool_Exp>;
  csi_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  uom_classification?: InputMaybe<Uom_Classification_Bool_Exp>;
  uom_classification_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_csi_conversion_pkey';

/** input type for inserting data into table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Insert_Input = {
  csi?: InputMaybe<Csi_Obj_Rel_Insert_Input>;
  csi_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  uom_classification?: InputMaybe<Uom_Classification_Obj_Rel_Insert_Input>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Uom_Csi_Conversion_Max_Fields = {
  __typename?: 'uom_csi_conversion_max_fields';
  csi_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uom_classification_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Max_Order_By = {
  csi_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uom_Csi_Conversion_Min_Fields = {
  __typename?: 'uom_csi_conversion_min_fields';
  csi_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  uom_classification_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Min_Order_By = {
  csi_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Mutation_Response = {
  __typename?: 'uom_csi_conversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Csi_Conversion>;
};

/** on_conflict condition type for table "uom_csi_conversion" */
export type Uom_Csi_Conversion_On_Conflict = {
  constraint: Uom_Csi_Conversion_Constraint;
  update_columns?: Array<Uom_Csi_Conversion_Update_Column>;
  where?: InputMaybe<Uom_Csi_Conversion_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_csi_conversion". */
export type Uom_Csi_Conversion_Order_By = {
  csi?: InputMaybe<Csi_Order_By>;
  csi_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uom_classification?: InputMaybe<Uom_Classification_Order_By>;
  uom_classification_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uom_csi_conversion */
export type Uom_Csi_Conversion_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Select_Column =
  /** column name */
  | 'csi_id'
  /** column name */
  | 'id'
  /** column name */
  | 'uom_classification_id';

/** input type for updating data in table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Set_Input = {
  csi_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Csi_Conversion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Csi_Conversion_Stream_Cursor_Value_Input = {
  csi_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  uom_classification_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "uom_csi_conversion" */
export type Uom_Csi_Conversion_Update_Column =
  /** column name */
  | 'csi_id'
  /** column name */
  | 'id'
  /** column name */
  | 'uom_classification_id';

export type Uom_Csi_Conversion_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Csi_Conversion_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Csi_Conversion_Bool_Exp;
};

/** input type for incrementing numeric columns in table "uom" */
export type Uom_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "uom" */
export type Uom_Insert_Input = {
  airtable_pfep_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  qb_set_uom?: InputMaybe<Scalars['String']>;
  qb_uom?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Uom_Max_Fields = {
  __typename?: 'uom_max_fields';
  airtable_pfep_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  qb_set_uom?: Maybe<Scalars['String']>;
  qb_uom?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Uom_Min_Fields = {
  __typename?: 'uom_min_fields';
  airtable_pfep_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  qb_set_uom?: Maybe<Scalars['String']>;
  qb_uom?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "uom" */
export type Uom_Mutation_Response = {
  __typename?: 'uom_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom>;
};

/** input type for inserting object relation for remote table "uom" */
export type Uom_Obj_Rel_Insert_Input = {
  data: Uom_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_On_Conflict>;
};

/** on_conflict condition type for table "uom" */
export type Uom_On_Conflict = {
  constraint: Uom_Constraint;
  update_columns?: Array<Uom_Update_Column>;
  where?: InputMaybe<Uom_Bool_Exp>;
};

/** Ordering options when selecting data from "uom". */
export type Uom_Order_By = {
  airtable_pfep_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  qb_set_uom?: InputMaybe<Order_By>;
  qb_uom?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uom */
export type Uom_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "uom_scope" */
export type Uom_Scope = {
  __typename?: 'uom_scope';
  description: Scalars['String'];
  id: Scalars['String'];
  /** An array relationship */
  uom_scope_parts: Array<Uom_Scope_Part>;
  /** An aggregate relationship */
  uom_scope_parts_aggregate: Uom_Scope_Part_Aggregate;
};


/** columns and relationships of "uom_scope" */
export type Uom_ScopeUom_Scope_PartsArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};


/** columns and relationships of "uom_scope" */
export type Uom_ScopeUom_Scope_Parts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Uom_Scope_Part_Order_By>>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};

/** aggregated selection of "uom_scope" */
export type Uom_Scope_Aggregate = {
  __typename?: 'uom_scope_aggregate';
  aggregate?: Maybe<Uom_Scope_Aggregate_Fields>;
  nodes: Array<Uom_Scope>;
};

/** aggregate fields of "uom_scope" */
export type Uom_Scope_Aggregate_Fields = {
  __typename?: 'uom_scope_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Uom_Scope_Max_Fields>;
  min?: Maybe<Uom_Scope_Min_Fields>;
};


/** aggregate fields of "uom_scope" */
export type Uom_Scope_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Scope_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "uom_scope". All fields are combined with a logical 'AND'. */
export type Uom_Scope_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Scope_Bool_Exp>>;
  _not?: InputMaybe<Uom_Scope_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Scope_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  uom_scope_parts?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
  uom_scope_parts_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_scope" */
export type Uom_Scope_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_scope_pkey';

/** input type for inserting data into table "uom_scope" */
export type Uom_Scope_Insert_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  uom_scope_parts?: InputMaybe<Uom_Scope_Part_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_Scope_Max_Fields = {
  __typename?: 'uom_scope_max_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Uom_Scope_Min_Fields = {
  __typename?: 'uom_scope_min_fields';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "uom_scope" */
export type Uom_Scope_Mutation_Response = {
  __typename?: 'uom_scope_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Scope>;
};

/** input type for inserting object relation for remote table "uom_scope" */
export type Uom_Scope_Obj_Rel_Insert_Input = {
  data: Uom_Scope_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Scope_On_Conflict>;
};

/** on_conflict condition type for table "uom_scope" */
export type Uom_Scope_On_Conflict = {
  constraint: Uom_Scope_Constraint;
  update_columns?: Array<Uom_Scope_Update_Column>;
  where?: InputMaybe<Uom_Scope_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_scope". */
export type Uom_Scope_Order_By = {
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uom_scope_parts_aggregate?: InputMaybe<Uom_Scope_Part_Aggregate_Order_By>;
};

/** columns and relationships of "uom_scope_part" */
export type Uom_Scope_Part = {
  __typename?: 'uom_scope_part';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  measurement?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  part?: Maybe<Part>;
  part_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  uom_conversion?: Maybe<Uom_Conversion>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  uom_scope?: Maybe<Uom_Scope>;
  uom_scope_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  vendor_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  vendor_part?: Maybe<Vendor_Parts>;
};

/** aggregated selection of "uom_scope_part" */
export type Uom_Scope_Part_Aggregate = {
  __typename?: 'uom_scope_part_aggregate';
  aggregate?: Maybe<Uom_Scope_Part_Aggregate_Fields>;
  nodes: Array<Uom_Scope_Part>;
};

export type Uom_Scope_Part_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uom_Scope_Part_Aggregate_Bool_Exp_Count>;
};

export type Uom_Scope_Part_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uom_scope_part" */
export type Uom_Scope_Part_Aggregate_Fields = {
  __typename?: 'uom_scope_part_aggregate_fields';
  avg?: Maybe<Uom_Scope_Part_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Uom_Scope_Part_Max_Fields>;
  min?: Maybe<Uom_Scope_Part_Min_Fields>;
  stddev?: Maybe<Uom_Scope_Part_Stddev_Fields>;
  stddev_pop?: Maybe<Uom_Scope_Part_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uom_Scope_Part_Stddev_Samp_Fields>;
  sum?: Maybe<Uom_Scope_Part_Sum_Fields>;
  var_pop?: Maybe<Uom_Scope_Part_Var_Pop_Fields>;
  var_samp?: Maybe<Uom_Scope_Part_Var_Samp_Fields>;
  variance?: Maybe<Uom_Scope_Part_Variance_Fields>;
};


/** aggregate fields of "uom_scope_part" */
export type Uom_Scope_Part_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_Scope_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "uom_scope_part" */
export type Uom_Scope_Part_Aggregate_Order_By = {
  avg?: InputMaybe<Uom_Scope_Part_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uom_Scope_Part_Max_Order_By>;
  min?: InputMaybe<Uom_Scope_Part_Min_Order_By>;
  stddev?: InputMaybe<Uom_Scope_Part_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uom_Scope_Part_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uom_Scope_Part_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uom_Scope_Part_Sum_Order_By>;
  var_pop?: InputMaybe<Uom_Scope_Part_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uom_Scope_Part_Var_Samp_Order_By>;
  variance?: InputMaybe<Uom_Scope_Part_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uom_scope_part" */
export type Uom_Scope_Part_Arr_Rel_Insert_Input = {
  data: Array<Uom_Scope_Part_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_Scope_Part_On_Conflict>;
};

/** aggregate avg on columns */
export type Uom_Scope_Part_Avg_Fields = {
  __typename?: 'uom_scope_part_avg_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Avg_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uom_scope_part". All fields are combined with a logical 'AND'. */
export type Uom_Scope_Part_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_Scope_Part_Bool_Exp>>;
  _not?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_Scope_Part_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  measurement?: InputMaybe<Numeric_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  part_id?: InputMaybe<String_Comparison_Exp>;
  uom_conversion?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversion_id?: InputMaybe<String_Comparison_Exp>;
  uom_scope?: InputMaybe<Uom_Scope_Bool_Exp>;
  uom_scope_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  vendor_id?: InputMaybe<String_Comparison_Exp>;
  vendor_part?: InputMaybe<Vendor_Parts_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_scope_part" */
export type Uom_Scope_Part_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_scope_part_pkey';

/** input type for incrementing numeric columns in table "uom_scope_part" */
export type Uom_Scope_Part_Inc_Input = {
  measurement?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "uom_scope_part" */
export type Uom_Scope_Part_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['numeric']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  part_id?: InputMaybe<Scalars['String']>;
  uom_conversion?: InputMaybe<Uom_Conversion_Obj_Rel_Insert_Input>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
  uom_scope?: InputMaybe<Uom_Scope_Obj_Rel_Insert_Input>;
  uom_scope_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendor_id?: InputMaybe<Scalars['String']>;
  vendor_part?: InputMaybe<Vendor_Parts_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_Scope_Part_Max_Fields = {
  __typename?: 'uom_scope_part_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  measurement?: Maybe<Scalars['numeric']>;
  part_id?: Maybe<Scalars['String']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  uom_scope_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  vendor_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
  uom_scope_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uom_Scope_Part_Min_Fields = {
  __typename?: 'uom_scope_part_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  measurement?: Maybe<Scalars['numeric']>;
  part_id?: Maybe<Scalars['String']>;
  uom_conversion_id?: Maybe<Scalars['String']>;
  uom_scope_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  vendor_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement?: InputMaybe<Order_By>;
  part_id?: InputMaybe<Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
  uom_scope_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uom_scope_part" */
export type Uom_Scope_Part_Mutation_Response = {
  __typename?: 'uom_scope_part_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_Scope_Part>;
};

/** on_conflict condition type for table "uom_scope_part" */
export type Uom_Scope_Part_On_Conflict = {
  constraint: Uom_Scope_Part_Constraint;
  update_columns?: Array<Uom_Scope_Part_Update_Column>;
  where?: InputMaybe<Uom_Scope_Part_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_scope_part". */
export type Uom_Scope_Part_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  measurement?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  part_id?: InputMaybe<Order_By>;
  uom_conversion?: InputMaybe<Uom_Conversion_Order_By>;
  uom_conversion_id?: InputMaybe<Order_By>;
  uom_scope?: InputMaybe<Uom_Scope_Order_By>;
  uom_scope_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendor_id?: InputMaybe<Order_By>;
  vendor_part?: InputMaybe<Vendor_Parts_Order_By>;
};

/** primary key columns input for table: uom_scope_part */
export type Uom_Scope_Part_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_scope_part" */
export type Uom_Scope_Part_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'measurement'
  /** column name */
  | 'part_id'
  /** column name */
  | 'uom_conversion_id'
  /** column name */
  | 'uom_scope_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'vendor_id';

/** input type for updating data in table "uom_scope_part" */
export type Uom_Scope_Part_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['numeric']>;
  part_id?: InputMaybe<Scalars['String']>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
  uom_scope_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendor_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Uom_Scope_Part_Stddev_Fields = {
  __typename?: 'uom_scope_part_stddev_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Stddev_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uom_Scope_Part_Stddev_Pop_Fields = {
  __typename?: 'uom_scope_part_stddev_pop_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Stddev_Pop_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uom_Scope_Part_Stddev_Samp_Fields = {
  __typename?: 'uom_scope_part_stddev_samp_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Stddev_Samp_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uom_scope_part" */
export type Uom_Scope_Part_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Scope_Part_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Scope_Part_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  measurement?: InputMaybe<Scalars['numeric']>;
  part_id?: InputMaybe<Scalars['String']>;
  uom_conversion_id?: InputMaybe<Scalars['String']>;
  uom_scope_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendor_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Uom_Scope_Part_Sum_Fields = {
  __typename?: 'uom_scope_part_sum_fields';
  measurement?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Sum_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** update columns of table "uom_scope_part" */
export type Uom_Scope_Part_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'description'
  /** column name */
  | 'id'
  /** column name */
  | 'measurement'
  /** column name */
  | 'part_id'
  /** column name */
  | 'uom_conversion_id'
  /** column name */
  | 'uom_scope_id'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'vendor_id';

export type Uom_Scope_Part_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uom_Scope_Part_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Scope_Part_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Scope_Part_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uom_Scope_Part_Var_Pop_Fields = {
  __typename?: 'uom_scope_part_var_pop_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Var_Pop_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uom_Scope_Part_Var_Samp_Fields = {
  __typename?: 'uom_scope_part_var_samp_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Var_Samp_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uom_Scope_Part_Variance_Fields = {
  __typename?: 'uom_scope_part_variance_fields';
  measurement?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "uom_scope_part" */
export type Uom_Scope_Part_Variance_Order_By = {
  measurement?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uom_scope */
export type Uom_Scope_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_scope" */
export type Uom_Scope_Select_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id';

/** input type for updating data in table "uom_scope" */
export type Uom_Scope_Set_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "uom_scope" */
export type Uom_Scope_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Scope_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Scope_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "uom_scope" */
export type Uom_Scope_Update_Column =
  /** column name */
  | 'description'
  /** column name */
  | 'id';

export type Uom_Scope_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Scope_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Scope_Bool_Exp;
};

/** select columns of table "uom" */
export type Uom_Select_Column =
  /** column name */
  | 'airtable_pfep_id'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'qb_set_uom'
  /** column name */
  | 'qb_uom';

/** input type for updating data in table "uom" */
export type Uom_Set_Input = {
  airtable_pfep_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  qb_set_uom?: InputMaybe<Scalars['String']>;
  qb_uom?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Uom_Stddev_Fields = {
  __typename?: 'uom_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Uom_Stddev_Pop_Fields = {
  __typename?: 'uom_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Uom_Stddev_Samp_Fields = {
  __typename?: 'uom_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "uom" */
export type Uom_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_Stream_Cursor_Value_Input = {
  airtable_pfep_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  qb_set_uom?: InputMaybe<Scalars['String']>;
  qb_uom?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Uom_Sum_Fields = {
  __typename?: 'uom_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "uom_system_conversion" */
export type Uom_System_Conversion = {
  __typename?: 'uom_system_conversion';
  from_id: Scalars['String'];
  id: Scalars['String'];
  quantity: Scalars['numeric'];
  to_id: Scalars['String'];
  /** An object relationship */
  uomConversionByToId: Uom_Conversion;
  /** An object relationship */
  uom_conversion: Uom_Conversion;
};

/** aggregated selection of "uom_system_conversion" */
export type Uom_System_Conversion_Aggregate = {
  __typename?: 'uom_system_conversion_aggregate';
  aggregate?: Maybe<Uom_System_Conversion_Aggregate_Fields>;
  nodes: Array<Uom_System_Conversion>;
};

export type Uom_System_Conversion_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uom_System_Conversion_Aggregate_Bool_Exp_Count>;
};

export type Uom_System_Conversion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uom_system_conversion" */
export type Uom_System_Conversion_Aggregate_Fields = {
  __typename?: 'uom_system_conversion_aggregate_fields';
  avg?: Maybe<Uom_System_Conversion_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Uom_System_Conversion_Max_Fields>;
  min?: Maybe<Uom_System_Conversion_Min_Fields>;
  stddev?: Maybe<Uom_System_Conversion_Stddev_Fields>;
  stddev_pop?: Maybe<Uom_System_Conversion_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uom_System_Conversion_Stddev_Samp_Fields>;
  sum?: Maybe<Uom_System_Conversion_Sum_Fields>;
  var_pop?: Maybe<Uom_System_Conversion_Var_Pop_Fields>;
  var_samp?: Maybe<Uom_System_Conversion_Var_Samp_Fields>;
  variance?: Maybe<Uom_System_Conversion_Variance_Fields>;
};


/** aggregate fields of "uom_system_conversion" */
export type Uom_System_Conversion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uom_System_Conversion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "uom_system_conversion" */
export type Uom_System_Conversion_Aggregate_Order_By = {
  avg?: InputMaybe<Uom_System_Conversion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uom_System_Conversion_Max_Order_By>;
  min?: InputMaybe<Uom_System_Conversion_Min_Order_By>;
  stddev?: InputMaybe<Uom_System_Conversion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uom_System_Conversion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uom_System_Conversion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uom_System_Conversion_Sum_Order_By>;
  var_pop?: InputMaybe<Uom_System_Conversion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uom_System_Conversion_Var_Samp_Order_By>;
  variance?: InputMaybe<Uom_System_Conversion_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uom_system_conversion" */
export type Uom_System_Conversion_Arr_Rel_Insert_Input = {
  data: Array<Uom_System_Conversion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uom_System_Conversion_On_Conflict>;
};

/** aggregate avg on columns */
export type Uom_System_Conversion_Avg_Fields = {
  __typename?: 'uom_system_conversion_avg_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Avg_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uom_system_conversion". All fields are combined with a logical 'AND'. */
export type Uom_System_Conversion_Bool_Exp = {
  _and?: InputMaybe<Array<Uom_System_Conversion_Bool_Exp>>;
  _not?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
  _or?: InputMaybe<Array<Uom_System_Conversion_Bool_Exp>>;
  from_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  to_id?: InputMaybe<String_Comparison_Exp>;
  uomConversionByToId?: InputMaybe<Uom_Conversion_Bool_Exp>;
  uom_conversion?: InputMaybe<Uom_Conversion_Bool_Exp>;
};

/** unique or primary key constraints on table "uom_system_conversion" */
export type Uom_System_Conversion_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'uom_system_conversion_pkey';

/** input type for incrementing numeric columns in table "uom_system_conversion" */
export type Uom_System_Conversion_Inc_Input = {
  quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "uom_system_conversion" */
export type Uom_System_Conversion_Insert_Input = {
  from_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  to_id?: InputMaybe<Scalars['String']>;
  uomConversionByToId?: InputMaybe<Uom_Conversion_Obj_Rel_Insert_Input>;
  uom_conversion?: InputMaybe<Uom_Conversion_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uom_System_Conversion_Max_Fields = {
  __typename?: 'uom_system_conversion_max_fields';
  from_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  to_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Max_Order_By = {
  from_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uom_System_Conversion_Min_Fields = {
  __typename?: 'uom_system_conversion_min_fields';
  from_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  to_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Min_Order_By = {
  from_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uom_system_conversion" */
export type Uom_System_Conversion_Mutation_Response = {
  __typename?: 'uom_system_conversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Uom_System_Conversion>;
};

/** on_conflict condition type for table "uom_system_conversion" */
export type Uom_System_Conversion_On_Conflict = {
  constraint: Uom_System_Conversion_Constraint;
  update_columns?: Array<Uom_System_Conversion_Update_Column>;
  where?: InputMaybe<Uom_System_Conversion_Bool_Exp>;
};

/** Ordering options when selecting data from "uom_system_conversion". */
export type Uom_System_Conversion_Order_By = {
  from_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  to_id?: InputMaybe<Order_By>;
  uomConversionByToId?: InputMaybe<Uom_Conversion_Order_By>;
  uom_conversion?: InputMaybe<Uom_Conversion_Order_By>;
};

/** primary key columns input for table: uom_system_conversion */
export type Uom_System_Conversion_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Select_Column =
  /** column name */
  | 'from_id'
  /** column name */
  | 'id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'to_id';

/** input type for updating data in table "uom_system_conversion" */
export type Uom_System_Conversion_Set_Input = {
  from_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  to_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Uom_System_Conversion_Stddev_Fields = {
  __typename?: 'uom_system_conversion_stddev_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Stddev_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uom_System_Conversion_Stddev_Pop_Fields = {
  __typename?: 'uom_system_conversion_stddev_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Stddev_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uom_System_Conversion_Stddev_Samp_Fields = {
  __typename?: 'uom_system_conversion_stddev_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Stddev_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uom_system_conversion" */
export type Uom_System_Conversion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uom_System_Conversion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uom_System_Conversion_Stream_Cursor_Value_Input = {
  from_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  to_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Uom_System_Conversion_Sum_Fields = {
  __typename?: 'uom_system_conversion_sum_fields';
  quantity?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Sum_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Update_Column =
  /** column name */
  | 'from_id'
  /** column name */
  | 'id'
  /** column name */
  | 'quantity'
  /** column name */
  | 'to_id';

export type Uom_System_Conversion_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uom_System_Conversion_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_System_Conversion_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_System_Conversion_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uom_System_Conversion_Var_Pop_Fields = {
  __typename?: 'uom_system_conversion_var_pop_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Var_Pop_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uom_System_Conversion_Var_Samp_Fields = {
  __typename?: 'uom_system_conversion_var_samp_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Var_Samp_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uom_System_Conversion_Variance_Fields = {
  __typename?: 'uom_system_conversion_variance_fields';
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "uom_system_conversion" */
export type Uom_System_Conversion_Variance_Order_By = {
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "uom" */
export type Uom_Update_Column =
  /** column name */
  | 'airtable_pfep_id'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'qb_set_uom'
  /** column name */
  | 'qb_uom';

export type Uom_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Uom_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uom_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uom_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uom_Var_Pop_Fields = {
  __typename?: 'uom_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Uom_Var_Samp_Fields = {
  __typename?: 'uom_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Uom_Variance_Fields = {
  __typename?: 'uom_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Uomquantity = {
  quantity: Scalars['Float'];
};

export type UomquantityCreateInput = {
  quantity: Scalars['Float'];
};

export type UomquantitySort = {
  quantity?: InputMaybe<SortDirection>;
};

export type UomquantityUpdateInput = {
  quantity?: InputMaybe<Scalars['Float']>;
};

export type UomquantityWhere = {
  AND?: InputMaybe<Array<UomquantityWhere>>;
  OR?: InputMaybe<Array<UomquantityWhere>>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantity_GT?: InputMaybe<Scalars['Float']>;
  quantity_GTE?: InputMaybe<Scalars['Float']>;
  quantity_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  quantity_LT?: InputMaybe<Scalars['Float']>;
  quantity_LTE?: InputMaybe<Scalars['Float']>;
  quantity_NOT?: InputMaybe<Scalars['Float']>;
  quantity_NOT_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  avatar?: Maybe<Scalars['String']>;
  /** An array relationship */
  comments: Array<Project_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Project_Comment_Aggregate;
  company?: Maybe<Scalars['String']>;
  /** An array relationship */
  customer_admins: Array<Customer_Admin>;
  /** An aggregate relationship */
  customer_admins_aggregate: Customer_Admin_Aggregate;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** An array relationship */
  invitations: Array<Invitation>;
  /** An aggregate relationship */
  invitations_aggregate: Invitation_Aggregate;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count: Scalars['Int'];
  profile?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  projects: Array<Project_Users>;
  /** An aggregate relationship */
  projects_aggregate: Project_Users_Aggregate;
  /** An array relationship */
  roles: Array<User_Role>;
  /** An aggregate relationship */
  roles_aggregate: User_Role_Aggregate;
  /** An array relationship */
  user_permissions: Array<User_Permissions>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permissions_Aggregate;
};


/** columns and relationships of "user" */
export type UserCommentsArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Comment_Order_By>>;
  where?: InputMaybe<Project_Comment_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustomer_AdminsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCustomer_Admins_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Admin_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Admin_Order_By>>;
  where?: InputMaybe<Customer_Admin_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invitation_Order_By>>;
  where?: InputMaybe<Invitation_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProfileArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "user" */
export type UserProjectsArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Users_Order_By>>;
  where?: InputMaybe<Project_Users_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Role_Order_By>>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permissions_Order_By>>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  avg?: Maybe<User_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
  stddev?: Maybe<User_Stddev_Fields>;
  stddev_pop?: Maybe<User_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Stddev_Samp_Fields>;
  sum?: Maybe<User_Sum_Fields>;
  var_pop?: Maybe<User_Var_Pop_Fields>;
  var_samp?: Maybe<User_Var_Samp_Fields>;
  variance?: Maybe<User_Variance_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  profile?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type User_Avg_Fields = {
  __typename?: 'user_avg_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Project_Comment_Bool_Exp>;
  comments_aggregate?: InputMaybe<Project_Comment_Aggregate_Bool_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  customer_admins?: InputMaybe<Customer_Admin_Bool_Exp>;
  customer_admins_aggregate?: InputMaybe<Customer_Admin_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  invitations?: InputMaybe<Invitation_Bool_Exp>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Bool_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  login_count?: InputMaybe<Int_Comparison_Exp>;
  profile?: InputMaybe<Jsonb_Comparison_Exp>;
  projects?: InputMaybe<Project_Users_Bool_Exp>;
  projects_aggregate?: InputMaybe<Project_Users_Aggregate_Bool_Exp>;
  roles?: InputMaybe<User_Role_Bool_Exp>;
  roles_aggregate?: InputMaybe<User_Role_Aggregate_Bool_Exp>;
  user_permissions?: InputMaybe<User_Permissions_Bool_Exp>;
  user_permissions_aggregate?: InputMaybe<User_Permissions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "user" */
export type User_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'users_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  profile?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  profile?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  profile?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  login_count?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "user_info" */
export type User_Info = {
  __typename?: 'user_info';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "user_info" */
export type User_Info_Aggregate = {
  __typename?: 'user_info_aggregate';
  aggregate?: Maybe<User_Info_Aggregate_Fields>;
  nodes: Array<User_Info>;
};

/** aggregate fields of "user_info" */
export type User_Info_Aggregate_Fields = {
  __typename?: 'user_info_aggregate_fields';
  avg?: Maybe<User_Info_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Info_Max_Fields>;
  min?: Maybe<User_Info_Min_Fields>;
  stddev?: Maybe<User_Info_Stddev_Fields>;
  stddev_pop?: Maybe<User_Info_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Info_Stddev_Samp_Fields>;
  sum?: Maybe<User_Info_Sum_Fields>;
  var_pop?: Maybe<User_Info_Var_Pop_Fields>;
  var_samp?: Maybe<User_Info_Var_Samp_Fields>;
  variance?: Maybe<User_Info_Variance_Fields>;
};


/** aggregate fields of "user_info" */
export type User_Info_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Info_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type User_Info_Avg_Fields = {
  __typename?: 'user_info_avg_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_info". All fields are combined with a logical 'AND'. */
export type User_Info_Bool_Exp = {
  _and?: InputMaybe<Array<User_Info_Bool_Exp>>;
  _not?: InputMaybe<User_Info_Bool_Exp>;
  _or?: InputMaybe<Array<User_Info_Bool_Exp>>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  login_count?: InputMaybe<Int_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "user_info" */
export type User_Info_Inc_Input = {
  login_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_info" */
export type User_Info_Insert_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type User_Info_Max_Fields = {
  __typename?: 'user_info_max_fields';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Info_Min_Fields = {
  __typename?: 'user_info_min_fields';
  avatar?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user_info" */
export type User_Info_Mutation_Response = {
  __typename?: 'user_info_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Info>;
};

/** input type for inserting object relation for remote table "user_info" */
export type User_Info_Obj_Rel_Insert_Input = {
  data: User_Info_Insert_Input;
};

/** Ordering options when selecting data from "user_info". */
export type User_Info_Order_By = {
  avatar?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  login_count?: InputMaybe<Order_By>;
};

/** select columns of table "user_info" */
export type User_Info_Select_Column =
  /** column name */
  | 'avatar'
  /** column name */
  | 'email'
  /** column name */
  | 'first_name'
  /** column name */
  | 'id'
  /** column name */
  | 'last_login'
  /** column name */
  | 'last_name'
  /** column name */
  | 'login_count';

/** input type for updating data in table "user_info" */
export type User_Info_Set_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type User_Info_Stddev_Fields = {
  __typename?: 'user_info_stddev_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Info_Stddev_Pop_Fields = {
  __typename?: 'user_info_stddev_pop_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Info_Stddev_Samp_Fields = {
  __typename?: 'user_info_stddev_samp_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user_info" */
export type User_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Info_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type User_Info_Sum_Fields = {
  __typename?: 'user_info_sum_fields';
  login_count?: Maybe<Scalars['Int']>;
};

export type User_Info_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Info_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Info_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Info_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Info_Var_Pop_Fields = {
  __typename?: 'user_info_var_pop_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Info_Var_Samp_Fields = {
  __typename?: 'user_info_var_samp_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Info_Variance_Fields = {
  __typename?: 'user_info_variance_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Project_Comment_Arr_Rel_Insert_Input>;
  company?: InputMaybe<Scalars['String']>;
  customer_admins?: InputMaybe<Customer_Admin_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invitations?: InputMaybe<Invitation_Arr_Rel_Insert_Input>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Scalars['jsonb']>;
  projects?: InputMaybe<Project_Users_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<User_Role_Arr_Rel_Insert_Input>;
  user_permissions?: InputMaybe<User_Permissions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  avatar?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  avatar?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  last_name?: Maybe<Scalars['String']>;
  login_count?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  avatar?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Project_Comment_Aggregate_Order_By>;
  company?: InputMaybe<Order_By>;
  customer_admins_aggregate?: InputMaybe<Customer_Admin_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitations_aggregate?: InputMaybe<Invitation_Aggregate_Order_By>;
  last_login?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  login_count?: InputMaybe<Order_By>;
  profile?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Project_Users_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<User_Role_Aggregate_Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permissions_Aggregate_Order_By>;
};

/** columns and relationships of "user_permissions" */
export type User_Permissions = {
  __typename?: 'user_permissions';
  /** An object relationship */
  permission: Permissions;
  permissionId: Scalars['String'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "user_permissions" */
export type User_Permissions_Aggregate = {
  __typename?: 'user_permissions_aggregate';
  aggregate?: Maybe<User_Permissions_Aggregate_Fields>;
  nodes: Array<User_Permissions>;
};

export type User_Permissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Permissions_Aggregate_Bool_Exp_Count>;
};

export type User_Permissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Permissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_permissions" */
export type User_Permissions_Aggregate_Fields = {
  __typename?: 'user_permissions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Permissions_Max_Fields>;
  min?: Maybe<User_Permissions_Min_Fields>;
};


/** aggregate fields of "user_permissions" */
export type User_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_permissions" */
export type User_Permissions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Permissions_Max_Order_By>;
  min?: InputMaybe<User_Permissions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_permissions" */
export type User_Permissions_Arr_Rel_Insert_Input = {
  data: Array<User_Permissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Permissions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_permissions". All fields are combined with a logical 'AND'. */
export type User_Permissions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permissions_Bool_Exp>>;
  _not?: InputMaybe<User_Permissions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permissions_Bool_Exp>>;
  permission?: InputMaybe<Permissions_Bool_Exp>;
  permissionId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_permissions" */
export type User_Permissions_Constraint =
  /** unique or primary key constraint on columns "permissionId", "userId" */
  | 'user_permissions_pkey';

/** input type for inserting data into table "user_permissions" */
export type User_Permissions_Insert_Input = {
  permission?: InputMaybe<Permissions_Obj_Rel_Insert_Input>;
  permissionId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Permissions_Max_Fields = {
  __typename?: 'user_permissions_max_fields';
  permissionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_permissions" */
export type User_Permissions_Max_Order_By = {
  permissionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Permissions_Min_Fields = {
  __typename?: 'user_permissions_min_fields';
  permissionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_permissions" */
export type User_Permissions_Min_Order_By = {
  permissionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_permissions" */
export type User_Permissions_Mutation_Response = {
  __typename?: 'user_permissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permissions>;
};

/** on_conflict condition type for table "user_permissions" */
export type User_Permissions_On_Conflict = {
  constraint: User_Permissions_Constraint;
  update_columns?: Array<User_Permissions_Update_Column>;
  where?: InputMaybe<User_Permissions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permissions". */
export type User_Permissions_Order_By = {
  permission?: InputMaybe<Permissions_Order_By>;
  permissionId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_permissions */
export type User_Permissions_Pk_Columns_Input = {
  permissionId: Scalars['String'];
  userId: Scalars['String'];
};

/** select columns of table "user_permissions" */
export type User_Permissions_Select_Column =
  /** column name */
  | 'permissionId'
  /** column name */
  | 'userId';

/** input type for updating data in table "user_permissions" */
export type User_Permissions_Set_Input = {
  permissionId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_permissions" */
export type User_Permissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Permissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Permissions_Stream_Cursor_Value_Input = {
  permissionId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_permissions" */
export type User_Permissions_Update_Column =
  /** column name */
  | 'permissionId'
  /** column name */
  | 'userId';

export type User_Permissions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Permissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Permissions_Bool_Exp;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  profile?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "user_role" */
export type User_Role = {
  __typename?: 'user_role';
  /** An object relationship */
  role: Role;
  roleId: Scalars['String'];
  /** An object relationship */
  user: User;
  userId: Scalars['String'];
};

/** aggregated selection of "user_role" */
export type User_Role_Aggregate = {
  __typename?: 'user_role_aggregate';
  aggregate?: Maybe<User_Role_Aggregate_Fields>;
  nodes: Array<User_Role>;
};

export type User_Role_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Role_Aggregate_Bool_Exp_Count>;
};

export type User_Role_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Role_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_role" */
export type User_Role_Aggregate_Fields = {
  __typename?: 'user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Role_Max_Fields>;
  min?: Maybe<User_Role_Min_Fields>;
};


/** aggregate fields of "user_role" */
export type User_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_role" */
export type User_Role_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Role_Max_Order_By>;
  min?: InputMaybe<User_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_role" */
export type User_Role_Arr_Rel_Insert_Input = {
  data: Array<User_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_role". All fields are combined with a logical 'AND'. */
export type User_Role_Bool_Exp = {
  _and?: InputMaybe<Array<User_Role_Bool_Exp>>;
  _not?: InputMaybe<User_Role_Bool_Exp>;
  _or?: InputMaybe<Array<User_Role_Bool_Exp>>;
  role?: InputMaybe<Role_Bool_Exp>;
  roleId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_role" */
export type User_Role_Constraint =
  /** unique or primary key constraint on columns "userId", "roleId" */
  | 'user_role_pkey';

/** input type for inserting data into table "user_role" */
export type User_Role_Insert_Input = {
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  roleId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Role_Max_Fields = {
  __typename?: 'user_role_max_fields';
  roleId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_role" */
export type User_Role_Max_Order_By = {
  roleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Role_Min_Fields = {
  __typename?: 'user_role_min_fields';
  roleId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_role" */
export type User_Role_Min_Order_By = {
  roleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_role" */
export type User_Role_Mutation_Response = {
  __typename?: 'user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Role>;
};

/** on_conflict condition type for table "user_role" */
export type User_Role_On_Conflict = {
  constraint: User_Role_Constraint;
  update_columns?: Array<User_Role_Update_Column>;
  where?: InputMaybe<User_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "user_role". */
export type User_Role_Order_By = {
  role?: InputMaybe<Role_Order_By>;
  roleId?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_role */
export type User_Role_Pk_Columns_Input = {
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

/** select columns of table "user_role" */
export type User_Role_Select_Column =
  /** column name */
  | 'roleId'
  /** column name */
  | 'userId';

/** input type for updating data in table "user_role" */
export type User_Role_Set_Input = {
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_role" */
export type User_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Role_Stream_Cursor_Value_Input = {
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_role" */
export type User_Role_Update_Column =
  /** column name */
  | 'roleId'
  /** column name */
  | 'userId';

export type User_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Role_Bool_Exp;
};

/** select columns of table "user" */
export type User_Select_Column =
  /** column name */
  | 'avatar'
  /** column name */
  | 'company'
  /** column name */
  | 'email'
  /** column name */
  | 'first_name'
  /** column name */
  | 'id'
  /** column name */
  | 'last_login'
  /** column name */
  | 'last_name'
  /** column name */
  | 'login_count'
  /** column name */
  | 'profile';

/** input type for updating data in table "user" */
export type User_Set_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type User_Stddev_Fields = {
  __typename?: 'user_stddev_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type User_Stddev_Pop_Fields = {
  __typename?: 'user_stddev_pop_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type User_Stddev_Samp_Fields = {
  __typename?: 'user_stddev_samp_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  avatar?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  last_name?: InputMaybe<Scalars['String']>;
  login_count?: InputMaybe<Scalars['Int']>;
  profile?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type User_Sum_Fields = {
  __typename?: 'user_sum_fields';
  login_count?: Maybe<Scalars['Int']>;
};

/** update columns of table "user" */
export type User_Update_Column =
  /** column name */
  | 'avatar'
  /** column name */
  | 'company'
  /** column name */
  | 'email'
  /** column name */
  | 'first_name'
  /** column name */
  | 'id'
  /** column name */
  | 'last_login'
  /** column name */
  | 'last_name'
  /** column name */
  | 'login_count'
  /** column name */
  | 'profile';

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Var_Pop_Fields = {
  __typename?: 'user_var_pop_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type User_Var_Samp_Fields = {
  __typename?: 'user_var_samp_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type User_Variance_Fields = {
  __typename?: 'user_variance_fields';
  login_count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "vendor" */
export type Vendor = {
  __typename?: 'vendor';
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: Maybe<Scalars['String']>;
  /** An object relationship */
  buyer?: Maybe<User_Info>;
  buyerId?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  parts_list: Array<Vendor_Parts>;
  /** An aggregate relationship */
  parts_list_aggregate: Vendor_Parts_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};


/** columns and relationships of "vendor" */
export type VendorParts_ListArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};


/** columns and relationships of "vendor" */
export type VendorParts_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vendor_Parts_Order_By>>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};

/** aggregated selection of "vendor" */
export type Vendor_Aggregate = {
  __typename?: 'vendor_aggregate';
  aggregate?: Maybe<Vendor_Aggregate_Fields>;
  nodes: Array<Vendor>;
};

/** aggregate fields of "vendor" */
export type Vendor_Aggregate_Fields = {
  __typename?: 'vendor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Vendor_Max_Fields>;
  min?: Maybe<Vendor_Min_Fields>;
};


/** aggregate fields of "vendor" */
export type Vendor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vendor". All fields are combined with a logical 'AND'. */
export type Vendor_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Bool_Exp>>;
  bcVendorNumber?: InputMaybe<String_Comparison_Exp>;
  buyer?: InputMaybe<User_Info_Bool_Exp>;
  buyerId?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parts_list?: InputMaybe<Vendor_Parts_Bool_Exp>;
  parts_list_aggregate?: InputMaybe<Vendor_Parts_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit = {
  __typename?: 'vendor_cleanup_audit';
  canonical_had_wevr_mapping: Scalars['Boolean'];
  canonical_vendor_id: Scalars['String'];
  cluster_normalized_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  deleted_vendor_parts_rows: Scalars['jsonb'];
  id: Scalars['bigint'];
  sibling_had_wevr_mapping: Scalars['Boolean'];
  sibling_vendor_id: Scalars['String'];
  sibling_vendor_row?: Maybe<Scalars['jsonb']>;
  uom_scope_part_moved: Scalars['Int'];
  vendor_parts_moved: Scalars['Int'];
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged: Scalars['Int'];
};


/** columns and relationships of "vendor_cleanup_audit" */
export type Vendor_Cleanup_AuditDeleted_Vendor_Parts_RowsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "vendor_cleanup_audit" */
export type Vendor_Cleanup_AuditSibling_Vendor_RowArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Aggregate = {
  __typename?: 'vendor_cleanup_audit_aggregate';
  aggregate?: Maybe<Vendor_Cleanup_Audit_Aggregate_Fields>;
  nodes: Array<Vendor_Cleanup_Audit>;
};

/** aggregate fields of "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Aggregate_Fields = {
  __typename?: 'vendor_cleanup_audit_aggregate_fields';
  avg?: Maybe<Vendor_Cleanup_Audit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vendor_Cleanup_Audit_Max_Fields>;
  min?: Maybe<Vendor_Cleanup_Audit_Min_Fields>;
  stddev?: Maybe<Vendor_Cleanup_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Vendor_Cleanup_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vendor_Cleanup_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Vendor_Cleanup_Audit_Sum_Fields>;
  var_pop?: Maybe<Vendor_Cleanup_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Vendor_Cleanup_Audit_Var_Samp_Fields>;
  variance?: Maybe<Vendor_Cleanup_Audit_Variance_Fields>;
};


/** aggregate fields of "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Cleanup_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Vendor_Cleanup_Audit_Append_Input = {
  deleted_vendor_parts_rows?: InputMaybe<Scalars['jsonb']>;
  sibling_vendor_row?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Vendor_Cleanup_Audit_Avg_Fields = {
  __typename?: 'vendor_cleanup_audit_avg_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "vendor_cleanup_audit". All fields are combined with a logical 'AND'. */
export type Vendor_Cleanup_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Cleanup_Audit_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Cleanup_Audit_Bool_Exp>>;
  canonical_had_wevr_mapping?: InputMaybe<Boolean_Comparison_Exp>;
  canonical_vendor_id?: InputMaybe<String_Comparison_Exp>;
  cluster_normalized_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_vendor_parts_rows?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  sibling_had_wevr_mapping?: InputMaybe<Boolean_Comparison_Exp>;
  sibling_vendor_id?: InputMaybe<String_Comparison_Exp>;
  sibling_vendor_row?: InputMaybe<Jsonb_Comparison_Exp>;
  uom_scope_part_moved?: InputMaybe<Int_Comparison_Exp>;
  vendor_parts_moved?: InputMaybe<Int_Comparison_Exp>;
  vendor_parts_pk_collisions_merged?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Constraint =
  /** unique or primary key constraint on columns "id" */
  | 'vendor_cleanup_audit_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Vendor_Cleanup_Audit_Delete_At_Path_Input = {
  deleted_vendor_parts_rows?: InputMaybe<Array<Scalars['String']>>;
  sibling_vendor_row?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Vendor_Cleanup_Audit_Delete_Elem_Input = {
  deleted_vendor_parts_rows?: InputMaybe<Scalars['Int']>;
  sibling_vendor_row?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Vendor_Cleanup_Audit_Delete_Key_Input = {
  deleted_vendor_parts_rows?: InputMaybe<Scalars['String']>;
  sibling_vendor_row?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Inc_Input = {
  id?: InputMaybe<Scalars['bigint']>;
  uom_scope_part_moved?: InputMaybe<Scalars['Int']>;
  vendor_parts_moved?: InputMaybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Insert_Input = {
  canonical_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  canonical_vendor_id?: InputMaybe<Scalars['String']>;
  cluster_normalized_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_vendor_parts_rows?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  sibling_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  sibling_vendor_id?: InputMaybe<Scalars['String']>;
  sibling_vendor_row?: InputMaybe<Scalars['jsonb']>;
  uom_scope_part_moved?: InputMaybe<Scalars['Int']>;
  vendor_parts_moved?: InputMaybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Vendor_Cleanup_Audit_Max_Fields = {
  __typename?: 'vendor_cleanup_audit_max_fields';
  canonical_vendor_id?: Maybe<Scalars['String']>;
  cluster_normalized_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  sibling_vendor_id?: Maybe<Scalars['String']>;
  uom_scope_part_moved?: Maybe<Scalars['Int']>;
  vendor_parts_moved?: Maybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Vendor_Cleanup_Audit_Min_Fields = {
  __typename?: 'vendor_cleanup_audit_min_fields';
  canonical_vendor_id?: Maybe<Scalars['String']>;
  cluster_normalized_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['bigint']>;
  sibling_vendor_id?: Maybe<Scalars['String']>;
  uom_scope_part_moved?: Maybe<Scalars['Int']>;
  vendor_parts_moved?: Maybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Mutation_Response = {
  __typename?: 'vendor_cleanup_audit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Cleanup_Audit>;
};

/** on_conflict condition type for table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_On_Conflict = {
  constraint: Vendor_Cleanup_Audit_Constraint;
  update_columns?: Array<Vendor_Cleanup_Audit_Update_Column>;
  where?: InputMaybe<Vendor_Cleanup_Audit_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_cleanup_audit". */
export type Vendor_Cleanup_Audit_Order_By = {
  canonical_had_wevr_mapping?: InputMaybe<Order_By>;
  canonical_vendor_id?: InputMaybe<Order_By>;
  cluster_normalized_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_vendor_parts_rows?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sibling_had_wevr_mapping?: InputMaybe<Order_By>;
  sibling_vendor_id?: InputMaybe<Order_By>;
  sibling_vendor_row?: InputMaybe<Order_By>;
  uom_scope_part_moved?: InputMaybe<Order_By>;
  vendor_parts_moved?: InputMaybe<Order_By>;
  vendor_parts_pk_collisions_merged?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_cleanup_audit */
export type Vendor_Cleanup_Audit_Pk_Columns_Input = {
  id: Scalars['bigint'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Vendor_Cleanup_Audit_Prepend_Input = {
  deleted_vendor_parts_rows?: InputMaybe<Scalars['jsonb']>;
  sibling_vendor_row?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Select_Column =
  /** column name */
  | 'canonical_had_wevr_mapping'
  /** column name */
  | 'canonical_vendor_id'
  /** column name */
  | 'cluster_normalized_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'deleted_vendor_parts_rows'
  /** column name */
  | 'id'
  /** column name */
  | 'sibling_had_wevr_mapping'
  /** column name */
  | 'sibling_vendor_id'
  /** column name */
  | 'sibling_vendor_row'
  /** column name */
  | 'uom_scope_part_moved'
  /** column name */
  | 'vendor_parts_moved'
  /** column name */
  | 'vendor_parts_pk_collisions_merged';

/** input type for updating data in table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Set_Input = {
  canonical_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  canonical_vendor_id?: InputMaybe<Scalars['String']>;
  cluster_normalized_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_vendor_parts_rows?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  sibling_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  sibling_vendor_id?: InputMaybe<Scalars['String']>;
  sibling_vendor_row?: InputMaybe<Scalars['jsonb']>;
  uom_scope_part_moved?: InputMaybe<Scalars['Int']>;
  vendor_parts_moved?: InputMaybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Vendor_Cleanup_Audit_Stddev_Fields = {
  __typename?: 'vendor_cleanup_audit_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Vendor_Cleanup_Audit_Stddev_Pop_Fields = {
  __typename?: 'vendor_cleanup_audit_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Vendor_Cleanup_Audit_Stddev_Samp_Fields = {
  __typename?: 'vendor_cleanup_audit_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Cleanup_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Cleanup_Audit_Stream_Cursor_Value_Input = {
  canonical_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  canonical_vendor_id?: InputMaybe<Scalars['String']>;
  cluster_normalized_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_vendor_parts_rows?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['bigint']>;
  sibling_had_wevr_mapping?: InputMaybe<Scalars['Boolean']>;
  sibling_vendor_id?: InputMaybe<Scalars['String']>;
  sibling_vendor_row?: InputMaybe<Scalars['jsonb']>;
  uom_scope_part_moved?: InputMaybe<Scalars['Int']>;
  vendor_parts_moved?: InputMaybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Vendor_Cleanup_Audit_Sum_Fields = {
  __typename?: 'vendor_cleanup_audit_sum_fields';
  id?: Maybe<Scalars['bigint']>;
  uom_scope_part_moved?: Maybe<Scalars['Int']>;
  vendor_parts_moved?: Maybe<Scalars['Int']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Int']>;
};

/** update columns of table "vendor_cleanup_audit" */
export type Vendor_Cleanup_Audit_Update_Column =
  /** column name */
  | 'canonical_had_wevr_mapping'
  /** column name */
  | 'canonical_vendor_id'
  /** column name */
  | 'cluster_normalized_name'
  /** column name */
  | 'created_at'
  /** column name */
  | 'deleted_vendor_parts_rows'
  /** column name */
  | 'id'
  /** column name */
  | 'sibling_had_wevr_mapping'
  /** column name */
  | 'sibling_vendor_id'
  /** column name */
  | 'sibling_vendor_row'
  /** column name */
  | 'uom_scope_part_moved'
  /** column name */
  | 'vendor_parts_moved'
  /** column name */
  | 'vendor_parts_pk_collisions_merged';

export type Vendor_Cleanup_Audit_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Vendor_Cleanup_Audit_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Vendor_Cleanup_Audit_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Vendor_Cleanup_Audit_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Vendor_Cleanup_Audit_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vendor_Cleanup_Audit_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Vendor_Cleanup_Audit_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Cleanup_Audit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Cleanup_Audit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vendor_Cleanup_Audit_Var_Pop_Fields = {
  __typename?: 'vendor_cleanup_audit_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Vendor_Cleanup_Audit_Var_Samp_Fields = {
  __typename?: 'vendor_cleanup_audit_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Vendor_Cleanup_Audit_Variance_Fields = {
  __typename?: 'vendor_cleanup_audit_variance_fields';
  id?: Maybe<Scalars['Float']>;
  uom_scope_part_moved?: Maybe<Scalars['Float']>;
  vendor_parts_moved?: Maybe<Scalars['Float']>;
  /** Count of vendor_parts rows DELETEd by the collision-resolution step for this sibling. May include rows from either side of the merge (sibling OR canonical) depending on which lost the populated-fields tie-break — the counter does NOT distinguish. To audit a specific collision outcome, inspect the canonical row's post-merge state directly. */
  vendor_parts_pk_collisions_merged?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup';
  imported_at: Scalars['timestamptz'];
  matapp_vendor_id: Scalars['String'];
};

/** aggregated selection of "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup_aggregate';
  aggregate?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate_Fields>;
  nodes: Array<Vendor_Cleanup_Wevr_Mapping_Lookup>;
};

/** aggregate fields of "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate_Fields = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Max_Fields>;
  min?: Maybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Min_Fields>;
};


/** aggregate fields of "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "vendor_cleanup_wevr_mapping_lookup". All fields are combined with a logical 'AND'. */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>>;
  imported_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  matapp_vendor_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Constraint =
  /** unique or primary key constraint on columns "matapp_vendor_id" */
  | 'vendor_cleanup_wevr_mapping_lookup_pkey';

/** input type for inserting data into table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Insert_Input = {
  imported_at?: InputMaybe<Scalars['timestamptz']>;
  matapp_vendor_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Max_Fields = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup_max_fields';
  imported_at?: Maybe<Scalars['timestamptz']>;
  matapp_vendor_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Min_Fields = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup_min_fields';
  imported_at?: Maybe<Scalars['timestamptz']>;
  matapp_vendor_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Mutation_Response = {
  __typename?: 'vendor_cleanup_wevr_mapping_lookup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Cleanup_Wevr_Mapping_Lookup>;
};

/** on_conflict condition type for table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_On_Conflict = {
  constraint: Vendor_Cleanup_Wevr_Mapping_Lookup_Constraint;
  update_columns?: Array<Vendor_Cleanup_Wevr_Mapping_Lookup_Update_Column>;
  where?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_cleanup_wevr_mapping_lookup". */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Order_By = {
  imported_at?: InputMaybe<Order_By>;
  matapp_vendor_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_cleanup_wevr_mapping_lookup */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Pk_Columns_Input = {
  matapp_vendor_id: Scalars['String'];
};

/** select columns of table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Select_Column =
  /** column name */
  | 'imported_at'
  /** column name */
  | 'matapp_vendor_id';

/** input type for updating data in table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Set_Input = {
  imported_at?: InputMaybe<Scalars['timestamptz']>;
  matapp_vendor_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Cleanup_Wevr_Mapping_Lookup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Stream_Cursor_Value_Input = {
  imported_at?: InputMaybe<Scalars['timestamptz']>;
  matapp_vendor_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vendor_cleanup_wevr_mapping_lookup" */
export type Vendor_Cleanup_Wevr_Mapping_Lookup_Update_Column =
  /** column name */
  | 'imported_at'
  /** column name */
  | 'matapp_vendor_id';

export type Vendor_Cleanup_Wevr_Mapping_Lookup_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Cleanup_Wevr_Mapping_Lookup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Cleanup_Wevr_Mapping_Lookup_Bool_Exp;
};

/** unique or primary key constraints on table "vendor" */
export type Vendor_Constraint =
  /** unique or primary key constraint on columns "bcVendorNumber" */
  | 'vendor_bc_vendor_number_uq'
  /** unique or primary key constraint on columns  */
  | 'vendor_norm_name_idx'
  /** unique or primary key constraint on columns "id" */
  | 'vendor_pkey';

/** input type for inserting data into table "vendor" */
export type Vendor_Insert_Input = {
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: InputMaybe<Scalars['String']>;
  buyer?: InputMaybe<User_Info_Obj_Rel_Insert_Input>;
  buyerId?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  parts_list?: InputMaybe<Vendor_Parts_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vendor_Max_Fields = {
  __typename?: 'vendor_max_fields';
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Vendor_Min_Fields = {
  __typename?: 'vendor_min_fields';
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: Maybe<Scalars['String']>;
  buyerId?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "vendor" */
export type Vendor_Mutation_Response = {
  __typename?: 'vendor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor>;
};

/** input type for inserting object relation for remote table "vendor" */
export type Vendor_Obj_Rel_Insert_Input = {
  data: Vendor_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_On_Conflict>;
};

/** on_conflict condition type for table "vendor" */
export type Vendor_On_Conflict = {
  constraint: Vendor_Constraint;
  update_columns?: Array<Vendor_Update_Column>;
  where?: InputMaybe<Vendor_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor". */
export type Vendor_Order_By = {
  bcVendorNumber?: InputMaybe<Order_By>;
  buyer?: InputMaybe<User_Info_Order_By>;
  buyerId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parts_list_aggregate?: InputMaybe<Vendor_Parts_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** columns and relationships of "vendor_parts" */
export type Vendor_Parts = {
  __typename?: 'vendor_parts';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  lotSize?: Maybe<Scalars['numeric']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  part: Part;
  partId: Scalars['String'];
  preferred: Scalars['Boolean'];
  unitCost?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  /** An object relationship */
  vendor: Vendor;
  vendorId: Scalars['String'];
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** aggregated selection of "vendor_parts" */
export type Vendor_Parts_Aggregate = {
  __typename?: 'vendor_parts_aggregate';
  aggregate?: Maybe<Vendor_Parts_Aggregate_Fields>;
  nodes: Array<Vendor_Parts>;
};

export type Vendor_Parts_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Vendor_Parts_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Vendor_Parts_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Vendor_Parts_Aggregate_Bool_Exp_Count>;
};

export type Vendor_Parts_Aggregate_Bool_Exp_Bool_And = {
  arguments: Vendor_Parts_Select_Column_Vendor_Parts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Vendor_Parts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Parts_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Vendor_Parts_Select_Column_Vendor_Parts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Vendor_Parts_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Vendor_Parts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Vendor_Parts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "vendor_parts" */
export type Vendor_Parts_Aggregate_Fields = {
  __typename?: 'vendor_parts_aggregate_fields';
  avg?: Maybe<Vendor_Parts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Vendor_Parts_Max_Fields>;
  min?: Maybe<Vendor_Parts_Min_Fields>;
  stddev?: Maybe<Vendor_Parts_Stddev_Fields>;
  stddev_pop?: Maybe<Vendor_Parts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Vendor_Parts_Stddev_Samp_Fields>;
  sum?: Maybe<Vendor_Parts_Sum_Fields>;
  var_pop?: Maybe<Vendor_Parts_Var_Pop_Fields>;
  var_samp?: Maybe<Vendor_Parts_Var_Samp_Fields>;
  variance?: Maybe<Vendor_Parts_Variance_Fields>;
};


/** aggregate fields of "vendor_parts" */
export type Vendor_Parts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Vendor_Parts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "vendor_parts" */
export type Vendor_Parts_Aggregate_Order_By = {
  avg?: InputMaybe<Vendor_Parts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Vendor_Parts_Max_Order_By>;
  min?: InputMaybe<Vendor_Parts_Min_Order_By>;
  stddev?: InputMaybe<Vendor_Parts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Vendor_Parts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Vendor_Parts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Vendor_Parts_Sum_Order_By>;
  var_pop?: InputMaybe<Vendor_Parts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Vendor_Parts_Var_Samp_Order_By>;
  variance?: InputMaybe<Vendor_Parts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "vendor_parts" */
export type Vendor_Parts_Arr_Rel_Insert_Input = {
  data: Array<Vendor_Parts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Parts_On_Conflict>;
};

/** aggregate avg on columns */
export type Vendor_Parts_Avg_Fields = {
  __typename?: 'vendor_parts_avg_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "vendor_parts" */
export type Vendor_Parts_Avg_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vendor_parts". All fields are combined with a logical 'AND'. */
export type Vendor_Parts_Bool_Exp = {
  _and?: InputMaybe<Array<Vendor_Parts_Bool_Exp>>;
  _not?: InputMaybe<Vendor_Parts_Bool_Exp>;
  _or?: InputMaybe<Array<Vendor_Parts_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<String_Comparison_Exp>;
  leadTimeDays?: InputMaybe<Numeric_Comparison_Exp>;
  lotSize?: InputMaybe<Numeric_Comparison_Exp>;
  minOrderQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  part?: InputMaybe<Part_Bool_Exp>;
  partId?: InputMaybe<String_Comparison_Exp>;
  preferred?: InputMaybe<Boolean_Comparison_Exp>;
  unitCost?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<String_Comparison_Exp>;
  vendor?: InputMaybe<Vendor_Bool_Exp>;
  vendorId?: InputMaybe<String_Comparison_Exp>;
  vendorPartNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "vendor_parts" */
export type Vendor_Parts_Constraint =
  /** unique or primary key constraint on columns "partId", "vendorId" */
  | 'vendor_parts_pkey';

/** input type for incrementing numeric columns in table "vendor_parts" */
export type Vendor_Parts_Inc_Input = {
  leadTimeDays?: InputMaybe<Scalars['numeric']>;
  lotSize?: InputMaybe<Scalars['numeric']>;
  minOrderQuantity?: InputMaybe<Scalars['numeric']>;
  unitCost?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "vendor_parts" */
export type Vendor_Parts_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  leadTimeDays?: InputMaybe<Scalars['numeric']>;
  lotSize?: InputMaybe<Scalars['numeric']>;
  minOrderQuantity?: InputMaybe<Scalars['numeric']>;
  part?: InputMaybe<Part_Obj_Rel_Insert_Input>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  unitCost?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Vendor_Obj_Rel_Insert_Input>;
  vendorId?: InputMaybe<Scalars['String']>;
  vendorPartNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Vendor_Parts_Max_Fields = {
  __typename?: 'vendor_parts_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  lotSize?: Maybe<Scalars['numeric']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  partId?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "vendor_parts" */
export type Vendor_Parts_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendorId?: InputMaybe<Order_By>;
  vendorPartNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Vendor_Parts_Min_Fields = {
  __typename?: 'vendor_parts_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by?: Maybe<Scalars['String']>;
  leadTimeDays?: Maybe<Scalars['numeric']>;
  lotSize?: Maybe<Scalars['numeric']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  partId?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  updated_by?: Maybe<Scalars['String']>;
  vendorId?: Maybe<Scalars['String']>;
  vendorPartNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "vendor_parts" */
export type Vendor_Parts_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  partId?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendorId?: InputMaybe<Order_By>;
  vendorPartNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "vendor_parts" */
export type Vendor_Parts_Mutation_Response = {
  __typename?: 'vendor_parts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Vendor_Parts>;
};

/** input type for inserting object relation for remote table "vendor_parts" */
export type Vendor_Parts_Obj_Rel_Insert_Input = {
  data: Vendor_Parts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Vendor_Parts_On_Conflict>;
};

/** on_conflict condition type for table "vendor_parts" */
export type Vendor_Parts_On_Conflict = {
  constraint: Vendor_Parts_Constraint;
  update_columns?: Array<Vendor_Parts_Update_Column>;
  where?: InputMaybe<Vendor_Parts_Bool_Exp>;
};

/** Ordering options when selecting data from "vendor_parts". */
export type Vendor_Parts_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  part?: InputMaybe<Part_Order_By>;
  partId?: InputMaybe<Order_By>;
  preferred?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Vendor_Order_By>;
  vendorId?: InputMaybe<Order_By>;
  vendorPartNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor_parts */
export type Vendor_Parts_Pk_Columns_Input = {
  partId: Scalars['String'];
  vendorId: Scalars['String'];
};

/** select columns of table "vendor_parts" */
export type Vendor_Parts_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'leadTimeDays'
  /** column name */
  | 'lotSize'
  /** column name */
  | 'minOrderQuantity'
  /** column name */
  | 'partId'
  /** column name */
  | 'preferred'
  /** column name */
  | 'unitCost'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'vendorId'
  /** column name */
  | 'vendorPartNumber';

/** select "vendor_parts_aggregate_bool_exp_bool_and_arguments_columns" columns of table "vendor_parts" */
export type Vendor_Parts_Select_Column_Vendor_Parts_Aggregate_Bool_Exp_Bool_And_Arguments_Columns =
  /** column name */
  | 'preferred';

/** select "vendor_parts_aggregate_bool_exp_bool_or_arguments_columns" columns of table "vendor_parts" */
export type Vendor_Parts_Select_Column_Vendor_Parts_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns =
  /** column name */
  | 'preferred';

/** input type for updating data in table "vendor_parts" */
export type Vendor_Parts_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  leadTimeDays?: InputMaybe<Scalars['numeric']>;
  lotSize?: InputMaybe<Scalars['numeric']>;
  minOrderQuantity?: InputMaybe<Scalars['numeric']>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  unitCost?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
  vendorPartNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Vendor_Parts_Stddev_Fields = {
  __typename?: 'vendor_parts_stddev_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "vendor_parts" */
export type Vendor_Parts_Stddev_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Vendor_Parts_Stddev_Pop_Fields = {
  __typename?: 'vendor_parts_stddev_pop_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "vendor_parts" */
export type Vendor_Parts_Stddev_Pop_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Vendor_Parts_Stddev_Samp_Fields = {
  __typename?: 'vendor_parts_stddev_samp_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "vendor_parts" */
export type Vendor_Parts_Stddev_Samp_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "vendor_parts" */
export type Vendor_Parts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Parts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Parts_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  leadTimeDays?: InputMaybe<Scalars['numeric']>;
  lotSize?: InputMaybe<Scalars['numeric']>;
  minOrderQuantity?: InputMaybe<Scalars['numeric']>;
  partId?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  unitCost?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['String']>;
  vendorPartNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Vendor_Parts_Sum_Fields = {
  __typename?: 'vendor_parts_sum_fields';
  leadTimeDays?: Maybe<Scalars['numeric']>;
  lotSize?: Maybe<Scalars['numeric']>;
  minOrderQuantity?: Maybe<Scalars['numeric']>;
  unitCost?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "vendor_parts" */
export type Vendor_Parts_Sum_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** update columns of table "vendor_parts" */
export type Vendor_Parts_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'leadTimeDays'
  /** column name */
  | 'lotSize'
  /** column name */
  | 'minOrderQuantity'
  /** column name */
  | 'partId'
  /** column name */
  | 'preferred'
  /** column name */
  | 'unitCost'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by'
  /** column name */
  | 'vendorId'
  /** column name */
  | 'vendorPartNumber';

export type Vendor_Parts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Vendor_Parts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Parts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Parts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Vendor_Parts_Var_Pop_Fields = {
  __typename?: 'vendor_parts_var_pop_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "vendor_parts" */
export type Vendor_Parts_Var_Pop_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Vendor_Parts_Var_Samp_Fields = {
  __typename?: 'vendor_parts_var_samp_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "vendor_parts" */
export type Vendor_Parts_Var_Samp_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Vendor_Parts_Variance_Fields = {
  __typename?: 'vendor_parts_variance_fields';
  leadTimeDays?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['Float']>;
  minOrderQuantity?: Maybe<Scalars['Float']>;
  unitCost?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "vendor_parts" */
export type Vendor_Parts_Variance_Order_By = {
  leadTimeDays?: InputMaybe<Order_By>;
  lotSize?: InputMaybe<Order_By>;
  minOrderQuantity?: InputMaybe<Order_By>;
  unitCost?: InputMaybe<Order_By>;
};

/** primary key columns input for table: vendor */
export type Vendor_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "vendor" */
export type Vendor_Select_Column =
  /** column name */
  | 'bcVendorNumber'
  /** column name */
  | 'buyerId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

/** input type for updating data in table "vendor" */
export type Vendor_Set_Input = {
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "vendor" */
export type Vendor_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vendor_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vendor_Stream_Cursor_Value_Input = {
  /** Business Central vendor number (e.g. V00819). Populated only by the BC->matapp mirror; never user-editable. BC is the sole source of vendor truth (see 2026-07-15-bc-sole-source-vendors-design.md). */
  bcVendorNumber?: InputMaybe<Scalars['String']>;
  buyerId?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  updated_by?: InputMaybe<Scalars['String']>;
};

/** update columns of table "vendor" */
export type Vendor_Update_Column =
  /** column name */
  | 'bcVendorNumber'
  /** column name */
  | 'buyerId'
  /** column name */
  | 'created_at'
  /** column name */
  | 'created_by'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'updated_at'
  /** column name */
  | 'updated_by';

export type Vendor_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Vendor_Set_Input>;
  /** filter the rows which have to be updated */
  where: Vendor_Bool_Exp;
};

/** columns and relationships of "workflow" */
export type Workflow = {
  __typename?: 'workflow';
  created_at: Scalars['timestamptz'];
  current_state?: Maybe<Scalars['String']>;
  entity_id: Scalars['String'];
  entity_type: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  options?: Maybe<Scalars['jsonb']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "workflow" */
export type WorkflowOptionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "workflow" */
export type Workflow_Aggregate = {
  __typename?: 'workflow_aggregate';
  aggregate?: Maybe<Workflow_Aggregate_Fields>;
  nodes: Array<Workflow>;
};

export type Workflow_Aggregate_Bool_Exp = {
  count?: InputMaybe<Workflow_Aggregate_Bool_Exp_Count>;
};

export type Workflow_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Workflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Workflow_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "workflow" */
export type Workflow_Aggregate_Fields = {
  __typename?: 'workflow_aggregate_fields';
  avg?: Maybe<Workflow_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Workflow_Max_Fields>;
  min?: Maybe<Workflow_Min_Fields>;
  stddev?: Maybe<Workflow_Stddev_Fields>;
  stddev_pop?: Maybe<Workflow_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Workflow_Stddev_Samp_Fields>;
  sum?: Maybe<Workflow_Sum_Fields>;
  var_pop?: Maybe<Workflow_Var_Pop_Fields>;
  var_samp?: Maybe<Workflow_Var_Samp_Fields>;
  variance?: Maybe<Workflow_Variance_Fields>;
};


/** aggregate fields of "workflow" */
export type Workflow_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Workflow_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "workflow" */
export type Workflow_Aggregate_Order_By = {
  avg?: InputMaybe<Workflow_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Workflow_Max_Order_By>;
  min?: InputMaybe<Workflow_Min_Order_By>;
  stddev?: InputMaybe<Workflow_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Workflow_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Workflow_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Workflow_Sum_Order_By>;
  var_pop?: InputMaybe<Workflow_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Workflow_Var_Samp_Order_By>;
  variance?: InputMaybe<Workflow_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Append_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "workflow" */
export type Workflow_Arr_Rel_Insert_Input = {
  data: Array<Workflow_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Workflow_On_Conflict>;
};

/** aggregate avg on columns */
export type Workflow_Avg_Fields = {
  __typename?: 'workflow_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "workflow" */
export type Workflow_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "workflow". All fields are combined with a logical 'AND'. */
export type Workflow_Bool_Exp = {
  _and?: InputMaybe<Array<Workflow_Bool_Exp>>;
  _not?: InputMaybe<Workflow_Bool_Exp>;
  _or?: InputMaybe<Array<Workflow_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_state?: InputMaybe<String_Comparison_Exp>;
  entity_id?: InputMaybe<String_Comparison_Exp>;
  entity_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "workflow" */
export type Workflow_Constraint =
  /** unique or primary key constraint on columns "name", "entity_id", "entity_type" */
  | 'workflow_entity_id_entity_type_name_key'
  /** unique or primary key constraint on columns "id" */
  | 'workflow_pkey';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Workflow_Delete_At_Path_Input = {
  options?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Workflow_Delete_Elem_Input = {
  options?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Workflow_Delete_Key_Input = {
  options?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "workflow" */
export type Workflow_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "workflow" */
export type Workflow_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_state?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Workflow_Max_Fields = {
  __typename?: 'workflow_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  current_state?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "workflow" */
export type Workflow_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_state?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Workflow_Min_Fields = {
  __typename?: 'workflow_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  current_state?: Maybe<Scalars['String']>;
  entity_id?: Maybe<Scalars['String']>;
  entity_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "workflow" */
export type Workflow_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_state?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "workflow" */
export type Workflow_Mutation_Response = {
  __typename?: 'workflow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Workflow>;
};

/** on_conflict condition type for table "workflow" */
export type Workflow_On_Conflict = {
  constraint: Workflow_Constraint;
  update_columns?: Array<Workflow_Update_Column>;
  where?: InputMaybe<Workflow_Bool_Exp>;
};

/** Ordering options when selecting data from "workflow". */
export type Workflow_Order_By = {
  created_at?: InputMaybe<Order_By>;
  current_state?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  entity_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: workflow */
export type Workflow_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Workflow_Prepend_Input = {
  options?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "workflow" */
export type Workflow_Select_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'current_state'
  /** column name */
  | 'entity_id'
  /** column name */
  | 'entity_type'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'options'
  /** column name */
  | 'updated_at';

/** input type for updating data in table "workflow" */
export type Workflow_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_state?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Workflow_Stddev_Fields = {
  __typename?: 'workflow_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "workflow" */
export type Workflow_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Workflow_Stddev_Pop_Fields = {
  __typename?: 'workflow_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "workflow" */
export type Workflow_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Workflow_Stddev_Samp_Fields = {
  __typename?: 'workflow_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "workflow" */
export type Workflow_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "workflow" */
export type Workflow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Workflow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Workflow_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  current_state?: InputMaybe<Scalars['String']>;
  entity_id?: InputMaybe<Scalars['String']>;
  entity_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Workflow_Sum_Fields = {
  __typename?: 'workflow_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workflow" */
export type Workflow_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "workflow" */
export type Workflow_Update_Column =
  /** column name */
  | 'created_at'
  /** column name */
  | 'current_state'
  /** column name */
  | 'entity_id'
  /** column name */
  | 'entity_type'
  /** column name */
  | 'id'
  /** column name */
  | 'name'
  /** column name */
  | 'options'
  /** column name */
  | 'updated_at';

export type Workflow_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Workflow_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Workflow_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Workflow_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Workflow_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Workflow_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Workflow_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Workflow_Set_Input>;
  /** filter the rows which have to be updated */
  where: Workflow_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Workflow_Var_Pop_Fields = {
  __typename?: 'workflow_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "workflow" */
export type Workflow_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Workflow_Var_Samp_Fields = {
  __typename?: 'workflow_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "workflow" */
export type Workflow_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Workflow_Variance_Fields = {
  __typename?: 'workflow_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "workflow" */
export type Workflow_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

export type BaseProductFieldsFragment = { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> };

export type GetBaseProductListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaseProductListQuery = { __typename?: 'query_root', base_products: Array<{ __typename?: 'base_product', id: string, sku?: string | null, cms_id?: number | null, title?: Record<string, any> | null, description?: Record<string, any> | null, platform?: { __typename?: 'platform', name: string } | null, customer?: { __typename?: 'customer', id: string, name: string } | null, program?: { __typename?: 'program', id: string, name: string } | null }> };

export type VerifySerialNumberExistsQueryVariables = Exact<{
  base_product_id?: InputMaybe<Scalars['String']>;
}>;


export type VerifySerialNumberExistsQuery = { __typename?: 'query_root', serial_numbers_by_pk?: { __typename?: 'serial_numbers', next_serial: number, base_product_id: string } | null };

export type CreateSerialNumberForBaseProductIdMutationVariables = Exact<{
  base_product_id?: InputMaybe<Scalars['String']>;
}>;


export type CreateSerialNumberForBaseProductIdMutation = { __typename?: 'mutation_root', insert_serial_numbers_one?: { __typename?: 'serial_numbers', next_serial: number, base_product_id: string } | null };

export type IncrementNextSerialNumberByBaseProductIdMutationVariables = Exact<{
  base_product_id?: Scalars['String'];
}>;


export type IncrementNextSerialNumberByBaseProductIdMutation = { __typename?: 'mutation_root', update_serial_numbers_by_pk?: { __typename?: 'serial_numbers', base_product_id: string, next_serial: number } | null };

export type GetBaseProductsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Base_Product_Bool_Exp>;
}>;


export type GetBaseProductsQuery = { __typename?: 'query_root', base_product_aggregate: { __typename?: 'base_product_aggregate', aggregate?: { __typename?: 'base_product_aggregate_fields', count: number } | null }, base_product: Array<{ __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> }> };

export type GetBaseProductByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBaseProductByIdQuery = { __typename?: 'query_root', base_product?: { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, program?: { __typename?: 'program', name: string } | null, products: Array<{ __typename?: 'product', sku: string, id: string }>, product_options: Array<{ __typename?: 'product_option', name: string, id: string }>, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> } | null };

export type InsertBaseProductMutationVariables = Exact<{
  object: Base_Product_Insert_Input;
}>;


export type InsertBaseProductMutation = { __typename?: 'mutation_root', insert_base_product_one?: { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> } | null };

export type UpdateBaseProductMutationVariables = Exact<{
  id: Scalars['String'];
  set: Base_Product_Set_Input;
}>;


export type UpdateBaseProductMutation = { __typename?: 'mutation_root', update_base_product_by_pk?: { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> } | null };

export type UpsertBaseProductMutationVariables = Exact<{
  object: Base_Product_Insert_Input;
  update_columns: Array<Base_Product_Update_Column> | Base_Product_Update_Column;
}>;


export type UpsertBaseProductMutation = { __typename?: 'mutation_root', insert_base_product_one?: { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> } | null };

export type DeleteBaseProductMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteBaseProductMutation = { __typename?: 'mutation_root', delete_base_product_by_pk?: { __typename?: 'base_product', cms_data?: Record<string, any> | null, cms_id?: number | null, description: string, designed_for?: string | null, id: string, metadata?: Record<string, any> | null, product_type: string, program_id?: string | null, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', value: string, name: string, tag_type_id: string, label?: string | null, id: number } }> } | null };

export type BomItemCommonFieldsFragment = { __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null };

export type BomItemFieldsFragment = { __typename?: 'item_bom', id: bigint, item_id: string, platform_id?: string | null, base_product_id?: string | null, choice_id?: string | null, project_id?: string | null, unit_id?: string | null, quantity?: number | null, include_waste?: boolean | null, metadata?: Record<string, any> | null };

export type TaggedBomItemFieldsFragment = { __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null };

export type BomPartFieldsFragment = { __typename?: 'part', partNumber: string, imageUrl?: string | null, name: string, id: string, csiId: string, itemType?: string | null, status?: Part_Status_Enum | null, conversionRateMaterial?: number | null, wasteMaterial?: number | null, csi: { __typename?: 'csi', display_name?: string | null }, purchaseType?: { __typename?: 'purchase_type', name: string } | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null, vendors: Array<{ __typename?: 'vendor_parts', leadTimeDays?: number | null, unitCost?: number | null, vendor: { __typename?: 'vendor', name: string } }> };

export type GetAllBomOptionsBySkuQueryVariables = Exact<{
  sku: Scalars['String'];
}>;


export type GetAllBomOptionsBySkuQuery = { __typename?: 'query_root', product_option_choice: Array<{ __typename?: 'product_option_choice', id: string, bom_name?: string | null, code: string, name: string, is_default?: boolean | null, product_option: { __typename?: 'product_option', id: string, name: string, sort_order?: number | null, description?: string | null } }> };

export type GetUnitBomEntityQueryVariables = Exact<{
  unitid: Scalars['String'];
}>;


export type GetUnitBomEntityQuery = { __typename?: 'query_root', unit_bom_entity_view: Array<{ __typename?: 'unit_bom_entity_view', include_waste?: boolean | null, quantity?: number | null, unit_id?: string | null, tag_set_names?: string | null, tag_path_ids?: number | null, tag_set_ids?: string | null, tag_set_quantities?: any | null, unit_bom_entity?: { __typename?: 'part_download_view', ae_responsible?: string | null, buyer?: string | null, cogs_account?: string | null, conversion_rate?: number | null, cost?: number | null, csi_division?: string | null, cut_sheet_url?: string | null, est_daily_consumption?: string | null, finish_color?: string | null, image_url?: string | null, inventory_classification?: string | null, is_app_design_approved?: boolean | null, is_finance_approved?: boolean | null, is_in_accounting_system?: boolean | null, is_supply_chain_approved?: boolean | null, item_type?: string | null, location_name?: string | null, lot_size?: number | null, manufacturer?: string | null, manufacturer_part_number?: string | null, material?: string | null, material_issued_uom?: string | null, id?: string | null, weight?: string | null, waste_material?: number | null, warehouse_name?: string | null, type?: string | null, take_off_uom?: string | null, status?: string | null, standard_container_width?: string | null, standard_lead_time_days?: number | null, standard_container_height?: string | null, standard_container_length?: string | null, size?: string | null, searchable_key_words?: string | null, purchase_uom?: string | null, old_part_numbers?: string | null, part_number?: string | null, preferred_supplier?: string | null, preferred_supplier_part_number?: string | null, purchase_type?: string | null, name?: string | null, max_daily_consumption?: string | null, minimum_order_quantity?: number | null } | null }> };

export type GetBomItemTagSetQueryVariables = Exact<{
  path?: InputMaybe<Ltree_Comparison_Exp>;
}>;


export type GetBomItemTagSetQuery = { __typename?: 'query_root', bom_item_tag_set: Array<{ __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null, tag_set?: { __typename?: 'tag_set', id: string, selected_json?: Record<string, any> | null, name?: string | null, tag_path: { __typename?: 'tag_path', id: number, path: string } } | null }> };

export type GetBomByPlatformAndSkuQueryVariables = Exact<{
  platform: Scalars['String'];
  sku: Scalars['String'];
}>;


export type GetBomByPlatformAndSkuQuery = { __typename?: 'query_root', platform: Array<{ __typename?: 'platform', id: string, code?: string | null, name: string, description?: string | null, parent?: { __typename?: 'platform', id: string, name: string, description?: string | null } | null }>, base_product: Array<{ __typename?: 'base_product', id: string, sku?: string | null, description: string, platform_id?: string | null }>, option: Array<{ __typename?: 'product_option', id: string, name: string, description?: string | null, base_product_id: string }>, choice: Array<{ __typename?: 'product_option_choice', id: string, name: string, code: string, product_option_id: string }>, platform_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, product_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, choice_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, item_count: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, item: Array<{ __typename?: 'part', partNumber: string, imageUrl?: string | null, name: string, id: string, csiId: string, itemType?: string | null, status?: Part_Status_Enum | null, conversionRateMaterial?: number | null, wasteMaterial?: number | null, csi: { __typename?: 'csi', display_name?: string | null }, purchaseType?: { __typename?: 'purchase_type', name: string } | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null, vendors: Array<{ __typename?: 'vendor_parts', leadTimeDays?: number | null, unitCost?: number | null, vendor: { __typename?: 'vendor', name: string } }> }> };

export type GetBomByPlatformAndBaseProductQueryVariables = Exact<{
  platformId: Scalars['String'];
  baseProductId: Scalars['String'];
}>;


export type GetBomByPlatformAndBaseProductQuery = { __typename?: 'query_root', platform: Array<{ __typename?: 'platform', id: string, code?: string | null, name: string, description?: string | null, parent?: { __typename?: 'platform', id: string, name: string, description?: string | null } | null }>, base_product: Array<{ __typename?: 'base_product', id: string, sku?: string | null, description: string, platform_id?: string | null }>, option: Array<{ __typename?: 'product_option', id: string, name: string, description?: string | null, base_product_id: string }>, choice: Array<{ __typename?: 'product_option_choice', id: string, name: string, code: string, product_option_id: string }>, platform_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, product_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, choice_bom: Array<{ __typename?: 'item_bom', id: bigint, item_id: string, quantity?: number | null, include_waste?: boolean | null, ref_id?: string | null }>, item_count: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, item: Array<{ __typename?: 'part', partNumber: string, imageUrl?: string | null, name: string, id: string, csiId: string, itemType?: string | null, status?: Part_Status_Enum | null, conversionRateMaterial?: number | null, wasteMaterial?: number | null, csi: { __typename?: 'csi', display_name?: string | null }, purchaseType?: { __typename?: 'purchase_type', name: string } | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null, vendors: Array<{ __typename?: 'vendor_parts', leadTimeDays?: number | null, unitCost?: number | null, vendor: { __typename?: 'vendor', name: string } }> }> };

export type GetBomAddPartAddionalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBomAddPartAddionalInfoQuery = { __typename?: 'query_root', part?: { __typename?: 'part', partNumber: string, id: string, conversionRateMaterial?: number | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null, measures: Array<{ __typename?: 'uom_scope_part', id: string, measurement?: number | null, uom_conversion?: { __typename?: 'uom_conversion', description?: string | null } | null, uom_scope?: { __typename?: 'uom_scope', description: string } | null }>, vendors: Array<{ __typename?: 'vendor_parts', unitCost?: number | null, vendor: { __typename?: 'vendor', name: string } }> } | null };

export type InsertItemBomMutationVariables = Exact<{
  object: Item_Bom_Insert_Input;
}>;


export type InsertItemBomMutation = { __typename?: 'mutation_root', insert_item_bom_one?: { __typename?: 'item_bom', id: bigint, item_id: string, platform_id?: string | null, base_product_id?: string | null, choice_id?: string | null, project_id?: string | null, unit_id?: string | null, quantity?: number | null, include_waste?: boolean | null, metadata?: Record<string, any> | null } | null };

export type UpdateItemBomMutationVariables = Exact<{
  id: Scalars['bigint'];
  set: Item_Bom_Set_Input;
}>;


export type UpdateItemBomMutation = { __typename?: 'mutation_root', update_item_bom_by_pk?: { __typename?: 'item_bom', id: bigint, item_id: string, platform_id?: string | null, base_product_id?: string | null, choice_id?: string | null, project_id?: string | null, unit_id?: string | null, quantity?: number | null, include_waste?: boolean | null, metadata?: Record<string, any> | null } | null };

export type UpsertItemBomMutationVariables = Exact<{
  object: Item_Bom_Insert_Input;
  update_columns: Array<Item_Bom_Update_Column> | Item_Bom_Update_Column;
}>;


export type UpsertItemBomMutation = { __typename?: 'mutation_root', insert_item_bom_one?: { __typename?: 'item_bom', id: bigint, item_id: string, platform_id?: string | null, base_product_id?: string | null, choice_id?: string | null, project_id?: string | null, unit_id?: string | null, quantity?: number | null, include_waste?: boolean | null, metadata?: Record<string, any> | null } | null };

export type InsertBomItemTagSetMutationVariables = Exact<{
  object: Bom_Item_Tag_Set_Insert_Input;
}>;


export type InsertBomItemTagSetMutation = { __typename?: 'mutation_root', insert_bom_item_tag_set_one?: { __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null } | null };

export type UpdateBomItemTagSetMutationVariables = Exact<{
  id: Scalars['uuid'];
  set: Bom_Item_Tag_Set_Set_Input;
}>;


export type UpdateBomItemTagSetMutation = { __typename?: 'mutation_root', update_bom_item_tag_set_by_pk?: { __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null } | null };

export type UpsertBomItemTagSetMutationVariables = Exact<{
  object: Bom_Item_Tag_Set_Insert_Input;
  update_columns: Array<Bom_Item_Tag_Set_Update_Column> | Bom_Item_Tag_Set_Update_Column;
}>;


export type UpsertBomItemTagSetMutation = { __typename?: 'mutation_root', insert_bom_item_tag_set_one?: { __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null } | null };

export type DeleteBomItemTagSetMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteBomItemTagSetMutation = { __typename?: 'mutation_root', delete_bom_item_tag_set_by_pk?: { __typename?: 'bom_item_tag_set', id: string, entity_id: string, tag_set_id?: string | null, quantity: number, include_waste?: boolean | null } | null };

export type SetUnitOptionChoicesMutationVariables = Exact<{
  unit_id: Scalars['String'];
  objects: Array<Unit_Product_Option_Choice_Insert_Input> | Unit_Product_Option_Choice_Insert_Input;
}>;


export type SetUnitOptionChoicesMutation = { __typename?: 'mutation_root', delete_unit_product_option_choice?: { __typename?: 'unit_product_option_choice_mutation_response', affected_rows: number } | null, insert_unit_product_option_choice?: { __typename?: 'unit_product_option_choice_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'unit_product_option_choice', unit_id: string, product_option_choice_id: string }> } | null };

export type DeleteItemBomMutationVariables = Exact<{
  id: Scalars['bigint'];
}>;


export type DeleteItemBomMutation = { __typename?: 'mutation_root', delete_item_bom_by_pk?: { __typename?: 'item_bom', id: bigint, item_id: string, platform_id?: string | null, base_product_id?: string | null, choice_id?: string | null, project_id?: string | null, unit_id?: string | null, quantity?: number | null, include_waste?: boolean | null, metadata?: Record<string, any> | null } | null };

export type AddUnitsToProjectMutationVariables = Exact<{
  units: Array<Unit_Insert_Input> | Unit_Insert_Input;
}>;


export type AddUnitsToProjectMutation = { __typename?: 'mutation_root', insert_unit?: { __typename?: 'unit_mutation_response', affected_rows: number } | null };

export type NextSerialNumberIncrementMutationVariables = Exact<{
  base_product_id: Scalars['String'];
  quantity?: Scalars['numeric'];
}>;


export type NextSerialNumberIncrementMutation = { __typename?: 'mutation_root', update_serial_numbers_by_pk?: { __typename?: 'serial_numbers', next_serial: number } | null };

export type PartConversionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PartConversionByIdQuery = { __typename?: 'query_root', partConversion?: { __typename?: 'part', id: string, partNumber: string, conversionRateMaterial?: number | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null, vendors: Array<{ __typename?: 'vendor_parts', unitCost?: number | null }> } | null };

export type GetPlatformAndProductlookupQueryVariables = Exact<{
  platform?: Scalars['String'];
  sku?: Scalars['String'];
}>;


export type GetPlatformAndProductlookupQuery = { __typename?: 'query_root', products: Array<{ __typename?: 'lookup', id?: string | null, code?: string | null }>, base_products: Array<{ __typename?: 'lookup', id?: string | null, sku?: string | null }> };

export type TaggedBomFieldsFragmentFragment = { __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null };

export type GetBomForTagPathWithAncestorsAndDescendantsQueryVariables = Exact<{
  path?: InputMaybe<Scalars['ltree']>;
}>;


export type GetBomForTagPathWithAncestorsAndDescendantsQuery = { __typename?: 'query_root', ancestors: Array<{ __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null }>, ancestors_aggregage: { __typename?: 'tagged_part_download_view_aggregate', aggregate?: { __typename?: 'tagged_part_download_view_aggregate_fields', count: number } | null }, current: Array<{ __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null }>, current_aggregate: { __typename?: 'tagged_part_download_view_aggregate', aggregate?: { __typename?: 'tagged_part_download_view_aggregate_fields', count: number } | null }, descendants: Array<{ __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null }>, descendants_aggregate: { __typename?: 'tagged_part_download_view_aggregate', aggregate?: { __typename?: 'tagged_part_download_view_aggregate_fields', count: number } | null } };

export type GetBomForTagPathWithAncestorsQueryVariables = Exact<{
  path?: InputMaybe<Scalars['ltree']>;
}>;


export type GetBomForTagPathWithAncestorsQuery = { __typename?: 'query_root', ancestors: Array<{ __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null }>, ancestors_aggregage: { __typename?: 'tagged_part_download_view_aggregate', aggregate?: { __typename?: 'tagged_part_download_view_aggregate_fields', count: number } | null }, current: Array<{ __typename?: 'tagged_part_download_view', id?: string | null, tag_path?: string | null, tag_set_id?: string | null, tag_set_name?: string | null, bom_item_tag_set_id?: string | null, quantity?: number | null, part_number?: string | null, name?: string | null, include_waste?: boolean | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, conversion_rate?: number | null, cost?: number | null, status?: string | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null, design_uom?: string | null, design_measure?: number | null, estimating_uom?: string | null, estimating_measure?: number | null, purchasing_uom?: string | null, purchasing_measure?: number | null, shipping_uom?: string | null, shipping_measure?: number | null, accounting_base_uom?: string | null, accounting_base_measure?: number | null }>, current_aggregate: { __typename?: 'tagged_part_download_view_aggregate', aggregate?: { __typename?: 'tagged_part_download_view_aggregate_fields', count: number } | null } };

export type AllTagPathsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTagPathsQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', tag_type_id: string, id: number, name: string, label?: string | null, value: string, sequence: number }>, tag_path: Array<{ __typename?: 'tag_path', path: string }> };

export type GetTagPathTreeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagPathTreeQuery = { __typename?: 'query_root', tag_set: Array<{ __typename?: 'tag_set', id: string, tag_path_id: number, tag_path: { __typename?: 'tag_path', path: string } }>, tag_path: Array<{ __typename?: 'tag_path', id: number, path: string, tag_sets: Array<{ __typename?: 'tag_set', id: string }>, path_segments: Array<{ __typename?: 'tag_path_segment_view', segment?: string | null, tag_id?: number | null, tag_name?: string | null, tag_path_id?: number | null, tag_type_sequence?: number | null, tag_type_value?: string | null, tag_value?: string | null, sort_order?: bigint | null, tag_type_id?: string | null }> }> };

export type PartIdsFromTagsQueryVariables = Exact<{
  where?: InputMaybe<Part_Bool_Exp>;
}>;


export type PartIdsFromTagsQuery = { __typename?: 'query_root', part: Array<{ __typename?: 'part', id: string, partNumber: string, name: string }> };

export type TaggedPartsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type TaggedPartsByIdsQuery = { __typename?: 'query_root', part_download_view: Array<{ __typename?: 'part_download_view', id?: string | null, part_number?: string | null, name?: string | null, take_off_uom?: string | null, waste_material?: number | null, csi_division?: string | null, preferred_supplier?: string | null, purchase_uom?: string | null, conversion_rate?: number | null, cost?: number | null, item_type?: string | null, purchase_type?: string | null, image_url?: string | null }> };

export type GetWevrProjectBomQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetWevrProjectBomQuery = { __typename?: 'query_root', projectBOM: { __typename?: 'ProjectBOMResult', projectNumber: string, totalCost: number, version?: string | null, asOfDate: string, name: string, project?: { __typename?: 'project', id: string, bloxProjectNumber?: string | null, name: string, program?: { __typename?: 'program', name: string } | null } | null, items: Array<{ __typename?: 'BOMRowDetail', item_id: string, subTotalCost: number, subTotalQuantity: number, takeOffSubTotalQuantity?: number | null, item?: { __typename?: 'part_download_view', take_off_uom?: string | null, purchase_uom?: string | null, part_number?: string | null, standard_lead_time_days?: number | null, image_url?: string | null, status?: string | null, name?: string | null, csi_division?: string | null, cost?: number | null } | null, more?: Array<{ __typename?: 'UnitBOMRowResult', sku: string, skuSubTotalCost: number, skuSubTotalQuantity: number, skuTakeOffSubTotalQuantity?: number | null }> | null } | null> } };

export type GetProjectBomQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectBomQuery = { __typename?: 'query_root', project?: { __typename?: 'project', id: string, bloxProjectNumber?: string | null, name: string, units: Array<{ __typename?: 'unit', id: string, base_product_id: string, serial_number?: string | null, base_product: { __typename?: 'base_product', sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null }, selected_tag_sets: Array<{ __typename?: 'unit_tag_view', tag_path_id?: number | null }>, unit_bom: Array<{ __typename?: 'unit_bom_entity_view', include_waste?: boolean | null, tag_path_ids?: number | null, quantity?: number | null, unit_bom_entity?: { __typename?: 'part_download_view', part_number?: string | null, id?: string | null, cost?: number | null, status?: string | null, waste_material?: number | null, purchase_uom?: string | null, conversion_rate?: number | null } | null }> }> } | null };

export type GetCsiOptionsOnlyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCsiOptionsOnlyQuery = { __typename?: 'query_root', csi: Array<{ __typename?: 'csi', key: string, label?: string | null }>, uom: Array<{ __typename?: 'uom', key: number, label: string }>, program: Array<{ __typename?: 'program', key: string, label: string }>, part_request_type: Array<{ __typename?: 'part_request_type', key: string, label: string }>, part_request_reason: Array<{ __typename?: 'part_request_reason', key: string, label: string }> };

export type GetCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomersQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'customer', name: string, id: string }> };

export type GetDashboardQueryQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['timestamptz']>;
}>;


export type GetDashboardQueryQuery = { __typename?: 'query_root', active_users: { __typename?: 'user_info_aggregate', aggregate?: { __typename?: 'user_info_aggregate_fields', count: number } | null }, new_parts: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, part_request_cycle_time: Array<{ __typename?: 'part_request_cycle_time', interval?: string | null }>, part_requests: { __typename?: 'part_request_aggregate', aggregate?: { __typename?: 'part_request_aggregate_fields', count: number } | null }, parts_by_stage: Array<{ __typename?: 'parts_workflow_counts_view', workflow_stage?: string | null, count?: bigint | null }>, last_users: Array<{ __typename?: 'user_info', id?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, last_login?: string | null, login_count?: number | null, avatar?: string | null }> };

export type GetPlatformDashboardQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformDashboardQueryQuery = { __typename?: 'query_root', active_parts: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, inactive_parts: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, graph_data: Array<{ __typename?: 'platform_utilization_view', current?: number | null, domain?: string | null, percent?: any | null, program?: string | null, total?: number | null }>, platform_parts: { __typename?: 'tag_entity_aggregate', aggregate?: { __typename?: 'tag_entity_aggregate_fields', count: number } | null }, total_parts: { __typename?: 'part_aggregate', aggregate?: { __typename?: 'part_aggregate_fields', count: number } | null }, number_requests: { __typename?: 'part_request_aggregate', aggregate?: { __typename?: 'part_request_aggregate_fields', count: number } | null } };

export type GetProjectGraphQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectGraphQuery = { __typename?: 'query_root', projectBOMGraph: { __typename?: 'Neo4JGraphResult', nodes: Array<{ __typename?: 'Neo4JNode', typename: string, id: string, name: string, properties?: Record<string, any> | null }>, links: Array<{ __typename?: 'Neo4JLink', typename: string, source: string, target: string, properties?: Record<string, any> | null }> } };

export type GetUnitGraphQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUnitGraphQuery = { __typename?: 'query_root', unitBOMGraph: { __typename?: 'Neo4JGraphResult', nodes: Array<{ __typename?: 'Neo4JNode', typename: string, id: string, name: string, properties?: Record<string, any> | null }>, links: Array<{ __typename?: 'Neo4JLink', typename: string, source: string, target: string, properties?: Record<string, any> | null }> } };

export type LookupFieldsFragment = { __typename?: 'lookup', key?: string | null, type?: string | null, value?: string | null };

export type LookupsBySourceQueryVariables = Exact<{
  source: Scalars['String'];
}>;


export type LookupsBySourceQuery = { __typename?: 'query_root', lookup: Array<{ __typename?: 'lookup', key?: string | null, type?: string | null, value?: string | null }> };

export type MatappGetCsiDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MatappGetCsiDetailsQuery = { __typename?: 'query_root', csi_by_pk?: { __typename?: 'csi', display_name?: string | null, level1: string, level2: string, level3: string, application_engineer?: { __typename?: 'user_info', email?: string | null } | null } | null };

export type MatappGetPartForSearchQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MatappGetPartForSearchQuery = { __typename?: 'query_root', search_parts_view: Array<{ __typename?: 'search_parts_view', id?: string | null, objectID?: string | null, csi_level1?: string | null, csi_level2?: string | null, csi_level3?: string | null, description?: string | null, imageUrl?: string | null, manufacturer?: string | null, manufacturer_part_number?: string | null, name?: string | null, part_number?: string | null, part_number_histories?: string | null, status?: string | null, vendor?: string | null, approval_stage?: string | null, tagged_domains?: string | null, tagged_platforms?: string | null, tagged_products?: string | null, tagged_choices?: string | null, tagged_programs?: string | null, tagged_processes?: string | null, tags?: Record<string, any> | null, purchase_type?: string | null }> };

export type MatappGetAllItemsForSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type MatappGetAllItemsForSearchQuery = { __typename?: 'query_root', search_parts_view: Array<{ __typename?: 'search_parts_view', id?: string | null, objectID?: string | null, csi_level1?: string | null, csi_level2?: string | null, csi_level3?: string | null, description?: string | null, imageUrl?: string | null, manufacturer?: string | null, manufacturer_part_number?: string | null, name?: string | null, part_number?: string | null, part_number_histories?: string | null, status?: string | null, vendor?: string | null, approval_stage?: string | null, tagged_domains?: string | null, tagged_platforms?: string | null, tagged_products?: string | null, tagged_choices?: string | null, tagged_programs?: string | null, tagged_processes?: string | null, tags?: Record<string, any> | null, purchase_type?: string | null }>, base_product: Array<{ __typename?: 'base_product', id: string, sku?: string | null, cms_data?: Record<string, any> | null, description: string, platform?: { __typename?: 'platform', name: string, parent?: { __typename?: 'platform', name: string } | null } | null, program?: { __typename?: 'program', name: string } | null }> };

export type MatappGetPartNumberQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type MatappGetPartNumberQuery = { __typename?: 'query_root', part_by_pk?: { __typename?: 'part', id: string, partNumber: string } | null };

export type MatappGeneratePartNumberMutationVariables = Exact<{ [key: string]: never; }>;


export type MatappGeneratePartNumberMutation = { __typename?: 'mutation_root', update_counters_by_pk?: { __typename?: 'counters', value: number } | null };

export type MatappRestorePartNumberCounterMutationVariables = Exact<{
  expected: Scalars['Int'];
}>;


export type MatappRestorePartNumberCounterMutation = { __typename?: 'mutation_root', update_counters?: { __typename?: 'counters_mutation_response', affected_rows: number } | null };

export type MatappAssignPartNumberMutationVariables = Exact<{
  partId: Scalars['String'];
  oldPartNumber: Scalars['String'];
  newPartNumber: Scalars['String'];
}>;


export type MatappAssignPartNumberMutation = { __typename?: 'mutation_root', update_part?: { __typename?: 'part_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'part', id: string, partNumber: string }> } | null };

export type MatappAssignPartNumberToUnnumberedMutationVariables = Exact<{
  partId: Scalars['String'];
  newPartNumber: Scalars['String'];
}>;


export type MatappAssignPartNumberToUnnumberedMutation = { __typename?: 'mutation_root', update_part?: { __typename?: 'part_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'part', id: string, partNumber: string }> } | null };

export type MatappGetPartNumberHistoryByOldNumberQueryVariables = Exact<{
  partId: Scalars['String'];
  oldPartNumber: Scalars['String'];
}>;


export type MatappGetPartNumberHistoryByOldNumberQuery = { __typename?: 'query_root', part_number_history: Array<{ __typename?: 'part_number_history', id: string }> };

export type MatappInsertPartNumberHistoryMutationVariables = Exact<{
  id: Scalars['uuid'];
  partId: Scalars['String'];
  oldPartNumber?: InputMaybe<Scalars['String']>;
  newPartNumber: Scalars['String'];
}>;


export type MatappInsertPartNumberHistoryMutation = { __typename?: 'mutation_root', insert_part_number_history_one?: { __typename?: 'part_number_history', id: string } | null };

export type MatappInsertEmailsMutationVariables = Exact<{
  objects: Array<Emails_Insert_Input> | Emails_Insert_Input;
}>;


export type MatappInsertEmailsMutation = { __typename?: 'mutation_root', insert_emails?: { __typename?: 'emails_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'emails', id: string, status?: string | null, subject: string, text?: string | null }> } | null };

export type MatappMarkEmailSentMutationVariables = Exact<{
  id: Scalars['uuid'];
  claimedAt: Scalars['timestamptz'];
}>;


export type MatappMarkEmailSentMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number } | null };

export type MatappMarkEmailFailedMutationVariables = Exact<{
  id: Scalars['uuid'];
  claimedAt: Scalars['timestamptz'];
}>;


export type MatappMarkEmailFailedMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number } | null };

export type MatappClaimEmailForSendMutationVariables = Exact<{
  id: Scalars['uuid'];
  claimedAt: Scalars['timestamptz'];
}>;


export type MatappClaimEmailForSendMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'emails', id: string, subject: string, text?: string | null, html?: string | null, to: string }> } | null };

export type MatappMarkEmailSendAttemptedMutationVariables = Exact<{
  id: Scalars['uuid'];
  claimedAt: Scalars['timestamptz'];
  attemptedAt: Scalars['timestamptz'];
}>;


export type MatappMarkEmailSendAttemptedMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number } | null };

export type MatappStaleEmailClaimsQueryVariables = Exact<{
  cutoff: Scalars['timestamptz'];
}>;


export type MatappStaleEmailClaimsQuery = { __typename?: 'query_root', emails: Array<{ __typename?: 'emails', id: string, subject: string, created_at: string, claimed_at?: string | null, send_attempted_at?: string | null }> };

export type MatappReclaimStaleEmailMutationVariables = Exact<{
  id: Scalars['uuid'];
  cutoff: Scalars['timestamptz'];
  claimedAt: Scalars['timestamptz'];
}>;


export type MatappReclaimStaleEmailMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'emails', id: string, subject: string, text?: string | null, html?: string | null, to: string }> } | null };

export type MatappMarkEmailUnconfirmedMutationVariables = Exact<{
  id: Scalars['uuid'];
  cutoff: Scalars['timestamptz'];
}>;


export type MatappMarkEmailUnconfirmedMutation = { __typename?: 'mutation_root', update_emails?: { __typename?: 'emails_mutation_response', affected_rows: number } | null };

export type MatappAddUserRoleMutationVariables = Exact<{
  userId: Scalars['String'];
  roleId: Scalars['String'];
}>;


export type MatappAddUserRoleMutation = { __typename?: 'mutation_root', insert_user_role?: { __typename?: 'user_role_mutation_response', affected_rows: number } | null };

export type GetPartsToSyncQueryVariables = Exact<{
  until: Scalars['timestamptz'];
}>;


export type GetPartsToSyncQuery = { __typename?: 'query_root', part_sync: Array<{ __typename?: 'part_sync', id: number, operation: string, part_identifier: string, source_table: string, source_table_updated_at: string, source_table_updated_by: string, processed: boolean, processed_at?: string | null }> };

export type InsertPartSyncMutationVariables = Exact<{
  part: Part_Sync_Insert_Input;
}>;


export type InsertPartSyncMutation = { __typename?: 'mutation_root', insert_part_sync_one?: { __typename?: 'part_sync', id: number, operation: string, part_identifier: string, processed: boolean, processed_at?: string | null, source_table: string, source_table_updated_at: string, source_table_updated_by: string } | null };

export type CleanPartSyncMutationVariables = Exact<{
  until: Scalars['timestamptz'];
}>;


export type CleanPartSyncMutation = { __typename?: 'mutation_root', delete_part_sync?: { __typename?: 'part_sync_mutation_response', affected_rows: number } | null };

export type UpdatePartSyncEventCompleteMutationVariables = Exact<{
  partIdentifier: Scalars['String'];
  at: Scalars['timestamptz'];
  until: Scalars['timestamptz'];
}>;


export type UpdatePartSyncEventCompleteMutation = { __typename?: 'mutation_root', update_part_sync?: { __typename?: 'part_sync_mutation_response', affected_rows: number } | null };

export type GetPartForAirtableQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPartForAirtableQuery = { __typename?: 'query_root', part?: { __typename?: 'part', partNumber: string, name: string, status?: Part_Status_Enum | null, conversionRateMaterial?: number | null, conversionRateCommodity?: number | null, wasteMaterial?: number | null, csi: { __typename?: 'csi', title: string, level1: string, level2: string, level3: string }, part_number_histories: Array<{ __typename?: 'part_number_history', old_part_number: string }>, uomMaterial?: { __typename?: 'uom', name: string } | null, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomCommodity?: { __typename?: 'uom', name: string } | null, purchaseType?: { __typename?: 'purchase_type', name: string } | null, measures: Array<{ __typename?: 'uom_scope_part', measurement?: number | null, description?: string | null, uom_scope_id?: string | null, uom_scope?: { __typename?: 'uom_scope', description: string } | null, uom_conversion?: { __typename?: 'uom_conversion', abbreviation?: string | null, description?: string | null } | null }> } | null, preferredSupplier: Array<{ __typename?: 'vendor_parts', unitCost?: number | null, leadTimeDays?: number | null, vendor: { __typename?: 'vendor', name: string, buyer?: { __typename?: 'user_info', first_name?: string | null, last_name?: string | null } | null } }>, preferredManufacturer: Array<{ __typename?: 'manufacturer_parts', manufacturerPartNumber?: string | null, manufacturer: { __typename?: 'manufacturer', name: string } }> };

export type GetPartIdFromPartNumberQueryVariables = Exact<{
  partNumbers: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetPartIdFromPartNumberQuery = { __typename?: 'query_root', part: Array<{ __typename?: 'part', id: string }> };

export type GetPartForKbbQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPartForKbbQuery = { __typename?: 'query_root', kbb_parts_view: Array<{ __typename?: 'kbb_parts_view', part_cost?: number | null, part_custom_field_1?: string | null, part_custom_field_2?: string | null, part_description?: string | null, part_number?: string | null, part_unit_of_measurement?: string | null, part_weight?: string | null }> };

export type GetExistingWareHouseDetailsForKbbLoopPullQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExistingWareHouseDetailsForKbbLoopPullQuery = { __typename?: 'query_root', part_warehouse_detail: Array<{ __typename?: 'part_warehouse_detail', id: string, warehouse_name: string, location_name: string, part_number: string }> };

export type UpsertWareHouseMutationVariables = Exact<{
  object: Part_Warehouse_Detail_Insert_Input;
}>;


export type UpsertWareHouseMutation = { __typename?: 'mutation_root', insert_part_warehouse_detail_one?: { __typename?: 'part_warehouse_detail', id: string } | null };

export type GetPartFormOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartFormOptionsQuery = { __typename?: 'query_root', nextPartNum?: { __typename?: 'counters', nextPartNumber: number } | null, item_type: Array<{ __typename?: 'item_type', key: string, value: string, label?: string | null }>, part_status: Array<{ __typename?: 'part_status', value: string, key: string, label?: string | null }>, purchase_type: Array<{ __typename?: 'purchase_type', key: number, value: number, label: string }>, manufacturer: Array<{ __typename?: 'manufacturer', key: string, value: string, label: string }>, vendor: Array<{ __typename?: 'vendor', bcVendorNumber?: string | null, key: string, value: string, label: string }>, uom: Array<{ __typename?: 'uom', key: number, value: number, label: string }>, csi: Array<{ __typename?: 'csi', key: string, label?: string | null }> };

export type GetUomScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUomScopesQuery = { __typename?: 'query_root', classifications: Array<{ __typename?: 'uom_classification', id: string, measurement: string, prefer_integer: boolean, abbreviation?: string | null }>, units: Array<{ __typename?: 'uom_conversion', id: string, uom_classification_id: string, description?: string | null }>, scopes: Array<{ __typename?: 'uom_scope', id: string, scope: string }> };

export type GetPartPublicationDetailsQueryVariables = Exact<{
  where?: InputMaybe<Part_Bool_Exp>;
}>;


export type GetPartPublicationDetailsQuery = { __typename?: 'query_root', part: Array<{ __typename?: 'part', name: string, description?: string | null, category?: string | null, finishColor?: string | null, imageUrl?: string | null, inventoryClassification?: string | null, material?: string | null, maxDailyConsumption?: string | null, partNumber: string, size?: string | null, sourceUrl?: string | null, status?: Part_Status_Enum | null, itemType?: string | null, wasteMaterial?: number | null, id: string, isApprovedByAppDesign: boolean, isApprovedByFinance?: boolean | null, isApprovedBySupplyChain?: boolean | null, isInQuickBooks?: boolean | null, purchaseType?: { __typename?: 'purchase_type', name: string, id: number } | null, manufacturers: Array<{ __typename?: 'manufacturer_parts', preferred: boolean, manufacturerId: string, manufacturerPartNumber?: string | null, cutSheetUrl?: string | null, container_depth?: string | null, container_height?: string | null, container_weight?: string | null, container_width?: string | null, manufacturer: { __typename?: 'manufacturer', name: string } }>, vendors: Array<{ __typename?: 'vendor_parts', vendorId: string, vendorPartNumber?: string | null, preferred: boolean, leadTimeDays?: number | null, unitCost?: number | null, lotSize?: number | null, minOrderQuantity?: number | null, vendor: { __typename?: 'vendor', name: string } }>, warehouse_details: Array<{ __typename?: 'part_warehouse_detail', id: string, location_name: string, warehouse_name: string }>, measures: Array<{ __typename?: 'uom_scope_part', description?: string | null, measurement?: number | null, uom_scope?: { __typename?: 'uom_scope', description: string } | null, uom_conversion?: { __typename?: 'uom_conversion', abbreviation?: string | null, description?: string | null, quantity?: number | null, id: string, uom_classification: { __typename?: 'uom_classification', measurement: string, abbreviation?: string | null } } | null }>, csi: { __typename?: 'csi', id: string, title: string }, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', id: number, label?: string | null, name: string, tag_type_id: string, value: string } }> }> };

export type PlatformFieldsFragment = { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null };

export type GetPlatformsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Platform_Bool_Exp>;
}>;


export type GetPlatformsQuery = { __typename?: 'query_root', platform_aggregate: { __typename?: 'platform_aggregate', aggregate?: { __typename?: 'platform_aggregate_fields', count: number } | null }, platform: Array<{ __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null }> };

export type GetPlatformByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPlatformByIdQuery = { __typename?: 'query_root', platform?: { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null } | null };

export type InsertPlatformMutationVariables = Exact<{
  object: Platform_Insert_Input;
}>;


export type InsertPlatformMutation = { __typename?: 'mutation_root', insert_platform_one?: { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null } | null };

export type UpdatePlatformMutationVariables = Exact<{
  id: Scalars['String'];
  set: Platform_Set_Input;
}>;


export type UpdatePlatformMutation = { __typename?: 'mutation_root', update_platform_by_pk?: { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null } | null };

export type UpsertPlatformMutationVariables = Exact<{
  object: Platform_Insert_Input;
  update_columns: Array<Platform_Update_Column> | Platform_Update_Column;
}>;


export type UpsertPlatformMutation = { __typename?: 'mutation_root', insert_platform_one?: { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null } | null };

export type DeletePlatformMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePlatformMutation = { __typename?: 'mutation_root', delete_platform_by_pk?: { __typename?: 'platform', description?: string | null, derived_from?: string | null, id: string, metadata?: Record<string, any> | null, name: string, code?: string | null } | null };

export type GetPlatformAsDesignedQueryVariables = Exact<{
  where?: InputMaybe<Platform_Bool_Exp>;
}>;


export type GetPlatformAsDesignedQuery = { __typename?: 'query_root', platform: Array<{ __typename?: 'platform', code?: string | null, id: string, name: string, derived_from?: string | null, base_products: Array<{ __typename?: 'base_product', id: string, sku?: string | null, product_options: Array<{ __typename?: 'product_option', id: string, name: string, sort_order?: number | null, from_choice?: string | null, allow_multiple: boolean, product_option_choices: Array<{ __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, name: string, sort_order?: number | null }> }> }> }> };

export type GetLoomByPlatformAndSkuQueryVariables = Exact<{
  sku?: InputMaybe<Base_Product_Bool_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
}>;


export type GetLoomByPlatformAndSkuQuery = { __typename?: 'query_root', platform: Array<{ __typename: 'platform', name: string, id: string, code?: string | null, items_aggregate: { __typename?: 'item_bom_aggregate', aggregate?: { __typename?: 'item_bom_aggregate_fields', count: number } | null }, items: Array<{ __typename: 'item_bom', id: bigint, quantity?: number | null, include_waste?: boolean | null, item: { __typename: 'part', id: string, partNumber: string, imageUrl?: string | null, name: string, status?: Part_Status_Enum | null, uomTakeOffId?: number | null, uomMaterialId?: number | null, conversionRateMaterial?: number | null, csi: { __typename: 'csi', display_name?: string | null }, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null } }>, parent?: { __typename: 'platform', name: string, id: string } | null, base_products: Array<{ __typename: 'base_product', sku?: string | null, id: string, items_aggregate: { __typename?: 'item_bom_aggregate', aggregate?: { __typename?: 'item_bom_aggregate_fields', count: number } | null }, items: Array<{ __typename: 'item_bom', id: bigint, quantity?: number | null, include_waste?: boolean | null, item: { __typename: 'part', id: string, partNumber: string, imageUrl?: string | null, name: string, status?: Part_Status_Enum | null, uomTakeOffId?: number | null, uomMaterialId?: number | null, conversionRateMaterial?: number | null, csi: { __typename: 'csi', display_name?: string | null }, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null } }>, product_options: Array<{ __typename: 'product_option', name: string, id: string, sort_order?: number | null, product_option_choices: Array<{ __typename: 'product_option_choice', id: string, name: string, sort_order?: number | null, items_aggregate: { __typename?: 'item_bom_aggregate', aggregate?: { __typename?: 'item_bom_aggregate_fields', count: number } | null }, items: Array<{ __typename: 'item_bom', id: bigint, quantity?: number | null, include_waste?: boolean | null, item: { __typename: 'part', id: string, partNumber: string, imageUrl?: string | null, name: string, status?: Part_Status_Enum | null, uomTakeOffId?: number | null, uomMaterialId?: number | null, conversionRateMaterial?: number | null, csi: { __typename: 'csi', display_name?: string | null }, uomTakeOff?: { __typename?: 'uom', name: string } | null, uomMaterial?: { __typename?: 'uom', name: string } | null } }> }> }> }> }> };

export type ProductOptionFieldsFragment = { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string };

export type GetProductOptionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Product_Option_Bool_Exp>;
}>;


export type GetProductOptionsQuery = { __typename?: 'query_root', product_option_aggregate: { __typename?: 'product_option_aggregate', aggregate?: { __typename?: 'product_option_aggregate_fields', count: number } | null }, product_option: Array<{ __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string }> };

export type GetProductOptionByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProductOptionByIdQuery = { __typename?: 'query_root', product_option?: { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string, base_product: { __typename?: 'base_product', id: string, sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null }, platform_requirement?: { __typename?: 'platform_requirement', name: string, id: string } | null } | null };

export type InsertProductOptionMutationVariables = Exact<{
  object: Product_Option_Insert_Input;
}>;


export type InsertProductOptionMutation = { __typename?: 'mutation_root', insert_product_option_one?: { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string } | null };

export type UpdateProductOptionMutationVariables = Exact<{
  id: Scalars['String'];
  set: Product_Option_Set_Input;
}>;


export type UpdateProductOptionMutation = { __typename?: 'mutation_root', update_product_option_by_pk?: { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string } | null };

export type UpsertProductOptionMutationVariables = Exact<{
  object: Product_Option_Insert_Input;
  update_columns: Array<Product_Option_Update_Column> | Product_Option_Update_Column;
}>;


export type UpsertProductOptionMutation = { __typename?: 'mutation_root', insert_product_option_one?: { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string } | null };

export type DeleteProductOptionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProductOptionMutation = { __typename?: 'mutation_root', delete_product_option_by_pk?: { __typename?: 'product_option', allow_multiple: boolean, description?: string | null, from_choice?: string | null, id: string, name: string } | null };

export type ProductOptionChoiceFieldsFragment = { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string };

export type GetProductOptionChoicesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Product_Option_Choice_Bool_Exp>;
}>;


export type GetProductOptionChoicesQuery = { __typename?: 'query_root', product_option_choice_aggregate: { __typename?: 'product_option_choice_aggregate', aggregate?: { __typename?: 'product_option_choice_aggregate_fields', count: number } | null }, product_option_choice: Array<{ __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string }> };

export type GetProductOptionChoiceByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProductOptionChoiceByIdQuery = { __typename?: 'query_root', product_option_choice?: { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string, product_option: { __typename?: 'product_option', id: string, name: string } } | null };

export type InsertProductOptionChoiceMutationVariables = Exact<{
  setDefaultWhere: Product_Option_Choice_Bool_Exp;
  object: Product_Option_Choice_Insert_Input;
}>;


export type InsertProductOptionChoiceMutation = { __typename?: 'mutation_root', update_product_option_choice?: { __typename?: 'product_option_choice_mutation_response', affected_rows: number } | null, insert_product_option_choice_one?: { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string } | null };

export type UpdateProductOptionChoiceMutationVariables = Exact<{
  id: Scalars['String'];
  set: Product_Option_Choice_Set_Input;
}>;


export type UpdateProductOptionChoiceMutation = { __typename?: 'mutation_root', update_product_option_choice_by_pk?: { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string } | null };

export type UpsertProductOptionChoiceMutationVariables = Exact<{
  object: Product_Option_Choice_Insert_Input;
  update_columns: Array<Product_Option_Choice_Update_Column> | Product_Option_Choice_Update_Column;
}>;


export type UpsertProductOptionChoiceMutation = { __typename?: 'mutation_root', insert_product_option_choice_one?: { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string } | null };

export type DeleteProductOptionChoiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteProductOptionChoiceMutation = { __typename?: 'mutation_root', delete_product_option_choice_by_pk?: { __typename?: 'product_option_choice', bom_name?: string | null, code: string, id: string, is_default?: boolean | null, metadata?: Record<string, any> | null, name: string } | null };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'query_root', project: Array<{ __typename?: 'project', id: string, name: string, bloxProjectNumber?: string | null, statusId: number, city?: string | null, state?: string | null, year?: number | null, customerId: string, status: { __typename?: 'project_status', name: string }, customer: { __typename?: 'customer', name: string, id: string } }>, project_status: Array<{ __typename?: 'project_status', name: string }>, customer: Array<{ __typename?: 'customer', name: string }> };

export type GetProjectOptionsByBaseProductQueryVariables = Exact<{
  baseProduct: Scalars['String'];
  unitId: Scalars['String'];
}>;


export type GetProjectOptionsByBaseProductQuery = { __typename?: 'query_root', base_product?: { __typename?: 'base_product', id: string, sku?: string | null, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', id: number, name: string, notes?: string | null, value: string, label?: string | null, tag_type_id: string, sequence: number, entities: Array<{ __typename?: 'tag_entity', entity_id: string, tag_id: number }> } }> } | null };

export type SetSelectedUnitOptionsMutationVariables = Exact<{
  unit_id?: InputMaybe<Scalars['String']>;
  tags: Array<Tag_Entity_Insert_Input> | Tag_Entity_Insert_Input;
}>;


export type SetSelectedUnitOptionsMutation = { __typename?: 'mutation_root', delete_tag_entity?: { __typename?: 'tag_entity_mutation_response', returning: Array<{ __typename?: 'tag_entity', id: number, tag_id: number, entity_id: string }> } | null, insert_tag_entity?: { __typename?: 'tag_entity_mutation_response', returning: Array<{ __typename?: 'tag_entity', id: number, tag_id: number, entity_id: string }> } | null };

export type GetProjectByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectByIdQuery = { __typename?: 'query_root', project?: { __typename?: 'project', bloxApproved?: boolean | null, bloxProjectNumber?: string | null, city?: string | null, comments?: string | null, id: string, name: string, postalCode?: string | null, state?: string | null, customerId: string, statusId: number, type?: string | null, year?: number | null, options?: Record<string, any> | null, status: { __typename?: 'project_status', name: string }, customer: { __typename?: 'customer', name: string, id: string }, units: Array<{ __typename?: 'unit', serial_number?: string | null, old_serial_number?: string | null, id: string, base_product: { __typename?: 'base_product', id: string, sku?: string | null, bom_tags_aggregate: { __typename?: 'tag_entity_aggregate', aggregate?: { __typename?: 'tag_entity_aggregate_fields', count: number } | null } }, tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', id: number, name: string, sequence: number, label?: string | null, value: string, tag_type_id: string, notes?: string | null } }> }>, base_product_quantities: Array<{ __typename?: 'project_base_product_quantities', base_product_id: string, quantity: number, base_product: { __typename?: 'base_product', sku?: string | null } }> } | null };

export type ReportFieldsFragment = { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null };

export type GetReportsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Report_Bool_Exp>;
}>;


export type GetReportsQuery = { __typename?: 'query_root', reports: Array<{ __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null }> };

export type GetReportByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReportByIdQuery = { __typename?: 'query_root', report?: { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null } | null };

export type InsertReportMutationVariables = Exact<{
  object: Report_Insert_Input;
}>;


export type InsertReportMutation = { __typename?: 'mutation_root', insert_report_one?: { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null } | null };

export type UpdateReportMutationVariables = Exact<{
  id: Scalars['String'];
  set: Report_Set_Input;
}>;


export type UpdateReportMutation = { __typename?: 'mutation_root', update_report_by_pk?: { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null } | null };

export type UpsertReportMutationVariables = Exact<{
  object: Report_Insert_Input;
  update_columns: Array<Report_Update_Column> | Report_Update_Column;
}>;


export type UpsertReportMutation = { __typename?: 'mutation_root', insert_report_one?: { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null } | null };

export type DeleteReportMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReportMutation = { __typename?: 'mutation_root', delete_report_by_pk?: { __typename?: 'report', id: string, name: string, embed_url: string, permission?: string | null } | null };

export type PlatformRequirementFieldsFragment = { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null };

export type GetPlatformRequirementsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Platform_Requirement_Bool_Exp>;
}>;


export type GetPlatformRequirementsQuery = { __typename?: 'query_root', platform_requirement_aggregate: { __typename?: 'platform_requirement_aggregate', aggregate?: { __typename?: 'platform_requirement_aggregate_fields', count: number } | null }, platform_requirement: Array<{ __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null }> };

export type GetPlatformRequirementByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPlatformRequirementByIdQuery = { __typename?: 'query_root', platform_requirement?: { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null, fulfilled_by: Array<{ __typename?: 'product_option', id: string, name: string }> } | null };

export type InsertPlatformRequirementMutationVariables = Exact<{
  object: Platform_Requirement_Insert_Input;
}>;


export type InsertPlatformRequirementMutation = { __typename?: 'mutation_root', insert_platform_requirement_one?: { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null } | null };

export type UpdatePlatformRequirementMutationVariables = Exact<{
  id: Scalars['String'];
  set: Platform_Requirement_Set_Input;
}>;


export type UpdatePlatformRequirementMutation = { __typename?: 'mutation_root', update_platform_requirement_by_pk?: { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null } | null };

export type UpsertPlatformRequirementMutationVariables = Exact<{
  object: Platform_Requirement_Insert_Input;
  update_columns: Array<Platform_Requirement_Update_Column> | Platform_Requirement_Update_Column;
}>;


export type UpsertPlatformRequirementMutation = { __typename?: 'mutation_root', insert_platform_requirement_one?: { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null } | null };

export type DeletePlatformRequirementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePlatformRequirementMutation = { __typename?: 'mutation_root', delete_platform_requirement_by_pk?: { __typename?: 'platform_requirement', description?: string | null, id: string, name: string, platform_id: string, metadata?: Record<string, any> | null } | null };

export type GetShortLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShortLinksQuery = { __typename?: 'query_root', short_url: Array<{ __typename?: 'short_url', id: number, url: string, slug: string, active: boolean, qrcode_url?: string | null, clicks: number, name?: string | null, description?: string | null, link_tags?: Record<string, any> | null }> };

export type AddShortLinkMutationVariables = Exact<{
  object: Short_Url_Insert_Input;
}>;


export type AddShortLinkMutation = { __typename?: 'mutation_root', insert_short_url_one?: { __typename?: 'short_url', id: number, slug: string, url: string, active: boolean, qrcode_url?: string | null, clicks: number, name?: string | null, description?: string | null, link_tags?: Record<string, any> | null } | null };

export type EditShortLinkMutationVariables = Exact<{
  id: Scalars['Int'];
  object: Short_Url_Set_Input;
}>;


export type EditShortLinkMutation = { __typename?: 'mutation_root', update_short_url_by_pk?: { __typename?: 'short_url', id: number, slug: string, url: string, active: boolean, qrcode_url?: string | null, clicks: number, name?: string | null, description?: string | null, link_tags?: Record<string, any> | null } | null };

export type UpdateShortLinkUrlMutationVariables = Exact<{
  id: Scalars['Int'];
  url: Scalars['String'];
}>;


export type UpdateShortLinkUrlMutation = { __typename?: 'mutation_root', update_short_url_by_pk?: { __typename?: 'short_url', id: number, url: string, slug: string, active: boolean, qrcode_url?: string | null, clicks: number, name?: string | null, description?: string | null, link_tags?: Record<string, any> | null } | null };

export type LongUrlFromSlugMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type LongUrlFromSlugMutation = { __typename?: 'mutation_root', update_short_url?: { __typename?: 'short_url_mutation_response', returning: Array<{ __typename?: 'short_url', url: string, slug: string, clicks: number }> } | null };

export type SupplierFieldsFragment = { __typename?: 'vendor', buyerId?: string | null, id: string, name: string };

export type GetSuppliersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Vendor_Bool_Exp>;
  orderBy?: InputMaybe<Array<Vendor_Order_By> | Vendor_Order_By>;
}>;


export type GetSuppliersQuery = { __typename?: 'query_root', supplier_aggregate: { __typename?: 'vendor_aggregate', aggregate?: { __typename?: 'vendor_aggregate_fields', count: number } | null }, supplier: Array<{ __typename?: 'vendor', buyerId?: string | null, id: string, name: string }> };

export type GetSupplierByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSupplierByIdQuery = { __typename?: 'query_root', supplier?: { __typename?: 'vendor', buyerId?: string | null, id: string, name: string } | null };

export type InsertSupplierMutationVariables = Exact<{
  object: Vendor_Insert_Input;
}>;


export type InsertSupplierMutation = { __typename?: 'mutation_root', insert_vendor_one?: { __typename?: 'vendor', buyerId?: string | null, id: string, name: string } | null };

export type UpdateSupplierMutationVariables = Exact<{
  id: Scalars['String'];
  set: Vendor_Set_Input;
}>;


export type UpdateSupplierMutation = { __typename?: 'mutation_root', update_vendor_by_pk?: { __typename?: 'vendor', buyerId?: string | null, id: string, name: string } | null };

export type UpsertSupplierMutationVariables = Exact<{
  object: Vendor_Insert_Input;
  update_columns: Array<Vendor_Update_Column> | Vendor_Update_Column;
}>;


export type UpsertSupplierMutation = { __typename?: 'mutation_root', insert_vendor_one?: { __typename?: 'vendor', buyerId?: string | null, id: string, name: string } | null };

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSupplierMutation = { __typename?: 'mutation_root', delete_vendor_by_pk?: { __typename?: 'vendor', buyerId?: string | null, id: string, name: string } | null };

export type GetAllTagTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagTypesQuery = { __typename?: 'query_root', tag_type: Array<{ __typename?: 'tag_type', value: string, description: string, id: string }> };

export type CreateTagTypeMutationVariables = Exact<{
  input: Tag_Type_Insert_Input;
}>;


export type CreateTagTypeMutation = { __typename?: 'mutation_root', tag_type?: { __typename?: 'tag_type', value: string, description: string } | null };

export type GetAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagsQuery = { __typename?: 'query_root', tag_type: Array<{ __typename?: 'tag_type', value: string, description: string, id: string }>, tags: Array<{ __typename?: 'tags', id: number, tag_type_id: string, name: string, value: string, label?: string | null, sequence: number }> };

export type GetTagByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetTagByIdQuery = { __typename?: 'query_root', tag?: { __typename?: 'tags', id: number, name: string, value: string, label?: string | null, notes?: string | null, sequence: number, tag_type_id: string, updated_at: string, updated_by: string, related_entity?: string | null, created_at: string, created_by: string } | null };

export type GetTagByIdListQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetTagByIdListQuery = { __typename?: 'query_root', tags: Array<{ __typename?: 'tags', label?: string | null, name: string, value: string, tag_type_id: string, sequence: number, id: number }> };

export type TagEntityMutationVariables = Exact<{
  objects: Array<Tag_Entity_Insert_Input> | Tag_Entity_Insert_Input;
}>;


export type TagEntityMutation = { __typename?: 'mutation_root', insert_tag_entity?: { __typename?: 'tag_entity_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'tag_entity', id: number, tag_id: number, entity_id: string }> } | null };

export type DeleteTagEntityMutationVariables = Exact<{
  tag_id: Scalars['Int'];
  entity_id: Scalars['String'];
}>;


export type DeleteTagEntityMutation = { __typename?: 'mutation_root', delete_tag_entity?: { __typename?: 'tag_entity_mutation_response', affected_rows: number } | null };

export type DeleteTagEntityByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteTagEntityByIdMutation = { __typename?: 'mutation_root', delete_tag_entity_by_pk?: { __typename?: 'tag_entity', id: number, tag_id: number, entity_id: string } | null };

export type InsertTagPathMutationVariables = Exact<{
  path: Scalars['ltree'];
}>;


export type InsertTagPathMutation = { __typename?: 'mutation_root', insert_tag_path_one?: { __typename?: 'tag_path', id: number, path: string } | null };

export type GetOptionTagsForBaseProductBySkuQueryVariables = Exact<{
  sku: Scalars['String'];
}>;


export type GetOptionTagsForBaseProductBySkuQuery = { __typename?: 'query_root', base_product: Array<{ __typename?: 'base_product', sku?: string | null, id: string, bom_tags: Array<{ __typename?: 'tag_entity', tag: { __typename?: 'tags', id: number, name: string, label?: string | null, tag_type_id: string, sequence: number, value: string } }> }> };

export type InsertTagSetFromPathMutationVariables = Exact<{
  path: Scalars['ltree'];
}>;


export type InsertTagSetFromPathMutation = { __typename?: 'mutation_root', insert_tag_set_one?: { __typename?: 'tag_set', id: string } | null };

export type GetAllTagSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagSetsQuery = { __typename?: 'query_root', tag_set: Array<{ __typename?: 'tag_set', id: string, tag_path: { __typename?: 'tag_path', path: string } }> };

export type GetTagSetByIdQueryVariables = Exact<{
  tag_set_id: Scalars['uuid'];
}>;


export type GetTagSetByIdQuery = { __typename?: 'query_root', tag_set?: { __typename?: 'tag_set', id: string, tag_path: { __typename?: 'tag_path', id: number, path: string } } | null };

export type GetTagPathSegmentViewQueryQueryVariables = Exact<{
  tag_path_id?: InputMaybe<Scalars['Int']>;
}>;


export type GetTagPathSegmentViewQueryQuery = { __typename?: 'query_root', tag_path_segment_view: Array<{ __typename?: 'tag_path_segment_view', segment?: string | null, sort_order?: bigint | null, tag_id?: number | null, tag_name?: string | null, tag_path?: string | null, tag_path_id?: number | null, tag_type_sequence?: number | null, tag_type_value?: string | null, tag_value?: string | null }> };

export type GetUnitDetailsWithBomQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitDetailsWithBomQuery = { __typename?: 'query_root', unit?: { __typename?: 'unit', id: string, serial_number?: string | null, schedule_on_date?: string | null, schedule_off_date?: string | null, price?: number | null, old_project?: string | null, old_serial_number?: string | null, created_at?: string | null, actual_off_date?: string | null, actual_on_date?: string | null, base_product: { __typename?: 'base_product', id: string, sku?: string | null, description: string, metadata?: Record<string, any> | null, product_type: string, created_at?: string | null, updated_at?: string | null, platform?: { __typename?: 'platform', code?: string | null, id: string, name: string, metadata?: Record<string, any> | null, description?: string | null, created_at?: string | null, derived_from?: string | null, updated_at?: string | null } | null, program?: { __typename?: 'program', created_at: string, created_by: string, description?: string | null, id: string, imageUrl?: string | null, name: string, updated_at: string, updated_by: string } | null }, project: { __typename?: 'project', id: string, bloxApproved?: boolean | null, bloxProjectNumber?: string | null, city?: string | null, comments?: string | null, created_at?: string | null, created_by?: string | null, customerId: string, name: string, options?: Record<string, any> | null, postalCode?: string | null, price?: number | null, state?: string | null, programId?: string | null, type?: string | null, statusId: number, year?: number | null, customer: { __typename?: 'customer', name: string } } } | null, bom: { __typename?: 'UnitBOMResult', asOfDate: string, id: string, serial_number: string, old_serial_number?: string | null, totalCost?: number | null, version?: string | null, items?: Array<{ __typename?: 'UnitBOMRow2', row_id: string, tagpathid?: string | null, cost: number, include_waste: boolean, item_id: string, level: string, quantity: number, take_off_quantity: number, item?: { __typename?: 'part_download_view', id?: string | null, part_number?: string | null, name?: string | null, old_part_numbers?: string | null, csi_division?: string | null, take_off_uom?: string | null, purchase_uom?: string | null, status?: string | null, cost?: number | null, conversion_rate?: number | null, ae_responsible?: string | null, buyer?: string | null, cogs_account?: string | null, cut_sheet_url?: string | null, image_url?: string | null, inventory_classification?: string | null, item_type?: string | null, location_name?: string | null, lot_size?: number | null, manufacturer?: string | null, manufacturer_part_number?: string | null, material?: string | null, material_issued_uom?: string | null, max_daily_consumption?: string | null, minimum_order_quantity?: number | null, preferred_supplier?: string | null, preferred_supplier_part_number?: string | null, purchase_type?: string | null, size?: string | null, standard_lead_time_days?: number | null, type?: string | null, waste_material?: number | null, weight?: string | null } | null }> | null } };

export type UnitFieldsFragment = { __typename?: 'unit', actual_off_date?: string | null, actual_on_date?: string | null, base_product_id: string, created_at?: string | null, id: string, old_project?: string | null, old_serial_number?: string | null, price?: number | null, project_id: string, schedule_off_date?: string | null, schedule_on_date?: string | null, serial_number?: string | null, updated_at?: string | null, base_product: { __typename?: 'base_product', sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null } };

export type UpdateUnitByIdMutationVariables = Exact<{
  id: Scalars['String'];
  set?: InputMaybe<Unit_Set_Input>;
}>;


export type UpdateUnitByIdMutation = { __typename?: 'mutation_root', update_unit_by_pk?: { __typename?: 'unit', actual_off_date?: string | null, actual_on_date?: string | null, base_product_id: string, created_at?: string | null, id: string, old_project?: string | null, old_serial_number?: string | null, price?: number | null, project_id: string, schedule_off_date?: string | null, schedule_on_date?: string | null, serial_number?: string | null, updated_at?: string | null, base_product: { __typename?: 'base_product', sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null } } | null };

export type AssignSerialNumberMutationVariables = Exact<{
  serial_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type AssignSerialNumberMutation = { __typename?: 'mutation_root', update_unit_by_pk?: { __typename?: 'unit', id: string, serial_number?: string | null, base_product_id: string } | null };

export type GetUnitByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetUnitByIdQuery = { __typename?: 'query_root', unit_by_pk?: { __typename?: 'unit', actual_off_date?: string | null, actual_on_date?: string | null, base_product_id: string, created_at?: string | null, id: string, old_project?: string | null, old_serial_number?: string | null, price?: number | null, project_id: string, schedule_off_date?: string | null, schedule_on_date?: string | null, serial_number?: string | null, updated_at?: string | null, base_product: { __typename?: 'base_product', sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null } } | null };

export type GetUnitTagViewQueryVariables = Exact<{
  unitId: Scalars['String'];
}>;


export type GetUnitTagViewQuery = { __typename?: 'query_root', unit_tag_view: Array<{ __typename?: 'unit_tag_view', entity_id?: string | null, tag_path_id?: number | null }> };

export type GetUnitsQueryVariables = Exact<{
  where?: InputMaybe<Unit_Bool_Exp>;
}>;


export type GetUnitsQuery = { __typename?: 'query_root', unit: Array<{ __typename?: 'unit', id: string, serial_number?: string | null, old_serial_number?: string | null, base_product: { __typename?: 'base_product', sku?: string | null, product_tag?: { __typename?: 'tags', id: number } | null }, project: { __typename?: 'project', name: string, bloxProjectNumber?: string | null, customer: { __typename?: 'customer', name: string } } }> };

export type GetConversionDetailsQueryVariables = Exact<{
  _scopeId: Scalars['String'];
  _classificationId: Scalars['String'];
  _supplierId: Scalars['String'];
}>;


export type GetConversionDetailsQuery = { __typename?: 'query_root', uom_scope_by_pk?: { __typename?: 'uom_scope', description: string, id: string } | null, uom_classification_by_pk?: { __typename?: 'uom_classification', id: string, measurement: string, abbreviation?: string | null } | null, vendor_by_pk?: { __typename?: 'vendor', id: string, name: string } | null, manufacturer_by_pk?: { __typename?: 'manufacturer', id: string, name: string } | null };

export type UserPermissionsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserPermissionsQuery = { __typename?: 'query_root', user?: { __typename?: 'user', email: string, roles: Array<{ __typename?: 'user_role', role: { __typename?: 'role', name: string, role_permissions: Array<{ __typename?: 'role_permissions', permission: { __typename?: 'permissions', name: string } }> } }>, user_permissions: Array<{ __typename?: 'user_permissions', permission: { __typename?: 'permissions', name: string } }> } | null };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'query_root', permissions: Array<{ __typename?: 'permissions', id: string, name: string }>, role: Array<{ __typename?: 'role', id: string, name: string, role_permissions: Array<{ __typename?: 'role_permissions', permissionId: string }> }>, user: Array<{ __typename?: 'user', id: string, avatar?: string | null, first_name?: string | null, last_name?: string | null, email: string, roles: Array<{ __typename?: 'user_role', role: { __typename?: 'role', name: string, role_permissions: Array<{ __typename?: 'role_permissions', permission: { __typename?: 'permissions', name: string } }> } }>, user_permissions: Array<{ __typename?: 'user_permissions', permission: { __typename?: 'permissions', name: string } }> }> };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', email: string, avatar?: string | null, company?: string | null, id: string, profile?: Record<string, any> | null, first_name?: string | null, last_name?: string | null, roles: Array<{ __typename?: 'user_role', role: { __typename?: 'role', name: string, id: string, role_permissions: Array<{ __typename?: 'role_permissions', permission: { __typename?: 'permissions', name: string, id: string } }> } }>, user_permissions: Array<{ __typename?: 'user_permissions', permission: { __typename?: 'permissions', name: string, id: string } }> } | null, role: Array<{ __typename?: 'role', name: string, id: string, role_permissions: Array<{ __typename?: 'role_permissions', permission: { __typename?: 'permissions', id: string, name: string } }> }>, permissions: Array<{ __typename?: 'permissions', name: string, id: string }> };

export const BaseProductFieldsFragmentDoc = gql`
    fragment BaseProductFields on base_product {
  bom_tags(order_by: {tag: {sequence: asc}}) {
    tag {
      value
      name
      tag_type_id
      label
      id
    }
  }
  cms_data
  cms_id
  description
  designed_for
  id
  metadata
  product_type
  program_id
  sku
}
    `;
export const BomItemCommonFieldsFragmentDoc = gql`
    fragment BOMItemCommonFields on item_bom {
  id
  item_id
  quantity
  include_waste
}
    `;
export const BomItemFieldsFragmentDoc = gql`
    fragment BOMItemFields on item_bom {
  id
  item_id
  platform_id
  base_product_id
  choice_id
  project_id
  unit_id
  quantity
  include_waste
  metadata
}
    `;
export const TaggedBomItemFieldsFragmentDoc = gql`
    fragment TaggedBomItemFields on bom_item_tag_set {
  id
  entity_id
  tag_set_id
  quantity
  include_waste
}
    `;
export const BomPartFieldsFragmentDoc = gql`
    fragment BOMPartFields on part {
  partNumber
  imageUrl
  name
  id
  csiId
  csi {
    display_name
  }
  itemType
  purchaseType {
    name
  }
  status
  uomTakeOff {
    name
  }
  uomMaterial {
    name
  }
  conversionRateMaterial
  vendors(where: {preferred: {_eq: true}}) {
    vendor {
      name
    }
    leadTimeDays
    unitCost
  }
  wasteMaterial
}
    `;
export const TaggedBomFieldsFragmentFragmentDoc = gql`
    fragment TaggedBOMFieldsFragment on tagged_part_download_view {
  id
  tag_path
  tag_set_id
  tag_set_name
  bom_item_tag_set_id
  quantity
  part_number
  name
  include_waste
  waste_material
  csi_division
  preferred_supplier
  conversion_rate
  cost
  status
  item_type
  purchase_type
  image_url
  design_uom
  design_measure
  estimating_uom
  estimating_measure
  purchasing_uom
  purchasing_measure
  shipping_uom
  shipping_measure
  accounting_base_uom
  accounting_base_measure
}
    `;
export const LookupFieldsFragmentDoc = gql`
    fragment LookupFields on lookup {
  key: id
  type: source
  value: name
}
    `;
export const PlatformFieldsFragmentDoc = gql`
    fragment PlatformFields on platform {
  description
  derived_from
  id
  metadata
  name
  code
}
    `;
export const ProductOptionFieldsFragmentDoc = gql`
    fragment ProductOptionFields on product_option {
  allow_multiple
  description
  from_choice
  id
  name
}
    `;
export const ProductOptionChoiceFieldsFragmentDoc = gql`
    fragment ProductOptionChoiceFields on product_option_choice {
  bom_name
  code
  id
  is_default
  metadata
  name
}
    `;
export const ReportFieldsFragmentDoc = gql`
    fragment ReportFields on report {
  id
  name
  embed_url
  permission
}
    `;
export const PlatformRequirementFieldsFragmentDoc = gql`
    fragment PlatformRequirementFields on platform_requirement {
  description
  id
  name
  platform_id
  metadata
}
    `;
export const SupplierFieldsFragmentDoc = gql`
    fragment SupplierFields on vendor {
  buyerId
  id
  name
}
    `;
export const UnitFieldsFragmentDoc = gql`
    fragment UnitFields on unit {
  actual_off_date
  actual_on_date
  base_product_id
  created_at
  id
  old_project
  old_serial_number
  price
  project_id
  schedule_off_date
  schedule_on_date
  serial_number
  updated_at
  base_product {
    sku
    product_tag {
      id
    }
  }
}
    `;
export const GetBaseProductListDocument = gql`
    query getBaseProductList {
  base_products: base_product(where: {cms_id: {_is_null: false}}) {
    id
    sku
    cms_id
    title: cms_data(path: "$.title")
    description: cms_data(path: "$.description")
    platform {
      name
    }
    customer {
      id
      name
    }
    program {
      id
      name
    }
  }
}
    `;
export const VerifySerialNumberExistsDocument = gql`
    query verifySerialNumberExists($base_product_id: String = "") {
  serial_numbers_by_pk(base_product_id: $base_product_id) {
    next_serial
    base_product_id
  }
}
    `;
export const CreateSerialNumberForBaseProductIdDocument = gql`
    mutation createSerialNumberForBaseProductId($base_product_id: String = "") {
  insert_serial_numbers_one(
    object: {base_product_id: $base_product_id, next_serial: 0}
  ) {
    next_serial
    base_product_id
  }
}
    `;
export const IncrementNextSerialNumberByBaseProductIdDocument = gql`
    mutation incrementNextSerialNumberByBaseProductId($base_product_id: String! = "dj422") {
  update_serial_numbers_by_pk(
    pk_columns: {base_product_id: $base_product_id}
    _inc: {next_serial: 1}
  ) {
    base_product_id
    next_serial
  }
}
    `;
export const GetBaseProductsDocument = gql`
    query getBaseProducts($offset: Int = 0, $limit: Int = 50, $where: base_product_bool_exp = {}) {
  base_product_aggregate {
    aggregate {
      count
    }
  }
  base_product(limit: $limit, offset: $offset, where: $where) {
    ...BaseProductFields
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const GetBaseProductByIdDocument = gql`
    query getBaseProductById($id: String!) {
  base_product: base_product_by_pk(id: $id) {
    ...BaseProductFields
    program {
      name
    }
    products {
      sku
      id
    }
    product_options {
      name
      id
    }
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const InsertBaseProductDocument = gql`
    mutation insertBaseProduct($object: base_product_insert_input!) {
  insert_base_product_one(object: $object) {
    ...BaseProductFields
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const UpdateBaseProductDocument = gql`
    mutation updateBaseProduct($id: String!, $set: base_product_set_input!) {
  update_base_product_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...BaseProductFields
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const UpsertBaseProductDocument = gql`
    mutation upsertBaseProduct($object: base_product_insert_input!, $update_columns: [base_product_update_column!]!) {
  insert_base_product_one(
    object: $object
    on_conflict: {constraint: base_product_pkey, update_columns: $update_columns}
  ) {
    ...BaseProductFields
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const DeleteBaseProductDocument = gql`
    mutation deleteBaseProduct($id: String!) {
  delete_base_product_by_pk(id: $id) {
    ...BaseProductFields
  }
}
    ${BaseProductFieldsFragmentDoc}`;
export const GetAllBomOptionsBySkuDocument = gql`
    query getAllBOMOptionsBySku($sku: String!) {
  product_option_choice(
    where: {product_option: {base_product: {sku: {_eq: $sku}}}}
    order_by: [{product_option: {sort_order: asc}}, {sort_order: asc}]
  ) {
    id
    bom_name
    code
    name
    product_option {
      id
      name
      sort_order
      description
    }
    is_default
  }
}
    `;
export const GetUnitBomEntityDocument = gql`
    query getUnitBomEntity($unitid: String!) {
  unit_bom_entity_view(where: {unit_id: {_eq: $unitid}}) {
    include_waste
    quantity
    unit_id
    unit_bom_entity {
      ae_responsible
      buyer
      cogs_account
      conversion_rate
      cost
      csi_division
      cut_sheet_url
      est_daily_consumption
      finish_color
      image_url
      inventory_classification
      is_app_design_approved
      is_finance_approved
      is_in_accounting_system
      is_supply_chain_approved
      item_type
      location_name
      lot_size
      manufacturer
      manufacturer_part_number
      material
      material_issued_uom
      id
      weight
      waste_material
      warehouse_name
      type
      take_off_uom
      status
      standard_container_width
      standard_lead_time_days
      standard_container_height
      standard_container_length
      size
      searchable_key_words
      purchase_uom
      old_part_numbers
      part_number
      preferred_supplier
      preferred_supplier_part_number
      purchase_type
      name
      max_daily_consumption
      minimum_order_quantity
    }
    tag_set_names
    tag_path_ids
    tag_set_ids
    tag_set_quantities
  }
}
    `;
export const GetBomItemTagSetDocument = gql`
    query getBomItemTagSet($path: ltree_comparison_exp) {
  bom_item_tag_set(where: {tag_set: {tag_path: {path: $path}}}) {
    id
    entity_id
    tag_set_id
    tag_set {
      id
      selected_json
      name
      tag_path {
        id
        path
      }
    }
    quantity
    include_waste
  }
}
    `;
export const GetBomByPlatformAndSkuDocument = gql`
    query getBomByPlatformAndSku($platform: String!, $sku: String!) {
  platform(where: {code: {_eq: $platform}}) {
    id
    code
    name
    description
    parent {
      id
      name
      description
    }
  }
  base_product(where: {sku: {_eq: $sku}}) {
    id
    sku
    description
    platform_id
  }
  option: product_option(where: {base_product: {sku: {_eq: $sku}}}) {
    id
    name
    description
    base_product_id
  }
  choice: product_option_choice(
    where: {product_option: {base_product: {sku: {_eq: $sku}}}}
  ) {
    id
    name
    code
    product_option_id
  }
  platform_bom: item_bom(
    where: {platform: {code: {_eq: $platform}}}
    order_by: {item: {partNumber: asc}}
  ) {
    ...BOMItemCommonFields
    ref_id: platform_id
  }
  product_bom: item_bom(
    where: {base_product: {sku: {_eq: $sku}}}
    order_by: [{product_option_choice: {product_option: {name: asc}}}, {item: {partNumber: asc}}]
  ) {
    ...BOMItemCommonFields
    ref_id: base_product_id
  }
  choice_bom: item_bom(
    where: {product_option_choice: {product_option: {base_product: {sku: {_eq: $sku}}}}}
    order_by: {item: {partNumber: asc}}
  ) {
    ...BOMItemCommonFields
    ref_id: choice_id
  }
  item_count: part_aggregate(
    where: {_or: [{boms: {base_product: {sku: {_eq: $sku}}}}, {boms: {product_option_choice: {product_option: {base_product: {sku: {_eq: $sku}}}}}}]}
  ) {
    aggregate {
      count
    }
  }
  item: part(
    where: {_or: [{boms: {platform: {code: {_eq: $platform}}}}, {boms: {base_product: {sku: {_eq: $sku}}}}, {boms: {product_option_choice: {product_option: {base_product: {sku: {_eq: $sku}}}}}}]}
    order_by: {partNumber: asc}
  ) {
    ...BOMPartFields
  }
}
    ${BomItemCommonFieldsFragmentDoc}
${BomPartFieldsFragmentDoc}`;
export const GetBomByPlatformAndBaseProductDocument = gql`
    query getBomByPlatformAndBaseProduct($platformId: String!, $baseProductId: String!) {
  platform(where: {id: {_eq: $platformId}}) {
    id
    code
    name
    description
    parent {
      id
      name
      description
    }
  }
  base_product(where: {id: {_eq: $baseProductId}}) {
    id
    sku
    description
    platform_id
  }
  option: product_option(where: {base_product_id: {_eq: $baseProductId}}) {
    id
    name
    description
    base_product_id
  }
  choice: product_option_choice(
    where: {product_option: {base_product_id: {_eq: $baseProductId}}}
  ) {
    id
    name
    code
    product_option_id
  }
  platform_bom: item_bom(
    where: {platform_id: {_eq: $platformId}}
    order_by: {item: {partNumber: asc}}
  ) {
    ...BOMItemCommonFields
    ref_id: platform_id
  }
  product_bom: item_bom(
    where: {base_product_id: {_eq: $baseProductId}}
    order_by: [{product_option_choice: {product_option: {name: asc}}}, {item: {partNumber: asc}}]
  ) {
    ...BOMItemCommonFields
    ref_id: base_product_id
  }
  choice_bom: item_bom(
    where: {product_option_choice: {product_option: {base_product_id: {_eq: $baseProductId}}}}
    order_by: {item: {partNumber: asc}}
  ) {
    ...BOMItemCommonFields
    ref_id: choice_id
  }
  item_count: part_aggregate(
    where: {_or: [{boms: {base_product_id: {_eq: $baseProductId}}}, {boms: {product_option_choice: {product_option: {base_product_id: {_eq: $baseProductId}}}}}]}
  ) {
    aggregate {
      count
    }
  }
  item: part(
    where: {_or: [{boms: {platform_id: {_eq: $platformId}}}, {boms: {base_product_id: {_eq: $baseProductId}}}, {boms: {product_option_choice: {product_option: {base_product_id: {_eq: $baseProductId}}}}}]}
    order_by: {partNumber: asc}
  ) {
    ...BOMPartFields
  }
}
    ${BomItemCommonFieldsFragmentDoc}
${BomPartFieldsFragmentDoc}`;
export const GetBomAddPartAddionalInfoDocument = gql`
    query getBomAddPartAddionalInfo {
  part: part_by_pk(id: "part:cba28ab4-dcb2-4e40-929d-0aac5cb17771") {
    partNumber
    id
    uomTakeOff {
      name
    }
    uomMaterial {
      name
    }
    measures {
      id
      uom_conversion {
        description
      }
      uom_scope {
        description
      }
      measurement
    }
    conversionRateMaterial
    vendors(where: {preferred: {_eq: true}}) {
      vendor {
        name
      }
      unitCost
    }
  }
}
    `;
export const InsertItemBomDocument = gql`
    mutation insertItemBom($object: item_bom_insert_input!) {
  insert_item_bom_one(object: $object) {
    ...BOMItemFields
  }
}
    ${BomItemFieldsFragmentDoc}`;
export const UpdateItemBomDocument = gql`
    mutation updateItemBom($id: bigint!, $set: item_bom_set_input!) {
  update_item_bom_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...BOMItemFields
  }
}
    ${BomItemFieldsFragmentDoc}`;
export const UpsertItemBomDocument = gql`
    mutation upsertItemBom($object: item_bom_insert_input!, $update_columns: [item_bom_update_column!]!) {
  insert_item_bom_one(
    object: $object
    on_conflict: {constraint: item_bom_pkey, update_columns: $update_columns}
  ) {
    ...BOMItemFields
  }
}
    ${BomItemFieldsFragmentDoc}`;
export const InsertBomItemTagSetDocument = gql`
    mutation insertBomItemTagSet($object: bom_item_tag_set_insert_input!) {
  insert_bom_item_tag_set_one(object: $object) {
    ...TaggedBomItemFields
  }
}
    ${TaggedBomItemFieldsFragmentDoc}`;
export const UpdateBomItemTagSetDocument = gql`
    mutation updateBomItemTagSet($id: uuid!, $set: bom_item_tag_set_set_input!) {
  update_bom_item_tag_set_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...TaggedBomItemFields
  }
}
    ${TaggedBomItemFieldsFragmentDoc}`;
export const UpsertBomItemTagSetDocument = gql`
    mutation upsertBomItemTagSet($object: bom_item_tag_set_insert_input!, $update_columns: [bom_item_tag_set_update_column!]!) {
  insert_bom_item_tag_set_one(
    object: $object
    on_conflict: {constraint: bom_item_tag_set_pkey, update_columns: $update_columns}
  ) {
    ...TaggedBomItemFields
  }
}
    ${TaggedBomItemFieldsFragmentDoc}`;
export const DeleteBomItemTagSetDocument = gql`
    mutation deleteBomItemTagSet($id: uuid!) {
  delete_bom_item_tag_set_by_pk(id: $id) {
    ...TaggedBomItemFields
  }
}
    ${TaggedBomItemFieldsFragmentDoc}`;
export const SetUnitOptionChoicesDocument = gql`
    mutation setUnitOptionChoices($unit_id: String!, $objects: [unit_product_option_choice_insert_input!]!) {
  delete_unit_product_option_choice(where: {unit_id: {_eq: $unit_id}}) {
    affected_rows
  }
  insert_unit_product_option_choice(objects: $objects) {
    affected_rows
    returning {
      unit_id
      product_option_choice_id
    }
  }
}
    `;
export const DeleteItemBomDocument = gql`
    mutation deleteItemBom($id: bigint!) {
  delete_item_bom_by_pk(id: $id) {
    ...BOMItemFields
  }
}
    ${BomItemFieldsFragmentDoc}`;
export const AddUnitsToProjectDocument = gql`
    mutation AddUnitsToProject($units: [unit_insert_input!]!) {
  insert_unit(objects: $units) {
    affected_rows
  }
}
    `;
export const NextSerialNumberIncrementDocument = gql`
    mutation NextSerialNumberIncrement($base_product_id: String!, $quantity: numeric! = 1) {
  update_serial_numbers_by_pk(
    pk_columns: {base_product_id: $base_product_id}
    _inc: {next_serial: $quantity}
  ) {
    next_serial
  }
}
    `;
export const PartConversionByIdDocument = gql`
    query partConversionById($id: String!) {
  partConversion: part_by_pk(id: $id) {
    id
    partNumber
    uomTakeOff {
      name
    }
    conversionRateMaterial
    uomMaterial {
      name
    }
    vendors(where: {preferred: {_eq: true}}) {
      unitCost
    }
  }
}
    `;
export const GetPlatformAndProductlookupDocument = gql`
    query getPlatformAndProductlookup($platform: String! = "", $sku: String! = "") {
  products: lookup(where: {source: {_eq: "platform"}, name: {_eq: $platform}}) {
    code: name
    id
  }
  base_products: lookup(where: {source: {_eq: "base_product"}, name: {_eq: $sku}}) {
    sku: name
    id
  }
}
    `;
export const GetBomForTagPathWithAncestorsAndDescendantsDocument = gql`
    query getBomForTagPathWithAncestorsAndDescendants($path: ltree) {
  ancestors: tagged_part_download_view(
    where: {tag_path: {_ancestor: $path, _neq: $path}}
  ) {
    ...TaggedBOMFieldsFragment
  }
  ancestors_aggregage: tagged_part_download_view_aggregate(
    where: {tag_path: {_lt: $path, _neq: $path}}
  ) {
    aggregate {
      count
    }
  }
  current: tagged_part_download_view(where: {tag_path: {_eq: $path}}) {
    ...TaggedBOMFieldsFragment
  }
  current_aggregate: tagged_part_download_view_aggregate(
    where: {tag_path: {_eq: $path}}
  ) {
    aggregate {
      count
    }
  }
  descendants: tagged_part_download_view(
    where: {tag_path: {_descendant: $path, _neq: $path}}
  ) {
    ...TaggedBOMFieldsFragment
  }
  descendants_aggregate: tagged_part_download_view_aggregate(
    where: {tag_path: {_gt: $path, _neq: $path}}
  ) {
    aggregate {
      count
    }
  }
}
    ${TaggedBomFieldsFragmentFragmentDoc}`;
export const GetBomForTagPathWithAncestorsDocument = gql`
    query getBomForTagPathWithAncestors($path: ltree) {
  ancestors: tagged_part_download_view(
    where: {tag_path: {_ancestor: $path, _neq: $path}}
  ) {
    ...TaggedBOMFieldsFragment
  }
  ancestors_aggregage: tagged_part_download_view_aggregate(
    where: {tag_path: {_lt: $path, _neq: $path}}
  ) {
    aggregate {
      count
    }
  }
  current: tagged_part_download_view(where: {tag_path: {_eq: $path}}) {
    ...TaggedBOMFieldsFragment
  }
  current_aggregate: tagged_part_download_view_aggregate(
    where: {tag_path: {_eq: $path}}
  ) {
    aggregate {
      count
    }
  }
}
    ${TaggedBomFieldsFragmentFragmentDoc}`;
export const AllTagPathsDocument = gql`
    query allTagPaths {
  tags(order_by: {sequence: asc}) {
    tag_type_id
    id
    name
    label
    value
    sequence
  }
  tag_path {
    path
  }
}
    `;
export const GetTagPathTreeDocument = gql`
    query getTagPathTree {
  tag_set {
    id
    tag_path_id
    tag_path {
      path
    }
  }
  tag_path(order_by: {path: asc}) {
    id
    path
    tag_sets {
      id
    }
    path_segments(order_by: [{tag_type_sequence: asc}, {sort_order: asc}]) {
      segment
      tag_id
      tag_name
      tag_path_id
      tag_type_sequence
      tag_type_id: tag_type_value
      tag_type_value
      tag_value
      sort_order
    }
  }
}
    `;
export const PartIdsFromTagsDocument = gql`
    query partIdsFromTags($where: part_bool_exp) {
  part(where: $where) {
    id
    partNumber
    name
  }
}
    `;
export const TaggedPartsByIdsDocument = gql`
    query taggedPartsByIds($ids: [String!]!) {
  part_download_view(where: {id: {_in: $ids}}) {
    id
    part_number
    name
    take_off_uom
    waste_material
    csi_division
    preferred_supplier
    purchase_uom
    conversion_rate
    cost
    item_type
    purchase_type
    image_url
  }
}
    `;
export const GetWevrProjectBomDocument = gql`
    query getWEVRProjectBOM($id: String!) {
  projectBOM(id: $id) {
    project {
      id
      bloxProjectNumber
      program {
        name
      }
      name
    }
    projectNumber
    totalCost
    version
    asOfDate
    name
    items {
      item_id
      subTotalCost
      subTotalQuantity
      takeOffSubTotalQuantity
      item {
        take_off_uom
        purchase_uom
        part_number
        standard_lead_time_days
        image_url
        status
        name
        csi_division
        cost
      }
      more {
        sku
        skuSubTotalCost
        skuSubTotalQuantity
        skuTakeOffSubTotalQuantity
      }
    }
  }
}
    `;
export const GetProjectBomDocument = gql`
    query getProjectBOM($id: String!) {
  project: project_by_pk(id: $id) {
    id
    bloxProjectNumber
    name
    units {
      id
      base_product_id
      base_product {
        sku
        product_tag {
          id
        }
      }
      serial_number
      selected_tag_sets {
        tag_path_id
      }
      unit_bom {
        include_waste
        tag_path_ids
        quantity
        unit_bom_entity {
          part_number
          id
          cost
          status
          waste_material
          purchase_uom
          conversion_rate
        }
      }
    }
  }
}
    `;
export const GetCsiOptionsOnlyDocument = gql`
    query getCSIOptionsOnly {
  csi(order_by: {level1: asc, level2: asc, level3: asc}) {
    key: id
    label: display_name
  }
  uom(order_by: {name: asc}) {
    key: id
    label: name
  }
  program(order_by: {name: asc}) {
    key: name
    label: name
  }
  part_request_type {
    key: value
    label: description
  }
  part_request_reason {
    key: value
    label: description
  }
}
    `;
export const GetCustomersDocument = gql`
    query getCustomers {
  customer {
    name
    id
  }
}
    `;
export const GetDashboardQueryDocument = gql`
    query getDashboardQuery($startDate: timestamptz) {
  active_users: user_info_aggregate(where: {last_login: {_gt: $startDate}}) {
    aggregate {
      count
    }
  }
  new_parts: part_aggregate(where: {created_at: {_gt: $startDate}}) {
    aggregate {
      count
    }
  }
  part_request_cycle_time {
    interval
  }
  part_requests: part_request_aggregate(where: {created_at: {_gt: $startDate}}) {
    aggregate {
      count
    }
  }
  parts_by_stage: parts_workflow_counts_view(
    where: {workflow_stage: {_neq: "Inactive"}}
  ) {
    workflow_stage
    count
  }
  last_users: user_info(limit: 4, order_by: {last_login: desc_nulls_last}) {
    id
    first_name
    last_name
    email
    last_login
    login_count
    avatar
  }
}
    `;
export const GetPlatformDashboardQueryDocument = gql`
    query getPlatformDashboardQuery {
  active_parts: part_aggregate(where: {status: {_eq: ACTIVE}}) {
    aggregate {
      count
    }
  }
  inactive_parts: part_aggregate(where: {status: {_eq: INACTIVE}}) {
    aggregate {
      count
    }
  }
  graph_data: platform_utilization_view {
    current
    domain
    percent
    program
    total
  }
  platform_parts: tag_entity_aggregate(
    where: {tag: {tag_type_id: {_eq: "DOMAIN"}, value: {_eq: "Platform"}}}
  ) {
    aggregate {
      count
    }
  }
  total_parts: part_aggregate(where: {status: {_in: [ACTIVE, INACTIVE]}}) {
    aggregate {
      count
    }
  }
  number_requests: part_request_aggregate(where: {status: {_eq: "REQUESTED"}}) {
    aggregate {
      count
    }
  }
}
    `;
export const GetProjectGraphDocument = gql`
    query getProjectGraph($id: String!) {
  projectBOMGraph(id: $id) {
    nodes {
      typename
      id
      name
      properties
    }
    links {
      typename
      source
      target
      properties
    }
  }
}
    `;
export const GetUnitGraphDocument = gql`
    query getUnitGraph($id: String!) {
  unitBOMGraph(id: $id) {
    nodes {
      typename
      id
      name
      properties
    }
    links {
      typename
      source
      target
      properties
    }
  }
}
    `;
export const LookupsBySourceDocument = gql`
    query lookupsBySource($source: String!) {
  lookup(where: {source: {_eq: $source}}, order_by: {name: asc}) {
    ...LookupFields
  }
}
    ${LookupFieldsFragmentDoc}`;
export const MatappGetCsiDetailsDocument = gql`
    query matappGetCsiDetails($id: String!) {
  csi_by_pk(id: $id) {
    display_name
    level1
    level2
    level3
    application_engineer {
      email
    }
  }
}
    `;
export const MatappGetPartForSearchDocument = gql`
    query matappGetPartForSearch($id: String!) {
  search_parts_view(where: {id: {_eq: $id}}) {
    id
    objectID
    csi_level1
    csi_level2
    csi_level3
    description
    imageUrl
    manufacturer
    manufacturer_part_number
    name
    part_number
    part_number_histories
    status
    vendor
    approval_stage
    tagged_domains
    tagged_platforms
    tagged_products
    tagged_choices
    tagged_programs
    tagged_processes
    tags
    purchase_type
  }
}
    `;
export const MatappGetAllItemsForSearchDocument = gql`
    query matappGetAllItemsForSearch {
  search_parts_view {
    id
    objectID
    csi_level1
    csi_level2
    csi_level3
    description
    imageUrl
    manufacturer
    manufacturer_part_number
    name
    part_number
    part_number_histories
    status
    vendor
    approval_stage
    tagged_domains
    tagged_platforms
    tagged_products
    tagged_choices
    tagged_programs
    tagged_processes
    tags
    purchase_type
  }
  base_product(where: {cms_data: {_has_key: "sku"}}) {
    id
    sku
    platform {
      name
      parent {
        name
      }
    }
    program {
      name
    }
    cms_data
    description
  }
}
    `;
export const MatappGetPartNumberDocument = gql`
    query matappGetPartNumber($id: String!) {
  part_by_pk(id: $id) {
    id
    partNumber
  }
}
    `;
export const MatappGeneratePartNumberDocument = gql`
    mutation matappGeneratePartNumber {
  update_counters_by_pk(pk_columns: {id: 1}, _inc: {value: -1}) {
    value
  }
}
    `;
export const MatappRestorePartNumberCounterDocument = gql`
    mutation matappRestorePartNumberCounter($expected: Int!) {
  update_counters(
    where: {id: {_eq: 1}, value: {_eq: $expected}}
    _inc: {value: 1}
  ) {
    affected_rows
  }
}
    `;
export const MatappAssignPartNumberDocument = gql`
    mutation matappAssignPartNumber($partId: String!, $oldPartNumber: String!, $newPartNumber: String!) {
  update_part(
    where: {id: {_eq: $partId}, partNumber: {_eq: $oldPartNumber}}
    _set: {partNumber: $newPartNumber}
  ) {
    affected_rows
    returning {
      id
      partNumber
    }
  }
}
    `;
export const MatappAssignPartNumberToUnnumberedDocument = gql`
    mutation matappAssignPartNumberToUnnumbered($partId: String!, $newPartNumber: String!) {
  update_part(
    where: {id: {_eq: $partId}, _or: [{partNumber: {_is_null: true}}, {partNumber: {_eq: ""}}]}
    _set: {partNumber: $newPartNumber}
  ) {
    affected_rows
    returning {
      id
      partNumber
    }
  }
}
    `;
export const MatappGetPartNumberHistoryByOldNumberDocument = gql`
    query matappGetPartNumberHistoryByOldNumber($partId: String!, $oldPartNumber: String!) {
  part_number_history(
    where: {partId: {_eq: $partId}, old_part_number: {_eq: $oldPartNumber}}
    limit: 1
  ) {
    id
  }
}
    `;
export const MatappInsertPartNumberHistoryDocument = gql`
    mutation matappInsertPartNumberHistory($id: uuid!, $partId: String!, $oldPartNumber: String = "", $newPartNumber: String!) {
  insert_part_number_history_one(
    object: {id: $id, partId: $partId, new_part_number: $newPartNumber, old_part_number: $oldPartNumber}
    on_conflict: {constraint: part_number_history_pkey, update_columns: []}
  ) {
    id
  }
}
    `;
export const MatappInsertEmailsDocument = gql`
    mutation matappInsertEmails($objects: [emails_insert_input!]!) {
  insert_emails(
    objects: $objects
    on_conflict: {constraint: emails_pkey1, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      status
      subject
      text
    }
  }
}
    `;
export const MatappMarkEmailSentDocument = gql`
    mutation matappMarkEmailSent($id: uuid!, $claimedAt: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, claimed_at: {_eq: $claimedAt}, status: {_eq: "sending"}}
    _set: {status: "sent"}
  ) {
    affected_rows
  }
}
    `;
export const MatappMarkEmailFailedDocument = gql`
    mutation matappMarkEmailFailed($id: uuid!, $claimedAt: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, claimed_at: {_eq: $claimedAt}, status: {_eq: "sending"}}
    _set: {status: "failed"}
  ) {
    affected_rows
  }
}
    `;
export const MatappClaimEmailForSendDocument = gql`
    mutation matappClaimEmailForSend($id: uuid!, $claimedAt: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, _or: [{status: {_is_null: true}}, {status: {_nin: ["sent", "sending", "unconfirmed"]}}]}
    _set: {status: "sending", claimed_at: $claimedAt, send_attempted_at: null}
  ) {
    affected_rows
    returning {
      id
      subject
      text
      html
      to
    }
  }
}
    `;
export const MatappMarkEmailSendAttemptedDocument = gql`
    mutation matappMarkEmailSendAttempted($id: uuid!, $claimedAt: timestamptz!, $attemptedAt: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, status: {_eq: "sending"}, claimed_at: {_eq: $claimedAt}, send_attempted_at: {_is_null: true}}
    _set: {send_attempted_at: $attemptedAt}
  ) {
    affected_rows
  }
}
    `;
export const MatappStaleEmailClaimsDocument = gql`
    query matappStaleEmailClaims($cutoff: timestamptz!) {
  emails(
    where: {status: {_eq: "sending"}, _or: [{claimed_at: {_lt: $cutoff}}, {claimed_at: {_is_null: true}, created_at: {_lt: $cutoff}}]}
    order_by: {created_at: asc}
    limit: 50
  ) {
    id
    subject
    created_at
    claimed_at
    send_attempted_at
  }
}
    `;
export const MatappReclaimStaleEmailDocument = gql`
    mutation matappReclaimStaleEmail($id: uuid!, $cutoff: timestamptz!, $claimedAt: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, status: {_eq: "sending"}, send_attempted_at: {_is_null: true}, claimed_at: {_lt: $cutoff}}
    _set: {claimed_at: $claimedAt}
  ) {
    affected_rows
    returning {
      id
      subject
      text
      html
      to
    }
  }
}
    `;
export const MatappMarkEmailUnconfirmedDocument = gql`
    mutation matappMarkEmailUnconfirmed($id: uuid!, $cutoff: timestamptz!) {
  update_emails(
    where: {id: {_eq: $id}, status: {_eq: "sending"}, _or: [{send_attempted_at: {_is_null: false}, claimed_at: {_lt: $cutoff}}, {claimed_at: {_is_null: true}, created_at: {_lt: $cutoff}}]}
    _set: {status: "unconfirmed", claimed_at: null}
  ) {
    affected_rows
  }
}
    `;
export const MatappAddUserRoleDocument = gql`
    mutation matappAddUserRole($userId: String!, $roleId: String!) {
  insert_user_role(
    objects: [{userId: $userId, roleId: $roleId}]
    on_conflict: {constraint: user_role_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    `;
export const GetPartsToSyncDocument = gql`
    query getPartsToSync($until: timestamptz!) {
  part_sync(
    distinct_on: [part_identifier]
    where: {source_table_updated_at: {_lte: $until}, processed: {_eq: false}}
    order_by: {source_table_updated_at: desc, part_identifier: desc}
  ) {
    id
    operation
    part_identifier
    source_table
    source_table_updated_at
    source_table_updated_by
    processed
    processed_at
  }
}
    `;
export const InsertPartSyncDocument = gql`
    mutation insertPartSync($part: part_sync_insert_input!) {
  insert_part_sync_one(object: $part) {
    id
    operation
    part_identifier
    processed
    processed_at
    source_table
    source_table_updated_at
    source_table_updated_by
  }
}
    `;
export const CleanPartSyncDocument = gql`
    mutation cleanPartSync($until: timestamptz!) {
  delete_part_sync(where: {processed: {_eq: true}, processed_at: {_lte: $until}}) {
    affected_rows
  }
}
    `;
export const UpdatePartSyncEventCompleteDocument = gql`
    mutation updatePartSyncEventComplete($partIdentifier: String!, $at: timestamptz!, $until: timestamptz!) {
  update_part_sync(
    where: {part_identifier: {_eq: $partIdentifier}, processed: {_neq: true}, source_table_updated_at: {_lte: $until}}
    _set: {processed: true, processed_at: $at}
  ) {
    affected_rows
  }
}
    `;
export const GetPartForAirtableDocument = gql`
    query getPartForAirtable($id: String!) {
  part: part_by_pk(id: $id) {
    partNumber
    csi {
      title
      level1
      level2
      level3
    }
    name
    status
    conversionRateMaterial
    conversionRateCommodity
    part_number_histories {
      old_part_number
    }
    uomMaterial {
      name
    }
    uomTakeOff {
      name
    }
    uomCommodity {
      name
    }
    wasteMaterial
    purchaseType {
      name
    }
    measures {
      measurement
      description
      uom_scope_id
      uom_scope {
        description
      }
      uom_conversion {
        abbreviation
        description
      }
    }
  }
  preferredSupplier: vendor_parts(
    where: {partId: {_eq: $id}, preferred: {_eq: true}}
    order_by: [{updated_at: desc}, {created_at: desc}]
    limit: 1
  ) {
    vendor {
      name
      buyer {
        first_name
        last_name
      }
    }
    unitCost
    leadTimeDays
  }
  preferredManufacturer: manufacturer_parts(
    where: {partId: {_eq: $id}, preferred: {_eq: true}}
  ) {
    manufacturer {
      name
    }
    manufacturerPartNumber
  }
}
    `;
export const GetPartIdFromPartNumberDocument = gql`
    query getPartIdFromPartNumber($partNumbers: [String!]!) {
  part(where: {partNumber: {_in: $partNumbers}}) {
    id
  }
}
    `;
export const GetPartForKbbDocument = gql`
    query getPartForKbb($id: String!) {
  kbb_parts_view(where: {id: {_eq: $id}}) {
    part_cost
    part_custom_field_1
    part_custom_field_2
    part_description
    part_number
    part_unit_of_measurement
    part_weight
  }
}
    `;
export const GetExistingWareHouseDetailsForKbbLoopPullDocument = gql`
    query getExistingWareHouseDetailsForKbbLoopPull {
  part_warehouse_detail {
    id
    warehouse_name
    location_name
    part_number
  }
}
    `;
export const UpsertWareHouseDocument = gql`
    mutation upsertWareHouse($object: part_warehouse_detail_insert_input!) {
  insert_part_warehouse_detail_one(
    object: $object
    on_conflict: {constraint: part_warehouse_detail_pkey, update_columns: [part_number, warehouse_name, location_name, options]}
  ) {
    id
  }
}
    `;
export const GetPartFormOptionsDocument = gql`
    query getPartFormOptions {
  nextPartNum: counters_by_pk(id: 1) {
    nextPartNumber: value
  }
  item_type(order_by: {value: asc}) {
    key: value
    value: value
    label: description
  }
  part_status(order_by: {value: asc}) {
    key: value
    value
    label: description
  }
  purchase_type {
    key: id
    value: id
    label: name
  }
  manufacturer {
    key: id
    value: id
    label: name
  }
  vendor(order_by: {name: asc}) {
    key: id
    value: id
    label: name
    bcVendorNumber
  }
  uom(order_by: {name: asc}) {
    key: id
    value: id
    label: name
  }
  csi(order_by: {id: asc}) {
    key: id
    label: display_name
  }
}
    `;
export const GetUomScopesDocument = gql`
    query getUOMScopes {
  classifications: uom_classification(order_by: {measurement: asc}) {
    id
    measurement
    prefer_integer
    abbreviation
  }
  units: uom_conversion(order_by: {description: asc}) {
    id
    uom_classification_id
    description
  }
  scopes: uom_scope(order_by: {description: asc}) {
    id
    scope: description
  }
}
    `;
export const GetPartPublicationDetailsDocument = gql`
    query getPartPublicationDetails($where: part_bool_exp = {}) {
  part(where: $where) {
    purchaseType {
      name
      id
    }
    name
    description
    category
    finishColor
    imageUrl
    inventoryClassification
    material
    maxDailyConsumption
    partNumber
    size
    sourceUrl
    status
    itemType
    wasteMaterial
    id
    manufacturers {
      preferred
      manufacturerId
      manufacturerPartNumber
      manufacturer {
        name
      }
      cutSheetUrl
      container_depth
      container_height
      container_weight
      container_width
    }
    vendors {
      vendorId
      vendor {
        name
      }
      vendorPartNumber
      preferred
      leadTimeDays
      unitCost
      lotSize
      minOrderQuantity
    }
    warehouse_details {
      id
      location_name
      warehouse_name
    }
    measures {
      description
      uom_scope {
        description
      }
      measurement
      uom_conversion {
        abbreviation
        description
        quantity
        id
        uom_classification {
          measurement
          abbreviation
        }
      }
    }
    isApprovedByAppDesign
    isApprovedByFinance
    isApprovedBySupplyChain
    isInQuickBooks
    csi {
      id
      title
    }
    bom_tags {
      tag {
        id
        label
        name
        tag_type_id
        value
      }
    }
  }
}
    `;
export const GetPlatformsDocument = gql`
    query getPlatforms($offset: Int = 0, $limit: Int = 50, $where: platform_bool_exp = {}) {
  platform_aggregate {
    aggregate {
      count
    }
  }
  platform(limit: $limit, offset: $offset, where: $where) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const GetPlatformByIdDocument = gql`
    query getPlatformById($id: String!) {
  platform: platform_by_pk(id: $id) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const InsertPlatformDocument = gql`
    mutation insertPlatform($object: platform_insert_input!) {
  insert_platform_one(object: $object) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const UpdatePlatformDocument = gql`
    mutation updatePlatform($id: String!, $set: platform_set_input!) {
  update_platform_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const UpsertPlatformDocument = gql`
    mutation upsertPlatform($object: platform_insert_input!, $update_columns: [platform_update_column!]!) {
  insert_platform_one(
    object: $object
    on_conflict: {constraint: platform_pkey, update_columns: $update_columns}
  ) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const DeletePlatformDocument = gql`
    mutation deletePlatform($id: String!) {
  delete_platform_by_pk(id: $id) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export const GetPlatformAsDesignedDocument = gql`
    query getPlatformAsDesigned($where: platform_bool_exp = {}) {
  platform(
    where: $where
    order_by: {id: asc, derived_from: asc_nulls_first, name: asc}
  ) {
    code
    id
    name
    derived_from
    base_products(order_by: {sku: asc}) {
      id
      sku
      product_options(order_by: {from_choice: asc_nulls_first}) {
        id
        name
        sort_order
        from_choice
        allow_multiple
        product_option_choices {
          bom_name
          code
          id
          is_default
          name
          sort_order
        }
      }
    }
  }
}
    `;
export const GetLoomByPlatformAndSkuDocument = gql`
    query getLoomByPlatformAndSku($sku: base_product_bool_exp = {}, $platform: platform_bool_exp = {}) {
  platform(where: $platform, order_by: {derived_from: asc_nulls_first}) {
    __typename
    name
    id
    code
    items_aggregate {
      aggregate {
        count
      }
    }
    items(order_by: {item: {partNumber: asc}}) {
      __typename
      id
      quantity
      include_waste
      item {
        __typename
        id
        partNumber
        imageUrl
        name
        status
        csi {
          __typename
          display_name
        }
        uomTakeOffId
        uomTakeOff {
          name
        }
        uomMaterialId
        uomMaterial {
          name
        }
        conversionRateMaterial
      }
    }
    parent {
      __typename
      name
      id
    }
    base_products(where: $sku) {
      __typename
      sku
      id
      items_aggregate {
        aggregate {
          count
        }
      }
      items(order_by: {item: {partNumber: asc}}) {
        __typename
        id
        quantity
        include_waste
        item {
          __typename
          id
          partNumber
          imageUrl
          name
          status
          csi {
            __typename
            display_name
          }
          uomTakeOffId
          uomTakeOff {
            name
          }
          uomMaterialId
          uomMaterial {
            name
          }
          conversionRateMaterial
        }
      }
      product_options {
        __typename
        name
        id
        sort_order
        product_option_choices {
          __typename
          id
          name
          sort_order
          items_aggregate {
            aggregate {
              count
            }
          }
          items(order_by: {item: {partNumber: asc}}) {
            __typename
            id
            quantity
            include_waste
            item {
              __typename
              id
              partNumber
              imageUrl
              name
              status
              csi {
                __typename
                display_name
              }
              uomTakeOffId
              uomTakeOff {
                name
              }
              uomMaterialId
              uomMaterial {
                name
              }
              conversionRateMaterial
            }
          }
        }
      }
    }
  }
}
    `;
export const GetProductOptionsDocument = gql`
    query getProductOptions($offset: Int = 0, $limit: Int = 50, $where: product_option_bool_exp = {}) {
  product_option_aggregate {
    aggregate {
      count
    }
  }
  product_option(limit: $limit, offset: $offset, where: $where) {
    ...ProductOptionFields
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const GetProductOptionByIdDocument = gql`
    query getProductOptionById($id: String!) {
  product_option: product_option_by_pk(id: $id) {
    ...ProductOptionFields
    base_product {
      id
      sku
      product_tag {
        id
      }
    }
    platform_requirement {
      name
      id
    }
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const InsertProductOptionDocument = gql`
    mutation insertProductOption($object: product_option_insert_input!) {
  insert_product_option_one(object: $object) {
    ...ProductOptionFields
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const UpdateProductOptionDocument = gql`
    mutation updateProductOption($id: String!, $set: product_option_set_input!) {
  update_product_option_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...ProductOptionFields
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const UpsertProductOptionDocument = gql`
    mutation upsertProductOption($object: product_option_insert_input!, $update_columns: [product_option_update_column!]!) {
  insert_product_option_one(
    object: $object
    on_conflict: {constraint: product_option_pkey, update_columns: $update_columns}
  ) {
    ...ProductOptionFields
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const DeleteProductOptionDocument = gql`
    mutation deleteProductOption($id: String!) {
  delete_product_option_by_pk(id: $id) {
    ...ProductOptionFields
  }
}
    ${ProductOptionFieldsFragmentDoc}`;
export const GetProductOptionChoicesDocument = gql`
    query getProductOptionChoices($offset: Int = 0, $limit: Int = 50, $where: product_option_choice_bool_exp = {}) {
  product_option_choice_aggregate {
    aggregate {
      count
    }
  }
  product_option_choice(limit: $limit, offset: $offset, where: $where) {
    ...ProductOptionChoiceFields
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const GetProductOptionChoiceByIdDocument = gql`
    query getProductOptionChoiceById($id: String!) {
  product_option_choice: product_option_choice_by_pk(id: $id) {
    ...ProductOptionChoiceFields
    product_option {
      id
      name
    }
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const InsertProductOptionChoiceDocument = gql`
    mutation insertProductOptionChoice($setDefaultWhere: product_option_choice_bool_exp!, $object: product_option_choice_insert_input!) {
  update_product_option_choice(_set: {is_default: false}, where: $setDefaultWhere) {
    affected_rows
  }
  insert_product_option_choice_one(object: $object) {
    ...ProductOptionChoiceFields
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const UpdateProductOptionChoiceDocument = gql`
    mutation updateProductOptionChoice($id: String!, $set: product_option_choice_set_input!) {
  update_product_option_choice_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...ProductOptionChoiceFields
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const UpsertProductOptionChoiceDocument = gql`
    mutation upsertProductOptionChoice($object: product_option_choice_insert_input!, $update_columns: [product_option_choice_update_column!]!) {
  insert_product_option_choice_one(
    object: $object
    on_conflict: {constraint: product_option_choice_pkey, update_columns: $update_columns}
  ) {
    ...ProductOptionChoiceFields
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const DeleteProductOptionChoiceDocument = gql`
    mutation deleteProductOptionChoice($id: String!) {
  delete_product_option_choice_by_pk(id: $id) {
    ...ProductOptionChoiceFields
  }
}
    ${ProductOptionChoiceFieldsFragmentDoc}`;
export const GetProjectsDocument = gql`
    query getProjects {
  project {
    id
    name
    bloxProjectNumber
    statusId
    city
    state
    year
    status {
      name
    }
    customer {
      name
      id
    }
    customerId
  }
  project_status {
    name
  }
  customer {
    name
  }
}
    `;
export const GetProjectOptionsByBaseProductDocument = gql`
    query getProjectOptionsByBaseProduct($baseProduct: String!, $unitId: String!) {
  base_product: base_product_by_pk(id: $baseProduct) {
    id
    sku
    bom_tags(
      where: {tag: {tag_type_id: {_eq: "CHOICE"}}}
      order_by: {tag: {sequence: asc}}
    ) {
      tag {
        id
        name
        notes
        value
        label
        tag_type_id
        sequence
        entities(where: {entity_id: {_eq: $unitId}}) {
          entity_id
          tag_id
        }
      }
    }
  }
}
    `;
export const SetSelectedUnitOptionsDocument = gql`
    mutation setSelectedUnitOptions($unit_id: String, $tags: [tag_entity_insert_input!]!) {
  delete_tag_entity(where: {entity_id: {_eq: $unit_id}}) {
    returning {
      id
      tag_id
      entity_id
    }
  }
  insert_tag_entity(objects: $tags) {
    returning {
      id
      tag_id
      entity_id
    }
  }
}
    `;
export const GetProjectByIdDocument = gql`
    query getProjectById($id: String!) {
  project: project_by_pk(id: $id) {
    bloxApproved
    bloxProjectNumber
    city
    comments
    id
    name
    postalCode
    state
    customerId
    statusId
    status {
      name
    }
    customer {
      name
      id
    }
    type
    year
    options
    units(order_by: [{base_product: {sku: asc}}, {serial_number: asc}]) {
      serial_number
      old_serial_number
      id
      base_product {
        id
        sku
        bom_tags_aggregate(where: {tag: {tag_type_id: {_eq: "CHOICE"}}}) {
          aggregate {
            count
          }
        }
      }
      tags(order_by: [{tag: {sequence: asc}}]) {
        tag {
          id
          name
          sequence
          label
          value
          tag_type_id
          notes
        }
      }
    }
    base_product_quantities {
      base_product_id
      quantity
      base_product {
        sku
      }
    }
  }
}
    `;
export const GetReportsDocument = gql`
    query getReports($offset: Int = 0, $limit: Int = 20, $where: report_bool_exp = {}) {
  reports: report {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const GetReportByIdDocument = gql`
    query getReportById($id: String!) {
  report: report_by_pk(id: $id) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const InsertReportDocument = gql`
    mutation insertReport($object: report_insert_input!) {
  insert_report_one(object: $object) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const UpdateReportDocument = gql`
    mutation updateReport($id: String!, $set: report_set_input!) {
  update_report_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const UpsertReportDocument = gql`
    mutation upsertReport($object: report_insert_input!, $update_columns: [report_update_column!]!) {
  insert_report_one(
    object: $object
    on_conflict: {constraint: report_pkey, update_columns: $update_columns}
  ) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const DeleteReportDocument = gql`
    mutation deleteReport($id: String!) {
  delete_report_by_pk(id: $id) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export const GetPlatformRequirementsDocument = gql`
    query getPlatformRequirements($offset: Int = 0, $limit: Int = 50, $where: platform_requirement_bool_exp = {}) {
  platform_requirement_aggregate {
    aggregate {
      count
    }
  }
  platform_requirement(limit: $limit, offset: $offset, where: $where) {
    ...PlatformRequirementFields
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const GetPlatformRequirementByIdDocument = gql`
    query getPlatformRequirementById($id: String!) {
  platform_requirement: platform_requirement_by_pk(id: $id) {
    ...PlatformRequirementFields
    fulfilled_by {
      id
      name
    }
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const InsertPlatformRequirementDocument = gql`
    mutation insertPlatformRequirement($object: platform_requirement_insert_input!) {
  insert_platform_requirement_one(object: $object) {
    ...PlatformRequirementFields
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const UpdatePlatformRequirementDocument = gql`
    mutation updatePlatformRequirement($id: String!, $set: platform_requirement_set_input!) {
  update_platform_requirement_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...PlatformRequirementFields
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const UpsertPlatformRequirementDocument = gql`
    mutation upsertPlatformRequirement($object: platform_requirement_insert_input!, $update_columns: [platform_requirement_update_column!]!) {
  insert_platform_requirement_one(
    object: $object
    on_conflict: {constraint: platform_requirement_pkey, update_columns: $update_columns}
  ) {
    ...PlatformRequirementFields
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const DeletePlatformRequirementDocument = gql`
    mutation deletePlatformRequirement($id: String!) {
  delete_platform_requirement_by_pk(id: $id) {
    ...PlatformRequirementFields
  }
}
    ${PlatformRequirementFieldsFragmentDoc}`;
export const GetShortLinksDocument = gql`
    query getShortLinks {
  short_url(order_by: {updated_at: desc}) {
    id
    url
    slug
    active
    qrcode_url
    clicks
    name
    description
    link_tags
  }
}
    `;
export const AddShortLinkDocument = gql`
    mutation addShortLink($object: short_url_insert_input!) {
  insert_short_url_one(object: $object) {
    id
    slug
    url
    active
    qrcode_url
    clicks
    name
    description
    link_tags
  }
}
    `;
export const EditShortLinkDocument = gql`
    mutation editShortLink($id: Int!, $object: short_url_set_input!) {
  update_short_url_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    slug
    url
    active
    qrcode_url
    clicks
    name
    description
    link_tags
  }
}
    `;
export const UpdateShortLinkUrlDocument = gql`
    mutation updateShortLinkUrl($id: Int!, $url: String!) {
  update_short_url_by_pk(pk_columns: {id: $id}, _set: {url: $url}) {
    id
    url
    slug
    active
    qrcode_url
    clicks
    name
    description
    link_tags
  }
}
    `;
export const LongUrlFromSlugDocument = gql`
    mutation longUrlFromSlug($slug: String!) {
  update_short_url(where: {slug: {_eq: $slug}}, _inc: {clicks: 1}) {
    returning {
      url
      slug
      clicks
    }
  }
}
    `;
export const GetSuppliersDocument = gql`
    query getSuppliers($offset: Int = 0, $limit: Int = 50, $where: vendor_bool_exp = {}, $orderBy: [vendor_order_by!] = null) {
  supplier_aggregate: vendor_aggregate(where: $where) {
    aggregate {
      count
    }
  }
  supplier: vendor(
    limit: $limit
    offset: $offset
    where: $where
    order_by: $orderBy
  ) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const GetSupplierByIdDocument = gql`
    query getSupplierById($id: String!) {
  supplier: vendor_by_pk(id: $id) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const InsertSupplierDocument = gql`
    mutation insertSupplier($object: vendor_insert_input!) {
  insert_vendor_one(object: $object) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const UpdateSupplierDocument = gql`
    mutation updateSupplier($id: String!, $set: vendor_set_input!) {
  update_vendor_by_pk(_set: $set, pk_columns: {id: $id}) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const UpsertSupplierDocument = gql`
    mutation upsertSupplier($object: vendor_insert_input!, $update_columns: [vendor_update_column!]!) {
  insert_vendor_one(
    object: $object
    on_conflict: {constraint: vendor_pkey, update_columns: $update_columns}
  ) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const DeleteSupplierDocument = gql`
    mutation deleteSupplier($id: String!) {
  delete_vendor_by_pk(id: $id) {
    ...SupplierFields
  }
}
    ${SupplierFieldsFragmentDoc}`;
export const GetAllTagTypesDocument = gql`
    query getAllTagTypes {
  tag_type {
    id: value
    value
    description
  }
}
    `;
export const CreateTagTypeDocument = gql`
    mutation createTagType($input: tag_type_insert_input!) {
  tag_type: insert_tag_type_one(object: $input) {
    value
    description
  }
}
    `;
export const GetAllTagsDocument = gql`
    query getAllTags {
  tag_type {
    id: value
    value
    description
  }
  tags(order_by: {sequence: asc}) {
    id
    tag_type_id
    name
    value
    label
    sequence
  }
}
    `;
export const GetTagByIdDocument = gql`
    query getTagById($id: Int!) {
  tag: tags_by_pk(id: $id) {
    id
    name
    value
    label
    notes
    sequence
    tag_type_id
    updated_at
    updated_by
    related_entity
    created_at
    created_by
  }
}
    `;
export const GetTagByIdListDocument = gql`
    query getTagByIdList($ids: [Int!]) {
  tags(where: {id: {_in: $ids}}, order_by: {sequence: asc}) {
    label
    name
    value
    tag_type_id
    sequence
    id
  }
}
    `;
export const TagEntityDocument = gql`
    mutation tagEntity($objects: [tag_entity_insert_input!]!) {
  insert_tag_entity(objects: $objects) {
    affected_rows
    returning {
      id
      tag_id
      entity_id
    }
  }
}
    `;
export const DeleteTagEntityDocument = gql`
    mutation deleteTagEntity($tag_id: Int!, $entity_id: String!) {
  delete_tag_entity(where: {tag_id: {_eq: $tag_id}, entity_id: {_eq: $entity_id}}) {
    affected_rows
  }
}
    `;
export const DeleteTagEntityByIdDocument = gql`
    mutation deleteTagEntityById($id: Int!) {
  delete_tag_entity_by_pk(id: $id) {
    id
    tag_id
    entity_id
  }
}
    `;
export const InsertTagPathDocument = gql`
    mutation insertTagPath($path: ltree!) {
  insert_tag_path_one(object: {path: $path}) {
    id
    path
  }
}
    `;
export const GetOptionTagsForBaseProductBySkuDocument = gql`
    query getOptionTagsForBaseProductBySku($sku: String!) {
  base_product(where: {sku: {_eq: $sku}}) {
    sku
    id
    bom_tags(
      where: {tag: {tag_type_id: {_eq: "CHOICE"}}}
      order_by: {tag: {sequence: asc}}
    ) {
      tag {
        id
        name
        label
        tag_type_id
        sequence
        value
      }
    }
  }
}
    `;
export const InsertTagSetFromPathDocument = gql`
    mutation insertTagSetFromPath($path: ltree!) {
  insert_tag_set_one(object: {tag_path: {data: {path: $path}}}) {
    id
  }
}
    `;
export const GetAllTagSetsDocument = gql`
    query getAllTagSets {
  tag_set {
    id
    tag_path {
      path
    }
  }
}
    `;
export const GetTagSetByIdDocument = gql`
    query getTagSetById($tag_set_id: uuid!) {
  tag_set: tag_set_by_pk(id: $tag_set_id) {
    id
    tag_path {
      id
      path
    }
  }
}
    `;
export const GetTagPathSegmentViewQueryDocument = gql`
    query getTagPathSegmentViewQuery($tag_path_id: Int) {
  tag_path_segment_view(where: {tag_path_id: {_eq: $tag_path_id}}) {
    segment
    sort_order
    tag_id
    tag_name
    tag_path
    tag_path_id
    tag_type_sequence
    tag_type_value
    tag_value
  }
}
    `;
export const GetUnitDetailsWithBomDocument = gql`
    query getUnitDetailsWithBom($unitId: String!) {
  unit: unit_by_pk(id: $unitId) {
    id
    serial_number
    base_product {
      id
      sku
      description
      metadata
      product_type
      platform {
        code
        id
        name
        metadata
        description
        created_at
        derived_from
        updated_at
      }
      created_at
      updated_at
      program {
        created_at
        created_by
        description
        id
        imageUrl
        name
        updated_at
        updated_by
      }
    }
    project {
      id
      bloxApproved
      bloxProjectNumber
      city
      comments
      created_at
      created_by
      customerId
      customer {
        name
      }
      name
      options
      postalCode
      price
      state
      programId
      type
      statusId
      year
    }
    schedule_on_date
    schedule_off_date
    price
    old_project
    old_serial_number
    created_at
    actual_off_date
    actual_on_date
  }
  bom: unitBOM(id: $unitId) {
    asOfDate
    id
    serial_number
    old_serial_number
    totalCost
    version
    items {
      item {
        id
        part_number
        name
        old_part_numbers
        csi_division
        take_off_uom
        purchase_uom
        status
        cost
        conversion_rate
        ae_responsible
        buyer
        cogs_account
        cut_sheet_url
        image_url
        inventory_classification
        item_type
        location_name
        lot_size
        manufacturer
        manufacturer_part_number
        material
        material_issued_uom
        max_daily_consumption
        minimum_order_quantity
        preferred_supplier
        preferred_supplier_part_number
        purchase_type
        size
        standard_lead_time_days
        type
        waste_material
        weight
      }
      row_id
      tagpathid
      cost
      include_waste
      item_id
      level
      quantity
      take_off_quantity
      row_id
    }
  }
}
    `;
export const UpdateUnitByIdDocument = gql`
    mutation updateUnitById($id: String!, $set: unit_set_input) {
  update_unit_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...UnitFields
  }
}
    ${UnitFieldsFragmentDoc}`;
export const AssignSerialNumberDocument = gql`
    mutation assignSerialNumber($serial_number: String = "", $id: String = "") {
  update_unit_by_pk(pk_columns: {id: $id}, _set: {serial_number: $serial_number}) {
    id
    serial_number
    base_product_id
  }
}
    `;
export const GetUnitByIdDocument = gql`
    query getUnitById($id: String = "") {
  unit_by_pk(id: $id) {
    ...UnitFields
  }
}
    ${UnitFieldsFragmentDoc}`;
export const GetUnitTagViewDocument = gql`
    query getUnitTagView($unitId: String!) {
  unit_tag_view(where: {entity_id: {_eq: $unitId}}) {
    entity_id
    tag_path_id
  }
}
    `;
export const GetUnitsDocument = gql`
    query getUnits($where: unit_bool_exp) {
  unit(where: $where, order_by: {serial_number: asc}) {
    id
    serial_number
    base_product {
      sku
      product_tag {
        id
      }
    }
    old_serial_number
    project {
      name
      customer {
        name
      }
      bloxProjectNumber
    }
  }
}
    `;
export const GetConversionDetailsDocument = gql`
    query GetConversionDetails($_scopeId: String!, $_classificationId: String!, $_supplierId: String!) {
  uom_scope_by_pk(id: $_scopeId) {
    description
    id
  }
  uom_classification_by_pk(id: $_classificationId) {
    id
    measurement
    abbreviation
  }
  vendor_by_pk(id: $_supplierId) {
    id
    name
  }
  manufacturer_by_pk(id: $_supplierId) {
    id
    name
  }
}
    `;
export const UserPermissionsDocument = gql`
    query userPermissions($id: String!) {
  user: user_by_pk(id: $id) {
    email
    roles {
      role {
        name
        role_permissions {
          permission {
            name
          }
        }
      }
    }
    user_permissions {
      permission {
        name
      }
    }
  }
}
    `;
export const GetAllUsersDocument = gql`
    query getAllUsers {
  permissions {
    id
    name
  }
  role {
    id
    name
    role_permissions {
      permissionId
    }
  }
  user(order_by: {email: asc}) {
    id
    avatar
    first_name
    last_name
    email
    roles {
      role {
        name
        role_permissions {
          permission {
            name
          }
        }
      }
    }
    user_permissions {
      permission {
        name
      }
    }
  }
}
    `;
export const GetUserByIdDocument = gql`
    query getUserById($id: String!) {
  user_by_pk(id: $id) {
    email
    avatar
    company
    id
    profile
    first_name
    last_name
    roles {
      role {
        name
        id
        role_permissions {
          permission {
            name
            id
          }
        }
      }
    }
    user_permissions {
      permission {
        name
        id
      }
    }
  }
  role {
    name
    id
    role_permissions {
      permission {
        id
        name
      }
    }
  }
  permissions {
    name
    id
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getBaseProductList(variables?: GetBaseProductListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBaseProductListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBaseProductListQuery>(GetBaseProductListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBaseProductList', 'query');
    },
    verifySerialNumberExists(variables?: VerifySerialNumberExistsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<VerifySerialNumberExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifySerialNumberExistsQuery>(VerifySerialNumberExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verifySerialNumberExists', 'query');
    },
    createSerialNumberForBaseProductId(variables?: CreateSerialNumberForBaseProductIdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateSerialNumberForBaseProductIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateSerialNumberForBaseProductIdMutation>(CreateSerialNumberForBaseProductIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createSerialNumberForBaseProductId', 'mutation');
    },
    incrementNextSerialNumberByBaseProductId(variables?: IncrementNextSerialNumberByBaseProductIdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<IncrementNextSerialNumberByBaseProductIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<IncrementNextSerialNumberByBaseProductIdMutation>(IncrementNextSerialNumberByBaseProductIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'incrementNextSerialNumberByBaseProductId', 'mutation');
    },
    getBaseProducts(variables?: GetBaseProductsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBaseProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBaseProductsQuery>(GetBaseProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBaseProducts', 'query');
    },
    getBaseProductById(variables: GetBaseProductByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBaseProductByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBaseProductByIdQuery>(GetBaseProductByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBaseProductById', 'query');
    },
    insertBaseProduct(variables: InsertBaseProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertBaseProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertBaseProductMutation>(InsertBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertBaseProduct', 'mutation');
    },
    updateBaseProduct(variables: UpdateBaseProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBaseProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBaseProductMutation>(UpdateBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBaseProduct', 'mutation');
    },
    upsertBaseProduct(variables: UpsertBaseProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertBaseProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertBaseProductMutation>(UpsertBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertBaseProduct', 'mutation');
    },
    deleteBaseProduct(variables: DeleteBaseProductMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteBaseProductMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteBaseProductMutation>(DeleteBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteBaseProduct', 'mutation');
    },
    getAllBOMOptionsBySku(variables: GetAllBomOptionsBySkuQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllBomOptionsBySkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllBomOptionsBySkuQuery>(GetAllBomOptionsBySkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllBOMOptionsBySku', 'query');
    },
    getUnitBomEntity(variables: GetUnitBomEntityQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitBomEntityQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitBomEntityQuery>(GetUnitBomEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnitBomEntity', 'query');
    },
    getBomItemTagSet(variables?: GetBomItemTagSetQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomItemTagSetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomItemTagSetQuery>(GetBomItemTagSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomItemTagSet', 'query');
    },
    getBomByPlatformAndSku(variables: GetBomByPlatformAndSkuQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomByPlatformAndSkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomByPlatformAndSkuQuery>(GetBomByPlatformAndSkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomByPlatformAndSku', 'query');
    },
    getBomByPlatformAndBaseProduct(variables: GetBomByPlatformAndBaseProductQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomByPlatformAndBaseProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomByPlatformAndBaseProductQuery>(GetBomByPlatformAndBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomByPlatformAndBaseProduct', 'query');
    },
    getBomAddPartAddionalInfo(variables?: GetBomAddPartAddionalInfoQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomAddPartAddionalInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomAddPartAddionalInfoQuery>(GetBomAddPartAddionalInfoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomAddPartAddionalInfo', 'query');
    },
    insertItemBom(variables: InsertItemBomMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertItemBomMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertItemBomMutation>(InsertItemBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertItemBom', 'mutation');
    },
    updateItemBom(variables: UpdateItemBomMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateItemBomMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateItemBomMutation>(UpdateItemBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateItemBom', 'mutation');
    },
    upsertItemBom(variables: UpsertItemBomMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertItemBomMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertItemBomMutation>(UpsertItemBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertItemBom', 'mutation');
    },
    insertBomItemTagSet(variables: InsertBomItemTagSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertBomItemTagSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertBomItemTagSetMutation>(InsertBomItemTagSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertBomItemTagSet', 'mutation');
    },
    updateBomItemTagSet(variables: UpdateBomItemTagSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateBomItemTagSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBomItemTagSetMutation>(UpdateBomItemTagSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateBomItemTagSet', 'mutation');
    },
    upsertBomItemTagSet(variables: UpsertBomItemTagSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertBomItemTagSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertBomItemTagSetMutation>(UpsertBomItemTagSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertBomItemTagSet', 'mutation');
    },
    deleteBomItemTagSet(variables: DeleteBomItemTagSetMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteBomItemTagSetMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteBomItemTagSetMutation>(DeleteBomItemTagSetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteBomItemTagSet', 'mutation');
    },
    setUnitOptionChoices(variables: SetUnitOptionChoicesMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetUnitOptionChoicesMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetUnitOptionChoicesMutation>(SetUnitOptionChoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setUnitOptionChoices', 'mutation');
    },
    deleteItemBom(variables: DeleteItemBomMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteItemBomMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteItemBomMutation>(DeleteItemBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteItemBom', 'mutation');
    },
    AddUnitsToProject(variables: AddUnitsToProjectMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddUnitsToProjectMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddUnitsToProjectMutation>(AddUnitsToProjectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddUnitsToProject', 'mutation');
    },
    NextSerialNumberIncrement(variables: NextSerialNumberIncrementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<NextSerialNumberIncrementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NextSerialNumberIncrementMutation>(NextSerialNumberIncrementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NextSerialNumberIncrement', 'mutation');
    },
    partConversionById(variables: PartConversionByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PartConversionByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartConversionByIdQuery>(PartConversionByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'partConversionById', 'query');
    },
    getPlatformAndProductlookup(variables?: GetPlatformAndProductlookupQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformAndProductlookupQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformAndProductlookupQuery>(GetPlatformAndProductlookupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformAndProductlookup', 'query');
    },
    getBomForTagPathWithAncestorsAndDescendants(variables?: GetBomForTagPathWithAncestorsAndDescendantsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomForTagPathWithAncestorsAndDescendantsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomForTagPathWithAncestorsAndDescendantsQuery>(GetBomForTagPathWithAncestorsAndDescendantsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomForTagPathWithAncestorsAndDescendants', 'query');
    },
    getBomForTagPathWithAncestors(variables?: GetBomForTagPathWithAncestorsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetBomForTagPathWithAncestorsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetBomForTagPathWithAncestorsQuery>(GetBomForTagPathWithAncestorsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getBomForTagPathWithAncestors', 'query');
    },
    allTagPaths(variables?: AllTagPathsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AllTagPathsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllTagPathsQuery>(AllTagPathsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allTagPaths', 'query');
    },
    getTagPathTree(variables?: GetTagPathTreeQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTagPathTreeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagPathTreeQuery>(GetTagPathTreeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTagPathTree', 'query');
    },
    partIdsFromTags(variables?: PartIdsFromTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<PartIdsFromTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartIdsFromTagsQuery>(PartIdsFromTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'partIdsFromTags', 'query');
    },
    taggedPartsByIds(variables: TaggedPartsByIdsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TaggedPartsByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TaggedPartsByIdsQuery>(TaggedPartsByIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taggedPartsByIds', 'query');
    },
    getWEVRProjectBOM(variables: GetWevrProjectBomQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetWevrProjectBomQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetWevrProjectBomQuery>(GetWevrProjectBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getWEVRProjectBOM', 'query');
    },
    getProjectBOM(variables: GetProjectBomQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectBomQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectBomQuery>(GetProjectBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectBOM', 'query');
    },
    getCSIOptionsOnly(variables?: GetCsiOptionsOnlyQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCsiOptionsOnlyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCsiOptionsOnlyQuery>(GetCsiOptionsOnlyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCSIOptionsOnly', 'query');
    },
    getCustomers(variables?: GetCustomersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetCustomersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCustomersQuery>(GetCustomersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCustomers', 'query');
    },
    getDashboardQuery(variables?: GetDashboardQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetDashboardQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetDashboardQueryQuery>(GetDashboardQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getDashboardQuery', 'query');
    },
    getPlatformDashboardQuery(variables?: GetPlatformDashboardQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformDashboardQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformDashboardQueryQuery>(GetPlatformDashboardQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformDashboardQuery', 'query');
    },
    getProjectGraph(variables: GetProjectGraphQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectGraphQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectGraphQuery>(GetProjectGraphDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectGraph', 'query');
    },
    getUnitGraph(variables: GetUnitGraphQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitGraphQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitGraphQuery>(GetUnitGraphDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnitGraph', 'query');
    },
    lookupsBySource(variables: LookupsBySourceQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LookupsBySourceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LookupsBySourceQuery>(LookupsBySourceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lookupsBySource', 'query');
    },
    matappGetCsiDetails(variables: MatappGetCsiDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGetCsiDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGetCsiDetailsQuery>(MatappGetCsiDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGetCsiDetails', 'query');
    },
    matappGetPartForSearch(variables: MatappGetPartForSearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGetPartForSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGetPartForSearchQuery>(MatappGetPartForSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGetPartForSearch', 'query');
    },
    matappGetAllItemsForSearch(variables?: MatappGetAllItemsForSearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGetAllItemsForSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGetAllItemsForSearchQuery>(MatappGetAllItemsForSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGetAllItemsForSearch', 'query');
    },
    matappGetPartNumber(variables: MatappGetPartNumberQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGetPartNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGetPartNumberQuery>(MatappGetPartNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGetPartNumber', 'query');
    },
    matappGeneratePartNumber(variables?: MatappGeneratePartNumberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGeneratePartNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGeneratePartNumberMutation>(MatappGeneratePartNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGeneratePartNumber', 'mutation');
    },
    matappRestorePartNumberCounter(variables: MatappRestorePartNumberCounterMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappRestorePartNumberCounterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappRestorePartNumberCounterMutation>(MatappRestorePartNumberCounterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappRestorePartNumberCounter', 'mutation');
    },
    matappAssignPartNumber(variables: MatappAssignPartNumberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappAssignPartNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappAssignPartNumberMutation>(MatappAssignPartNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappAssignPartNumber', 'mutation');
    },
    matappAssignPartNumberToUnnumbered(variables: MatappAssignPartNumberToUnnumberedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappAssignPartNumberToUnnumberedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappAssignPartNumberToUnnumberedMutation>(MatappAssignPartNumberToUnnumberedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappAssignPartNumberToUnnumbered', 'mutation');
    },
    matappGetPartNumberHistoryByOldNumber(variables: MatappGetPartNumberHistoryByOldNumberQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappGetPartNumberHistoryByOldNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappGetPartNumberHistoryByOldNumberQuery>(MatappGetPartNumberHistoryByOldNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappGetPartNumberHistoryByOldNumber', 'query');
    },
    matappInsertPartNumberHistory(variables: MatappInsertPartNumberHistoryMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappInsertPartNumberHistoryMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappInsertPartNumberHistoryMutation>(MatappInsertPartNumberHistoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappInsertPartNumberHistory', 'mutation');
    },
    matappInsertEmails(variables: MatappInsertEmailsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappInsertEmailsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappInsertEmailsMutation>(MatappInsertEmailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappInsertEmails', 'mutation');
    },
    matappMarkEmailSent(variables: MatappMarkEmailSentMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappMarkEmailSentMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappMarkEmailSentMutation>(MatappMarkEmailSentDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappMarkEmailSent', 'mutation');
    },
    matappMarkEmailFailed(variables: MatappMarkEmailFailedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappMarkEmailFailedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappMarkEmailFailedMutation>(MatappMarkEmailFailedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappMarkEmailFailed', 'mutation');
    },
    matappClaimEmailForSend(variables: MatappClaimEmailForSendMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappClaimEmailForSendMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappClaimEmailForSendMutation>(MatappClaimEmailForSendDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappClaimEmailForSend', 'mutation');
    },
    matappMarkEmailSendAttempted(variables: MatappMarkEmailSendAttemptedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappMarkEmailSendAttemptedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappMarkEmailSendAttemptedMutation>(MatappMarkEmailSendAttemptedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappMarkEmailSendAttempted', 'mutation');
    },
    matappStaleEmailClaims(variables: MatappStaleEmailClaimsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappStaleEmailClaimsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappStaleEmailClaimsQuery>(MatappStaleEmailClaimsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappStaleEmailClaims', 'query');
    },
    matappReclaimStaleEmail(variables: MatappReclaimStaleEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappReclaimStaleEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappReclaimStaleEmailMutation>(MatappReclaimStaleEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappReclaimStaleEmail', 'mutation');
    },
    matappMarkEmailUnconfirmed(variables: MatappMarkEmailUnconfirmedMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappMarkEmailUnconfirmedMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappMarkEmailUnconfirmedMutation>(MatappMarkEmailUnconfirmedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappMarkEmailUnconfirmed', 'mutation');
    },
    matappAddUserRole(variables: MatappAddUserRoleMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MatappAddUserRoleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MatappAddUserRoleMutation>(MatappAddUserRoleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'matappAddUserRole', 'mutation');
    },
    getPartsToSync(variables: GetPartsToSyncQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartsToSyncQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartsToSyncQuery>(GetPartsToSyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartsToSync', 'query');
    },
    insertPartSync(variables: InsertPartSyncMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertPartSyncMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertPartSyncMutation>(InsertPartSyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertPartSync', 'mutation');
    },
    cleanPartSync(variables: CleanPartSyncMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CleanPartSyncMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CleanPartSyncMutation>(CleanPartSyncDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cleanPartSync', 'mutation');
    },
    updatePartSyncEventComplete(variables: UpdatePartSyncEventCompleteMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePartSyncEventCompleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePartSyncEventCompleteMutation>(UpdatePartSyncEventCompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePartSyncEventComplete', 'mutation');
    },
    getPartForAirtable(variables: GetPartForAirtableQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartForAirtableQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartForAirtableQuery>(GetPartForAirtableDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartForAirtable', 'query');
    },
    getPartIdFromPartNumber(variables: GetPartIdFromPartNumberQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartIdFromPartNumberQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartIdFromPartNumberQuery>(GetPartIdFromPartNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartIdFromPartNumber', 'query');
    },
    getPartForKbb(variables: GetPartForKbbQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartForKbbQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartForKbbQuery>(GetPartForKbbDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartForKbb', 'query');
    },
    getExistingWareHouseDetailsForKbbLoopPull(variables?: GetExistingWareHouseDetailsForKbbLoopPullQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetExistingWareHouseDetailsForKbbLoopPullQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetExistingWareHouseDetailsForKbbLoopPullQuery>(GetExistingWareHouseDetailsForKbbLoopPullDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getExistingWareHouseDetailsForKbbLoopPull', 'query');
    },
    upsertWareHouse(variables: UpsertWareHouseMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertWareHouseMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertWareHouseMutation>(UpsertWareHouseDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertWareHouse', 'mutation');
    },
    getPartFormOptions(variables?: GetPartFormOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartFormOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartFormOptionsQuery>(GetPartFormOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartFormOptions', 'query');
    },
    getUOMScopes(variables?: GetUomScopesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUomScopesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUomScopesQuery>(GetUomScopesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUOMScopes', 'query');
    },
    getPartPublicationDetails(variables?: GetPartPublicationDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPartPublicationDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPartPublicationDetailsQuery>(GetPartPublicationDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPartPublicationDetails', 'query');
    },
    getPlatforms(variables?: GetPlatformsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformsQuery>(GetPlatformsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatforms', 'query');
    },
    getPlatformById(variables: GetPlatformByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformByIdQuery>(GetPlatformByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformById', 'query');
    },
    insertPlatform(variables: InsertPlatformMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertPlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertPlatformMutation>(InsertPlatformDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertPlatform', 'mutation');
    },
    updatePlatform(variables: UpdatePlatformMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePlatformMutation>(UpdatePlatformDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePlatform', 'mutation');
    },
    upsertPlatform(variables: UpsertPlatformMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertPlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertPlatformMutation>(UpsertPlatformDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertPlatform', 'mutation');
    },
    deletePlatform(variables: DeletePlatformMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePlatformMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePlatformMutation>(DeletePlatformDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePlatform', 'mutation');
    },
    getPlatformAsDesigned(variables?: GetPlatformAsDesignedQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformAsDesignedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformAsDesignedQuery>(GetPlatformAsDesignedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformAsDesigned', 'query');
    },
    getLoomByPlatformAndSku(variables?: GetLoomByPlatformAndSkuQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetLoomByPlatformAndSkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLoomByPlatformAndSkuQuery>(GetLoomByPlatformAndSkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getLoomByPlatformAndSku', 'query');
    },
    getProductOptions(variables?: GetProductOptionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProductOptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductOptionsQuery>(GetProductOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductOptions', 'query');
    },
    getProductOptionById(variables: GetProductOptionByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProductOptionByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductOptionByIdQuery>(GetProductOptionByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductOptionById', 'query');
    },
    insertProductOption(variables: InsertProductOptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertProductOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertProductOptionMutation>(InsertProductOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertProductOption', 'mutation');
    },
    updateProductOption(variables: UpdateProductOptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProductOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductOptionMutation>(UpdateProductOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProductOption', 'mutation');
    },
    upsertProductOption(variables: UpsertProductOptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertProductOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertProductOptionMutation>(UpsertProductOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertProductOption', 'mutation');
    },
    deleteProductOption(variables: DeleteProductOptionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteProductOptionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteProductOptionMutation>(DeleteProductOptionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteProductOption', 'mutation');
    },
    getProductOptionChoices(variables?: GetProductOptionChoicesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProductOptionChoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductOptionChoicesQuery>(GetProductOptionChoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductOptionChoices', 'query');
    },
    getProductOptionChoiceById(variables: GetProductOptionChoiceByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProductOptionChoiceByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductOptionChoiceByIdQuery>(GetProductOptionChoiceByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductOptionChoiceById', 'query');
    },
    insertProductOptionChoice(variables: InsertProductOptionChoiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertProductOptionChoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertProductOptionChoiceMutation>(InsertProductOptionChoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertProductOptionChoice', 'mutation');
    },
    updateProductOptionChoice(variables: UpdateProductOptionChoiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateProductOptionChoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProductOptionChoiceMutation>(UpdateProductOptionChoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateProductOptionChoice', 'mutation');
    },
    upsertProductOptionChoice(variables: UpsertProductOptionChoiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertProductOptionChoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertProductOptionChoiceMutation>(UpsertProductOptionChoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertProductOptionChoice', 'mutation');
    },
    deleteProductOptionChoice(variables: DeleteProductOptionChoiceMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteProductOptionChoiceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteProductOptionChoiceMutation>(DeleteProductOptionChoiceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteProductOptionChoice', 'mutation');
    },
    getProjects(variables?: GetProjectsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectsQuery>(GetProjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjects', 'query');
    },
    getProjectOptionsByBaseProduct(variables: GetProjectOptionsByBaseProductQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectOptionsByBaseProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectOptionsByBaseProductQuery>(GetProjectOptionsByBaseProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectOptionsByBaseProduct', 'query');
    },
    setSelectedUnitOptions(variables: SetSelectedUnitOptionsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SetSelectedUnitOptionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetSelectedUnitOptionsMutation>(SetSelectedUnitOptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'setSelectedUnitOptions', 'mutation');
    },
    getProjectById(variables: GetProjectByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetProjectByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProjectByIdQuery>(GetProjectByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProjectById', 'query');
    },
    getReports(variables?: GetReportsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetReportsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReportsQuery>(GetReportsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getReports', 'query');
    },
    getReportById(variables: GetReportByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetReportByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetReportByIdQuery>(GetReportByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getReportById', 'query');
    },
    insertReport(variables: InsertReportMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertReportMutation>(InsertReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertReport', 'mutation');
    },
    updateReport(variables: UpdateReportMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateReportMutation>(UpdateReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateReport', 'mutation');
    },
    upsertReport(variables: UpsertReportMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertReportMutation>(UpsertReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertReport', 'mutation');
    },
    deleteReport(variables: DeleteReportMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteReportMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteReportMutation>(DeleteReportDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteReport', 'mutation');
    },
    getPlatformRequirements(variables?: GetPlatformRequirementsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformRequirementsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformRequirementsQuery>(GetPlatformRequirementsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformRequirements', 'query');
    },
    getPlatformRequirementById(variables: GetPlatformRequirementByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlatformRequirementByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlatformRequirementByIdQuery>(GetPlatformRequirementByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlatformRequirementById', 'query');
    },
    insertPlatformRequirement(variables: InsertPlatformRequirementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertPlatformRequirementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertPlatformRequirementMutation>(InsertPlatformRequirementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertPlatformRequirement', 'mutation');
    },
    updatePlatformRequirement(variables: UpdatePlatformRequirementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdatePlatformRequirementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePlatformRequirementMutation>(UpdatePlatformRequirementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updatePlatformRequirement', 'mutation');
    },
    upsertPlatformRequirement(variables: UpsertPlatformRequirementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertPlatformRequirementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertPlatformRequirementMutation>(UpsertPlatformRequirementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertPlatformRequirement', 'mutation');
    },
    deletePlatformRequirement(variables: DeletePlatformRequirementMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeletePlatformRequirementMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeletePlatformRequirementMutation>(DeletePlatformRequirementDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deletePlatformRequirement', 'mutation');
    },
    getShortLinks(variables?: GetShortLinksQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetShortLinksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetShortLinksQuery>(GetShortLinksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getShortLinks', 'query');
    },
    addShortLink(variables: AddShortLinkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AddShortLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddShortLinkMutation>(AddShortLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addShortLink', 'mutation');
    },
    editShortLink(variables: EditShortLinkMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<EditShortLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditShortLinkMutation>(EditShortLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'editShortLink', 'mutation');
    },
    updateShortLinkUrl(variables: UpdateShortLinkUrlMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateShortLinkUrlMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateShortLinkUrlMutation>(UpdateShortLinkUrlDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateShortLinkUrl', 'mutation');
    },
    longUrlFromSlug(variables: LongUrlFromSlugMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<LongUrlFromSlugMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LongUrlFromSlugMutation>(LongUrlFromSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'longUrlFromSlug', 'mutation');
    },
    getSuppliers(variables?: GetSuppliersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSuppliersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSuppliersQuery>(GetSuppliersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSuppliers', 'query');
    },
    getSupplierById(variables: GetSupplierByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetSupplierByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetSupplierByIdQuery>(GetSupplierByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getSupplierById', 'query');
    },
    insertSupplier(variables: InsertSupplierMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertSupplierMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertSupplierMutation>(InsertSupplierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertSupplier', 'mutation');
    },
    updateSupplier(variables: UpdateSupplierMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateSupplierMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateSupplierMutation>(UpdateSupplierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateSupplier', 'mutation');
    },
    upsertSupplier(variables: UpsertSupplierMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpsertSupplierMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertSupplierMutation>(UpsertSupplierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertSupplier', 'mutation');
    },
    deleteSupplier(variables: DeleteSupplierMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteSupplierMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteSupplierMutation>(DeleteSupplierDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteSupplier', 'mutation');
    },
    getAllTagTypes(variables?: GetAllTagTypesQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllTagTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllTagTypesQuery>(GetAllTagTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllTagTypes', 'query');
    },
    createTagType(variables: CreateTagTypeMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CreateTagTypeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateTagTypeMutation>(CreateTagTypeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createTagType', 'mutation');
    },
    getAllTags(variables?: GetAllTagsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllTagsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllTagsQuery>(GetAllTagsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllTags', 'query');
    },
    getTagById(variables: GetTagByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTagByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagByIdQuery>(GetTagByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTagById', 'query');
    },
    getTagByIdList(variables?: GetTagByIdListQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTagByIdListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagByIdListQuery>(GetTagByIdListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTagByIdList', 'query');
    },
    tagEntity(variables: TagEntityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<TagEntityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TagEntityMutation>(TagEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'tagEntity', 'mutation');
    },
    deleteTagEntity(variables: DeleteTagEntityMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteTagEntityMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTagEntityMutation>(DeleteTagEntityDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTagEntity', 'mutation');
    },
    deleteTagEntityById(variables: DeleteTagEntityByIdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<DeleteTagEntityByIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteTagEntityByIdMutation>(DeleteTagEntityByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteTagEntityById', 'mutation');
    },
    insertTagPath(variables: InsertTagPathMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertTagPathMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertTagPathMutation>(InsertTagPathDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertTagPath', 'mutation');
    },
    getOptionTagsForBaseProductBySku(variables: GetOptionTagsForBaseProductBySkuQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetOptionTagsForBaseProductBySkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOptionTagsForBaseProductBySkuQuery>(GetOptionTagsForBaseProductBySkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOptionTagsForBaseProductBySku', 'query');
    },
    insertTagSetFromPath(variables: InsertTagSetFromPathMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<InsertTagSetFromPathMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InsertTagSetFromPathMutation>(InsertTagSetFromPathDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'insertTagSetFromPath', 'mutation');
    },
    getAllTagSets(variables?: GetAllTagSetsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllTagSetsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllTagSetsQuery>(GetAllTagSetsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllTagSets', 'query');
    },
    getTagSetById(variables: GetTagSetByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTagSetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagSetByIdQuery>(GetTagSetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTagSetById', 'query');
    },
    getTagPathSegmentViewQuery(variables?: GetTagPathSegmentViewQueryQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetTagPathSegmentViewQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetTagPathSegmentViewQueryQuery>(GetTagPathSegmentViewQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getTagPathSegmentViewQuery', 'query');
    },
    getUnitDetailsWithBom(variables: GetUnitDetailsWithBomQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitDetailsWithBomQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitDetailsWithBomQuery>(GetUnitDetailsWithBomDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnitDetailsWithBom', 'query');
    },
    updateUnitById(variables: UpdateUnitByIdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateUnitByIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUnitByIdMutation>(UpdateUnitByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUnitById', 'mutation');
    },
    assignSerialNumber(variables?: AssignSerialNumberMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<AssignSerialNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AssignSerialNumberMutation>(AssignSerialNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'assignSerialNumber', 'mutation');
    },
    getUnitById(variables?: GetUnitByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitByIdQuery>(GetUnitByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnitById', 'query');
    },
    getUnitTagView(variables: GetUnitTagViewQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitTagViewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitTagViewQuery>(GetUnitTagViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnitTagView', 'query');
    },
    getUnits(variables?: GetUnitsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUnitsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUnitsQuery>(GetUnitsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUnits', 'query');
    },
    GetConversionDetails(variables: GetConversionDetailsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetConversionDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetConversionDetailsQuery>(GetConversionDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetConversionDetails', 'query');
    },
    userPermissions(variables: UserPermissionsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UserPermissionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPermissionsQuery>(UserPermissionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPermissions', 'query');
    },
    getAllUsers(variables?: GetAllUsersQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllUsersQuery>(GetAllUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllUsers', 'query');
    },
    getUserById(variables: GetUserByIdQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetUserByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserByIdQuery>(GetUserByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUserById', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
export function getSdkWithHooks(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  const sdk = getSdk(client, withWrapper);
  return {
    ...sdk,
    useGetBaseProductList(key: SWRKeyInterface, variables?: GetBaseProductListQueryVariables, config?: SWRConfigInterface<GetBaseProductListQuery, ClientError>) {
      return useSWR<GetBaseProductListQuery, ClientError>(key, () => sdk.getBaseProductList(variables), config);
    },
    useVerifySerialNumberExists(key: SWRKeyInterface, variables?: VerifySerialNumberExistsQueryVariables, config?: SWRConfigInterface<VerifySerialNumberExistsQuery, ClientError>) {
      return useSWR<VerifySerialNumberExistsQuery, ClientError>(key, () => sdk.verifySerialNumberExists(variables), config);
    },
    useGetBaseProducts(key: SWRKeyInterface, variables?: GetBaseProductsQueryVariables, config?: SWRConfigInterface<GetBaseProductsQuery, ClientError>) {
      return useSWR<GetBaseProductsQuery, ClientError>(key, () => sdk.getBaseProducts(variables), config);
    },
    useGetBaseProductById(key: SWRKeyInterface, variables: GetBaseProductByIdQueryVariables, config?: SWRConfigInterface<GetBaseProductByIdQuery, ClientError>) {
      return useSWR<GetBaseProductByIdQuery, ClientError>(key, () => sdk.getBaseProductById(variables), config);
    },
    useGetAllBomOptionsBySku(key: SWRKeyInterface, variables: GetAllBomOptionsBySkuQueryVariables, config?: SWRConfigInterface<GetAllBomOptionsBySkuQuery, ClientError>) {
      return useSWR<GetAllBomOptionsBySkuQuery, ClientError>(key, () => sdk.getAllBOMOptionsBySku(variables), config);
    },
    useGetUnitBomEntity(key: SWRKeyInterface, variables: GetUnitBomEntityQueryVariables, config?: SWRConfigInterface<GetUnitBomEntityQuery, ClientError>) {
      return useSWR<GetUnitBomEntityQuery, ClientError>(key, () => sdk.getUnitBomEntity(variables), config);
    },
    useGetBomItemTagSet(key: SWRKeyInterface, variables?: GetBomItemTagSetQueryVariables, config?: SWRConfigInterface<GetBomItemTagSetQuery, ClientError>) {
      return useSWR<GetBomItemTagSetQuery, ClientError>(key, () => sdk.getBomItemTagSet(variables), config);
    },
    useGetBomByPlatformAndSku(key: SWRKeyInterface, variables: GetBomByPlatformAndSkuQueryVariables, config?: SWRConfigInterface<GetBomByPlatformAndSkuQuery, ClientError>) {
      return useSWR<GetBomByPlatformAndSkuQuery, ClientError>(key, () => sdk.getBomByPlatformAndSku(variables), config);
    },
    useGetBomByPlatformAndBaseProduct(key: SWRKeyInterface, variables: GetBomByPlatformAndBaseProductQueryVariables, config?: SWRConfigInterface<GetBomByPlatformAndBaseProductQuery, ClientError>) {
      return useSWR<GetBomByPlatformAndBaseProductQuery, ClientError>(key, () => sdk.getBomByPlatformAndBaseProduct(variables), config);
    },
    useGetBomAddPartAddionalInfo(key: SWRKeyInterface, variables?: GetBomAddPartAddionalInfoQueryVariables, config?: SWRConfigInterface<GetBomAddPartAddionalInfoQuery, ClientError>) {
      return useSWR<GetBomAddPartAddionalInfoQuery, ClientError>(key, () => sdk.getBomAddPartAddionalInfo(variables), config);
    },
    usePartConversionById(key: SWRKeyInterface, variables: PartConversionByIdQueryVariables, config?: SWRConfigInterface<PartConversionByIdQuery, ClientError>) {
      return useSWR<PartConversionByIdQuery, ClientError>(key, () => sdk.partConversionById(variables), config);
    },
    useGetPlatformAndProductlookup(key: SWRKeyInterface, variables?: GetPlatformAndProductlookupQueryVariables, config?: SWRConfigInterface<GetPlatformAndProductlookupQuery, ClientError>) {
      return useSWR<GetPlatformAndProductlookupQuery, ClientError>(key, () => sdk.getPlatformAndProductlookup(variables), config);
    },
    useGetBomForTagPathWithAncestorsAndDescendants(key: SWRKeyInterface, variables?: GetBomForTagPathWithAncestorsAndDescendantsQueryVariables, config?: SWRConfigInterface<GetBomForTagPathWithAncestorsAndDescendantsQuery, ClientError>) {
      return useSWR<GetBomForTagPathWithAncestorsAndDescendantsQuery, ClientError>(key, () => sdk.getBomForTagPathWithAncestorsAndDescendants(variables), config);
    },
    useGetBomForTagPathWithAncestors(key: SWRKeyInterface, variables?: GetBomForTagPathWithAncestorsQueryVariables, config?: SWRConfigInterface<GetBomForTagPathWithAncestorsQuery, ClientError>) {
      return useSWR<GetBomForTagPathWithAncestorsQuery, ClientError>(key, () => sdk.getBomForTagPathWithAncestors(variables), config);
    },
    useAllTagPaths(key: SWRKeyInterface, variables?: AllTagPathsQueryVariables, config?: SWRConfigInterface<AllTagPathsQuery, ClientError>) {
      return useSWR<AllTagPathsQuery, ClientError>(key, () => sdk.allTagPaths(variables), config);
    },
    useGetTagPathTree(key: SWRKeyInterface, variables?: GetTagPathTreeQueryVariables, config?: SWRConfigInterface<GetTagPathTreeQuery, ClientError>) {
      return useSWR<GetTagPathTreeQuery, ClientError>(key, () => sdk.getTagPathTree(variables), config);
    },
    usePartIdsFromTags(key: SWRKeyInterface, variables?: PartIdsFromTagsQueryVariables, config?: SWRConfigInterface<PartIdsFromTagsQuery, ClientError>) {
      return useSWR<PartIdsFromTagsQuery, ClientError>(key, () => sdk.partIdsFromTags(variables), config);
    },
    useTaggedPartsByIds(key: SWRKeyInterface, variables: TaggedPartsByIdsQueryVariables, config?: SWRConfigInterface<TaggedPartsByIdsQuery, ClientError>) {
      return useSWR<TaggedPartsByIdsQuery, ClientError>(key, () => sdk.taggedPartsByIds(variables), config);
    },
    useGetWevrProjectBom(key: SWRKeyInterface, variables: GetWevrProjectBomQueryVariables, config?: SWRConfigInterface<GetWevrProjectBomQuery, ClientError>) {
      return useSWR<GetWevrProjectBomQuery, ClientError>(key, () => sdk.getWEVRProjectBOM(variables), config);
    },
    useGetProjectBom(key: SWRKeyInterface, variables: GetProjectBomQueryVariables, config?: SWRConfigInterface<GetProjectBomQuery, ClientError>) {
      return useSWR<GetProjectBomQuery, ClientError>(key, () => sdk.getProjectBOM(variables), config);
    },
    useGetCsiOptionsOnly(key: SWRKeyInterface, variables?: GetCsiOptionsOnlyQueryVariables, config?: SWRConfigInterface<GetCsiOptionsOnlyQuery, ClientError>) {
      return useSWR<GetCsiOptionsOnlyQuery, ClientError>(key, () => sdk.getCSIOptionsOnly(variables), config);
    },
    useGetCustomers(key: SWRKeyInterface, variables?: GetCustomersQueryVariables, config?: SWRConfigInterface<GetCustomersQuery, ClientError>) {
      return useSWR<GetCustomersQuery, ClientError>(key, () => sdk.getCustomers(variables), config);
    },
    useGetDashboardQuery(key: SWRKeyInterface, variables?: GetDashboardQueryQueryVariables, config?: SWRConfigInterface<GetDashboardQueryQuery, ClientError>) {
      return useSWR<GetDashboardQueryQuery, ClientError>(key, () => sdk.getDashboardQuery(variables), config);
    },
    useGetPlatformDashboardQuery(key: SWRKeyInterface, variables?: GetPlatformDashboardQueryQueryVariables, config?: SWRConfigInterface<GetPlatformDashboardQueryQuery, ClientError>) {
      return useSWR<GetPlatformDashboardQueryQuery, ClientError>(key, () => sdk.getPlatformDashboardQuery(variables), config);
    },
    useGetProjectGraph(key: SWRKeyInterface, variables: GetProjectGraphQueryVariables, config?: SWRConfigInterface<GetProjectGraphQuery, ClientError>) {
      return useSWR<GetProjectGraphQuery, ClientError>(key, () => sdk.getProjectGraph(variables), config);
    },
    useGetUnitGraph(key: SWRKeyInterface, variables: GetUnitGraphQueryVariables, config?: SWRConfigInterface<GetUnitGraphQuery, ClientError>) {
      return useSWR<GetUnitGraphQuery, ClientError>(key, () => sdk.getUnitGraph(variables), config);
    },
    useLookupsBySource(key: SWRKeyInterface, variables: LookupsBySourceQueryVariables, config?: SWRConfigInterface<LookupsBySourceQuery, ClientError>) {
      return useSWR<LookupsBySourceQuery, ClientError>(key, () => sdk.lookupsBySource(variables), config);
    },
    useMatappGetCsiDetails(key: SWRKeyInterface, variables: MatappGetCsiDetailsQueryVariables, config?: SWRConfigInterface<MatappGetCsiDetailsQuery, ClientError>) {
      return useSWR<MatappGetCsiDetailsQuery, ClientError>(key, () => sdk.matappGetCsiDetails(variables), config);
    },
    useMatappGetPartForSearch(key: SWRKeyInterface, variables: MatappGetPartForSearchQueryVariables, config?: SWRConfigInterface<MatappGetPartForSearchQuery, ClientError>) {
      return useSWR<MatappGetPartForSearchQuery, ClientError>(key, () => sdk.matappGetPartForSearch(variables), config);
    },
    useMatappGetAllItemsForSearch(key: SWRKeyInterface, variables?: MatappGetAllItemsForSearchQueryVariables, config?: SWRConfigInterface<MatappGetAllItemsForSearchQuery, ClientError>) {
      return useSWR<MatappGetAllItemsForSearchQuery, ClientError>(key, () => sdk.matappGetAllItemsForSearch(variables), config);
    },
    useMatappGetPartNumber(key: SWRKeyInterface, variables: MatappGetPartNumberQueryVariables, config?: SWRConfigInterface<MatappGetPartNumberQuery, ClientError>) {
      return useSWR<MatappGetPartNumberQuery, ClientError>(key, () => sdk.matappGetPartNumber(variables), config);
    },
    useMatappGetPartNumberHistoryByOldNumber(key: SWRKeyInterface, variables: MatappGetPartNumberHistoryByOldNumberQueryVariables, config?: SWRConfigInterface<MatappGetPartNumberHistoryByOldNumberQuery, ClientError>) {
      return useSWR<MatappGetPartNumberHistoryByOldNumberQuery, ClientError>(key, () => sdk.matappGetPartNumberHistoryByOldNumber(variables), config);
    },
    useMatappStaleEmailClaims(key: SWRKeyInterface, variables: MatappStaleEmailClaimsQueryVariables, config?: SWRConfigInterface<MatappStaleEmailClaimsQuery, ClientError>) {
      return useSWR<MatappStaleEmailClaimsQuery, ClientError>(key, () => sdk.matappStaleEmailClaims(variables), config);
    },
    useGetPartsToSync(key: SWRKeyInterface, variables: GetPartsToSyncQueryVariables, config?: SWRConfigInterface<GetPartsToSyncQuery, ClientError>) {
      return useSWR<GetPartsToSyncQuery, ClientError>(key, () => sdk.getPartsToSync(variables), config);
    },
    useGetPartForAirtable(key: SWRKeyInterface, variables: GetPartForAirtableQueryVariables, config?: SWRConfigInterface<GetPartForAirtableQuery, ClientError>) {
      return useSWR<GetPartForAirtableQuery, ClientError>(key, () => sdk.getPartForAirtable(variables), config);
    },
    useGetPartIdFromPartNumber(key: SWRKeyInterface, variables: GetPartIdFromPartNumberQueryVariables, config?: SWRConfigInterface<GetPartIdFromPartNumberQuery, ClientError>) {
      return useSWR<GetPartIdFromPartNumberQuery, ClientError>(key, () => sdk.getPartIdFromPartNumber(variables), config);
    },
    useGetPartForKbb(key: SWRKeyInterface, variables: GetPartForKbbQueryVariables, config?: SWRConfigInterface<GetPartForKbbQuery, ClientError>) {
      return useSWR<GetPartForKbbQuery, ClientError>(key, () => sdk.getPartForKbb(variables), config);
    },
    useGetExistingWareHouseDetailsForKbbLoopPull(key: SWRKeyInterface, variables?: GetExistingWareHouseDetailsForKbbLoopPullQueryVariables, config?: SWRConfigInterface<GetExistingWareHouseDetailsForKbbLoopPullQuery, ClientError>) {
      return useSWR<GetExistingWareHouseDetailsForKbbLoopPullQuery, ClientError>(key, () => sdk.getExistingWareHouseDetailsForKbbLoopPull(variables), config);
    },
    useGetPartFormOptions(key: SWRKeyInterface, variables?: GetPartFormOptionsQueryVariables, config?: SWRConfigInterface<GetPartFormOptionsQuery, ClientError>) {
      return useSWR<GetPartFormOptionsQuery, ClientError>(key, () => sdk.getPartFormOptions(variables), config);
    },
    useGetUomScopes(key: SWRKeyInterface, variables?: GetUomScopesQueryVariables, config?: SWRConfigInterface<GetUomScopesQuery, ClientError>) {
      return useSWR<GetUomScopesQuery, ClientError>(key, () => sdk.getUOMScopes(variables), config);
    },
    useGetPartPublicationDetails(key: SWRKeyInterface, variables?: GetPartPublicationDetailsQueryVariables, config?: SWRConfigInterface<GetPartPublicationDetailsQuery, ClientError>) {
      return useSWR<GetPartPublicationDetailsQuery, ClientError>(key, () => sdk.getPartPublicationDetails(variables), config);
    },
    useGetPlatforms(key: SWRKeyInterface, variables?: GetPlatformsQueryVariables, config?: SWRConfigInterface<GetPlatformsQuery, ClientError>) {
      return useSWR<GetPlatformsQuery, ClientError>(key, () => sdk.getPlatforms(variables), config);
    },
    useGetPlatformById(key: SWRKeyInterface, variables: GetPlatformByIdQueryVariables, config?: SWRConfigInterface<GetPlatformByIdQuery, ClientError>) {
      return useSWR<GetPlatformByIdQuery, ClientError>(key, () => sdk.getPlatformById(variables), config);
    },
    useGetPlatformAsDesigned(key: SWRKeyInterface, variables?: GetPlatformAsDesignedQueryVariables, config?: SWRConfigInterface<GetPlatformAsDesignedQuery, ClientError>) {
      return useSWR<GetPlatformAsDesignedQuery, ClientError>(key, () => sdk.getPlatformAsDesigned(variables), config);
    },
    useGetLoomByPlatformAndSku(key: SWRKeyInterface, variables?: GetLoomByPlatformAndSkuQueryVariables, config?: SWRConfigInterface<GetLoomByPlatformAndSkuQuery, ClientError>) {
      return useSWR<GetLoomByPlatformAndSkuQuery, ClientError>(key, () => sdk.getLoomByPlatformAndSku(variables), config);
    },
    useGetProductOptions(key: SWRKeyInterface, variables?: GetProductOptionsQueryVariables, config?: SWRConfigInterface<GetProductOptionsQuery, ClientError>) {
      return useSWR<GetProductOptionsQuery, ClientError>(key, () => sdk.getProductOptions(variables), config);
    },
    useGetProductOptionById(key: SWRKeyInterface, variables: GetProductOptionByIdQueryVariables, config?: SWRConfigInterface<GetProductOptionByIdQuery, ClientError>) {
      return useSWR<GetProductOptionByIdQuery, ClientError>(key, () => sdk.getProductOptionById(variables), config);
    },
    useGetProductOptionChoices(key: SWRKeyInterface, variables?: GetProductOptionChoicesQueryVariables, config?: SWRConfigInterface<GetProductOptionChoicesQuery, ClientError>) {
      return useSWR<GetProductOptionChoicesQuery, ClientError>(key, () => sdk.getProductOptionChoices(variables), config);
    },
    useGetProductOptionChoiceById(key: SWRKeyInterface, variables: GetProductOptionChoiceByIdQueryVariables, config?: SWRConfigInterface<GetProductOptionChoiceByIdQuery, ClientError>) {
      return useSWR<GetProductOptionChoiceByIdQuery, ClientError>(key, () => sdk.getProductOptionChoiceById(variables), config);
    },
    useGetProjects(key: SWRKeyInterface, variables?: GetProjectsQueryVariables, config?: SWRConfigInterface<GetProjectsQuery, ClientError>) {
      return useSWR<GetProjectsQuery, ClientError>(key, () => sdk.getProjects(variables), config);
    },
    useGetProjectOptionsByBaseProduct(key: SWRKeyInterface, variables: GetProjectOptionsByBaseProductQueryVariables, config?: SWRConfigInterface<GetProjectOptionsByBaseProductQuery, ClientError>) {
      return useSWR<GetProjectOptionsByBaseProductQuery, ClientError>(key, () => sdk.getProjectOptionsByBaseProduct(variables), config);
    },
    useGetProjectById(key: SWRKeyInterface, variables: GetProjectByIdQueryVariables, config?: SWRConfigInterface<GetProjectByIdQuery, ClientError>) {
      return useSWR<GetProjectByIdQuery, ClientError>(key, () => sdk.getProjectById(variables), config);
    },
    useGetReports(key: SWRKeyInterface, variables?: GetReportsQueryVariables, config?: SWRConfigInterface<GetReportsQuery, ClientError>) {
      return useSWR<GetReportsQuery, ClientError>(key, () => sdk.getReports(variables), config);
    },
    useGetReportById(key: SWRKeyInterface, variables: GetReportByIdQueryVariables, config?: SWRConfigInterface<GetReportByIdQuery, ClientError>) {
      return useSWR<GetReportByIdQuery, ClientError>(key, () => sdk.getReportById(variables), config);
    },
    useGetPlatformRequirements(key: SWRKeyInterface, variables?: GetPlatformRequirementsQueryVariables, config?: SWRConfigInterface<GetPlatformRequirementsQuery, ClientError>) {
      return useSWR<GetPlatformRequirementsQuery, ClientError>(key, () => sdk.getPlatformRequirements(variables), config);
    },
    useGetPlatformRequirementById(key: SWRKeyInterface, variables: GetPlatformRequirementByIdQueryVariables, config?: SWRConfigInterface<GetPlatformRequirementByIdQuery, ClientError>) {
      return useSWR<GetPlatformRequirementByIdQuery, ClientError>(key, () => sdk.getPlatformRequirementById(variables), config);
    },
    useGetShortLinks(key: SWRKeyInterface, variables?: GetShortLinksQueryVariables, config?: SWRConfigInterface<GetShortLinksQuery, ClientError>) {
      return useSWR<GetShortLinksQuery, ClientError>(key, () => sdk.getShortLinks(variables), config);
    },
    useGetSuppliers(key: SWRKeyInterface, variables?: GetSuppliersQueryVariables, config?: SWRConfigInterface<GetSuppliersQuery, ClientError>) {
      return useSWR<GetSuppliersQuery, ClientError>(key, () => sdk.getSuppliers(variables), config);
    },
    useGetSupplierById(key: SWRKeyInterface, variables: GetSupplierByIdQueryVariables, config?: SWRConfigInterface<GetSupplierByIdQuery, ClientError>) {
      return useSWR<GetSupplierByIdQuery, ClientError>(key, () => sdk.getSupplierById(variables), config);
    },
    useGetAllTagTypes(key: SWRKeyInterface, variables?: GetAllTagTypesQueryVariables, config?: SWRConfigInterface<GetAllTagTypesQuery, ClientError>) {
      return useSWR<GetAllTagTypesQuery, ClientError>(key, () => sdk.getAllTagTypes(variables), config);
    },
    useGetAllTags(key: SWRKeyInterface, variables?: GetAllTagsQueryVariables, config?: SWRConfigInterface<GetAllTagsQuery, ClientError>) {
      return useSWR<GetAllTagsQuery, ClientError>(key, () => sdk.getAllTags(variables), config);
    },
    useGetTagById(key: SWRKeyInterface, variables: GetTagByIdQueryVariables, config?: SWRConfigInterface<GetTagByIdQuery, ClientError>) {
      return useSWR<GetTagByIdQuery, ClientError>(key, () => sdk.getTagById(variables), config);
    },
    useGetTagByIdList(key: SWRKeyInterface, variables?: GetTagByIdListQueryVariables, config?: SWRConfigInterface<GetTagByIdListQuery, ClientError>) {
      return useSWR<GetTagByIdListQuery, ClientError>(key, () => sdk.getTagByIdList(variables), config);
    },
    useGetOptionTagsForBaseProductBySku(key: SWRKeyInterface, variables: GetOptionTagsForBaseProductBySkuQueryVariables, config?: SWRConfigInterface<GetOptionTagsForBaseProductBySkuQuery, ClientError>) {
      return useSWR<GetOptionTagsForBaseProductBySkuQuery, ClientError>(key, () => sdk.getOptionTagsForBaseProductBySku(variables), config);
    },
    useGetAllTagSets(key: SWRKeyInterface, variables?: GetAllTagSetsQueryVariables, config?: SWRConfigInterface<GetAllTagSetsQuery, ClientError>) {
      return useSWR<GetAllTagSetsQuery, ClientError>(key, () => sdk.getAllTagSets(variables), config);
    },
    useGetTagSetById(key: SWRKeyInterface, variables: GetTagSetByIdQueryVariables, config?: SWRConfigInterface<GetTagSetByIdQuery, ClientError>) {
      return useSWR<GetTagSetByIdQuery, ClientError>(key, () => sdk.getTagSetById(variables), config);
    },
    useGetTagPathSegmentViewQuery(key: SWRKeyInterface, variables?: GetTagPathSegmentViewQueryQueryVariables, config?: SWRConfigInterface<GetTagPathSegmentViewQueryQuery, ClientError>) {
      return useSWR<GetTagPathSegmentViewQueryQuery, ClientError>(key, () => sdk.getTagPathSegmentViewQuery(variables), config);
    },
    useGetUnitDetailsWithBom(key: SWRKeyInterface, variables: GetUnitDetailsWithBomQueryVariables, config?: SWRConfigInterface<GetUnitDetailsWithBomQuery, ClientError>) {
      return useSWR<GetUnitDetailsWithBomQuery, ClientError>(key, () => sdk.getUnitDetailsWithBom(variables), config);
    },
    useGetUnitById(key: SWRKeyInterface, variables?: GetUnitByIdQueryVariables, config?: SWRConfigInterface<GetUnitByIdQuery, ClientError>) {
      return useSWR<GetUnitByIdQuery, ClientError>(key, () => sdk.getUnitById(variables), config);
    },
    useGetUnitTagView(key: SWRKeyInterface, variables: GetUnitTagViewQueryVariables, config?: SWRConfigInterface<GetUnitTagViewQuery, ClientError>) {
      return useSWR<GetUnitTagViewQuery, ClientError>(key, () => sdk.getUnitTagView(variables), config);
    },
    useGetUnits(key: SWRKeyInterface, variables?: GetUnitsQueryVariables, config?: SWRConfigInterface<GetUnitsQuery, ClientError>) {
      return useSWR<GetUnitsQuery, ClientError>(key, () => sdk.getUnits(variables), config);
    },
    useGetConversionDetails(key: SWRKeyInterface, variables: GetConversionDetailsQueryVariables, config?: SWRConfigInterface<GetConversionDetailsQuery, ClientError>) {
      return useSWR<GetConversionDetailsQuery, ClientError>(key, () => sdk.GetConversionDetails(variables), config);
    },
    useUserPermissions(key: SWRKeyInterface, variables: UserPermissionsQueryVariables, config?: SWRConfigInterface<UserPermissionsQuery, ClientError>) {
      return useSWR<UserPermissionsQuery, ClientError>(key, () => sdk.userPermissions(variables), config);
    },
    useGetAllUsers(key: SWRKeyInterface, variables?: GetAllUsersQueryVariables, config?: SWRConfigInterface<GetAllUsersQuery, ClientError>) {
      return useSWR<GetAllUsersQuery, ClientError>(key, () => sdk.getAllUsers(variables), config);
    },
    useGetUserById(key: SWRKeyInterface, variables: GetUserByIdQueryVariables, config?: SWRConfigInterface<GetUserByIdQuery, ClientError>) {
      return useSWR<GetUserByIdQuery, ClientError>(key, () => sdk.getUserById(variables), config);
    }
  };
}
export type SdkWithHooks = ReturnType<typeof getSdkWithHooks>;